import { URL_SEARCH_PARAMETER_KEY_CONSTANTS, getClientIdFromQueryParam, MyHRLogger, loggerConfig, LaasClientId as LaasClientId$1, newi18instance, ErrorBanner, BackendServiceClient, useTitle, CustomBreadcrumbs, SuspenseLoader, RatingsButton, WebAnalytics, OmnitureHelper, fetchPreferredLanguage, FloaterButton, GetHelpIcon } from '@amzn/myhr-ui-commons';
import { View as View$1, Container, Row, Col, Spacer, Hr } from '@amzn/stencil-react-components/layout';
import { useBreakpoints } from '@amzn/stencil-react-components/responsive';
import React, { useContext, createContext, useState, useEffect, useRef, memo, useMemo } from 'react';
import { useTranslation, I18nextProvider } from 'react-i18next';
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner';
import { View } from '@amzn/stencil-react-components/dist/submodules/layout';
import { Text } from '@amzn/stencil-react-components/dist/submodules/text';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.values.js';
import { browserName, BrowserTypes } from 'react-device-detect';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/web.timers.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.number.is-nan.js';
import { LaasClientId, cloudFrontURI } from '@amzn/myhr-ui-commons/dist';
import 'core-js/modules/es.array.concat.js';
import { Button, ButtonVariant, ButtonSize, ButtonIconPosition, ButtonColorScheme } from '@amzn/stencil-react-components/button';
import { Text as Text$1, H1, H3, H2, Label } from '@amzn/stencil-react-components/text';
import { useLocation, Redirect, MemoryRouter, Switch, Route } from 'react-router-dom';
import { IconInformationFill, IconRefresh, IconDocument, IconBin, IconUpload, IconMinus, IconCross, IconPlus, IconExternalLink, IconSize, IconChevronRight, IconPadlock, IconLiveHelp, IconPhone, IconCopy } from '@amzn/stencil-react-components/icons';
import defaultTheme from '@amzn/stencil-react-theme-default';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.array.filter.js';
import { v4 } from 'uuid';
import Input from 'react-phone-number-input/input';
import 'react-phone-number-input/style.css';
import 'core-js/modules/es.set.js';
import { Flyout, FlyoutContent } from '@amzn/stencil-react-components/flyout';
import 'amazon-connect-chatjs';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.function.bind.js';
import 'core-js/modules/esnext.string.replace-all.js';
import { InputWrapper, RecommendedLengthFooter, TextArea, FormWrapper, Radio, Input as Input$1, Select, SelectLayout } from '@amzn/stencil-react-components/form';
import { useRecommendedLength, TokenType } from '@amzn/stencil-react-components/hooks';
import DOMPurify from 'dompurify';
import 'core-js/modules/es.function.name.js';
import 'core-js/modules/es.number.to-fixed.js';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.find.js';
import moment from 'moment';
import { Link } from '@amzn/stencil-react-components/link';
import { Modal, ModalContent, ModalStyle, ModalTitle } from '@amzn/stencil-react-components/modal';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.array.is-array.js';
import 'core-js/modules/es.array.fill.js';
import { Resizable } from 're-resizable';
import { styledWithTheme, StencilProvider } from '@amzn/stencil-react-components/context';
import 'core-js/modules/es.array.slice.js';
import 'bootstrap/dist/css/bootstrap-grid.css';
import { Tag } from '@amzn/stencil-react-components/tag';
import { DateTime } from 'luxon';
import 'core-js/modules/es.array.sort.js';
import 'core-js/modules/es.array.every.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.promise.finally.js';
import { parsePhoneNumber as parsePhoneNumber$1 } from 'libphonenumber-js/min';
import { px } from '@amzn/stencil-react-components/utils';
import { Strophe, $pres, $msg } from 'strophe.js/src/strophe';

var LiveHelpChannel;

(function (LiveHelpChannel) {
  LiveHelpChannel["CALL"] = "call";
  LiveHelpChannel["REQUEST"] = "request";
  LiveHelpChannel["CHAT"] = "chat";
  LiveHelpChannel["NONE"] = "none";
})(LiveHelpChannel || (LiveHelpChannel = {}));

var LiveHelpInlineFontScheme;

(function (LiveHelpInlineFontScheme) {
  LiveHelpInlineFontScheme["TITLE"] = "T600";
  LiveHelpInlineFontScheme["GET_HELP_SUBTITLE"] = "T500";
  LiveHelpInlineFontScheme["REQUEST_CALL_TIMER_MSG"] = "T400";
  LiveHelpInlineFontScheme["FOOTER_BUTTON"] = "T500";
  LiveHelpInlineFontScheme["CHAT_TEXTAREA_YOUR_MSG_TEXT"] = "T400";
  LiveHelpInlineFontScheme["HEADER_CLOSE_BUTTON"] = "T500";
})(LiveHelpInlineFontScheme || (LiveHelpInlineFontScheme = {}));

var initialLiveHelpServiceState = {
  activeChannel: LiveHelpChannel.NONE,
  inlineChannelTitle: '',
  isGetHelpActive: false,
  liveHelpInlineFooterActions: []
};
var LiveHelpInlineContext = /*#__PURE__*/createContext({
  liveHelpServiceState: initialLiveHelpServiceState,
  setLiveHelpServiceState: function setLiveHelpServiceState() {
    return null;
  },
  closeModal: function closeModal() {
    return null;
  }
});
var useLiveHelpInlineContext = function useLiveHelpInlineContext() {
  return useContext(LiveHelpInlineContext);
};

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var URLConstants;

(function (URLConstants) {
  URLConstants["ERROR_URL"] = "/myhr/error/3";
})(URLConstants || (URLConstants = {}));
/**
 * @constant PATHNAME : paths to respective pages while routing through inline experience
 */


var PATHNAME = {
  LIVEHELP_LANDING_PAGE: '/livehelp/landing',
  CALL: '/livehelp/call',
  ROOT: '/'
};

var Exceptions;

(function (Exceptions) {
  Exceptions["DESTINATION_NOT_ALLOWED"] = "DestinationNotAllowedException";
  Exceptions["STATUS_CODE_403_ERROR"] = "Request failed with status code 403";
  Exceptions["STATUS_CODE_400_ERROR"] = "Request failed with status code 400";
  Exceptions["REQUEST_ABORTED_ERROR"] = "Request aborted";
  Exceptions["AXIOS_0MS_ERROR"] = "timeout of 0ms exceeded";
})(Exceptions || (Exceptions = {}));

var MetricEvents;

(function (MetricEvents) {
  MetricEvents["SUCCESS_COUNT"] = "SuccessCount";
  MetricEvents["ERROR_COUNT"] = "ErrorCount";
  MetricEvents["COUNT"] = "Count";
  MetricEvents["LATENCY"] = "Latency";
  MetricEvents["AVAILABILITY"] = "Availability";
  MetricEvents["CLICKS_COUNT"] = "ClicksCount";
  MetricEvents["NETWORK_ERROR_COUNT"] = "NetworkErrorCount";
  MetricEvents["INVALID_INPUT"] = "InvalidInput";
  MetricEvents["STATUS_CODE_4XX_ERROR"] = "4xxError";
  MetricEvents["AXIOS_ERROR"] = "AxiosError";
})(MetricEvents || (MetricEvents = {}));

var MetricUnits;

(function (MetricUnits) {
  MetricUnits["MILLISECONDS"] = "Milliseconds";
  MetricUnits["COUNT"] = "Count";
})(MetricUnits || (MetricUnits = {}));

var HawkeyeDatasets;

(function (HawkeyeDatasets) {
  HawkeyeDatasets["EMPLOYEE_ACTIVITY"] = "live_help_employee_activity";
  HawkeyeDatasets["CONTACT_VOLUME"] = "live_help_contact_volume";
  HawkeyeDatasets["SSA_EMPLOYEE_ACTIVITY"] = "myhr_self_service_employee_activity";
  HawkeyeDatasets["PRIORTY_QUEUE"] = "live_help_priority_queue";
})(HawkeyeDatasets || (HawkeyeDatasets = {}));

var HelpChannel;

(function (HelpChannel) {
  HelpChannel["LIVE_CHAT"] = "Live Chat";
  HelpChannel["VOICE"] = "Phone";
  HelpChannel["CHAT_BOT"] = "Chat Bot";
  HelpChannel["CASE"] = "Case";
  HelpChannel["SSA"] = "SSA";
  HelpChannel["EXTERNAL_CHAT_WPO"] = "External Chat WPO";
})(HelpChannel || (HelpChannel = {}));

var IngressChannel;

(function (IngressChannel) {
  IngressChannel["IVY"] = "Ivy";
  IngressChannel["A2Z"] = "A2Z";
  IngressChannel["INSIDE_AMAZON"] = "Inside Amazon";
})(IngressChannel || (IngressChannel = {}));

var CommonOperations;

(function (CommonOperations) {
  CommonOperations["PAGE_LOAD"] = "PageLoad";
  CommonOperations["INLINE_WIDGET_PAGE_LOAD"] = "InlineWidgetPageLoad";
  CommonOperations["CONTACT_CHANNEL_PAGE_LOAD"] = "ContactChannelPageLoad";
  CommonOperations["CHAT_CONTAINER_PAGE_LOAD"] = "ChatContainerPageLoad";
  CommonOperations["ATOZ_TOKEN_EXPIRED"] = "AtoZTokenExpired";
  CommonOperations["CHAT_TOKEN_EXPIRED"] = "ChatTokenExpired";
  CommonOperations["MESSAGES_DOWNLOAD_FAILED"] = "MessagesDownloadFailed";
  CommonOperations["CHAT_CONNECTION_FAILED"] = "ChatConnectionFailed";
  CommonOperations["SEND_EMPLOYEE_ACTIVITY_METRIC"] = "SendEmployeeActivityMetric";
  CommonOperations["SEND_BUSINESS_ACTIVITY_METRIC"] = "SendBusinessActivityMetric";
  CommonOperations["SUCESS_PRIORTY_QUEUE_USER_METRIC"] = "PriortyQueueUserMetric";
})(CommonOperations || (CommonOperations = {}));

var ServiceName;

(function (ServiceName) {
  ServiceName["LIVEHELP_SERVICE"] = "LiveHelpService";
})(ServiceName || (ServiceName = {}));

var PageName;

(function (PageName) {
  PageName["LIVEHELP_INLINE_PAGE_NAME"] = "LivehelpInline";
  PageName["CONTACT_CHANNEL"] = "ContactChannel";
  PageName["OMNITURE_PAGE_NAME"] = "MyHR LiveHelp";
  PageName["INLINE_OMNITURE_PAGE_NAME"] = "MyHR LiveHelp FAB";
})(PageName || (PageName = {}));

var LivehelpType;

(function (LivehelpType) {
  LivehelpType["FAB"] = "FAB";
  LivehelpType["MYHR"] = "MyHR";
})(LivehelpType || (LivehelpType = {}));

var PageActionsForOmnitureMetrics;

(function (PageActionsForOmnitureMetrics) {
  PageActionsForOmnitureMetrics["FAB_CLICK"] = "Click, FAB";
  PageActionsForOmnitureMetrics["FAB_RENDER"] = "Render, FAB";
  PageActionsForOmnitureMetrics["CONTACT_CHANNELS_PAGE_LOAD_DEFAULT"] = "Load";
  PageActionsForOmnitureMetrics["CONTACT_CHANNELS_PAGE_LOAD_INLINE"] = "Load, LiveHelp";
  PageActionsForOmnitureMetrics["LIVE_CHAT_CLICK"] = "Click, Channel- Live Chat";
  PageActionsForOmnitureMetrics["CALL_CLICK"] = "Click, Channel- Phone";
  PageActionsForOmnitureMetrics["CASE_CLICK"] = "Click, Channel- Case";
  PageActionsForOmnitureMetrics["REDIRECT_TO_MY_HR"] = "Redirect to MyHR";
})(PageActionsForOmnitureMetrics || (PageActionsForOmnitureMetrics = {}));

var CALENDAR_CONSTANTS = {
  DAYS: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
  FORMAT_TOKEN: {
    // Change Ids in translations for Days of Week stringIds while changing day format.
    DAY: 'cccc',
    TIME: 'hh:mm a'
  }
};
var RECOMMENDED_WORD_LIMIT_FOR_CHAT = 50;
var CHAT_STATE_KEY = 'chat_state';
var START_TIME_WHEN_USER_CLICKED_FAB_KEY = 'startTimeWhenUserClickedFab';
var ATOZ_MYHR_APP_ROOT_ID = 'atoz-my-hr-app-root';
var LIVE_HELP_WIDGET_ROOT_ID = 'myhr-livehelp-widget-root';
/**
 * Page Load Latency
 */

var PAGE_LOAD_CHECK_TIME = 30;
var COMPLETE = 'complete';
var NAVIGATION = 'navigation';
/**
 *
 * Trick RefreshControl Scroll Effect
 * @typedef {Object} SCROLL_ELEMENT
 * @property ID [unique value so that the code does not effect other elements]
 * @property CSS [styling added to the newly created element to produce scroll effect]
 * @property PIXELS_TO_SCROLL_FROM_TOP [amount of scroll to perform]
 */

var SCROLL_ELEMENT = {
  ID: 'scroll-android-live-help-chat',
  CSS: 'position:absolute; width:100%; height:100%;',
  PIXELS_TO_SCROLL_FROM_TOP: 1
};
var ercNumbersMap = /*#__PURE__*/new Map([['IND', ['1800-30002058', '(+91) 2230430136']], ['USA', ['(+1) 8888927180']], ['GBR', ['0808-145-3744', '020-7855-3100']], ['CAN', ['0-800-015-0702']], ['CZE', ['800-701-388', '228-882-253']], ['IRL', ['1-800-947784', '165-31466']], ['POL', ['80-011-246-76', '12-881-11-61']], ['ZAF', ['080-098-8812']], ['DEU', ['0-800-000-9781', '(+49) 089-1208-5603']], ['FRA', ['0-800-907-578', '(+331) 70-39-49-57']], ['ITA', ['800-792-463', '(+39) 02-8295-0296']], ['SVK', ['0-800-606-025', '(+421) 233-456-686']], ['ESP', ['900-831-779', '(+34) 9-3220-3850']], ['AUS', ['(+61) 1300-109-674']], ['BEL', ['0800-714-62', '(+322) 80-865-08']], ['BHR', ['80006434']], ['CHN', ['8000', '400-623-6780']], ['EGY', ['(+20) 22-160-4988']], ['FIN', ['0800-917-731', '(+358) 9-4245-1824']], ['JPN', ['0800-123-3656']], ['MEX', ['018000623471', '4423489568']], ['NLD', ['800-022-9880', '(+31) 208-085-004']], ['NZL', ['(+61) 1300-109-674']], ['PHL', ['(+63) 28-271-1438', '(+63) 32-4200']], ['ROU', ['(+40) 800-896-340']], ['SGP', ['(+65) 64084280']], ['SWE', ['(+49) 89-2206-1049']], ['CHE', ['(+49) 89-2206-1049']], ['ARE', ['(+971) 45-731-573']]]);
var DEFAULT_LIVEHELP_CHANNEL_PRIORITY = 1000;
/**
 * @constant FAB_ICON_ZINDEX
 * this provides z-index for fab icon and in the case when Resizable of chat container is used
 * as it has default z-index as 1 and FAB (floating action button) has z-index of 799
 */

var FAB_ICON_ZINDEX = 799;
var SKIP_SSA_PAGE_QUERY_PARAM = 'needMoreHelp';
var ATOZ_NAVBAR_ZINDEX = {
  THOUSAND: '1000',
  SEVENT_FIFY: '750'
};
var GO_TO_MY_HR_TEXT = 'Go to My HR';
var MY_HR = 'My HR';
var ATOZ_REQUEST_ID_KEY = 'x-atoz-client-request-id';
var NA = 'NA';
var DEFAULT_CLICK_SOURCE = 'Browse';
var EMPTY_STRING_LITERAL = '';
var INLINE_FLYOUT_WIDTH_PX = 600;

var DEFAULT_PAGE_NAME = 'MyHR-Livehelp';
/**
 * Returns page name passed by the client for FAB
 */

var getPageName = function getPageName() {
  var _getDomDataset$pageNa;

  return (_getDomDataset$pageNa = getDomDataset().pageName) !== null && _getDomDataset$pageNa !== void 0 ? _getDomDataset$pageNa : isComponentInline() ? PageName.LIVEHELP_INLINE_PAGE_NAME : DEFAULT_PAGE_NAME;
};
/**
 * @function getClientId - Used to fetch clientID for current Inline session
 * If current session is "MyHR", returns "MyHR" else passed clientId is returned
 * @param clientIdFromProps clientId passed in FAB by client as prop.
 * @returns clientId string
 */

var getClientId = function getClientId(clientIdFromProps) {
  return isCurrentSessionMyHR() ? LaasClientId.MY_HR : clientIdFromProps;
};
/**
 * @function isComponentInline - Checks if component is inline FAB component
 * @returns boolean. true if component is inline.
 */

var isComponentInline = function isComponentInline() {
  var _document$getElementB;

  var livehelpWidget = (_document$getElementB = document.getElementById(LIVE_HELP_WIDGET_ROOT_ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.dataset;

  if (livehelpWidget) {
    return true;
  }

  return false;
};
/**
 * Returns DOM dataset attributes.
 */

var getDomDataset = function getDomDataset() {
  var _document$getElementB2, _document$getElementB3;

  var appRootId = isComponentInline() ? LIVE_HELP_WIDGET_ROOT_ID : ATOZ_MYHR_APP_ROOT_ID;
  return (_document$getElementB2 = (_document$getElementB3 = document.getElementById(appRootId)) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.dataset) !== null && _document$getElementB2 !== void 0 ? _document$getElementB2 : {};
};
/**
 * Checks if the session is MyHR or not
 * @returns true if the session is MyHR, otherwise false
 */

var isCurrentSessionMyHR = function isCurrentSessionMyHR() {
  var _getDomDataset = getDomDataset(),
      isMyhrSession = _getDomDataset.isMyhrSession,
      clientId = _getDomDataset.clientId; // If session is set as MyHR in DOM or clientId is MyHR, return true


  if (isMyhrSession === 'true' || clientId === LaasClientId.MY_HR) {
    return true;
  } // If session storate has clientId = MyHR, return true


  if (sessionStorage.getItem(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID) === LaasClientId.MY_HR) {
    return true;
  } // If query param has clientId = MyHR, return true


  var queryParamClientId = getClientIdFromQueryParam();

  if (queryParamClientId && queryParamClientId === LaasClientId.MY_HR) {
    return true;
  }

  var clientIdFromLocalStorage = localStorage.getItem(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID); // If local storage has clientId = MyHR and TTL is not expired, return true

  if (clientIdFromLocalStorage !== null && clientIdFromLocalStorage !== void 0 && clientIdFromLocalStorage.startsWith(LaasClientId.MY_HR)) {
    var clientIdSplitArray = clientIdFromLocalStorage.split('_');
    var ttl = Number(clientIdSplitArray[clientIdSplitArray.length - 1]); // If TTL for MyHR clientId is greater than current time, return true

    if (!Number.isNaN(ttl) && ttl > Date.now()) {
      return true;
    }
  }

  return false;
};

var EMPLOYEE_ID_FALLBACK = 'User';
/**
 * @function getUserIdentifier - Fetch employeeID from AToZ-Header DOM
 * @param fallback value that should be returned when employeeId is not found in DOM.
 * @returns employeeId if available else return "User"
 */

var getUserIdentifier = function getUserIdentifier(fallback) {
  if (fallback === void 0) {
    fallback = EMPLOYEE_ID_FALLBACK;
  }

  var dataset = getDomDataset();
  var employeeId = dataset.employeeId;

  if (employeeId) {
    return employeeId;
  }

  return fallback;
}; // for initial launch, keeping it as 7AM - 3:45PM PST

var isPriorityQueueOpen = function isPriorityQueueOpen() {
  var convertTimeToMinutesElapsed = function convertTimeToMinutesElapsed(hours, minutes) {
    return hours * 60 + minutes;
  };

  var startTime = convertTimeToMinutesElapsed(7, 0);
  var endTime = convertTimeToMinutesElapsed(15, 45);
  var currentDateTimeInPST = new Date(new Date().toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles'
  }));
  var currentTime = convertTimeToMinutesElapsed(currentDateTimeInPST.getHours(), currentDateTimeInPST.getMinutes());
  var currentDay = currentDateTimeInPST.getDay();
  var withinHoopDay = currentDay >= 1 && currentDay <= 5;
  var withinHoopTime = currentTime >= startTime && currentTime <= endTime;
  return withinHoopDay && withinHoopTime;
};
var getCountrySpecificErcNumbers = function getCountrySpecificErcNumbers(countryCode) {
  if (countryCode) {
    var ercNumberList = ercNumbersMap.get(countryCode); // when we don't have erc numbers for user's country

    if (!ercNumberList) {
      return null;
    }

    return ercNumberList.join(' / ');
  } // when we don't get country from atoz, should not happen but added as a precaution


  return null;
};

var SERVICE_NAME = 'LiveHelpService';
var INLINE_SERVICE_NAME = 'LiveHelpServiceInline';
var myHRLogger = /*#__PURE__*/new MyHRLogger(loggerConfig);
/**
 * @function getClientId - function to generate correct client id from Livehelp widget root dom and current session
 * If current session is MyHR or client id is not present in DOM, MyHR is returned as client id
 * @returns clientId
 */

var getClientId$1 = function getClientId() {
  if (isCurrentSessionMyHR()) {
    return LaasClientId$1.MY_HR;
  }

  var _getDomDataset = getDomDataset(),
      clientId = _getDomDataset.clientId;

  return clientId !== null && clientId !== void 0 ? clientId : LaasClientId$1.MY_HR;
};
/**
 * This method updates logs Context by adding pageName and clientId info to it
 * @param context - logs context
 */

var updateLogContextForInlineComponent = function updateLogContextForInlineComponent(context) {
  return Object.assign({}, context, {
    serviceName: getServiceName(),
    pageName: getPageName(),
    clientId: getClientId$1()
  });
};
/**
 * @function getServiceName - function to return generated service name
 * "LiveHelpService" is returned if component is not inline
 * "LiveHelpServiceInline" is returned if component is inline
 * @returns generated Service name for logs
 */


var getServiceName = function getServiceName() {
  if (isComponentInline()) {
    return INLINE_SERVICE_NAME;
  }

  return SERVICE_NAME;
};
/**
 * This method returns dimension map for metric
 * @param operation - name of the operation in which the metrics are to be collected
 * @param clientId - name of client for which metric are to be emitted
 * @param pageName - name of the page in which the metrics are to be collected
 */


var getMetricDimensions = function getMetricDimensions(operation, pageName, clientId) {
  // when both clientId and pageName present
  if (clientId && pageName) {
    return [{
      serviceName: getServiceName(),
      clientId: clientId.toString(),
      pageName: pageName,
      operation: operation
    }];
  } // when only pageName present


  if (!clientId && pageName) {
    return [{
      serviceName: getServiceName(),
      pageName: pageName,
      operation: operation
    }];
  } // when both pageName and client is not present


  return [{
    serviceName: getServiceName(),
    operation: operation
  }];
};

var getMetricDimensionList = function getMetricDimensionList(operation, pageName) {
  var metricDimensionList = [];

  if (isComponentInline()) {
    // we don't want to emit metrics here as pageName and clientId is not set for Prop validation
    if (operation !== 'PropsValidation' && pageName !== PageName.LIVEHELP_INLINE_PAGE_NAME) {
      metricDimensionList.push(getMetricDimensions(operation, getPageName(), getClientId$1()));
    }

    metricDimensionList.push(getMetricDimensions(operation));
  } else {
    metricDimensionList.push(getMetricDimensions(operation, pageName));
  }

  return metricDimensionList;
};
/**
 * This method gives logsContext for Inline Components
 * @param OPERATION_NAME - name of the operation in which the metrics are to be collected
 * @param pageName - name of the page in which the metrics are to be collected
 * @param clientId -
 */

var getLivehelpLogContextForInlineComponent = function getLivehelpLogContextForInlineComponent(OPERATION_NAME, clientId, pageName) {
  return {
    serviceName: INLINE_SERVICE_NAME,
    userIdentifier: getUserIdentifier(),
    pageName: pageName,
    operationName: OPERATION_NAME,
    clientId: clientId
  };
};
/**
 * @function recordLatencyMetric - function logs emf metric to capture the latency
 * @param pageName - name of the page in which the metrics are to be collected
 * @param operation - name of the operation in which the metrics are to be collected
 * @param startTime - start time of the operation
 */

var recordLatencyMetric = function recordLatencyMetric(pageName, operation, startTime) {
  var metricDimensionList = getMetricDimensionList(operation, pageName);
  metricDimensionList.forEach(function (metricDimension) {
    myHRLogger.logEmfMetric({
      metricName: MetricEvents.LATENCY,
      dimensions: metricDimension,
      metricUnit: MetricUnits.MILLISECONDS,
      metricValue: Date.now() - startTime
    });
  });
};

var ensurePageIsLoaded = function ensurePageIsLoaded() {
  var waitForPageLoad = function waitForPageLoad(resolve, reject) {
    if (document.readyState.toLowerCase() === COMPLETE) {
      resolve();
    } else {
      setTimeout(waitForPageLoad, PAGE_LOAD_CHECK_TIME, resolve, reject);
    }
  };

  return new Promise(waitForPageLoad);
};
/**
 * Function first ensures the page is loaded. Then it calculates the latency.
 * Latency is not logged when it is zero, undefined, NaN.
 * @param pageName - name of the page in which the metrics are to be collected
 * @param operation - name of the operation in which the metrics are to be collected
 */


var recordPerformanceLatencyMetric = function recordPerformanceLatencyMetric(pageName, operation) {
  var metricDimensionList = getMetricDimensionList(operation, pageName);
  ensurePageIsLoaded().then(function () {
    var _performance;

    var DOMLoad = 0;
    var pageNav = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.getEntriesByType(NAVIGATION)[0];

    if ((pageNav === null || pageNav === void 0 ? void 0 : pageNav.domComplete) !== undefined && (pageNav === null || pageNav === void 0 ? void 0 : pageNav.redirectStart) !== undefined) {
      DOMLoad = pageNav.domComplete - pageNav.redirectStart;
    }

    if (DOMLoad) {
      metricDimensionList.forEach(function (metricDimension) {
        myHRLogger.logEmfMetric({
          metricName: MetricEvents.LATENCY,
          dimensions: metricDimension,
          metricUnit: MetricUnits.MILLISECONDS,
          metricValue: DOMLoad
        });
      });
    }
  });
};
/**
 * @function recordCountMetric - function logs emf metric to capture the count
 * @param pageName - name of the page in which the metrics are to be collected
 * @param operation - name of the operation in which the metrics are to be collected
 * @param metricName - name of the metric (default:"count")
 * @param metricValue - count metric value (default: 1)
 */

var recordCountMetric = function recordCountMetric(pageName, operation, metricName, metricValue) {
  if (metricValue === void 0) {
    metricValue = 1;
  }

  var metricDimensionList = getMetricDimensionList(operation, pageName);
  metricDimensionList.forEach(function (metricDimension) {
    myHRLogger.logEmfMetric({
      metricName: metricName,
      dimensions: metricDimension,
      metricUnit: MetricUnits.COUNT,
      metricValue: metricValue
    });
  });
};
/**
 * @function recordErrorCountMetric - function logs emf metric to capture the count of errors into network and non-network errors
 * @param pageName - name of the page in which the metrics are to be collected
 * @param operation - name of the operation in which the metrics are to be collected
 * @param errorMessage - errorMessage
 * @param metricValue - count metric value (default: 1)
 */

var recordErrorCountMetric = function recordErrorCountMetric(pageName, operation, errorMessage, metricValue) {
  if (metricValue === void 0) {
    metricValue = 1;
  }

  // Based on the information in https://paste.amazon.com/show/vijrohit/1649667802, Network errror messages contain the string "Network Error"
  var metricDimensionList = getMetricDimensionList(operation, pageName);

  var isNetworkError = function isNetworkError() {
    var networkError = 'network error';

    if (errorMessage) {
      // Handles edge cases- null, undefined, NaN, empty string
      return errorMessage.toLowerCase().includes(networkError);
    }

    return false;
  }; // Return true if error message contains 4xx error message


  var is4xxError = function is4xxError() {
    if (errorMessage) {
      return errorMessage.includes(Exceptions.STATUS_CODE_400_ERROR) || errorMessage.includes(Exceptions.STATUS_CODE_403_ERROR);
    }

    return false;
  }; // Return true if error message contains axios related error messages


  var isAxiosError = function isAxiosError() {
    if (errorMessage) {
      return errorMessage.includes(Exceptions.AXIOS_0MS_ERROR) || errorMessage.includes(Exceptions.REQUEST_ABORTED_ERROR);
    }

    return false;
  };

  var metricName = MetricEvents.ERROR_COUNT;

  if (isNetworkError()) {
    metricName = MetricEvents.NETWORK_ERROR_COUNT;
  }

  if (is4xxError()) {
    metricName = MetricEvents.STATUS_CODE_4XX_ERROR;
  }

  if (isAxiosError()) {
    metricName = MetricEvents.AXIOS_ERROR;
  }

  myHRLoggerErrorLog("[" + getUserIdentifier() + "] : MetricName - " + metricName + ". " + getDetailedErrorMessage(errorMessage) + ".");
  metricDimensionList.forEach(function (metricDimension) {
    myHRLogger.logEmfMetric({
      metricName: metricName,
      dimensions: metricDimension,
      metricUnit: MetricUnits.COUNT,
      metricValue: metricValue
    });
  });
};
/**
 * @function myHRLoggerInfoLog - function to log "info" level log line using MyHRLogger
 * @param message - the human readable string identifying the log line
 * @param context - an optional arbitrary additional data JSON object to log
 */

var myHRLoggerInfoLog = function myHRLoggerInfoLog(message, context) {
  if (isComponentInline()) {
    myHRLogger.info(message, updateLogContextForInlineComponent(context));
  } else {
    myHRLogger.info(message, context);
  }
};
/**
 * @function myHRLoggerWarnLog - function to log "warn" level log line using MyHRLogger
 * @param message - the human readable string identifying the log line
 * @param context - an optional arbitrary additional data JSON object to log
 */

var myHRLoggerWarnLog = function myHRLoggerWarnLog(message, context) {
  if (isComponentInline()) {
    myHRLogger.warn(message, updateLogContextForInlineComponent(context));
  } else {
    myHRLogger.warn(message, context);
  }
};
/**
 * @function myHRLoggerErrorLog - function to log "error" level log line using MyHRLogger
 * @param message - the human readable string identifying the log line
 * @param context - an optional arbitrary additional data JSON object to log
 */

var myHRLoggerErrorLog = function myHRLoggerErrorLog(message, context) {
  if (isComponentInline()) {
    myHRLogger.error(message, updateLogContextForInlineComponent(context));
  } else {
    myHRLogger.error(message, context);
  }
};
/**
 * @function errorMessage - function to generate error message
 * Message includes stringified error, non-stringified error
 * If error message is from backend, contains backend error message
 * @param error - Error Object
 * @returns generated error message
 */

var getDetailedErrorMessage = function getDetailedErrorMessage(error) {
  var _error$response, _error$response$data, _error$response2, _error$response2$data;

  var errorMessage = (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.message ? ", Backend Error Message : " + (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) + "," : "") + " Error - " + error + ", Error Stringified : " + JSON.stringify(error);
  return errorMessage;
};

var LanguagesAvailable;

(function (LanguagesAvailable) {
  LanguagesAvailable["ar_SA"] = "ar-SA";
  LanguagesAvailable["cs"] = "cs";
  LanguagesAvailable["de_DE"] = "de-DE";
  LanguagesAvailable["nl_NL"] = "nl-NL";
  LanguagesAvailable["en_CA"] = "en-CA";
  LanguagesAvailable["en_IN"] = "en-IN";
  LanguagesAvailable["en_GB"] = "en-GB";
  LanguagesAvailable["en_US"] = "en-US";
  LanguagesAvailable["es_ES"] = "es-ES";
  LanguagesAvailable["es_MX"] = "es-MX";
  LanguagesAvailable["fr_CA"] = "fr-CA";
  LanguagesAvailable["fr_FR"] = "fr-FR";
  LanguagesAvailable["id_ID"] = "id-ID";
  LanguagesAvailable["it_IT"] = "it-IT";
  LanguagesAvailable["ja_JP"] = "ja-JP";
  LanguagesAvailable["ko_KR"] = "ko-KR";
  LanguagesAvailable["pl_PL"] = "pl-PL";
  LanguagesAvailable["pt_BR"] = "pt-BR";
  LanguagesAvailable["ro_RO"] = "ro-RO";
  LanguagesAvailable["sk"] = "sk";
  LanguagesAvailable["tr_TR"] = "tr-TR";
  LanguagesAvailable["uk_UA"] = "uk-UA";
  LanguagesAvailable["vi_VN"] = "vi-VN";
  LanguagesAvailable["zh_CN"] = "zh-CN";
  LanguagesAvailable["zu_ZA"] = "zu-ZA";
})(LanguagesAvailable || (LanguagesAvailable = {}));

var FETCH_IS_APP_OPERATION = 'FetchIsAppFromDOM';
var IS_APP_ATTRIBUTE = 'isApp';
var FETCH_LOCALE_OPERATION = 'FetchLocaleFromDOM';
var LOCALE_ATTRIBUTE = 'locale';
var FETCH_IS_EXTERNAL_NETWORK_OPERATION = 'FetchIsExternalNetworkFromDOM';
var IS_EXTERNAL_NETWORK_ATTRIBUTE = 'isExternalNetwork';
var FETCH_COUNTRY_CODE_OPERATION = 'FetchCountryCodeFromDOM';
var COUNTRY_CODE_ATTRIBUTE = 'countryCode';
var FETCH_POPSTAR_FEATURES_OPERATION = 'FetchPopstarFeaturesFromDOM';
var POPSTAR_FEATURES_ATTRIBUTE = 'popstarFeatures';
/**
 * Logs and publishes metrics when attribute was not found in DOM
 * @param attribute Name of the attribute that was not found in DOM.
 * @param operation Operation name to be used.
 * @param dataset Attributes that were found in DOM.
 * @param fallbackUsed Fallback value that was used.
 */

var onFailedFetchDOMOperation = function onFailedFetchDOMOperation(attribute, operation, dataset, fallbackUsed) {
  var pageName = getPageName();
  myHRLoggerErrorLog("Failed to fetch attribute " + attribute + " from DOM on path " + window.location.href + ". Used fallback value: " + JSON.stringify(fallbackUsed), {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: pageName,
    dataset: dataset
  });
  recordErrorCountMetric(pageName, operation, 'Failed to fetch attribute from DOM');
};
/**
 * @function isEnvironmentBrowser - Check if the user is on browser
 * @returns true if on browser, else return false
 */


var isEnvironmentBrowser = function isEnvironmentBrowser() {
  var dataset = getDomDataset();
  var isApp = dataset.isApp;

  if (isApp) {
    return isApp === 'false';
  }

  var fallbackValue = (browserName in BrowserTypes);
  onFailedFetchDOMOperation(IS_APP_ATTRIBUTE, FETCH_IS_APP_OPERATION, dataset, fallbackValue);
  return fallbackValue;
};
/**
 * Returns preferred language of the user
 * @param fallback value that should be returned when preferred is not found in DOM.
 */

var getPreferredLanguage = function getPreferredLanguage(fallback) {
  var dataset = getDomDataset();
  var preferredLanguage = dataset.locale;

  if (preferredLanguage && Object.values(LanguagesAvailable).includes(preferredLanguage)) {
    return preferredLanguage;
  }

  var fallbackValue = fallback !== undefined ? fallback : LanguagesAvailable.en_US;
  onFailedFetchDOMOperation(LOCALE_ATTRIBUTE, FETCH_LOCALE_OPERATION, dataset, fallbackValue);
  return fallbackValue;
};
/**
 * Returns false if user is on Amazon VPN, else returns true.
 * @param fallback value that should be returned when value is not found in DOM.
 */

var getIsUserOffNetwork = function getIsUserOffNetwork(fallback) {
  if (fallback === void 0) {
    fallback = false;
  }

  // TODO: Investigate on how we can find if user is on VPN or not.
  var dataset = getDomDataset();
  var isExternalNetwork = dataset.isExternalNetwork;

  if (isExternalNetwork) {
    return isExternalNetwork === 'true';
  }

  onFailedFetchDOMOperation(IS_EXTERNAL_NETWORK_ATTRIBUTE, FETCH_IS_EXTERNAL_NETWORK_OPERATION, dataset, fallback);
  return fallback;
};
/**
 * Returns country code of the user
 * @param fallback value that should be returned when country code is not found in DOM.
 */

var getCountryCode = function getCountryCode(fallback) {
  var dataset = getDomDataset();
  var countryCode = dataset.countryCode;

  if (countryCode) {
    return countryCode;
  }

  onFailedFetchDOMOperation(COUNTRY_CODE_ATTRIBUTE, FETCH_COUNTRY_CODE_OPERATION, dataset, fallback);
  return fallback;
};
/**
 * Returns list of popstar feature flags enabled for the user.
 */

var getPopstarFeatures = function getPopstarFeatures() {
  var dataset = getDomDataset();
  var popstarFeatures = dataset.popstarFeatures;

  if (popstarFeatures) {
    return JSON.parse(popstarFeatures);
  }

  var fallbackValue = [];
  onFailedFetchDOMOperation(POPSTAR_FEATURES_ATTRIBUTE, FETCH_POPSTAR_FEATURES_OPERATION, dataset, fallbackValue);
  return fallbackValue;
};

var ErcErrorBanner = function ErcErrorBanner() {
  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var ercNumbers = getCountrySpecificErcNumbers(getCountryCode());
  return /*#__PURE__*/React.createElement(View, {
    margin: matches.s ? {
      top: 16
    } : {
      top: 27
    }
  }, /*#__PURE__*/React.createElement(MessageBanner, {
    type: MessageBannerType.Error,
    isDismissible: false
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 16,
    color: "#232F3E"
  }, /*#__PURE__*/React.createElement("b", null, " ", t('livehelp.loading_error_text'), " "), t('livehelp.loading_error')), ercNumbers && /*#__PURE__*/React.createElement(Text, {
    fontSize: 16,
    color: "#232F3E"
  }, t('livehelp.erc_number_message'), " ", ercNumbers)));
};

var OPERATION_NAME = 'JS Runtime Error Metric';
var LIVEHELP_ERROR_BOUNDARY = 'LiveHelpErrorBoundary';
var getLogsContext = function getLogsContext() {
  return {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    operationName: OPERATION_NAME,
    pageName: LIVEHELP_ERROR_BOUNDARY
  };
};
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      hasError: false
    };
    _this.userIdentifier = getUserIdentifier();
    return _this;
  }
  /**
   * @function getDerivedStateFromError - function updates state to render Error UI
   * @returns - returns updated state
   */


  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  /**
   * @function componentDidCatch - function to log errors to cloudwatch and redirect user to error page
   * @param error - minor info on error
   * @param errorInfo - detailed info on error
   */
  ;

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    var logsContext = getLogsContext();
    recordErrorCountMetric(logsContext.pageName, logsContext.operationName, JSON.stringify(error));

    if (isComponentInline()) {
      myHRLoggerErrorLog("[" + this.userIdentifier + "]: Runtime error occured in pageName: " + getPageName() + " for client: " + getClientId$1() + " with error: " + getDetailedErrorMessage(error), errorInfo);
    } else {
      myHRLoggerErrorLog("[" + this.userIdentifier + "]: Runtime error occured. " + getDetailedErrorMessage(error), errorInfo);
      window.location.replace(URLConstants.ERROR_URL);
    }
  };

  _proto.render = function render() {
    if (this.state.hasError) {
      if (isComponentInline()) {
        return /*#__PURE__*/React.createElement(ErcErrorBanner, null);
      }

      return /*#__PURE__*/React.createElement(View$1, null);
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(React.Component);

var atoz_myhr_app = {
	livehelp: {
		help_eligibility_title: "للحصول على مساعدة بشأن أهلية التطبيق، يمكنك التواصل مع HR الآن أو إنشاء طلب.",
		chat_title: "دردشة",
		call_title: "الاتصال",
		create_request: "إنشاء طلب",
		wait_time: "وقت الانتظار",
		response_time: "وقت الاستجابة",
		waiting_time_minute_text: "{{minutes}} دقيقة",
		waiting_time_hours_text: "{{hours}} ساعات",
		hr_help_and_support: "التواصل مع HR وإدارة الطلبات",
		call_error_processing: "حدث خطأ أثناء معالجة طلبك، يرجى المحاولة مرة أخرى من البداية.",
		help_needed_with: "ما الذي تحتاج إلى مساعدة بشأنه؟",
		immigration_title: "الترحيل",
		disability_and_leave_title: "الإعاقة والإجازة",
		other: "غير ذلك",
		submit: "إرسال",
		cancel: "إلغاء",
		enter_number_title: "أدخل رقمك لتلقي مكالمة من HR.",
		request_call: "طلب مكالمة",
		amazon_support_contact_shortly: "ستتلقى مكالمة من فريق دعم موظفي Amazon قريبًا.",
		confirm_preferred_phone_number: "لطلب مكالمة، قم بتأكيد رقم هاتفك المفضل ولغتك المفضلة",
		what_preferred_phone_no: "ما هو رقم هاتفك المفضل؟",
		preferred_language_text: "ما هي لغتك المفضلة؟",
		what_to_expect: "ما يمكن توقعه",
		call_from_agent_minutes: "سيتصل بك أحد الموظفين في غضون ${minutes} دقائق",
		call_from_amazon_number: "ستظهر المكالمة كرقم ${contactNumber} أو رقم مجهول",
		disconnected_agent_call_minute: "في حالة قطع الاتصال، سيتصل بك الموظف مرة أخرى في غضون دقيقة واحدة",
		live_help_text_timekeeping_leaves_of_absence: "للمساعدة بشأن ضبط الوقت والإجازات المأذونة، يمكنك الاتصال أو الدردشة أو إنشاء طلب",
		get_call_back: "معاودة الاتصال",
		request_phone_call: "طلب مكالمة هاتفية",
		close_chat_window: "هل ترغب في إغلاق نافذة الدردشة المباشرة؟",
		chat_ended: "تم إنهاء الدردشة.",
		idle_chat_disconnect: "تم قطع الاتصال بسبب عدم النشاط",
		disconnect_from_chat: "غادر المستخدم الدردشة. تم إنهاء محادثة الدردشة.",
		chat_idle_message: "تم قطع الدردشة بسبب الخمول لمدة {{minutes}} دقائق.",
		chat_extended_after_idleness: "قام المستخدم بتمديد جلسته بعد تحذير الخمول.",
		surety_chat_idle_message: "مرحبًا، أريد فقط التأكد من أن دردشتنا لا تزال متصلة. لقد كنا خاملين لمدة ${minutes} دقائق. سيتم إغلاق الدردشة، إذا لم تتمكن من الرد في غضون دقيقتين.",
		disconnect_chat_message: "هل أنت متأكد من رغبتك في قطع الاتصال بالدردشة؟",
		supported_file_attachments: "أنواع الملفات المدعومة لمرفقات الدردشة: .pdf، .jpg، .jpeg، .png، .doc، .docx، .xls، .csv، .wav، .pptx، .pptx، .ppt، .txt.  الحد الأقصى لحجم الملف لمرفق الدردشة هو 20 ميغابايت.",
		upload_attachment: "تحميل المرفق",
		choose_file_upload: "اختر ملف لتحميله",
		stay_Connected: "ابق على اتصال",
		disconnect: "قطع الاتصال",
		message_input_placeholder: "اكتب رسالة واضغط على «إدخال» لإرسالها",
		upload: "تحميل",
		end_chat: "إنهاء الدردشة",
		connect: "الاتصال",
		save_chat: "حفظ الدردشة",
		connected: "متصل",
		user_left_chat: "غادر {{user}} الدردشة. تم إنهاء محادثة الدردشة.",
		user_left_chat_during_transfer: "غادر {{user}} الدردشة. يتم نقلك.",
		user_joined_chat: "انضم ${user} إلى الدردشة",
		input_phone_number: "إدخال رقم هاتفك",
		time: "الوقت",
		call_from_anonymous_number: "ستظهر المكالمة كرقم ${contactNumber} أو رقم مجهول",
		extended_user_session_warning: "قام المستخدم بتمديد جلسته بعد تحذير الخمول",
		close: "إغلاق",
		okay: "حسنًا",
		send: "إرسال",
		timer_message: "طلب الاتصال مرة أخرى بعد {{counter}} ثوانٍ",
		start_new_chat: "بدء دردشة جديدة",
		open_menu: "فتح القائمة",
		live_chat: "دردشة مباشرة",
		end_chat_session: "إنهاء جلسة الدردشة",
		create_request_3steps: "يمكنك إنشاء طلب من خلال 3 خطوات",
		available_now: "متاح الآن",
		phone: "هاتف",
		minute: "دقيقة",
		chat_with_HR: "دردشة مباشرة",
		chat_with_HR_desc: "تحدث مع أحد موظفي HR لمعالجة استفسارك على الفور",
		call_HR: "الاتصال",
		call_hr_desc: "اتصل بقسم HR لتقديم الاستفسارات الحرجة/العاجلة",
		doc_note_due_date_ready: "تم تجهيز ملاحظة الطبيب مع التاريخ المحدد للتحميل",
		system: "النظام",
		connected_with_agent: "أنت الآن على اتصال بموظف المساعدة المباشرة",
		transferring_to_agent: "جارٍ نقلك إلى موظف المساعدة المباشرة",
		days: "أيام",
		request_a_call: "طلب مكالمة",
		request_phone_call_heading: "للتواصل مع HR عبر الهاتف، نحتاج إلى رقم هاتفك واللغة المفضلين.",
		request_phone_call_heading_2: "للتواصل مع HR عبر الهاتف، نحتاج إلى رقم هاتفك المفضل.",
		what_your_preffered_number: "ما هو رقم هاتفك المفضل (بما في ذلك رمز البلد)؟",
		what_your_preffered_language: "ما هي لغتك المفضلة؟",
		phone_number_cannot_be_empty: "لا يمكن ترك رقم الهاتف فارغًا",
		only_numbers_allowed: "يسمح فقط بالأرقام هنا",
		receive_call_number: "ستتلقى مكالمة فورية من {{contactNumber}}.",
		receive_call_HR_team: "ستتلقى على الفور مكالمة من فريق HR support.",
		agent_hold_with_wait_time: "سيتم وضعك قيد الانتظار وسيتواصل الموظف معك في غضون ${waitTime} دقائق.",
		agent_hold_without_wait_time: "سيتم وضعك قيد الانتظار وسيتواصل الموظف معك.",
		disconnected_agent_wait: "في حالة قطع الاتصال، سيتصل بك الموظف مرة أخرى في غضون دقيقة واحدة.",
		call_hr_desc2: "أدخل رقم هاتفك وسيتصل بك أخصائي HR Support مباشرةً.",
		create_hr_request: "طلب",
		chat_with_an_hr_specialist: "الدردشة مع أخصائي HR",
		talk_to_an_hr_specialist: "تحدث إلى أخصائي HR",
		create_an_hr_case: "إنشاء HR Case",
		minutes: "دقائق",
		waiting_time_less_than_minute_text: "أقل من دقيقة واحدة",
		waiting_time_minutes_text: "{{minutes}} دقائق",
		waiting_time_hour_text: "{{hours}} ساعة",
		waiting_time_more_than_hours_text: "أكثر من {{hours}} ساعات",
		few_days: "من يوم إلى يومين",
		landing_page_heading: "المساعدة في ${category}",
		landing_page_subheading: "تواصل مع HR {{availableChannels}}.",
		subheading_chat_text: "من خلال الدردشة المباشرة",
		subheading_call_text: "عن طريق الهاتف",
		subheading_case_text: "عن طريق إنشاء طلب",
		or_connector: "أو",
		create_case_description: "إذا لم تكن بحاجة إلى مساعدة فورية، فأنشئ طلبًا.",
		next_hours_of_operation: "الدعم التالي متاح من {{day}} {{startTime}} إلى {{endTime}}",
		next_hours_of_operation_with_days: "الدعم التالي متاح من {{startDay}} {{startTime}} إلى {{endDay}} {{endTime}}",
		time_in_am: "{{time}} صباحًا",
		time_in_pm: "{{time}} مساءً",
		download_transcript_error: "فشل تنزيل النص. يرجى المحاولة مرة أخرى.",
		download_attachment_error: "فشل تنزيل المرفق. يرجى المحاولة مرة أخرى.",
		sent_message_error: "يتعذر إرسال الرسالة بسبب انقطاع الشبكة. يرجى التحقق من شبكتك والمحاولة مرة أخرى.",
		get_contact_channels_failure: "فشل الحصول على القنوات المتاحة. يرجى المحاولة مرة أخرى.",
		select_a_file: "حدد ملفًا",
		external_disable_message: "يمكن الوصول إليها داخل شبكة Amazon",
		required_field: "حقل مطلوب",
		end_chat_modal_text: "سيؤدي هذا إلى إنهاء الدردشة المباشرة مع جلسة HR.",
		end_chat_modal_title: "هل تريد إنهاء الدردشة؟",
		download_transcript: "تنزيل النص",
		new_live_chat_session: "جلسة دردشة مباشرة جديدة",
		live_chat_with_HR: "دردشة مباشرة مع HR",
		chat_header_title: "مرحبًا بك في الدردشة المباشرة مع HR",
		chat_header_subtitle_key: "تم اختيار الموضوع",
		chat_session_started: "بدأت جلسة الدردشة",
		chat_session_ended: "تم إنهاء جلسة الدردشة",
		chat_wait_system_message: "يرجى الانتظار حتى نقوم بتوصيلك بموظف الدردشة المباشرة.",
		chat_waitTime_system_message: "وقت الانتظار المقدر هو",
		chat_info_system_message: "ستبقى جلسة الدردشة متصلة حتى إذا غادرت هذه النافذة.",
		chat_agent_typing_message: "موظف الدعم يكتب",
		livechat_warning_banner: "سيتم قطع الدردشة المباشرة مع جلسة HR في غضون {{minutes}} دقائق",
		no_available_channel: "لا توجد قنوات متاحة في الوقت الحالي. يرجى استخدام خيار «شيء آخر» في هذا الوقت.",
		chat_input_footer_label: "الرسالة الخاصة بك",
		business_days: "{{days}} أيام عمل",
		business_day: "{{day}} يوم عمل",
		file_size_limit: "يجب أن يكون حجم الملف أقل من 20 ميغابايت.",
		generic_error_message: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
		one_field_reqd_error: "مطلوب حقل واحد على الأقل لإرسال نموذج الاستبيان.",
		send_survey: "إرسال الاستبيان",
		upload_error_access_denied: "تم رفض إذن الوصول.",
		upload_error_internal_server_exception: "حدثت مشكلة في الخدمة تتعلق بطلبك، يرجى المحاولة مرة أخرى.",
		upload_error_service_quota_exceeded: "تم الوصول إلى الحد الأقصى وهو 5 مرفقات.",
		upload_error_throttling: "حدثت مشكلة في الخدمة تتعلق بطلبك، يرجى المحاولة مرة أخرى.",
		upload_error_validation: "نوع ملف المرفقات غير مدعوم.",
		upload_error_generic: "يتعذر تحميل المرفق",
		not_allowed_destination: "لا يُسمح بالمكالمات الصادرة إلى رقم الوجهة",
		call_not_allowed: "لا يمكن استقبال المكالمة على هذا الرقم",
		check_country_code: "تأكد من إضافة رمز البلد في بداية الرقم.",
		try_different_number: "جرب رقمًا مختلفًا.",
		Sunday: "الأحد",
		Monday: "الإثنين",
		Tuesday: "الثلاثاء",
		Wednesday: "الأربعاء",
		Thursday: "الخميس",
		Friday: "الجمعة",
		Saturday: "السبت",
		recommended_words_error_text: "{{wordCount}} الكلمات التي تم إدخالها. يُسمح بعدد كلمات يصل إلى {{wordLimit}}",
		recommended_words_text: "تم إدخال {{wordCount}} من الكلمات. {{wordLimit}} أو أقل مطلوبة",
		stay_connected: "ابق على اتصال",
		chat_open_error_modal_text: "لديك دردشة مفتوحة بالفعل، يرجى إغلاقها لبدء محادثة جديدة.",
		chat_open_error_modal_title: "الدردشة مفتوحة بالفعل",
		previous_chat_history: "سجل الدردشة السابق",
		choose_chat_history: "اختيار سجل الدردشة",
		no_chat_records_available: "لم يتم العثور على سجلات دردشة سابقة. انتقل إلى LiveChat للدردشة مع الموظف",
		empty_chat_present: "لا توجد محادثة في جلسة الدردشة هذه",
		language_support_text: "نعمل حاليًا على تحسين تجربتك. يمكنك الآن الوصول إلى بوابة الخدمة الذاتية لفريق خدمات الإعاقات والإجازات باللغة الإنجليزية.",
		english_language_only_text: "اللغة الإنجليزية فقط",
		invalid_message_contraint_error: "تم تجاوز عدد الأحرف المسموح به. يُسمح بحد أقصى 1024 حرفًا",
		loading_error: "حدث خطأ أثناء تحميل هذه الشاشة. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
		loading_error_text: "حدث خطأ أثناء التحميل.",
		maximize_chat_history: "تكبير سجل الدردشة",
		minimize_chat_history: "تصغير سجل الدردشة",
		need_more_help: "هل تحتاج إلى مزيد من المساعدة؟",
		erc_number_message: "للحصول على الدعم الفوري، يمكنك التواصل مع قسم HR على:",
		get_started: "البدء",
		self_service_content_error: "حدثت مشكلة أثناء تحميل محتوى الخدمة الذاتية. يرجى استخدام زر «البدء» لبدء سير عمل الخدمة الذاتية.",
		describe_issue_title: "صف مشكلتك للتواصل مع موظف الدعم",
		record_chat_session: "قد يتم تسجيل جلسة الدردشة لأغراض تتعلق بالجودة أو التدريب.",
		idleness_disconnect_message: "سيتم قطع الدردشة إذا كنت في وضع الخمول أو لم يتم الرد لأكثر من {{minutes}} دقائق.",
		userinput_box_hint_text: "ما الذي تحتاج إلى مساعدة بشأنه؟",
		get_help: "احصل على مساعدة",
		connect_with_hr_by_chat_phone_request: "تواصل مع HR عن طريق الدردشة المباشرة أو الهاتف أو عن طريق إنشاء طلب.",
		myhr_contact_us: "My HR | اتصل بنا",
		not_able_to_get_live_help: "لا يمكننا الحصول على خيارات دعم المساعدة المباشرة لك في الوقت الحالي. يرجى زيارة MyHR للحصول على مساعدة إضافية",
		chat_transcript_opt_in_modal_content: "يرغب كيان Amazon الذي تستخدمه في تخزين هذه الدردشة لأغراض تتعلق بالجودة والتدريب وحفظ السجلات. للموافقة، انقر على «موافقة». للرفض، انقر على «رفض». للحصول على مزيد من المعلومات حول كيفية تعاملنا مع بياناتك الشخصية، بما في ذلك حقك في التراجع عن الموافقة، راجع إشعار Amazon العالمي المتعلق بخصوصية الموظف على Inside Amazon.",
		chat_transcript_opt_in_modal_title: "هل تريد الاشتراك في نص الدردشة؟",
		chat_transcript_opt_in_consent: "الموافقة",
		chat_transcript_opt_in_decline: "رفض",
		connect_to_provider: "هل تريد الاتصال بمقدم خدمات الصحة التابع لجهة خارجية؟",
		your_information: "معلوماتك",
		all_feilds_are_required: "جميع الحقول مطلوبة.",
		name: "الاسم",
		email: "البريد الإلكتروني",
		phoneNumber: "رقم الهاتف",
		"continue": "المتابعة",
		please_provide_valid: "يرجى تقديم بيانات صالحة",
		to_start_live_chat_click_continue: "لبدء جلسة الدردشة المباشرة مع طبيب الصحة النفسية، قدم معلوماتك وانقر على «متابعة».",
		you_are_connected_with_a_third_party: "أنت متصل بمقدم مساعدة الموظفين (EAP) التابع لجهة خارجية.",
		to_save_transcript_download: "لحفظ هذا النص، قم بتنزيل النص قبل إغلاق هذه الجلسة.",
		fix_the_errors: "إصلاح الأخطاء: لم ترد على [X] الأسئلة المطلوبة.",
		all_clinicians_busy: "عذرًا، ولكن يبدو أن جميع الأطباء مشغولون بالموظفين الآخرين. انقر فوق جلسة دردشة مباشرة جديدة لإعادة الدخول إلى قائمة الانتظار.",
		username: "الاسم",
		connect_to_a_provider_outside_amazon: "هل تريد الاتصال بمقدم خدمة من خارج Amazon؟",
		you_are_now_connected_to_confidential: "أنت الآن تتصل بمقدم خدمة خارجي وسري خارج Amazon يتطلب اسمك ورقم هاتفك وتفاصيل موقعك للتسجيل والمصادقة. هذه الخدمة مجانية وسرية.",
		no_agents: "وكلاء الموارد البشرية (HR) غير متاحين حاليًا، يرجى تجربة قناة أخرى",
		high_wait_time: "جميع وكلاء الموارد البشرية (HR) لدينا مشغولون في الوقت الحالي. يرجى تجربة قنوات أخرى في هذه الأثناء",
		by_tapping_continue_agree_wpo_terms: "بالنقر على «متابعة»، فإنك توافق على انك قد قرأت خدمة «خيارات مكان العمل» ووافقت عليها",
		terms_and_conditions: "الشروط والأحكام",
		end_chat_modal_text_wpo: "سيؤدي هذا إلى إيقاف الدردشة المباشرة.",
		live_support_options: "خيارات الدعم المباشر",
		open: "فتح",
		myhr: "My HR"
	}
};
var arSA = {
	atoz_myhr_app: atoz_myhr_app
};

var atoz_myhr_app$1 = {
	livehelp: {
		help_eligibility_title: "Pokud chcete pomoci se způsobilostí žádostí, můžete se nyní spojit s oddělením HR nebo vytvořit žádost.",
		chat_title: "Chat",
		call_title: "Hovor",
		create_request: "Vytvořit požadavek",
		wait_time: "Čekací doba",
		response_time: "Doba odezvy",
		waiting_time_minute_text: "{{minutes}} min",
		waiting_time_hours_text: "{{hours}} hod",
		hr_help_and_support: "Kontaktování oddělení HR a správa požadavků",
		call_error_processing: "Při zpracování vašeho požadavku došlo k chybě, zkuste to znovu od začátku.",
		help_needed_with: "S čím potřebujete pomoci?",
		immigration_title: "Imigrace",
		disability_and_leave_title: "Invalidita a volno",
		other: "Jiné",
		submit: "Odeslat",
		cancel: "Zrušit",
		enter_number_title: "Zadejte číslo, na které vám zavolá oddělení HR.",
		request_call: "Požádat o hovor",
		amazon_support_contact_shortly: "Brzy vám zavolá tým podpory zaměstnanců Amazonu.",
		confirm_preferred_phone_number: "Pokud chcete požádat o hovor, potvrďte preferované telefonní číslo a jazyk.",
		what_preferred_phone_no: "Jaké je vaše telefonní číslo?",
		preferred_language_text: "Jaký je váš preferovaný jazyk?",
		what_to_expect: "Co můžete očekávat",
		call_from_agent_minutes: "Agent vám zavolá během ${minutes} min",
		call_from_amazon_number: "Hovor se zobrazí jako ${contactNumber} nebo anonymní číslo",
		disconnected_agent_call_minute: "Pokud budete odpojeni, agent vám zavolá zpět do 1 minuty.",
		live_help_text_timekeeping_leaves_of_absence: "Pokud potřebujete pomoc s evidencí pracovní doby a absencí, můžete zavolat, chatovat nebo vytvořit požadavek.",
		get_call_back: "Nechte si zavolat zpět",
		request_phone_call: "Požádat o telefonní hovor",
		close_chat_window: "Chcete zavřít okno živého chatu?",
		chat_ended: "Chat skončil.",
		idle_chat_disconnect: "Odpojeno z důvodu neaktivity",
		disconnect_from_chat: "Uživatel opustil chat. Konverzace na chatu byla ukončena.",
		chat_idle_message: "Chat byl odpojen z důvodu nečinnosti po dobu {{minutes}} minut.",
		chat_extended_after_idleness: "Uživatel prodloužil relaci po upozornění na neaktivitu.",
		surety_chat_idle_message: "Dobrý den, chci se jen ujistit, že je náš chat stále ve spojení. Chat je neaktivní po dobu ${minutes} min. Pokud neodpovíte do 2 minut, chat se ukončí.",
		disconnect_chat_message: "Opravdu se chcete odpojit od chatu?",
		supported_file_attachments: "Podporované typy souborů pro přílohy chatu: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Maximální velikost souboru pro přílohu chatu je 20 MB.",
		upload_attachment: "Nahrát přílohu",
		choose_file_upload: "Vyberte soubor, který chcete nahrát",
		stay_Connected: "Zůstaňte připojeni",
		disconnect: "Odpojit",
		message_input_placeholder: "Zadejte zprávu a odešlete pomocí klávesy Enter",
		upload: "Nahrát",
		end_chat: "Ukončit chat",
		connect: "Připojit se",
		save_chat: "Uložit chat",
		connected: "Připojeno",
		user_left_chat: "{{user}} opustil/a chat. Vaše konverzace v chatu byla ukončena.",
		user_left_chat_during_transfer: "{{user}} opustil/a chat. Jste přepojováni.",
		user_joined_chat: "${user} se připojil/a se k chatu",
		input_phone_number: "Zadejte telefonní číslo",
		time: "Čas",
		call_from_anonymous_number: "Hovor se zobrazí jako ${contactNumber} nebo anonymní číslo",
		extended_user_session_warning: "Uživatel prodloužil relaci po upozornění na neaktivitu",
		close: "Zavřít",
		okay: "Dobře",
		send: "Odeslat",
		timer_message: "Vyžádejte si hovor znovu po {{counter}} s",
		start_new_chat: "Zahájit nový chat",
		open_menu: "Otevřít nabídku",
		live_chat: "Živý chat",
		end_chat_session: "Ukončit relaci chatu",
		create_request_3steps: "Požadavek můžete vytvořit ve třech krocích",
		available_now: "K dispozici",
		phone: "telefon",
		minute: "min",
		chat_with_HR: "Živý chat",
		chat_with_HR_desc: "Chatujte s oddělením HR, abyste mohli svůj dotaz vyřešit okamžitě",
		call_HR: "Hovor",
		call_hr_desc: "V případě kritických/naléhavých dotazů zavolejte oddělení HR",
		doc_note_due_date_ready: "Připravte si k nahrání potvrzení od lékaře s datem",
		system: "SYSTÉM",
		connected_with_agent: "Nyní jste spojeni s agentem živé nápovědy",
		transferring_to_agent: "Přepojení na agenta živé nápovědy",
		days: "dní",
		request_a_call: "Požádat o hovor",
		request_phone_call_heading: "Pokud se chcete s oddělením HR spojit telefonicky, potřebujeme znát vaše telefonní číslo a jazyk.",
		request_phone_call_heading_2: "Pokud se chcete s oddělením HR spojit telefonicky, potřebujeme znát vaše telefonní číslo.",
		what_your_preffered_number: "Jaké je vaše telefonní číslo (včetně předvolby země)?",
		what_your_preffered_language: "Jaký je váš preferovaný jazyk?",
		phone_number_cannot_be_empty: "Telefonní číslo nesmí být prázdné",
		only_numbers_allowed: "Povolena jsou pouze čísla",
		receive_call_number: "Okamžitě obdržíte hovor z čísla {{contactNumber}}.",
		receive_call_HR_team: "Okamžitě vám zavolá tým HR Support.",
		agent_hold_with_wait_time: "Chat bude přidržen a agent se s vámi spojí do ${waitTime} minuty.",
		agent_hold_without_wait_time: "Chat bude přidržen a agent se s vámi spojí.",
		disconnected_agent_wait: "Pokud budete odpojeni, agent vám zavolá zpět do 1 minuty.",
		call_hr_desc2: "Uveďte telefonní číslo a odborník HR Support vám zavolá.",
		create_hr_request: "Požadavek",
		chat_with_an_hr_specialist: "Chat s odborníkem HR",
		talk_to_an_hr_specialist: "Obraťte se na odborníka HR",
		create_an_hr_case: "Vytvořit HR Case",
		minutes: "min",
		waiting_time_less_than_minute_text: "méně než 1 min",
		waiting_time_minutes_text: "{{minutes}} min",
		waiting_time_hour_text: "{{hours}} hod",
		waiting_time_more_than_hours_text: "více než {{hours}} hod",
		few_days: "1–2 dny",
		landing_page_heading: "Pomoc s ${category}",
		landing_page_subheading: "Spojte se s HR {{availableChannels}}.",
		subheading_chat_text: "pomocí živého chatu",
		subheading_call_text: "telefonicky",
		subheading_case_text: "vytvořením požadavku",
		or_connector: "nebo",
		create_case_description: "Pokud nepotřebujete okamžitou pomoc, vytvořte požadavek.",
		next_hours_of_operation: "Další podpora je k dispozici od: {{day}}, {{startTime}}–{{endTime}}",
		next_hours_of_operation_with_days: "Další podpora je k dispozici od: {{startDay}} {{startTime}}–{{endDay}} {{endTime}}",
		time_in_am: "{{time}} dop.",
		time_in_pm: "{{time}} odp.",
		download_transcript_error: "Nepodařilo se stáhnout přepis. Zkuste to znovu.",
		download_attachment_error: "Přílohu se nepodařilo stáhnout. Zkuste to znovu.",
		sent_message_error: "Zprávu nelze odeslat z důvodu přerušení sítě. Zkontrolujte síť a zkuste to znovu.",
		get_contact_channels_failure: "Nepodařilo se získat dostupné kanály. Zkuste to znovu.",
		select_a_file: "Vyberte soubor",
		external_disable_message: "Přístupné v síti Amazon",
		required_field: "Povinné pole",
		end_chat_modal_text: "Tím ukončíte živý chat s oddělením HR.",
		end_chat_modal_title: "Ukončit chat?",
		download_transcript: "Stáhnout přepis",
		new_live_chat_session: "Nová relace živého chatu",
		live_chat_with_HR: "Živý chat s HR",
		chat_header_title: "Vítejte v živém chatu s HR",
		chat_header_subtitle_key: "Vybrané téma",
		chat_session_started: "Chat byl zahájen",
		chat_session_ended: "Relace chatu skončila",
		chat_wait_system_message: "Počkejte na spojení s agentem živého chatu.",
		chat_waitTime_system_message: "Odhadovaná čekací doba je",
		chat_info_system_message: "Relace chatu zůstane připojena, i když toto okno opustíte.",
		chat_agent_typing_message: "Agent podpory píše",
		livechat_warning_banner: "Relace živého chatu s oddělením HR se odpojí během {{minutes}} min.",
		no_available_channel: "Momentálně nejsou k dispozici žádné kanály. V tuto chvíli použijte možnost Něco jiného.",
		chat_input_footer_label: "Vaše zpráva",
		business_days: "{{days}} pracovních dnů",
		business_day: "{{day}} pracovní den",
		file_size_limit: "Velikost souboru by měla být menší než 20 MB.",
		generic_error_message: "Něco se pokazilo. Zkuste to znovu.",
		one_field_reqd_error: "Pro odeslání formuláře průzkumu je nutné vyplnit alespoň 1 pole.",
		send_survey: "Odeslat průzkum",
		upload_error_access_denied: "Přístupové oprávnění bylo odepřeno.",
		upload_error_internal_server_exception: "U vašeho požadavku došlo k problému se službou, zkuste to znovu.",
		upload_error_service_quota_exceeded: "Bylo dosaženo maximálního limitu 5 příloh.",
		upload_error_throttling: "U vašeho požadavku došlo k problému se službou, zkuste to znovu.",
		upload_error_validation: "Typ souboru přílohy není podporován.",
		upload_error_generic: "Nelze nahrát přílohu",
		not_allowed_destination: "Odchozí hovory na cílové číslo nejsou povoleny",
		call_not_allowed: "Hovor na tomto čísle nelze přijmout",
		check_country_code: "Ujistěte se, že jste na začátek čísla přidali kód země.",
		try_different_number: "Zkuste jiné číslo.",
		Sunday: "Neděle",
		Monday: "Pondělí",
		Tuesday: "Úterý",
		Wednesday: "Středa",
		Thursday: "Čtvrtek",
		Friday: "Pátek",
		Saturday: "Sobota",
		recommended_words_error_text: "Počet zadaných slov: {{wordCount}}. Povolen je až následující počet slov: {{wordLimit}}",
		recommended_words_text: "Počet zadaných slov: {{wordCount}}zadaná slova. Požadovaný počet slov: {{wordLimit}} nebo méně",
		stay_connected: "Zůstaňte připojeni",
		chat_open_error_modal_text: "Již máte otevřený chat –⁠ zavřete jej a začněte nový chat.",
		chat_open_error_modal_title: "Chat je již otevřený",
		previous_chat_history: "Předchozí historie chatu",
		choose_chat_history: "Vyberte historii chatu",
		no_chat_records_available: "Nebyly nalezeny žádné předchozí záznamy chatu. Pokračujte na živý chat a začněte chatovat s agentem",
		empty_chat_present: "V této relaci chatu neprobíhá žádná konverzace",
		language_support_text: "Momentálně pracujeme na zlepšení služeb. Prozatím máte přístup k samoobslužnému portálu Služeb pro invaliditu a zdravotní volno (v angličtině).",
		english_language_only_text: "Pouze v angličtině",
		invalid_message_contraint_error: "Limit znaků byl překročen. Povoleno je maximálně 1024 znaků",
		loading_error: "Při načítání této obrazovky došlo k chybě. Zkuste to znovu za pár minut.",
		loading_error_text: "Chyba načítání.",
		maximize_chat_history: "Maximalizace historie chatu",
		minimize_chat_history: "Minimalizovat historii chatu",
		need_more_help: "Potřebujete další pomoc?",
		erc_number_message: "Pro okamžitou podporu se můžete spojit s oddělením HR na:",
		get_started: "Začínáme",
		self_service_content_error: "Při načítání samoobslužného obsahu se vyskytl problém. Pro zahájení samoobslužného postupu použijte tlačítko „Začít“.",
		describe_issue_title: "Popište svůj problém a spojte se s agentem podpory",
		record_chat_session: "Relace chatu může být nahrávána pro účely zlepšení kvality nebo školení.",
		idleness_disconnect_message: "Pokud jste neaktivní nebo neodpovídáte déle než {{minutes}} minut, chat bude odpojen.",
		userinput_box_hint_text: "S čím potřebujete pomoci?",
		get_help: "Získat pomoc",
		connect_with_hr_by_chat_phone_request: "Spojte se s oddělením HR prostřednictvím chatu, telefonu nebo vytvořením žádosti.",
		myhr_contact_us: "My HR | Kontaktujte nás",
		not_able_to_get_live_help: "Momentálně nejsou k dispozici možnosti podpory živé nápovědy. Další nápovědu naleznete na portálu myHR",
		chat_transcript_opt_in_modal_content: "Vaše zaměstnávající entita, společnost Amazon, by chtěla tento chat uchovávat pro účely kvality, školení a vedení záznamů. Pokud souhlasíte, klikněte na tlačítko Souhlas. Pokud chcete požadavek odmítnout, klikněte na tlačítko Odmítnout. Další informace o tom, jak nakládáme s vašimi osobními údaji, včetně vašeho práva odvolat souhlas, naleznete v Oznámení společnosti Amazon o ochraně osobních údajů zaměstnanců na webu Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Přihlásit se k odběru přepisu chatu?",
		chat_transcript_opt_in_consent: "Souhlas",
		chat_transcript_opt_in_decline: "Odmítnout",
		connect_to_provider: "Připojit se k poskytovateli třetí strany?",
		your_information: "Informace o vás",
		all_feilds_are_required: "Všechna pole jsou povinná.",
		name: "Jméno",
		email: "E-mail",
		phoneNumber: "Telefonní číslo",
		"continue": "Pokračovat",
		please_provide_valid: "Zadejte platnou hodnotu",
		to_start_live_chat_click_continue: "Pokud chcete zahájit živý chat s klinickým lékařem zaměřeným na duševní zdraví, zadejte své údaje a klepněte na tlačítko Pokračovat.",
		you_are_connected_with_a_third_party: "Jste spojeni s poskytovatelem pomoci zaměstnancům (EAP) třetí strany.",
		to_save_transcript_download: "Pokud chcete tento přepis uložit, stáhněte si přepis před ukončením relace.",
		fix_the_errors: "Opravte chyby: Neodpověděli jste na požadované otázky ([X]).",
		all_clinicians_busy: "Omlouváme se, ale zdá se, že všichni lékaři jsou zaneprázdněni jinými zaměstnanci. Klepnutím na možnost Nová relace živého chatu se znovu zařadíte do fronty.",
		username: "Jméno",
		connect_to_a_provider_outside_amazon: "Připojit se k poskytovateli mimo Amazon?",
		you_are_now_connected_to_confidential: "Připojujete se k důvěrnému externímu poskytovateli mimo společnost Amazon, který k registraci a ověření vyžaduje vaše jméno, telefonní číslo a údaje o poloze. Tato služba je bezplatná a důvěrná.",
		no_agents: "Agenti HR nejsou v tuto chvíli k dispozici, zkuste jiný kanál",
		high_wait_time: "Všichni naši agenti HR jsou v tuto chvíli zaneprázdněni. Mezitím zkuste jiné kanály",
		by_tapping_continue_agree_wpo_terms: "Klepnutím na tlačítko Pokračovat souhlasíte s tím, že jste si přečetli a souhlasíte s podmínkami služby Workplace Options",
		terms_and_conditions: "Podmínky a ujednání",
		end_chat_modal_text_wpo: "Tím ukončíte živý chat.",
		live_support_options: "Možnosti živé podpory",
		open: "Otevřené",
		myhr: "My HR"
	}
};
var csCZ = {
	atoz_myhr_app: atoz_myhr_app$1
};

var atoz_myhr_app$2 = {
	livehelp: {
		help_eligibility_title: "Wenn du Hilfe bei der Antragsberechtigung benötigst, kannst du dich jetzt mit der Personalabteilung in Verbindung setzen oder eine Anfrage erstellen.",
		chat_title: "Chat",
		call_title: "Anrufen",
		create_request: "Eine Anfrage erstellen",
		wait_time: "Wartezeit",
		response_time: "Reaktionszeit",
		waiting_time_minute_text: "{{minutes}} Minute",
		waiting_time_hours_text: "{{hours}} Stunden",
		hr_help_and_support: "HR kontaktieren und Anfragen verwalten",
		call_error_processing: "Bei der Bearbeitung der Anfrage ist ein Fehler aufgetreten. Bitte versuche es noch einmal von Anfang an.",
		help_needed_with: "Wobei brauchst du Hilfe?",
		immigration_title: "Einwanderung",
		disability_and_leave_title: "Behinderung & Urlaub",
		other: "Sonstiges",
		submit: "Absenden",
		cancel: "Abbrechen",
		enter_number_title: "Gib deine Nummer ein, um einen Anruf von der Personalabteilung zu erhalten.",
		request_call: "Einen Anruf anfordern",
		amazon_support_contact_shortly: "Du erhältst in Kürze einen Anruf vom Amazon Employee Support Team.",
		confirm_preferred_phone_number: "Zum Anfordern eines Anrufs deine bevorzugte Telefonnummer und Sprache bestätigen",
		what_preferred_phone_no: "Was ist deine bevorzugte Telefonnummer?",
		preferred_language_text: "Was ist deine bevorzugte Sprache?",
		what_to_expect: "Was du erwarten kannst",
		call_from_agent_minutes: "Ein Agent wird dich innerhalb von ${minutes} Minuten anrufen",
		call_from_amazon_number: "Der Anruf wird entweder als ${contactNumber} oder anonyme Nummer angezeigt",
		disconnected_agent_call_minute: "Wenn die Verbindung getrennt wird, ruft der Agent dich innerhalb von 1 Minute zurück",
		live_help_text_timekeeping_leaves_of_absence: "Für Hilfe bei der Zeitmessung und Freistellung kannst du anrufen, chatten oder eine Anfrage erstellen",
		get_call_back: "Rückruf anfordern",
		request_phone_call: "Einen Telefonanruf anfordern",
		close_chat_window: "Möchtest du das Live-Chat-Fenster schließen?",
		chat_ended: "Der Chat wurde beendet.",
		idle_chat_disconnect: "Aufgrund von Inaktivität getrennt",
		disconnect_from_chat: "Der Benutzer hat den Chat verlassen. Das Chat-Gespräch wurde beendet.",
		chat_idle_message: "Der Chat wurde unterbrochen, weil er für {{minutes}} Minuten inaktiv war.",
		chat_extended_after_idleness: "Benutzer hat die Sitzung nach Inaktivitätswarnung verlängert.",
		surety_chat_idle_message: "Hallo, ich möchte nur sichergehen, dass unser Chat noch verbunden ist. Wir sind seit ${minutes} Minuten im untätig. Unser Chat wird geschlossen, wenn du nicht innerhalb von 2 Minuten antworten kannst.",
		disconnect_chat_message: "Möchtest du die Verbindung zum Chat wirklich trennen?",
		supported_file_attachments: "Für Chat-Anhänge unterstützte Dateitypen: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Die maximale Dateigröße für einen Chat-Anhang beträgt 20 MB.",
		upload_attachment: "Anlage hochladen",
		choose_file_upload: "Die Datei zum Hochladen auswählen",
		stay_Connected: "Bleibe in Verbindung",
		disconnect: "Trennen",
		message_input_placeholder: "Eine Nachricht eingeben und die Eingabetaste drücken, um zu senden",
		upload: "Hochladen",
		end_chat: "Chat beenden",
		connect: "Verbinden",
		save_chat: "Chat speichern",
		connected: "Verbunden",
		user_left_chat: "{{user}} hat den Chat verlassen. Dein Chat-Gespräch wurde beendet.",
		user_left_chat_during_transfer: "{{user}} hat den Chat verlassen. Du wirst übertragen.",
		user_joined_chat: "${user} ist dem Chat beigetreten",
		input_phone_number: "Deine Telefonnummer eingeben",
		time: "Zeit",
		call_from_anonymous_number: "Der Anruf wird entweder als ${contactNumber} oder anonyme Nummer angezeigt",
		extended_user_session_warning: "Benutzer hat die Sitzung nach Untätigkeitswarnung verlängert",
		close: "Schließen",
		okay: "Okay",
		send: "Senden",
		timer_message: "Nach {{counter}} Sekunden erneut Anruf anfordern",
		start_new_chat: "Einen neuen Chat starten",
		open_menu: "Menü öffnen",
		live_chat: "Live-Chat",
		end_chat_session: "Chat-Sitzung beenden",
		create_request_3steps: "Du kannst eine Anfrage in 3 Schritten erstellen",
		available_now: "Jetzt verfügbar",
		phone: "Telefon",
		minute: "Minute",
		chat_with_HR: "Live-Chat",
		chat_with_HR_desc: "Mit der Personalabteilung chatten, damit deine Anfrage sofort beantwortet wird",
		call_HR: "Anrufen",
		call_hr_desc: "Bei kritischen/dringenden Fragen die Personalabteilung anrufen",
		doc_note_due_date_ready: "Ein ärztliches Attest mit deinem Termin zum Hochladen bereithalten",
		system: "SYSTEM",
		connected_with_agent: "Du bist jetzt mit einem Live-Hilfe-Agenten verbunden",
		transferring_to_agent: "Du wirst zu einem Live-Hilfe-Agenten weitergeleitet",
		days: "Tage",
		request_a_call: "Einen Anruf anfordern",
		request_phone_call_heading: "Für Kontakt mit der Personalabteilung ist deine bevorzugte Telefonnummer und Sprache erforderlich.",
		request_phone_call_heading_2: "Für die telefonisch Verbindung mit der Personalabteilung ist deine bevorzugte Telefonnummer erforderlich.",
		what_your_preffered_number: "Was ist deine bevorzugte Telefonnummer (einschließlich Landesvorwahl)?",
		what_your_preffered_language: "Was ist deine bevorzugte Sprache?",
		phone_number_cannot_be_empty: "Telefonnummer darf nicht leer sein",
		only_numbers_allowed: "Hier sind nur Zahlen erlaubt",
		receive_call_number: "Du erhältst sofort einen Anruf von {{contactNumber}}.",
		receive_call_HR_team: "Du erhältst sofort einen Anruf vom HR-Supportteam.",
		agent_hold_with_wait_time: "Du wirst in die Warteschleife gesetzt und der Mitarbeiter wird sich innerhalb von ${waitTime} Minuten bei dir melden.",
		agent_hold_without_wait_time: "Du befindest dich in der Warteschleife und der Mitarbeiter wird sich mit dir in Verbindung setzen.",
		disconnected_agent_wait: "Wenn die Verbindung getrennt wird, ruft der Agent dich innerhalb von 1 Minute zurück.",
		call_hr_desc2: "Gib deine Telefonnummer an und ein HR-Support-Spezialist der Personalabteilung wird dich direkt anrufen.",
		create_hr_request: "Anfrage",
		chat_with_an_hr_specialist: "Mit einem Spezialisten der Personalabteilung chatten",
		talk_to_an_hr_specialist: "Mit einem Spezialisten der Personalabteilung sprechen",
		create_an_hr_case: "Einen Fall für die Personalabteilung erstellen",
		minutes: "Minuten",
		waiting_time_less_than_minute_text: "weniger als 1 Minute",
		waiting_time_minutes_text: "{{minutes}} Minuten",
		waiting_time_hour_text: "{{hours}} Stunde",
		waiting_time_more_than_hours_text: "mehr als {{hours}} Stunden",
		few_days: "1–2 Tage",
		landing_page_heading: "Hilfe bei ${category}",
		landing_page_subheading: "Setze dich mit HR {{availableChannels}} in Verbindung.",
		subheading_chat_text: "per Live-Chat",
		subheading_call_text: "per Telefon",
		subheading_case_text: "durch Erstellen einer Anfrage",
		or_connector: "oder",
		create_case_description: "Wenn du keine sofortige Hilfe benötigst, erstelle eine Anfrage.",
		next_hours_of_operation: "Der nächste Support ist ab {{day}} {{startTime}} bis {{endTime}} verfügbar",
		next_hours_of_operation_with_days: "Nächster Support verfügbar von {{startDay}} {{startTime}} bis {{endDay}} {{endTime}}.",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Transkript konnte nicht heruntergeladen werden. Versuche es bitte noch einmal.",
		download_attachment_error: "Anlage konnte nicht heruntergeladen werden. Versuche es bitte noch einmal.",
		sent_message_error: "Nachricht konnte aufgrund einer Netzwerkunterbrechung nicht gesendet werden. Bitte überprüfe das Netzwerk und versuche es erneut.",
		get_contact_channels_failure: "Verfügbare Kanäle konnten nicht abgerufen werden. Versuche es bitte noch einmal.",
		select_a_file: "Wähle eine Datei aus",
		external_disable_message: "Innerhalb des Amazon-Netzwerks zugänglich",
		required_field: "Erforderliches Feld",
		end_chat_modal_text: "Dadurch wird deine Live-Chat-Sitzung mit HR beendet.",
		end_chat_modal_title: "Chat beenden?",
		download_transcript: "Transkript herunterladen",
		new_live_chat_session: "Neue Live-Chat-Sitzung",
		live_chat_with_HR: "Live-Chat mit HR",
		chat_header_title: "Willkommen beim Live-Chat mit HR",
		chat_header_subtitle_key: "Thema ausgewählt",
		chat_session_started: "Chat-Sitzung wurde gestartet",
		chat_session_ended: "Chat-Sitzung wurde beendet",
		chat_wait_system_message: "Bitte warte, während wir dich mit einem Live-Chat-Mitarbeiter verbinden.",
		chat_waitTime_system_message: "Die geschätzte Wartezeit beträgt",
		chat_info_system_message: "Deine Chat-Sitzung bleibt auch dann verbunden, wenn du dieses Fenster verlässt.",
		chat_agent_typing_message: "Der Support-Mitarbeiter schreibt gerade",
		livechat_warning_banner: "Dein Live-Chat mit der HR-Sitzung wird in {{minutes}} Minuten unterbrochen",
		no_available_channel: "Derzeit sind keine Kanäle verfügbar. Bitte verwende zu diesem Zeitpunkt die Option „Sonstiges“.",
		chat_input_footer_label: "Deine Nachricht",
		business_days: "{{days}} Werktage",
		business_day: "{{day}} Werktag",
		file_size_limit: "Die Dateigröße muss weniger als 20 MB betragen.",
		generic_error_message: "Ein Fehler ist aufgetreten. Versuche es bitte noch einmal.",
		one_field_reqd_error: "Zum Absenden des Umfrageformulars ist mindestens ein Feld erforderlich.",
		send_survey: "Umfrage versenden",
		upload_error_access_denied: "Zugriffsberechtigung verweigert.",
		upload_error_internal_server_exception: "Bei der Anfrage ist ein Serviceproblem aufgetreten. Bitte versuche es erneut.",
		upload_error_service_quota_exceeded: "Die maximale Grenze von fünf Anhängen wurde erreicht.",
		upload_error_throttling: "Bei der Anfrage ist ein Serviceproblem aufgetreten. Bitte versuche es erneut.",
		upload_error_validation: "Der Dateityp des Anhangs wird nicht unterstützt.",
		upload_error_generic: "Anhang kann nicht hochgeladen werden",
		not_allowed_destination: "Ausgehende Anrufe an die Zielnummer sind nicht zulässig",
		call_not_allowed: "Unter dieser Nummer kann kein Anruf entgegengenommen werden",
		check_country_code: "Achte darauf, am Anfang der Nummer die Landesvorwahl hinzuzufügen.",
		try_different_number: "Versuche es mit einer anderen Nummer.",
		Sunday: "Sonntag",
		Monday: "Montag",
		Tuesday: "Dienstag",
		Wednesday: "Mittwoch",
		Thursday: "Donnerstag",
		Friday: "Freitag",
		Saturday: "Samstag",
		recommended_words_error_text: "{{wordCount}} eingegebene Wörter. Bis zu {{wordLimit}} Wörter sind erlaubt",
		recommended_words_text: "{{wordCount}} eingegebene Wörter. {{wordLimit}} oder weniger sind erforderlich",
		stay_connected: "Bleibe in Verbindung",
		chat_open_error_modal_text: "Du hast bereits einen Chat geöffnet. Bitte schließe diesen, um einen neuen Chat zu starten.",
		chat_open_error_modal_title: "Chat ist bereits geöffnet",
		previous_chat_history: "Bisheriger Chat-Verlauf",
		choose_chat_history: "Chat-Verlauf wählen",
		no_chat_records_available: "Keine vorherigen Chat-Aufzeichnungen gefunden. Mit LiveChat fortfahren, um mit dem Mitarbeiter zu chatten",
		empty_chat_present: "Kein Gespräch in dieser Chat-Sitzung",
		language_support_text: "Wir arbeiten derzeit daran, dein Erlebnis zu verbessern. Derzeit kannst du auf Englisch auf das Selbstbedienungsportal für Invaliditäts- und Beurlaubungsdienstleistungen zugreifen.",
		english_language_only_text: "Nur Englisch",
		invalid_message_contraint_error: "Zeichenbeschränkung überschritten. Maximal 1024 Zeichen sind zulässig",
		loading_error: "Beim Laden dieses Bildschirms ist ein Fehler aufgetreten. Versuche es in ein paar Minuten noch einmal.",
		loading_error_text: "Fehler beim Laden.",
		maximize_chat_history: "Chat-Verlauf maximieren",
		minimize_chat_history: "Chat-Verlauf minimieren",
		need_more_help: "Benötigst du weitere Hilfe?",
		erc_number_message: "Wenn du sofortige Unterstützung benötigst, wende dich an HR unter:",
		get_started: "Starten",
		self_service_content_error: "Beim Laden von Self-Service-Inhalten ist ein Problem aufgetreten. Bitte starte den Self-Service-Workflow über die Schaltfläche \"Starten\".",
		describe_issue_title: "Beschreibe dein Problem, um mit einem Support-Mitarbeiter verbunden zu werden.",
		record_chat_session: "Deine Chat-Sitzung wird möglicherweise zu Qualitätssicherungs- und Schulungszwecken aufgezeichnet.",
		idleness_disconnect_message: "Der Chat wird unterbrochen, wenn du inaktiv bist oder länger als {{minutes}} Minuten nicht antwortest.",
		userinput_box_hint_text: "Wobei brauchst du Hilfe?",
		get_help: "Hilfe erhalten",
		connect_with_hr_by_chat_phone_request: "Nimm per Live-Chat, telefonisch oder durch Erstellen einer Anfrage Kontakt mit HR auf.",
		myhr_contact_us: "My HR | Kontakt",
		not_able_to_get_live_help: "Wir können dir derzeit keine Optionen zur Live-Hilfe bereitstellen. Bitte besuche MyHR, um zusätzliche Unterstützung zu erhalten.",
		chat_transcript_opt_in_modal_content: "Die Amazon-Einheit, bei der du beschäftigt bist, möchte diesen Chat zu Qualitätssicherungs- und Schulungszwecken sowie zur Dokumentation speichern. Klicke auf \"Erlauben\", um einzuwilligen. Klicke auf \"Verweigern\", um dies abzulehnen. Weitere Informationen über die Verarbeitung deiner persönlichen Daten, auch zu deinem Recht auf Widerruf der Einwilligung, findest du in der Amazon EU Datenschutzerklärung für Mitarbeiter auf Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Für das Chat-Protokoll anmelden?",
		chat_transcript_opt_in_consent: "Erlauben",
		chat_transcript_opt_in_decline: "Verweigern",
		connect_to_provider: "Mit einem externen Dienstleister verbinden?",
		your_information: "Deine Informationen",
		all_feilds_are_required: "Alle Felder sind Pflichtfelder.",
		name: "Name",
		email: "E-Mail",
		phoneNumber: "Telefonnummer ein.",
		"continue": "Fortfahren",
		please_provide_valid: "Bitte gib eine gültige",
		to_start_live_chat_click_continue: "Gib deine Daten ein und tippe auf \"Fortfahren\", um deine Live-Chat-Sitzung mit einer medizinischen Fachkraft für mentale Gesundheit zu starten.",
		you_are_connected_with_a_third_party: "Du bist mit einem externen Employee Assistance Provider (EAP) verbunden.",
		to_save_transcript_download: "Wenn du dieses Protokoll speichern möchtest, lade es herunter, bevor du diese Sitzung schließt.",
		fix_the_errors: "Behebe die Fehler: Du hast [X] Pflichtfragen nicht beantwortet.",
		all_clinicians_busy: "Leider scheinen alle medizinischen Fachkräfte mit anderen Mitarbeitern im Gespräch zu sein. Tippe auf \"Neue Live-Chat-Sitzung\", um erneut in die Warteschlange aufgenommen zu werden.",
		username: "Name",
		open: "Offen",
		myhr: "Meine Personalabteilung",
		connect_to_a_provider_outside_amazon: "Mit einem Dienstleister außerhalb von Amazon verbinden?",
		you_are_now_connected_to_confidential: "Du stellst jetzt eine Verbindung zu einem vertraulichen, externen Dienstleister außerhalb von Amazon her, der deinen Namen, deine Telefonnummer und deine Standortdaten benötigt, um dich zu registrieren und zu authentifizieren. Dieser Service ist kostenlos und vertraulich.",
		no_agents: "Die HR-Mitarbeiter sind derzeit nicht verfügbar, bitte versuche es mit einem anderen Kanal",
		high_wait_time: "Alle unsere HR-Mitarbeiter sind derzeit beschäftigt. Bitte versuche es in der Zwischenzeit mit anderen Kanälen",
		by_tapping_continue_agree_wpo_terms: "Durch Klicken auf „Weiter“ bestätigst du, dass du die Arbeitsplatz-Optionen gelesen hast und mit dem Service einverstanden bist.",
		terms_and_conditions: "Nutzungsbedingungen",
		end_chat_modal_text_wpo: "Dadurch wird dein Live-Chat beendet.",
		live_support_options: "Optionen für den Live-Support"
	}
};
var deDE = {
	atoz_myhr_app: atoz_myhr_app$2
};

var atoz_myhr_app$3 = {
	livehelp: {
		help_eligibility_title: "For help with application eligibility, you can connect with HR now or create a request.",
		chat_title: "Chat",
		call_title: "Call",
		create_request: "Create a request",
		wait_time: "Wait time",
		response_time: "Response time",
		waiting_time_minute_text: "{{minutes}} minute",
		waiting_time_hours_text: "{{hours}} hours",
		hr_help_and_support: "Contact HR and Manage Requests",
		call_error_processing: "There was an error processing your request, kindly try again from the start.",
		help_needed_with: "What do you need help with?",
		immigration_title: "Immigration",
		disability_and_leave_title: "Disability & Leave",
		other: "Other",
		submit: "Submit",
		cancel: "Cancel",
		enter_number_title: "Enter your number to receive a call from HR.",
		request_call: "Request a call",
		amazon_support_contact_shortly: "You will receive a call from Amazon Employee support team shortly.",
		confirm_preferred_phone_number: "To request a call, confirm your preferred phone number and language",
		what_preferred_phone_no: "What’s your preferred phone number?",
		preferred_language_text: "What’s your preferred language?",
		what_to_expect: "What to expect",
		call_from_agent_minutes: "An agent will call you within ${minutes} minutes",
		call_from_amazon_number: "The call will show up as either an ${contactNumber} or anonymous number",
		disconnected_agent_call_minute: "If you get disconnected, the agent will call you back within 1 minute",
		live_help_text_timekeeping_leaves_of_absence: "For help with timekeeping and leaves of absence, you can call, chat, or create a request",
		get_call_back: "Get a call back",
		request_phone_call: "Request a phone call",
		close_chat_window: "Do you wish to close the Live Chat window?",
		chat_ended: "Chat has ended.",
		idle_chat_disconnect: "Disconnected due to Inactivity",
		disconnect_from_chat: "User left the chat. Chat conversation has ended.",
		chat_idle_message: "The chat has been disconnected due to being idle for {{minutes}} minutes.",
		chat_extended_after_idleness: "User has extended their session after idleness warning.",
		surety_chat_idle_message: "Hi, I just want to make sure our chat is still connected. We've been idle for ${minutes} minutes. Our chat will close, if you aren't able to respond in 2 minutes.",
		disconnect_chat_message: "Are you sure you want to disconnect from the chat?",
		supported_file_attachments: "File types supported for chat attachments: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Max file size for a chat attachment is 20MB.",
		upload_attachment: "Upload attachment",
		choose_file_upload: "Choose file to upload",
		stay_Connected: "Stay Connected",
		disconnect: "Disconnect",
		message_input_placeholder: "Type a message and press enter to send",
		upload: "Upload",
		end_chat: "End Chat",
		connect: "Connect",
		save_chat: "Save Chat",
		connected: "Connected",
		user_left_chat: "{{user}} left the chat. Your chat conversation has ended.",
		user_left_chat_during_transfer: "{{user}} left the chat. You are getting transferred.",
		user_joined_chat: "${user} joined the chat",
		input_phone_number: "Enter your phone number",
		time: "Time",
		call_from_anonymous_number: "The call will show up as either an ${contactNumber} or anonymous number",
		extended_user_session_warning: "User has extended their session after idleness warning",
		close: "Close",
		okay: "Okay",
		send: "Send",
		timer_message: "Request call again after {{counter}} seconds",
		start_new_chat: "Start a new Chat",
		open_menu: "Open menu",
		live_chat: "Live chat",
		end_chat_session: "End Chat Session",
		create_request_3steps: "You can create a request in 3 steps",
		available_now: "Available now",
		phone: "phone",
		minute: "minute",
		chat_with_HR: "Live chat",
		chat_with_HR_desc: "Chat with an HR to get your query addressed instantly",
		call_HR: "Call",
		call_hr_desc: "Call an HR for critical/urgent queries",
		doc_note_due_date_ready: "Have a doctor’s note with your due date ready to upload",
		system: "SYSTEM",
		connected_with_agent: "You're now connected with a live help agent",
		transferring_to_agent: "Transferring you to a live help agent",
		days: "days",
		request_a_call: "Request a call",
		request_phone_call_heading: "To connect with HR by phone, we need your preferred phone number and language.",
		request_phone_call_heading_2: "To connect with HR by phone, we need your preferred phone number.",
		what_your_preffered_number: "What is your preferred phone number (including country code)?",
		what_your_preffered_language: "What is your preferred language?",
		phone_number_cannot_be_empty: "Phone number cannot be empty",
		only_numbers_allowed: "Only numbers are allowed here",
		receive_call_number: "You'll instantly receive a call from {{contactNumber}}.",
		receive_call_HR_team: "You'll instantly receive a call from the HR support team.",
		agent_hold_with_wait_time: "You'll be put on hold and agent will connect with you within ${waitTime} minutes.",
		agent_hold_without_wait_time: "You’ll be put on hold and agent will connect with you.",
		disconnected_agent_wait: "If you get disconnected, the agent will call you back within 1 minute.",
		call_hr_desc2: "Provide your phone number and an HR Support specialist will call you directly.",
		create_hr_request: "Request",
		chat_with_an_hr_specialist: "Chat with an HR Specialist",
		talk_to_an_hr_specialist: "Talk to an HR Specialist",
		create_an_hr_case: "Create an HR Case",
		minutes: "minutes",
		waiting_time_less_than_minute_text: "less than 1 minute",
		waiting_time_minutes_text: "{{minutes}} minutes",
		waiting_time_hour_text: "{{hours}} hour",
		waiting_time_more_than_hours_text: "more than {{hours}} hours",
		few_days: "1-2 days",
		landing_page_heading: "Help with ${category}",
		landing_page_subheading: "Connect with HR {{availableChannels}}.",
		subheading_chat_text: "by live chat",
		subheading_call_text: "by phone",
		subheading_case_text: "by creating a request",
		or_connector: "or",
		create_case_description: "If you don't need immediate help, create a request.",
		next_hours_of_operation: "Next support available from {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Next support available from {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Failed to download transcript. Please try again.",
		download_attachment_error: "Failed to download attachment. Please try again.",
		sent_message_error: "Unable to send message due to network interruption. Please check your network and try again.",
		get_contact_channels_failure: "Failed to get available channels. Please try again.",
		select_a_file: "Select a file",
		external_disable_message: "Accessible inside the Amazon network",
		required_field: "Required field",
		end_chat_modal_text: "This will end your live chat with HR session.",
		end_chat_modal_title: "End chat?",
		download_transcript: "Download transcript",
		new_live_chat_session: "New live chat session",
		live_chat_with_HR: "Live chat with HR",
		chat_header_title: "Welcome to Live Chat with HR",
		chat_header_subtitle_key: "Topic Selected",
		chat_session_started: "Chat session started",
		chat_session_ended: "Chat session ended",
		chat_wait_system_message: "Please wait while we connect you to a live chat agent.",
		chat_waitTime_system_message: "Estimated wait time is",
		chat_info_system_message: "Your chat session will remain connected even if you leave this window.",
		chat_agent_typing_message: "Support Agent is typing",
		livechat_warning_banner: "Your live chat with HR session will disconnect in {{minutes}} minutes",
		no_available_channel: "No channels are available at the moment. Please use the Something Else option at this time.",
		chat_input_footer_label: "Your message",
		business_days: "{{days}} business days",
		business_day: "{{day}} business day",
		file_size_limit: "File size should be less than 20MB.",
		generic_error_message: "Something went wrong. Please try again.",
		one_field_reqd_error: "Atleast 1 field is required to submit the survey form.",
		send_survey: "Send survey",
		upload_error_access_denied: "Access permission denied.",
		upload_error_internal_server_exception: "There was a service issue with your request, please try again.",
		upload_error_service_quota_exceeded: "Max limit of 5 attachments has been reached.",
		upload_error_throttling: "There was a service issue with your request, please try again.",
		upload_error_validation: "The attachment file type is not supported.",
		upload_error_generic: "Unable to upload attachment",
		not_allowed_destination: "Outbound calls to the destination number are not allowed",
		call_not_allowed: "Call cannot be received on this number",
		check_country_code: "Make sure you have added country code at start of number.",
		try_different_number: "Try a different number.",
		Sunday: "Sunday",
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		recommended_words_error_text: "{{wordCount}} words entered. Upto {{wordLimit}} words are permitted",
		recommended_words_text: "{{wordCount}} words entered. {{wordLimit}} or fewer are required",
		stay_connected: "Stay Connected",
		chat_open_error_modal_text: "You already have a chat open, please close it to start a new chat.",
		chat_open_error_modal_title: "Chat already open",
		previous_chat_history: "Previous Chat History",
		choose_chat_history: "Choose Chat History",
		no_chat_records_available: "No previous chat records found. Proceed to LiveChat to chat with the agent",
		empty_chat_present: "No conversation in this chat session",
		language_support_text: "We are currently working to improve your experience. For now you can access the Disability and Leave Services self-service portal in English.",
		english_language_only_text: "English Language Only",
		invalid_message_contraint_error: "Character limit exceeded. Maximum of 1024 characters are allowed",
		loading_error: "An error has occurred while loading this screen. Please try again in a few minutes.",
		loading_error_text: "Loading Error.",
		maximize_chat_history: "Maximize chat history",
		minimize_chat_history: "Minimize chat history",
		need_more_help: "Need more help?",
		erc_number_message: "For immediate support, you can connect with HR at :",
		get_started: "Get started",
		self_service_content_error: "There was an issue while loading self service content. Please use 'Get started' button to initiate self service workflow.",
		describe_issue_title: "Describe your issue to get connected to a support agent",
		record_chat_session: "Your chat session may be recorded for quality or training purposes.",
		idleness_disconnect_message: "Your chat will be disconnected if you are idle or do not respond for more than {{minutes}} minutes.",
		userinput_box_hint_text: "What do you need help with?",
		get_help: "Get Help",
		connect_with_hr_by_chat_phone_request: "Connect with HR by live chat, phone, or by creating a request.",
		myhr_contact_us: "My HR | Contact Us",
		not_able_to_get_live_help: "We are not able to get the live help support options for you at this time. Please visit MyHR for additional help",
		chat_transcript_opt_in_modal_content: "Your employing Amazon entity would like to store this chat for quality and training purposes and record keeping. To consent, click Consent. To decline, click Decline. To receive further information on how we handle your personal data, including your right to withdraw consent, see the Employee Privacy Notice on Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Opt-in for chat transcript?",
		chat_transcript_opt_in_consent: "Consent",
		chat_transcript_opt_in_decline: "Decline",
		connect_to_provider: "Connect to third-party provider?",
		your_information: "Your information",
		all_feilds_are_required: "All fields are required.",
		name: "Name",
		email: "E-mail",
		phoneNumber: "Phone Number",
		"continue": "Continue",
		please_provide_valid: "Please provide valid",
		no_agents: "HR agents are not available currently, please try another channel",
		high_wait_time: "All of our HR agents are busy at the moment. Please try other channels in the meantime",
		to_start_live_chat_click_continue: "To start your live chat session with a mental health clinician, provide your information and tap Continue.",
		you_are_connected_with_a_third_party: "You are connected with a third-party Employee Assistance Provider (EAP).",
		to_save_transcript_download: "To save this transcript, download transcript before closing this session.",
		fix_the_errors: "Fix the errors: You didn't respond to [X] required questions.",
		all_clinicians_busy: "Sorry, but all clinicians seem to be busy with other employees. Tap New live chat session to re-enter the queue.",
		username: "Name",
		by_tapping_continue_agree_wpo_terms: "By tapping Continue, you agree you have read and agree with the Workplace Options service",
		terms_and_conditions: "Terms & Conditions",
		end_chat_modal_text_wpo: "This will end your live chat.",
		live_support_options: "Live support options",
		connect_to_a_provider_outside_amazon: "Connect to a provider outside of Amazon?",
		you_are_now_connected_to_confidential: "You are now connecting to a confidential, external provider outside of Amazon that requires your name, phone number, and location details to register and authenticate. This service is free and confidential.",
		disconnect_after_x_minutes_inactivity: "Are you still there? Your session will disconnect after {{minutes}} minutes of inactivity.",
		estimated_wait_time_x_minutes: "Estimated wait time is {{minutes}} minutes.",
		fab_footer_text: "Need help with different issue?",
		open: "Open",
		go_to: "Go to",
		please_wait_message: "Please Wait we are processing your request ....",
		phone_number_already_registered: "Phone number already Registered",
		please_close_active_chat_session: "You have an active chat session, please close it and wait for 5 minutes",
		phone_number_format_invalid: "Invalid Phone number.The numbers should start with a plus sign, followed by the country code and national number.Example for US +15417543010",
		wpo_400_response: "Either you are already registered or some issue with API",
		wpo_403_response: "You are unauthorized to create request",
		default_error_message: "Something went wrong, please retry after sometime",
		agent_joined_chat_session: "Agent has joined the chat",
		agent_left_chat_session: "Agent has left the chat"
	}
};
var enUS = {
	atoz_myhr_app: atoz_myhr_app$3
};

var atoz_myhr_app$4 = {
	livehelp: {
		help_eligibility_title: "Para obtener ayuda con la admisibilidad de la aplicación, puedes contactar con RR. HH. ahora o crear una solicitud.",
		chat_title: "Chat",
		call_title: "Llamar",
		create_request: "Crear una solicitud",
		wait_time: "Tiempo de espera",
		response_time: "Tiempo de respuesta",
		waiting_time_minute_text: "{{minutes}} minuto",
		waiting_time_hours_text: "{{hours}} horas",
		hr_help_and_support: "Contacta con RR. HH. y administra las solicitudes",
		call_error_processing: "Se ha producido un error al procesar la solicitud, inténtalo de nuevo desde el principio.",
		help_needed_with: "¿Con qué necesitas ayuda?",
		immigration_title: "Inmigración",
		disability_and_leave_title: "Discapacidad y licencia",
		other: "Otro",
		submit: "Enviar",
		cancel: "Cancelar",
		enter_number_title: "Introducir el número para recibir una llamada de RR. HH.",
		request_call: "Solicitar una llamada",
		amazon_support_contact_shortly: "Recibirás una llamada del equipo de apoyo al empleado/a de Amazon en breve.",
		confirm_preferred_phone_number: "Para solicitar una llamada, confirmar el idioma y el número de teléfono preferido",
		what_preferred_phone_no: "¿Cuál es tu número de teléfono favorito?",
		preferred_language_text: "¿Cuál es tu idioma preferido?",
		what_to_expect: "Qué esperar",
		call_from_agent_minutes: "Un agente te llamará dentro de ${minutes} minutos",
		call_from_amazon_number: "La llamada se mostrará como un ${contactNumber} o un número anónimo",
		disconnected_agent_call_minute: "Si te desconectas, el agente te devolverá la llamada en 1 minuto.",
		live_help_text_timekeeping_leaves_of_absence: "Para obtener ayuda con el timekeeping y los permisos de ausencia, puedes llamar, chatear o crear una solicitud.",
		get_call_back: "Recibir una llamada de respuesta",
		request_phone_call: "Solicita una llamada telefónica",
		close_chat_window: "¿Quieres cerrar la ventana de chat en vivo?",
		chat_ended: "El chat se ha detenido.",
		idle_chat_disconnect: "Desconexión por inactividad",
		disconnect_from_chat: "El usuario se fue del chat. La conversación de chat se ha detenido.",
		chat_idle_message: "El chat se ha desconectado porque ha estado inactivo durante {{minutes}} minutos.",
		chat_extended_after_idleness: "El usuario ha ampliado la sesión después de la advertencia de inactividad.",
		surety_chat_idle_message: "Hola, solo me quiero asegurar de que el chat está todavía conectado. Hemos estado inactivos durante ${minutes} minutos. El chat se cerrará, si no respondes en 2 minutos.",
		disconnect_chat_message: "¿Seguro que te quieres desconectar del chat?",
		supported_file_attachments: "Tipos de ficheros compatibles para los accesorios del chat: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  El tamaño de fichero máximo para un accesorio de chat es 20 MB.",
		upload_attachment: "Cargar accesorio",
		choose_file_upload: "Elegir fichero para cargar",
		stay_Connected: "Mantenerse conectado",
		disconnect: "Desconectar",
		message_input_placeholder: "Escribir un mensaje y pulsar Intro para enviar",
		upload: "Cargar",
		end_chat: "Detener chat",
		connect: "Contactar",
		save_chat: "Guardar chat",
		connected: "Conectado",
		user_left_chat: "{{user}} se fue del chat. La conversación de chat se ha detenido.",
		user_left_chat_during_transfer: "{{user}} se fue del chat. Te van a transferir.",
		user_joined_chat: "${user} se unió al chat",
		input_phone_number: "Introducir el número de teléfono",
		time: "Hora",
		call_from_anonymous_number: "La llamada se mostrará como un ${contactNumber} o un número anónimo",
		extended_user_session_warning: "El usuario ha ampliado la sesión después de la advertencia de inactividad",
		close: "Cerrar",
		okay: "Bien",
		send: "Enviar",
		timer_message: "Solicitar llamada de nuevo después de {{counter}} segundos",
		start_new_chat: "Empezar un chat nuevo",
		open_menu: "Abrir menú",
		live_chat: "Chat en vivo",
		end_chat_session: "Detener sesión de chat",
		create_request_3steps: "Puedes crear una solicitud en 3 pasos",
		available_now: "Disponible ahora",
		phone: "teléfono",
		minute: "minuto",
		chat_with_HR: "Chat en vivo",
		chat_with_HR_desc: "Chatear con RR. HH. para obtener respuesta a la pregunta de forma instantánea",
		call_HR: "Llamar",
		call_hr_desc: "Llamar a RR. HH. para preguntas fundamentales o urgentes",
		doc_note_due_date_ready: "Tener una nota del médico con la fecha de vencimiento lista para cargar",
		system: "SISTEMA",
		connected_with_agent: "Ahora estás conectado con un agente de ayuda en directo",
		transferring_to_agent: "Transferirte a un agente de ayuda en directo",
		days: "días",
		request_a_call: "Solicitar una llamada",
		request_phone_call_heading: "Para contactar con RR. HH. por teléfono, necesitamos tu número de teléfono e idioma favorito.",
		request_phone_call_heading_2: "Para contactar con RR. HH. por teléfono, necesitamos tu número de teléfono favorito.",
		what_your_preffered_number: "¿Cuál es tu número de teléfono preferido (incluido el código de país)?",
		what_your_preffered_language: "¿Cuál es tu idioma preferido?",
		phone_number_cannot_be_empty: "El número de teléfono no puede estar vacío",
		only_numbers_allowed: "Aquí, solo están permitidos los números",
		receive_call_number: "Recibirás al instante una llamada de {{contactNumber}}.",
		receive_call_HR_team: "Recibirás al instante una llamada del equipo de HR Support.",
		agent_hold_with_wait_time: "Quedarás en espera y el agente se pondrá en contacto contigo en ${waitTime} minutos.",
		agent_hold_without_wait_time: "Estarás en espera y un agente contactará contigo.",
		disconnected_agent_wait: "Si te desconectas, el agente te devolverá la llamada en 1 minuto.",
		call_hr_desc2: "Proporciona tu número de teléfono y un especialista de HR Support te llamará directamente.",
		create_hr_request: "Solicitar",
		chat_with_an_hr_specialist: "Chatear con un especialista de RR. HH.",
		talk_to_an_hr_specialist: "Hablar con un especialista de RR. HH.",
		create_an_hr_case: "Crear un HR Case",
		minutes: "minutos",
		waiting_time_less_than_minute_text: "menos de 1 minuto",
		waiting_time_minutes_text: "{{minutes}} minutos",
		waiting_time_hour_text: "{{hours}} hora",
		waiting_time_more_than_hours_text: "más de {{hours}} horas",
		few_days: "1-2 días",
		landing_page_heading: "Ayuda con ${category}",
		landing_page_subheading: "Contacta con {{availableChannels}} de RR. HH.",
		subheading_chat_text: "mediante chat en directo",
		subheading_call_text: "por teléfono",
		subheading_case_text: "mediante la creación de una solicitud",
		or_connector: "o",
		create_case_description: "Si no necesitas ayuda inmediata, crea una solicitud.",
		next_hours_of_operation: "Siguiente apoyo disponible desde {{day}} {{startTime}} hasta {{endTime}}",
		next_hours_of_operation_with_days: "Servicio de asistencia siguiente desde {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} a. m.",
		time_in_pm: "{{time}} p. m.",
		download_transcript_error: "No se ha podido descargar el expediente. Inténtalo de nuevo.",
		download_attachment_error: "No se ha podido descargar el accesorio. Inténtalo de nuevo.",
		sent_message_error: "No se puede enviar el mensaje debido a una interrupción de la red. Comprueba la red e inténtalo de nuevo.",
		get_contact_channels_failure: "No se pudieron conseguir los canales disponibles. Inténtalo de nuevo.",
		select_a_file: "Seleccionar un fichero",
		external_disable_message: "Accesible dentro de la red de Amazon",
		required_field: "Campo obligatorio",
		end_chat_modal_text: "Esto detendrá tu sesión de chat en directo con RR. HH.",
		end_chat_modal_title: "¿Detener chat?",
		download_transcript: "Descargar la transcripción",
		new_live_chat_session: "Nueva sesión de chat en directo",
		live_chat_with_HR: "Chat en directo con RR. HH.",
		chat_header_title: "Te damos la bienvenida al chat en directo con RR. HH.",
		chat_header_subtitle_key: "Tema seleccionado",
		chat_session_started: "Se ha iniciado la sesión de chat",
		chat_session_ended: "La sesión de chat se ha detenido",
		chat_wait_system_message: "Espera mientras te conectamos con un agente de chat en directo.",
		chat_waitTime_system_message: "El tiempo de espera estimado es",
		chat_info_system_message: "La sesión de chat permanecerá conectada aunque salgas de esta ventana.",
		chat_agent_typing_message: "El agente del servicio de asistencia está escribiendo",
		livechat_warning_banner: "La sesión de chat en directo con RR. HH. se desconectará en {{minutes}} minutos",
		no_available_channel: "No hay canales disponibles en este momento. Utiliza la opción Algo más en este momento.",
		chat_input_footer_label: "Tu mensaje",
		business_days: "{{days}} días laborables",
		business_day: "{{day}} día laborable",
		file_size_limit: "El tamaño del fichero debe ser inferior a 20 MB.",
		generic_error_message: "Algo salió mal. Inténtalo de nuevo.",
		one_field_reqd_error: "Se requiere al menos 1 campo para enviar el formulario de encuesta.",
		send_survey: "Enviar encuesta",
		upload_error_access_denied: "Se ha denegado el permiso de acceso.",
		upload_error_internal_server_exception: "Se ha producido un problema de servicio con la solicitud, inténtalo de nuevo.",
		upload_error_service_quota_exceeded: "Se ha alcanzado el límite máximo de 5 accesorios.",
		upload_error_throttling: "Se ha producido un problema de servicio con la solicitud, inténtalo de nuevo.",
		upload_error_validation: "No se admite el tipo de fichero de accesorio.",
		upload_error_generic: "No se puede cargar el accesorio",
		not_allowed_destination: "No se permiten llamadas salientes al número de destino",
		call_not_allowed: "No se pueden recibir llamadas en este número",
		check_country_code: "Asegúrate de haber añadido el código de país al principio del número.",
		try_different_number: "Prueba con un número diferente.",
		Sunday: "Domingo",
		Monday: "​Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		recommended_words_error_text: "{{wordCount}} palabras introducidas. Se permiten hasta {{wordLimit}} palabras.",
		recommended_words_text: "{{wordCount}} palabras introducidas. Se requieren {{wordLimit}} o menos.",
		stay_connected: "Mantenerse conectado",
		chat_open_error_modal_text: "Ya tienes un chat abierto, ciérralo para empezar un chat nuevo.",
		chat_open_error_modal_title: "El chat ya está abierto",
		previous_chat_history: "Historial de chat anterior",
		choose_chat_history: "Elegir el historial de chat",
		no_chat_records_available: "No se han encontrado registros de chat anteriores. Continuar con LiveChat para charlar con el agente",
		empty_chat_present: "No hay conversación en esta sesión de chat",
		language_support_text: "Actualmente estamos trabajando para mejorar tu experiencia. Por ahora, puedes acceder al portal de autoservicio de los Servicios de permisos e incapacidades en inglés.",
		english_language_only_text: "Solo en inglés",
		invalid_message_contraint_error: "Se ha superado el límite de caracteres. Se permite un máximo de 1024 caracteres",
		loading_error: "Se ha producido un error al cargar esta pantalla. Inténtalo de nuevo en unos minutos.",
		loading_error_text: "Error al cargar.",
		maximize_chat_history: "Maximizar el historial de chat",
		minimize_chat_history: "Minimizar el historial de chat",
		need_more_help: "¿Necesitas más ayuda?",
		erc_number_message: "Para obtener asistencia inmediata, puedes contactar con RR. HH. en:",
		get_started: "Empezar",
		self_service_content_error: "Se ha producido un problema al cargar el contenido de autoservicio. Utiliza el botón “Empezar” para iniciar el flujo de trabajo de autoservicio.",
		describe_issue_title: "Describir el problema para contactar con un agente del servicio de asistencia",
		record_chat_session: "La sesión de chat se puede grabar con fines de calidad o formación.",
		idleness_disconnect_message: "El chat se desconectará si estás inactivo o no respondes durante más de {{minutes}} minutos.",
		userinput_box_hint_text: "¿Con qué necesitas ayuda?",
		get_help: "Asistencia",
		connect_with_hr_by_chat_phone_request: "Conecta con RR. HH. por chat en directo, por teléfono o mediante la creación de una solicitud.",
		myhr_contact_us: "MyHR | Contáctanos",
		not_able_to_get_live_help: "En este momento, no podemos ofrecerte las opciones de asistencia en directo. Consulta MyHR para obtener ayuda adicional",
		chat_transcript_opt_in_modal_content: "La entidad empleadora de Amazon desea almacenar este chat con fines de calidad y de formación y para el mantenimiento de registros. Para dar tu consentimiento, haz clic en Consentir. Para rechazar, haz clic en Rechazar. Para recibir más información sobre cómo gestionamos los datos personales, incluido el derecho a retirar el consentimiento, consulta el Aviso de Privacidad para empleados de Amazon Global en Inside Amazon.",
		chat_transcript_opt_in_modal_title: "¿Deseas recibir la transcripción del chat?",
		chat_transcript_opt_in_consent: "Consentimiento",
		chat_transcript_opt_in_decline: "Rechazar",
		connect_to_provider: "¿Conectarse a un proveedor de terceros?",
		your_information: "Tu información",
		all_feilds_are_required: "Todos los campos son obligatorios.",
		name: "Nombre",
		email: "Correo electrónico",
		phoneNumber: "Número de teléfono",
		"continue": "Continuar",
		please_provide_valid: "Proporciona un valor válido para",
		to_start_live_chat_click_continue: "Para iniciar la sesión de chat en directo con un médico de salud mental, proporciona la información y pulsa Continuar.",
		you_are_connected_with_a_third_party: "Estás conectado con un proveedor de asistencia al empleado (EAP) externo.",
		to_save_transcript_download: "Para guardar esta transcripción, descárgala antes de cerrar esta sesión.",
		fix_the_errors: "Corrige los errores: No respondiste a [X] preguntas obligatorias.",
		all_clinicians_busy: "Lo siento, pero todos los médicos parecen estar ocupados con otros empleados. Pulsa Nueva sesión de chat en directo para volver a entrar en la cola.",
		username: "Nombre",
		connect_to_a_provider_outside_amazon: "¿Conectarse a un proveedor fuera a Amazon?",
		you_are_now_connected_to_confidential: "Ahora te estás conectando a un proveedor externo confidencial fuera de Amazon que requiere tu nombre, número de teléfono y detalles de ubicación para registrarte y autenticarte. Este servicio es gratuito y confidencial.",
		no_agents: "Los agentes de RR. HH. no están disponibles actualmente, prueba con otro canal",
		high_wait_time: "Todos nuestros agentes de RR. HH. están ocupados en este momento. Por favor, prueba con otros canales mientras tanto",
		by_tapping_continue_agree_wpo_terms: "Al pulsar Continuar, aceptas que has leído y estás de acuerdo con el servicio de opciones del lugar de trabajo.",
		terms_and_conditions: "Términos y condiciones",
		end_chat_modal_text_wpo: "Esto finalizará el chat en directo.",
		live_support_options: "Opciones de asistencia en directo",
		open: "Abierto",
		myhr: "My HR"
	}
};
var esES = {
	atoz_myhr_app: atoz_myhr_app$4
};

var atoz_myhr_app$5 = {
	livehelp: {
		help_eligibility_title: "Pour obtenir de l'aide sur l'admissibilité à une demande, vous pouvez communiquer avec les RH dès maintenant ou créer une demande.",
		chat_title: "Clavardage",
		call_title: "Appeler",
		create_request: "Créer une demande",
		wait_time: "Temps d'attente",
		response_time: "Temps de réponse",
		waiting_time_minute_text: "{{minutes}} minute",
		waiting_time_hours_text: "{{hours}} heures",
		hr_help_and_support: "Contactez les RH et gérez les demandes",
		call_error_processing: "Une erreur s’est produite lors du traitement de votre demande. Veuillez reprendre du début.",
		help_needed_with: "Sur quel sujet avez-vous besoin d'aide?",
		immigration_title: "Immigration",
		disability_and_leave_title: "Invalidité et congé",
		other: "Autres",
		submit: "Envoyer",
		cancel: "Annuler",
		enter_number_title: "Entrez votre numéro pour recevoir un appel des RH.",
		request_call: "Demander un appel",
		amazon_support_contact_shortly: "Vous recevrez sous peu un appel de l'équipe de soutien des employés d'Amazon.",
		confirm_preferred_phone_number: "Pour demander un appel, confirmez votre numéro de téléphone et votre langue de choix",
		what_preferred_phone_no: "Quel est votre numéro de téléphone privilégié?",
		preferred_language_text: "Quelle est votre langue privilégiée?",
		what_to_expect: "À quoi s'attendre",
		call_from_agent_minutes: "Un agent vous appellera dans les $ {minutes} minutes",
		call_from_amazon_number: "L'appel s'affichera sous forme de ${contactNumber} ou d'un numéro anonyme.",
		disconnected_agent_call_minute: "Si vous êtes déconnecté, l'agent vous rappellera dans un délai d'une minute",
		live_help_text_timekeeping_leaves_of_absence: "Pour obtenir de l'aide sur le contrôle des présences et les congés, vous pouvez appeler, discuter ou créer une demande",
		get_call_back: "Obtenir un rappel",
		request_phone_call: "Demander un appel téléphonique",
		close_chat_window: "Souhaitez-vous fermer la fenêtre de clavardage en direct?",
		chat_ended: "Le clavardage a pris fin.",
		idle_chat_disconnect: "Déconnecté en raison de l'inactivité",
		disconnect_from_chat: "L'utilisateur a quitté le clavardage. La conversation par clavardage est terminée.",
		chat_idle_message: "Le clavardage a été interrompu, car il a été inactif pendant {{minutes}} minutes.",
		chat_extended_after_idleness: "L’utilisateur a prolongé sa séance après avoir reçu un avertissement d’inactivité",
		surety_chat_idle_message: "Bonjour, je veux juste m'assurer que notre clavardage est toujours connecté. Nous sommes restés inactifs pendant ${minutes} minutes. Notre clavardage se terminera si vous n'êtes pas en mesure de répondre en deux minutes.",
		disconnect_chat_message: "Voulez-vous vraiment vous déconnecter du clavardage?",
		supported_file_attachments: "Types de fichiers pris en charge pour les pièces jointes au du clavardage : .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  La taille maximale du fichier d'une pièce jointe de clavardage est de 20 Mo.",
		upload_attachment: "Télécharger la pièce jointe",
		choose_file_upload: "Choisissez le fichier à télécharger",
		stay_Connected: "Restez connecté",
		disconnect: "Déconnecté",
		message_input_placeholder: "Tapez un message et appuyez sur Entrée pour envoyer",
		upload: "Téléverser",
		end_chat: "Fin du clavardage",
		connect: "Se connecter",
		save_chat: "Enregistrer le clavardage",
		connected: "Connecté",
		user_left_chat: "{{user}} a quitté le clavardage. Votre conversation par clavardage est terminée.",
		user_left_chat_during_transfer: "{{user}} a quitté le clavardage. Vous êtes redirigé.",
		user_joined_chat: "${user} a rejoint le clavardage",
		input_phone_number: "Saisir votre numéro de téléphone",
		time: "Temps",
		call_from_anonymous_number: "L'appel s'affichera sous forme de ${contactNumber} ou d'un numéro anonyme.",
		extended_user_session_warning: "L'utilisateur a prolongé sa séance après un avertissement d'inactivité",
		close: "Fermer",
		okay: "D’accord",
		send: "Envoyer",
		timer_message: "Demander de rappeler après {{counter}} secondes",
		start_new_chat: "Démarrer un nouveau clavardage",
		open_menu: "Ouvrir le menu",
		live_chat: "Clavardage en direct",
		end_chat_session: "Fin de la séance de clavardage",
		create_request_3steps: "Vous pouvez créer une demande en trois étapes",
		available_now: "Disponible maintenant",
		phone: "téléphone",
		minute: "minute",
		chat_with_HR: "Clavardage en direct",
		chat_with_HR_desc: "Discutez avec un représentant des RH pour obtenir une réponse instantanée à votre question",
		call_HR: "Appeler",
		call_hr_desc: "Appeler un agent des RH pour poser des questions cruciales ou urgentes",
		doc_note_due_date_ready: "Ayez un billet du médecin avec votre date d'échéance prête à être téléchargée",
		system: "SYSTÈME",
		connected_with_agent: "Vous êtes maintenant en contact avec un agent d'aide en direct",
		transferring_to_agent: "On vous transfère à un agent d'aide en direct",
		days: "jours",
		request_a_call: "Demander un appel",
		request_phone_call_heading: "Pour communiquer avec les RH par téléphone, nous avons besoin de votre numéro de téléphone et de la langue que vous privilégiez.",
		request_phone_call_heading_2: "Pour communiquer avec les RH par téléphone, nous avons besoin de votre numéro de téléphone privilégié.",
		what_your_preffered_number: "Quel est votre numéro de téléphone privilégié (y compris l’indicatif du pays)?",
		what_your_preffered_language: "Quelle est votre langue privilégiée?",
		phone_number_cannot_be_empty: "Le numéro de téléphone ne peut pas être vide",
		only_numbers_allowed: "Seuls les chiffres sont autorisés ici",
		receive_call_number: "Vous recevrez instantanément un appel du {{contactNumber}}.",
		receive_call_HR_team: "Vous recevrez instantanément un appel de l’équipe HR Support.",
		agent_hold_with_wait_time: "Vous serez en attente, et l’agent communiquera avec vous d’ici ${waitTime} minutes.",
		agent_hold_without_wait_time: "Vous serez en attente, et l’agent communiquera avec vous.",
		disconnected_agent_wait: "Si vous êtes déconnecté, l'agent vous rappellera dans un délai d'une minute.",
		call_hr_desc2: "Fournissez votre numéro de téléphone et un spécialiste du soutien des RH vous appellera directement.",
		create_hr_request: "Demande",
		chat_with_an_hr_specialist: "Discuter avec un spécialiste des RH",
		talk_to_an_hr_specialist: "Parler à un spécialiste des RH",
		create_an_hr_case: "Créer un dossier de RH",
		minutes: "minutes",
		waiting_time_less_than_minute_text: "moins d’une minute",
		waiting_time_minutes_text: "{{minutes}} minutes",
		waiting_time_hour_text: "{{hours}} heure",
		waiting_time_more_than_hours_text: "plus de {{hours}} heures",
		few_days: "1 à 2 jours",
		landing_page_heading: "Aide avec ${category}",
		landing_page_subheading: "Communiquez avec les RH {{availableChannels}}.",
		subheading_chat_text: "par clavardage en direct",
		subheading_call_text: "par téléphone",
		subheading_case_text: "en créant une demande",
		or_connector: "ou",
		create_case_description: "Si vous n'avez pas besoin d'aide immédiate, créez une demande.",
		next_hours_of_operation: "Soutien suivant disponible de {{startTime}} à {{endTime}} le {{day}}",
		next_hours_of_operation_with_days: "Prochain soutien disponible du {{startDay}} {{startTime}} au {{endDay}} {{endTime}}",
		time_in_am: "{{heure}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Impossible de télécharger la transcription. Veuillez réessayer.",
		download_attachment_error: "Impossible de télécharger la pièce jointe. Veuillez réessayer.",
		sent_message_error: "Il est impossible d’envoyer le message en raison d’une interruption du réseau. Veuillez vérifier votre réseau, puis réessayer.",
		get_contact_channels_failure: "Impossible d'obtenir les canaux disponibles. Veuillez réessayer.",
		select_a_file: "Sélectionner un fichier",
		external_disable_message: "Accessible à l'intérieur du réseau Amazon",
		required_field: "Champ obligatoire",
		end_chat_modal_text: "Votre séance de clavardage en direct avec les RH prendra fin.",
		end_chat_modal_title: "Mettre fin au clavardage?",
		download_transcript: "Télécharger la transcription",
		new_live_chat_session: "Nouvelle séance de clavardage en direct",
		live_chat_with_HR: "Clavardage en direct avec les RH",
		chat_header_title: "Bienvenue au clavardage en direct avec les RH",
		chat_header_subtitle_key: "Rubrique sélectionnée",
		chat_session_started: "La séance de clavardage est commencée",
		chat_session_ended: "Fin de la séance de clavardage",
		chat_wait_system_message: "Veuillez patienter pendant que nous vous mettons en contact avec un agent de clavardage en direct.",
		chat_waitTime_system_message: "Le temps d’attente est estimé à",
		chat_info_system_message: "Votre séance de clavardage restera active même si vous quittez cette fenêtre.",
		chat_agent_typing_message: "L’agent de soutien est en train d’écrire",
		livechat_warning_banner: "Votre séance de clavardage en direct avec les RH sera interrompue dans {{minutes}} minutes",
		no_available_channel: "Aucun canal n’est accessible pour le moment. Veuillez utiliser l’option Autre chose pour le moment.",
		chat_input_footer_label: "Votre message",
		business_days: "{{days}} jours ouvrables",
		business_day: "{{day}} jour ouvrable",
		file_size_limit: "La taille du fichier doit être inférieure à 20 Mo.",
		generic_error_message: "Un problème est survenu. Veuillez réessayer.",
		one_field_reqd_error: "Pour soumettre le formulaire de sondage, vous devez remplir au moins un champ.",
		send_survey: "Envoyer le sondage",
		upload_error_access_denied: "Permission d’accès refusée.",
		upload_error_internal_server_exception: "Un problème de service est survenu avec votre demande; veuillez réessayer.",
		upload_error_service_quota_exceeded: "La limite maximale de cinq pièces jointes a été atteinte.",
		upload_error_throttling: "Un problème de service est survenu avec votre demande; veuillez réessayer.",
		upload_error_validation: "Le type de fichier joint n’est pas pris en charge.",
		upload_error_generic: "Impossible de téléverser la pièce jointe",
		not_allowed_destination: "Les appels sortants vers le numéro de destination ne sont pas autorisés",
		call_not_allowed: "Ce numéro ne peut recevoir aucun appel",
		check_country_code: "Vérifiez que vous avez bien ajouté l’indicatif du pays au début du numéro.",
		try_different_number: "Essayez un autre numéro.",
		Sunday: "Dimanche",
		Monday: "Lundi",
		Tuesday: "Mardi",
		Wednesday: "Mercredi",
		Thursday: "Jeudi",
		Friday: "Vendredi",
		Saturday: "Samedi",
		recommended_words_error_text: "{{wordCount}} mots saisis. Vous pouvez saisir un maximum de {{wordLimit}} mots.",
		recommended_words_text: "{{wordCount}} mots saisis. {{wordLimit}} caractères ou moins sont nécessaires",
		stay_connected: "Restez connecté",
		chat_open_error_modal_text: "Un clavardage est déjà ouvert, veuillez le fermer pour lancer une nouvelle discussion.",
		chat_open_error_modal_title: "Le clavardage est déjà ouvert",
		previous_chat_history: "Historique des clavardages précédents",
		choose_chat_history: "Choisir l’historique des clavardages",
		no_chat_records_available: "Aucun dossier de clavardages antérieurs n’a été trouvé. Passez au clavardage en direct pour discuter avec l’agent",
		empty_chat_present: "Il n’y a aucune conversation dans cette séance de clavardage",
		language_support_text: "Nous nous efforçons actuellement d’améliorer votre expérience. Pour l’instant, vous pouvez accéder au portail libre-service des Services d’invalidité et de congé en anglais.",
		english_language_only_text: "Anglais seulement",
		invalid_message_contraint_error: "Limite de caractères dépassée. Un maximum de 1 024 caractères est autorisé",
		loading_error: "Une erreur s'est produite lors du chargement de cet écran. Veuillez réessayer dans quelques minutes.",
		loading_error_text: "Erreur de chargement.",
		maximize_chat_history: "Maximiser l'historique de clavardage",
		minimize_chat_history: "Minimiser l'historique de clavardage",
		need_more_help: "Besoin d'aide supplémentaire?",
		erc_number_message: "Pour obtenir un soutien immédiat, vous pouvez contacter les RH à l'adresse suivante :",
		get_started: "Commencer",
		self_service_content_error: "Un problème s'est produit lors du chargement du contenu en libre-service. Veuillez utiliser le bouton « Commencer » pour lancer le flux de travail en libre-service.",
		describe_issue_title: "Décrivez votre problème pour vous connecter à un agent de soutien",
		record_chat_session: "Votre session de clavardage peut être enregistrée à des fins de qualité ou de formation.",
		idleness_disconnect_message: "Votre clavardage sera déconnecté si vous êtes inactif ou si vous ne répondez pas pendant plus de {{minutes}} minutes.",
		userinput_box_hint_text: "Sur quel sujet avez-vous besoin d'aide?",
		get_help: "Obtenir de l'aide",
		connect_with_hr_by_chat_phone_request: "Contactez les RH par clavardage en direct, par téléphone ou en créant une demande.",
		myhr_contact_us: "My HR | Contactez-nous",
		not_able_to_get_live_help: "Nous ne sommes pas en mesure d'obtenir les options de soutien en direct pour vous en ce moment. Veuillez consulter MyHR pour obtenir de l'aide supplémentaire",
		chat_transcript_opt_in_modal_content: "L'entité Amazon qui vous emploie aimerait stocker ce clavardage à des fins de qualité, de formation et de tenue de dossiers. Pour donner votre accord, cliquez sur Accepter. Pour refuser, cliquez sur Refuser. Pour recevoir de plus amples informations sur la façon dont nous traitons vos données personnelles, notamment votre droit d'annulation de votre acceptation, consultez l'Avis global sur la protection de la vie privée des employés d'Amazon sur Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Accepter la transcription du clavardage?",
		chat_transcript_opt_in_consent: "Accepter",
		chat_transcript_opt_in_decline: "Refuser",
		connect_to_provider: "Se connecter à un fournisseur tiers?",
		your_information: "Vos informations",
		all_feilds_are_required: "Tous les champs sont obligatoires.",
		name: "Nom",
		email: "Courrier électronique",
		phoneNumber: "Numéro de téléphone",
		"continue": "Continuer",
		please_provide_valid: "Veuillez fournir des données valides",
		to_start_live_chat_click_continue: "Pour commencer votre séance de clavardage en direct avec un clinicien en santé mentale, fournissez les informations vous concernant et touchez « Continuer ».",
		you_are_connected_with_a_third_party: "Vous êtes en contact avec un fournisseur de soutien aux employés (EAP).",
		to_save_transcript_download: "Pour sauvegarder cette transcription, téléchargez la transcription avant de clore cette session.",
		fix_the_errors: "Corriger les erreurs : Vous n'avez pas répondu aux [X] questions requises.",
		all_clinicians_busy: "Désolé, mais tous les cliniciens semblent être occupés avec d'autres employés. Touchez « Nouvelle session de clavardage en direct » pour entrer de nouveau dans la file d'attente.",
		username: "Nom",
		connect_to_a_provider_outside_amazon: "Souhaitez-vous contacter un fournisseur hors d'Amazon?",
		you_are_now_connected_to_confidential: "Vous vous connectez actuellement à un fournisseur externe confidentiel, hors d'Amazon. Celui-ci a besoin de votre nom, de votre numéro de téléphone et de vos coordonnées pour s'enregistrer et s'authentifier. Ce service est gratuit et confidentiel.",
		no_agents: "Les agents RH ne sont pas disponibles actuellement, veuillez essayer un autre canal.",
		high_wait_time: "Tous nos agents RH sont actuellement occupés. Veuillez essayer d'autres canaux en attendant.",
		by_tapping_continue_agree_wpo_terms: "En touchant Continuer, vous reconnaissez avoir lu et accepté le service des options du lieu de travail.",
		terms_and_conditions: "Conditions générales",
		end_chat_modal_text_wpo: "Cela mettra fin à votre clavardage en direct.",
		live_support_options: "Options d'assistance en direct",
		open: "Ouverte",
		myhr: "My HR"
	}
};
var frCA = {
	atoz_myhr_app: atoz_myhr_app$5
};

var atoz_myhr_app$6 = {
	livehelp: {
		help_eligibility_title: "Pour obtenir de l'aide concernant l'éligibilité à l'application, vous pouvez contacter les HR dès maintenant ou créer une demande.",
		chat_title: "Chat",
		call_title: "Appel",
		create_request: "Créer une demande",
		wait_time: "Temps d'attente",
		response_time: "Temps de réponse",
		waiting_time_minute_text: "{{minutes}} minute",
		waiting_time_hours_text: "{{hours}} heures",
		hr_help_and_support: "Contacter les HR et gérer les demandes",
		call_error_processing: "Une erreur s'est produite lors du traitement de votre demande, veuillez réessayer depuis le début.",
		help_needed_with: "Pour quoi avez-vous besoin d'aide ?",
		immigration_title: "Immigration",
		disability_and_leave_title: "Invalidité et congé",
		other: "Autre",
		submit: "Envoyer",
		cancel: "Annuler",
		enter_number_title: "Entrez votre numéro pour recevoir un appel des HR.",
		request_call: "Demander un appel",
		amazon_support_contact_shortly: "Vous recevrez un appel de l'équipe d'assistance aux employés d'Amazon sous peu.",
		confirm_preferred_phone_number: "Pour demander un appel, confirmez votre numéro de téléphone et votre langue préférés",
		what_preferred_phone_no: "Quel est votre numéro de téléphone préféré ?",
		preferred_language_text: "Quelle est votre langue préférée ?",
		what_to_expect: "À quoi s'attendre",
		call_from_agent_minutes: "Un agent vous appellera dans ${minutes} minutes",
		call_from_amazon_number: "L'appel apparaîtra sous la forme de ${contactNumber} ou d'un numéro anonyme",
		disconnected_agent_call_minute: "En cas de déconnexion, l'agent vous rappellera dans la minute qui suit.",
		live_help_text_timekeeping_leaves_of_absence: "Pour obtenir de l'aide concernant le suivi des fiches de présence et des absences, vous pouvez appeler, ouvrir un chat ou créer une demande",
		get_call_back: "Être rappelé",
		request_phone_call: "Demander un appel téléphonique",
		close_chat_window: "Souhaitez-vous fermer la fenêtre de chat en direct ?",
		chat_ended: "Le chat est terminé.",
		idle_chat_disconnect: "Déconnecté pour cause d'inactivité",
		disconnect_from_chat: "L'utilisateur a quitté le chat. La conversation de chat est terminée.",
		chat_idle_message: "Le chat a été déconnecté car il est resté inactif pendant {{minutes}} minutes.",
		chat_extended_after_idleness: "L'utilisateur a prolongé sa session après un avertissement d'inactivité.",
		surety_chat_idle_message: "Bonjour, je veux juste m'assurer que notre chat est toujours actif. Nous sommes restés inactifs pendant ${minutes} minutes. Notre chat sera fermé si vous n'êtes pas en mesure de répondre dans les 2 minutes.",
		disconnect_chat_message: "Êtes-vous sûr de vouloir vous déconnecter du chat ?",
		supported_file_attachments: "Types de fichiers pris en charge pour les pièces jointes au chat : .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  La taille maximale d'un fichier joint à un chat est de 20 Mo.",
		upload_attachment: "Télécharger une pièce jointe",
		choose_file_upload: "Choisir le fichier à télécharger",
		stay_Connected: "Rester connecté",
		disconnect: "Déconnecter",
		message_input_placeholder: "Tapez un message et appuyez sur Entrée pour l'envoyer",
		upload: "Télécharger",
		end_chat: "Terminer le chat",
		connect: "Se connecter",
		save_chat: "Enregistrer le chat",
		connected: "Connecté",
		user_left_chat: "{{user}} a quitté le chat. Votre conversation de chat est terminée.",
		user_left_chat_during_transfer: "{{user}} a quitté le chat. Vous allez être transféré.",
		user_joined_chat: "${user} a rejoint le chat",
		input_phone_number: "Entrer votre numéro de téléphone",
		time: "Heure",
		call_from_anonymous_number: "L'appel apparaîtra sous la forme de ${contactNumber} ou d'un numéro anonyme",
		extended_user_session_warning: "L'utilisateur a prolongé sa session après un avertissement d'inactivité",
		close: "Fermer",
		okay: "D'accord",
		send: "Envoyer",
		timer_message: "Redemander un appel après {{counter}} secondes",
		start_new_chat: "Démarrer un nouveau chat",
		open_menu: "Ouvrir le menu",
		live_chat: "Chat en direct",
		end_chat_session: "Terminer la session de chat",
		create_request_3steps: "Vous pouvez créer une demande en 3 étapes",
		available_now: "Disponible dès maintenant",
		phone: "téléphone",
		minute: "minute",
		chat_with_HR: "Chat en direct",
		chat_with_HR_desc: "Discuter avec un agent HR pour obtenir une réponse instantanée à votre question",
		call_HR: "Appel",
		call_hr_desc: "Appeler un agent des HR pour toute demande critique/urgente",
		doc_note_due_date_ready: "Gardez le certificat médical avec votre date d'accouchement à portée de main afin de pouvoir le télécharger",
		system: "SYSTÈME",
		connected_with_agent: "Vous êtes maintenant connecté à un agent d'assistance en direct",
		transferring_to_agent: "Transfert vers un agent d'assistance en direct",
		days: "jours",
		request_a_call: "Demander un appel",
		request_phone_call_heading: "Pour communiquer avec les HR par téléphone, nous avons besoin de votre numéro de téléphone et de votre langue préférés.",
		request_phone_call_heading_2: "Pour communiquer avec les HR par téléphone, nous avons besoin de votre numéro de téléphone préféré.",
		what_your_preffered_number: "Quel est votre numéro de téléphone préféré (avec le code de pays) ?",
		what_your_preffered_language: "Quelle est votre langue préférée ?",
		phone_number_cannot_be_empty: "Le numéro de téléphone ne peut pas être vide",
		only_numbers_allowed: "Seuls les chiffres sont autorisés ici",
		receive_call_number: "Vous recevrez instantanément un appel de {{contactNumber}}.",
		receive_call_HR_team: "Vous recevrez instantanément un appel de l'équipe du HR Support.",
		agent_hold_with_wait_time: "Vous serez mis en attente et l'agent vous contactera d'ici ${waitTime} minutes.",
		agent_hold_without_wait_time: "Vous serez mis en attente et l'agent entrera en contact avec vous.",
		disconnected_agent_wait: "En cas de déconnexion, l'agent vous rappellera dans la minute qui suit.",
		call_hr_desc2: "Indiquez votre numéro de téléphone et un spécialiste du HR Support vous appellera directement.",
		create_hr_request: "Demander",
		chat_with_an_hr_specialist: "Discuter avec un spécialiste des HR",
		talk_to_an_hr_specialist: "Parler à un spécialiste des HR",
		create_an_hr_case: "Créer un HR Case",
		minutes: "minutes",
		waiting_time_less_than_minute_text: "moins de 1 minute",
		waiting_time_minutes_text: "{{minutes}} minutes",
		waiting_time_hour_text: "{{hours}}heure",
		waiting_time_more_than_hours_text: "plus de {{hours}} heures",
		few_days: "1 à 2 jours",
		landing_page_heading: "Aide pour ${category}",
		landing_page_subheading: "Entrez en contact avec les HR {{availableChannels}}.",
		subheading_chat_text: "par chat en direct",
		subheading_call_text: "par téléphone",
		subheading_case_text: "en créant une demande",
		or_connector: "ou",
		create_case_description: "Si vous n'avez pas besoin d'une assistance immédiate, créez une demande.",
		next_hours_of_operation: "L'assistance suivante est disponible à partir de {{day}}{{startTime}} – {{endTime}}",
		next_hours_of_operation_with_days: "L'assistance suivante est disponible à partir de {{startDay}}{{startTime}} – {{endDay}} {{endTime}}",
		time_in_am: "{{time}}",
		time_in_pm: "{{time}}",
		download_transcript_error: "Impossible de télécharger la transcription. Veuillez réessayer.",
		download_attachment_error: "Impossible de télécharger la pièce jointe. Veuillez réessayer.",
		sent_message_error: "Impossible d'envoyer le message en raison d'une interruption du réseau. Veuillez vérifier votre réseau et réessayer.",
		get_contact_channels_failure: "Impossible d'obtenir les canaux disponibles. Veuillez réessayer.",
		select_a_file: "Sélectionner un fichier",
		external_disable_message: "Accessible au sein du réseau Amazon",
		required_field: "Champ obligatoire",
		end_chat_modal_text: "Cela mettra fin à votre session de chat en direct avec les HR.",
		end_chat_modal_title: "Mettre fin au chat ?",
		download_transcript: "Télécharger la transcription",
		new_live_chat_session: "Nouvelle session de chat en direct",
		live_chat_with_HR: "Chat en direct avec les HR",
		chat_header_title: "Bienvenue dans le chat en direct avec les HR",
		chat_header_subtitle_key: "Sujet sélectionné",
		chat_session_started: "Session de chat commencée",
		chat_session_ended: "Session de chat terminée",
		chat_wait_system_message: "Veuillez patienter pendant que nous vous mettons en contact avec un agent de chat en direct.",
		chat_waitTime_system_message: "Le temps d'attente estimé est de",
		chat_info_system_message: "Votre session de chat restera connectée même si vous quittez cette fenêtre.",
		chat_agent_typing_message: "L'agent d'assistance est en train de taper",
		livechat_warning_banner: "Votre session de chat en direct avec les HR sera déconnectée dans {{minutes}} minutes",
		no_available_channel: "Aucun canal n'est disponible pour le moment. Veuillez utiliser l'option Autre chose pour le moment.",
		chat_input_footer_label: "Votre message",
		business_days: "{{days}} jours ouvrés",
		business_day: "{{day}} jour ouvré",
		file_size_limit: "La taille du fichier doit être inférieure à 20 Mo.",
		generic_error_message: "Une erreur est survenue ! Veuillez réessayer.",
		one_field_reqd_error: "Au moins un champ est obligatoire pour soumettre le formulaire d'enquête.",
		send_survey: "Envoyer l'enquête",
		upload_error_access_denied: "Autorisation d'accès refusée.",
		upload_error_internal_server_exception: "Un problème de service s'est produit avec votre demande, veuillez réessayer.",
		upload_error_service_quota_exceeded: "La limite maximale de 5 pièces jointes a été atteinte.",
		upload_error_throttling: "Un problème de service s'est produit avec votre demande, veuillez réessayer.",
		upload_error_validation: "Le type de fichier joint n'est pas pris en charge.",
		upload_error_generic: "Impossible de télécharger la pièce jointe",
		not_allowed_destination: "Les appels sortants vers le numéro de destination ne sont pas autorisés",
		call_not_allowed: "Impossible de recevoir un appel sur ce numéro",
		check_country_code: "Veillez à ajouter le code du pays au début du numéro.",
		try_different_number: "Essayez un autre numéro.",
		Sunday: "Dimanche",
		Monday: "Lundi",
		Tuesday: "Mardi",
		Wednesday: "Mercredi",
		Thursday: "Jeudi",
		Friday: "Vendredi",
		Saturday: "Samedi",
		recommended_words_error_text: "{{wordCount}} mots entrés. {{wordLimit}} mots sont autorisés au maximum",
		recommended_words_text: "{{wordCount}} mots entrés. {{wordLimit}} ou moins sont nécessaires",
		stay_connected: "Rester connecté",
		chat_open_error_modal_text: "Vous avez déjà ouvert un chat, veuillez le fermer pour en démarrer un nouveau.",
		chat_open_error_modal_title: "Le chat est déjà ouvert",
		previous_chat_history: "Historique des chats précédents",
		choose_chat_history: "Choisir l'historique du chat",
		no_chat_records_available: "Aucun enregistrement de chat précédent n'a été trouvé. Passer au chat en direct pour discuter avec l'agent",
		empty_chat_present: "Aucune conversation dans cette session de chat",
		language_support_text: "Nous nous efforçons actuellement d'améliorer votre expérience. Pour l'instant, vous pouvez accéder au portail en self-service pour les demandes liées à l'invalidité et aux congés en anglais.",
		english_language_only_text: "En anglais uniquement",
		invalid_message_contraint_error: "Limite de caractères dépassée. Un maximum de 1 024 caractères est autorisé",
		loading_error: "Une erreur s'est produite lors du chargement de cet écran. Veuillez réessayer dans quelques minutes.",
		loading_error_text: "Erreur lors du chargement.",
		maximize_chat_history: "Optimiser l'historique du chat",
		minimize_chat_history: "Minimiser l'historique du chat",
		need_more_help: "Besoin d'aide supplémentaire ?",
		erc_number_message: "Pour obtenir une assistance immédiate, vous pouvez contacter les HR à l'adresse suivante :",
		get_started: "Commencer",
		self_service_content_error: "Un problème s'est produit lors du chargement du contenu en self-service. Veuillez utiliser le bouton Commencer pour lancer le flux de travail du self-service.",
		describe_issue_title: "Décrivez votre problème pour être mis en relation avec un agent d'assistance",
		record_chat_session: "Votre session de chat peut être enregistrée à des fins de qualité ou de formation.",
		idleness_disconnect_message: "Votre chat sera déconnecté si vous êtes inactif ou si vous ne répondez pas pendant plus de {{minutes}} minutes.",
		userinput_box_hint_text: "Pour quoi avez-vous besoin d'aide ?",
		get_help: "Obtenir de l'aide",
		connect_with_hr_by_chat_phone_request: "Communiquez avec les HR par chat en direct, par téléphone ou en créant une demande.",
		myhr_contact_us: "My HR | Contactez-nous",
		not_able_to_get_live_help: "Nous ne sommes pas en mesure d'obtenir les options d'assistance en direct pour vous pour le moment. Veuillez visiter MyHR pour obtenir de l'aide supplémentaire",
		chat_transcript_opt_in_modal_content: "L'entité Amazon qui vous emploie souhaite stocker ce chat à des fins de qualité, de formation et de tenue des dossiers. Pour donner votre consentement, cliquez sur Accepter. Pour refuser, cliquez sur Refuser. Pour obtenir de plus amples informations sur la manière dont nous traitons vos données personnelles, y compris votre droit de retirer votre consentement, consultez la notice de confidentialité globale d'Amazon pour les employés sur Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Vous souhaitez recevoir la transcription du chat ?",
		chat_transcript_opt_in_consent: "Accepter",
		chat_transcript_opt_in_decline: "Refuser",
		connect_to_provider: "Vous vous connectez à un fournisseur tiers ?",
		your_information: "Vos informations",
		all_feilds_are_required: "Tous les champs sont obligatoires.",
		name: "Nom",
		email: "E-mail",
		phoneNumber: "Numéro de téléphone",
		"continue": "Continuer",
		please_provide_valid: "Veuillez fournir un code valide",
		to_start_live_chat_click_continue: "Pour démarrer votre session de chat en direct avec un clinicien en santé mentale, fournissez vos informations et appuyez sur Continuer.",
		you_are_connected_with_a_third_party: "Vous êtes connecté à un fournisseur d'aide aux employés (EAP) tiers.",
		to_save_transcript_download: "Pour enregistrer cette transcription, téléchargez-la avant de fermer cette session.",
		fix_the_errors: "Corriger les erreurs : Vous n'avez pas répondu à [X] questions obligatoires.",
		all_clinicians_busy: "Désolé, mais tous les cliniciens semblent être occupés avec d'autres employés. Appuyez sur Nouvelle session de chat en direct pour revenir dans la file d'attente.",
		username: "Nom",
		connect_to_a_provider_outside_amazon: "Vous vous connectez à un fournisseur extérieur à Amazon ?",
		you_are_now_connected_to_confidential: "Vous êtes maintenant connecté à un fournisseur externe confidentiel en dehors d'Amazon qui a besoin de votre nom, de votre numéro de téléphone et de vos informations de localisation pour vous enregistrer et vous authentifier. Ce service est gratuit et confidentiel.",
		no_agents: "Les agents des HR ne sont pas disponibles actuellement, veuillez essayer un autre canal",
		high_wait_time: "Tous nos agents des HR sont actuellement occupés. Veuillez essayer d'autres canaux en attendant",
		by_tapping_continue_agree_wpo_terms: "En appuyant sur Continuer, vous confirmez avoir lu et accepter le service Workplace Options",
		terms_and_conditions: "Conditions générales",
		end_chat_modal_text_wpo: "Cela mettra fin à votre chat en direct.",
		live_support_options: "Options d'assistance en direct",
		myhr: "My HR"
	}
};
var frFR = {
	atoz_myhr_app: atoz_myhr_app$6
};

var atoz_myhr_app$7 = {
	livehelp: {
		help_eligibility_title: "Per assistenza in merito all'idoneità della domanda, puoi metterti in contatto con HR ora o creare una richiesta.",
		chat_title: "Chat",
		call_title: "Chiama",
		create_request: "Crea una richiesta",
		wait_time: "Tempo di attesa",
		response_time: "Tempo di risposta",
		waiting_time_minute_text: "{{minutes}} minuto",
		waiting_time_hours_text: "{{hours}} ore",
		hr_help_and_support: "Contatta HR e gestisci le richieste",
		call_error_processing: "Si è verificato un errore durante l'elaborazione della tua richiesta, riprova dall'inizio.",
		help_needed_with: "Per cosa hai bisogno di aiuto?",
		immigration_title: "Immigrazione",
		disability_and_leave_title: "Disabilità e congedo",
		other: "Altro",
		submit: "Invia",
		cancel: "Annulla",
		enter_number_title: "Inserisci il tuo numero per ricevere una chiamata da HR.",
		request_call: "Richiedi una chiamata",
		amazon_support_contact_shortly: "A breve riceverai una chiamata dal team di supporto per i dipendenti di Amazon.",
		confirm_preferred_phone_number: "Per richiedere una chiamata, conferma il numero di telefono e la lingua che preferisci",
		what_preferred_phone_no: "Qual è il tuo numero di telefono preferito?",
		preferred_language_text: "Quale lingua preferisci?",
		what_to_expect: "Cosa aspettarsi",
		call_from_agent_minutes: "Un agente ti chiamerà entro ${minutes} minuti",
		call_from_amazon_number: "La chiamata risulterà provenire da ${contactNumber} o da un numero anonimo",
		disconnected_agent_call_minute: "In caso di disconnessione, l'agente ti richiamerà entro 1 minuto",
		live_help_text_timekeeping_leaves_of_absence: "Per assistenza con il timekeeping e i periodi di assenza dal lavoro, puoi chiamare, scrivere via chat o creare una richiesta",
		get_call_back: "Chiedi di essere richiamato",
		request_phone_call: "Richiedi una telefonata",
		close_chat_window: "Vuoi chiudere la finestra della Live Chat?",
		chat_ended: "La chat è terminata.",
		idle_chat_disconnect: "Disconnesso per inattività",
		disconnect_from_chat: "L'utente ha lasciato la chat. La conversazione in chat è terminata.",
		chat_idle_message: "La chat è stata disconnessa perché è rimasta inattiva per {{minutes}} minuti.",
		chat_extended_after_idleness: "L'utente ha esteso la sessione dopo l'avviso di inattività.",
		surety_chat_idle_message: "Salve, voglio solo assicurarmi che siamo ancora connessi in chat. Siamo rimasti inattivi per ${minutes} minuti. La chat si chiuderà in assenza di una tua risposta entro 2 minuti.",
		disconnect_chat_message: "Confermi di volerti disconnettere dalla chat?",
		supported_file_attachments: "Tipi di file supportati per gli allegati della chat: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Gli allegati della chat possono avere una dimensione massima di 20 MB.",
		upload_attachment: "Carica allegato",
		choose_file_upload: "Scegli il file da caricare",
		stay_Connected: "Rimani connesso",
		disconnect: "Disconnetti",
		message_input_placeholder: "Digita un messaggio e premi invio per inviare",
		upload: "Carica",
		end_chat: "Termina chat",
		connect: "Connetti",
		save_chat: "Salva chat",
		connected: "Connesso",
		user_left_chat: "{{user}} ha lasciato la chat. La tua conversazione in chat è terminata.",
		user_left_chat_during_transfer: "{{user}} ha lasciato la chat. Stai per essere trasferito.",
		user_joined_chat: "${user} è ora nella chat",
		input_phone_number: "Inserisci il tuo numero di telefono",
		time: "Orario",
		call_from_anonymous_number: "La chiamata risulterà provenire da ${contactNumber} o da un numero anonimo",
		extended_user_session_warning: "L'utente ha esteso la sessione dopo l'avviso di inattività",
		close: "Chiudi",
		okay: "OK",
		send: "Invia",
		timer_message: "Richiedi nuovamente la chiamata dopo {{counter}} secondi",
		start_new_chat: "Inizia una nuova chat",
		open_menu: "Apri menu",
		live_chat: "Live chat",
		end_chat_session: "Termina sessione chat",
		create_request_3steps: "Puoi creare una richiesta in 3 passaggi",
		available_now: "Disponibile ora",
		phone: "telefono",
		minute: "minuto",
		chat_with_HR: "Live chat",
		chat_with_HR_desc: "Chatta con un HR per far esaminare subito la tua domanda",
		call_HR: "Chiama",
		call_hr_desc: "Chiama un HR per domande importanti/urgenti",
		doc_note_due_date_ready: "Tieni pronto per il caricamento un certificato medico con la data prevista",
		system: "SISTEMA",
		connected_with_agent: "Ora sei connesso con un agente del supporto in diretta",
		transferring_to_agent: "È in corso il trasferimento a un agente del supporto in diretta",
		days: "giorni",
		request_a_call: "Richiedi una chiamata",
		request_phone_call_heading: "Per connetterti con HR via telefono, abbiamo bisogno del tuo numero di telefono e della lingua che preferisci.",
		request_phone_call_heading_2: "Per connetterti con HR via telefono, abbiamo bisogno del tuo numero di telefono.",
		what_your_preffered_number: "Qual è il tuo numero di telefono preferito (incluso il prefisso internazionale)?",
		what_your_preffered_language: "Quale lingua preferisci?",
		phone_number_cannot_be_empty: "Il numero di telefono non può essere vuoto",
		only_numbers_allowed: "Qui sono consentiti solo numeri",
		receive_call_number: "Riceverai immediatamente una chiamata da {{contactNumber}}.",
		receive_call_HR_team: "Riceverai immediatamente una chiamata dal team HR Support.",
		agent_hold_with_wait_time: "Rimarrai in attesa e l'agente si metterà in contatto con te entro ${waitTime} minuti.",
		agent_hold_without_wait_time: "Rimarrai in attesa e l'agente si metterà in contatto con te.",
		disconnected_agent_wait: "In caso di disconnessione, l'agente ti richiamerà entro 1 minuto.",
		call_hr_desc2: "Fornisci il tuo numero di telefono e uno specialista di HR Support ti chiamerà direttamente.",
		create_hr_request: "Richiesta",
		chat_with_an_hr_specialist: "Chatta con uno specialista HR",
		talk_to_an_hr_specialist: "Parla con uno specialista HR",
		create_an_hr_case: "Crea un HR Case",
		minutes: "minuti",
		waiting_time_less_than_minute_text: "meno di 1 minuto",
		waiting_time_minutes_text: "{{minutes}} minuti",
		waiting_time_hour_text: "{{hours}} ora",
		waiting_time_more_than_hours_text: "oltre {{hours}} ore",
		few_days: "1-2 giorni",
		landing_page_heading: "Aiuto con ${category}",
		landing_page_subheading: "Connettiti con HR {{availableChannels}}.",
		subheading_chat_text: "tramite Live Chat",
		subheading_call_text: "per telefono",
		subheading_case_text: "creando una richiesta",
		or_connector: "o",
		create_case_description: "Se non hai bisogno di aiuto immediato, crea una richiesta.",
		next_hours_of_operation: "Prossima disponibilità del supporto in data {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Prossimo supporto disponibile: {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Impossibile scaricare la trascrizione. Riprova.",
		download_attachment_error: "Impossibile scaricare l'allegato. Riprova.",
		sent_message_error: "Impossibile inviare il messaggio a causa di un'interruzione della rete. Controlla la tua rete e riprova.",
		get_contact_channels_failure: "Impossibile trovare i canali disponibili. Riprova.",
		select_a_file: "Seleziona un file",
		external_disable_message: "Accessibile all'interno della rete Amazon",
		required_field: "Campo obbligatorio",
		end_chat_modal_text: "Questo chiuderà la sessione della Live Chat con HR.",
		end_chat_modal_title: "Vuoi terminare la chat?",
		download_transcript: "Scarica la trascrizione",
		new_live_chat_session: "Nuova sessione di Live Chat",
		live_chat_with_HR: "Live Chat con HR",
		chat_header_title: "Benvenuto nella Live Chat con HR",
		chat_header_subtitle_key: "Argomento selezionato",
		chat_session_started: "Sessione di chat iniziata",
		chat_session_ended: "Sessione chat terminata",
		chat_wait_system_message: "Attendi mentre ti mettiamo in contatto con un agente della Live Chat.",
		chat_waitTime_system_message: "Il tempo di attesa stimato è di",
		chat_info_system_message: "La tua sessione di chat rimarrà connessa anche se esci da questa finestra.",
		chat_agent_typing_message: "L'agente di supporto sta scrivendo",
		livechat_warning_banner: "La sessione di Live Chat con HR sarà disconnessa tra {{minutes}} minuti",
		no_available_channel: "Al momento non sono disponibili canali. Per il momento puoi utilizzare l'opzione Altro.",
		chat_input_footer_label: "Il tuo messaggio",
		business_days: "{{days}} giorni lavorativi",
		business_day: "{{day}} giorno lavorativo",
		file_size_limit: "La dimensione del file deve essere inferiore a 20 MB.",
		generic_error_message: "Qualcosa è andato storto. Riprova.",
		one_field_reqd_error: "Per inviare il modulo del sondaggio è richiesto almeno 1 campo.",
		send_survey: "Invia sondaggio",
		upload_error_access_denied: "Autorizzazione di accesso negata.",
		upload_error_internal_server_exception: "C'è stato un problema di servizio con la tua richiesta, riprova.",
		upload_error_service_quota_exceeded: "È stato raggiunto il limite massimo di 5 allegati.",
		upload_error_throttling: "C'è stato un problema di servizio con la tua richiesta, riprova.",
		upload_error_validation: "Il tipo di file allegato non è supportato.",
		upload_error_generic: "Impossibile caricare l'allegato",
		not_allowed_destination: "Non sono consentite chiamate in uscita verso il numero di destinazione",
		call_not_allowed: "Impossibile ricevere la chiamata su questo numero",
		check_country_code: "Assicurati di aver aggiunto il prefisso internazionale all'inizio del numero.",
		try_different_number: "Prova con un altro numero.",
		Sunday: "Domenica",
		Monday: "Lunedì",
		Tuesday: "Martedì",
		Wednesday: "Mercoledì",
		Thursday: "Giovedì",
		Friday: "Venerdì",
		Saturday: "Sabato",
		recommended_words_error_text: "{{wordCount}} parole inserite. Sono consentite fino a {{wordLimit}} parole",
		recommended_words_text: "{{wordCount}} parole inserite. Sono richieste massimo {{wordLimit}}",
		stay_connected: "Rimani connesso",
		chat_open_error_modal_text: "Hai già una chat aperta, chiudila per iniziarne una nuova.",
		chat_open_error_modal_title: "Chat già aperta",
		previous_chat_history: "Cronologia chat precedenti",
		choose_chat_history: "Scegli la cronologia chat",
		no_chat_records_available: "Nessun record di chat precedenti trovato. Passa a LiveChat per chattare con l'agente",
		empty_chat_present: "Nessuna conversazione in questa sessione di chat",
		language_support_text: "Siamo al lavoro per migliorare la tua esperienza. Al momento puoi accedere al portale self-service dei servizi di invalidità e congedo in inglese.",
		english_language_only_text: "Solo in lingua inglese",
		invalid_message_contraint_error: "Limite di caratteri superato. Sono consentiti al massimo 1024 caratteri",
		loading_error: "Si è verificato un errore durante il caricamento di questa schermata. Riprova tra qualche minuto.",
		loading_error_text: "Errore di caricamento.",
		maximize_chat_history: "Ingrandisci la cronologia chat",
		minimize_chat_history: "Riduci al minimo la cronologia chat",
		need_more_help: "Hai bisogno di aiuto?",
		erc_number_message: "Per un supporto immediato, puoi contattare HR all'indirizzo:",
		get_started: "Inizia",
		self_service_content_error: "Si è verificato un problema durante il caricamento dei contenuti self-service. Utilizza il pulsante \"Inizia\" per avviare il flusso di lavoro self-service.",
		describe_issue_title: "Descrivi il problema per entrare in contatto con un agente del supporto",
		record_chat_session: "La tua sessione di chat può essere registrata per scopi di qualità o di formazione.",
		idleness_disconnect_message: "La chat verrà disconnessa in caso di inattività o mancata risposta per oltre {{minutes}} minuti.",
		userinput_box_hint_text: "Per cosa hai bisogno di aiuto?",
		get_help: "Ottieni assistenza",
		connect_with_hr_by_chat_phone_request: "Contatta HR tramite live chat, telefono o creando una richiesta.",
		myhr_contact_us: "My HR | Contattaci",
		not_able_to_get_live_help: "Al momento non siamo in grado di fornirti le opzioni di assistenza live. Visita MyHR per ulteriore assistenza",
		chat_transcript_opt_in_modal_content: "L'entità Amazon di cui sei dipendente vorrebbe archiviare questa chat per scopi di qualità e formazione e a fini di documentazione. Per acconsentire, fai clic su Acconsento. Per rifiutare, fai clic su Rifiuta. Per ricevere ulteriori informazioni su come gestiamo i tuoi dati personali, incluso il diritto di revoca del consenso, consulta l'Informativa privacy per i dipendenti su Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Vuoi ricevere la trascrizione della chat?",
		chat_transcript_opt_in_consent: "Acconsento",
		chat_transcript_opt_in_decline: "Rifiuto",
		connect_to_provider: "Connessione all'operatore sanitario di terze parti?",
		your_information: "Le tue informazioni",
		all_feilds_are_required: "Tutti i campi sono obbligatori.",
		name: "Nome",
		email: "E-mail",
		phoneNumber: "Numero di telefono",
		"continue": "Continua",
		please_provide_valid: "Immetti un valore valido per",
		to_start_live_chat_click_continue: "Per iniziare la sessione di chat dal vivo con uno specialista della salute mentale, fornisci le tue informazioni e tocca Continua.",
		you_are_connected_with_a_third_party: "Connessione a un EAP (Employee Assistance Provider) esterno eseguita.",
		to_save_transcript_download: "Per salvare questa trascrizione, scaricala prima di chiudere questa sessione.",
		fix_the_errors: "Correggi gli errori: Non hai risposto a [X] domande obbligatorie.",
		all_clinicians_busy: "Mi dispiace, ma sembra che tutti gli specialisti siano impegnati con altri dipendenti. Tocca Nuova sessione di Live Chat per rientrare nella coda.",
		username: "Nome",
		connect_to_a_provider_outside_amazon: "Connessione a un operatore sanitario esterno ad Amazon?",
		you_are_now_connected_to_confidential: "Ti stai connettendo a un operatore sanitario riservato esterno ad Amazon che richiede il tuo nome, numero di telefono e dettagli sulla posizione per la registrazione e l'autenticazione. Questo servizio è gratuito e riservato.",
		no_agents: "Gli agenti HR non sono disponibili al momento, prova a usare un altro canale",
		high_wait_time: "Tutti i nostri agenti HR sono al momento occupati. Nel frattempo, prova a usare altri canali",
		by_tapping_continue_agree_wpo_terms: "Selezionando Continua, confermi di aver letto e accettato il servizio Workplace Options",
		terms_and_conditions: "Termini e condizioni",
		end_chat_modal_text_wpo: "La live chat viene chiusa.",
		live_support_options: "Opzioni di supporto live",
		open: "Aperto",
		myhr: "My HR"
	}
};
var itIT = {
	atoz_myhr_app: atoz_myhr_app$7
};

var atoz_myhr_app$8 = {
	livehelp: {
		help_eligibility_title: "応募資格に関するサポートについては、今すぐHRに問い合わせるか、リクエストを作成できます。",
		chat_title: "チャット",
		call_title: "電話",
		create_request: "リクエストを作成",
		wait_time: "待ち時間",
		response_time: "応答時間",
		waiting_time_minute_text: "{{minutes}}分",
		waiting_time_hours_text: "{{hours}}時間",
		hr_help_and_support: "HRへのお問い合わせと依頼の管理",
		call_error_processing: "リクエストの処理中にエラーが発生しました。最初からやり直してください。",
		help_needed_with: "どのようなサポートが必要ですか？",
		immigration_title: "イミグレーション",
		disability_and_leave_title: "障害および休暇",
		other: "その他",
		submit: "送信",
		cancel: "キャンセル",
		enter_number_title: "HRからの電話を受ける電話番号を入力してください。",
		request_call: "電話をリクエストする",
		amazon_support_contact_shortly: "まもなくAmazon従業員サポートチームから電話がかかってきます。",
		confirm_preferred_phone_number: "電話をリクエストするには、ご希望の電話番号と言語を確認してください",
		what_preferred_phone_no: "ご希望の電話番号を教えてください。",
		preferred_language_text: "希望する言語を教えてください。",
		what_to_expect: "想定されること",
		call_from_agent_minutes: "エージェントが${minutes}分以内に電話します",
		call_from_amazon_number: "電話は、${contactNumber}または匿名の番号として表示されます",
		disconnected_agent_call_minute: "接続が切断された場合、エージェントは1分以内に折り返し電話をかけます",
		live_help_text_timekeeping_leaves_of_absence: "時間管理や休職についてのサポートは、電話またはチャットするか、リクエストを作成できます。",
		get_call_back: "折り返し電話をもらう",
		request_phone_call: "電話をリクエストする",
		close_chat_window: "ライブチャットウィンドウを閉じますか？",
		chat_ended: "チャットは終了しました。",
		idle_chat_disconnect: "操作がなかったため接続が切断されました",
		disconnect_from_chat: "ユーザーがチャットを退出しました。チャットの会話は終了しました。",
		chat_idle_message: "{{minutes}}分間アイドル状態だったため、チャットが切断されました。",
		chat_extended_after_idleness: "アイドル状態警告の後、ユーザーがセッションを延長しました。",
		surety_chat_idle_message: "チャットがまだ接続されていることを確認させてください。${minutes}分間アイドル状態が続いています。2分以内に返信がない場合、チャットは終了します。",
		disconnect_chat_message: "チャットを切断してもよろしいですか？",
		supported_file_attachments: "チャットの添付ファイルでサポートされるファイルタイプ：.pdf、.jpg、.jpeg、.png、.doc、.docx、.xls、.csv、.wav、.pptx、.ppt、.txt。 チャットの添付ファイルの最大ファイルサイズは20MBです。",
		upload_attachment: "添付ファイルのアップロード",
		choose_file_upload: "アップロードするファイルを選択",
		stay_Connected: "接続を維持",
		disconnect: "切断",
		message_input_placeholder: "メッセージを入力し、「Enter」キーを押して送信します",
		upload: "アップロードする",
		end_chat: "チャットを終了",
		connect: "接続",
		save_chat: "チャットを保存",
		connected: "接続済み",
		user_left_chat: "{{user}}がチャットを退出しました。チャットの会話は終了しました。",
		user_left_chat_during_transfer: "{{user}}がチャットを退出しました。転送しています。",
		user_joined_chat: "${user}がチャットに参加しました",
		input_phone_number: "電話番号を入力してください",
		time: "時間",
		call_from_anonymous_number: "電話は、${contactNumber}または匿名の番号として表示されます",
		extended_user_session_warning: "アイドル状態警告の後、ユーザーがセッションを延長しました",
		close: "閉じる",
		okay: "確認",
		send: "送信",
		timer_message: "{{counter}}秒後に再度電話をリクエスト",
		start_new_chat: "新規チャットを開始",
		open_menu: "メニューを開く",
		live_chat: "ライブチャット",
		end_chat_session: "チャットセッションを終了",
		create_request_3steps: "リクエストは3つのステップで作成できます",
		available_now: "今すぐ利用可能",
		phone: "電話",
		minute: "分",
		chat_with_HR: "ライブチャット",
		chat_with_HR_desc: "HRとチャットして、問合わせにすぐに対応してもらう",
		call_HR: "電話",
		call_hr_desc: "重要/緊急の問合わせについてHRに電話する",
		doc_note_due_date_ready: "期日が記載された医師の診断書をアップロードできるよう準備してください",
		system: "システム",
		connected_with_agent: "ライブヘルプエージェントにつながりました",
		transferring_to_agent: "ライブヘルプエージェントに転送しています",
		days: "日",
		request_a_call: "電話をリクエストする",
		request_phone_call_heading: "HRに電話で連絡するには、ご希望の電話番号と言語を教えてください。",
		request_phone_call_heading_2: "HRに電話で連絡するには、ご希望の電話番号が必要です。",
		what_your_preffered_number: "ご希望の電話番号（国コードを含む）を教えてください。",
		what_your_preffered_language: "希望する言語を教えてください。",
		phone_number_cannot_be_empty: "電話番号を空白にすることはできません",
		only_numbers_allowed: "ここでは数字のみ入力できます",
		receive_call_number: "{{contactNumber}}からすぐに電話がかかってきます。",
		receive_call_HR_team: "HR Supportチームからすぐに電話がかかってきます。",
		agent_hold_with_wait_time: "保留状態になった後、${waitTime}分以内にエージェントとつながります。",
		agent_hold_without_wait_time: "保留になった後、エージェントとつながります。",
		disconnected_agent_wait: "接続が切断された場合、エージェントは1分以内に折り返し電話をかけます。",
		call_hr_desc2: "電話番号を入力すると、HR Supportスペシャリストが直接あなたに電話します。",
		create_hr_request: "リクエスト",
		chat_with_an_hr_specialist: "HRスペシャリストとチャット",
		talk_to_an_hr_specialist: "HRスペシャリストと話す",
		create_an_hr_case: "HR Caseを作成",
		minutes: "分",
		waiting_time_less_than_minute_text: "1分未満",
		waiting_time_minutes_text: "{{minutes}}分",
		waiting_time_hour_text: "{{hours}}時間",
		waiting_time_more_than_hours_text: "{{hours}}時間以上",
		few_days: "1〜2日",
		landing_page_heading: "${category}に関するサポート",
		landing_page_subheading: "{{availableChannels}}HRに連絡をとります。",
		subheading_chat_text: "ライブチャットで",
		subheading_call_text: "電話で",
		subheading_case_text: "リクエストを作成して",
		or_connector: "もしくは",
		create_case_description: "すぐにサポートが必要ない場合は、リクエストを作成してください。",
		next_hours_of_operation: "利用可能な次のサポート：{{day}} {{startTime}}〜{{endTime}}",
		next_hours_of_operation_with_days: "利用可能な次のサポート：{{startDay}} {{startTime}}〜{{endDay}} {{endTime}}",
		time_in_am: "午前{{time}}",
		time_in_pm: "午後{{time}}",
		download_transcript_error: "トランスクリプトをダウンロードできませんでした。もう一度お試しください。",
		download_attachment_error: "添付ファイルをダウンロードできませんでした。もう一度お試しください。",
		sent_message_error: "ネットワークが中断されたため、メッセージを送信できません。ネットワークを確認して、もう一度試してください。",
		get_contact_channels_failure: "利用可能なチャンネルを取得できませんでした。もう一度お試しください。",
		select_a_file: "ファイルを選択",
		external_disable_message: "Amazon network内でアクセス可能",
		required_field: "必須項目",
		end_chat_modal_text: "これにより、HRとのライブチャットセッションは終了します。",
		end_chat_modal_title: "チャットを終了しますか？",
		download_transcript: "トランスクリプトをダウンロード",
		new_live_chat_session: "新規ライブチャットセッション",
		live_chat_with_HR: "HRとのライブチャット",
		chat_header_title: "HRとのライブチャットへようこそ",
		chat_header_subtitle_key: "トピックが選択されました",
		chat_session_started: "チャットセッションを開始しました",
		chat_session_ended: "チャットセッションは終了しました",
		chat_wait_system_message: "ライブチャットエージェントに接続しますので、しばらくお待ちください。",
		chat_waitTime_system_message: "推定待ち時間：",
		chat_info_system_message: "このウィンドウを離れても、チャットセッションは接続されたままになります。",
		chat_agent_typing_message: "サポートエージェントが入力中",
		livechat_warning_banner: "HRとのライブチャットセッションは{{minutes}}分で切断されます",
		no_available_channel: "現在、利用できるチャンネルはありません。今回は「その他」オプションを使用してください。",
		chat_input_footer_label: "あなたのメッセージ",
		business_days: "{{days}}営業日",
		business_day: "{{day}}営業日",
		file_size_limit: "ファイルサイズは20MB未満にしてください。",
		generic_error_message: "問題が発生しました。もう一度お試しください。",
		one_field_reqd_error: "アンケートフォームを送信するには、少なくとも1つの項目に入力が必要です。",
		send_survey: "アンケートを送信",
		upload_error_access_denied: "アクセス許可が拒否されました。",
		upload_error_internal_server_exception: "リクエストでサービス上の問題がありました。もう一度お試しください。",
		upload_error_service_quota_exceeded: "添付ファイルの上限5個に達しました。",
		upload_error_throttling: "リクエストでサービス上の問題がありました。もう一度お試しください。",
		upload_error_validation: "この添付ファイルの種類はサポートされていません。",
		upload_error_generic: "添付ファイルをアップロードできません",
		not_allowed_destination: "この通話先番号への発信通話は使用できません",
		call_not_allowed: "この番号では電話を受けることができません",
		check_country_code: "番号の先頭に国コードを追加したことを確認してください。",
		try_different_number: "別の番号を試してください。",
		Sunday: "日曜日",
		Monday: "月曜日",
		Tuesday: "火曜日",
		Wednesday: "水曜日",
		Thursday: "木曜日",
		Friday: "金曜日",
		Saturday: "土曜日",
		recommended_words_error_text: "{{wordCount}}語入力されました。最大{{wordLimit}}語まで入力できます",
		recommended_words_text: "{{wordCount}}語入力されました。語数は{{wordLimit}}以下にしてください",
		stay_connected: "接続を維持",
		chat_open_error_modal_text: "すでにチャットが開いています。新規チャットを開始するには、これを閉じてください。",
		chat_open_error_modal_title: "チャットはすでに開いています",
		previous_chat_history: "以前のチャット履歴",
		choose_chat_history: "チャット履歴を選択",
		no_chat_records_available: "以前のチャット記録は見つかりませんでした。LiveChatに進み、エージェントとチャットしてください",
		empty_chat_present: "このチャットセッションに会話はありません",
		language_support_text: "現在、皆さんの体験を改善できるよう取り組んでいます。現時点では、障害および休暇サービスのセルフサービスポータル（英語）にアクセスできます。",
		english_language_only_text: "英語のみ",
		invalid_message_contraint_error: "文字数制限を超えました。最大1024文字まで入力できます。",
		loading_error: "この画面の読み込み中にエラーが発生しました。数分後にもう一度お試しください。",
		loading_error_text: "読み込みエラー。",
		maximize_chat_history: "チャット履歴を最大化",
		minimize_chat_history: "チャット履歴を最小化",
		need_more_help: "さらにヘルプが必要ですか？",
		erc_number_message: "すぐにサポートが必要な場合は、以下からHRに連絡できます。",
		get_started: "開始",
		self_service_content_error: "セルフサービスコンテンツの読み込み中に問題が発生しました。「開始」ボタンを使用して、セルフサービスワークフローを開始してください。",
		describe_issue_title: "サポートエージェントに接続するには、問題を説明してください",
		record_chat_session: "チャットセッションは、品質または研修の目的で記録される場合があります。",
		idleness_disconnect_message: "{{minutes}}分以上アイドル状態が続く場合や返信がない場合、チャットは切断されます。",
		userinput_box_hint_text: "どのようなサポートが必要ですか？",
		get_help: "ヘルプを得る",
		connect_with_hr_by_chat_phone_request: "ライブチャット/電話で、またはリクエストを作成して、HRに連絡をとります。",
		myhr_contact_us: "My HR | お問い合わせ",
		not_able_to_get_live_help: "現在、ライブヘルプサポートのオプションを利用できません。その他のヘルプについては、MyHRにアクセスしてください",
		chat_transcript_opt_in_modal_content: "雇用元のAmazon部署が、品質向上や研修、記録のため、このチャットを保存することを希望しています。同意するには、「同意」をクリックします。拒否するには、「拒否」をクリックします。同意の撤回権を含め、Amazonによる個人データの取り扱いについての詳細は、Inside Amazonで社員向けプライバシー規約をご覧ください。",
		chat_transcript_opt_in_modal_title: "チャットトランスクリプトをオプトインしますか？",
		chat_transcript_opt_in_consent: "同意",
		chat_transcript_opt_in_decline: "拒否",
		connect_to_provider: "サードパーティプロバイダーに接続しますか？",
		your_information: "あなたの情報",
		all_feilds_are_required: "すべてが必須項目です。",
		name: "名前",
		email: "Eメール",
		phoneNumber: "電話番号",
		"continue": "続行",
		please_provide_valid: "有効な情報を入力してください",
		to_start_live_chat_click_continue: "メンタルヘルス臨床医とのライブチャットセッションを開始するには、情報を入力して「続行」をタップします。",
		you_are_connected_with_a_third_party: "サードパーティの従業員支援プロバイダー（EAP）につながりました。",
		to_save_transcript_download: "このトランスクリプトを保存するには、このセッションを終了する前にトランスクリプトをダウンロードしてください。",
		fix_the_errors: "エラーを修正してください。 [X]個の必須質問に回答していません。",
		all_clinicians_busy: "申し訳ありませんが、臨床医は他の社員をサポート中のようです。「新規ライブチャットセッション」をタップしてキューに入り直してください。",
		username: "名前",
		connect_to_a_provider_outside_amazon: "Amazon外部のプロバイダーに接続しますか？",
		you_are_now_connected_to_confidential: "Amazon外部の機密プロバイダーに接続しています。このプロバイダーでは、登録と認証のためにあなたの名前、電話番号、場所情報が求められます。このサービスは無料で、機密として扱われます。",
		no_agents: "現在、HRエージェントはご利用いただけません。別のチャネルをお試しください。",
		high_wait_time: "現在、HRエージェントに空きがありません。その間、他のチャネルをお試しください。",
		by_tapping_continue_agree_wpo_terms: "「続行」をタップすることで、職場オプションサービスを読み、同意したものとみなされます。",
		terms_and_conditions: "利用規約",
		end_chat_modal_text_wpo: "これにより、ライブチャットは終了します。",
		live_support_options: "ライブサポートオプション",
		myhr: "My HR"
	}
};
var jaJP = {
	atoz_myhr_app: atoz_myhr_app$8
};

var atoz_myhr_app$9 = {
	livehelp: {
		help_eligibility_title: "Als je wilt weten of je in aanmerking komt, kun je nu contact opnemen met HR of een aanvraag aanmaken.",
		chat_title: "Chatten",
		call_title: "Bellen",
		create_request: "Een aanvraag aanmaken",
		wait_time: "Wachttijd",
		response_time: "Reactietijd",
		waiting_time_minute_text: "{{minutes}} minuut",
		waiting_time_hours_text: "{{hours}} uur",
		hr_help_and_support: "Contact opnemen met HR en aanvragen beheren",
		call_error_processing: "Er is een fout opgetreden bij het verwerken van je aanvraag. Probeer het opnieuw vanaf het begin.",
		help_needed_with: "Waar heb je hulp bij nodig?",
		immigration_title: "Immigratie",
		disability_and_leave_title: "Arbeidsongeschiktheid en verlof",
		other: "Overig",
		submit: "Indienen",
		cancel: "Annuleren",
		enter_number_title: "Voer je nummer in om een telefoontje van HR te ontvangen.",
		request_call: "Een gesprek aanvragen",
		amazon_support_contact_shortly: "Je wordt binnenkort gebeld door het ondersteuningsteam voor Amazon-medewerkers.",
		confirm_preferred_phone_number: "Om een gesprek aan te vragen, moet je je voorkeurstelefoonnummer en -taal bevestigen",
		what_preferred_phone_no: "Wat is je voorkeurstelefoonnummer?",
		preferred_language_text: "Wat is je voorkeurstaal?",
		what_to_expect: "Wat je kunt verwachten",
		call_from_agent_minutes: "Een medewerker belt je binnen ${minutes} minuten",
		call_from_amazon_number: "Het gesprek wordt weergegeven als een ${contactNumber} of als een anoniem nummer",
		disconnected_agent_call_minute: "Als de verbinding wordt verbroken, belt de medewerker je binnen 1 minuut terug",
		live_help_text_timekeeping_leaves_of_absence: "Voor hulp bij tijdregistratie en afwezigheidsperioden kun je bellen, chatten of een aanvraag aanmaken",
		get_call_back: "Terugbellen",
		request_phone_call: "Een telefoongesprek aanvragen",
		close_chat_window: "Wil je het LiveChat-venster sluiten?",
		chat_ended: "De chat is afgelopen.",
		idle_chat_disconnect: "Verbinding verbroken vanwege inactiviteit",
		disconnect_from_chat: "De gebruiker heeft de chat verlaten. Het chatgesprek is beëindigd.",
		chat_idle_message: "De chatverbinding is verbroken omdat deze {{minutes}} minuten niet is gebruikt.",
		chat_extended_after_idleness: "De gebruiker heeft zijn/haar sessie verlengd na een waarschuwing voor inactiviteit.",
		surety_chat_idle_message: "Hallo, ik wil alleen even controleren of onze chat nog steeds is verbonden. We zijn al ${minutes} minuten inactief. Onze chat wordt gesloten als je niet binnen 2 minuten kunt reageren.",
		disconnect_chat_message: "Weet je zeker dat je de chatverbinding wilt verbreken?",
		supported_file_attachments: "Ondersteunde bestandstypen voor chatbijlagen: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  De maximale bestandsgrootte voor een chatbijlage is 20 MB.",
		upload_attachment: "Bijlage uploaden",
		choose_file_upload: "Kies een bestand om te uploaden",
		stay_Connected: "Verbonden blijven",
		disconnect: "Verbinding verbreken",
		message_input_placeholder: "Typ een bericht en druk op enter om te verzenden",
		upload: "Uploaden",
		end_chat: "Chat beëindigen",
		connect: "Verbinden",
		save_chat: "Chat opslaan",
		connected: "Verbonden",
		user_left_chat: "{{user}} heeft de chat verlaten. Je chatgesprek is beëindigd.",
		user_left_chat_during_transfer: "{{user}} heeft de chat verlaten. Je wordt overgedragen.",
		user_joined_chat: "${user} neemt deel aan de chat",
		input_phone_number: "Voer je telefoonnummer in",
		time: "Tijd",
		call_from_anonymous_number: "Het gesprek wordt weergegeven als een ${contactNumber} of als een anoniem nummer",
		extended_user_session_warning: "De gebruiker heeft zijn/haar sessie verlengd na een waarschuwing voor inactiviteit",
		close: "Sluiten",
		okay: "Oké",
		send: "Verzenden",
		timer_message: "Na {{counter}} seconden opnieuw een oproep aanvragen",
		start_new_chat: "Een nieuwe chat starten",
		open_menu: "Menu openen",
		live_chat: "Livechat",
		end_chat_session: "Chatsessie beëindigen",
		create_request_3steps: "Je kunt een aanvraag aanmaken in 3 stappen",
		available_now: "Nu beschikbaar",
		phone: "telefoon",
		minute: "minuut",
		chat_with_HR: "Livechat",
		chat_with_HR_desc: "Chat met een HR om je vraag direct te laten beantwoorden",
		call_HR: "Bellen",
		call_hr_desc: "Bel een HR voor kritieke/dringende vragen",
		doc_note_due_date_ready: "Zorg dat je een doktersverklaring met je bevallingsdatum klaar hebt om te uploaden",
		system: "SYSTEEM",
		connected_with_agent: "Je bent nu verbonden met een liveondersteuningsmedewerker",
		transferring_to_agent: "Je wordt overgedragen naar een liveondersteuningsmedewerker",
		days: "dagen",
		request_a_call: "Een gesprek aanvragen",
		request_phone_call_heading: "Om telefonisch contact op te nemen met HR, hebben we je voorkeurstelefoonnummer en -taal nodig.",
		request_phone_call_heading_2: "Om telefonisch contact op te nemen met HR, hebben we je voorkeurstelefoonnummer nodig.",
		what_your_preffered_number: "Wat is je voorkeurstelefoonnummer (inclusief landcode)?",
		what_your_preffered_language: "Wat is je voorkeurstaal?",
		phone_number_cannot_be_empty: "Telefoonnummer mag niet leeg zijn",
		only_numbers_allowed: "Hier zijn alleen cijfers toegestaan",
		receive_call_number: "Je wordt direct gebeld door {{contactNumber}}.",
		receive_call_HR_team: "Je wordt direct gebeld door het HR-ondersteuningsteam.",
		agent_hold_with_wait_time: "Je wordt in de wacht gezet en de medewerker neemt binnen ${waitTime} minuten contact met je op.",
		agent_hold_without_wait_time: "Je wordt in de wacht gezet en de medewerker neemt contact met je op.",
		disconnected_agent_wait: "Als de verbinding wordt verbroken, belt de medewerker je binnen 1 minuut terug.",
		call_hr_desc2: "Geef je telefoonnummer op en een HR-ondersteuningsspecialist zal je rechtstreeks bellen.",
		create_hr_request: "Aanvraag",
		chat_with_an_hr_specialist: "Chatten met een HR-specialist",
		talk_to_an_hr_specialist: "Praat met een HR-specialist",
		create_an_hr_case: "Een HR Case aanmaken",
		minutes: "minuten",
		waiting_time_less_than_minute_text: "minder dan 1 minuut",
		waiting_time_minutes_text: "{{minutes}} minuten",
		waiting_time_hour_text: "{{hours}} uur",
		waiting_time_more_than_hours_text: "meer dan {{hours}} uur",
		few_days: "1-2 dagen",
		landing_page_heading: "Hulp bij ${category}",
		landing_page_subheading: "Contact opnemen met HR {{availableChannels}}.",
		subheading_chat_text: "via livechat",
		subheading_call_text: "per telefoon",
		subheading_case_text: "door een aanvraag te maken",
		or_connector: "of",
		create_case_description: "Als je geen onmiddellijke hulp nodig hebt, kun je een aanvraag aanmaken.",
		next_hours_of_operation: "De volgende ondersteuning is beschikbaar van {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "De volgende ondersteuning is beschikbaar van {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} a.m.",
		time_in_pm: "{{time}} p.m.",
		download_transcript_error: "Het downloaden van het transcript is mislukt. Probeer het opnieuw.",
		download_attachment_error: "Het downloaden van de bijlage is mislukt. Probeer het opnieuw.",
		sent_message_error: "Kan geen bericht verzenden vanwege een netwerkonderbreking. Controleer je netwerk en probeer het opnieuw.",
		get_contact_channels_failure: "Het verkrijgen van beschikbare kanalen is mislukt. Probeer het opnieuw.",
		select_a_file: "Selecteer een bestand",
		external_disable_message: "Toegankelijk binnen het Amazon-netwerk",
		required_field: "Verplicht veld",
		end_chat_modal_text: "Hiermee wordt je LiveChat met HR-sessie beëindigd.",
		end_chat_modal_title: "Chat beëindigen?",
		download_transcript: "Transcript downloaden",
		new_live_chat_session: "Nieuwe livechatsessie",
		live_chat_with_HR: "LiveChat met HR",
		chat_header_title: "Welkom bij LiveChat met HR",
		chat_header_subtitle_key: "Onderwerp geselecteerd",
		chat_session_started: "Chatsessie gestart",
		chat_session_ended: "Chatsessie beëindigd",
		chat_wait_system_message: "Een ogenblik geduld, we brengen je in contact met een livechatmedewerker.",
		chat_waitTime_system_message: "De geschatte wachttijd is",
		chat_info_system_message: "Je chatsessie blijft verbonden, zelfs als je dit venster verlaat.",
		chat_agent_typing_message: "Ondersteuningsmedewerker is aan het typen",
		livechat_warning_banner: "Je LiveChat met HR-sessie wordt over {{minutes}} minuten verbroken",
		no_available_channel: "Op het moment zijn er geen kanalen beschikbaar. Gebruik op dit moment de optie Iets anders.",
		chat_input_footer_label: "Je bericht",
		business_days: "{{days}} werkdagen",
		business_day: "{{day}} werkdag",
		file_size_limit: "De bestandsgrootte moet kleiner zijn dan 20 MB.",
		generic_error_message: "Er is iets misgegaan. Probeer het opnieuw.",
		one_field_reqd_error: "Er is ten minste 1 veld vereist om het enquêteformulier in te dienen.",
		send_survey: "Enquête verzenden",
		upload_error_access_denied: "De toegangstoestemming is geweigerd.",
		upload_error_internal_server_exception: "Er is een serviceprobleem opgetreden met je aanvraag. Probeer het opnieuw.",
		upload_error_service_quota_exceeded: "De maximale limiet van 5 bijlagen is bereikt.",
		upload_error_throttling: "Er is een serviceprobleem opgetreden met je aanvraag. Probeer het opnieuw.",
		upload_error_validation: "Het bestandstype voor bijlagen wordt niet ondersteund.",
		upload_error_generic: "Kan bijlage niet uploaden",
		not_allowed_destination: "Uitgaande oproepen naar het bestemmingsnummer zijn niet toegestaan",
		call_not_allowed: "Oproep kan niet worden ontvangen op dit nummer",
		check_country_code: "Zorg dat je de landcode toevoegt aan het begin van het nummer.",
		try_different_number: "Probeer een ander nummer.",
		Sunday: "Zondag",
		Monday: "Maandag",
		Tuesday: "Dinsdag",
		Wednesday: "Woensdag",
		Thursday: "Donderdag",
		Friday: "Vrijdag",
		Saturday: "Zaterdag",
		recommended_words_error_text: "{{wordCount}} woorden ingevoerd. Er zijn maximaal {{wordLimit}} woorden toegestaan",
		recommended_words_text: "{{wordCount}} woorden ingevoerd. Er zijn {{wordLimit}} of minder vereist",
		stay_connected: "Verbonden blijven",
		chat_open_error_modal_text: "Je hebt al een chat geopend. Sluit deze om een nieuwe chat te starten.",
		chat_open_error_modal_title: "Chat is al geopend",
		previous_chat_history: "Vorige chatgeschiedenis",
		choose_chat_history: "Chatgeschiedenis kiezen",
		no_chat_records_available: "Geen eerdere chatrecords gevonden. Ga naar LiveChat om met de medewerker te chatten",
		empty_chat_present: "Geen gesprek in deze chatsessie",
		language_support_text: "We zijn momenteel bezig om je ervaring te verbeteren. Voorlopig heb je toegang tot het selfserviceportal Disability and Leave Services in het Engels.",
		english_language_only_text: "Alleen in het Engels",
		invalid_message_contraint_error: "De tekenlimiet is overschreden. Er zijn maximaal 1024 tekens toegestaan",
		loading_error: "Er is een fout opgetreden tijdens het laden van dit scherm. Probeer het over een paar minuten opnieuw.",
		loading_error_text: "Fout bij het laden.",
		maximize_chat_history: "Chatgeschiedenis maximaliseren",
		minimize_chat_history: "Chatgeschiedenis minimaliseren",
		need_more_help: "Meer hulp nodig?",
		erc_number_message: "Voor onmiddellijke ondersteuning kun je contact opnemen met HR via:",
		get_started: "Aan de slag",
		self_service_content_error: "Er is een probleem opgetreden tijdens het laden van selfservicecontent. Gebruik de knop 'Aan de slag' om de selfserviceworkflow te starten.",
		describe_issue_title: "Beschrijf je probleem om te worden doorverbonden met een ondersteuningsmedewerker",
		record_chat_session: "Je chatsessie kan worden opgenomen voor kwaliteits- of trainingsdoeleinden.",
		idleness_disconnect_message: "Je chatverbinding wordt verbroken als je inactief bent of langer dan {{minutes}} minuten niet reageert.",
		userinput_box_hint_text: "Waar heb je hulp bij nodig?",
		get_help: "Hulp krijgen",
		connect_with_hr_by_chat_phone_request: "Neem contact op met HR via livechat, telefoon of door een aanvraag in te dienen.",
		myhr_contact_us: "My HR | Neem contact met ons op",
		not_able_to_get_live_help: "We kunnen op dit moment geen opties voor liveondersteuning voor je krijgen. Bezoek myHR voor meer hulp",
		chat_transcript_opt_in_modal_content: "Je werkgevende Amazon-entiteit wil deze chat opslaan voor kwaliteits- en trainingsdoeleinden en voor het bijhouden van gegevens. Klik op Toestemmen om toestemming te geven. Klik op Weigeren om te weigeren. Voor meer informatie over hoe we omgaan met je persoonlijke gegevens, inclusief je recht om toestemming in te trekken, raadpleeg je de Amazon EU Privacyverklaring voor Werknemers op Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Aanmelden voor een transcript van de chat?",
		chat_transcript_opt_in_consent: "Toestemmen",
		chat_transcript_opt_in_decline: "Weigeren",
		connect_to_provider: "Verbinding maken met een externe provider?",
		your_information: "Je informatie",
		all_feilds_are_required: "Alle velden zijn verplicht.",
		name: "Naam",
		email: "E-mail",
		phoneNumber: "Telefoonnummer",
		"continue": "Doorgaan",
		please_provide_valid: "Geef een geldig nummer op",
		to_start_live_chat_click_continue: "Voer je gegevens in en tik op Doorgaan om je livechatsessie met een hulpverlener in de geestelijke gezondheidszorg te starten.",
		you_are_connected_with_a_third_party: "Je bent verbonden met een externe EAP.",
		to_save_transcript_download: "Als je dit transcript wilt opslaan, moet je het transcript downloaden voordat je deze sessie sluit.",
		fix_the_errors: "Los de fouten op: Je hebt niet gereageerd op [X] vereiste vragen.",
		all_clinicians_busy: "Onze excuses, maar alle hulpverleners lijken het druk te hebben met andere medewerkers. Tik op Nieuwe livechatsessie om de wachtrij opnieuw te openen.",
		username: "Naam",
		connect_to_a_provider_outside_amazon: "Verbinding maken met een provider buiten Amazon?",
		you_are_now_connected_to_confidential: "Je maakt nu verbinding met een vertrouwelijke, externe provider buiten Amazon die je naam, telefoonnummer en locatiegegevens nodig heeft om je te registreren en verifiëren. Deze service is gratis en vertrouwelijk.",
		no_agents: "Er zijn momenteel geen HR-medewerkers beschikbaar, probeer een ander kanaal",
		high_wait_time: "Al onze HR-momenteel zijn momenteel bezet. Probeer in de tussentijd andere kanalen",
		by_tapping_continue_agree_wpo_terms: "Door op Doorgaan te tikken, ga je ermee akkoord dat je de Workplace Options-service hebt gelezen en ermee akkoord gaat",
		terms_and_conditions: "Algemene voorwaarden",
		end_chat_modal_text_wpo: "Hiermee wordt je livechat beëindigd.",
		live_support_options: "Opties voor liveondersteuning",
		myhr: "My HR"
	}
};
var nlNL = {
	atoz_myhr_app: atoz_myhr_app$9
};

var atoz_myhr_app$a = {
	livehelp: {
		help_eligibility_title: "Aby uzyskać pomoc dotyczącą kwalifikowalności w zakresie aplikacji, możesz teraz połączyć się z zespołem HR lub utworzyć wniosek.",
		chat_title: "Czat",
		call_title: "Zadzwoń",
		create_request: "Utwórz wniosek",
		wait_time: "Czas oczekiwania",
		response_time: "Czas odpowiedzi",
		waiting_time_minute_text: "{{minutes}} minuta",
		waiting_time_hours_text: "{{hours}} godz.",
		hr_help_and_support: "Skontaktuj się z działem HR i zarządzaj wnioskami",
		call_error_processing: "Wystąpił błąd w przetwarzaniu Twojego wniosku, spróbuj ponownie od początku.",
		help_needed_with: "W czym potrzebujesz pomocy?",
		immigration_title: "Imigracja",
		disability_and_leave_title: "Niepełnosprawność i zwolnienie",
		other: "Inne",
		submit: "Prześlij",
		cancel: "Anuluj",
		enter_number_title: "Wprowadź numer, aby odebrać połączenie od zespołu HR.",
		request_call: "Złóż wniosek o połączenie",
		amazon_support_contact_shortly: "Wkrótce zadzwoni do Ciebie pracownik zespołu pomocy dla pracowników Amazon.",
		confirm_preferred_phone_number: "Aby złożyć wniosek o połączenie, potwierdź preferowany numer telefonu i język",
		what_preferred_phone_no: "Jaki jest preferowany przez Ciebie numer telefonu?",
		preferred_language_text: "Jaki jest preferowany przez Ciebie język?",
		what_to_expect: "Czego się spodziewać",
		call_from_agent_minutes: "Agent zadzwoni do Ciebie w ciągu ${minutes} minut",
		call_from_amazon_number: "Połączenie zostanie wyświetlone jako numer ${contactNumber} lub anonimowy numer",
		disconnected_agent_call_minute: "Jeśli połączenie zostanie rozłączone, agent oddzwoni do Ciebie w ciągu 1 minuty",
		live_help_text_timekeeping_leaves_of_absence: "Aby uzyskać pomoc w zakresie systemu ewidencji czasu pracy i przerwy w świadczeniu pracy, możesz zadzwonić, rozmawiać za pośrednictwem czatu lub utworzyć wniosek",
		get_call_back: "Odbierz telefon",
		request_phone_call: "Złóż wniosek o rozmowę telefoniczną",
		close_chat_window: "Czy chcesz zamknąć okno Czat na żywo?",
		chat_ended: "Czat się zakończył.",
		idle_chat_disconnect: "Rozłączono z powodu braku aktywności",
		disconnect_from_chat: "Użytkownik opuścił czat. Rozmowa na czacie zakończyła się.",
		chat_idle_message: "Czat został odłączony z powodu bezczynności przez {{minutes}} min.",
		chat_extended_after_idleness: "Użytkownik przedłużył sesję po ostrzeżeniu o bezczynności.",
		surety_chat_idle_message: "Witaj, chcę się tylko upewnić, że nasz czat nadal jest połączony. Czat był bezczynny przez ${minutes} minut. Jeśli nie będziesz w stanie odpowiedzieć w ciągu 2 minut, nasz czat zostanie zamknięty.",
		disconnect_chat_message: "Czy na pewno chcesz odłączyć się od czatu?",
		supported_file_attachments: "Typy plików obsługiwane w zakresie załączników do czatu: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Maksymalny rozmiar pliku w zakresie załącznika do czatu wynosi 20 MB.",
		upload_attachment: "Prześlij załącznik",
		choose_file_upload: "Wybierz plik do przesłania",
		stay_Connected: "Pozostań w kontakcie",
		disconnect: "Odłącz",
		message_input_placeholder: "Wpisz wiadomość i naciśnij Enter, aby wysłać",
		upload: "Prześlij",
		end_chat: "Zakończ czatu",
		connect: "Połącz",
		save_chat: "Zapisz czat",
		connected: "Połączono",
		user_left_chat: "{{user}} opuścił(a) czat. Twoja rozmowa na czacie została zakończona.",
		user_left_chat_during_transfer: "{{user}} opuścił(a) czat. Nastąpi przeniesienie.",
		user_joined_chat: "${user} dołączył(a) do czatu",
		input_phone_number: "Wprowadź numer telefonu",
		time: "Czas",
		call_from_anonymous_number: "Połączenie zostanie wyświetlone jako numer ${contactNumber} lub anonimowy numer",
		extended_user_session_warning: "Użytkownik przedłużył sesję po ostrzeżeniu o bezczynności",
		close: "Zamknij",
		okay: "Dobrze",
		send: "Wyślij",
		timer_message: "Poproś o połączenie po {{counter}} sekundach",
		start_new_chat: "Rozpocznij nowy czat",
		open_menu: "Otwórz menu",
		live_chat: "Czat na żywo",
		end_chat_session: "Zakończ sesję czatu",
		create_request_3steps: "Wniosek można utworzyć w 3 krokach",
		available_now: "Dostępne teraz",
		phone: "telefon",
		minute: "minuta",
		chat_with_HR: "Czat na żywo",
		chat_with_HR_desc: "Porozmawiaj z zespołem HR na czacie, aby natychmiast otrzymać odpowiedź na zapytanie",
		call_HR: "Zadzwoń",
		call_hr_desc: "Zadzwoń do zespołu HR w przypadku krytycznych/pilnych zapytań",
		doc_note_due_date_ready: "Przygotuj do przesłania zwolnienie lekarskie z terminem",
		system: "SYSTEM",
		connected_with_agent: "Nawiązano połączenie z agentem ds. pomocy na żywo",
		transferring_to_agent: "Przekierowywanie do agenta ds. pomocy na żywo",
		days: "dni",
		request_a_call: "Złóż wniosek o połączenie",
		request_phone_call_heading: "Aby nawiązać połączenie telefoniczne z zespołem HR, musimy znać preferowany przez Ciebie numeru telefonu i język.",
		request_phone_call_heading_2: "Aby nawiązać połączenie telefoniczne z zespołem HR, musimy znać preferowany przez Ciebie numeru telefonu.",
		what_your_preffered_number: "Jaki jest Twój preferowany numer telefonu (w tym kod kraju)?",
		what_your_preffered_language: "Jaki jest preferowany przez Ciebie język?",
		phone_number_cannot_be_empty: "Trzeba podać numer telefonu",
		only_numbers_allowed: "W tym miejscu dozwolone są tylko liczby",
		receive_call_number: "Natychmiast otrzymasz połączenie z numeru {{contactNumber}}.",
		receive_call_HR_team: "Natychmiast otrzymasz połączenie z zespołem wsparcia HR Support.",
		agent_hold_with_wait_time: "Czat zostanie zawieszony, a agent połączy się z Tobą w ciągu ${waitTime} minut.",
		agent_hold_without_wait_time: "Zaczekasz za rozmowę, a agent połączy się z Tobą.",
		disconnected_agent_wait: "Jeśli połączenie zostanie rozłączone, agent oddzwoni do Ciebie w ciągu 1 minuty.",
		call_hr_desc2: "Podaj numer telefonu, a specjalista z zespołu HR Support skontaktuje się bezpośrednio z Tobą.",
		create_hr_request: "Wniosek",
		chat_with_an_hr_specialist: "Czat ze specjalistą z zespołu HR",
		talk_to_an_hr_specialist: "Porozmawiaj ze specjalistą z zespołu HR",
		create_an_hr_case: "Utwórz zgłoszenie do zespołu HR",
		minutes: "minut",
		waiting_time_less_than_minute_text: "mniej niż 1 minuta",
		waiting_time_minutes_text: "{{minutes}} minut",
		waiting_time_hour_text: "{{hours}} godzina",
		waiting_time_more_than_hours_text: "więcej niż {{hours}} godz.",
		few_days: "1-2 dni",
		landing_page_heading: "Pomoc w ramach ${category}",
		landing_page_subheading: "Połącz się z HR {{availableChannels}}.",
		subheading_chat_text: "przez czat na żywo",
		subheading_call_text: "przez telefon",
		subheading_case_text: "przez utworzenie wniosku",
		or_connector: "albo",
		create_case_description: "Jeśli nie potrzebujesz natychmiastowej pomocy, utwórz wniosek.",
		next_hours_of_operation: "Następna pomoc dostępna od {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Następna sesja wsparcia dostępna od {{startDay}} {{startTime}} do {{endDay}} {{endTime}}",
		time_in_am: "{{time}} rano",
		time_in_pm: "{{time}} po południu",
		download_transcript_error: "Nie udało się pobrać transkrypcji. Spróbuj ponownie.",
		download_attachment_error: "Nie udało się pobrać załącznika. Spróbuj ponownie.",
		sent_message_error: "Nie można wysłać wiadomości z powodu awarii sieci. Sprawdź sieć i spróbuj ponownie.",
		get_contact_channels_failure: "Nie udało się uzyskać dostępu do kanałów. Spróbuj ponownie.",
		select_a_file: "Wybierz plik",
		external_disable_message: "Dostępne w sieci Amazon",
		required_field: "Pole wymagane",
		end_chat_modal_text: "Spowoduje to zakończenie sesji czatu na żywo z zespołem HR.",
		end_chat_modal_title: "Zakończyć czat?",
		download_transcript: "Pobierz transkrypcję",
		new_live_chat_session: "Nowa sesja czatu na żywo",
		live_chat_with_HR: "Czat na żywo z zespołem HR",
		chat_header_title: "Witamy na czacie na żywo z HR",
		chat_header_subtitle_key: "Wybrany temat",
		chat_session_started: "Rozpoczęto czat",
		chat_session_ended: "Sesja czatu została zakończona",
		chat_wait_system_message: "Proszę czekać, aż połączymy Cię z agentem czatu na żywo.",
		chat_waitTime_system_message: "Szacowany czas oczekiwania to",
		chat_info_system_message: "Sesja czatu pozostanie połączona nawet po opuszczeniu tego okna.",
		chat_agent_typing_message: "Agent wsparcia pisze",
		livechat_warning_banner: "Twój czat na żywo z sesją HR rozłączy się w ciągu {{minutes}} minut",
		no_available_channel: "W tej chwili nie są dostępne żadne kanały. W tej chwili skorzystaj z opcji Żadna z powyższych odpowiedzi.",
		chat_input_footer_label: "Wiadomość",
		business_days: "Liczba dni roboczych: {{days}}",
		business_day: "{{day}} dzień roboczy",
		file_size_limit: "Rozmiar pliku powinien być mniejszy niż 20 MB.",
		generic_error_message: "Coś poszło nie tak. Spróbuj ponownie.",
		one_field_reqd_error: "Do przesłania formularza ankiety wymagane jest co najmniej 1 pole.",
		send_survey: "Wyślij ankietę",
		upload_error_access_denied: "Odmowa uprawnień dostępu.",
		upload_error_internal_server_exception: "Wystąpił problem z obsługą Twojego wniosku, spróbuj ponownie.",
		upload_error_service_quota_exceeded: "Osiągnięto maksymalny limit 5 załączników.",
		upload_error_throttling: "Wystąpił problem z obsługą Twojego wniosku, spróbuj ponownie.",
		upload_error_validation: "Typ pliku załącznika nie jest obsługiwany.",
		upload_error_generic: "Nie można przesłać załącznika",
		not_allowed_destination: "Połączenia wychodzące z numerem docelowym nie są dozwolone",
		call_not_allowed: "Nie można odebrać połączenia z tym numerem",
		check_country_code: "Upewnij się, że na początku numeru znajduje się kod kraju.",
		try_different_number: "Wypróbuj inny numer.",
		Sunday: "niedziela",
		Monday: "poniedziałek",
		Tuesday: "wtorek",
		Wednesday: "środa",
		Thursday: "czwartek",
		Friday: "Piątek",
		Saturday: "sobota",
		recommended_words_error_text: "Liczba wpisanych słów: {{wordCount}}. Maksymalna dozwolona liczba słów: {{wordLimit}}.",
		recommended_words_text: "Liczba wprowadzonych słów: {{wordCount}}. Wymagana liczba słów: nie więcej niż {{wordLimit}}.",
		stay_connected: "Pozostań w kontakcie",
		chat_open_error_modal_text: "Masz już otwarty czat, zamknij go, aby rozpocząć nowy.",
		chat_open_error_modal_title: "Czat jest już otwarty",
		previous_chat_history: "Historia poprzedniego czatu",
		choose_chat_history: "Wybierz historię czatów",
		no_chat_records_available: "Nie znaleziono poprzednich rekordów czatu. Przejdź do LiveChat, aby porozmawiać z agentem",
		empty_chat_present: "Brak rozmowy w tej sesji czatu",
		language_support_text: "Obecnie pracujemy nad poprawą Twojego komfortu. Na razie możesz uzyskać dostęp do samoobsługowego portalu z usługami dla osób niepełnosprawnych i z problemami zdrowotnymi tylko w języku angielskim.",
		english_language_only_text: "Tylko język angielski",
		invalid_message_contraint_error: "Przekroczono limit znaków. Dozwolone są maksymalnie 1024 znaki",
		loading_error: "Wystąpił błąd podczas ładowania tego ekranu. Spróbuj ponownie za kilka minut.",
		loading_error_text: "Błąd ładowania.",
		maximize_chat_history: "Maksymalizuj historię czatów",
		minimize_chat_history: "Minimalizuj historię czatów",
		need_more_help: "Potrzebujesz pomocy?",
		erc_number_message: "Aby uzyskać natychmiastowe wsparcie, możesz połączyć się z HR pod adresem:",
		get_started: "Pierwsze kroki",
		self_service_content_error: "Wystąpił problem podczas ładowania treści samoobsługowych. Użyj przycisku „Pierwsze kroki”, aby zainicjować samoobsługowy przepływ pracy.",
		describe_issue_title: "Opisz problem, aby uzyskać połączenie z agentem pomocy technicznej",
		record_chat_session: "Twoja sesja czatu może być nagrywana w celach jakościowych lub szkoleniowych.",
		idleness_disconnect_message: "Twój czat zostanie rozłączony, jeśli będziesz w stanie bezczynności lub nie udzielisz odpowiedzi przez ponad {{minutes}} min.",
		userinput_box_hint_text: "W czym potrzebujesz pomocy?",
		get_help: "Uzyskaj pomoc",
		connect_with_hr_by_chat_phone_request: "Połącz się z HR przez czat na żywo, telefon lub przez utworzenie wniosku.",
		myhr_contact_us: "MyHR | Skontaktuj się z nami",
		not_able_to_get_live_help: "W tej chwili nie jesteśmy w stanie uzyskać dostępnych dla Ciebie opcji pomocy na żywo. Odwiedź witrynę myHR, aby uzyskać dodatkową pomoc",
		chat_transcript_opt_in_modal_content: "Zatrudniająca Cię jednostka organizacyjna Amazon chce przechowywać ten czat ze względów jakościowych i szkoleniowych oraz dla celów związanych z prowadzeniem dokumentacji. Aby wyrazić zgodę, kliknij Zgoda. Aby odrzucić, kliknij Odrzuć. Aby uzyskać dodatkowe informacje o wykorzystywaniu przez nas Twoich danych osobowych, w tym o prawie do wycofania zgody, zapoznaj się z Polityką prywatności dla pracowników Amazon w witrynie Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Wyrażasz zgodę na transkrypcję czatu?",
		chat_transcript_opt_in_consent: "Zgoda",
		chat_transcript_opt_in_decline: "Odrzuć",
		connect_to_provider: "Połączyć Cię z dostawcą zewnętrznym?",
		your_information: "Twoje informacje",
		all_feilds_are_required: "Wszystkie pola są wymagane.",
		name: "Imię i nazwisko",
		email: "E-mail",
		phoneNumber: "Numer telefonu",
		"continue": "Kontynuuj",
		please_provide_valid: "Podaj poprawną wartość",
		to_start_live_chat_click_continue: "Aby rozpocząć sesję czatu na żywo z lekarzem ds. zdrowia psychicznego, podaj swoje dane i wybierz Kontynuuj.",
		you_are_connected_with_a_third_party: "Nawiązano połączenie z zewnętrznym dostawcą pomocy dla pracowników (EAP).",
		to_save_transcript_download: "Aby zapisać tę transkrypcję, pobierz ją przed zamknięciem tej sesji.",
		fix_the_errors: "Napraw błędy: Nie udzielono odpowiedzi na wymagane pytania ([X]).",
		all_clinicians_busy: "Niestety wygląda na to, że wszyscy lekarze rozmawiają w tej chwili z innymi pracownikami. Wybierz Nowa sesja czatu na żywo, aby ponownie dołączyć do kolejki.",
		username: "Imię i nazwisko",
		connect_to_a_provider_outside_amazon: "Połączyć Cię z dostawcą spoza Amazon?",
		you_are_now_connected_to_confidential: "Teraz łączysz się z poufnym dostawcą zewnętrznym spoza Amazon, który wymaga podania imienia i nazwiska, numeru telefonu oraz szczegółów lokalizacji dla celów związanych z rejestracją i uwierzytelnianiem. Ta usługa jest bezpłatna i poufna.",
		no_agents: "Agenci HR są obecnie niedostępni, wypróbuj inny kanał",
		high_wait_time: "Wszyscy nasi agenci HR są w tej chwili zajęci. W międzyczasie wypróbuj inne kanały",
		by_tapping_continue_agree_wpo_terms: "Wybierając Kontynuuj, potwierdzasz, że znasz usługę Opcje miejsca pracy i wyrażasz zgodę na jej regulamin.",
		terms_and_conditions: "Regulamin",
		end_chat_modal_text_wpo: "Spowoduje to zakończenie czatu na żywo.",
		live_support_options: "Opcje wsparcia na żywo",
		open: "Otwórz",
		myhr: "My HR"
	}
};
var plPL = {
	atoz_myhr_app: atoz_myhr_app$a
};

var atoz_myhr_app$b = {
	livehelp: {
		help_eligibility_title: "Para obter ajuda com a elegibilidade da inscrição, você pode se conectar ao RH agora ou criar uma solicitação.",
		chat_title: "Chat",
		call_title: "Ligar",
		create_request: "Criar uma solicitação",
		wait_time: "Tempo de espera",
		response_time: "Tempo de resposta",
		waiting_time_minute_text: "{{minutes}} minuto",
		waiting_time_hours_text: "{{hours}} horas",
		hr_help_and_support: "Entrar em contato com o RH e gerenciar solicitações",
		call_error_processing: "Houve um erro ao processar a solicitação; tente novamente desde o início.",
		help_needed_with: "Com o que você precisa de ajuda?",
		immigration_title: "Imigração",
		disability_and_leave_title: "Deficiência e licença",
		other: "Outros",
		submit: "Enviar",
		cancel: "Cancelar",
		enter_number_title: "Digite seu número para receber uma ligação do RH.",
		request_call: "Solicitar uma chamada",
		amazon_support_contact_shortly: "Você receberá uma ligação da equipe de suporte ao funcionário da Amazon em breve.",
		confirm_preferred_phone_number: "Para solicitar uma chamada, confirme seu número de telefone e idioma preferidos",
		what_preferred_phone_no: "Qual é o seu número de telefone preferido?",
		preferred_language_text: "Qual é o seu idioma preferido?",
		what_to_expect: "O que esperar",
		call_from_agent_minutes: "Um agente ligará para você em ${minutes} minutos",
		call_from_amazon_number: "A chamada aparecerá como um número ${contactNumber} ou número anônimo",
		disconnected_agent_call_minute: "Se você for desconectado, o agente ligará de volta em 1 minuto",
		live_help_text_timekeeping_leaves_of_absence: "Para obter ajuda com a cronometragem e as ausências, você pode ligar, conversar ou criar uma solicitação",
		get_call_back: "Receber uma chamada de volta",
		request_phone_call: "Solicitar uma chamada telefônica",
		close_chat_window: "Deseja fechar a janela de chat ao vivo?",
		chat_ended: "O chat terminou.",
		idle_chat_disconnect: "Desconectado devido a inatividade",
		disconnect_from_chat: "O usuário saiu do chat. A conversa do chat terminou.",
		chat_idle_message: "O chat foi desconectado por ter ficado inativo por {{minutes}} minutos.",
		chat_extended_after_idleness: "O usuário prolongou a sessão após o aviso de inatividade.",
		surety_chat_idle_message: "Olá, só quero ter certeza de que nosso chat ainda está conectado. Ficamos ociosos por ${minutes} minutos. Nosso chat será encerrado se você não conseguir responder em 2 minutos.",
		disconnect_chat_message: "Tem certeza de que deseja se desconectar do chat?",
		supported_file_attachments: "Tipos de arquivos compatíveis para anexos de chat: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  O tamanho máximo do arquivo para um anexo de chat é de 20 MB.",
		upload_attachment: "Carregar anexo",
		choose_file_upload: "Escolha o arquivo para carregar",
		stay_Connected: "Permanecer conectado",
		disconnect: "Desconectar",
		message_input_placeholder: "Digite uma mensagem e pressione Enter para enviar",
		upload: "Carregar",
		end_chat: "Encerrar chat",
		connect: "Conectar",
		save_chat: "Salvar chat",
		connected: "Conectado",
		user_left_chat: "{{user}} saiu do chat. Sua conversa no chat terminou.",
		user_left_chat_during_transfer: "{{user}} saiu do chat. Sua chamada está sendo transferida.",
		user_joined_chat: "${user} entrou no chat",
		input_phone_number: "Digite seu número de telefone",
		time: "Tempo",
		call_from_anonymous_number: "A chamada aparecerá como um número ${contactNumber} ou número anônimo",
		extended_user_session_warning: "O usuário estendeu sua sessão após o aviso de ociosidade",
		close: "Fechar",
		okay: "OK",
		send: "Enviar",
		timer_message: "Solicite a chamada novamente após {{counter}} segundos",
		start_new_chat: "Comece um novo chat",
		open_menu: "Abrir menu",
		live_chat: "Chat ao vivo",
		end_chat_session: "Terminar sessão de chat",
		create_request_3steps: "Você pode criar uma solicitação em 3 etapas",
		available_now: "Disponível agora",
		phone: "telefone",
		minute: "minuto",
		chat_with_HR: "Chat ao vivo",
		chat_with_HR_desc: "Converse com o RH para que sua consulta seja resolvida instantaneamente",
		call_HR: "Ligar",
		call_hr_desc: "Ligue para o RH em caso de consultas críticas/urgentes",
		doc_note_due_date_ready: "Tenha um atestado médico com sua data de vencimento pronto para carregar",
		system: "SISTEMA",
		connected_with_agent: "Agora você está conectado a um agente de ajuda ao vivo",
		transferring_to_agent: "Transferindo você para um agente de ajuda ao vivo",
		days: "dias",
		request_a_call: "Solicitar uma chamada",
		request_phone_call_heading: "Para se conectar ao RH por telefone, precisamos do seu número de telefone e idioma preferidos.",
		request_phone_call_heading_2: "Para se conectar ao RH por telefone, precisamos do seu número de telefone preferido.",
		what_your_preffered_number: "Qual é o número de telefone de sua preferência (incluindo o código do país)?",
		what_your_preffered_language: "Qual é o seu idioma preferido?",
		phone_number_cannot_be_empty: "O número de telefone não pode estar em branco",
		only_numbers_allowed: "Somente números são permitidos aqui",
		receive_call_number: "Você receberá instantaneamente uma chamada de {{contactNumber}}.",
		receive_call_HR_team: "Você receberá instantaneamente uma chamada da equipe do HR Support.",
		agent_hold_with_wait_time: "Você ficará em espera e o atendente entrará em contato em ${waitTime} minutos.",
		agent_hold_without_wait_time: "Você ficará em espera e o atendente entrará em contato.",
		disconnected_agent_wait: "Se você for desconectado, o agente ligará de volta em 1 minuto.",
		call_hr_desc2: "Forneça seu número de telefone, e um especialista em suporte de RH ligará diretamente para você.",
		create_hr_request: "Solicitação",
		chat_with_an_hr_specialist: "Converse com um especialista em RH",
		talk_to_an_hr_specialist: "Fale com um especialista em RH",
		create_an_hr_case: "Criar um caso de RH",
		minutes: "minutos",
		waiting_time_less_than_minute_text: "menos de 1 minuto",
		waiting_time_minutes_text: "{{minutes}} minutos",
		waiting_time_hour_text: "{{hours}} hora",
		waiting_time_more_than_hours_text: "mais de {{hours}} horas",
		few_days: "1-2 dias",
		landing_page_heading: "Ajuda com ${category}",
		landing_page_subheading: "Entre em contato com o RH {{availableChannels}}.",
		subheading_chat_text: "por chat ao vivo",
		subheading_call_text: "por telefone",
		subheading_case_text: "criando uma solicitação",
		or_connector: "ou",
		create_case_description: "Se você não precisar de ajuda imediata, crie uma solicitação.",
		next_hours_of_operation: "Próximo suporte disponível a partir de {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Próximo suporte disponível em {{startDay}} {{startTime}} – {{endDay}} {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Falha ao baixar a transcrição. Tente novamente.",
		download_attachment_error: "Falha ao baixar o anexo. Tente novamente.",
		sent_message_error: "Não foi possível enviar a mensagem devido à interrupção na rede. Verifique a rede e tente novamente.",
		get_contact_channels_failure: "Falha ao obter os canais disponíveis. Tente novamente.",
		select_a_file: "Selecionar um arquivo",
		external_disable_message: "Acessível dentro da rede Amazon",
		required_field: "Campo obrigatório",
		end_chat_modal_text: "Essa ação terminará a sessão de chat ao vivo com o RH.",
		end_chat_modal_title: "Terminar o chat?",
		download_transcript: "Baixar a transcrição",
		new_live_chat_session: "Nova sessão de chat ao vivo",
		live_chat_with_HR: "Chat ao vivo com o RH",
		chat_header_title: "Bem-vindo(a) ao chat ao vivo com o RH",
		chat_header_subtitle_key: "Tópico selecionado",
		chat_session_started: "Sessão de chat iniciada",
		chat_session_ended: "Sessão de chat terminada",
		chat_wait_system_message: "Aguarde enquanto conectamos você a um atendente do chat ao vivo.",
		chat_waitTime_system_message: "O tempo de espera estimado é de",
		chat_info_system_message: "A sessão de chat permanecerá conectada mesmo que você saia desta janela.",
		chat_agent_typing_message: "O atendente de suporte está digitando",
		livechat_warning_banner: "A sessão de chat ao vivo com o RH será desconectada em {{minutes}} minutos",
		no_available_channel: "Nenhum canal está disponível no momento. Desta vez, use a opção Outros.",
		chat_input_footer_label: "Sua mensagem",
		business_days: "{{days}} dias úteis",
		business_day: "{{day}} dia útil",
		file_size_limit: "O arquivo deve ter menos de 20 MB.",
		generic_error_message: "Algo deu errado. Tente novamente.",
		one_field_reqd_error: "É necessário, pelo menos, 1 campo para enviar o formulário de pesquisa.",
		send_survey: "Enviar a pesquisa",
		upload_error_access_denied: "Permissão de acesso negada.",
		upload_error_internal_server_exception: "Houve um problema para atender à solicitação; tente novamente.",
		upload_error_service_quota_exceeded: "O limite máximo de cinco anexos foi atingido.",
		upload_error_throttling: "Houve um problema para atender à solicitação; tente novamente.",
		upload_error_validation: "O tipo de arquivo anexado não é compatível.",
		upload_error_generic: "Não foi possível carregar o anexo",
		not_allowed_destination: "Não são permitidas chamadas de saída para o número de destino",
		call_not_allowed: "Não é possível receber a chamada neste número",
		check_country_code: "Verifique se o código do país foi adicionado antes do número.",
		try_different_number: "Tente usar outro número.",
		Sunday: "Domingo",
		Monday: "Segunda-feira",
		Tuesday: "Terça-feira",
		Wednesday: "Quarta-feira",
		Thursday: "Quinta-feira",
		Friday: "Sexta-feira",
		Saturday: "Sábado",
		recommended_words_error_text: "{{wordCount}} palavras inseridas. São permitidas até {{wordLimit}} palavras",
		recommended_words_text: "{{wordCount}} palavras inseridas. São permitidas até {{wordLimit}} ou menos",
		stay_connected: "Permanecer conectado",
		chat_open_error_modal_text: "Uma sessão de chat já está aberta; feche-a para iniciar outra.",
		chat_open_error_modal_title: "O chat já está aberto",
		previous_chat_history: "Histórico do chat anterior",
		choose_chat_history: "Selecionar o histórico de chat",
		no_chat_records_available: "Nenhum registro de chat anterior foi encontrado. Ir para o chat ao vivo para conversar com o atendente",
		empty_chat_present: "Nenhuma conversa nesta sessão de chat",
		language_support_text: "Estamos trabalhando para melhorar sua experiência. Por enquanto, é possível acessar o portal de autoatendimento do Disability and Leave Services em inglês.",
		english_language_only_text: "Somente em inglês",
		invalid_message_contraint_error: "Limite de caracteres excedido. São permitidos no máximo 1024 caracteres",
		loading_error: "Ocorreu um erro ao carregar esta tela. Tente novamente em alguns minutos.",
		loading_error_text: "Erro de carregamento.",
		maximize_chat_history: "Maximizar o histórico de chats",
		minimize_chat_history: "Minimizar o histórico de chats",
		need_more_help: "Precisa de mais ajuda?",
		erc_number_message: "Para obter suporte imediato, conecte-se com o RH em:",
		get_started: "Começar",
		self_service_content_error: "Houve um problema ao carregar o conteúdo de autoatendimento. Use o botão “Começar” para iniciar o fluxo de trabalho de autoatendimento.",
		describe_issue_title: "Descreva seu problema para se conectar com um agente de suporte",
		record_chat_session: "Sua sessão de chat pode ser gravada para fins de qualidade ou treinamento.",
		idleness_disconnect_message: "Seu chat será desconectado se você ficar inativo por mais de {{minutes}} minutos ou não responder.",
		userinput_box_hint_text: "Com o que você precisa de ajuda?",
		get_help: "Obter ajuda",
		connect_with_hr_by_chat_phone_request: "Conecte-se com o RH por chat ao vivo, telefone ou criando uma solicitação.",
		myhr_contact_us: "My HR | Fale conosco",
		not_able_to_get_live_help: "Não é possível obter as opções de suporte de ajuda ao vivo para você no momento. Acesse MyHR para obter ajuda adicional",
		chat_transcript_opt_in_modal_content: "Sua entidade empregadora da Amazon gostaria de armazenar este chat para fins de qualidade e treinamento e manutenção de registros. Para consentir, clique em Consentir. Para recusar, clique em Recusar. Para receber mais informações sobre como tratamos seus dados pessoais, incluindo seu direito de retirar o consentimento, consulte o Aviso de Privacidade para o Funcionário da Amazon.",
		chat_transcript_opt_in_modal_title: "Aceitar a transcrição do chat?",
		chat_transcript_opt_in_consent: "Consentir",
		chat_transcript_opt_in_decline: "Recusar",
		connect_to_provider: "Conectar-se a um prestador de serviços terceirizado?",
		your_information: "Suas informações",
		all_feilds_are_required: "Todos os campos são obrigatórios.",
		name: "Nome",
		email: "E-mail",
		phoneNumber: "Número de telefone",
		"continue": "Continuar",
		please_provide_valid: "Forneça um valor válido",
		to_start_live_chat_click_continue: "Para iniciar sua sessão de chat ao vivo com um médico especializado em saúde mental, forneça suas informações e toque em Continuar.",
		you_are_connected_with_a_third_party: "Você está conectado com um prestador de serviços de apoio ao funcionário (EAP) terceirizado.",
		to_save_transcript_download: "Para salvar essa transcrição, baixe-a antes de encerrar a sessão.",
		fix_the_errors: "Corrija os erros: Você não respondeu às [X] perguntas obrigatórias.",
		all_clinicians_busy: "Lamento, mas todos os médicos parecem estar ocupados com outros funcionários. Toque em Nova sessão de chat ao vivo para entrar novamente na fila.",
		username: "Nome",
		connect_to_a_provider_outside_amazon: "Conectar-se a um prestador de serviços fora da Amazon?",
		you_are_now_connected_to_confidential: "Agora você está se conectando a um prestador de serviços externo confidencial fora da Amazon que exige seu nome, número de telefone e detalhes de localização para se registrar e autenticar. Esse serviço é gratuito e confidencial.",
		no_agents: "Os agentes de RH não estão disponíveis no momento, tente outro canal",
		high_wait_time: "Todos os nossos agentes de RH estão ocupados no momento. Enquanto isso, tente outros canais",
		by_tapping_continue_agree_wpo_terms: "Ao tocar em Continuar, você confirma que leu e concorda com o serviço Workplace Options",
		terms_and_conditions: "Termos e condições",
		end_chat_modal_text_wpo: "Isso encerrará o chat ao vivo.",
		live_support_options: "Opções de suporte em tempo real",
		open: "Abrir",
		myhr: "My HR"
	}
};
var ptBR = {
	atoz_myhr_app: atoz_myhr_app$b
};

var atoz_myhr_app$c = {
	livehelp: {
		help_eligibility_title: "Pentru a primi ajutor în legătură cu eligibilitatea aplicației te poți conecta acum cu departamentul HR sau poți crea o solicitare.",
		chat_title: "Chat",
		call_title: "Apel",
		create_request: "Creează o solicitare",
		wait_time: "Timp de așteptare",
		response_time: "Timp de răspuns",
		waiting_time_minute_text: "{{minutes}} minut",
		waiting_time_hours_text: "{{hours}} ore",
		hr_help_and_support: "Contactează departamentul HR și gestionează solicitările",
		call_error_processing: "A apărut o eroare la procesarea solicitării tale, te rugăm să încerci din nou de la început.",
		help_needed_with: "În legătură cu ce ai nevoie de ajutor?",
		immigration_title: "Imigrare",
		disability_and_leave_title: "Dizabilitate și concediu",
		other: "Altele",
		submit: "Trimitere",
		cancel: "Anulare",
		enter_number_title: "Introdu numărul tău pentru a primi un apel de la departamentul HR.",
		request_call: "Solicită un apel",
		amazon_support_contact_shortly: "Vei primi un apel de la echipa de asistență a angajaților Amazon în scurt timp.",
		confirm_preferred_phone_number: "Pentru a solicita un apel, confirmă numărul tău de telefon și limba ta preferată",
		what_preferred_phone_no: "Care e numărul tău de telefon preferat?",
		preferred_language_text: "Care e limba ta preferată?",
		what_to_expect: "La ce să te aștepți",
		call_from_agent_minutes: "Un agent te va suna în ${minutes} minute",
		call_from_amazon_number: "Apelul va apărea fie ca un ${contactNumber}, fie ca număr anonim",
		disconnected_agent_call_minute: "Dacă te vei deconecta, agentul te va suna înapoi în mai puțin de 1 minut",
		live_help_text_timekeeping_leaves_of_absence: "Pentru a primi ajutor în legătură cu pontajul și cu concediul, poți apela, poți discuta sau poți crea o solicitare",
		get_call_back: "Primești un apel înapoi",
		request_phone_call: "Solicită un apel telefonic",
		close_chat_window: "Dorești să închizi fereastra Live Chat?",
		chat_ended: "Chatul s-a încheiat.",
		idle_chat_disconnect: "Deconectat din cauza inactivității",
		disconnect_from_chat: "Utilizatorul a părăsit chatul. Conversația din chat s-a încheiat.",
		chat_idle_message: "Chatul a fost deconectat din cauza faptului că a fost inactiv timp de {{minutes}} minute.",
		chat_extended_after_idleness: "Utilizatorul și-a extins sesiunea după avertismentul de inactivitate.",
		surety_chat_idle_message: "Bună, vreau doar să mă asigur că chatul nostru a rămas conectat. Am fost inactiv pentru ${minutes} minute. Chatul nostru se va încheia dacă nu poți răspunde în 2 minute.",
		disconnect_chat_message: "Ești sigur că vrei să te deconectezi de la chat?",
		supported_file_attachments: "Tipuri de fișiere acceptate pentru atașamentele de chat: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Dimensiunea maximă a fișierului pentru un atașament de chat este de 20 MB.",
		upload_attachment: "Încarcă atașamentul",
		choose_file_upload: "Alege fișierul pentru încărcare",
		stay_Connected: "Rămâi conectat",
		disconnect: "Deconectează-te",
		message_input_placeholder: "Tastează un mesaj și apasă enter pentru a-l trimite",
		upload: "Încarcă",
		end_chat: "Închide chatul",
		connect: "Conectează-te",
		save_chat: "Salvează chatul",
		connected: "Conectat",
		user_left_chat: "{{user}} a părăsit chatul. Conversația ta din chat s-a încheiat.",
		user_left_chat_during_transfer: "{{user}} a părăsit chatul. Ești transferat.",
		user_joined_chat: "${user} a intrat în chat",
		input_phone_number: "Introdu numărul tău de telefon",
		time: "Oră",
		call_from_anonymous_number: "Apelul va apărea fie ca un ${contactNumber}, fie ca număr anonim",
		extended_user_session_warning: "Utilizatorul și-a extins sesiunea după avertismentul de inactivitate",
		close: "Închide",
		okay: "Bine",
		send: "Trimite",
		timer_message: "Solicită apel din nou după {{counter}} de secunde",
		start_new_chat: "Deschide un nou Chat",
		open_menu: "Deschide meniul",
		live_chat: "Chat live",
		end_chat_session: "Terminare sesiune de chat",
		create_request_3steps: "Poți crea o solicitare în 3 pași",
		available_now: "Disponibil acum",
		phone: "telefon",
		minute: "minut",
		chat_with_HR: "Chat live",
		chat_with_HR_desc: "Discută pe chat cu un reprezentant HR pentru a îți rezolva imediat solicitarea",
		call_HR: "Apel",
		call_hr_desc: "Apelează un reprezentant de la HR pentru interogări critice/urgente",
		doc_note_due_date_ready: "Să ai o notă de la medic cu data scadentă gata de încărcare",
		system: "SISTEM",
		connected_with_agent: "Acum ești conectat cu un agent de la ajutorul live",
		transferring_to_agent: "Transfer către un agent de ajutor live",
		days: "zile",
		request_a_call: "Solicită un apel",
		request_phone_call_heading: "Pentru a te conecta cu departamentul HR prin telefon, avem nevoie de numărul tău de telefon și de limba ta preferată.",
		request_phone_call_heading_2: "Pentru a te conecta cu departamentul HR prin telefon, avem nevoie de numărul tău de telefon preferat.",
		what_your_preffered_number: "Care este numărul tău de telefon preferat (inclusiv codul de țară)?",
		what_your_preffered_language: "Care e limba ta preferată?",
		phone_number_cannot_be_empty: "Numărul de telefon nu poate fi gol",
		only_numbers_allowed: "Aici sunt permise doar numerele",
		receive_call_number: "Vei primi instantaneu un apel de la {{contactNumber}}.",
		receive_call_HR_team: "Vei primi instantaneu un apel de la echipa HR Support.",
		agent_hold_with_wait_time: "Vei fi pus în așteptare și agentul se va conecta cu tine în ${waitTime} de minute.",
		agent_hold_without_wait_time: "Vei fi pus în așteptare și agentul se va conecta cu tine.",
		disconnected_agent_wait: "Dacă te vei deconecta, agentul te va suna înapoi în mai puțin de 1 minut.",
		call_hr_desc2: "Furnizează-ne numărul tău de telefon și un specialist HR Support te va suna direct.",
		create_hr_request: "Solicitare",
		chat_with_an_hr_specialist: "Discută cu un specialist HR",
		talk_to_an_hr_specialist: "Vorbește cu un specialist HR",
		create_an_hr_case: "Creează un caz HR",
		minutes: "minute",
		waiting_time_less_than_minute_text: "mai puțin de 1 minut",
		waiting_time_minutes_text: "{{minutes}} minute",
		waiting_time_hour_text: "{{hours}} oră",
		waiting_time_more_than_hours_text: "mai mult de {{hours}} ore",
		few_days: "1-2 zile",
		landing_page_heading: "Ajutor în legătură cu ${category}",
		landing_page_subheading: "Conectează-te cu departamentul HR {{availableChannels}}.",
		subheading_chat_text: "prin chatul live",
		subheading_call_text: "prin telefon",
		subheading_case_text: "prin crearea unei solicitări",
		or_connector: "sau",
		create_case_description: "Dacă nu ai nevoie de ajutor imediat, creează o solicitare.",
		next_hours_of_operation: "Următorul suport va fi disponibil de la {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Următoarea asistență este disponibilă de la {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Eșec la descărcarea transcrierii. Încercați din nou.",
		download_attachment_error: "Descărcarea atașamentului nu a reușit. Încercați din nou.",
		sent_message_error: "Nu se poate trimite mesajul din cauza întreruperii rețelei. Te rugăm să verifici rețeaua și să încerci din nou.",
		get_contact_channels_failure: "Nu s-au putut obține canalele disponibile. Încercați din nou.",
		select_a_file: "Selectează un fișier",
		external_disable_message: "Accesibil în interiorul rețelei Amazon",
		required_field: "Câmp obligatoriu",
		end_chat_modal_text: "Acest lucru va încheia chatul live din sesiunea cu departamentul HR.",
		end_chat_modal_title: "Închizi chatul?",
		download_transcript: "Descarcă transcrierea",
		new_live_chat_session: "Sesiune de chat live nouă",
		live_chat_with_HR: "Chat live cu departamentul HR",
		chat_header_title: "Bine ai venit la Chatul live cu departamentul HR",
		chat_header_subtitle_key: "Subiect selectat",
		chat_session_started: "Sesiunea de chat a început",
		chat_session_ended: "Sesiunea de chat s-a încheiat",
		chat_wait_system_message: "Te rugăm să aștepți în timp ce te conectăm la un agent de chat live.",
		chat_waitTime_system_message: "Timpul estimat de așteptare este de",
		chat_info_system_message: "Sesiunea ta de chat va rămâne conectată chiar dacă părăsești această fereastră.",
		chat_agent_typing_message: "Agentul de suport tastează",
		livechat_warning_banner: "Chatul tău live din sesiunea cu departamentul HR se va deconecta în {{minutes}} de minute",
		no_available_channel: "Momentan nu sunt disponibile canale. Te rugăm să folosești opțiunea Altceva în acest moment.",
		chat_input_footer_label: "Mesajul tău",
		business_days: "{{days}} zile lucrătoare",
		business_day: "{{day}} zi lucrătoare",
		file_size_limit: "Dimensiunea fișierului trebuie să fie mai mică de 20MB.",
		generic_error_message: "Ceva nu a mers cum trebuie. Încercați din nou.",
		one_field_reqd_error: "Cel puțin 1 câmp este necesar pentru a trimite formularul sondajului.",
		send_survey: "Trimite chestionarul",
		upload_error_access_denied: "Permisiunea de acces a fost refuzată.",
		upload_error_internal_server_exception: "A apărut o problemă de serviciu cu solicitarea ta, te rugăm să încerci din nou.",
		upload_error_service_quota_exceeded: "Limita maximă de 5 atașamente a fost atinsă.",
		upload_error_throttling: "A apărut o problemă de serviciu cu solicitarea ta, te rugăm să încerci din nou.",
		upload_error_validation: "Tipul de fișier pentru atașament nu este acceptat.",
		upload_error_generic: "Nu se poate încărca atașamentul",
		not_allowed_destination: "Apelurile de ieșire către numărul de destinație nu sunt permise",
		call_not_allowed: "Apelul nu poate fi primit pe acest număr",
		check_country_code: "Asigură-te că ai adăugat codul țării la începutul numărului.",
		try_different_number: "Încearcă un număr diferit.",
		Sunday: "Duminică",
		Monday: "Luni",
		Tuesday: "Marți",
		Wednesday: "Miercuri",
		Thursday: "Joi",
		Friday: "Vineri",
		Saturday: "Sâmbătă",
		recommended_words_error_text: "{{wordCount}} cuvinte introduse. Sunt permise până la {{wordLimit}} cuvinte",
		recommended_words_text: "{{wordCount}} cuvinte introduse. Sunt necesare {{wordLimit}} sau mai puține.",
		stay_connected: "Rămâi conectat",
		chat_open_error_modal_text: "Ai deja un chat deschis, te rugăm să-l închizi pentru a deschide un chat nou.",
		chat_open_error_modal_title: "Chatul este deja deschis",
		previous_chat_history: "Istoricul conversațiilor anterioare",
		choose_chat_history: "Alege Istoricul conversațiilor",
		no_chat_records_available: "Nu au fost găsite înregistrări de chat anterioare. Continuă cu LiveChat pentru a discuta cu agentul",
		empty_chat_present: "Nu este nicio conversație în această sesiune de chat",
		language_support_text: "În prezent lucrăm pentru a-ți îmbunătăți experiența. Deocamdată poți accesa portalul cu autoservire Disability and Leave Services în limba engleză.",
		english_language_only_text: "Numai în limba engleză",
		invalid_message_contraint_error: "Limita de caractere este depășită. Sunt permise maxim 1024 de caractere",
		loading_error: "A apărut o eroare la încărcarea acestui ecran. Încercați din nou în câteva minute.",
		loading_error_text: "A apărut o eroare la încărcare.",
		maximize_chat_history: "Maximizează istoricul conversațiilor",
		minimize_chat_history: "Minimizează istoricului conversațiilor",
		need_more_help: "Ai nevoie de mai mult ajutor?",
		erc_number_message: "Pentru asistență imediată, te poți conecta cu HR la:",
		get_started: "Începe",
		self_service_content_error: "A apărut o problemă în timpul încărcării conținutului de autoservire. Te rugăm să folosești butonul „Începe” pentru a iniția fluxul de lucru autoservire.",
		describe_issue_title: "Descrie problema ta pentru a te conecta cu un agent de asistență",
		record_chat_session: "Sesiunea de chat poate fi înregistrată pentru îmbunătățirea calității sau pentru instruire.",
		idleness_disconnect_message: "Chatul tău va fi deconectat dacă nu ești activ sau nu răspunzi mai mult de {{minutes}} minute.",
		userinput_box_hint_text: "În legătură cu ce ai nevoie de ajutor?",
		get_help: "Obține ajutor",
		connect_with_hr_by_chat_phone_request: "Conectează-te cu HR prin chat live, telefon sau prin crearea unei solicitări.",
		myhr_contact_us: "My HR | Contactează-ne",
		not_able_to_get_live_help: "Nu putem obține opțiunile de asistență live pentru tine în acest moment. Te rugăm să consulți MyHR pentru ajutor suplimentar",
		chat_transcript_opt_in_modal_content: "Entitatea ta angajatoare Amazon ar dori să stocheze acest chat pentru îmbunătățirea calității și instruire și păstrarea înregistrărilor. Pentru a consimți, fă clic pe Consimțământ. Pentru a refuza, fă clic pe Refuzare. Pentru a primi informații suplimentare despre modul în care îți gestionăm datele personale, inclusiv dreptul tău de a-ți retrage consimțământul, consultă Notificarea privind confidențialitatea angajaților pe Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Optezi pentru transcrierea chatului?",
		chat_transcript_opt_in_consent: "Consimte",
		chat_transcript_opt_in_decline: "Refuză",
		connect_to_provider: "Te conectezi la un furnizor de serviciu terț?",
		your_information: "Informații despre tine",
		all_feilds_are_required: "Toate câmpurile sunt obligatorii.",
		name: "Nume",
		email: "E-mail",
		phoneNumber: "Număr de telefon",
		"continue": "Continuă",
		please_provide_valid: "Te rugăm să furnizezi date valide",
		to_start_live_chat_click_continue: "Pentru a începe sesiunea de chat live cu un clinician în domeniul sănătății mintale, furnizează-ți informațiile și atinge Continuă.",
		you_are_connected_with_a_third_party: "Ești conectat cu un Furnizor de serviciu terț de asistență pentru angajați (EAP).",
		to_save_transcript_download: "Pentru a salva această transcriere, descarcă transcrierea înainte de a închide această sesiune.",
		fix_the_errors: "Remediază erorile: Nu ai răspuns la [X] întrebări necesare.",
		all_clinicians_busy: "Ne pare rău, dar toți clinicienii par să fie ocupați cu alți angajați. Atinge Sesiune de chat live nouă pentru a reintra în coadă.",
		username: "Nume",
		connect_to_a_provider_outside_amazon: "Te conectezi la un furnizor de serviciu din afara Amazon?",
		you_are_now_connected_to_confidential: "Acum te conectezi la un furnizor de serviciu extern confidențial din afara Amazon, care are nevoie numele tău, numărul de telefon și detaliile locației pentru a te înregistra și a te autentifica. Acest serviciu este gratuit și confidențial.",
		no_agents: "Agenții HR nu sunt disponibili momentan, încearcă un alt canal",
		high_wait_time: "Toți agenții noștri HR sunt ocupați în acest moment. Te rugăm să încerci alte canale între timp",
		by_tapping_continue_agree_wpo_terms: "Atingând Continuare, ești de acord că ai citit și ești de acord cu serviciul Opțiuni la locul de muncă",
		terms_and_conditions: "Termeni și condiții",
		end_chat_modal_text_wpo: "Acest lucru va încheia chatul live.",
		live_support_options: "Opțiuni pentru asistență live",
		open: "Deschis",
		myhr: "My HR"
	}
};
var roRO = {
	atoz_myhr_app: atoz_myhr_app$c
};

var atoz_myhr_app$d = {
	livehelp: {
		help_eligibility_title: "Ak potrebujete pomôcť s oprávnenosťou žiadosti, môžete sa teraz spojiť s HR alebo vytvoriť požiadavku.",
		chat_title: "Chat",
		call_title: "Zavolať",
		create_request: "Vytvoriť požiadavku",
		wait_time: "Čas čakania",
		response_time: "Čas odpovede",
		waiting_time_minute_text: "{{minutes}} min",
		waiting_time_hours_text: "{{hours}} h",
		hr_help_and_support: "Kontaktujte HR a spravujte požiadavky",
		call_error_processing: "Pri spracúvaní vašej žiadosti sa vyskytla chyba, skúste to znova od začiatku.",
		help_needed_with: "S čím vám pomôžeme?",
		immigration_title: "Prisťahovanie",
		disability_and_leave_title: "Pracovná neschopnosť a voľno",
		other: "Iné",
		submit: "Odoslať",
		cancel: "Zrušiť",
		enter_number_title: "Zadajte svoje číslo, aby ste mohli prijať telefonát od HR.",
		request_call: "Požiadať o telefonát",
		amazon_support_contact_shortly: "Čoskoro sa vám telefonicky ozve tím podpory pre zamestnancov spoločnosti Amazon.",
		confirm_preferred_phone_number: "Ak chcete požiadať o telefonát, potvrďte svoje preferované telefónne číslo a jazyk",
		what_preferred_phone_no: "Aké je vaše preferované telefónne číslo?",
		preferred_language_text: "Aký je váš preferovaný jazyk?",
		what_to_expect: "Čo možno očakávať",
		call_from_agent_minutes: "Agent vám zavolá do ${minutes} minút",
		call_from_amazon_number: "Telefonát sa zobrazí buď ako ${contactNumber}, alebo ako anonymné číslo",
		disconnected_agent_call_minute: "Ak dôjde k vášmu odpojeniu, agent vám zavolá späť do 1 minúty",
		live_help_text_timekeeping_leaves_of_absence: "Ak potrebujete pomoc s meraním času a pracovnými voľnami, môžete zavolať, chatovať alebo vytvoriť požiadavku",
		get_call_back: "Zavolať mi späť",
		request_phone_call: "Požiadať o telefonát",
		close_chat_window: "Chcete zavrieť okno živého chatu?",
		chat_ended: "Chat sa skončil.",
		idle_chat_disconnect: "Došlo k odpojeniu z dôvodu nečinnosti",
		disconnect_from_chat: "Používateľ odišiel z chatu. Konverzácia cez chat sa skončila.",
		chat_idle_message: "Došlo k odpojeniu chatu, pretože ste boli nečinní {{minutes}} min.",
		chat_extended_after_idleness: "Používateľ predĺžil svoju reláciu po varovaní na nečinnosť.",
		surety_chat_idle_message: "Zdravím, iba sa chcem uistiť, že náš chat je stále pripojený. Boli sme nečinní ${minutes} min. Ak nám neodpoviete do 2 minút, náš chat sa zatvorí.",
		disconnect_chat_message: "Naozaj chcete odísť z chatu?",
		supported_file_attachments: "Podporované typy súborov pre prílohy v chate: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Veľkosť prílohy v chate nemôže prekročiť 20 MB.",
		upload_attachment: "Nahrať prílohu",
		choose_file_upload: "Vyberte súbor, ktorý chcete nahrať",
		stay_Connected: "Zostaňte v spojení",
		disconnect: "Odpojiť",
		message_input_placeholder: "Zadajte správu a stlačením klávesu Enter ju odošlite",
		upload: "Nahrať",
		end_chat: "Ukončiť chat",
		connect: "Pripojiť",
		save_chat: "Uložiť chat",
		connected: "Pripojené",
		user_left_chat: "Používateľ {{user}} odišiel z chatu. Vaša konverzácia cez chat sa skončila.",
		user_left_chat_during_transfer: "Používateľ {{user}} odišiel z chatu. Prepájame vás.",
		user_joined_chat: "Používateľ ${user} sa pripojil k chatu",
		input_phone_number: "Zadajte svoje telefónne číslo",
		time: "Čas",
		call_from_anonymous_number: "Telefonát sa zobrazí buď ako ${contactNumber}, alebo ako anonymné číslo",
		extended_user_session_warning: "Používateľ predĺžil svoju reláciu po varovaní na nečinnosť",
		close: "Zavrieť",
		okay: "Dobre",
		send: "Odoslať",
		timer_message: "Požiadajte o ďalší telefonát po {{counter}} sekundách",
		start_new_chat: "Začať nový chat",
		open_menu: "Otvoriť ponuku",
		live_chat: "Živý chat",
		end_chat_session: "Ukončiť reláciu chatu",
		create_request_3steps: "Požiadavka sa dá vytvoriť v 3 krokoch",
		available_now: "Teraz k dispozícii",
		phone: "telefón",
		minute: "minúta",
		chat_with_HR: "Živý chat",
		chat_with_HR_desc: "Chatujte s HR, aby ste svoj dotaz vyriešili okamžite",
		call_HR: "Zavolať",
		call_hr_desc: "V prípade kritických/naliehavých otázok oddeleniu HR zavolajte",
		doc_note_due_date_ready: "Pripravte si na nahratie potvrdenie od lekára s dátumom",
		system: "SYSTÉM",
		connected_with_agent: "Teraz ste spojení s agentom živej podpory",
		transferring_to_agent: "Prepájame vás na agenta živej podpory",
		days: "dni",
		request_a_call: "Požiadať o telefonát",
		request_phone_call_heading: "Ak sa chcete spojiť s HR telefonicky, potrebujeme, aby ste uviedli svoje preferované telefónne číslo a jazyk.",
		request_phone_call_heading_2: "Ak sa chcete spojiť s HR telefonicky, potrebujeme, aby ste uviedli svoje preferované telefónne číslo.",
		what_your_preffered_number: "Aké je vaše preferované telefónne číslo (vrátane medzinárodnej predvoľby krajiny)?",
		what_your_preffered_language: "Aký je váš preferovaný jazyk?",
		phone_number_cannot_be_empty: "Pole s telefónnym číslom nemôže byť prázdne",
		only_numbers_allowed: "Tu sú povolené len čísla",
		receive_call_number: "Okamžite vám zavoláme z čísla {{contactNumber}}.",
		receive_call_HR_team: "Okamžite vám zavolá tím podpory HR.",
		agent_hold_with_wait_time: "Budete v poradí a agent sa s vami spojí do ${waitTime} minút.",
		agent_hold_without_wait_time: "Budete v poradí a agent sa s vami spojí.",
		disconnected_agent_wait: "Ak dôjde k vášmu odpojeniu, agent vám zavolá späť do 1 minúty.",
		call_hr_desc2: "Zadajte svoje telefónne číslo a špecialista podpory HR vám zavolá priamo.",
		create_hr_request: "Požiadavka",
		chat_with_an_hr_specialist: "Chatujte s HR špecialistom",
		talk_to_an_hr_specialist: "Porozprávajte sa s HR špecialistom",
		create_an_hr_case: "Vytvoriť prípad HR",
		minutes: "minúty",
		waiting_time_less_than_minute_text: "menej ako 1 minúta",
		waiting_time_minutes_text: "{{minutes}} min",
		waiting_time_hour_text: "{{hours}} h",
		waiting_time_more_than_hours_text: "viac ako {{hours}} h",
		few_days: "1 – 2 dni",
		landing_page_heading: "Pomoc s: ${category}",
		landing_page_subheading: "Spojte sa s HR {{availableChannels}}.",
		subheading_chat_text: "prostredníctvom živého chatu",
		subheading_call_text: "telefonicky",
		subheading_case_text: "vytvorením požiadavky",
		or_connector: "alebo",
		create_case_description: "Ak nepotrebujete okamžitú pomoc, vytvorte požiadavku.",
		next_hours_of_operation: "Ďalšia podpora je k dispozícii: {{day}} od {{startTime}} do {{endTime}}",
		next_hours_of_operation_with_days: "Ďalšia podpora je k dispozícii: od {{startDay}} {{startTime}} do {{endDay}} {{endTime}}",
		time_in_am: "{{time}} dop.",
		time_in_pm: "{{time}} pop.",
		download_transcript_error: "Prepis sa nepodarilo stiahnuť. Skúste to znova.",
		download_attachment_error: "Prílohu sa nepodarilo stiahnuť. Skúste to znova.",
		sent_message_error: "Správu nie je možné odoslať z dôvodu výpadku siete. Skontrolujte pripojenie k sieti a skúste to znova.",
		get_contact_channels_failure: "Nepodarilo sa získať dostupné kanály. Skúste to znova.",
		select_a_file: "Vybrať súbor",
		external_disable_message: "K dispozícii v sieti Amazon",
		required_field: "Povinné pole",
		end_chat_modal_text: "Týmto sa ukončí vaša relácia živého chatu s HR.",
		end_chat_modal_title: "Chcete ukončiť chat?",
		download_transcript: "Stiahnuť prepis",
		new_live_chat_session: "Nová relácia živého chatu",
		live_chat_with_HR: "Živý chat s HR",
		chat_header_title: "Víta vás živý chat s HR",
		chat_header_subtitle_key: "Téma je vybratá",
		chat_session_started: "Relácia chatu sa začala",
		chat_session_ended: "Relácia chatu sa skončila",
		chat_wait_system_message: "Počkajte, kým vás spojíme s agentom živého chatu.",
		chat_waitTime_system_message: "Odhadovaný čas čakania je",
		chat_info_system_message: "Vaša relácia chatu zostane pripojená, aj keď odídete z tohto okna.",
		chat_agent_typing_message: "Agent podpory píše",
		livechat_warning_banner: "Vaša relácia živého chatu s HR sa skončí o {{minutes}} min",
		no_available_channel: "Momentálne nie sú k dispozícii žiadne kanály. Použite teraz možnosť Niečo iné.",
		chat_input_footer_label: "Vaša správa",
		business_days: "{{days}}prac. d.",
		business_day: "{{day}} pracovný deň",
		file_size_limit: "Veľkosť súboru by nemala prekročiť 20 MB.",
		generic_error_message: "Vyskytla sa chyba. Skúste to znova.",
		one_field_reqd_error: "Na odoslanie formulára prieskumu je potrebné vyplniť aspoň 1 pole.",
		send_survey: "Odoslať prieskum",
		upload_error_access_denied: "Povolenie na prístup bolo zamietnuté.",
		upload_error_internal_server_exception: "Pri spracúvaní vašej požiadavky sa vyskytol problém so službou, skúste to znova.",
		upload_error_service_quota_exceeded: "Dosiahli ste maximálny limit 5 príloh.",
		upload_error_throttling: "Pri spracúvaní vašej požiadavky sa vyskytol problém so službou, skúste to znova.",
		upload_error_validation: "Typ súboru prílohy nie je podporovaný.",
		upload_error_generic: "Prílohu sa nepodarilo nahrať",
		not_allowed_destination: "Odchádzajúce telefonáty na cieľové číslo nie sú povolené",
		call_not_allowed: "Na tomto čísle nie je možné prijať telefonát",
		check_country_code: "Uistite sa, že ste za začiatku čísla uviedli medzinárodnú predvoľbu krajiny.",
		try_different_number: "Skúste použiť iné číslo.",
		Sunday: "Nedeľa",
		Monday: "Pondelok",
		Tuesday: "Utorok",
		Wednesday: "Streda",
		Thursday: "Štvrtok",
		Friday: "Piatok",
		Saturday: "Sobota",
		recommended_words_error_text: "Zadali ste {{wordCount}} slov. Maximum je {{wordLimit}}",
		recommended_words_text: "Zadali ste {{wordCount}} slov. Maximum je {{wordLimit}}",
		stay_connected: "Zostaňte v spojení",
		chat_open_error_modal_text: "Ak chcete spustiť nový chat, zatvorte už otvorený chat.",
		chat_open_error_modal_title: "Chat je už otvorený",
		previous_chat_history: "Predchádzajúca história chatu",
		choose_chat_history: "Vybrať históriu chatu",
		no_chat_records_available: "Nenašli sa žiadne predchádzajúce záznamy o chate. Prejdite na živý chat a chatujte s agentom",
		empty_chat_present: "V tejto relácii chatu sa nenachádza žiadna konverzácia",
		language_support_text: "Momentálne pracujeme na zlepšení vašich skúseností. Zatiaľ môžete používať portál samoobslužnej služby Disability and Leave Services v angličtine.",
		english_language_only_text: "Iba v angličtine",
		invalid_message_contraint_error: "Prekročili ste maximálny počet znakov. Maximum je 1 024 znakov",
		loading_error: "Pri načítavaní tejto obrazovky sa vyskytla chyba. Skúste to znova o niekoľko minút.",
		loading_error_text: "Pri načítavaní sa vyskytla chyba.",
		maximize_chat_history: "Maximalizovať históriu chatu",
		minimize_chat_history: "Minimalizovať históriu chatu",
		need_more_help: "Potrebujete ďalšiu pomoc?",
		erc_number_message: "Ak chcete získať okamžitú podporu, spojte sa s HR:",
		get_started: "Začať",
		self_service_content_error: "Pri načítavaní samoobslužného obsahu sa vyskytol problém. Stlačte tlačidlo Začať na spustenie samoobslužného pracovného postupu.",
		describe_issue_title: "Opíšte svoj problém a spojte sa s agentom podpory",
		record_chat_session: "Vaša relácia chatu sa môže zaznamenávať na účely školenia alebo zvyšovania kvality.",
		idleness_disconnect_message: "Ak budete nečinní alebo nebudete odpovedať viac ako {{minutes}} min, váš chat sa odpojí.",
		userinput_box_hint_text: "S čím vám pomôžeme?",
		get_help: "Získať pomoc",
		connect_with_hr_by_chat_phone_request: "Spojte sa s HR prostredníctvom živého chatu, telefonicky alebo vytvorením požiadavky.",
		myhr_contact_us: "My HR | Kontaktujte nás",
		not_able_to_get_live_help: "Momentálne vám nemôžeme poskytnúť možnosti živej podpory. Prejdite na MyHR a získajte ďalšiu pomoc",
		chat_transcript_opt_in_modal_content: "Subjekt Amazon, ktorý vás zamestnáva, by chcel tento chat uložiť na účely školenia, zvyšovania kvality a evidencie. Ak s tým súhlasíte, kliknite na položku Súhlasím. Ak s tým nesúhlasíte, kliknite na položku Odmietnuť. Ďalšie informácie o tom, ako zaobchádzame s vašimi osobnými údajmi, vrátane vášho práva na odvolanie súhlasu nájdete v oznámení spoločnosti Amazon o ochrane osobných údajov zamestnancov na portáli Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Chcete si nechať urobiť prepis chatu?",
		chat_transcript_opt_in_consent: "Súhlasím",
		chat_transcript_opt_in_decline: "Odmietnuť",
		connect_to_provider: "Chcete sa pripojiť k externému poskytovateľovi?",
		your_information: "Vaše informácie",
		all_feilds_are_required: "Všetky polia sú povinné.",
		name: "Meno",
		email: "E-mail",
		phoneNumber: "Telefónne číslo",
		"continue": "Pokračovať",
		please_provide_valid: "Uveďte platné",
		to_start_live_chat_click_continue: "Ak chcete začať reláciu živého chatu so psychológom, zadajte svoje informácie a ťuknite na položku Pokračovať.",
		you_are_connected_with_a_third_party: "Ste prepojení s externým poskytovateľom pomoci zamestnancom (EAP).",
		to_save_transcript_download: "Ak si chcete uložiť tento prepis, pred ukončením tejto relácie si ho stiahnite.",
		fix_the_errors: "Opravte chyby: Neodpovedali ste na niekoľko ([X]) povinných otázok.",
		all_clinicians_busy: "Ľutujeme, ale zdá sa, že všetci lekári sú zaneprázdnení ostatnými zamestnancami. Ťuknutím na tlačidlo Nová relácia živého chatu sa znova zaradíte do poradia.",
		username: "Meno",
		connect_to_a_provider_outside_amazon: "Chcete sa pripojiť k poskytovateľovi mimo Amazonu?",
		you_are_now_connected_to_confidential: "Teraz sa pripájate k dôvernému externému poskytovateľovi mimo Amazonu, ktorý na registráciu a overenie vyžaduje vaše meno, telefónne číslo a podrobnosti o polohe. Táto služba je bezplatná a dôverná.",
		no_agents: "HR agenti nie sú momentálne k dispozícii, skúste iný kanál",
		high_wait_time: "Všetci naši HR agenti sú momentálne zaneprázdnení. Medzitým skúste iné kanály",
		by_tapping_continue_agree_wpo_terms: "Ťuknutím na tlačidlo Pokračovať potvrdzujete, že ste si prečítali podmienky služby Workplace Options a súhlasíte s nimi",
		terms_and_conditions: "Zmluvné podmienky",
		end_chat_modal_text_wpo: "Tým sa ukončí váš živý chat.",
		live_support_options: "Možnosti podpory naživo",
		open: "Otvoriť",
		myhr: "My HR"
	}
};
var skSK = {
	atoz_myhr_app: atoz_myhr_app$d
};

var atoz_myhr_app$e = {
	livehelp: {
		help_eligibility_title: "Başvuru uygunluğuyla ilgili yardım için HR ile hemen bağlantı kurabilir veya bir talep oluşturabilirsiniz.",
		chat_title: "Sohbet",
		call_title: "Ara",
		create_request: "Bir istek oluştur",
		wait_time: "Bekleme süresi",
		response_time: "Yanıt süresi",
		waiting_time_minute_text: "{{minutes}} dakika",
		waiting_time_hours_text: "{{hours}} saat",
		hr_help_and_support: "HR ile İletişime Geçin ve İstekleri Yönetin",
		call_error_processing: "İsteğiniz işlenirken bir hata oluştu, lütfen baştan tekrar deneyin.",
		help_needed_with: "Ne konuda yardıma ihtiyacınız var?",
		immigration_title: "Göçmenlik",
		disability_and_leave_title: "Maluliyet ve İzin",
		other: "Diğer",
		submit: "Gönder",
		cancel: "İptal",
		enter_number_title: "HR'den bir çağrı almak için numaranızı girin.",
		request_call: "Çağrı talep edin",
		amazon_support_contact_shortly: "Kısa süre içinde Amazon Çalışan destek ekibinden bir çağrı alacaksınız.",
		confirm_preferred_phone_number: "Çağrı isteğinde bulunmak için aranmayı tercih ettiğiniz telefon numarasını ve dili onaylayın",
		what_preferred_phone_no: "Aranmayı tercih ettiğiniz telefon numarası nedir?",
		preferred_language_text: "Tercih ettiğiniz dil nedir?",
		what_to_expect: "Ne beklemelisiniz",
		call_from_agent_minutes: "Bir temsilci sizi ${minutes} dakika içinde arayacak",
		call_from_amazon_number: "Çağrı, ${contactNumber} veya anonim bir numara olarak görünecektir.",
		disconnected_agent_call_minute: "Bağlantınız kesilirse temsilci sizi 1 dakika içinde geri arayacaktır",
		live_help_text_timekeeping_leaves_of_absence: "Zaman tutma ve uzun süreli izinlerle ilgili yardım almak için arayabilir, sohbet edebilir veya bir istek oluşturabilirsiniz.",
		get_call_back: "Geri arama alın",
		request_phone_call: "Telefon çağrısı isteyin",
		close_chat_window: "Canlı Sohbet penceresini kapatmak istiyor musunuz?",
		chat_ended: "Sohbet sona erdi.",
		idle_chat_disconnect: "Hareketsizlik nedeniyle bağlantı kesildi",
		disconnect_from_chat: "Kullanıcı sohbetten ayrıldı. Sohbet görüşmesi sona erdi.",
		chat_idle_message: "{{minutes}} dakika boyunca hareketsiz kaldığınız için sohbetin bağlantısı kesildi.",
		chat_extended_after_idleness: "Kullanıcı hareketsiz kalma uyarısından sonra oturumunu uzattı.",
		surety_chat_idle_message: "Merhaba, sadece sohbetimizin hala bağlı olduğundan emin olmak istiyorum. ${minutes} dakikadır herhangi bir konuşma yapmadık. 2 dakika içinde yanıt veremezseniz sohbetimiz kapanacak.",
		disconnect_chat_message: "Sohbetten ayrılmak istediğinizden emin misiniz?",
		supported_file_attachments: "Sohbet ekleri için desteklenen dosya türleri: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Sohbet eki için maksimum dosya boyutu 20 MB'tır.",
		upload_attachment: "Ek yükle",
		choose_file_upload: "Yüklenecek dosyayı seçin",
		stay_Connected: "Bağlı Kal",
		disconnect: "Bağlantıyı Kes",
		message_input_placeholder: "Bir mesaj yazın ve göndermek için Enter tuşuna basın",
		upload: "Yükle",
		end_chat: "Sohbeti Sonlandır",
		connect: "Bağlan",
		save_chat: "Sohbeti kaydet",
		connected: "Bağlı",
		user_left_chat: "{{user}} sohbetten ayrıldı. Sohbet görüşmeniz sona erdi.",
		user_left_chat_during_transfer: "{{user}} sohbetten ayrıldı. Aktarılıyorsunuz.",
		user_joined_chat: "${user} sohbete katıldı",
		input_phone_number: "Telefon numaranızı girin",
		time: "Süre",
		call_from_anonymous_number: "Çağrı, ${contactNumber} veya anonim bir numara olarak görünecektir.",
		extended_user_session_warning: "Kullanıcı hareketsiz kalma uyarısından sonra oturumunu uzattı",
		close: "Kapat",
		okay: "Tamam",
		send: "Gönder",
		timer_message: "{{counter}} saniye sonra tekrar aranmak için istekte bulunun",
		start_new_chat: "Yeni bir Sohbet başlat",
		open_menu: "Menüyü aç",
		live_chat: "Canlı sohbet",
		end_chat_session: "Sohbet Oturumunu Sonlandır",
		create_request_3steps: "3 adımda bir istek oluşturabilirsiniz",
		available_now: "Şu anda kullanılabilir",
		phone: "telefon",
		minute: "dakika",
		chat_with_HR: "Canlı sohbet",
		chat_with_HR_desc: "Sorgunuzun hemen ele alınması için bir HR temsilcisi ile sohbet edin",
		call_HR: "Ara",
		call_hr_desc: "Kritik/acil sorgular için bir HR temsilcisini arayın",
		doc_note_due_date_ready: "Son tarihinizi içeren bir doktor notunu yüklemeye hazır şekilde bulundurun",
		system: "SİSTEM",
		connected_with_agent: "Bir canlı yardım temsilcisi sohbete bağlandı",
		transferring_to_agent: "Sizi bir canlı yardım temsilcisine aktarıyorum",
		days: "gün",
		request_a_call: "Çağrı talep edin",
		request_phone_call_heading: "HR ile telefonla bağlantı kurmak için aranmayı tercih ettiğiniz telefon numarasına ve dile ihtiyacımız var.",
		request_phone_call_heading_2: "HR ile telefon üzerinden bağlantı kurmak için aranmayı tercih ettiğiniz telefon numarasına ihtiyacımız var.",
		what_your_preffered_number: "Aranmayı tercih ettiğiniz telefon numarası nedir (ülke kodu dahil)?",
		what_your_preffered_language: "Tercih ettiğiniz dil nedir?",
		phone_number_cannot_be_empty: "Telefon numarası boş olamaz",
		only_numbers_allowed: "Burada yalnızca numaralara izin verilir",
		receive_call_number: "{{contactNumber}} numarasından hemen bir çağrı alacaksınız.",
		receive_call_HR_team: "HR Support ekibinden anında bir çağrı alacaksınız.",
		agent_hold_with_wait_time: "Beklemeye alınacaksınız ve temsilci sizinle ${waitTime} dakika içinde bağlantı kuracak.",
		agent_hold_without_wait_time: "Beklemeye alınacaksınız ve temsilci sizinle bağlantı kuracak.",
		disconnected_agent_wait: "Bağlantınız kesilirse temsilci sizi 1 dakika içinde geri arayacaktır.",
		call_hr_desc2: "Telefon numaranızı girdiğinizde bir HR Support uzmanı sizi doğrudan arar.",
		create_hr_request: "İste",
		chat_with_an_hr_specialist: "Bir HR Uzmanı ile sohbet edin",
		talk_to_an_hr_specialist: "Bir HR Uzmanı ile konuşun",
		create_an_hr_case: "Bir HR Case’i Oluşturun",
		minutes: "dakika",
		waiting_time_less_than_minute_text: "1 dakikadan az",
		waiting_time_minutes_text: "{{minutes}} dakika",
		waiting_time_hour_text: "{{hours}} saat",
		waiting_time_more_than_hours_text: "{{hours}} saatten fazla",
		few_days: "1-2 gün",
		landing_page_heading: "${category} konusunda yardım",
		landing_page_subheading: "HR {{availableChannels}} ile bağlantı kurun.",
		subheading_chat_text: "canlı sohbet ile",
		subheading_call_text: "telefon ile",
		subheading_case_text: "bir istek oluşturarak",
		or_connector: "veya",
		create_case_description: "Acil yardıma ihtiyacınız yoksa bir istek oluşturun.",
		next_hours_of_operation: "Bir sonraki destek {{day}} {{startTime}} - {{endTime}} arasında kullanılabilir",
		next_hours_of_operation_with_days: "Bir sonraki destek {{startDay}} {{startTime}} - {{endDay}} {{endTime}} arasında kullanılabilir",
		time_in_am: "ÖÖ {{time}}",
		time_in_pm: "ÖS {{time}}",
		download_transcript_error: "Transkript indirilemedi. Lütfen tekrar deneyin.",
		download_attachment_error: "Ek indirilemedi. Lütfen tekrar deneyin.",
		sent_message_error: "Ağ kesintisi nedeniyle mesaj gönderilemiyor. Lütfen ağınızı kontrol edin ve tekrar deneyin.",
		get_contact_channels_failure: "Kullanılabilir kanallar alınamadı. Lütfen tekrar deneyin.",
		select_a_file: "Bir dosya seçin",
		external_disable_message: "Amazon ağı içinden erişilebilir",
		required_field: "Zorunlu alan",
		end_chat_modal_text: "Bu, HR oturumuyla canlı sohbetinizi sonlandıracak.",
		end_chat_modal_title: "Sohbet sonlandırılsın mı?",
		download_transcript: "Transkripti indir",
		new_live_chat_session: "Yeni canlı sohbet oturumu",
		live_chat_with_HR: "HR ile canlı sohbet",
		chat_header_title: "HR ile Canlı Sohbete Hoş Geldiniz",
		chat_header_subtitle_key: "Konu Seçildi",
		chat_session_started: "Sohbet oturumu başladı",
		chat_session_ended: "Sohbet oturumu sona erdi",
		chat_wait_system_message: "Sizi bir canlı sohbet temsilcisine bağlarken lütfen bekleyin.",
		chat_waitTime_system_message: "Tahmini bekleme süresi",
		chat_info_system_message: "Bu pencereden ayrılsanız bile sohbet oturumunuz bağlı kalacaktır.",
		chat_agent_typing_message: "Destek Temsilcisi yazıyor",
		livechat_warning_banner: "{{minutes}} dakika içinde HR oturumu ile canlı sohbetinizin bağlantısı kesilecek",
		no_available_channel: "Şu anda kullanılabilir kanal yok. Lütfen şu anda Başka Bir Şey seçeneğini kullanın.",
		chat_input_footer_label: "Mesajınız",
		business_days: "{{days}} iş günü",
		business_day: "{{day}} iş günü",
		file_size_limit: "Dosya boyutu 20 MB'tan az olmalıdır.",
		generic_error_message: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
		one_field_reqd_error: "Anket formunu göndermek için en az 1 alan gereklidir.",
		send_survey: "Anketi gönder",
		upload_error_access_denied: "Erişim izni reddedildi.",
		upload_error_internal_server_exception: "İsteğinizle ilgili bir hizmet sorunu oluştu, lütfen tekrar deneyin.",
		upload_error_service_quota_exceeded: "5 ek üst sınırına ulaşıldı.",
		upload_error_throttling: "İsteğinizle ilgili bir hizmet sorunu oluştu, lütfen tekrar deneyin.",
		upload_error_validation: "Ek dosya türü desteklenmiyor.",
		upload_error_generic: "Ek yüklenemiyor",
		not_allowed_destination: "Hedef numaraya giden çağrılara izin verilmiyor",
		call_not_allowed: "Bu numaradan çağrı alınamıyor",
		check_country_code: "Numaranın başına ülke kodunu eklediğinizden emin olun.",
		try_different_number: "Farklı bir numara deneyin.",
		Sunday: "Pazar",
		Monday: "Pazartesi",
		Tuesday: "Salı",
		Wednesday: "Çarşamba",
		Thursday: "Perşembe",
		Friday: "Cuma",
		Saturday: "Cumartesi",
		recommended_words_error_text: "{{wordCount}} kelime girildi. En fazla {{wordLimit}} kelimeye izin verilir",
		recommended_words_text: "{{wordCount}} kelime girildi. {{wordLimit}} veya daha az kelime girilmelidir",
		stay_connected: "Bağlı Kal",
		chat_open_error_modal_text: "Zaten açık bir sohbetiniz var, yeni bir sohbet başlatmak için lütfen onu kapatın.",
		chat_open_error_modal_title: "Sohbet zaten açık",
		previous_chat_history: "Önceki Sohbet Geçmişi",
		choose_chat_history: "Sohbet Geçmişini seçin",
		no_chat_records_available: "Önceki bir sohbet kaydı bulunamadı. Temsilci ile sohbet etmek için Canlı Sohbete geçin",
		empty_chat_present: "Bu sohbet oturumunda konuşma yok",
		language_support_text: "Şu anda deneyiminizi geliştirmek için çalışıyoruz. Şimdilik Maluliyet ve İzin Hizmetleri self servis portalına İngilizce olarak erişebilirsiniz.",
		english_language_only_text: "Yalnızca İngilizce",
		invalid_message_contraint_error: "Karakter sınırı aşıldı. Maksimum 1024 karaktere izin verilir",
		loading_error: "Bu ekran yüklenirken bir hata oluştu. Lütfen birkaç dakika içinde tekrar deneyin.",
		loading_error_text: "Yükleme Hatası.",
		maximize_chat_history: "Sohbet geçmişini büyüt",
		minimize_chat_history: "Sohbet geçmişini simge durumuna küçült",
		need_more_help: "Daha fazla yardıma mı ihtiyacınız var?",
		erc_number_message: "Anında destek için şu adresten HR ile bağlantı kurabilirsiniz:",
		get_started: "Başlayın",
		self_service_content_error: "Self servis içeriği yüklenirken bir sorun oluştu. Self servis iş akışını başlatmak için lütfen \"Başlayın\" düğmesini kullanın.",
		describe_issue_title: "Bir destek temsilcisine bağlanmak için sorununuzu açıklayın",
		record_chat_session: "Sohbet oturumunuz kalite veya eğitim amacıyla kaydedilebilir.",
		idleness_disconnect_message: "{{minutes}} dakikadan uzun süre hareketsiz kalırsanız veya yanıt vermezseniz sohbetinizin bağlantısı kesilir.",
		userinput_box_hint_text: "Ne konuda yardıma ihtiyacınız var?",
		get_help: "Yardım Alma",
		connect_with_hr_by_chat_phone_request: "Canlı sohbet, telefon veya istek oluşturarak HR ile bağlantı kurun.",
		myhr_contact_us: "My HR | Bize Ulaşın",
		not_able_to_get_live_help: "Şu anda sizin için canlı yardım destek seçeneklerini alamıyoruz. Ek yardım için lütfen MyHR'yi ziyaret edin",
		chat_transcript_opt_in_modal_content: "Size iş veren Amazon tüzel kişiniz, bu sohbeti kalite ve eğitim amacıyla ve kayıt tutma amacıyla saklamak istiyor. İzin vermek için İzin Ver'e tıklayın. Reddetmek için Reddet’e tıklayın. Onayınızı geri çekme hakkınız da dahil olmak üzere kişisel verilerinizi nasıl işlediğimiz hakkında daha fazla bilgi almak için Inside Amazon'daki Çalışan Gizlilik Bildirimi'ne bakın.",
		chat_transcript_opt_in_modal_title: "Sohbet transkripti etkinleştirilsin mi?",
		chat_transcript_opt_in_consent: "İzin Ver",
		chat_transcript_opt_in_decline: "Reddet",
		connect_to_provider: "Üçüncü taraf sağlayıcıya bağlanılsın mı?",
		your_information: "Bilgileriniz",
		all_feilds_are_required: "Tüm alanlar gereklidir.",
		name: "Ad",
		email: "E-Posta",
		phoneNumber: "Telefon Numarası",
		"continue": "Devam et",
		please_provide_valid: "Lütfen geçerli olacak şekilde sağlayın",
		to_start_live_chat_click_continue: "Bir ruh sağlığı klinisyeniyle canlı sohbet oturumunuzu başlatmak için bilgilerinizi verin ve Devam et'e dokunun.",
		you_are_connected_with_a_third_party: "Bir üçüncü taraf Çalışan Yardım Sağlayıcısı (EAP) ile bağlantınız var.",
		to_save_transcript_download: "Bu transkripti kaydetmek için, bu oturumu kapatmadan önce transkripti indirin.",
		fix_the_errors: "Hataları düzeltin: [X] zorunlu soruyu yanıtlamadınız.",
		all_clinicians_busy: "Üzgünüz ancak tüm klinisyenler diğer çalışanlarla ilgileniyor. Sıraya yeniden girmek için Yeni canlı sohbet oturumu'na dokunun.",
		username: "Ad",
		connect_to_a_provider_outside_amazon: "Amazon dışındaki bir sağlayıcıya bağlanılsın mı?",
		you_are_now_connected_to_confidential: "Şimdi, kaydolmak ve kimlik doğrulaması yapmak için adınızı, telefon numaranızı ve konum bilgilerinizi belirtmenizi gerektiren Amazon dışında, gizli, harici bir sağlayıcıya bağlanıyorsunuz. Bu hizmet ücretsiz ve gizlidir.",
		no_agents: "HR temsilcileri şu anda müsait değil. Lütfen başka bir kanal deneyin",
		high_wait_time: "Şu anda tüm HR temsilcilerimiz meşgul Bu sırada lütfen farklı kanalları deneyin",
		by_tapping_continue_agree_wpo_terms: "Devam'a dokunarak, İş Yeri Seçenekleri hizmetiyle ilgili şu belgeleri okuyup kabul ettiğinizi onaylamış olursunuz:",
		terms_and_conditions: "Hüküm ve Koşullar",
		end_chat_modal_text_wpo: "Bu, canlı sohbetinizi sona erdirecek.",
		live_support_options: "Canlı destek seçenekleri",
		open: "Aç",
		myhr: "My HR"
	}
};
var trTR = {
	atoz_myhr_app: atoz_myhr_app$e
};

var atoz_myhr_app$f = {
	livehelp: {
		help_eligibility_title: "Щоб отримати допомогу із заявкою, Ви можете зв’язатися з відділом кадрів зараз або створити запит.",
		chat_title: "Чат",
		call_title: "Телефонувати",
		create_request: "Створити запит",
		wait_time: "Час очікування",
		response_time: "Час відповіді",
		waiting_time_minute_text: "{{minutes}} хвилина",
		waiting_time_hours_text: "{{hours}} год",
		hr_help_and_support: "Зв’язок із відділом кадрів і керування запитами",
		call_error_processing: "Під час обробки запиту сталася помилка. Спробуйте ще раз.",
		help_needed_with: "З яким питанням Вам потрібна допомога?",
		immigration_title: "Імміграція",
		disability_and_leave_title: "Непрацездатність і відпустка",
		other: "Інше",
		submit: "Надіслати",
		cancel: "Скасувати",
		enter_number_title: "Введіть свій номер, щоб Вам зателефонував спеціаліст відділу кадрів.",
		request_call: "Замовити дзвінок",
		amazon_support_contact_shortly: "Незабаром Вам зателефонує спеціаліст служби підтримки співробітників Amazon.",
		confirm_preferred_phone_number: "Щоб замовити дзвінок, підтвердьте основний номер телефону й основну мову",
		what_preferred_phone_no: "Який Ваш основний номер телефону?",
		preferred_language_text: "Яка Ваша основна мова?",
		what_to_expect: "Чого очікувати",
		call_from_agent_minutes: "Агент зателефонує Вам протягом ${minutes} хв.",
		call_from_amazon_number: "Дзвінок надійде від ${contactNumber} або анонімного номера.",
		disconnected_agent_call_minute: "Якщо Ви відключитесь, агент перетелефонує Вам протягом 1 хвилини",
		live_help_text_timekeeping_leaves_of_absence: "Щоб отримати допомогу з питань обліку робочого часу та відпустки, Ви можете зателефонувати, поспілкуватися в чаті або створити запит",
		get_call_back: "Отримати зворотний дзвінок",
		request_phone_call: "Замовити телефонний дзвінок",
		close_chat_window: "Закрити вікно онлайн-чата?",
		chat_ended: "Сеанс чату закінчився.",
		idle_chat_disconnect: "Відключено через бездіяльність",
		disconnect_from_chat: "Користувач покинув чат. Розмова в чаті закінчилася.",
		chat_idle_message: "Сеанс чату було завершено через неактивність протягом {{minutes}} хв.",
		chat_extended_after_idleness: "Користувач продовжив сеанс після попередження про неактивність.",
		surety_chat_idle_message: "Ми все ще спілкуємося? Ми нічого не писали протягом ${minutes} хв. Сеанс чату завершиться, якщо Ви не відповісте за 2 хвилини.",
		disconnect_chat_message: "Ви впевнені, що хочете відключитися від чату?",
		supported_file_attachments: "Типи файлів, що підтримуються для вкладень у чаті: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Максимальний розмір файлу для вкладення в чаті – 20 МБ.",
		upload_attachment: "Передати вкладення",
		choose_file_upload: "Вибрати файл для передання",
		stay_Connected: "Залишатися на зв’язку",
		disconnect: "Відключитися",
		message_input_placeholder: "Введіть повідомлення та натисніть клавішу Enter, щоб надіслати його",
		upload: "Передати",
		end_chat: "Завершити чат",
		connect: "Підключитися",
		save_chat: "Зберегти чат",
		connected: "Підключено",
		user_left_chat: "Учасник {{user}} покинув чат. Ваша розмова в чаті завершилася.",
		user_left_chat_during_transfer: "Учасник {{user}} покинув чат. Вас переводять.",
		user_joined_chat: "Учасник ${user} приєднався до чату",
		input_phone_number: "Введіть свій номер телефону",
		time: "Час",
		call_from_anonymous_number: "Дзвінок надійде від ${contactNumber} або анонімного номера.",
		extended_user_session_warning: "Користувач продовжив сеанс після попередження про неактивність",
		close: "Закрити",
		okay: "Добре",
		send: "Надіслати",
		timer_message: "Замовте дзвінок знову за {{counter}} сек.",
		start_new_chat: "Почати новий чат",
		open_menu: "Відкрити меню",
		live_chat: "Онлайн-чат",
		end_chat_session: "Завершити сеанс чату",
		create_request_3steps: "Ви можете створити запит у 3 кроки",
		available_now: "Доступно зараз",
		phone: "телефон",
		minute: "хвилина",
		chat_with_HR: "Онлайн-чат",
		chat_with_HR_desc: "Поговоріть у чаті зі спеціалістом відділу кадрів, щоб швидко розв’язати Ваше питання",
		call_HR: "Телефонувати",
		call_hr_desc: "Зателефонуйте до відділу кадрів у разі критичних/термінових питань",
		doc_note_due_date_ready: "Підготуйте до передання медичну довідку з імовірною датою",
		system: "СИСТЕМА",
		connected_with_agent: "Ви на зв’язку з онлайн-агентом довідкової служби",
		transferring_to_agent: "Переводимо Вас на онлайн-агента довідкової служби",
		days: "днів",
		request_a_call: "Замовити дзвінок",
		request_phone_call_heading: "Щоб зв’язатися зі спеціалістом відділу кадрів телефоном, укажіть основний номер телефону й основну мову.",
		request_phone_call_heading_2: "Щоб зв’язатися зі спеціалістом відділу кадрів телефоном, укажіть свій основний номер телефону.",
		what_your_preffered_number: "Який Ваш основний номер телефону (включно з кодом країни)?",
		what_your_preffered_language: "Яка Ваша основна мова?",
		phone_number_cannot_be_empty: "Номер телефону не може бути пустим",
		only_numbers_allowed: "Тут дозволені тільки цифри",
		receive_call_number: "Ви негайно отримаєте дзвінок від {{contactNumber}}.",
		receive_call_HR_team: "Ви негайно отримаєте дзвінок від команди підтримки відділу кадрів.",
		agent_hold_with_wait_time: "Розмову буде поставлено на утримання, і агент зв’яжеться з Вами протягом ${waitTime} хв.",
		agent_hold_without_wait_time: "Розмову буде поставлено на утримання, і агент зв’яжеться з Вами.",
		disconnected_agent_wait: "Якщо Ви відключитесь, агент перетелефонує Вам протягом 1 хвилини.",
		call_hr_desc2: "Укажіть свій номер телефону, і спеціаліст відділу кадрів зателефонує Вам безпосередньо.",
		create_hr_request: "Запит",
		chat_with_an_hr_specialist: "Чат зі спеціалістом відділу кадрів",
		talk_to_an_hr_specialist: "Поговорити зі спеціалістом відділу кадрів",
		create_an_hr_case: "Створити звернення до відділу кадрів",
		minutes: "хв.",
		waiting_time_less_than_minute_text: "менш ніж 1 хв",
		waiting_time_minutes_text: "{{minutes}} хв.",
		waiting_time_hour_text: "{{hours}} год",
		waiting_time_more_than_hours_text: "більш ніж {{hours}} год",
		few_days: "1–2 дні",
		landing_page_heading: "Допомога з ${category}",
		landing_page_subheading: "Зв’язатися з відділом кадрів {{availableChannels}}.",
		subheading_chat_text: "через онлайн-чат",
		subheading_call_text: "телефоном",
		subheading_case_text: "через створення запиту",
		or_connector: "або",
		create_case_description: "Якщо Вам не потрібна негайна допомога, створіть запит.",
		next_hours_of_operation: "Наступний сеанс підтримки доступний із: {{day}} {{startTime}} – {{endTime}}",
		next_hours_of_operation_with_days: "Наступний сеанс підтримки: {{startDay}}, {{startTime}} – {{endDay}}, {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Не вдалося завантажити запис розмови. Спробуйте ще раз.",
		download_attachment_error: "Не вдалося завантажити вкладення. Спробуйте ще раз.",
		sent_message_error: "Неможливо надіслати повідомлення через проблему з мережею. Перевірте мережу та спробуйте ще раз.",
		get_contact_channels_failure: "Не вдалось отримати доступні канали. Спробуйте ще раз.",
		select_a_file: "Вибрати файл",
		external_disable_message: "Доступний всередині мережі Amazon",
		required_field: "Обов’язкове поле",
		end_chat_modal_text: "На цьому Ваш сеанс онлайн-чату з відділом кадрів завершиться.",
		end_chat_modal_title: "Завершити чат?",
		download_transcript: "Завантажити запис розмови",
		new_live_chat_session: "Новий сеанс онлайн-чату",
		live_chat_with_HR: "Онлайн-чат із відділом кадрів",
		chat_header_title: "Ласкаво просимо до онлайн-чату зі службою підтримки",
		chat_header_subtitle_key: "Вибрано тему",
		chat_session_started: "Сеанс чату розпочався",
		chat_session_ended: "Сеанс чату завершився",
		chat_wait_system_message: "Зачекайте, доки ми не підключимо Вас до агента онлайн-чату.",
		chat_waitTime_system_message: "Приблизний час очікування –",
		chat_info_system_message: "Ваш сеанс чату залишиться активним, навіть якщо Ви вийдете з цього вікна.",
		chat_agent_typing_message: "Агент служби підтримки пише",
		livechat_warning_banner: "Ваш сеанс онлайн-чату з відділом кадрів завершиться за {{minutes}} хв",
		no_available_channel: "Зараз немає доступних каналів. Скористайтеся варіантом \"Щось інше\".",
		chat_input_footer_label: "Ваше повідомлення",
		business_days: "{{days}} робочих днів",
		business_day: "{{day}} робочий день",
		file_size_limit: "Розмір файлу не має перевищувати 20 МБ.",
		generic_error_message: "Сталася помилка. Спробуйте ще раз.",
		one_field_reqd_error: "Щоб надіслати форму опитування, необхідно заповнити принаймні 1 поле.",
		send_survey: "Надіслати опитування",
		upload_error_access_denied: "У доступі відмовлено.",
		upload_error_internal_server_exception: "Виникла проблема з Вашим запитом. Спробуйте ще раз.",
		upload_error_service_quota_exceeded: "Досягнуто максимальної кількості вкладень (5).",
		upload_error_throttling: "Виникла проблема з Вашим запитом. Спробуйте ще раз.",
		upload_error_validation: "Тип файлу вкладення не підтримується.",
		upload_error_generic: "Неможливо передати вкладення",
		not_allowed_destination: "Вихідні дзвінки на номер призначення не дозволені",
		call_not_allowed: "На цей номер неможливо отримати дзвінок",
		check_country_code: "Обов’язково додайте код країни на початку номера.",
		try_different_number: "Спробуйте інший номер.",
		Sunday: "Неділя",
		Monday: "Понеділок",
		Tuesday: "Вівторок",
		Wednesday: "Середа",
		Thursday: "Четвер",
		Friday: "П’ятниця",
		Saturday: "Субота",
		recommended_words_error_text: "Введено слів: {{wordCount}}. Дозволено слів: до {{wordLimit}}.",
		recommended_words_text: "Введено слів: {{wordCount}}. Дозволено слів: до {{wordLimit}}.",
		stay_connected: "Залишатися на зв’язку",
		chat_open_error_modal_text: "У Вас уже є відкритий чат. Закрийте його, щоб розпочати новий.",
		chat_open_error_modal_title: "Чат уже відкрито",
		previous_chat_history: "Попередня історія чату",
		choose_chat_history: "Вибір історії чату",
		no_chat_records_available: "Попередніх записів чату не знайдено. Перейти до онлайн-чату, щоб поспілкуватися з агентом",
		empty_chat_present: "Немає розмов у цьому сеансі чату",
		language_support_text: "Зараз ми працюємо над покращенням наших послуг. Ви можете користуватися порталом самообслуговування \"Непрацездатність і відпустка\" англійською мовою.",
		english_language_only_text: "Тільки англійською мовою",
		invalid_message_contraint_error: "Перевищено обмеження кількості символів. Дозволено не більше 1024 символів.",
		loading_error: "Під час завантаження цього екрана сталася помилка. Спробуйте ще раз за кілька хвилин.",
		loading_error_text: "Помилка завантаження.",
		maximize_chat_history: "Розгорнути історію чату",
		minimize_chat_history: "Згорнути історію чату",
		need_more_help: "Потрібна додаткова допомога?",
		erc_number_message: "Щоб негайно отримати підтримку, зв’яжіться з відділом кадрів у такий спосіб:",
		get_started: "Почати",
		self_service_content_error: "Під час завантаження контенту самообслуговування виникла проблема. Натисніть кнопку \"Почати\", щоб розпочати процедуру самообслуговування.",
		describe_issue_title: "Опишіть свою проблему, щоб поспілкуватися з агентом служби підтримки",
		record_chat_session: "Ваш сеанс чату може записуватися для цілей забезпечення якості обслуговування або навчання.",
		idleness_disconnect_message: "Чат буде перервано, якщо Ви не робитимете жодних дій або не відповідатимете довше {{minutes}} хвилин.",
		userinput_box_hint_text: "З яким питанням Вам потрібна допомога?",
		get_help: "Отримати допомогу",
		connect_with_hr_by_chat_phone_request: "Зв’яжіться з відділом кадрів в онлайн-чаті, телефоном або через запит.",
		myhr_contact_us: "My HR | Зв’яжіться з нами",
		not_able_to_get_live_help: "Наразі ми не можемо надати Вам варіанти підтримки в режимі реального часу. Щоб отримати допомогу, скористайтеся системою MyHR.",
		chat_transcript_opt_in_modal_content: "Ваша організація Amazon хотіла б зберегти цей чат для цілей забезпечення якості, навчання та ведення записів. Щоб дати згоду, натисніть \"Погодитися\". Якщо Ви не згодні, натисніть \"Відмовитися\". Щоб дізнатися більше про те, як ми обробляємо Ваші особисті дані, включно з Вашим правом відкликати згоду, ознайомтеся з Повідомленням про конфіденційність співробітників у системі Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Бажаєте записувати розмову?",
		chat_transcript_opt_in_consent: "Погодитися",
		chat_transcript_opt_in_decline: "Відмовитися",
		connect_to_provider: "Підключитися до стороннього спеціаліста?",
		your_information: "Ваша інформація",
		all_feilds_are_required: "Усі поля є обов’язковими для заповнення.",
		name: "Ім’я",
		email: "Електронна пошта",
		phoneNumber: "Номер телефону",
		"continue": "Продовжити",
		please_provide_valid: "Надайте дійсні дані:",
		to_start_live_chat_click_continue: "Щоб розпочати сеанс онлайн-чату зі спеціалістом із питань психічного здоров’я, надайте необхідну інформацію та натисніть \"Продовжити\".",
		you_are_connected_with_a_third_party: "Ви підключилися до стороннього спеціаліста з підтримки співробітників.",
		to_save_transcript_download: "Щоб зберегти цей запис розмови, завантажте його, перш ніж закрити сеанс.",
		fix_the_errors: "Виправте помилки: Ви не відповіли на кілька ([X]) обов’язкових запитань.",
		all_clinicians_busy: "Вибачте, але всі спеціалісти займаються іншими співробітниками. Натисніть \"Новий сеанс онлайн-чату\", щоб знову стати в чергу.",
		username: "Ім’я",
		connect_to_a_provider_outside_amazon: "Бажаєте поспілкуватися зі спеціалістом за межами Amazon?",
		you_are_now_connected_to_confidential: "Ви підключаєтеся до конфіденційного зовнішнього спеціаліста за межами Amazon, якому потрібні Ваші ім’я, номер телефону й дані про місцезнаходження для реєстрації та автентифікації. Ця послуга є безкоштовною та конфіденційною.",
		no_agents: "Агенти відділу кадрів зараз недоступні. Спробуйте інший канал.",
		high_wait_time: "Усі наші агенти відділу кадрів зараз зайняті. Будь ласка, спробуйте інші канали.",
		by_tapping_continue_agree_wpo_terms: "Натискаючи \"Продовжити\", Ви підтверджуєте, що прочитали та приймаєте умови надання послуги Workplace Options.",
		terms_and_conditions: "Правила й умови",
		end_chat_modal_text_wpo: "На цьому Ваш чат закінчиться.",
		live_support_options: "Варіанти підтримки в режимі реального часу",
		open: "Відкрито",
		myhr: "Мій відділ кадрів"
	}
};
var ukUA = {
	atoz_myhr_app: atoz_myhr_app$f
};

var atoz_myhr_app$g = {
	livehelp: {
		help_eligibility_title: "如需有关申请资格的帮助，您可以立即与 HR 联系或创建请求。",
		chat_title: "聊天",
		call_title: "呼叫",
		create_request: "创建请求",
		wait_time: "等待时间",
		response_time: "响应时间",
		waiting_time_minute_text: "{{minutes}} 分钟",
		waiting_time_hours_text: "{{hours}} 小时",
		hr_help_and_support: "联系 HR 并管理请求",
		call_error_processing: "处理您的请求时出现错误，请从头开始重试。",
		help_needed_with: "您需要什么样的帮助？",
		immigration_title: "移民",
		disability_and_leave_title: "残疾与休假",
		other: "其他",
		submit: "提交",
		cancel: "取消",
		enter_number_title: "输入您的号码以接听来自 HR 的电话。",
		request_call: "请求通话",
		amazon_support_contact_shortly: "您很快就会接到 Amazon 员工支持团队的电话。",
		confirm_preferred_phone_number: "要请求通话，请确认您的首选电话号码和语言",
		what_preferred_phone_no: "您的首选电话号码是多少？",
		preferred_language_text: "您的首选语言是什么？",
		what_to_expect: "将发生的事情",
		call_from_agent_minutes: "坐席将在 ${minutes} 几分钟内给您打电话",
		call_from_amazon_number: "通话将显示为 ${contactNumber} 或匿名号码",
		disconnected_agent_call_minute: "如果您断开连接，坐席将在 1 分钟内给您回电",
		live_help_text_timekeeping_leaves_of_absence: "如需时间记录和请假方面的帮助，您可以通过致电、聊天或创建请求来获取",
		get_call_back: "要求回电",
		request_phone_call: "请求通话",
		close_chat_window: "您是否要关闭实时聊天窗口？",
		chat_ended: "聊天已终止。",
		idle_chat_disconnect: "由于不活动而断开连接",
		disconnect_from_chat: "用户已退出聊天。聊天对话已终止。",
		chat_idle_message: "由于空闲了 {{minutes}} 分钟，聊天已断开连接。",
		chat_extended_after_idleness: "用户在听到空闲警告后延长了会话。",
		surety_chat_idle_message: "您好，我需要确保我们的聊天仍处于连接状态。我们已经空闲了 ${minutes} 分钟。如果您未能在 2 分钟内回复，我们的聊天将关闭。",
		disconnect_chat_message: "您是否确定要断开聊天？",
		supported_file_attachments: "聊天附件支持的文件类型：.pdf、.jpg、.jpeg、.png、.doc、.docx、.xls、.csv、.wav、.pptx、.ppt、.txt。 聊天附件的最大文件大小为 20MB。",
		upload_attachment: "上传附件",
		choose_file_upload: "选择要上传的文件",
		stay_Connected: "保持连接",
		disconnect: "断开连接",
		message_input_placeholder: "键入消息并按 Enter 发送",
		upload: "上传",
		end_chat: "终止聊天",
		connect: "连接",
		save_chat: "保存聊天",
		connected: "已连接",
		user_left_chat: "{{user}} 已退出聊天。您的聊天对话已终止。",
		user_left_chat_during_transfer: "{{user}} 已退出聊天。您正在转接中。",
		user_joined_chat: "${user} 加入了聊天",
		input_phone_number: "输入您的电话号码",
		time: "时间",
		call_from_anonymous_number: "通话将显示为 ${contactNumber} 或匿名号码",
		extended_user_session_warning: "用户在听到空闲警告后延长了会话",
		close: "关闭",
		okay: "好",
		send: "发送",
		timer_message: "在 {{counter}} 秒后再次请求通话",
		start_new_chat: "开始新聊天",
		open_menu: "打开菜单",
		live_chat: "实时聊天",
		end_chat_session: "终止聊天会话",
		create_request_3steps: "您可以通过 3 个步骤创建请求",
		available_now: "现已可用",
		phone: "电话",
		minute: "分钟",
		chat_with_HR: "实时聊天",
		chat_with_HR_desc: "与 HR 聊天，立即解决您的问题",
		call_HR: "呼叫",
		call_hr_desc: "致电 HR 询问关键/紧急问题",
		doc_note_due_date_ready: "准备好医生诊断说明以及您的预产期以便上传",
		system: "系统",
		connected_with_agent: "您现在已连接到在线坐席",
		transferring_to_agent: "将您转接到在线坐席",
		days: "天",
		request_a_call: "请求通话",
		request_phone_call_heading: "要通过电话与 HR 联系，我们需要您提供首选电话号码和语言。",
		request_phone_call_heading_2: "要通过电话与 HR 联系，我们需要您提供首选电话号码。",
		what_your_preffered_number: "您的首选电话号码是多少（包括国家/地区代码）？",
		what_your_preffered_language: "您的首选语言是什么？",
		phone_number_cannot_be_empty: "电话号码不能为空",
		only_numbers_allowed: "此处只允许输入数字",
		receive_call_number: "您很快就会收到 {{contactNumber}} 的来电。",
		receive_call_HR_team: "您很快就会收到 HR 支持团队的来电。",
		agent_hold_with_wait_time: "您的通话将进入等待状态，坐席将在 ${waitTime} 几分钟内与您联系。",
		agent_hold_without_wait_time: "您的通话将进入等待状态，坐席将会与您联系。",
		disconnected_agent_wait: "如果您断开连接，坐席将在 1 分钟内给您回电。",
		call_hr_desc2: "请提供您的电话号码，HR 支持专家将直接与您通话。",
		create_hr_request: "请求",
		chat_with_an_hr_specialist: "与 HR 专家聊天",
		talk_to_an_hr_specialist: "与 HR 专家交谈",
		create_an_hr_case: "创建 HR 案例",
		minutes: "分钟",
		waiting_time_less_than_minute_text: "少于 1 分钟",
		waiting_time_minutes_text: "{{minutes}} 分钟",
		waiting_time_hour_text: "{{hours}} 小时",
		waiting_time_more_than_hours_text: "超过 {{hours}} 个小时",
		few_days: "1-2 天",
		landing_page_heading: "有关 ${category} 的帮助",
		landing_page_subheading: "通过 HR {{availableChannels}} 联系。",
		subheading_chat_text: "通过实时聊天",
		subheading_call_text: "通过电话",
		subheading_case_text: "通过创建请求",
		or_connector: "或者",
		create_case_description: "如果您不需要即时帮助，请创建请求。",
		next_hours_of_operation: "接下来，支持将在 {{day}} {{startTime}} - {{endTime}} 之间提供",
		next_hours_of_operation_with_days: "接下来，将在 {{startDay}} {{startTime}} - {{endDay}} {{endTime}} 之间提供支持服务",
		time_in_am: "上午 {{time}}",
		time_in_pm: "下午 {{time}}",
		download_transcript_error: "未能下载脚本。请重试。",
		download_attachment_error: "未能下载附件。请重试。",
		sent_message_error: "由于网络中断，无法发送消息。请检查您的网络，然后重试。",
		get_contact_channels_failure: "无法获取可用渠道。请重试。",
		select_a_file: "选择文件",
		external_disable_message: "可在 Amazon 网络内访问",
		required_field: "必填字段",
		end_chat_modal_text: "这将终止您与 HR 的实时聊天会话。",
		end_chat_modal_title: "是否终止聊天？",
		download_transcript: "下载脚本",
		new_live_chat_session: "新建实时聊天会话",
		live_chat_with_HR: "与 HR 实时聊天",
		chat_header_title: "欢迎与 HR 进行实时聊天",
		chat_header_subtitle_key: "已选主题",
		chat_session_started: "聊天会话已启动",
		chat_session_ended: "聊天会话已终止",
		chat_wait_system_message: "请稍候，我们正在将您连接到实时聊天坐席。",
		chat_waitTime_system_message: "预计等待时间为",
		chat_info_system_message: "即使您离开此窗口，您的聊天会话仍会保持连接状态。",
		chat_agent_typing_message: "支持坐席正在输入",
		livechat_warning_banner: "您与 HR 的实时聊天会话将在 {{minutes}} 分钟内断开",
		no_available_channel: "目前没有可用的渠道。此时请使用“其他内容”选项。",
		chat_input_footer_label: "您的消息",
		business_days: "{{days}} 个工作日",
		business_day: "{{day}} 个工作日",
		file_size_limit: "文件大小应小于 20MB。",
		generic_error_message: "出现问题。请重试。",
		one_field_reqd_error: "提交调查表至少需要填写 1 个字段。",
		send_survey: "发送调查",
		upload_error_access_denied: "访问权限被拒绝。",
		upload_error_internal_server_exception: "您的请求遇到服务方面的问题，请重试。",
		upload_error_service_quota_exceeded: "已达到最多 5 个附件的限制。",
		upload_error_throttling: "您的请求遇到服务方面的问题，请重试。",
		upload_error_validation: "不支持该附件文件类型。",
		upload_error_generic: "无法上传附件",
		not_allowed_destination: "不允许呼出目标号码",
		call_not_allowed: "此号码无法接听电话",
		check_country_code: "请确保在号码开头添加了国家/地区代码。",
		try_different_number: "请尝试其他号码。",
		Sunday: "星期日",
		Monday: "星期一",
		Tuesday: "星期二",
		Wednesday: "星期三",
		Thursday: "星期四",
		Friday: "星期五",
		Saturday: "星期六",
		recommended_words_error_text: "已输入 {{wordCount}} 个单词。最多允许使用 {{wordLimit}} 个单词",
		recommended_words_text: "已输入 {{wordCount}} 个单词。所需单词数不超过 {{wordLimit}} 个",
		stay_connected: "保持连接",
		chat_open_error_modal_text: "您已经打开了一个聊天，请将其关闭以开始新聊天。",
		chat_open_error_modal_title: "聊天已打开",
		previous_chat_history: "以前的聊天记录",
		choose_chat_history: "选择聊天记录",
		no_chat_records_available: "未找到以前的聊天记录。前往 LiveChat 与坐席聊天",
		empty_chat_present: "此聊天会话中没有对话",
		language_support_text: "我们正在努力改善您的体验。现在，您可以访问英语版本的残疾与休假服务自助门户。",
		english_language_only_text: "仅限英语",
		invalid_message_contraint_error: "超出了字符限制。最多允许 1024 个字符",
		loading_error: "加载此屏幕时出错。请过几分钟后重试。",
		loading_error_text: "加载错误。",
		maximize_chat_history: "尽量保存聊天记录",
		minimize_chat_history: "尽量减少聊天记录",
		need_more_help: "需要更多帮助？",
		erc_number_message: "如需即时支持，您可以通过以下方式与 HR 联系：",
		get_started: "开始",
		self_service_content_error: "加载自助服务内容时出现问题。请使用“开始”按钮启动自助服务工作流。",
		describe_issue_title: "描述您的问题以联系支持客服",
		record_chat_session: "出于提高质量或培训目的，可能会录制您的聊天会话。",
		idleness_disconnect_message: "如果您处于空闲状态，或者没有回复的时间超过 {{minutes}} 分钟，您的聊天将断开连接。",
		userinput_box_hint_text: "您需要什么样的帮助？",
		get_help: "获取帮助",
		connect_with_hr_by_chat_phone_request: "通过实时聊天、电话或创建请求，与 HR 联系。",
		myhr_contact_us: "My HR | 联系我们",
		not_able_to_get_live_help: "我们此时无法为您提供实时帮助支持选项。请访问 MyHR 以获取更多帮助",
		chat_transcript_opt_in_modal_content: "雇佣您的 Amazon 实体希望存储此聊天记录，以用于提高质量和培训目的以及保存记录。如果同意，请单击“同意”。如果不同意，请单击“拒绝”。要进一步了解我们如何处理您的个人数据，包括您撤回同意书的权利，请参阅 Inside Amazon 上的《员工隐私声明》。",
		chat_transcript_opt_in_modal_title: "选择保存聊天记录？",
		chat_transcript_opt_in_consent: "同意",
		chat_transcript_opt_in_decline: "拒绝",
		connect_to_provider: "连接到第三方保健服务提供商？",
		your_information: "您的信息",
		all_feilds_are_required: "所有字段都是必填字段。",
		name: "姓名",
		email: "电子邮件",
		phoneNumber: "电话号码",
		"continue": "继续",
		please_provide_valid: "请提供有效的",
		to_start_live_chat_click_continue: "要与心理健康临床医生开始实时聊天会话，请提供您的信息，然后点击“继续”。",
		you_are_connected_with_a_third_party: "您已与第三方员工援助保健服务提供商 (EAP) 建立了联系。",
		to_save_transcript_download: "要保存此脚本，请先下载脚本，然后再关闭该会话。",
		fix_the_errors: "修复错误： 您没有回答 [X] 个必答问题。",
		all_clinicians_busy: "抱歉，所有临床医生似乎都在忙着处理其他员工的问题。点击“新建实时聊天会话”，重新加入队列。",
		username: "姓名",
		connect_to_a_provider_outside_amazon: "连接到 Amazon 外部的保健服务提供商？",
		you_are_now_connected_to_confidential: "您当前正在连接 Amazon 外部的一家保密的保健服务提供商，该提供商需要您提供姓名、电话号码和地点详细信息，才能注册和进行身份验证。这项服务是免费的，并且会保密。",
		no_agents: "HR 座席目前不可用，请尝试其他渠道",
		high_wait_time: "目前，我们所有的 HR 座席都很忙。请暂时尝试其他渠道",
		by_tapping_continue_agree_wpo_terms: "点击“继续”，即表示您已阅读并同意 Workplace Options 服务",
		terms_and_conditions: "条款和条件",
		end_chat_modal_text_wpo: "这将结束您的实时聊天。",
		live_support_options: "实时支持选项",
		open: "打开",
		myhr: "My HR"
	}
};
var zhCN = {
	atoz_myhr_app: atoz_myhr_app$g
};

var atoz_myhr_app$h = {
	livehelp: {
		help_eligibility_title: "若需申請資格的相關幫助，您可以立刻與人力資源聯繫，或建立請求。",
		chat_title: "聊天",
		call_title: "通話",
		create_request: "建立請求",
		wait_time: "等候時間",
		response_time: "回應時間",
		waiting_time_minute_text: "{{minutes}} 分鐘",
		waiting_time_hours_text: "{{hours}} 小時",
		hr_help_and_support: "聯絡人力資源與管理請求",
		call_error_processing: "處理您的請求時發生錯誤，請從頭再試一次。",
		help_needed_with: "您需要什麼協助？",
		immigration_title: "移民",
		disability_and_leave_title: "殘疾及請假",
		other: "其他",
		submit: "提交",
		cancel: "取消",
		enter_number_title: "輸入您的電話號碼，以接聽人力資源的電話。",
		request_call: "請求通話",
		amazon_support_contact_shortly: "您很快就會接到 Amazon 員工支援團隊的電話。",
		confirm_preferred_phone_number: "若要請求通話，請確認您偏好的電話號碼和語言",
		what_preferred_phone_no: "您的偏好電話號碼為何？",
		preferred_language_text: "您的偏好語言為何？",
		what_to_expect: "期待內容",
		call_from_agent_minutes: "專員會在 ${minutes} 分鐘內致電",
		call_from_amazon_number: "通話將顯示為 ${contactNumber} 或匿名號碼",
		disconnected_agent_call_minute: "如果您的連線中斷，專員會在 1 分鐘內回電",
		live_help_text_timekeeping_leaves_of_absence: "若需計時和缺勤的相關幫助，您可以通話、聊天或建立請求",
		get_call_back: "取得回電",
		request_phone_call: "要求電話通話",
		close_chat_window: "您是否要關閉線上聊天視窗？",
		chat_ended: "聊天已結束。",
		idle_chat_disconnect: "由於閒置而中斷連線",
		disconnect_from_chat: "使用者已離開聊天室。聊天對話已結束。",
		chat_idle_message: "由於閒置 {{minutes}} 分鐘，已中斷聊天連線。",
		chat_extended_after_idleness: "使用者已在閒置警告之後延長工作階段。",
		surety_chat_idle_message: "您好，我只是想確認我們的聊天仍然連線。我們已閒置 ${minutes} 分鐘。如果您無法於 2 分鐘內回覆，我們的聊天將會關閉。",
		disconnect_chat_message: "您是否確定要中斷聊天連線？",
		supported_file_attachments: "聊天附件支援的檔案類型：.pdf、.jpg、.jpeg、.png、.doc、.docx、.xls、.csv、.wav、.pptx、.ppt、.txt。 聊天附件的最大檔案大小上限為 20MB。",
		upload_attachment: "上傳附件",
		choose_file_upload: "選擇要上傳的檔案",
		stay_Connected: "保持連線",
		disconnect: "中斷連線",
		message_input_placeholder: "輸入訊息，並按下 Enter 鍵傳送",
		upload: "上傳",
		end_chat: "結束聊天",
		connect: "連線",
		save_chat: "儲存聊天",
		connected: "已連線",
		user_left_chat: "{{user}} 離開聊天。您的聊天對話已結束。",
		user_left_chat_during_transfer: "{{user}} 離開聊天。您正在轉移。",
		user_joined_chat: "${user} 加入聊天",
		input_phone_number: "輸入您的電話號碼",
		time: "時間",
		call_from_anonymous_number: "通話將顯示為 ${contactNumber} 或匿名號碼",
		extended_user_session_warning: "使用者已在閒置警告之後延長工作階段",
		close: "關閉",
		okay: "好",
		send: "傳送",
		timer_message: "要求在 {{counter}} 秒鐘以後再打電話",
		start_new_chat: "開始新的聊天",
		open_menu: "開啟選單",
		live_chat: "線上聊天",
		end_chat_session: "結束聊天工作階段",
		create_request_3steps: "您可以透過 3 個步驟建立請求",
		available_now: "目前可用",
		phone: "電話",
		minute: "分鐘",
		chat_with_HR: "線上聊天",
		chat_with_HR_desc: "與人力資源聊天，立即解決您的問題",
		call_HR: "通話",
		call_hr_desc: "重要/緊急查詢請致電人力資源",
		doc_note_due_date_ready: "準備好醫生說明，以便在截止日上傳",
		system: "系統",
		connected_with_agent: "您現在已與即時協助專員連線",
		transferring_to_agent: "將您轉接至線上協助專員",
		days: "天",
		request_a_call: "請求通話",
		request_phone_call_heading: "若需透過電話與人力資源聯繫，我們需要您偏好的電話號碼和語言。",
		request_phone_call_heading_2: "若需透過電話與人力資源聯繫，我們需要您偏好的電話號碼。",
		what_your_preffered_number: "您的偏好電話號碼 (包括國家代碼) 為何？",
		what_your_preffered_language: "您的偏好語言為何？",
		phone_number_cannot_be_empty: "電話號碼不能為空白",
		only_numbers_allowed: "此處僅允許數字",
		receive_call_number: "您將立即收到來自 {{contactNumber}} 的電話。",
		receive_call_HR_team: "您會立刻接到人力資源支援團隊的電話。",
		agent_hold_with_wait_time: "您需要稍待片刻，專員將於 ${waitTime} 分鐘內與您聯繫。",
		agent_hold_without_wait_time: "您需要稍待片刻，專員將會與您聯繫。",
		disconnected_agent_wait: "如果您的連線中斷，專員會在 1 分鐘內回電。",
		call_hr_desc2: "請提供電話號碼，人力資源支援專員會直接致電給您。",
		create_hr_request: "請求",
		chat_with_an_hr_specialist: "與人力資源專員聊天",
		talk_to_an_hr_specialist: "與人力資源專員交談",
		create_an_hr_case: "建立人力資源案例",
		minutes: "分鐘",
		waiting_time_less_than_minute_text: "少於 1 分鐘",
		waiting_time_minutes_text: "{{minutes}}分鐘",
		waiting_time_hour_text: "{{hours}} 小時",
		waiting_time_more_than_hours_text: "超過 {{hours}} 小時",
		few_days: "1-2 天",
		landing_page_heading: "以 ${category} 協助",
		landing_page_subheading: "連線人力資源 {{availableChannels}}。",
		subheading_chat_text: "透過線上聊天",
		subheading_call_text: "透過電話",
		subheading_case_text: "透過建立請求",
		or_connector: "或者",
		create_case_description: "如果您不需要立即的協助，請建立請求。",
		next_hours_of_operation: "下一個支援可取得自 {{day}} {{startTime}}-{{endTime}}",
		next_hours_of_operation_with_days: "下一個支援可取得自 {{startDay}} {{startTime}} - {{endDay}}{{endTime}}",
		time_in_am: "{{time}} 上午",
		time_in_pm: "{{time}} 下午",
		download_transcript_error: "無法下載記錄副本。請再試一次。",
		download_attachment_error: "無法下載附件。請再試一次。",
		sent_message_error: "由於網路中斷，無法傳送訊息。請檢查您的網路，並再試一次。",
		get_contact_channels_failure: "無法取得可用的頻道。請再試一次。",
		select_a_file: "選擇檔案",
		external_disable_message: "可於 Amazon 網路內部存取",
		required_field: "必填欄位",
		end_chat_modal_text: "這會結束您與 HR 的線上聊天階段。",
		end_chat_modal_title: "結束聊天？",
		download_transcript: "下載記錄副本",
		new_live_chat_session: "新的線上聊天工作階段",
		live_chat_with_HR: "與人力資源線上聊天",
		chat_header_title: "歡迎來到與人力資源線上聊天",
		chat_header_subtitle_key: "已選取的主題",
		chat_session_started: "聊天工作階段已開始",
		chat_session_ended: "聊天工作階段已結束",
		chat_wait_system_message: "我們將您連線至線上聊天專員，請稍待片刻。",
		chat_waitTime_system_message: "預計的等候時間為",
		chat_info_system_message: "即使您離開此視窗，您的聊天工作階段仍會保持連線狀態。",
		chat_agent_typing_message: "支援專員正在輸入",
		livechat_warning_banner: "您與人力資源的線上聊天，將於 {{minutes}} 分鐘中斷連線",
		no_available_channel: "目前沒有可用的頻道。這次請使用「其他東西」選項。",
		chat_input_footer_label: "您的訊息",
		business_days: "{{days}} 工作日",
		business_day: "{{day}} 工作日",
		file_size_limit: "檔案大小應小於 20MB。",
		generic_error_message: "發生問題。請再試一次。",
		one_field_reqd_error: "需至少填入 1 個欄位以提交調查表格。",
		send_survey: "傳送調查問卷",
		upload_error_access_denied: "已拒絕存取權限。",
		upload_error_internal_server_exception: "您的要求發生服務問題，請再試一次。",
		upload_error_service_quota_exceeded: "已達到 5 個附件的最大限制。",
		upload_error_throttling: "您的要求發生服務問題，請再試一次。",
		upload_error_validation: "不支援附件檔案類型。",
		upload_error_generic: "無法上傳附件",
		not_allowed_destination: "不允許撥打至目的地號碼的境外電話",
		call_not_allowed: "此號碼無法接聽來電",
		check_country_code: "確保您在號碼開頭加上國家/地區代碼。",
		try_different_number: "嘗試不同的號碼。",
		Sunday: "星期日",
		Monday: "星期一",
		Tuesday: "星期二",
		Wednesday: "星期三",
		Thursday: "星期四",
		Friday: "星期五",
		Saturday: "星期六",
		recommended_words_error_text: "已輸入 {{wordCount}} 個字詞。已允許使用最多 {{wordLimit}} 個字詞",
		recommended_words_text: "已輸入 {{wordCount}} 個字詞。必須填入 {{wordLimit}} 個或更少字詞。",
		stay_connected: "保持連線",
		chat_open_error_modal_text: "您已開啟聊天室，請將其關閉以開始新的聊天。",
		chat_open_error_modal_title: "已開啟聊天",
		previous_chat_history: "上一個聊天記錄",
		choose_chat_history: "選擇聊天記錄",
		no_chat_records_available: "找不到之前的聊天記錄。前往 LiveChat 以和專員聊天",
		empty_chat_present: "此聊天工作階段中沒有對話",
		language_support_text: "我們目前正努力改善您的體驗。現在，您可以存取英語的殘疾和請假服務自助服務入口網站。",
		english_language_only_text: "僅提供英語",
		invalid_message_contraint_error: "已超過字元限制。最多允許使用 1024 個字元",
		loading_error: "載入此畫面時發生錯誤。請在幾分鐘後再試一次。",
		loading_error_text: "載入錯誤。",
		maximize_chat_history: "最大化聊天記錄",
		minimize_chat_history: "最小化聊天記錄",
		need_more_help: "是否需要更多協助？",
		erc_number_message: "如需獲得立即支援，您可以透過以下方式與 HR 聯絡：",
		get_started: "開始使用",
		self_service_content_error: "載入自助服務內容時發生問題。請使用「開始使用」按鈕來啟動自助服務工作流程。",
		describe_issue_title: "描述您的問題以連線到支援代理人員",
		record_chat_session: "為了提升品質或培訓目的，您的聊天工作階段可能會被錄製。",
		idleness_disconnect_message: "如果閒置或超過 {{minutes}} 分鐘沒有回應，您的聊天將會中斷連線。",
		userinput_box_hint_text: "您需要什麼協助？",
		get_help: "取得協助",
		connect_with_hr_by_chat_phone_request: "透過即時聊天、電話或建立請求與 HR 聯絡。",
		myhr_contact_us: "My HR | 聯絡我們",
		not_able_to_get_live_help: "我們目前無法為您提供即時說明支援選項。請造訪 MyHR 尋求其他協助",
		chat_transcript_opt_in_modal_content: "您雇用的 Amazon 實體想要儲存此聊天，用於提升品質和培訓目的以及保存記錄。若同意，請按一下 [同意]。若拒絕，請按一下 [拒絕]。如需進一步了解我們如何處理您的個人資料的相關資訊，包括您撤回同意的權利，請參閱 Inside Amazon 上的員工隱私聲明。",
		chat_transcript_opt_in_modal_title: "選擇加入聊天記錄副本？",
		chat_transcript_opt_in_consent: "同意",
		chat_transcript_opt_in_decline: "拒絕",
		connect_to_provider: "是否要連線到第三方供應商？",
		your_information: "您的資訊",
		all_feilds_are_required: "所有欄位都是必填欄位。",
		name: "姓名",
		email: "電子郵件",
		phoneNumber: "電話號碼",
		"continue": "繼續",
		please_provide_valid: "請提供有效的",
		to_start_live_chat_click_continue: "如需與心理健康臨床醫生開始即時聊天工作階段，請提供您的資訊並點選 [繼續]。",
		you_are_connected_with_a_third_party: "您已與第三方員工協助供應商 (EAP) 連線。",
		to_save_transcript_download: "若要儲存此記錄副本，請在關閉此工作階段之前下載記錄副本。",
		fix_the_errors: "修正錯誤： 您沒有回應 [X] 的必填問題。",
		all_clinicians_busy: "抱歉，所有的臨床醫生似乎都忙於與其他員工交談。點選 [新增即時聊天工作階段] 以重新進入佇列。",
		username: "姓名",
		connect_to_a_provider_outside_amazon: "是否連線到 Amazon 以外的供應商？",
		you_are_now_connected_to_confidential: "您現在正在連線到 Amazon 以外的機密外部供應商，該供應商需要您的姓名、電話號碼和位置詳細資料才能註冊和驗證。此服務是免費且保密的。",
		no_agents: "人力資源專員目前無法提供服務，請嘗試其他管道",
		high_wait_time: "我們所有人力資源專員目前都在忙碌中。請在此期間嘗試其他管道",
		by_tapping_continue_agree_wpo_terms: "點選 [繼續]，即表示您同意已閱讀並同意「工作場所選項」服務",
		terms_and_conditions: "條款及條件",
		end_chat_modal_text_wpo: "這將結束您的線上聊天。",
		live_support_options: "線上支援選項",
		open: "未結案",
		myhr: "我的人力資源"
	}
};
var zhTW = {
	atoz_myhr_app: atoz_myhr_app$h
};

var atoz_myhr_app$i = {
	livehelp: {
		help_eligibility_title: "신청 자격 관련 도움이 필요한 경우 지금 HR에 연락하거나 요청을 생성하십시오.",
		chat_title: "채팅",
		call_title: "통화",
		create_request: "요청 생성",
		wait_time: "대기 시간",
		response_time: "응답 시간",
		waiting_time_minute_text: "{{minutes}}분",
		waiting_time_hours_text: "{{hours}}시간",
		hr_help_and_support: "HR 문의 및 요청 관리",
		call_error_processing: "요청을 처리하는 중 오류가 발생했습니다. 처음부터 다시 시도하십시오.",
		help_needed_with: "어떤 도움이 필요하십니까?",
		immigration_title: "이미그레이션",
		disability_and_leave_title: "Disability & Leave",
		other: "기타",
		submit: "제출",
		cancel: "취소",
		enter_number_title: "HR에서 전화를 받으려면 번호를 입력하십시오.",
		request_call: "통화 요청",
		amazon_support_contact_shortly: "곧 Amazon 직원 지원 팀에서 전화를 드립니다.",
		confirm_preferred_phone_number: "통화를 요청하려면 연락을 받을 전화번호와 언어를 확인해주십시오.",
		what_preferred_phone_no: "선호하는 전화번호가 몇 번입니까?",
		preferred_language_text: "선호하는 언어는 무엇입니까?",
		what_to_expect: "기대 가능한 내용",
		call_from_agent_minutes: "상담원이 ${minutes}분 내로 전화를 드릴 것입니다.",
		call_from_amazon_number: "전화를 건 번호가 ${contactNumber}번 또는 발신자표시제한으로 표시됩니다.",
		disconnected_agent_call_minute: "연결이 끊어지면 상담원이 1분 이내에 다시 전화를 드립니다.",
		live_help_text_timekeeping_leaves_of_absence: "직원 타임카드 및 휴직 관련 도움이 필요하면 전화, 채팅, 요청 생성을 통해 연락하시면 됩니다.",
		get_call_back: "후속 전화 받기",
		request_phone_call: "전화 통화 요청",
		close_chat_window: "실시간 채팅 창을 닫으시겠습니까?",
		chat_ended: "채팅이 종료되었습니다.",
		idle_chat_disconnect: "활동이 없어 연결이 끊겼습니다.",
		disconnect_from_chat: "사용자가 채팅을 나갔습니다. 채팅 대화가 중지되었습니다.",
		chat_idle_message: "{{minutes}}분간 유휴 상태여서 채팅 연결이 끊겼습니다.",
		chat_extended_after_idleness: "유휴 경고 후 사용자가 세션을 연장했습니다.",
		surety_chat_idle_message: "안녕하세요, 채팅이 아직 연결되어 있는지 확인하려고 합니다. ${minutes}분간 아무 메시지가 없었습니다. 2분 내에 응답하지 않으시면 채팅이 종료됩니다.",
		disconnect_chat_message: "채팅 연결을 끊으시겠습니까?",
		supported_file_attachments: "채팅 첨부파일에 지원되는 파일 형식: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt  채팅 첨부파일의 최대 파일 크기는 20MB입니다.",
		upload_attachment: "첨부파일 업로드",
		choose_file_upload: "업로드할 파일 선택",
		stay_Connected: "연결된 상태로 유지",
		disconnect: "연결 끊기",
		message_input_placeholder: "메시지를 입력하고 Enter 키를 눌러 보내십시오.",
		upload: "업로드",
		end_chat: "채팅 중지",
		connect: "연결",
		save_chat: "채팅 저장",
		connected: "연결됨",
		user_left_chat: "{{user}} 님이 채팅을 나갔습니다. 채팅 대화가 중지되었습니다.",
		user_left_chat_during_transfer: "{{user}} 님이 채팅을 나갔습니다. 담당자 연결 중입니다.",
		user_joined_chat: "${user} 님이 채팅에 참여함",
		input_phone_number: "전화번호 입력",
		time: "시간",
		call_from_anonymous_number: "전화를 건 번호가 ${contactNumber}번 또는 발신자표시제한으로 표시됩니다.",
		extended_user_session_warning: "유휴 경고 후 사용자가 세션을 연장함",
		close: "닫기",
		okay: "수락",
		send: "보내기",
		timer_message: "{{counter}}초 후 다시 통화를 요청하십시오.",
		start_new_chat: "새 채팅 시작",
		open_menu: "메뉴 열기",
		live_chat: "실시간 채팅",
		end_chat_session: "채팅 세션 중지",
		create_request_3steps: "요청 생성 3개 단계",
		available_now: "지금 상담 가능",
		phone: "전화",
		minute: "분",
		chat_with_HR: "실시간 채팅",
		chat_with_HR_desc: "HR과의 채팅으로 궁금한 점을 즉시 해소",
		call_HR: "통화",
		call_hr_desc: "위급/시급한 질문은 HR에 전화로 연락하십시오.",
		doc_note_due_date_ready: "예정일이 명시된 의사 소견서를 업로드할 수 있게 준비하시기 바랍니다.",
		system: "시스템",
		connected_with_agent: "실시간 헬프 상담원과 연결되었습니다.",
		transferring_to_agent: "실시간 헬프 상담원과 연결하는 중",
		days: "일",
		request_a_call: "통화 요청",
		request_phone_call_heading: "전화로 HR과 소통하려면 연락을 받을 전화번호와 언어를 선택하셔야 합니다.",
		request_phone_call_heading_2: "HR과 전화로 연락하려면 전화를 받을 전화번호가 필요합니다.",
		what_your_preffered_number: "연락을 받을 전화번호(국가 번호 포함)는 몇 번입니까?",
		what_your_preffered_language: "선호하는 언어는 무엇입니까?",
		phone_number_cannot_be_empty: "전화번호는 비워 둘 수 없습니다.",
		only_numbers_allowed: "여기는 숫자만 입력 가능합니다.",
		receive_call_number: "곧 {{contactNumber}}번에서 전화가 옵니다.",
		receive_call_HR_team: "곧 HR 지원팀에서 전화가 옵니다.",
		agent_hold_with_wait_time: "대기 상태가 되고 상담원이 ${waitTime}분 내에 연락을 드릴 것입니다.",
		agent_hold_without_wait_time: "대기 상태가 되고 상담원이 연락을 드릴 것입니다.",
		disconnected_agent_wait: "연결이 끊어지면 상담원이 1분 이내에 다시 전화를 드립니다.",
		call_hr_desc2: "전화번호를 입력하시면 HR Support 전문가가 직접 전화를 드립니다.",
		create_hr_request: "요청",
		chat_with_an_hr_specialist: "HR 전문가와 채팅",
		talk_to_an_hr_specialist: "HR 전문가와 상담하기",
		create_an_hr_case: "HR 사례 생성",
		minutes: "분",
		waiting_time_less_than_minute_text: "1분 미만",
		waiting_time_minutes_text: "{{minutes}}분",
		waiting_time_hour_text: "{{hours}}시간",
		waiting_time_more_than_hours_text: "{{hours}}시간 이상",
		few_days: "1~2일",
		landing_page_heading: "${category} 관련 도움",
		landing_page_subheading: "HR {{availableChannels}}에 연락합니다.",
		subheading_chat_text: "실시간 채팅으로",
		subheading_call_text: "전화로",
		subheading_case_text: "요청을 생성하여",
		or_connector: "또는",
		create_case_description: "도움을 당장 받아야 하는 상황이 아니라면 요청을 생성하십시오.",
		next_hours_of_operation: "다음 지원 가능 시간은 {{day}}{{startTime}} ~ {{endTime}}입니다.",
		next_hours_of_operation_with_days: "다음 지원 가능 시간은 {{startDay}} {{startTime}} ~ {{endDay}} {{endTime}}입니다.",
		time_in_am: "오전 {{time}}",
		time_in_pm: "오후 {{time}}",
		download_transcript_error: "트랜스크립트를 다운로드하지 못했습니다. 다시 시도하십시오.",
		download_attachment_error: "첨부파일을 다운로드하지 못했습니다. 다시 시도하십시오.",
		sent_message_error: "네트워크가 끊겨 메시지를 보낼 수 없습니다. 네트워크 상태를 확인하고 다시 시도하십시오.",
		get_contact_channels_failure: "사용 가능한 채널을 가져오지 못했습니다. 다시 시도하십시오.",
		select_a_file: "파일 선택",
		external_disable_message: "Amazon 네트워크 내에서 액세스 가능",
		required_field: "필수 필드",
		end_chat_modal_text: "HR 세션과의 실시간 채팅이 중지됩니다.",
		end_chat_modal_title: "채팅을 중지하시겠습니까?",
		download_transcript: "트랜스크립트 다운로드",
		new_live_chat_session: "새 실시간 채팅 세션",
		live_chat_with_HR: "HR과의 실시간 채팅",
		chat_header_title: "HR과의 실시간 채팅에 오신 것을 환영합니다.",
		chat_header_subtitle_key: "주제 선택됨",
		chat_session_started: "채팅 세션 시작됨",
		chat_session_ended: "채팅 세션 종료됨",
		chat_wait_system_message: "실시간 채팅 상담원과 연결되는 동안 잠시 기다려 주십시오.",
		chat_waitTime_system_message: "예상 대기 시간:",
		chat_info_system_message: "이 창을 나가도 채팅 세션은 연결된 상태로 유지됩니다.",
		chat_agent_typing_message: "지원 담당자가 입력 중",
		livechat_warning_banner: "HR 세션과의 실시간 채팅 연결이 {{minutes}}분 후 끊어집니다.",
		no_available_channel: "현재 사용 가능한 채널이 없습니다. 지금은 다른 옵션을 사용하십시오.",
		chat_input_footer_label: "전달할 메시지",
		business_days: "{{days}}영업일",
		business_day: "{{day}}영업일",
		file_size_limit: "파일 크기는 20MB 미만이어야 합니다.",
		generic_error_message: "문제가 발생했습니다. 다시 시도하십시오.",
		one_field_reqd_error: "설문조사 양식을 제출하려면 필드를 최소 1개 기입해야 합니다.",
		send_survey: "설문조사 보내기",
		upload_error_access_denied: "액세스 권한이 거부되었습니다.",
		upload_error_internal_server_exception: "요청에 서비스 문제가 있습니다. 다시 시도하십시오.",
		upload_error_service_quota_exceeded: "첨부파일 최대 한도인 5개에 도달했습니다.",
		upload_error_throttling: "요청에 서비스 문제가 있습니다. 다시 시도하십시오.",
		upload_error_validation: "지원되지 않는 첨부파일 형식입니다.",
		upload_error_generic: "첨부파일을 업로드할 수 없음",
		not_allowed_destination: "해당 번호로 직접 전화를 거실 수는 없습니다.",
		call_not_allowed: "이 번호로는 전화를 받을 수 없습니다.",
		check_country_code: "번호 시작 부분에 국가 코드를 반드시 추가해야 합니다.",
		try_different_number: "다른 번호를 시도하십시오.",
		Sunday: "일요일",
		Monday: "월요일",
		Tuesday: "화요일",
		Wednesday: "수요일",
		Thursday: "목요일",
		Friday: "금요일",
		Saturday: "토요일",
		recommended_words_error_text: "{{wordCount}}단어가 입력되었습니다. 최대 {{wordLimit}}단어까지 허용됩니다.",
		recommended_words_text: "{{wordCount}}단어가 입력되었습니다.{{wordLimit}}단어 이하를 입력해야 합니다.",
		stay_connected: "연결된 상태로 유지",
		chat_open_error_modal_text: "이미 열려 있는 채팅이 있습니다. 새 채팅을 시작하려면 기존 채팅을 닫으십시오.",
		chat_open_error_modal_title: "채팅이 이미 열려 있음",
		previous_chat_history: "이전 채팅 기록",
		choose_chat_history: "채팅 기록 선택",
		no_chat_records_available: "이전 채팅 기록을 찾을 수 없습니다. 상담원과 채팅하려면 실시간 채팅을 진행하십시오.",
		empty_chat_present: "이 채팅 세션에 대화 없음",
		language_support_text: "현재 사용자 경험을 개선하기 위한 작업 중입니다. 지금은 Disability and Leave Services 셀프서비스 포털을 영어로 이용할 수 있습니다.",
		english_language_only_text: "영어만 가능",
		invalid_message_contraint_error: "글자 수 제한을 초과했습니다. 최대 1,024자까지 입력할 수 있습니다.",
		loading_error: "이 화면을 로드하는 동안 오류가 발생했습니다. 몇 분 후에 다시 시도하십시오.",
		loading_error_text: "로드 중 오류.",
		maximize_chat_history: "채팅 기록 최대화",
		minimize_chat_history: "채팅 기록 최소화",
		need_more_help: "도움이 더 필요하십니까?",
		erc_number_message: "지원을 당장 받아야 하는 상황이라면 다음을 통해 HR에 연락하시기 바랍니다.",
		get_started: "시작하기",
		self_service_content_error: "셀프 서비스 콘텐츠를 로드하는 중에 문제가 발생했습니다. '시작하기' 버튼을 사용하여 셀프 서비스 워크플로를 시작하십시오.",
		describe_issue_title: "지원 상담원과 연결되려면 문제를 자세히 설명하십시오.",
		record_chat_session: "품질 개선 또는 교육 목적으로 채팅 세션이 기록될 수 있습니다.",
		idleness_disconnect_message: "{{minutes}}분 이상 유휴 상태이거나 응답이 없으면 채팅 연결이 끊어집니다.",
		userinput_box_hint_text: "어떤 도움이 필요하십니까?",
		get_help: "도움말 보기",
		connect_with_hr_by_chat_phone_request: "실시간 채팅, 전화 통화 또는 요청 생성을 통해 HR과 소통할 수 있습니다.",
		myhr_contact_us: "My HR | 문의",
		not_able_to_get_live_help: "지금은 실시간 헬프 지원 옵션을 제공해드릴 수 없습니다. 추가 도움이 필요하면 MyHR을 방문하십시오.",
		chat_transcript_opt_in_modal_content: "귀하가 근무하는 Amazon 법인이 품질 개선 및 교육, 기록 보관 목적으로 이 채팅을 저장하려 합니다. 동의하려면 동의를 클릭하십시오. 거부하려면 거부를 클릭하십시오. 동의 철회 권리를 포함, 회사가 귀하의 개인 데이터를 어떻게 처리하는지에 대한 정보를 자세히 확인하려면 Inside Amazon의 직원 개인정보 처리방침을 참조하십시오.",
		chat_transcript_opt_in_modal_title: "채팅 트랜스크립트 작성에 동의하십니까?",
		chat_transcript_opt_in_consent: "동의",
		chat_transcript_opt_in_decline: "거부",
		connect_to_provider: "타사 공급업체에 연결하시겠습니까?",
		your_information: "귀하의 정보",
		all_feilds_are_required: "모든 필드를 기입해야 합니다.",
		name: "이름",
		email: "이메일",
		phoneNumber: "전화번호",
		"continue": "계속",
		please_provide_valid: "유효한 정보를 입력하십시오.",
		to_start_live_chat_click_continue: "정신 건강 전문의와 실시간 채팅 세션을 시작하려면 귀하의 정보를 입력하고 계속을 탭하십시오.",
		you_are_connected_with_a_third_party: "타사 직원 지원 공급업체(EAP)와 연결되어 있으십니다.",
		to_save_transcript_download: "이 트랜스크립트를 저장하려면 이 세션을 닫기 전에 트랜스크립트를 다운로드하십시오.",
		fix_the_errors: "다음 오류를 수정하십시오. 필수 질문 [X]개에 응답하지 않으셨습니다.",
		all_clinicians_busy: "죄송하지만 모든 의료진이 다른 직원과의 상담으로 여유가 없는 것 같습니다. 다시 대기열에 들어가려면 새 실시간 채팅 세션을 탭하십시오.",
		username: "이름",
		connect_to_a_provider_outside_amazon: "Amazon 외부 공급업체에 연결하시겠습니까?",
		you_are_now_connected_to_confidential: "이제 기밀 Amazon 외부 공급업체에 연결 중인데, 등록 및 인증하려면 이름, 전화번호, 근무지 세부 정보가 필요합니다. 이 서비스는 무료이며 기밀이 보장됩니다.",
		no_agents: "HR 에이전트와 현재 상담할 수 없습니다. 다른 채널을 사용해 보십시오.",
		high_wait_time: "현재 모든 HR 에이전트가 다른 업무 중입니다. 그동안 다른 채널을 시도해 주십시오.",
		by_tapping_continue_agree_wpo_terms: "계속을 누르면 직장 옵션 서비스를 읽고 동의한 것으로 간주됩니다.",
		terms_and_conditions: "약관",
		end_chat_modal_text_wpo: "실시간 채팅이 중지됩니다.",
		live_support_options: "실시간 지원 옵션",
		open: "열기",
		myhr: "My HR"
	}
};
var koKR = {
	atoz_myhr_app: atoz_myhr_app$i
};

var atoz_myhr_app$j = {
	livehelp: {
		help_eligibility_title: "Untuk bantuan terkait kelayakan lamaran kerja, Anda dapat terhubung dengan HR sekarang atau membuat permintaan.",
		chat_title: "Obrolan",
		call_title: "Panggil",
		create_request: "Buat permintaan",
		wait_time: "Waktu tunggu",
		response_time: "Waktu respons",
		waiting_time_minute_text: "{{minutes}} menit",
		waiting_time_hours_text: "{{hours}} jam",
		hr_help_and_support: "Hubungi HR dan Kelola Permintaan",
		call_error_processing: "Terjadi kesalahan saat memproses permintaan Anda, coba lagi dari awal.",
		help_needed_with: "Apa bantuan yang Anda butuhkan?",
		immigration_title: "Imigrasi",
		disability_and_leave_title: "Disabilitas & Cuti",
		other: "Lainnya",
		submit: "Kirim",
		cancel: "Batal",
		enter_number_title: "Masukkan nomor Anda untuk menerima panggilan telepon dari HR.",
		request_call: "Minta panggilan telepon",
		amazon_support_contact_shortly: "Anda akan segera menerima panggilan telepon dari tim dukungan Karyawan Amazon.",
		confirm_preferred_phone_number: "Untuk meminta panggilan telepon, konfirmasikan nomor telepon dan bahasa pilihan Anda",
		what_preferred_phone_no: "Berapa nomor telepon pilihan Anda?",
		preferred_language_text: "Apa bahasa pilihan Anda?",
		what_to_expect: "Proses selanjutnya",
		call_from_agent_minutes: "Seorang agen akan menghubungi Anda dalam ${minutes} menit",
		call_from_amazon_number: "Panggilan telepon akan muncul sebagai ${contactNumber} atau nomor tidak dikenal",
		disconnected_agent_call_minute: "Jika Anda terputus, agen akan menghubungi Anda kembali dalam waktu 1 menit",
		live_help_text_timekeeping_leaves_of_absence: "Untuk bantuan terkait ketepatan waktu dan cuti, Anda dapat menelepon, mengobrol, atau membuat permintaan",
		get_call_back: "Dapatkan panggilan telepon balik",
		request_phone_call: "Minta panggilan telepon",
		close_chat_window: "Anda ingin menutup jendela Obrolan Langsung?",
		chat_ended: "Obrolan telah berakhir.",
		idle_chat_disconnect: "Terputus karena Tidak Aktif",
		disconnect_from_chat: "Pengguna meninggalkan obrolan. Percakapan obrolan telah berakhir.",
		chat_idle_message: "Obrolan telah terputus karena tidak ada aktivitas selama {{minutes}} menit.",
		chat_extended_after_idleness: "Pengguna telah memperpanjang sesinya setelah peringatan tidak ada aktivitas diberikan.",
		surety_chat_idle_message: "Hai, saya hanya ingin memastikan obrolan kita masih terhubung. Kita sudah tidak aktif selama ${minutes} menit. Obrolan kita akan ditutup jika Anda tidak dapat merespons dalam 2 menit.",
		disconnect_chat_message: "Anda yakin ingin terputus dari obrolan?",
		supported_file_attachments: "Jenis file yang didukung untuk lampiran obrolan: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Ukuran file maksimal untuk lampiran obrolan adalah 20 MB.",
		upload_attachment: "Unggah lampiran",
		choose_file_upload: "Pilih file yang akan diunggah",
		stay_Connected: "Tetap Terhubung",
		disconnect: "Putuskan",
		message_input_placeholder: "Ketik pesan dan tekan enter untuk mengirim",
		upload: "Unggah",
		end_chat: "Akhiri Obrolan",
		connect: "Hubungkan",
		save_chat: "Simpan Obrolan",
		connected: "Terhubung",
		user_left_chat: "{{user}} meninggalkan obrolan. Percakapan obrolan Anda telah berakhir.",
		user_left_chat_during_transfer: "{{user}} meninggalkan obrolan. Anda sedang ditransfer.",
		user_joined_chat: "${user} bergabung dengan obrolan",
		input_phone_number: "Masukkan nomor telepon Anda",
		time: "Waktu",
		call_from_anonymous_number: "Panggilan telepon akan muncul sebagai ${contactNumber} atau nomor tidak dikenal",
		extended_user_session_warning: "Pengguna telah memperpanjang sesinya setelah peringatan tidak ada aktivitas diberikan",
		close: "Tutup",
		okay: "Oke",
		send: "Kirim",
		timer_message: "Minta panggilan telepon lagi setelah {{counter}} detik",
		start_new_chat: "Mulai Obrolan baru",
		open_menu: "Buka menu",
		live_chat: "Obrolan langsung",
		end_chat_session: "Akhiri Sesi Obrolan",
		create_request_3steps: "Anda dapat membuat permintaan dalam 3 langkah",
		available_now: "Tersedia sekarang",
		phone: "telepon",
		minute: "menit",
		chat_with_HR: "Obrolan langsung",
		chat_with_HR_desc: "Mulai obrolan dengan HR agar pertanyaan Anda langsung dijawab",
		call_HR: "Panggil",
		call_hr_desc: "Hubungi HR untuk pertanyaan kritis/mendesak",
		doc_note_due_date_ready: "Siapkan catatan dokter dengan tanggal persalinan Anda untuk diunggah",
		system: "SISTEM",
		connected_with_agent: "Anda sekarang terhubung dengan agen bantuan langsung",
		transferring_to_agent: "Mentransfer Anda ke agen bantuan langsung",
		days: "hari",
		request_a_call: "Minta panggilan telepon",
		request_phone_call_heading: "Untuk terhubung dengan HR melalui telepon, kami memerlukan nomor telepon dan bahasa pilihan Anda.",
		request_phone_call_heading_2: "Untuk terhubung dengan HR melalui telepon, kami memerlukan nomor telepon pilihan Anda.",
		what_your_preffered_number: "Berapa nomor telepon pilihan Anda (termasuk kode negara)?",
		what_your_preffered_language: "Apa bahasa pilihan Anda?",
		phone_number_cannot_be_empty: "Nomor telepon tidak boleh kosong",
		only_numbers_allowed: "Hanya nomor yang diizinkan di sini",
		receive_call_number: "Anda akan langsung menerima panggilan telepon dari {{contactNumber}}.",
		receive_call_HR_team: "Anda akan langsung menerima panggilan telepon dari tim HR Support.",
		agent_hold_with_wait_time: "Panggilan Anda akan ditahan dan agen akan terhubung dengan Anda dalam ${waitTime} menit.",
		agent_hold_without_wait_time: "Panggilan Anda akan ditahan dan agen akan terhubung dengan Anda.",
		disconnected_agent_wait: "Jika Anda terputus, agen akan menghubungi Anda kembali dalam waktu 1 menit.",
		call_hr_desc2: "Berikan nomor telepon Anda dan spesialis HR Support akan menghubungi Anda secara langsung.",
		create_hr_request: "Permintaan",
		chat_with_an_hr_specialist: "Mulai obrolan dengan Spesialis HR",
		talk_to_an_hr_specialist: "Berbicara dengan Spesialis HR",
		create_an_hr_case: "Buat Kasus HR",
		minutes: "menit",
		waiting_time_less_than_minute_text: "kurang dari 1 menit",
		waiting_time_minutes_text: "{{minutes}} menit",
		waiting_time_hour_text: "{{hours}} jam",
		waiting_time_more_than_hours_text: "lebih dari {{hours}} jam",
		few_days: "1-2 hari",
		landing_page_heading: "Bantuan terkait ${category}",
		landing_page_subheading: "Terhubung dengan HR {{availableChannels}}.",
		subheading_chat_text: "melalui obrolan langsung",
		subheading_call_text: "melalui telepon",
		subheading_case_text: "dengan membuat permintaan",
		or_connector: "atau",
		create_case_description: "Jika Anda tidak memerlukan bantuan segera, kirim permintaan.",
		next_hours_of_operation: "Dukungan berikutnya tersedia dari {{day}} {{startTime}} - {{endTime}}",
		next_hours_of_operation_with_days: "Dukungan berikutnya tersedia dari {{startDay}} {{startTime}} - {{endDay}} {{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Gagal mengunduh transkrip. Coba lagi.",
		download_attachment_error: "Gagal mengunduh lampiran. Coba lagi.",
		sent_message_error: "Tidak dapat mengirimkan pesan karena gangguan jaringan. Periksa jaringan Anda dan coba lagi.",
		get_contact_channels_failure: "Gagal mendapatkan saluran yang tersedia. Coba lagi.",
		select_a_file: "Pilih file",
		external_disable_message: "Dapat diakses di dalam jaringan Amazon",
		required_field: "Bidang wajib diisi",
		end_chat_modal_text: "Tindakan ini akan mengakhiri sesi obrolan langsung Anda dengan HR.",
		end_chat_modal_title: "Akhiri obrolan?",
		download_transcript: "Unduh transkrip",
		new_live_chat_session: "Sesi obrolan langsung baru",
		live_chat_with_HR: "Obrolan langsung dengan HR",
		chat_header_title: "Selamat Datang di Obrolan Langsung dengan HR",
		chat_header_subtitle_key: "Topik yang Dipilih",
		chat_session_started: "Sesi obrolan dimulai",
		chat_session_ended: "Sesi obrolan berakhir",
		chat_wait_system_message: "Tunggu sementara kami menghubungkan Anda dengan agen obrolan langsung.",
		chat_waitTime_system_message: "Perkiraan waktu tunggu adalah",
		chat_info_system_message: "Sesi obrolan Anda akan tetap terhubung meskipun Anda menutup jendela ini.",
		chat_agent_typing_message: "Agen Dukungan sedang mengetik",
		livechat_warning_banner: "Sesi obrolan langsung Anda dengan HR akan terputus dalam {{minutes}} menit",
		no_available_channel: "Tidak ada saluran yang tersedia saat ini. Gunakan opsi Lainnya sekarang.",
		chat_input_footer_label: "Pesan Anda",
		business_days: "{{days}} hari kerja",
		business_day: "{{day}} hari kerja",
		file_size_limit: "Ukuran file harus kurang dari 20 MB.",
		generic_error_message: "Ups, terjadi masalah. Coba lagi.",
		one_field_reqd_error: "Minimal 1 bidang wajib diisi untuk mengirimkan formulir survei.",
		send_survey: "Kirim survei",
		upload_error_access_denied: "Izin akses ditolak.",
		upload_error_internal_server_exception: "Terjadi masalah layanan terkait permintaan Anda, coba lagi.",
		upload_error_service_quota_exceeded: "Batas maksimal 5 lampiran telah tercapai.",
		upload_error_throttling: "Terjadi masalah layanan terkait permintaan Anda, coba lagi.",
		upload_error_validation: "Jenis file lampiran tidak didukung.",
		upload_error_generic: "Tidak dapat mengunggah lampiran",
		not_allowed_destination: "Panggilan telepon keluar ke nomor tujuan tidak diizinkan",
		call_not_allowed: "Panggilan telepon tidak dapat diterima di nomor ini",
		check_country_code: "Pastikan Anda telah menambahkan kode negara di depan nomor telepon.",
		try_different_number: "Coba nomor yang berbeda.",
		Sunday: "Minggu",
		Monday: "Senin",
		Tuesday: "Selasa",
		Wednesday: "Rabu",
		Thursday: "Kamis",
		Friday: "Jumat",
		Saturday: "Sabtu",
		recommended_words_error_text: "{{wordCount}} kata dimasukkan. Maksimal {{wordLimit}} kata diizinkan",
		recommended_words_text: "{{wordCount}} kata dimasukkan. Maksimal {{wordLimit}} kata dibutuhkan",
		stay_connected: "Tetap Terhubung",
		chat_open_error_modal_text: "Anda sudah membuka obrolan, tutup untuk memulai obrolan baru.",
		chat_open_error_modal_title: "Obrolan sudah terbuka",
		previous_chat_history: "Riwayat Obrolan Sebelumnya",
		choose_chat_history: "Pilih Riwayat Obrolan",
		no_chat_records_available: "Tidak ada data obrolan sebelumnya yang ditemukan. Lanjutkan ke Obrolan Langsung untuk mengobrol dengan agen",
		empty_chat_present: "Tidak ada percakapan dalam sesi obrolan ini",
		language_support_text: "Saat ini kami sedang berupaya meningkatkan pengalaman Anda. Untuk saat ini Anda dapat mengakses portal layanan mandiri Disability and Leave Services dalam bahasa Inggris.",
		english_language_only_text: "Hanya Bahasa Inggris",
		invalid_message_contraint_error: "Batas karakter terlampaui. Maksimal 1024 karakter diizinkan",
		loading_error: "Terjadi kesalahan saat memuat layar ini. Coba lagi dalam beberapa menit.",
		loading_error_text: "Kesalahan Pemuatan.",
		maximize_chat_history: "Maksimalkan riwayat obrolan",
		minimize_chat_history: "Minimalkan riwayat obrolan",
		need_more_help: "Perlu bantuan lebih lanjut?",
		erc_number_message: "Untuk dukungan langsung, Anda dapat terhubung dengan HR di:",
		get_started: "Mulai",
		self_service_content_error: "Terjadi masalah saat memuat konten layanan mandiri. Gunakan tombol 'Mulai' untuk memulai alur kerja layanan mandiri.",
		describe_issue_title: "Jelaskan masalah Anda agar dapat terhubung dengan agen dukungan",
		record_chat_session: "Sesi obrolan Anda dapat direkam untuk tujuan pemeriksaan kualitas atau pelatihan.",
		idleness_disconnect_message: "Obrolan Anda akan terputus jika Anda tidak aktif atau tidak merespons selama lebih dari {{minutes}} menit.",
		userinput_box_hint_text: "Apa bantuan yang Anda butuhkan?",
		get_help: "Dapatkan Bantuan",
		connect_with_hr_by_chat_phone_request: "Terhubung dengan HR melalui obrolan langsung, telepon, atau dengan membuat permintaan.",
		myhr_contact_us: "My HR | Hubungi Kami",
		not_able_to_get_live_help: "Kami tidak bisa mendapatkan opsi dukungan bantuan langsung untuk Anda saat ini. Kunjungi MyHR untuk bantuan tambahan",
		chat_transcript_opt_in_modal_content: "Entitas Amazon yang mempekerjakan Anda ingin menyimpan obrolan ini untuk tujuan pemeriksaan kualitas dan pelatihan serta pencatatan data. Untuk mengizinkan, klik Izinkan. Untuk menolak, klik Tolak. Agar mendapatkan informasi lebih lanjut tentang cara kami menangani data pribadi Anda, termasuk hak Anda untuk mencabut izin, lihat Pemberitahuan Privasi Karyawan di Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Izinkan transkrip obrolan?",
		chat_transcript_opt_in_consent: "Izinkan",
		chat_transcript_opt_in_decline: "Tolak",
		connect_to_provider: "Terhubung dengan penyedia pihak ketiga?",
		your_information: "Informasi Anda",
		all_feilds_are_required: "Semua bidang wajib diisi.",
		name: "Nama",
		email: "Email",
		phoneNumber: "Nomor Telepon",
		"continue": "Lanjut",
		please_provide_valid: "Berikan",
		to_start_live_chat_click_continue: "Untuk memulai sesi obrolan langsung Anda dengan dokter spesialis jiwa, berikan informasi Anda dan ketuk Lanjut.",
		you_are_connected_with_a_third_party: "Anda terhubung dengan Penyedia Bantuan Karyawan (EAP) pihak ketiga.",
		to_save_transcript_download: "Untuk menyimpan, unduh transkrip ini sebelum menutup sesi ini.",
		fix_the_errors: "Perbaiki kesalahan: Anda tidak menjawab [X] pertanyaan yang diperlukan.",
		all_clinicians_busy: "Maaf, tetapi semua dokter tampaknya sibuk dengan karyawan lain. Ketuk Sesi obrolan langsung baru untuk masuk kembali ke antrean.",
		username: "Nama",
		connect_to_a_provider_outside_amazon: "Terhubung dengan penyedia di luar Amazon?",
		you_are_now_connected_to_confidential: "Anda sekarang terhubung dengan penyedia eksternal rahasia di luar Amazon yang memerlukan nama, nomor telepon, dan detail lokasi Anda untuk melakukan pendaftaran dan autentikasi. Layanan ini gratis dan rahasia.",
		no_agents: "Agen HR saat ini tidak tersedia, coba saluran lain",
		high_wait_time: "Semua agen HR kami saat ini sedang sibuk. Coba saluran lain untuk sementara",
		by_tapping_continue_agree_wpo_terms: "Dengan mengetuk Lanjut, Anda setuju bahwa Anda telah membaca dan menyetujui layanan Workplace Options",
		terms_and_conditions: "Syarat & Ketentuan",
		end_chat_modal_text_wpo: "Tindakan ini akan mengakhiri obrolan langsung Anda.",
		live_support_options: "Opsi dukungan langsung",
		open: "Buka",
		myhr: "My HR"
	}
};
var idID = {
	atoz_myhr_app: atoz_myhr_app$j
};

var atoz_myhr_app$k = {
	livehelp: {
		help_eligibility_title: "Để được trợ giúp về điều kiện đăng ký, bạn có thể kết nối với Bộ phận nhân sự bây giờ hoặc tạo yêu cầu.",
		chat_title: "Trò chuyện",
		call_title: "Gọi",
		create_request: "Tạo một yêu cầu",
		wait_time: "Thời gian chờ",
		response_time: "Thời gian phản hồi",
		waiting_time_minute_text: "{{minutes}} phút",
		waiting_time_hours_text: "{{hours}} giờ",
		hr_help_and_support: "Liên hệ với Bộ phận nhân sự và quản lý yêu cầu",
		call_error_processing: "Đã xảy ra lỗi khi xử lý yêu cầu của bạn, vui lòng thử lại ngay từ đầu.",
		help_needed_with: "Bạn cần trợ giúp gì?",
		immigration_title: "Nhập cư",
		disability_and_leave_title: "Thương tật & Nghỉ",
		other: "Khác",
		submit: "Nộp",
		cancel: "Hủy bỏ",
		enter_number_title: "Nhập số điện thoại của bạn để nhận cuộc gọi từ Bộ phận nhân sự.",
		request_call: "Yêu cầu cuộc gọi",
		amazon_support_contact_shortly: "Bạn sẽ sớm nhận được cuộc gọi từ nhóm hỗ trợ Nhân viên Amazon.",
		confirm_preferred_phone_number: "Để yêu cầu cuộc gọi, xác nhận số điện thoại và ngôn ngữ ưa dùng của bạn",
		what_preferred_phone_no: "Số điện thoại ưa dùng của bạn là gì?",
		preferred_language_text: "Ngôn ngữ ưa dùng của bạn là gì?",
		what_to_expect: "Điều mong đợi",
		call_from_agent_minutes: "Một tổng đài viên sẽ gọi cho bạn trong vòng ${minutes} phút",
		call_from_amazon_number: "Cuộc gọi sẽ hiển thị dưới dạng một ${contactNumber} hoặc số ẩn danh",
		disconnected_agent_call_minute: "Nếu bạn bị ngắt kết nối, tổng đài viên sẽ gọi lại cho bạn trong vòng 1 phút.",
		live_help_text_timekeeping_leaves_of_absence: "Để được trợ giúp về chấm công và nghỉ phép, bạn có thể gọi, trò chuyện hoặc tạo yêu cầu",
		get_call_back: "Nhận cuộc gọi lại",
		request_phone_call: "Yêu cầu một cuộc gọi điện thoại",
		close_chat_window: "Bạn có muốn đóng cửa sổ Live Chat không?",
		chat_ended: "Trò chuyện đã kết thúc.",
		idle_chat_disconnect: "Ngắt kết nối do Không hoạt động",
		disconnect_from_chat: "Người dùng rời khỏi trò chuyện. Trò chuyện đã kết thúc.",
		chat_idle_message: "Trò chuyện đã bị ngắt kết nối do ngừng lại trong {{minutes}} phút.",
		chat_extended_after_idleness: "Người dùng đã kéo dài phiên của họ sau cảnh báo ngừng lại.",
		surety_chat_idle_message: "Xin chào, tôi chỉ muốn chắc chắn rằng trò chuyện của chúng ta vẫn được kết nối. Chúng ta đã dừng lại trong ${minutes} phút. Trò chuyện của chúng ta sẽ đóng, nếu bạn không thể trả lời trong 2 phút.",
		disconnect_chat_message: "Bạn có chắc chắn muốn ngắt kết nối khỏi cuộc trò chuyện không?",
		supported_file_attachments: "Các loại tệp được hỗ trợ cho tệp trò chuyện đính kèm: .pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .csv, .wav, .pptx, .ppt, .txt.  Kích thước tệp tối đa cho tệp trò chuyện đính kèm là 20MB.",
		upload_attachment: "Tải tệp đính kèm lên",
		choose_file_upload: "Chọn tệp để tải lên",
		stay_Connected: "Duy trì kết nối",
		disconnect: "Ngắt kết nối",
		message_input_placeholder: "Nhập tin nhắn và nhấn enter để gửi",
		upload: "Tải lên",
		end_chat: "Kết thúc trò chuyện",
		connect: "Kết nối",
		save_chat: "Lưu trò chuyện",
		connected: "Đã kết nối",
		user_left_chat: "{{user}} đã rời khỏi trò chuyện. Trò chuyện của bạn đã kết thúc.",
		user_left_chat_during_transfer: "{{user}} đã rời khỏi trò chuyện. Bạn đang được chuyển đi.",
		user_joined_chat: "${user} đã tham gia trò chuyện",
		input_phone_number: "Nhập số điện thoại của bạn",
		time: "Thời gian",
		call_from_anonymous_number: "Cuộc gọi sẽ hiển thị dưới dạng một ${contactNumber} hoặc số ẩn danh",
		extended_user_session_warning: "Người dùng đã kéo dài phiên của họ sau cảnh báo ngừng lại",
		close: "Đóng",
		okay: "Được",
		send: "Gửi",
		timer_message: "Yêu cầu gọi lại sau {{counter}} giây",
		start_new_chat: "Bắt đầu một Trò chuyện mới",
		open_menu: "Mở menu",
		live_chat: "Trò chuyện trực tiếp",
		end_chat_session: "Kết thúc phiên trò chuyện",
		create_request_3steps: "Bạn có thể tạo một yêu cầu trong 3 bước",
		available_now: "Hiện đã có",
		phone: "điện thoại",
		minute: "phút",
		chat_with_HR: "Trò chuyện trực tiếp",
		chat_with_HR_desc: "Trò chuyện với Bộ phận nhân sự để được giải đáp thắc mắc ngay lập tức",
		call_HR: "Gọi",
		call_hr_desc: "Gọi cho Bộ phận nhân sự để được giải đáp thắc mắc quan trọng/khẩn cấp",
		doc_note_due_date_ready: "Có ghi chú của bác sĩ với ngày đến hạn của bạn sẵn sàng để tải lên",
		system: "HỆ THỐNG",
		connected_with_agent: "Bây giờ bạn đã kết nối với một tổng đài viên trợ giúp trực tiếp",
		transferring_to_agent: "Chuyển bạn đến một tổng đài viên trợ giúp trực tiếp",
		days: "ngày",
		request_a_call: "Yêu cầu cuộc gọi",
		request_phone_call_heading: "Để kết nối với Bộ phận nhân sự qua điện thoại, chúng tôi cần số điện thoại và ngôn ngữ ưa dùng của bạn.",
		request_phone_call_heading_2: "Để kết nối với Bộ phận nhân sự qua điện thoại, chúng tôi cần số điện thoại ưa dùng của bạn.",
		what_your_preffered_number: "Số điện thoại ưa dùng của bạn (bao gồm mã quốc gia) là gì?",
		what_your_preffered_language: "Ngôn ngữ ưa dùng của bạn là gì?",
		phone_number_cannot_be_empty: "Số điện thoại không thể để trống",
		only_numbers_allowed: "Chỉ cho phép các số ở đây",
		receive_call_number: "Bạn sẽ nhận ngay được cuộc gọi từ {{contactNumber}}.",
		receive_call_HR_team: "Bạn sẽ nhận được cuộc gọi ngay từ nhóm hỗ trợ Bộ phận nhân sự.",
		agent_hold_with_wait_time: "Bạn sẽ được giữ máy chờ và tổng đài viên sẽ kết nối với bạn trong vòng ${waitTime} phút.",
		agent_hold_without_wait_time: "Bạn sẽ được giữ máy chờ và tổng đài viên sẽ kết nối với bạn.",
		disconnected_agent_wait: "Nếu bạn bị ngắt kết nối, tổng đài viên sẽ gọi lại cho bạn trong vòng 1 phút.",
		call_hr_desc2: "Cung cấp số điện thoại của bạn và một chuyên viên Hỗ trợ thuộc Bộ phận nhân sự sẽ gọi trực tiếp cho bạn.",
		create_hr_request: "Yêu cầu",
		chat_with_an_hr_specialist: "Trò chuyện với Chuyên viên nhân sự",
		talk_to_an_hr_specialist: "Trao đổi với Chuyên viên nhân sự",
		create_an_hr_case: "Tạo một trường hợp của Bộ phận nhân sự",
		minutes: "phút",
		waiting_time_less_than_minute_text: "chưa đến 1 phút",
		waiting_time_minutes_text: "{{minutes}} phút",
		waiting_time_hour_text: "{{hours}} giờ",
		waiting_time_more_than_hours_text: "hơn {{hours}} giờ",
		few_days: "1-2 ngày",
		landing_page_heading: "Trợ giúp về ${category}",
		landing_page_subheading: "Kết nối với Bộ phận nhân sự {{availableChannels}}.",
		subheading_chat_text: "bằng trò chuyện trực tiếp",
		subheading_call_text: "qua điện thoại",
		subheading_case_text: "bằng cách tạo một yêu cầu",
		or_connector: "hoặc",
		create_case_description: "Nếu bạn không cần trợ giúp ngay lập tức, tạo một yêu cầu.",
		next_hours_of_operation: "Hỗ trợ tiếp theo có từ {{day}}{{startTime}} -{{endTime}}",
		next_hours_of_operation_with_days: "Hỗ trợ tiếp theo có từ {{startDay}}{{startTime}} -{{endDay}}{{endTime}}",
		time_in_am: "{{time}} AM",
		time_in_pm: "{{time}} PM",
		download_transcript_error: "Không thể tải xuống bản ghi. Xin thử lại.",
		download_attachment_error: "Không thể tải xuống tệp đính kèm. Xin thử lại.",
		sent_message_error: "Không thể gửi tin nhắn do gián đoạn mạng. Vui lòng kiểm tra mạng của bạn và thử lại.",
		get_contact_channels_failure: "Không thể nhận được các kênh có sẵn. Xin thử lại.",
		select_a_file: "Chọn một tệp",
		external_disable_message: "Có thể truy cập bên trong mạng Amazon",
		required_field: "Trường bắt buộc",
		end_chat_modal_text: "Điều này sẽ kết thúc phiên trò chuyện trực tiếp của bạn với Bộ phận nhân sự.",
		end_chat_modal_title: "Kết thúc trò chuyện?",
		download_transcript: "Tải bản ghi",
		new_live_chat_session: "Phiên trò chuyện trực tuyến mới",
		live_chat_with_HR: "Trò chuyện trực tiếp với Bộ phận nhân sự",
		chat_header_title: "Chào mừng bạn đến với Live Chat với Bộ phận nhân sự",
		chat_header_subtitle_key: "Chủ đề đã chọn",
		chat_session_started: "Phiên trò chuyện đã bắt đầu",
		chat_session_ended: "Phiên trò chuyện đã kết thúc",
		chat_wait_system_message: "Vui lòng đợi trong khi chúng tôi kết nối bạn với một tổng đài viên trò chuyện trực tiếp.",
		chat_waitTime_system_message: "Thời gian chờ ước tính là",
		chat_info_system_message: "Phiên trò chuyện của bạn sẽ vẫn được kết nối ngay cả khi bạn rời khỏi cửa sổ này.",
		chat_agent_typing_message: "Tổng đài viên hỗ trợ đang gõ",
		livechat_warning_banner: "Phiên trò chuyện trực tiếp với Bộ phận nhân sự của bạn sẽ ngắt kết nối trong {{minutes}} phút",
		no_available_channel: "Không có kênh nào có sẵn tại thời điểm này. Vui lòng sử dụng tùy chọn Kênh nào khác tại thời điểm này.",
		chat_input_footer_label: "Tin nhắn của bạn",
		business_days: "{{days}} ngày làm việc",
		business_day: "{{day}} ngày làm việc",
		file_size_limit: "Kích thước tệp phải nhỏ hơn 20MB.",
		generic_error_message: "Đã xảy ra lỗi. Xin thử lại.",
		one_field_reqd_error: "Cần có ít nhất 1 trường để gửi biểu mẫu khảo sát.",
		send_survey: "Gửi khảo sát",
		upload_error_access_denied: "Quyền truy cập bị từ chối.",
		upload_error_internal_server_exception: "Đã có sự cố về dịch vụ với yêu cầu của bạn, vui lòng thử lại.",
		upload_error_service_quota_exceeded: "Đã đạt đến giới hạn tối đa 5 tập tin đính kèm.",
		upload_error_throttling: "Đã có sự cố về dịch vụ với yêu cầu của bạn, vui lòng thử lại.",
		upload_error_validation: "Loại tệp đính kèm không được hỗ trợ.",
		upload_error_generic: "Không thể tải tệp đính kèm lên",
		not_allowed_destination: "Không được phép gọi đi đến số đích",
		call_not_allowed: "Không thể nhận cuộc gọi trên số này",
		check_country_code: "Đảm bảo bạn đã thêm mã quốc gia ở đầu số.",
		try_different_number: "Thử một số khác.",
		Sunday: "Chủ nhật",
		Monday: "Thứ hai",
		Tuesday: "Thứ ba",
		Wednesday: "Thứ tư",
		Thursday: "Thứ năm",
		Friday: "Thứ sáu",
		Saturday: "Thứ bảy",
		recommended_words_error_text: "{{wordCount}} từ đã nhập. Cho phép tối đa {{wordLimit}} từ",
		recommended_words_text: "{{wordCount}} từ đã nhập. Cần {{wordLimit}} hoặc ít hơn",
		stay_connected: "Duy trì kết nối",
		chat_open_error_modal_text: "Bạn đã có một trò chuyện đang mở, vui lòng đóng lại để bắt đầu một trò chuyện mới.",
		chat_open_error_modal_title: "Trò chuyện đã mở",
		previous_chat_history: "Lịch sử trò chuyện trước",
		choose_chat_history: "Chọn lịch sử trò chuyện",
		no_chat_records_available: "Không tìm thấy hồ sơ trò chuyện trước đó. Tiếp tục tới LiveChat để trò chuyện với tổng đài viên",
		empty_chat_present: "Không có cuộc trò chuyện trong phiên trò chuyện này",
		language_support_text: "Chúng tôi hiện đang làm việc để cải thiện trải nghiệm của bạn. Bây giờ bạn có thể truy cập vào cổng tự phục vụ của Dịch vụ thương tật và nghỉ bằng tiếng Anh.",
		english_language_only_text: "Chỉ tiếng Anh",
		invalid_message_contraint_error: "Đã vượt quá giới hạn ký tự. Cho phép tối đa 1024 ký tự",
		loading_error: "Đã xảy ra lỗi khi đang tải màn hình này. Vui lòng thử lại trong vài phút.",
		loading_error_text: "Lỗi tải.",
		maximize_chat_history: "Phóng to lịch sử trò chuyện",
		minimize_chat_history: "Thu nhỏ lịch sử trò chuyện",
		need_more_help: "Cần trợ giúp thêm?",
		erc_number_message: "Để được hỗ trợ ngay lập tức, bạn có thể kết nối với Bộ phận nhân sự tại:",
		get_started: "Bắt đầu",
		self_service_content_error: "Đã xảy ra sự cố khi tải nội dung tự phục vụ. Hãy sử dụng nút “Bắt đầu” để bắt đầu quy trình tự phục vụ.",
		describe_issue_title: "Mô tả sự cố của bạn khi kết nối với tổng đài viên hỗ trợ",
		record_chat_session: "Phiên trò chuyện của bạn có thể được ghi lại vì mục đích chất lượng hoặc đào tạo.",
		idleness_disconnect_message: "Trò chuyện của bạn sẽ bị ngắt kết nối nếu bạn đang dừng lại hoặc không phản hồi trong hơn {{minutes}} phút.",
		userinput_box_hint_text: "Bạn cần trợ giúp gì?",
		get_help: "Nhận trợ giúp",
		connect_with_hr_by_chat_phone_request: "Kết nối với Bộ phận nhân sự bằng trò chuyện trực tiếp, điện thoại hoặc bằng cách tạo yêu cầu.",
		myhr_contact_us: "Bộ phận nhân sự của tôi | Liên hệ",
		not_able_to_get_live_help: "Chúng tôi không thể nhận các tùy chọn hỗ trợ trợ giúp trực tiếp cho bạn tại thời điểm này. Vui lòng truy cập MyHR để được trợ giúp thêm",
		chat_transcript_opt_in_modal_content: "Thực thể Amazon bạn đang làm việc muốn lưu trữ trò chuyện này vì mục đích chất lượng và đào tạo cũng như để lưu giữ hồ sơ. Để đồng ý, nhấp vào Đồng ý. Để từ chối, nhấp vào Từ chối. Để nhận thêm thông tin về việc chúng tôi xử lý dữ liệu cá nhân của bạn như thế nào, bao gồm quyền rút lại sự đồng ý của bạn, xem Thông báo quyền riêng tư của Nhân viên trên Inside Amazon.",
		chat_transcript_opt_in_modal_title: "Chọn dùng bản ghi trò chuyện?",
		chat_transcript_opt_in_consent: "Đồng ý",
		chat_transcript_opt_in_decline: "Từ chối",
		connect_to_provider: "Kết nối với nhà cung cấp bên thứ ba?",
		your_information: "Thông tin của bạn",
		all_feilds_are_required: "Tất cả các trường là bắt buộc.",
		name: "Tên",
		email: "E-mail",
		phoneNumber: "Số điện thoại",
		"continue": "Tiếp tục",
		please_provide_valid: "Vui lòng cung cấp hợp lệ",
		to_start_live_chat_click_continue: "Để bắt đầu phiên trò chuyện trực tiếp của bạn với một bác sĩ lâm sàng sức khỏe tâm thần, cung cấp thông tin của bạn và nhấn vào Tiếp tục.",
		you_are_connected_with_a_third_party: "Bạn được kết nối với bên thứ ba là Nhà cung cấp Hỗ trợ nhân viên (EAP).",
		to_save_transcript_download: "Để lưu bản ghi này, tải xuống bản ghi trước khi đóng phiên này.",
		fix_the_errors: "Sửa lỗi: Bạn đã không trả lời câu hỏi bắt buộc [X].",
		all_clinicians_busy: "Xin lỗi, nhưng tất cả các bác sĩ lâm sàng dường như bận với các nhân viên khác. Nhấn vào Phiên trò chuyện trực tiếp mới để vào lại hàng đợi.",
		username: "Tên",
		connect_to_a_provider_outside_amazon: "Kết nối với nhà cung cấp bên ngoài Amazon?",
		you_are_now_connected_to_confidential: "Bạn đang kết nối với một nhà cung cấp bên ngoài, bảo mật, ở bên ngoài Amazon yêu cầu tên, số điện thoại và chi tiết vị trí của bạn để đăng ký và xác thực. Dịch vụ này miễn phí và bảo mật.",
		no_agents: "Hiện không có tổng đài viên Nhân sự, vui lòng thử một kênh khác",
		high_wait_time: "Tất cả tổng đài viên Nhân sự của chúng tôi đang bận vào lúc này. Vui lòng thử các kênh khác trong thời gian chờ đợi",
		by_tapping_continue_agree_wpo_terms: "Bằng cách nhấn vào Tiếp tục, bạn đồng ý rằng bạn đã đọc và đồng ý với dịch vụ Tùy chọn nơi làm việc",
		terms_and_conditions: "Điều khoản & điều kiện",
		end_chat_modal_text_wpo: "Điều này sẽ kết thúc trò chuyện trực tiếp của bạn.",
		live_support_options: "Tùy chọn hỗ trợ trực tiếp",
		open: "Mở",
		myhr: "Bộ phận nhân sự của tôi"
	}
};
var viVN = {
	atoz_myhr_app: atoz_myhr_app$k
};

var locales = {
  ar: arSA,
  cs: csCZ,
  de: deDE,
  en: enUS,
  "en-US": enUS,
  es: esES,
  fr: frFR,
  "fr-CA": frCA,
  it: itIT,
  ja: jaJP,
  "nl-NL": nlNL,
  pl: plPL,
  "pt-BR": ptBR,
  ro: roRO,
  sk: skSK,
  "tr-TR": trTR,
  "uk-UA": ukUA,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  "ko-KR": koKR,
  "id_ID": idID,
  "vi_VN": viVN
};

var i18 = /*#__PURE__*/function () {
  var instance;
  return {
    getInstance: function getInstance() {
      if (instance == null) {
        instance = newi18instance(locales); // Hide the constructor so the returned object can't be new'd...

        instance.constructor = null;
      }

      return instance;
    }
  };
}();

var stringifyObject = function stringifyObject(obj) {
  try {
    return obj ? JSON.stringify(obj) : '';
  } catch (error) {
    return '';
  }
};
var parseStringifiedObject = function parseStringifiedObject(objString) {
  try {
    return objString && objString !== 'undefined' ? JSON.parse(objString) : undefined;
  } catch (error) {
    return undefined;
  }
};

var FontSize;

(function (FontSize) {
  FontSize["HEADER_DESKTOP"] = "25px";
  FontSize["HEADER_MOBILE"] = "20px";
  FontSize["TEXT_DESKTOP"] = "18px";
  FontSize["TEXT_MOBILE"] = "16px";
})(FontSize || (FontSize = {}));

var ChatErrorBanner = function ChatErrorBanner(props) {
  var errorDetails = {
    isError: true,
    message: props.message
  };
  return /*#__PURE__*/React.createElement(ErrorBanner, {
    showErrorBanner: errorDetails
  });
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".custom-banner{display:none}.custom-banner-text{padding-left:10px}";
styleInject(css_248z);

var CustomBanner = function CustomBanner(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  return /*#__PURE__*/React.createElement(View$1, {
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Container, Object.assign({
    backgroundColor: props.backgroundColor,
    paddingBottom: 16,
    paddingHorizontal: 16,
    paddingTop: 16,
    className: "custom-banner",
    ref: props.refs
  }, props.options), /*#__PURE__*/React.createElement(Row, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconInformationFill, {
    color: props.iconColor
  }), /*#__PURE__*/React.createElement(Text$1, {
    lineHeight: 1.5,
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    className: "custom-banner-text"
  }, t(props.text)))));
};

var css_248z$1 = ".custom-banner{display:none}.custom-banner-text{padding-left:10px}.destination-banner-list{padding-left:20px}";
styleInject(css_248z$1);

var DestinationNotAllowedExceptionBanner = function DestinationNotAllowedExceptionBanner(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(View$1, {
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Container, {
    backgroundColor: "#fce1df",
    paddingBottom: 16,
    paddingHorizontal: 16,
    paddingTop: 16,
    className: "custom-banner",
    ref: props.refs
  }, /*#__PURE__*/React.createElement(Row, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconInformationFill, {
    color: "#ba282a"
  }), /*#__PURE__*/React.createElement(Text$1, {
    className: "custom-banner-text",
    fontSize: FontSize.TEXT_MOBILE
  }, t('livehelp.call_not_allowed'))), /*#__PURE__*/React.createElement("ul", {
    className: "destination-banner-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text$1, {
    className: "custom-banner-text",
    fontSize: FontSize.TEXT_MOBILE
  }, t('livehelp.check_country_code'))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text$1, {
    className: "custom-banner-text",
    fontSize: FontSize.TEXT_MOBILE
  }, t('livehelp.try_different_number'))))));
};

var BackendServiceClientWrapper = /*#__PURE__*/function (_BackendServiceClient) {
  _inheritsLoose(BackendServiceClientWrapper, _BackendServiceClient);

  function BackendServiceClientWrapper() {
    var appRoot = isComponentInline() ? LIVE_HELP_WIDGET_ROOT_ID : ATOZ_MYHR_APP_ROOT_ID;
    return _BackendServiceClient.call(this, appRoot) || this;
  }

  return BackendServiceClientWrapper;
}(BackendServiceClient);

/**
 * @enum USER_DETAIL_ATTRIBUTE
 * this provides keys for user detail identifier while registering & more for WPO.
 */
var USER_DETAIL_ATTRIBUTE;

(function (USER_DETAIL_ATTRIBUTE) {
  USER_DETAIL_ATTRIBUTE["email"] = "email";
  USER_DETAIL_ATTRIBUTE["phoneNumber"] = "phoneNumber";
  USER_DETAIL_ATTRIBUTE["username"] = "username";
})(USER_DETAIL_ATTRIBUTE || (USER_DETAIL_ATTRIBUTE = {}));

var DESCREPTIVE_ERROR;

(function (DESCREPTIVE_ERROR) {
  DESCREPTIVE_ERROR["INVALID_PHONE_NUMBER_TEXT"] = "Invalid Phone number.The numbers should start with a plus sign";
  DESCREPTIVE_ERROR["DUPLICATE_PHONE_NUMBER"] = "Phone number already exists in company";
})(DESCREPTIVE_ERROR || (DESCREPTIVE_ERROR = {}));

var CHAT_MSG_VIEW_VARIANT;

(function (CHAT_MSG_VIEW_VARIANT) {
  CHAT_MSG_VIEW_VARIANT["NEUTRAL"] = "NEUTRAL";
  CHAT_MSG_VIEW_VARIANT["PRIMARY"] = "PRIMARY";
})(CHAT_MSG_VIEW_VARIANT || (CHAT_MSG_VIEW_VARIANT = {}));

var INSIDE_CHAT_BANNER_TYPE;

(function (INSIDE_CHAT_BANNER_TYPE) {
  INSIDE_CHAT_BANNER_TYPE["CHAT_CONNECTED"] = "CHAT_CONNECTED";
  INSIDE_CHAT_BANNER_TYPE["DOWNCHAT_TRANSCRIPT"] = "DOWNCHAT_TRANSCRIPT";
  INSIDE_CHAT_BANNER_TYPE["NO_AGENT_AVAILABLE"] = "NO_AGENT_AVAILABLE";
})(INSIDE_CHAT_BANNER_TYPE || (INSIDE_CHAT_BANNER_TYPE = {}));

var ChatEndFooterBtns;

(function (ChatEndFooterBtns) {
  ChatEndFooterBtns["CLOSE"] = "close";
  ChatEndFooterBtns["DOWNLOAD_TRANSCRIPT"] = "download_transcript";
  ChatEndFooterBtns["NEW_LIVE_CHAT_SESSION"] = "new_live_chat_session";
})(ChatEndFooterBtns || (ChatEndFooterBtns = {}));

var EndChatState;

(function (EndChatState) {
  EndChatState["ACTIVE"] = "ACTIVE";
  EndChatState["INACTIVE"] = "INACTIVE";
  EndChatState["CONFIRMED"] = "CONFIRMED";
})(EndChatState || (EndChatState = {}));

var AgentStatus;

(function (AgentStatus) {
  AgentStatus["CONNECTED"] = "CONNECTED";
  AgentStatus["WAITING"] = "WAITING";
  AgentStatus["NOT_JOINED"] = "NOT_JOINED";
  AgentStatus["NOT_REQUESTED"] = "NOT_REQUESTED";
  AgentStatus["DISCONNECTED"] = "DISCONNECTED";
  AgentStatus["NOT_AVAILALBE"] = "NOT_AVAILALBE";
})(AgentStatus || (AgentStatus = {}));

var InsideContainerFixedMessage;

(function (InsideContainerFixedMessage) {
  InsideContainerFixedMessage["CHAT_CONNECTED"] = "CHAT_CONNECTED";
  InsideContainerFixedMessage["DOWNLOAD_TRANSCRIPT"] = "DOWNLOAD_TRANSCRIPT";
  InsideContainerFixedMessage["FORM_FIELD_ERROR"] = "FORM_FIELD_ERROR";
  InsideContainerFixedMessage["UNAUTHORIZED"] = "UNAUTHORIZED";
  InsideContainerFixedMessage["NONE"] = "NONE";
  InsideContainerFixedMessage["REQUESTING_BACKEND"] = "REQUESTING_BACKEND";
  InsideContainerFixedMessage["BAD_REQUEST"] = "BAD_REQUEST";
  InsideContainerFixedMessage["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
  InsideContainerFixedMessage["DUPLICATE_PHONE_NUMBER"] = "DUPLICATE_PHONE_NUMBER";
  InsideContainerFixedMessage["NEXT_SESSION_WAIT_TIME_MESSAGE"] = "NEXT_SESSION_WAIT_TIME_MESSAGE";
  InsideContainerFixedMessage["DEFAULT_ERROR_MESSAGE"] = "DEFAULT_ERROR_MESSAGE";
})(InsideContainerFixedMessage || (InsideContainerFixedMessage = {}));

var WPO_API_REQUEST_TYPE;

(function (WPO_API_REQUEST_TYPE) {
  WPO_API_REQUEST_TYPE["IM"] = "IM";
  WPO_API_REQUEST_TYPE["VIDEO"] = "VIDEO";
})(WPO_API_REQUEST_TYPE || (WPO_API_REQUEST_TYPE = {}));

var WPO_API_REQUEST_STATUS;

(function (WPO_API_REQUEST_STATUS) {
  WPO_API_REQUEST_STATUS["CANCELLED"] = "Cancelled";
  WPO_API_REQUEST_STATUS["EXPIRED"] = "Expired";
})(WPO_API_REQUEST_STATUS || (WPO_API_REQUEST_STATUS = {}));

var WPO_API_TYPE;

(function (WPO_API_TYPE) {
  WPO_API_TYPE["CREATE_CHAT_INSTANCE"] = "CREATE_CHAT_INSTANCE";
  WPO_API_TYPE["UPDATE_CHAT_DISCONNECT_STATUS"] = "UPDATE_CHAT_DISCONNECT_STATUS";
  WPO_API_TYPE["UPDATE_SESSION_TIMER"] = "UPDATE_SESSION_TIMER";
})(WPO_API_TYPE || (WPO_API_TYPE = {}));

var ExternalChatType;

(function (ExternalChatType) {
  ExternalChatType["WPO"] = "WPO";
})(ExternalChatType || (ExternalChatType = {}));

var TIMER;

(function (TIMER) {
  TIMER["IDLENESS_WARNING"] = "IDLENESS_WARNING";
  TIMER["IDLENESS_DISCONNECT"] = "IDLENESS_DISCONNECT";
  TIMER["STROPHE_DISCONNECT"] = "STROPHE_DISCONNECT";
  TIMER["AGENT_WAIT"] = "AGENT_WAIT";
})(TIMER || (TIMER = {}));

var WPOChatOperations;

(function (WPOChatOperations) {
  WPOChatOperations["CHAT_SESSION_ESTABLISHED"] = "chatSessionEstablished";
  WPOChatOperations["CHAT_SESSION_DISCONNECTED"] = "chatSessionDisconnected";
  WPOChatOperations["STROPHE_CONNECTION_FAILED"] = "stropheConnectionFailed";
  WPOChatOperations["CREATE_WPO_CHAT"] = "CreateWPOChat";
  WPOChatOperations["UPDATE_WPO_CHAT_STATUS"] = "UpdateWPOChatStatus";
  WPOChatOperations["UPDATE_WPO_SESSION_DATA"] = "UpdateWPOChatSessionData";
})(WPOChatOperations || (WPOChatOperations = {}));

var STAGE = /*#__PURE__*/'prod'.trim().toLowerCase();
var STAGES;

(function (STAGES) {
  STAGES["test"] = "test";
  STAGES["development"] = "development";
  STAGES["alpha"] = "alpha";
  STAGES["beta"] = "beta";
  STAGES["prod"] = "prod";
})(STAGES || (STAGES = {}));

var isProdStage = function isProdStage() {
  return STAGE === STAGES.prod;
};

/**
 * @function isValidEmail
 * @param email string value representing email
 * @returns boolean value saying whether the email is valid along with whether it belongs to AMAZON or not
 */

function isValidEmail(email) {
  var regex = /(\W|^)[\w.+]*@amazon\.com(\W|$)/;

  if (email && email.length && email.match(regex)) {
    return true;
  }

  return false;
}
/**
 * @function isValidName
 * @param name name of the user
 * @returns boolean value
 */


function isValidName(name) {
  return name.length >= 4;
}

function requestWPOApi(body, apiType) {
  var wpoURLSuffix = '';
  var backendServiceClient = new BackendServiceClientWrapper();

  switch (apiType) {
    case WPO_API_TYPE.CREATE_CHAT_INSTANCE:
      wpoURLSuffix = 'chat';
      break;

    case WPO_API_TYPE.UPDATE_CHAT_DISCONNECT_STATUS:
      wpoURLSuffix = 'channel/status';
      break;

    case WPO_API_TYPE.UPDATE_SESSION_TIMER:
      wpoURLSuffix = 'updateSessionData';
      break;
  }

  var queryParams = {
    'x-myhr-client-id': 'MyHR_LiveHelp',
    operation: "/api/wpo/" + wpoURLSuffix
  };
  return backendServiceClient.post(body, queryParams);
}

var getContainerMessageBanner = function getContainerMessageBanner(messageType) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  switch (messageType) {
    case InsideContainerFixedMessage.REQUESTING_BACKEND:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Bias,
        icon: /*#__PURE__*/React.createElement(IconRefresh, {
          css: {
            transform: 'rotate(180deg)'
          }
        })
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.please_wait_message')));

    case InsideContainerFixedMessage.DUPLICATE_PHONE_NUMBER:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.phone_number_already_registered')));

    case InsideContainerFixedMessage.NEXT_SESSION_WAIT_TIME_MESSAGE:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Informational
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.please_close_active_chat_session')));

    case InsideContainerFixedMessage.INVALID_PHONE_NUMBER:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.phone_number_format_invalid')));

    case InsideContainerFixedMessage.CHAT_CONNECTED:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Informational
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.you_are_connected_with_a_third_party')));

    case InsideContainerFixedMessage.DOWNLOAD_TRANSCRIPT:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Warning
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.to_save_transcript_download')));

    case InsideContainerFixedMessage.FORM_FIELD_ERROR:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.fix_the_errors')));

    case InsideContainerFixedMessage.BAD_REQUEST:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.wpo_400_response')));

    case InsideContainerFixedMessage.UNAUTHORIZED:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.wpo_403_response')));

    case InsideContainerFixedMessage.DEFAULT_ERROR_MESSAGE:
      return /*#__PURE__*/React.createElement(MessageBanner, {
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text$1, {
        role: "alert",
        fontSize: "T400"
      }, t('livehelp.default_error_message')));

    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

var shouldMockWPOChat = function shouldMockWPOChat() {
  var enableChatKey = 'enableWPOChat';
  var trueString = 'true';
  return new URLSearchParams(window.location.search).get(enableChatKey) === trueString || !isProdStage() && localStorage.getItem(enableChatKey) === trueString;
};

var themeConfig = {
  normalText: {
    fontSize: '16px',
    lineHeight: 1.45
  },
  smallText: {
    fontSize: '14px',
    lineHeight: 1.35
  },
  miniText: {
    fontSize: '12px',
    lineHeight: 1.32
  },
  heading: {
    medium: {
      fontSize: '18px',
      lineHeight: 1.45
    }
  }
};
var stencilOverridenTheme = /*#__PURE__*/Object.assign({}, defaultTheme, {
  font: /*#__PURE__*/Object.assign({}, defaultTheme.font, {
    primary: /*#__PURE__*/Object.assign({}, defaultTheme.font.primary, {
      size: /*#__PURE__*/Object.assign({}, defaultTheme.font.primary.size, {
        T200: {
          s: themeConfig.miniText,
          m: themeConfig.miniText,
          xl: themeConfig.miniText,
          l: themeConfig.miniText
        },
        T300: {
          s: themeConfig.normalText,
          m: themeConfig.smallText,
          xl: themeConfig.smallText,
          l: themeConfig.smallText
        },
        T400: {
          s: themeConfig.normalText,
          m: themeConfig.normalText,
          xl: themeConfig.normalText,
          l: themeConfig.normalText
        },
        T600: {
          s: themeConfig.normalText,
          m: themeConfig.normalText,
          xl: themeConfig.heading.medium,
          l: themeConfig.heading.medium
        }
      })
    })
  })
});
var WPO_STROPHE_IDENTIFIER = {
  priority: 'priority',
  zero: '0',
  chatState: {
    chat: 'chat',
    unavailable: 'unavailable',
    terminate: 'terminate'
  },
  xmlTag: {
    body: 'body',
    attribute: {
      from: 'from',
      type: 'type'
    },
    message: 'message'
  },
  message: {
    display_name: 'DISPLAY_NAME',
    left_chat: 'LEFT_CHAT'
  }
};
var initialWPOFormValues = {
  email: '',
  phoneNumber: '',
  username: ''
};
var initialWPOFormErrorValues = {
  email: false,
  phoneNumber: false,
  username: false
};
var wpoFormFields = [{
  fieldId: USER_DETAIL_ATTRIBUTE.username,
  validationFunction: isValidName,
  employeeAttributeIdentifier: 'legalName'
}, {
  fieldId: USER_DETAIL_ATTRIBUTE.email,
  validationFunction: isValidEmail,
  employeeAttributeIdentifier: 'email'
}, {
  fieldId: USER_DETAIL_ATTRIBUTE.phoneNumber,
  validationFunction: isValidPhoneNumber,
  employeeAttributeIdentifier: 'mobilePhone'
}];
var initialEjabberedCredValues = {
  ejabberdId: '',
  ejabberdPwd: '',
  ejabberdURL: '',
  requestExpirationInSeconds: 120,
  requestId: -1
};
var initialUserMetaInformation = /*#__PURE__*/Object.assign({}, initialWPOFormValues, {
  ejabberedCreds: /*#__PURE__*/Object.assign({}, initialEjabberedCredValues)
});
var initialChatState = {
  isActive: false,
  isAgentTyping: false,
  endStatus: EndChatState.INACTIVE,
  agentStatus: AgentStatus.NOT_REQUESTED
};
var EmployeeDetailsMockResponse = {
  country: 'IND',
  legalName: 'testName',
  login: 'legal',
  mobilePhone: '9876543210',
  preferredName: 'testName',
  buildingCode: 'HYD13',
  timeZoneId: 'Asia/Calcutta',
  email: 'legal@amazon.com'
};
var AGENT_WAIT_TIME_IN_SEC = 120;
var IDLENESS_WARNING_TIME_IN_SEC = 180;
var IDLENESS_DISCONNECT_TIME_IN_SEC = 120;
var STROPHE_DISCONECT_TIME_IN_SEC = 5;
var WPO_POLICY_VIEW_URL = 'https://www.workplaceoptions.com/privacy-policy/';
var DEFAULT_ATOZ_ZINDEX = '1000';
var OVERRIDEN_ATOZ_ZINDEX = '750';
var WPO_CHAT_CONTAINER_PAGE_NAME = 'WPOChatContainer';
var DEFAULT_WPO_OPERATION = 'WPOChatOperations';

/**
 * This method returns logContext
 * @param PAGE_NAME - page at which event happened
 * @param OPERATION_NAME - Operation for whihc metric needs to be recorded
 */

var getLivehelpLogContext = function getLivehelpLogContext(PAGE_NAME, OPERATION_NAME) {
  return {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME
  };
};
/**
 *                                       FAB Metrics and Logs
 */

/**
 * This method emits Count metric and log in Hawkeye when Employee uses Livehelp Inline
 * @param data - contact volume data
 */


var emitInlineContactMetric = function emitInlineContactMetric(data) {
  var OPERATION_NAME = 'EmployeeContactViaInline';
  var logContext = getLivehelpLogContextForInlineComponent(OPERATION_NAME, getClientId$1(), getPageName());
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Employee contacted via Livehelp Inline. Data - " + JSON.stringify(data), logContext);
};
/**
 * This method emits Count metric and log when Self Service Component is Shoen to the user
 * @param PAGE_NAME - page at which event happened
 */

var emitSSADisplayedMetric = function emitSSADisplayedMetric(PAGE_NAME) {
  var OPERATION_NAME = 'SelfServiceDisplayed';
  var logContext = getLivehelpLogContext(PAGE_NAME, OPERATION_NAME);
  recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Self Service content displayed to employee on " + PAGE_NAME + " page.", logContext);
};
/**
 * This method emits count metric and log everytime employee is shown active channels in inline component.
 */

var emitActiveChannelsDisplayedOnInlineMetric = function emitActiveChannelsDisplayedOnInlineMetric(activeLiveHelpChannels) {
  var OPERATION_NAME = 'EmployeeShownActiveChannels';
  var logContext = getLivehelpLogContextForInlineComponent(OPERATION_NAME, getClientId$1(), getPageName());
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Active Channels displayed to employee: " + activeLiveHelpChannels, logContext);
};
/**
 * This method emits count metric and log everytime employee see channels in inline component.
 */

var emitChannelsDisplayedOnInlineMetric = function emitChannelsDisplayedOnInlineMetric() {
  var OPERATION_NAME = 'EmployeeShownChannels';
  var logContext = getLivehelpLogContextForInlineComponent(OPERATION_NAME, getClientId$1(), getPageName());
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Channels displayed to employee.", logContext);
};
/**
 * This method emits count metric and log everytime employee clicks on FAB to open inline component.
 */

var emitUserClickedOnFabMetric = function emitUserClickedOnFabMetric() {
  var OPERATION_NAME = 'UserClickedFab';
  sessionStorage.setItem(START_TIME_WHEN_USER_CLICKED_FAB_KEY, String(Date.now()));
  var logContext = getLivehelpLogContextForInlineComponent(OPERATION_NAME, getClientId$1(), getPageName());
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : User clicked on FAB icon.", logContext);
};
/**
 * This method emits Latency metric for specific operation in FAB from time it was clicked
 * @param operationName - operation for which latency will be calculated
 */

var emitLatencyForSpecificOperationFromFabClick = function emitLatencyForSpecificOperationFromFabClick(operationName) {
  var startTimeWhenFabClicked = Number(sessionStorage.getItem(START_TIME_WHEN_USER_CLICKED_FAB_KEY));
  var logContext = getLivehelpLogContextForInlineComponent(operationName, getClientId$1(), getPageName());
  recordLatencyMetric(logContext.pageName, operationName, startTimeWhenFabClicked);
};
/**
 *                                      WPO Metrics and logs
 */

/**
 * This method emits count metric and log everytime WPO Agent is connected to WPO chat.
 */

var emitWPOChatAgentConnected = function emitWPOChatAgentConnected() {
  var OPERATION_NAME = 'AgentConnected';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Agent connected to WPO chat.", logContext);
};
/**
 * This method emits count metric and log everytime Employee disconnected WPO Chat.
 */

var emitWPOChatEmployeeEndedChat = function emitWPOChatEmployeeEndedChat() {
  var OPERATION_NAME = 'EmployeeEndedChat';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Employee Ended WPO Chat.", logContext);
};
/**
 * This method emits count metric and log everytime Agent disconnected WPO Chat.
 */

var emitWPOChatAgentDisconnectedChat = function emitWPOChatAgentDisconnectedChat() {
  var OPERATION_NAME = 'AgentEndedChat';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Agent Ended WPO Chat.", logContext);
};
/**
 * This method emits count metric and log everytime WPO Clinicians are not available.
 */

var emitWPOChatAgentsNotAvailable = function emitWPOChatAgentsNotAvailable() {
  var OPERATION_NAME = 'agentsNotAvailable';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Agents are not available to receive current WPO Chat.", logContext);
};
/**
 * This method emits count metric and log everytime employee downloads WPO Chat transcript.
 */

var emitWPOChatEmployeeDownloadedChatTranscript = function emitWPOChatEmployeeDownloadedChatTranscript() {
  var OPERATION_NAME = 'downloadTranscript';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Employee downloaded WPO Chat transcript.", logContext);
};
/**
 * This method emits count metric and log everytime employee ends chat before agent joins.
 */

var emitWPOChatEmployeeEndedChatBeforeAgentJoined = function emitWPOChatEmployeeEndedChatBeforeAgentJoined() {
  var OPERATION_NAME = 'employeeEndsChatBeforeAgentConnected';
  var logContext = getLivehelpLogContext(WPO_CHAT_CONTAINER_PAGE_NAME, OPERATION_NAME);
  recordCountMetric(logContext.pageName, OPERATION_NAME, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Employee ended WPO chat before agent is connected.", logContext);
};

var EnvName;

(function (EnvName) {
  EnvName["PROD"] = "prod";
  EnvName["BETA"] = "beta";
})(EnvName || (EnvName = {}));

var SourcePagesForLiveHelpRedirection;

(function (SourcePagesForLiveHelpRedirection) {
  SourcePagesForLiveHelpRedirection["SSA"] = "SSA";
  SourcePagesForLiveHelpRedirection["QUERY"] = "Query";
})(SourcePagesForLiveHelpRedirection || (SourcePagesForLiveHelpRedirection = {}));

var FAB_SESSION_DATA_OBJECT_NAME = 'livehelpFABSessionData';
/**
 * Function to read local storage and return FAB session data object
 * @returns Returns FAB session data object after parsing to JSON
 */

var getFABLocalStorageObject = function getFABLocalStorageObject() {
  return parseStringifiedObject(localStorage.getItem(FAB_SESSION_DATA_OBJECT_NAME));
};
/**
 * Function to set FAB session data object in local storage
 * @param object Object to store in local storage
 */

var setFABSessionDataObject = function setFABSessionDataObject(object) {
  localStorage.setItem(FAB_SESSION_DATA_OBJECT_NAME, stringifyObject(object));
};

var FIFTEEN_MINUTES_IN_MILLISECONDS = 15 * 60 * 1000;
var countWords = function countWords(text) {
  return text.split(/\s+/).filter(function (x) {
    return x.trim().length;
  }).length;
};
/**
 * For SSA redirection such as from Manage My Leave self-service buttons,
 * sourcePage query parameter captures granular information about employee's actions which led to LiveHelp.
 * This is a departure from previous understanding that SSA pages when redirecting to LiveHelp will pass `SSA` in sourcePage
 * in order to see call/chat contact options.
 * Adding this function to cover the new cases of redirection from SSA which need to open LiveHelp.
 * SIM: https://sim.amazon.com/issues/LiveHelp-297
 * @param source Query parameter `sourcePage` passed to LiveHelp redirection.
 * @returns A boolean value indicating if case in-sensitive SSA substring is present.
 */

function containsSSASubstring(source) {
  if (source) {
    return source.includes(SourcePagesForLiveHelpRedirection.SSA.toLowerCase()) || source.includes(SourcePagesForLiveHelpRedirection.SSA);
  }

  return false;
}
var getSiteHRRedirectFlag = function getSiteHRRedirectFlag() {
  return getPopstarFeatures().includes('myhr_chat_redirect');
};
/**
 * Sets inline request id if not already present.
 */

var setInlineRequestIdIfNotPresent = function setInlineRequestIdIfNotPresent() {
  var _fabSessionObject, _fabSessionObject2;

  var atozMyHRRequestId = localStorage.getItem(ATOZ_REQUEST_ID_KEY);
  var shouldReuseMyHRRequestId = !!atozMyHRRequestId && isCurrentSessionMyHR();
  var fabSessionObject = getFABLocalStorageObject();
  var isRequestIdExpired = !((_fabSessionObject = fabSessionObject) !== null && _fabSessionObject !== void 0 && _fabSessionObject.requestIdExpiryTime) || !((_fabSessionObject2 = fabSessionObject) !== null && _fabSessionObject2 !== void 0 && _fabSessionObject2.requestId) || Date.now() > fabSessionObject.requestIdExpiryTime;

  if (isRequestIdExpired) {
    fabSessionObject = {
      requestId: shouldReuseMyHRRequestId ? atozMyHRRequestId : v4(),
      requestIdExpiryTime: Date.now() + FIFTEEN_MINUTES_IN_MILLISECONDS
    };
    setFABSessionDataObject(fabSessionObject);
  } else {
    updateInlineRequestIdExpiryTime();
  }
};
/**
 * Updates inline request id expiry time
 */

var updateInlineRequestIdExpiryTime = function updateInlineRequestIdExpiryTime() {
  var fabSessionObject = getFABLocalStorageObject();

  if (fabSessionObject) {
    fabSessionObject.requestIdExpiryTime = Date.now() + FIFTEEN_MINUTES_IN_MILLISECONDS;
    setFABSessionDataObject(fabSessionObject);
  }
};
/**
 * Return request id. Fetches either myhr request id or live help inline request id based on whether
 * inline component is active.
 * If live help inline request id is not found, creates new request id and stores as live help inline.
 * Assumes myhr request id will always be present for myhr live help use case.
 */

var getRequestId = function getRequestId() {
  var _getFABLocalStorageOb, _getFABLocalStorageOb2;

  var requestId = isComponentInline() ? (_getFABLocalStorageOb = getFABLocalStorageObject()) === null || _getFABLocalStorageOb === void 0 ? void 0 : _getFABLocalStorageOb.requestId : localStorage.getItem(ATOZ_REQUEST_ID_KEY);

  if (requestId) {
    return requestId;
  } // Adding fallback in case request id is not found. Ideally this should only happen if user deletes request id manually.


  setInlineRequestIdIfNotPresent();
  return (_getFABLocalStorageOb2 = getFABLocalStorageObject()) === null || _getFABLocalStorageOb2 === void 0 ? void 0 : _getFABLocalStorageOb2.requestId;
};
/**
 * Genartates presentation details for given intent
 * @param intent context for showing live help channels
 */

var getPresentationDetailsFromIntent = function getPresentationDetailsFromIntent(intent) {
  return {
    title: (intent === null || intent === void 0 ? void 0 : intent.item) || (intent === null || intent === void 0 ? void 0 : intent.type) || (intent === null || intent === void 0 ? void 0 : intent.category) || ''
  };
};
var getPageNameForOmnitureMetrics = function getPageNameForOmnitureMetrics() {
  return isComponentInline() ? PageName.INLINE_OMNITURE_PAGE_NAME : PageName.OMNITURE_PAGE_NAME;
};
/**
 * Returns url prefix that can be used for redirection.
 *
 * * In MyHR, it can return either '/myhr or '/myhr2'. ie path for MyHR landing page
 * * In FAB, it will return empty string ('')
 */

var getMyHRUrlPrefix = function getMyHRUrlPrefix() {
  return isComponentInline() ? '' : '/' + location.pathname.split('/')[1];
};
/**
 * This method returns clientId appended with ttl timestamp of 15 minutes.
 */

var getMyHRClientIdWithTtl = function getMyHRClientIdWithTtl() {
  // time to live is 15 minutes from current time
  var timeToLive = Date.now() + FIFTEEN_MINUTES_IN_MILLISECONDS;
  return LaasClientId$1.MY_HR + "_" + timeToLive;
};

/**
 * @function logSelfServiceEmployeeActivity - function to log hawkeye metric for ssa redirection
 * @param userIntent - Category, Type, and Item for which employee needs help
 * @param selfServiceStartTime - Timestamp of when self service workflow is started
 */
var logSelfServiceEmployeeActivity = function logSelfServiceEmployeeActivity(_ref4) {
  var userIntent = _ref4.userIntent,
      selfServiceStartTime = _ref4.selfServiceStartTime;

  try {
    if (stage === 'test') {
      throw new Error('cannot log business metrics in local environment');
    }

    var dataToPublish = {
      datasetName: '',
      records: []
    };
    dataToPublish.datasetName = HawkeyeDatasets.SSA_EMPLOYEE_ACTIVITY + "-" + stage;
    var record = {
      requestId: getRequestId(),
      employeeId: getUserIdentifier(),
      recordTimestamp: myHRLogger$1.logUtils.recordCurrentTimestampISO(),
      selfServiceStartTimestamp: selfServiceStartTime.getTime(),
      intent: userIntent
    };
    /**
     * SSA_EMPLOYEE_ACTIVITY SCHEMA HISTORY
     * Schema 1 : https://sim.amazon.com/issues/P13NDE-290
     */

    dataToPublish.records.push(record);
    return Promise.resolve(myHRLogger$1.myHRDataPipelineLogInfo(dataToPublish)).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};
var logPriortyQueue = function logPriortyQueue(_ref3) {
  var sourceIntent = _ref3.sourceIntent,
      bussinessLine = _ref3.bussinessLine;

  try {
    if (stage === 'test') {
      throw new Error('cannot log business metrics in local environment');
    }

    var intent = {
      C: sourceIntent.C || EMPTY_STRING_LITERAL,
      T: sourceIntent.T || EMPTY_STRING_LITERAL,
      I: sourceIntent.I || EMPTY_STRING_LITERAL
    };
    var data = {
      datasetName: EMPTY_STRING_LITERAL,
      records: []
    };
    data.datasetName = HawkeyeDatasets.PRIORTY_QUEUE + '-' + stage;
    var record = {
      employeeId: getUserIdentifier(),
      recordTimestamp: myHRLogger$1.logUtils.recordCurrentTimestampISO(),
      userAgent: window.navigator.userAgent,
      bussinessLine: bussinessLine,
      intent: intent,
      requestId: getRequestId()
    };
    data.records.push(record);
    /**
     * PRIORTY_QUEUE SCHEMA HISTORY
     * Schema 1 : https://sim.amazon.com/issues/D60630331
     */

    data.schemaVersion = 1;
    return Promise.resolve(myHRLogger$1.myHRDataPipelineLogInfo(data)).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};
var logContactVolumeMetric = function logContactVolumeMetric(_ref2) {
  var sourceIntent = _ref2.sourceIntent,
      helpChannel = _ref2.helpChannel,
      clickSource = _ref2.clickSource,
      _ref2$typeOfMRI = _ref2.typeOfMRI,
      typeOfMRI = _ref2$typeOfMRI === void 0 ? NA : _ref2$typeOfMRI,
      connectProperties = _ref2.connectProperties,
      _ref2$variation = _ref2.variation,
      variation = _ref2$variation === void 0 ? NA : _ref2$variation,
      _ref2$clientId = _ref2.clientId,
      clientId = _ref2$clientId === void 0 ? LaasClientId$1.MY_HR : _ref2$clientId;

  try {
    if (stage === 'test') {
      throw new Error('cannot log business metrics in local environment');
    }

    var intent = {
      C: sourceIntent.C || EMPTY_STRING_LITERAL,
      T: sourceIntent.T || EMPTY_STRING_LITERAL,
      I: sourceIntent.I || EMPTY_STRING_LITERAL
    };
    var data = {
      datasetName: EMPTY_STRING_LITERAL,
      records: []
    };
    data.datasetName = HawkeyeDatasets.CONTACT_VOLUME + '-' + stage;
    var record = {
      employeeId: getUserIdentifier(),
      recordTimestamp: myHRLogger$1.logUtils.recordCurrentTimestampISO(),
      intent: intent,
      helpChannel: helpChannel,
      clickSource: clickSource || DEFAULT_CLICK_SOURCE,
      clientId: clientId,
      livehelpType: getLivehelpType(),
      typeOfMRI: typeOfMRI,
      requestId: getRequestId(),
      ingressChannel: IngressChannel.A2Z,
      variation: variation
    };
    connectProperties !== null ? record.connectProperties = connectProperties : record;
    data.records.push(record);
    /**
     * CONTACT_VOLUME SCHEMA HISTORY
     * Schema 1 : https://sim.amazon.com/issues/D37284298
     * Schema 2 : https://issues.amazon.com/issues/D45187064
     * Schema 3 : https://issues.amazon.com/issues/D51024831
     * Schema 4 : https://issues.amazon.com/issues/D59179802
     * Schema 5 : https://issues.amazon.com/issues/D66802781
     * Schema 6 : https://issues.amazon.com/issues/D69224459
     * Schema 7 : https://issues.amazon.com/issues/D74017337
     */

    data.schemaVersion = 7;
    return Promise.resolve(myHRLogger$1.myHRDataPipelineLogInfo(data)).then(function () {
      if (isComponentInline()) {
        emitInlineContactMetric(record);
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var logEmployeeActivityMetric = function logEmployeeActivityMetric(_ref) {
  var sourceIntent = _ref.sourceIntent,
      clickSource = _ref.clickSource,
      _ref$typeOfMRI = _ref.typeOfMRI,
      typeOfMRI = _ref$typeOfMRI === void 0 ? NA : _ref$typeOfMRI,
      _ref$variation = _ref.variation,
      variation = _ref$variation === void 0 ? NA : _ref$variation,
      _ref$clientId = _ref.clientId,
      clientId = _ref$clientId === void 0 ? LaasClientId$1.MY_HR : _ref$clientId;

  try {
    if (stage === 'test') {
      throw new Error('cannot log business metrics in local environment');
    }

    if (!sourceIntent.C) {
      return Promise.resolve();
    }

    var intent = {
      C: sourceIntent.C,
      T: sourceIntent.T || EMPTY_STRING_LITERAL,
      I: sourceIntent.I || EMPTY_STRING_LITERAL
    };
    var data = {
      datasetName: EMPTY_STRING_LITERAL,
      records: []
    };
    data.datasetName = HawkeyeDatasets.EMPLOYEE_ACTIVITY + '-' + stage;
    var record = {
      employeeId: getUserIdentifier(),
      recordTimestamp: myHRLogger$1.logUtils.recordCurrentTimestampISO(),
      userAgent: window.navigator.userAgent,
      requestId: getRequestId(),
      clickSource: clickSource || DEFAULT_CLICK_SOURCE,
      livehelpType: getLivehelpType(),
      clientId: clientId,
      typeOfMRI: typeOfMRI,
      intent: intent,
      variation: variation
    };
    data.records.push(record);
    /**
     * EMPLOYEE_ACTIVITY SCHEMA HISTORY
     * Schema 1 : https://issues.amazon.com/D37283160
     * Schema 2 : https://issues.amazon.com/issues/D45186664
     * Schema 3 : https://issues.amazon.com/issues/D51024633
     * Schema 4 : https://issues.amazon.com/issues/D51024633
     * Schema 5 : https://issues.amazon.com/issues/D59180099
     * Schema 6 : https://issues.amazon.com/issues/D66803027
     * Schema 7 : https://issues.amazon.com/issues/D69224654
     */

    data.schemaVersion = 7;
    return Promise.resolve(myHRLogger$1.myHRDataPipelineLogInfo(data)).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};
var stage = 'prod';
var myHRLogger$1 = /*#__PURE__*/new MyHRLogger(loggerConfig);
var getLivehelpType = function getLivehelpType() {
  if (isComponentInline()) {
    return LivehelpType.FAB;
  }

  return LivehelpType.MYHR;
};

var css_248z$2 = ".parent{margin-top:auto!important}.phone-footer-container{border-top:1px solid #6b6b6b;box-shadow:0 0 0 rgba(35,47,62,.3)}.phone-footer-container>div{display:flex;justify-content:center}.phone-footer-button{width:100%}.phone-footer-api-response-banner-text{padding-left:10px}.footer-request-call-again-text{margin-top:5px}";
styleInject(css_248z$2);

var Timer = function Timer(_ref) {
  var counter = _ref.counter,
      setCounter = _ref.setCounter,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 'T300' : _ref$fontSize;

  var _useState = useState(i18.getInstance),
      i18Instance = _useState[0];

  var _useTranslation = useTranslation(undefined, {
    i18n: i18Instance
  }),
      t = _useTranslation.t;

  useEffect(function () {
    var timer = setTimeout(function () {
      setCounter(function (counter) {
        return counter - 1;
      });
    }, 1000);

    if (counter === 0) {
      clearTimeout(timer);
    }
  }, [counter]);
  return /*#__PURE__*/React.createElement(Text$1, {
    role: "timer",
    fontSize: fontSize,
    fontWeight: "light",
    textAlign: "center",
    className: "footer-request-call-again-text"
  }, t('livehelp.timer_message', {
    counter: counter
  }));
};

var Footer = function Footer(_ref) {
  var handleSubmit = function handleSubmit() {
    try {
      var _props$employeeAttrib, _props$voiceContactCh, _props$voiceContactCh2, _props$voiceContactCh3, _props$waitTimeInMin, _props$isVoiceWaitTim, _props$timeStampForLi, _props$voiceContactCh4, _props$voiceContactCh5, _props$voiceContactCh6, _props$voiceContactCh7, _props$voiceContactCh8;

      setRequestCallError('livehelp.call_error_processing');
      var timeStampForRequestCallClick = Date.now();
      setRequestButtonDisabled(true);
      setCounter(60);
      recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.CLICKS_COUNT); // To lose focus on submit button when clicked for accessibility

      if (requestCallButtonRef.current) {
        requestCallButtonRef.current.blur();
      }

      if (successMessageRef.current) {
        successMessageRef.current.style.display = 'none';
      }

      if (failureMessageRef.current) {
        failureMessageRef.current.style.display = 'none';
      }

      if (destinationNotAllowedRef.current) {
        destinationNotAllowedRef.current.style.display = 'none';
      }

      if (phoneNumber === undefined || phoneNumber === '') {
        setErrorBanner(true);
        setRequestButtonDisabled(false);
        setCounter(0);
        return Promise.resolve();
      }

      setErrorBanner(false);
      var queryParams = {
        'x-myhr-client-id': 'MyHR_LiveHelp',
        operation: '/api/contact/voice'
      };
      var body = {
        attributes: {
          location_country: (_props$employeeAttrib = props.employeeAttributes) === null || _props$employeeAttrib === void 0 ? void 0 : _props$employeeAttrib.country,
          userLanguage: props.preferredLanguage,
          userContext: props.userContext,
          businessLine: (_props$voiceContactCh = props.voiceContactChannel) === null || _props$voiceContactCh === void 0 ? void 0 : _props$voiceContactCh.businessLine,
          queueId: (_props$voiceContactCh2 = props.voiceContactChannel) === null || _props$voiceContactCh2 === void 0 ? void 0 : _props$voiceContactCh2.queueId,
          queuePassed: (_props$voiceContactCh3 = props.voiceContactChannel) !== null && _props$voiceContactCh3 !== void 0 && _props$voiceContactCh3.queueId ? 'true' : 'false',
          waitTimeInMin: (_props$waitTimeInMin = props.waitTimeInMin) === null || _props$waitTimeInMin === void 0 ? void 0 : _props$waitTimeInMin.toString(),
          isWaitTimeDisplayed: (_props$isVoiceWaitTim = !props.isVoiceWaitTimeHidden) === null || _props$isVoiceWaitTim === void 0 ? void 0 : _props$isVoiceWaitTim.toString(),
          timeStampForLiveHelpClick: (_props$timeStampForLi = props.timeStampForLiveHelpClick) === null || _props$timeStampForLi === void 0 ? void 0 : _props$timeStampForLi.toString(),
          timeStampForRequestCallClick: timeStampForRequestCallClick === null || timeStampForRequestCallClick === void 0 ? void 0 : timeStampForRequestCallClick.toString()
        },
        voiceContactChannel: {
          instanceId: (_props$voiceContactCh4 = props.voiceContactChannel) === null || _props$voiceContactCh4 === void 0 ? void 0 : _props$voiceContactCh4.instanceId,
          contactFlowId: (_props$voiceContactCh5 = props.voiceContactChannel) === null || _props$voiceContactCh5 === void 0 ? void 0 : _props$voiceContactCh5.contactFlowId,
          queueId: (_props$voiceContactCh6 = props.voiceContactChannel) === null || _props$voiceContactCh6 === void 0 ? void 0 : _props$voiceContactCh6.queueId,
          sourcePhoneNumber: (_props$voiceContactCh7 = props.voiceContactChannel) === null || _props$voiceContactCh7 === void 0 ? void 0 : _props$voiceContactCh7.sourcePhoneNumber,
          region: (_props$voiceContactCh8 = props.voiceContactChannel) === null || _props$voiceContactCh8 === void 0 ? void 0 : _props$voiceContactCh8.region
        },
        destinationPhoneNumber: phoneNumber,
        connectAWSAccount: props.voiceAttributes.connectAWSAccount
      };

      if (!body.voiceContactChannel.instanceId || !body.voiceContactChannel.contactFlowId || !body.voiceContactChannel.region) {
        setShowErrorBanner(true);
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while creating voice contact channel. Invalid voice contact channel attributes - " + JSON.stringify(body.voiceContactChannel), logsContext);
        recordCountMetric(logsContext.pageName, logsContext.operationName, MetricEvents.INVALID_INPUT);
        return Promise.resolve();
      }

      var startTimeCreateVoiceContact = Date.now();
      backendServiceClient.post(body, queryParams).then(function (_result) {
        var _props$chatContactCha, _props$chatContactCha2, _props$chatContactCha3, _location$state, _location$state$props;

        recordLatencyMetric(PAGE_NAME, OPERATION_NAME, startTimeCreateVoiceContact);
        recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
        var parsedResponse = JSON.parse(_result.data.response);
        var contactId = parsedResponse.contactId;
        var receivedProps = props.location.state.propsToPass.receivedProps;
        var intentDisambiguted = props.userContext.split('_');
        var intent = {
          C: intentDisambiguted[0],
          T: intentDisambiguted[1],
          I: intentDisambiguted[2]
        };
        var connectProperties = {
          instanceId: (_props$chatContactCha = props.chatContactChannel) === null || _props$chatContactCha === void 0 ? void 0 : _props$chatContactCha.instanceId,
          contactFlowId: (_props$chatContactCha2 = props.chatContactChannel) === null || _props$chatContactCha2 === void 0 ? void 0 : _props$chatContactCha2.contactFlowId,
          queueId: (_props$chatContactCha3 = props.chatContactChannel) === null || _props$chatContactCha3 === void 0 ? void 0 : _props$chatContactCha3.queueId,
          contactId: contactId
        };
        logContactVolumeMetric({
          sourceIntent: intent,
          helpChannel: HelpChannel.VOICE,
          connectProperties: connectProperties,
          clickSource: liveHelpClickSource,
          typeOfMRI: receivedProps.typeOfMRI,
          variation: receivedProps.variation,
          clientId: (_location$state = location.state) === null || _location$state === void 0 ? void 0 : (_location$state$props = _location$state.propsToPass) === null || _location$state$props === void 0 ? void 0 : _location$state$props.clientId
        })["catch"](function (error) {
          myHRLoggerErrorLog("[" + userIdentifier + "]: Unable to publish business volume metric from voice. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
            operationName: CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC
          }));
          recordErrorCountMetric(PAGE_NAME, CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC, JSON.stringify(error));
        }); // show success banner

        if (successMessageRef.current) {
          successMessageRef.current.style.display = 'block';
        }
      })["catch"](function (error) {
        var _error$response, _error$response$data;

        setRequestButtonDisabled(false);
        setCounter(0);
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while starting outbound voice contact calling CreateVoiceContact API. " + getDetailedErrorMessage(error), logsContext);
        var errorMessage = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message;

        if (errorMessage !== null && errorMessage !== void 0 && errorMessage.includes(Exceptions.DESTINATION_NOT_ALLOWED)) {
          onDestinationNotAllowedException(error);
        } else {
          onGenericException(error);
        }
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var showDesktopView = _ref.showDesktopView,
      props = _ref.props,
      phoneNumber = _ref.phoneNumber,
      setErrorBanner = _ref.setErrorBanner,
      liveHelpClickSource = _ref.liveHelpClickSource;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var isMobile = matches === null || matches === void 0 ? void 0 : matches.s;
  var liveHelpInlineContext = useLiveHelpInlineContext();
  var isCallInlineActive = (liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.activeChannel) === LiveHelpChannel.CALL;
  var userIdentifier = getUserIdentifier();
  var PAGE_NAME = 'LiveHelpVoiceCall';
  var OPERATION_NAME = 'CreateVoiceContact';
  var DESTINATION_NOT_ALLOWED_OPERATION = 'CreateVoiceContact:DestinationNotAllowedException';

  var _useState = useState(false),
      requestButtonDisabled = _useState[0],
      setRequestButtonDisabled = _useState[1];

  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var location = useLocation();

  var _useState2 = useState(false),
      showErrorBanner = _useState2[0],
      setShowErrorBanner = _useState2[1];

  var _useState3 = useState('livehelp.call_error_processing'),
      requestCallError = _useState3[0],
      setRequestCallError = _useState3[1];

  var _useState4 = useState(0),
      counter = _useState4[0],
      setCounter = _useState4[1];

  var errorMessage = t('livehelp.generic_error_message');
  var successMessageRef = useRef(null);
  var failureMessageRef = useRef(null);
  var destinationNotAllowedRef = useRef(null);
  var requestCallButtonRef = useRef(null);
  var backendServiceClient = new BackendServiceClientWrapper();

  function onDestinationNotAllowedException(error) {
    recordErrorCountMetric(PAGE_NAME, DESTINATION_NOT_ALLOWED_OPERATION, JSON.stringify(error)); // show error banner

    if (destinationNotAllowedRef.current) {
      destinationNotAllowedRef.current.style.display = 'block';
    }
  }

  function onGenericException(error) {
    recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(error)); // show error banner

    if (failureMessageRef.current) {
      failureMessageRef.current.style.display = 'block';
    }
  }

  var getRequestCallButton = function getRequestCallButton() {
    return [/*#__PURE__*/React.createElement(Button, {
      key: "livehelp-inline-request-call-btn",
      ref: requestCallButtonRef,
      tabIndex: 0,
      style: {
        width: isCallInlineActive ? isMobile ? '100%' : 'auto' : '100%'
      },
      onClick: handleSubmit,
      variant: ButtonVariant.Primary,
      size: isCallInlineActive ? ButtonSize.Small : ButtonSize.Default,
      className: !isCallInlineActive ? 'phone-footer-button' : '',
      disabled: requestButtonDisabled && counter > 0
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: isCallInlineActive ? LiveHelpInlineFontScheme.FOOTER_BUTTON : matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    }, isCallInlineActive ? t('livehelp.request_call') : t('livehelp.request_a_call')))];
  };

  var getCancelButton = function getCancelButton() {
    return [/*#__PURE__*/React.createElement(Button, {
      key: "livehelp-inline-cancel-btn",
      variant: isMobile ? ButtonVariant.Secondary : ButtonVariant.Tertiary,
      size: ButtonSize.Small,
      style: {
        width: isMobile ? '100%' : 'auto'
      },
      onClick: function onClick() {
        return liveHelpInlineContext.closeModal();
      }
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: isCallInlineActive ? LiveHelpInlineFontScheme.FOOTER_BUTTON : matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    }, t('livehelp.cancel')))];
  };

  useEffect(function () {
    if (isCallInlineActive && props.voiceAttributes) {
      liveHelpInlineContext.setLiveHelpServiceState({
        liveHelpInlineFooterActions: [].concat(getCancelButton(), getRequestCallButton())
      });
    }
  }, [liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.activeChannel, requestButtonDisabled, props.voiceAttributes, phoneNumber]);
  useEffect(function () {
    if (counter === 0) {
      setRequestButtonDisabled(false);
    }
  }, [counter]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "parent"
  }, /*#__PURE__*/React.createElement(CustomBanner, {
    backgroundColor: "#d7f3ed",
    iconColor: "#24756b",
    text: "livehelp.amazon_support_contact_shortly",
    refs: successMessageRef
  }), /*#__PURE__*/React.createElement(CustomBanner, {
    backgroundColor: "#fce1df",
    iconColor: "#ba282a",
    text: requestCallError,
    refs: failureMessageRef
  }), /*#__PURE__*/React.createElement(DestinationNotAllowedExceptionBanner, {
    refs: destinationNotAllowedRef
  }), /*#__PURE__*/React.createElement(Container, {
    paddingBottom: 16,
    paddingTop: 16,
    className: !showDesktopView && !isCallInlineActive ? 'phone-footer-container' : ''
  }, !isCallInlineActive && getRequestCallButton(), requestButtonDisabled && counter > 0 && /*#__PURE__*/React.createElement(Timer, {
    counter: counter,
    setCounter: setCounter,
    fontSize: isCallInlineActive ? LiveHelpInlineFontScheme.REQUEST_CALL_TIMER_MSG : 'T300'
  })), showErrorBanner && /*#__PURE__*/React.createElement(ChatErrorBanner, {
    message: errorMessage
  })));
};

var css_248z$3 = ".phone-header-heading-desktop{color:#161e2d!important;font-weight:700!important;line-height:44px!important}.phone-header-heading:focus-visible{outline:none!important}.phone-header-subtext{color:#000!important;font-weight:400!important;line-height:1.5!important;margin:14px 0 0!important}.phone-header-subtext-mobile{margin-top:14px!important}.phone-view-heading{color:#161e2d!important;font-weight:400!important;line-height:32px!important}";
styleInject(css_248z$3);

var Header = function Header(props) {
  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var headingRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    isFullWidth: true
  }, /*#__PURE__*/React.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(H1, {
    tabIndex: -1,
    className: props.showDesktopView ? 'phone-header-heading-desktop' : 'phone-view-heading',
    id: "phone-contact-card-heading",
    style: {
      fontSize: props.showDesktopView ? FontSize.HEADER_DESKTOP : FontSize.HEADER_MOBILE
    },
    ref: headingRef
  }, t('livehelp.request_a_call')))), /*#__PURE__*/React.createElement(Text$1, {
    className: matches.s ? 'phone-header-subtext-mobile' : 'phone-header-subtext',
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
  }, t('livehelp.request_phone_call_heading_2')));
};

var css_248z$4 = ".phone-contact-card{overflow:visible!important;width:550px!important}.phone-contact-card-mobile{background:#f2f2f2;height:100vh!important;overflow:scroll!important;width:100vw!important}.phone-contact-card-container{padding-top:42px;width:100%}.phone-contact-card-container-inline{padding-top:0;width:100%}.phone-contact-card-container-width{max-width:768px}@media only screen and (min-width:601px) and (max-width:768px){.phone-contact-card-container-width{max-width:550px}}";
styleInject(css_248z$4);

var css_248z$5 = ".phone-input{display:flex;font-size:16px;height:44px!important;justify-content:center;padding-bottom:8px;padding-top:8px}.phone-input-width-desktop{width:550px!important}.phone-input-width-mobile{width:100%!important}.phone-input-border{border:2px solid #56616c}.phone-input-error-border{border:2px solid #bb2929}#phone-banner{background-color:#d7ebfb;border-left:5px solid #379aec;margin-bottom:8px;margin-top:8px;padding:8px}#error-banner{margin-top:4px}.phone-list{-webkit-padding-start:12px;padding-inline-start:12px}.phone-banner-heading{-webkit-padding-start:8px;color:#394451!important;font-weight:500!important;line-height:1.5!important;padding-inline-start:8px}.phone-banner-list-item{margin-bottom:0!important}.phone-input-label{font-weight:400!important}.text-padding{padding:2px!important}";
styleInject(css_248z$5);

var PhoneBanner = function PhoneBanner(_ref) {
  var _voiceContactChannel$;

  var voiceContactChannel = _ref.voiceContactChannel,
      employeeCountry = _ref.employeeCountry;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var IndiaCountryCode = 'IND';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    id: "phone-banner"
  }, /*#__PURE__*/React.createElement(Container, {
    paddingTop: 4,
    paddingBottom: 8,
    paddingHorizontal: 0
  }, /*#__PURE__*/React.createElement(H3, {
    className: "phone-banner-heading",
    style: {
      fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    }
  }, t('livehelp.what_to_expect')), /*#__PURE__*/React.createElement(Container, {
    paddingTop: 8,
    paddingHorizontal: 12
  }, /*#__PURE__*/React.createElement("ul", {
    className: "phone-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    color: "#232F3E",
    className: "phone-banner-list-item text-padding"
  }, voiceContactChannel !== null && voiceContactChannel !== void 0 && (_voiceContactChannel$ = voiceContactChannel.sourcePhoneNumber) !== null && _voiceContactChannel$ !== void 0 && _voiceContactChannel$.length && employeeCountry !== IndiaCountryCode ? t('livehelp.receive_call_number', {
    contactNumber: voiceContactChannel === null || voiceContactChannel === void 0 ? void 0 : voiceContactChannel.sourcePhoneNumber
  }) : t('livehelp.receive_call_HR_team'))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    color: "#232F3E",
    className: "text-padding"
  }, t('livehelp.agent_hold_without_wait_time'))))))));
};

var PhoneContainer = function PhoneContainer(_ref) {
  var phoneNumber = _ref.phoneNumber,
      setPhoneNumber = _ref.setPhoneNumber,
      voiceContactChannel = _ref.voiceContactChannel,
      employeeCountry = _ref.employeeCountry,
      errorBanner = _ref.errorBanner,
      setErrorBanner = _ref.setErrorBanner,
      showDesktopView = _ref.showDesktopView;
  var errorBannerRef = useRef(null);
  var phoneInputRef = useRef(null);

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  if (errorBanner) {
    // show error banner
    if (errorBannerRef.current) {
      errorBannerRef.current.style.display = 'block';

      if (phoneInputRef.current) {
        phoneInputRef.current.setAttribute('aria-invalid', 'true');
        phoneInputRef.current.setAttribute('aria-describedby', 'error-banner');
      }
    }
  } else if (errorBannerRef.current) {
    // hide error banner
    errorBannerRef.current.style.display = 'none';

    if (phoneInputRef.current) {
      phoneInputRef.current.removeAttribute('aria-invalid');
      phoneInputRef.current.removeAttribute('aria-describedby');
    }
  }

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  function phoneNumberTranslations() {
    return t('livehelp.input_phone_number').toString();
  }

  return /*#__PURE__*/React.createElement(Container, {
    isFullWidth: true
  }, /*#__PURE__*/React.createElement(Text$1, {
    margin: {
      top: 14
    },
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    "aria-hidden": "true"
  }, '* ' + t('livehelp.required_field')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text$1, {
    color: "#56616c",
    lineHeight: 1.5,
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "phone-input-box",
    className: "phone-input-label"
  }, t('livehelp.what_your_preffered_number'), " ", /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "*"))), /*#__PURE__*/React.createElement(Input, {
    "aria-required": "true",
    international: true,
    withCountryCallingCode: true,
    ref: phoneInputRef,
    tabIndex: 0,
    className: 'phone-input' + (errorBanner ? ' phone-input-error-border' : ' phone-input-border') + (showDesktopView ? ' phone-input-width-desktop' : ' phone-input-width-mobile'),
    id: "phone-input-box",
    placeholder: phoneNumberTranslations(),
    value: phoneNumber,
    onChange: function onChange(e) {
      setPhoneNumber(e);
      setErrorBanner(false);
    }
  }), /*#__PURE__*/React.createElement(CustomBanner, {
    backgroundColor: "#FEF0EF",
    iconColor: "#bb2929",
    text: "livehelp.phone_number_cannot_be_empty",
    refs: errorBannerRef,
    options: {
      id: 'error-banner'
    }
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(PhoneBanner, {
    voiceContactChannel: voiceContactChannel,
    employeeCountry: employeeCountry
  }));
};

var countries = /*#__PURE__*/require('i18n-iso-countries');

var PhoneContactCard = function PhoneContactCard(props) {
  var _props$employeeAttrib, _props$employeeAttrib2, _updatedProps$employe5, _updatedProps$employe6;

  var localStoragePropsKey = 'phoneContactCard_props';

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var liveHelpInlineContext = useLiveHelpInlineContext();
  var isCallInlineActive = (liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.activeChannel) === LiveHelpChannel.CALL;

  var _useState = useState({
    voiceContactChannel: undefined,
    employeeAttributes: undefined,
    preferredLanguage: '',
    voiceAttributes: undefined,
    userContext: '',
    crumbs: [],
    waitTimeInMin: undefined,
    isVoiceWaitTimeHidden: false,
    timeStampForLiveHelpClick: undefined,
    receivedProps: undefined,
    liveHelpClickSource: ''
  }),
      updatedProps = _useState[0],
      setUpdatedProps = _useState[1];

  var mobileViewPadding = {
    top: !isCallInlineActive ? '8%' : '0%',
    left: '4.27%',
    right: '4.27%'
  };
  useEffect(function () {
    setInternalProps();
    return function () {
      localStorage.removeItem(localStoragePropsKey);
    };
  }, []);
  useEffect(function () {
    var _updatedProps$employe, _updatedProps$employe2;

    if ((_updatedProps$employe = updatedProps.employeeAttributes) !== null && _updatedProps$employe !== void 0 && _updatedProps$employe.mobilePhone && ((_updatedProps$employe2 = updatedProps.employeeAttributes) === null || _updatedProps$employe2 === void 0 ? void 0 : _updatedProps$employe2.mobilePhone) !== phoneNumber) {
      var _updatedProps$employe3, _updatedProps$employe4;

      setPhoneNumber(getParsedPhoneNumber(updatedProps === null || updatedProps === void 0 ? void 0 : (_updatedProps$employe3 = updatedProps.employeeAttributes) === null || _updatedProps$employe3 === void 0 ? void 0 : _updatedProps$employe3.mobilePhone, updatedProps === null || updatedProps === void 0 ? void 0 : (_updatedProps$employe4 = updatedProps.employeeAttributes) === null || _updatedProps$employe4 === void 0 ? void 0 : _updatedProps$employe4.country));
    }
  }, [updatedProps]);

  var getParsedPhoneNumber = function getParsedPhoneNumber(mobilePhone, country) {
    var _parsePhoneNumber;

    return mobilePhone ? (_parsePhoneNumber = parsePhoneNumber(mobilePhone, countries.alpha3ToAlpha2(country))) === null || _parsePhoneNumber === void 0 ? void 0 : _parsePhoneNumber.number : '';
  };

  var TITLE = 'MyHR | Livehelp | Call HR';

  var _useState2 = useState(getParsedPhoneNumber((_props$employeeAttrib = props.employeeAttributes) === null || _props$employeeAttrib === void 0 ? void 0 : _props$employeeAttrib.mobilePhone, (_props$employeeAttrib2 = props.employeeAttributes) === null || _props$employeeAttrib2 === void 0 ? void 0 : _props$employeeAttrib2.country)),
      phoneNumber = _useState2[0],
      setPhoneNumber = _useState2[1];

  var _useState3 = useState(false),
      errorBanner = _useState3[0],
      setErrorBanner = _useState3[1];

  var phoneContactCardRef = useRef(null);

  var setInternalProps = function setInternalProps() {
    var _props$crumbs;

    if (((_props$crumbs = props.crumbs) === null || _props$crumbs === void 0 ? void 0 : _props$crumbs.length) > 0) {
      setUpdatedProps(props);
      localStorage.setItem(localStoragePropsKey, stringifyObject(props));
    } else {
      setUpdatedProps(parseStringifiedObject(localStorage.getItem(localStoragePropsKey)));
    }
  };

  useTitle(TITLE);
  var desktopView = /*#__PURE__*/React.createElement(View$1, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    backgroundColor: !isCallInlineActive ? '#F2F2F2' : '#FFFFFF',
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(View$1, {
    className: (isCallInlineActive ? 'phone-contact-card-container-inline' : 'phone-contact-card-container') + " phone-contact-card-container-width"
  }, !isCallInlineActive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomBreadcrumbs, {
    crumbs: updatedProps.crumbs !== undefined ? updatedProps.crumbs : []
  })), /*#__PURE__*/React.createElement(Header, {
    showDesktopView: true
  }), /*#__PURE__*/React.createElement(View$1, {
    className: "phone-contact-card"
  }, /*#__PURE__*/React.createElement(PhoneContainer, {
    phoneNumber: phoneNumber,
    setPhoneNumber: setPhoneNumber,
    voiceContactChannel: updatedProps.voiceContactChannel,
    employeeCountry: (_updatedProps$employe5 = updatedProps.employeeAttributes) === null || _updatedProps$employe5 === void 0 ? void 0 : _updatedProps$employe5.country,
    errorBanner: errorBanner,
    setErrorBanner: setErrorBanner,
    showDesktopView: true
  }), /*#__PURE__*/React.createElement(Footer, {
    showDesktopView: true,
    props: updatedProps,
    phoneNumber: phoneNumber,
    setErrorBanner: setErrorBanner,
    liveHelpClickSource: updatedProps.liveHelpClickSource
  }))));
  var mobileView = /*#__PURE__*/React.createElement(View$1, {
    height: "100%",
    className: !isCallInlineActive ? 'phone-contact-card-mobile' : '',
    tabIndex: -1,
    ref: phoneContactCardRef
  }, /*#__PURE__*/React.createElement(View$1, {
    height: "100%",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    padding: mobileViewPadding
  }, !isCallInlineActive && /*#__PURE__*/React.createElement(Header, {
    showDesktopView: false
  }), /*#__PURE__*/React.createElement(PhoneContainer, {
    phoneNumber: phoneNumber,
    setPhoneNumber: setPhoneNumber,
    voiceContactChannel: updatedProps.voiceContactChannel,
    employeeCountry: updatedProps === null || updatedProps === void 0 ? void 0 : (_updatedProps$employe6 = updatedProps.employeeAttributes) === null || _updatedProps$employe6 === void 0 ? void 0 : _updatedProps$employe6.country,
    errorBanner: errorBanner,
    setErrorBanner: setErrorBanner,
    showDesktopView: false
  }), /*#__PURE__*/React.createElement(Footer, {
    props: updatedProps,
    phoneNumber: phoneNumber,
    setErrorBanner: setErrorBanner,
    showDesktopView: false,
    liveHelpClickSource: updatedProps.liveHelpClickSource
  })));
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18.getInstance()
  }, matches.s ? mobileView : desktopView));
};

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

function _isSettledPact(thenable) {
	return thenable instanceof _Pact && thenable.s & 1;
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a do ... while loop
function _do(body, test) {
	var awaitBody;
	do {
		var result = body();
		if (result && result.then) {
			if (_isSettledPact(result)) {
				result = result.v;
			} else {
				awaitBody = true;
				break;
			}
		}
		var shouldContinue = test();
		if (_isSettledPact(shouldContinue)) {
			shouldContinue = shouldContinue.v;
		}
		if (!shouldContinue) {
			return result;
		}
	} while (!shouldContinue.then);
	const pact = new _Pact();
	const reject = _settle.bind(null, pact, 2);
	(awaitBody ? result.then(_resumeAfterBody) : shouldContinue.then(_resumeAfterTest)).then(void 0, reject);
	return pact;
	function _resumeAfterBody(value) {
		result = value;
		for (;;) {
			shouldContinue = test();
			if (_isSettledPact(shouldContinue)) {
				shouldContinue = shouldContinue.v;
			}
			if (!shouldContinue) {
				break;
			}
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
				return;
			}
			result = body();
			if (result && result.then) {
				if (_isSettledPact(result)) {
					result = result.v;
				} else {
					result.then(_resumeAfterBody).then(void 0, reject);
					return;
				}
			}
		}
		_settle(pact, 1, result);
	}
	function _resumeAfterTest(shouldContinue) {
		if (shouldContinue) {
			do {
				result = body();
				if (result && result.then) {
					if (_isSettledPact(result)) {
						result = result.v;
					} else {
						result.then(_resumeAfterBody).then(void 0, reject);
						return;
					}
				}
				shouldContinue = test();
				if (_isSettledPact(shouldContinue)) {
					shouldContinue = shouldContinue.v;
				}
				if (!shouldContinue) {
					_settle(pact, 1, result);
					return;
				}
			} while (!shouldContinue.then);
			shouldContinue.then(_resumeAfterTest).then(void 0, reject);
		} else {
			_settle(pact, 1, result);
		}
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, result);
}

var PageTitle;

(function (PageTitle) {
  PageTitle["LIVE_HELP"] = "MyHR | Livehelp";
  PageTitle["CHAT_WITH_HR"] = "MyHR | Livehelp | Chat with HR";
  PageTitle["NEW_CHAT_MESSAGE"] = " new messages | Live chat with HR";
  PageTitle["CHAT_DISCONNECTING_SOON"] = "Disconnecting soon | Live chat with HR";
})(PageTitle || (PageTitle = {}));

/*
 * Custom hook to check if the browser page is currently visible or hidden
 */

function usePageVisibility() {
  var _useState = useState(!document.hidden),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var onVisibilityChange = function onVisibilityChange() {
    setIsVisible(!document.hidden);
  };

  useEffect(function () {
    document.addEventListener('visibilitychange', onVisibilityChange, false);
    return function () {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
  return isVisible;
}

/**
 * @function getTranslatedContentFromTAS - function to fetch translated texts from TAS
 * @param translationId - translationId corresponding to the translated text
 * @param locale - target locale, ex. en-US
 */

var getTranslatedContentFromTAS = function getTranslatedContentFromTAS(translationId, locale) {
  try {
    var backendServiceClient = new BackendServiceClientWrapper();
    var queryParams = {
      'x-myhr-client-id': 'MyHR_TAS',
      operation: 'FetchTranslation',
      path: "/v1/translations/" + translationId + "?locale=" + locale
    };
    return Promise.resolve(_catch(function () {
      return Promise.resolve(backendServiceClient.get(queryParams));
    }, function () {
      return getEnglishContentFromTAS(translationId);
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var getEnglishContentFromTAS = function getEnglishContentFromTAS(translationId) {
  try {
    var backendServiceClient = new BackendServiceClientWrapper();
    var queryParams = {
      'x-myhr-client-id': 'MyHR_TAS',
      operation: 'FetchTranslation',
      path: "/v1/translations/" + translationId + "?locale=en-US"
    };
    return Promise.resolve(backendServiceClient.get(queryParams));
  } catch (e) {
    return Promise.reject(e);
  }
};

// here vw and vh are the css width and height e.g. (vw can be 30vw and vh can 30 vh)
function convertVwToPx(vw) {
  var vw2num = parseInt(vw.split('vx')[0], 10);
  return vw2num * document.documentElement.clientWidth / 100;
}

function convertVhToPx(vh) {
  var vh2num = parseInt(vh.split('vh')[0], 10);
  return vh2num * document.documentElement.clientHeight / 100;
}

var ChatSpinner = function ChatSpinner() {
  return /*#__PURE__*/React.createElement(Container, {
    paddingTop: "40%"
  }, /*#__PURE__*/React.createElement(SuspenseLoader, null));
};

var ChatContext = /*#__PURE__*/createContext(null);
var useChatContext = function useChatContext() {
  return useContext(ChatContext);
};

var wait = function wait(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

var retryOperation = function retryOperation(operation, delay, retries) {
  if (delay === void 0) {
    delay = 1000;
  }

  if (retries === void 0) {
    retries = 2;
  }

  return new Promise(function (resolve, reject) {
    return operation().then(function (data) {
      resolve(data);
    })["catch"](function (reason) {
      if (retries > 0) {
        return wait(delay).then(retryOperation.bind(null, operation, delay, retries - 1)).then(function (data) {
          resolve(data);
        })["catch"](reject);
      }

      return reject(reason);
    });
  });
};

var MessageType;

(function (MessageType) {
  MessageType["Attachment"] = "ATTACHMENT";
  MessageType["Message"] = "MESSAGE";
  MessageType["ChatInfo"] = "CHAT_INFO";
  MessageType["Event"] = "EVENT";
})(MessageType || (MessageType = {}));

var EndChatType;

(function (EndChatType) {
  EndChatType["AgentNotAvailable"] = "There are currently no agents available, please try again later.";
})(EndChatType || (EndChatType = {}));

var ContentType;

(function (ContentType) {
  ContentType["AgentJoined"] = "application/vnd.amazonaws.connect.event.participant.joined";
  ContentType["AgentLeft"] = "application/vnd.amazonaws.connect.event.participant.left";
  ContentType["ChatEnded"] = "application/vnd.amazonaws.connect.event.chat.ended";
  ContentType["ChatTransferSucceeded"] = "application/vnd.amazonaws.connect.event.transfer.succeeded";
})(ContentType || (ContentType = {}));

var TIME_FOR_DOWNLOAD = 4000;
var DELAY_FOR_REFRESH = 8000;
var DEFAULT_IDLENESS_DISCONNECT_TIME_OUT_IN_MINUTES = 5;
var WARNING_TIMEOUT_DELTA_IN_MINUTES = 2; //delta for warning and disconnect idleness time out

var ParticipantRole;

(function (ParticipantRole) {
  ParticipantRole["Agent"] = "AGENT";
  ParticipantRole["Customer"] = "CUSTOMER";
  ParticipantRole["System"] = "SYSTEM";
})(ParticipantRole || (ParticipantRole = {}));

var ChatRecordingBehavior;

(function (ChatRecordingBehavior) {
  ChatRecordingBehavior["Consent"] = "Consent";
  ChatRecordingBehavior["Decline"] = "Decline";
  ChatRecordingBehavior["OptIn"] = "OptIn";
})(ChatRecordingBehavior || (ChatRecordingBehavior = {}));

var IdlenessReminder;

(function (IdlenessReminder) {
  IdlenessReminder["NotActive"] = "";
  IdlenessReminder["Warning"] = "warning";
  IdlenessReminder["Disconnect"] = "disconnect";
})(IdlenessReminder || (IdlenessReminder = {}));

var TimerState;

(function (TimerState) {
  TimerState["NotActive"] = "";
  TimerState["ResetTimer"] = "reset";
})(TimerState || (TimerState = {}));

var DisconnectFor;

(function (DisconnectFor) {
  DisconnectFor["NotActive"] = "";
  DisconnectFor["Window"] = "Window";
  DisconnectFor["Session"] = "Session";
})(DisconnectFor || (DisconnectFor = {}));

var ChatSessionConnectionStatus;

(function (ChatSessionConnectionStatus) {
  ChatSessionConnectionStatus["DescribeIssue"] = "DESCRIBE_ISSUE";
  ChatSessionConnectionStatus["Attempting"] = "ATTEMPTING";
  ChatSessionConnectionStatus["Connected"] = "CONNECTED";
  ChatSessionConnectionStatus["Failure"] = "FAILED_TO_CONNECT";
  ChatSessionConnectionStatus["Ended"] = "JUST_ENDED_SESSION";
})(ChatSessionConnectionStatus || (ChatSessionConnectionStatus = {}));

var ChatSessionActionResponse;

(function (ChatSessionActionResponse) {
  ChatSessionActionResponse["DownloadAttachmentSuccessful"] = "DownloadAttachmentSuccessful";
  ChatSessionActionResponse["DownloadAttachmentFailed"] = "DownloadAttachmentFailed";
  ChatSessionActionResponse["DownloadChatFailed"] = "DownloadChatFailed";
  ChatSessionActionResponse["DownloadChatSuccessful"] = "DownloadChatSuccessful";
  ChatSessionActionResponse["MessageSentSuccessful"] = "MessageSentSuccessful";
  ChatSessionActionResponse["MessageSentFailed"] = "MessageSentFailed";
  ChatSessionActionResponse["NoAction"] = "NoAction";
})(ChatSessionActionResponse || (ChatSessionActionResponse = {}));

var defaultChatState = {
  isLiveHelpInlineSource: false,
  isActive: false,
  isChatMinimized: false,
  chatTokens: null,
  instanceId: null,
  region: null,
  cti: null,
  employeeAttributes: null,
  showWaitTime: false,
  waitTime: null,
  businessLine: null,
  idlenessReminder: IdlenessReminder.NotActive,
  idlenessBannerTimeInMinutes: WARNING_TIMEOUT_DELTA_IN_MINUTES,
  idlenessDisconnectTimeOutInMinutes: null,
  currentLanguage: null,
  timerState: TimerState.NotActive,
  activateListener: true,
  disconnectFor: DisconnectFor.NotActive,
  agentConnected: false,
  confirmExit: false,
  contactFlowId: null,
  queueId: null,
  userContext: null,
  timeStampForLiveHelpClick: /*#__PURE__*/Date.now(),
  timeStampForChatClick: /*#__PURE__*/Date.now(),
  waitingForAgentPostTransfer: false,
  newChatSession: true,
  connectAWSAccount: '',
  liveHelpClickSource: '',
  isDescribeIssue: true,
  clientId: LaasClientId.MY_HR,
  chatRecordingBehavior: ChatRecordingBehavior.Decline
};
var defaultChatSession = {
  chatSession: null,
  connectionStatus: ChatSessionConnectionStatus.Attempting,
  errorMessage: '',
  actionResponse: ChatSessionActionResponse.NoAction
};
var MAX_CONTAINER_HEIGHT = '100vh';
var MIN_CONTAINER_HEIGHT_BROWSER = '80vh';
var MAX_CONTAINER_WIDTH = '100vw';
var MIN_CONTAINER_WIDTH_BROWSER = '30vw';
var BROWSER_RESIZE_SIDES_ENABLED = {
  top: true,
  right: false,
  bottom: false,
  left: true,
  topRight: false,
  bottomRight: false,
  topLeft: true,
  bottomLeft: false
};
var MOBILE_RESIZE_SIDES_ENABLED = {
  top: false,
  right: false,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: false,
  topLeft: false,
  bottomLeft: false
};
var AttachmentUploadStatus;

(function (AttachmentUploadStatus) {
  AttachmentUploadStatus["Ready"] = "READY_TO_UPLOAD";
  AttachmentUploadStatus["Uploading"] = "UPLOADING";
  AttachmentUploadStatus["Inactive"] = "INACTIVE";
})(AttachmentUploadStatus || (AttachmentUploadStatus = {}));

var RESIZABLE_DIMENSIONS = {
  chatView: {
    maxHeight: '100vh',
    minHeight: '80vh',
    minWidth: '30vw',
    maxWidth: '100vw'
  },
  registerView: {
    maxHeight: '70vh',
    minHeight: '70vh',
    minWidth: '20vw',
    maxWidth: '25vw'
  }
};

var AttachmentUploadFailedBanner = function AttachmentUploadFailedBanner(props) {
  return /*#__PURE__*/React.createElement(MessageBanner, {
    type: MessageBannerType.Error,
    isDismissible: true,
    onDismissed: props.onDismiss
  }, props.errorMessage);
};

var css_248z$6 = ".footer-container{box-shadow:0 -4px 10px rgba(35,47,62,.3);margin-top:auto!important}.chat-history-footer-container-zoomed,.footer-container{background:#fff;border-top:1px solid #6b6b6b;width:100%;z-index:1}.chat-history-footer-container-zoomed{height:2px;margin-top:auto}.chat-history-container-view{padding:12px}.footer-message-input{font-size:16px!important;height:44px!important;text-overflow:ellipsis}.footer-description-input{font-size:16px!important;height:150px!important;text-overflow:ellipsis}.file-upload{border:2px solid #0077d9;font:inherit;padding:8px}.send-button{background:#1768c9!important}.attachment-info-text{padding:10px!important}.attachment-info-container{margin-top:5px!important}.attachment-remove-button{background-color:#f1f4f7!important;border:none!important;color:inherit!important;font:inherit!important;height:100%!important;justify-content:right!important;padding:0!important;text-align:left!important;width:100%!important}";
styleInject(css_248z$6);

var FileReadyToUpload = function FileReadyToUpload(props) {
  var _props$fileData, _props$fileData2;

  var onDeleteFile = function onDeleteFile() {
    props.setFileReadyToUpload(Object.assign({}, props.fileReadyToUpload, {
      uploadStatus: AttachmentUploadStatus.Inactive
    }));
    props.setFocusToInputBox();
  };

  var attachmentDetailsRef = useRef(null);
  useEffect(function () {
    setTimeout(function () {
      if (attachmentDetailsRef && attachmentDetailsRef.current) {
        attachmentDetailsRef.current.focus();
      }
    }, 1000);
  }, []);
  var fileName = ((_props$fileData = props.fileData) === null || _props$fileData === void 0 ? void 0 : _props$fileData.name) || '';
  var sizeInBytes = ((_props$fileData2 = props.fileData) === null || _props$fileData2 === void 0 ? void 0 : _props$fileData2.size) || 0;
  var fileSize = (sizeInBytes / (1024 * 1024)).toFixed(2).toString() + ' MB';
  return /*#__PURE__*/React.createElement(Container, {
    isFullWidth: true,
    className: "attachment-info-container"
  }, /*#__PURE__*/React.createElement(Row, {
    backgroundColor: "#F1F4F7",
    tabIndex: -1,
    alignItems: "center",
    ref: attachmentDetailsRef,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Row, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(View$1, {
    padding: {
      top: '10px',
      bottom: '10px',
      left: '10px'
    }
  }, /*#__PURE__*/React.createElement(IconDocument, {
    color: "#56616C"
  })), /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "12px",
    fontWeight: "medium",
    color: "#56616C",
    className: "attachment-info-text",
    wordBreak: "break-all"
  }, fileName), /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "12px",
    fontWeight: "regular",
    color: "#56616C",
    className: "attachment-info-text"
  }, fileSize)), props.fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Uploading ? /*#__PURE__*/React.createElement(View$1, {
    padding: {
      top: '10px',
      bottom: '10px',
      right: '10px'
    },
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Spinner, null)) : /*#__PURE__*/React.createElement(View$1, {
    padding: {
      top: '10px',
      bottom: '10px',
      right: '10px'
    },
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "attachment-remove-button",
    "aria-label": "remove attachment",
    onClick: onDeleteFile,
    size: ButtonSize.Small,
    isDestructive: true
  }, /*#__PURE__*/React.createElement(IconBin, {
    color: "#BB2929"
  })))));
};

var UserInputBox = function UserInputBox(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isCustomerTyping = _useState[0],
      setisCustomerTyping = _useState[1];

  var _useState2 = useState(false),
      isRecommendedLengthError = _useState2[0],
      setIsRecommendedLengthError = _useState2[1];

  var _useState3 = useState(''),
      recommendedLengthErrorMessage = _useState3[0],
      setRecommendedLengthErrorMessage = _useState3[1];

  var _useState4 = useState(false),
      announce = _useState4[0],
      setAnnounce = _useState4[1];

  var _useRecommendedLength = useRecommendedLength({
    value: props.userInput,
    tokenType: TokenType.Words,
    recommendedLength: RECOMMENDED_WORD_LIMIT_FOR_CHAT
  }),
      progress = _useRecommendedLength.progress;

  useEffect(function () {
    if (props.props.shouldStartIdlenessTimer) {
      props.props.setChatState(Object.assign({}, props.props.chatState, {
        timerState: TimerState.ResetTimer,
        activateListener: !props.props.chatState.activateListener
      }));
    }
  }, [isCustomerTyping]);

  var handleChange = function handleChange(e) {
    var _purifiedValue$replac;

    var purifiedValue = DOMPurify.sanitize(e.target.value); // dom sanitize replacing the string values by orginal character symbol

    props.setUserInput(purifiedValue === null || purifiedValue === void 0 ? void 0 : (_purifiedValue$replac = purifiedValue.replaceAll('&lt;', '<')) === null || _purifiedValue$replac === void 0 ? void 0 : _purifiedValue$replac.replaceAll('&gt;', '>'));
    var wordCount = countWords(e.target.value);

    if (wordCount > RECOMMENDED_WORD_LIMIT_FOR_CHAT) {
      setIsRecommendedLengthError(true);
      setRecommendedLengthErrorMessage(t('livehelp.recommended_words_error_text', {
        wordCount: wordCount,
        wordLimit: RECOMMENDED_WORD_LIMIT_FOR_CHAT
      }));
    } else {
      setIsRecommendedLengthError(false);
      setRecommendedLengthErrorMessage('');
    }

    if (!isCustomerTyping) {
      sendTypingEventIfApt();
    }

    if (purifiedValue.length > 1) {
      setisCustomerTyping(true);
    } else {
      setisCustomerTyping(false);
    }

    if (purifiedValue.charAt(purifiedValue.length - 1) === ' ') {
      setAnnounce(true);
    } else {
      setAnnounce(false);
    }
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter' && !isRecommendedLengthError) {
      event.preventDefault();
      props.sendInput();
      setAnnounce(true);
      setisCustomerTyping(false);
    }
  }; //Sends typing event if and only if the correct conditions are met


  var sendTypingEventIfApt = function sendTypingEventIfApt() {
    if (props.props.chatSession.connectionStatus !== ChatSessionConnectionStatus.Connected) {
      console.warn('session disconnected');
      return;
    }

    var currentChatSession = props.props.chatSession.chatSession;

    var sendTypingEvent = function sendTypingEvent() {
      try {
        return Promise.resolve(retryOperation(function () {
          return currentChatSession.sendEvent({
            contentType: 'application/vnd.amazonaws.connect.event.typing'
          });
        })).then(function (awsSdkResponse) {
          var _awsSdkResponse$data = awsSdkResponse.data,
              AbsoluteTime = _awsSdkResponse$data.AbsoluteTime,
              Id = _awsSdkResponse$data.Id;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    sendTypingEvent();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.active && /*#__PURE__*/React.createElement(View$1, {
    flexDirection: "column",
    width: '100%'
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: "chat-footer-input",
    labelText: t('livehelp.chat_input_footer_label'),
    renderLabel: function renderLabel(_ref) {
      var labelId = _ref.labelId;
      return /*#__PURE__*/React.createElement(Text$1, {
        id: labelId,
        fontSize: LiveHelpInlineFontScheme.CHAT_TEXTAREA_YOUR_MSG_TEXT
      }, t('livehelp.chat_input_footer_label'));
    },
    error: isRecommendedLengthError,
    footer: function footer(footerProps) {
      return /*#__PURE__*/React.createElement(RecommendedLengthFooter, Object.assign({
        progress: progress
      }, footerProps, {
        error: isRecommendedLengthError,
        "aria-live": announce ? 'assertive' : 'off'
      }), isRecommendedLengthError ? recommendedLengthErrorMessage : t('livehelp.recommended_words_error_text', {
        wordCount: "" + countWords(props.userInput),
        wordLimit: RECOMMENDED_WORD_LIMIT_FOR_CHAT
      }));
    }
  }, function (inputProps) {
    return /*#__PURE__*/React.createElement(TextArea, Object.assign({}, inputProps, {
      value: props.userInput,
      name: "footerInput",
      onKeyPress: handleKeyPress,
      onChange: handleChange,
      spellCheck: "true",
      width: '100%',
      tabIndex: 0,
      ref: props.inputBoxRef,
      className: props.props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue ? 'footer-description-input' : 'footer-message-input',
      placeholder: props.props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue ? t('livehelp.userinput_box_hint_text') : ''
    }));
  }), props.fileReadyToUpload.uploadStatus !== AttachmentUploadStatus.Inactive ? /*#__PURE__*/React.createElement(FileReadyToUpload, {
    fileData: props.fileReadyToUpload.fileData,
    setFileReadyToUpload: props.setFileReadyToUpload,
    fileReadyToUpload: props.fileReadyToUpload,
    setFocusToInputBox: props.setFocusOnInputBox
  }) : null));
};

var windowCopy = window;

var DownloadTranscriptService = /*#__PURE__*/function () {
  function DownloadTranscriptService() {
    this.userIdentifier = getUserIdentifier();
    this.OPERATION_NAME = 'ChatTranscriptDownload';
    this.logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: this.userIdentifier,
      pageName: HelpChannel.LIVE_CHAT,
      operationName: this.OPERATION_NAME
    };
  }

  var _proto = DownloadTranscriptService.prototype;

  _proto.formatTranscript = function formatTranscript(messages) {
    var text = '';
    messages.forEach(function (part) {
      if (part.type === MessageType.Message) {
        if (part.participant === ParticipantRole.System) {
          text += new Date(part.timestamp).toLocaleString() + "\t" + ParticipantRole.System + "\t\"" + part.content + "\"\n";
        } else if (part.participant === ParticipantRole.Agent || part.participant === ParticipantRole.Customer) {
          text += new Date(part.timestamp).toLocaleString() + "\t" + part.displayName + "\t\"" + part.content + "\"\n";
        }
      } else if (part.type === MessageType.Attachment) {
        text += new Date(part.timestamp).toLocaleString() + "\t" + part.displayName + "\t\"" + part.attachmentName + "\"\n";
      }
    });
    return text;
  }
  /**
   * Download
   * Initiates the Chat Transcript download process.  This is based on the saved browser
   * transcripts.
   */
  ;

  _proto.downloadTranscript = function downloadTranscript(messages) {
    try {
      var c = this.formatTranscript(messages);
      var file = new Blob([c], {
        type: 'text/plain'
      });
      var a = document.createElement('a');
      var url = windowCopy.URL.createObjectURL(file);
      var DOWNLOAD_TRANSCRIPT_OPERATION_NAME = this.OPERATION_NAME;
      var logsContext = this.logsContext;
      a.href = url;
      a.download = 'chat-transcript.txt';
      a.click();
      setTimeout(function () {
        windowCopy.URL.revokeObjectURL(url);
        myHRLoggerInfoLog("[" + getUserIdentifier() + ": Successfully Downloaded Chat History transcript", logsContext);
        recordCountMetric(HelpChannel.LIVE_CHAT, DOWNLOAD_TRANSCRIPT_OPERATION_NAME, MetricEvents.COUNT);
      }, TIME_FOR_DOWNLOAD);
      return null;
    } catch (error) {
      myHRLoggerErrorLog("[" + this.userIdentifier + "]: Error occurred in LiveHelpChat while downloading transcript. " + getDetailedErrorMessage(error), this.logsContext);
      recordErrorCountMetric(HelpChannel.LIVE_CHAT, this.OPERATION_NAME, JSON.stringify(error));
      return JSON.stringify(error);
    }
  };

  return DownloadTranscriptService;
}();

var css_248z$7 = ".chat-end-utilities-bar-button{font-size:16px!important;margin-bottom:8px;margin-top:8px;width:100%}.chat-utilities-bar-button{font-size:16px!important}.chat-send-button{min-width:unset!important}.button-end-chat{padding-left:0!important;padding-right:0!important}.order-1{order:1}.order-2{order:2}";
styleInject(css_248z$7);

var UtilitiesBar = function UtilitiesBar(props) {
  var PAGE_NAME = 'LiveHelpChat';
  var userIdentifier = getUserIdentifier();
  var OPERATION_NAME = 'UtilitiesBar';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME,
    chatMetaData: {
      queueId: props.props.chatState.queueId,
      contactFlowId: props.props.chatState.contactFlowId
    }
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var downloadTranscriptService = new DownloadTranscriptService();

  var openUploadModal = function openUploadModal() {
    if (props !== null && props !== void 0 && props.setShowFileUploadModal) props.setShowFileUploadModal(true);
    props.props.setChatState(Object.assign({}, props.props.chatState, {
      timerState: TimerState.NotActive,
      activateListener: !props.props.chatState.activateListener
    }));
  };

  var saveChat = function saveChat() {
    var _props$props$chatStat;

    myHRLoggerInfoLog("[" + ((_props$props$chatStat = props.props.chatState.chatTokens) === null || _props$props$chatStat === void 0 ? void 0 : _props$props$chatStat.initialContactId) + "]: User clicked on download transcript button after end of last chat.", logsContext);
    var downloadChatResponse = downloadTranscriptService.downloadTranscript(props.props.messages);

    if (downloadChatResponse) {
      props.props.setChatSession(Object.assign({}, props.props.chatSession, {
        connectionStatus: ChatSessionConnectionStatus.Ended,
        errorMessage: t('livehelp.download_transcript_error'),
        actionResponse: ChatSessionActionResponse.DownloadChatFailed
      }));
    } else {
      props.props.setChatSession(Object.assign({}, props.props.chatSession, {
        connectionStatus: ChatSessionConnectionStatus.Ended,
        errorMessage: '',
        actionResponse: ChatSessionActionResponse.DownloadChatSuccessful
      }));
    }
  };

  var endChat = function endChat() {
    console.log('[Live Chat Container] End Chat');
    props.props.setChatState(Object.assign({}, props.props.chatState, {
      confirmExit: true,
      disconnectFor: props.props.disconnectFor.Session
    }));
  };

  var startNewChat = function startNewChat() {
    var _props$props$chatStat2;

    myHRLoggerInfoLog("[" + ((_props$props$chatStat2 = props.props.chatState.chatTokens) === null || _props$props$chatStat2 === void 0 ? void 0 : _props$props$chatStat2.initialContactId) + "]: User clicked on start new chat after the end of last chat.", logsContext);
    props.props.setMessages([]);
    props.props.setChatState(Object.assign({}, props.props.chatState, {
      chatTokens: null,
      timeStampForChatClick: Date.now(),
      isDescribeIssue: true
    }));
    props.props.setChatSession(Object.assign({}, defaultChatSession, {
      connectionStatus: ChatSessionConnectionStatus.DescribeIssue
    }));
  };

  var canSaveChat = function canSaveChat() {
    return props.props.chatSession.connectionStatus !== ChatSessionConnectionStatus.Failure;
  };

  var canStartNewChat = function canStartNewChat() {
    var chatState = props.props.chatState; // Check if on Livehelp landing page

    var pathname = window.location.pathname;
    var regex = new RegExp('/myhr(2*)/livehelp/landing');

    if (!regex.test(pathname)) {
      return false;
    } // Check if required attributes to create chat available.


    if (!(chatState.cti && chatState.instanceId && chatState.region && chatState.businessLine && chatState.employeeAttributes && chatState.contactFlowId && chatState.queueId && chatState.userContext)) {
      return false;
    }

    return true;
  };

  if (props.active) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      width: '100%',
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(View$1, {
      className: "order-2",
      display: "inline-block"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Tertiary,
      onClick: openUploadModal,
      className: 'chat-utilities-bar-button button-upload-document',
      disabled: props.uploadingAttachment
    }, /*#__PURE__*/React.createElement(IconUpload, {
      title: "Upload attachment"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Primary,
      onClick: props.sendInput,
      className: "chat-utilities-bar-button chat-send-button",
      disabled: props.props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue && props.props.fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Inactive && props.isEmpty || props.isRecommendedWordError
    }, t('livehelp.send')))), /*#__PURE__*/React.createElement(View$1, {
      className: "order-1",
      display: "inline-block"
    }, /*#__PURE__*/React.createElement(Row, {
      height: '100%'
    }, /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Tertiary,
      isDestructive: true,
      size: ButtonSize.Small,
      className: 'chat-utilities-bar-button button-end-chat',
      onClick: endChat
    }, props.props.chatState.agentConnected ? t('livehelp.end_chat') : t('livehelp.cancel'))))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View$1, {
      padding: {
        left: '16px',
        right: '16px',
        top: '0px',
        bottom: '0px'
      },
      width: '100%'
    }, /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Primary,
      className: "chat-end-utilities-bar-button",
      onClick: props.props.onCloseChatWindow,
      ref: props.chatCloseButtonRef
    }, t('livehelp.close')), isEnvironmentBrowser() && canSaveChat() && /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Secondary,
      className: "chat-end-utilities-bar-button button-save-chat",
      onClick: saveChat
    }, t('livehelp.download_transcript')), canStartNewChat() && /*#__PURE__*/React.createElement(Button, {
      className: "chat-end-utilities-bar-button button-start-chat",
      onClick: startNewChat,
      variant: ButtonVariant.Secondary
    }, t('livehelp.new_live_chat_session'))));
  }
};

/**
 * @function sendMessageFromParticipant - Sends a text message to Connect on behalf of the participant; includes logging and error handling
 * @returns void
 */

function sendMessageFromParticipant(message, chatSession, setChatSession) {
  var PAGE_NAME = 'LiveHelpChat';
  var userIdentifier = getUserIdentifier();
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: 'LiveChatContact'
  };
  var i18n = i18.getInstance();
  var operationName = 'SendChatMessage';

  var invokeService = function invokeService() {
    try {
      var isConnected = chatSession.connectionStatus === ChatSessionConnectionStatus.Connected;

      if (!isConnected) {
        setChatSession(Object.assign({}, chatSession, {
          connectionStatus: ChatSessionConnectionStatus.Ended,
          actionResponse: ChatSessionActionResponse.MessageSentFailed,
          errorMessage: 'Unable to send message. Session is not connected.'
        }));
        throw new Error('Session is not connected.');
      }

      return Promise.resolve(retryOperation(function () {
        return chatSession.chatSession.sendMessage({
          contentType: 'text/plain',
          message: message
        });
      })).then(function (awsSdkResponse) {
        setChatSession(Object.assign({}, chatSession, {
          actionResponse: ChatSessionActionResponse.MessageSentSuccessful,
          errorMessage: ''
        }));
        var _awsSdkResponse$data = awsSdkResponse.data,
            AbsoluteTime = _awsSdkResponse$data.AbsoluteTime,
            Id = _awsSdkResponse$data.Id;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  invokeService().then(function () {
    return setChatSession(Object.assign({}, chatSession, {
      actionResponse: ChatSessionActionResponse.MessageSentSuccessful
    }));
  })["catch"](function (error) {
    var invalidConstraintsMessage = 'Invalid request body';
    var errorMessage = (error === null || error === void 0 ? void 0 : error.message) === invalidConstraintsMessage ? i18n.t('livehelp.invalid_message_contraint_error') : i18n.t('livehelp.sent_message_error');
    setChatSession(Object.assign({}, chatSession, {
      actionResponse: ChatSessionActionResponse.MessageSentFailed,
      errorMessage: errorMessage
    }));
    myHRLoggerErrorLog("[" + userIdentifier + "]: Error occured in LiveHelpChat while sending message. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
      operationName: operationName
    }));
    recordErrorCountMetric(PAGE_NAME, operationName, JSON.stringify(error));
  });
}

var Footer$1 = function Footer(props) {
  var PAGE_NAME = 'LiveHelpChat';
  var userIdentifier = getUserIdentifier();
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: 'LiveChatContact',
    chatMetaData: {
      queueId: props.chatState.queueId,
      contactFlowId: props.chatState.contactFlowId
    }
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var setFocusOnInputBox = function setFocusOnInputBox() {
    setTimeout(function () {
      if (props.inputBoxRef && props.inputBoxRef.current) {
        props.inputBoxRef.current.focus();
      }
    }, 250);
  };

  var uploadErrorMessages = {
    AccessDeniedException: t('livehelp.upload_error_access_denied'),
    InternalServerException: t('livehelp.upload_error_internal_server_exception'),
    ServiceQuotaExceededException: t('livehelp.upload_error_service_quota_exceeded'),
    ThrottlingException: t('livehelp.upload_error_throttling'),
    ValidationException: t('livehelp.upload_error_validation')
  };

  var _useState = useState(''),
      userInput = _useState[0],
      setUserInput = _useState[1]; //State to track error in upload.


  var _useState2 = useState({
    showErrorOccured: false,
    errorMessage: ''
  }),
      uploadError = _useState2[0],
      setUploadError = _useState2[1];

  var sendInput = function sendInput() {
    if (props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue && ((userInput === null || userInput === void 0 ? void 0 : userInput.trim().length) !== 0 || props.fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Ready)) {
      props.setChatSession(Object.assign({}, props.chatSession, {
        connectionStatus: ChatSessionConnectionStatus.Attempting
      }));

      if ((userInput === null || userInput === void 0 ? void 0 : userInput.trim().length) !== 0) {
        props.setMessageString(userInput.trim());
      } else props.setMessageString('');
    } else {
      if ((userInput === null || userInput === void 0 ? void 0 : userInput.trim().length) !== 0) {
        var message = userInput;
        clearInput();
        sendMessageFromParticipant(message.trim(), props.chatSession, props.setChatSession);
      }

      if (props.fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Ready) {
        uploadAttachmentToConnect();
      }
    }
  };

  var isRecommendedWordError = function isRecommendedWordError() {
    return countWords(userInput) > RECOMMENDED_WORD_LIMIT_FOR_CHAT;
  };

  var isEmpty = function isEmpty() {
    return userInput.trim().length == 0;
  };

  var clearInput = function clearInput() {
    setUserInput('');
  };

  var uploadAttachmentToConnect = function uploadAttachmentToConnect() {
    try {
      var operationName = 'UploadAttachment';
      recordCountMetric(PAGE_NAME, operationName, MetricEvents.CLICKS_COUNT);
      var response;
      props.setFileReadyToUpload(Object.assign({}, props.fileReadyToUpload, {
        uploadStatus: AttachmentUploadStatus.Uploading
      }));

      var _temp2 = _catch(function () {
        return Promise.resolve(retryOperation(function () {
          return props.chatSession.chatSession.sendAttachment({
            attachment: props.fileReadyToUpload.fileData
          });
        })).then(function (_retryOperation) {
          response = _retryOperation;
          recordCountMetric(PAGE_NAME, operationName, MetricEvents.SUCCESS_COUNT); //Added Logs for attachment

          myHRLoggerInfoLog("[" + props.chatState.chatTokens.contactId + "]: User Sent an attachment  ", Object.assign({}, logsContext, {
            operationName: operationName
          }));
          setUploadError({
            errorMessage: '',
            showErrorOccured: false
          });
        });
      }, function (e) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred in LiveHelpChat while uploading attachment. " + getDetailedErrorMessage(e), Object.assign({}, logsContext, {
          operationName: operationName
        }));
        recordErrorCountMetric(PAGE_NAME, operationName, JSON.stringify(e));
        props.setFileReadyToUpload({
          fileData: null,
          uploadStatus: AttachmentUploadStatus.Inactive
        });
        var errorMessage = e.type in uploadErrorMessages ? uploadErrorMessages[e.type] : t('livehelp.upload_error_generic');
        setUploadError({
          errorMessage: errorMessage,
          showErrorOccured: true
        });
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var onDismissedUploadErrorBanner = function onDismissedUploadErrorBanner() {
    setUploadError(Object.assign({}, uploadError, {
      showErrorOccured: false
    }));
  };

  var getAttachAndInputBoxes = function getAttachAndInputBoxes() {
    var isActive = props.chatSession.connectionStatus === ChatSessionConnectionStatus.Connected || props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      justifyContent: "flex",
      gridGap: 32,
      padding: 12,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(View$1, {
      display: "flex",
      flex: "1"
    }, /*#__PURE__*/React.createElement(UserInputBox, {
      active: isActive,
      props: props,
      userInput: userInput,
      setUserInput: setUserInput,
      sendInput: sendInput,
      fileReadyToUpload: props.fileReadyToUpload,
      setFileReadyToUpload: props.setFileReadyToUpload,
      inputBoxRef: props.inputBoxRef,
      setFocusOnInputBox: setFocusOnInputBox
    }))), /*#__PURE__*/React.createElement(View$1, {
      padding: {
        left: 12,
        right: 12,
        bottom: 12,
        top: isActive ? 0 : 12
      }
    }, /*#__PURE__*/React.createElement(UtilitiesBar, {
      active: isActive,
      setConfirmExit: props.setConfirmExit,
      props: props,
      sendInput: sendInput,
      chatCloseButtonRef: props.chatCloseButtonRef,
      uploadingAttachment: props.fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Uploading,
      setShowFileUploadModal: props.setShowFileUploadModal,
      isRecommendedWordError: isRecommendedWordError(),
      isEmpty: isEmpty()
    })));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    isFullWidth: true,
    paddingHorizontal: 0,
    paddingBottom: 0,
    paddingTop: 0,
    className: "footer-container",
    backgroundColor: "white"
  }, uploadError.showErrorOccured && /*#__PURE__*/React.createElement(AttachmentUploadFailedBanner, {
    errorMessage: uploadError.errorMessage,
    onDismiss: onDismissedUploadErrorBanner
  }), getAttachAndInputBoxes()));
};

var DisconnectBanner = function DisconnectBanner(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var alertTagRef = useRef(null);

  var _useChatContext = useChatContext(),
      chatState = _useChatContext.chatState,
      chatSession = _useChatContext.chatSession,
      setChatState = _useChatContext.setChatState,
      setChatSession = _useChatContext.setChatSession;

  useEffect(function () {
    if (alertTagRef.current) {
      alertTagRef.current.focus();
    }
  }, []);

  var onKeyEnter = function onKeyEnter(event) {
    var ENTER_KEY_CODE = 13;

    if (event.keyCode === ENTER_KEY_CODE) {
      resetTimer();
    }
  };

  var resetTimer = function resetTimer() {
    var _props$inputBoxRef, _props$inputBoxRef$cu;

    setChatState(Object.assign({}, chatState, {
      timerState: TimerState.ResetTimer,
      activateListener: !chatState.activateListener,
      idlenessReminder: IdlenessReminder.NotActive
    }));
    (_props$inputBoxRef = props.inputBoxRef) === null || _props$inputBoxRef === void 0 ? void 0 : (_props$inputBoxRef$cu = _props$inputBoxRef.current) === null || _props$inputBoxRef$cu === void 0 ? void 0 : _props$inputBoxRef$cu.focus();
    var sessionExtensionMessage = t('livehelp.chat_extended_after_idleness');
    sendMessageFromParticipant(sessionExtensionMessage, chatSession, setChatSession);
  };

  return /*#__PURE__*/React.createElement(View$1, {
    role: "dialog",
    "aria-label": "Time out warning"
  }, /*#__PURE__*/React.createElement(MessageBanner, {
    type: MessageBannerType.Warning
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    color: "#232F3E",
    "aria-atomic": true,
    role: "status"
  }, t('livehelp.livechat_warning_banner', {
    minutes: props.idlenessBannerTimeInMinutes
  }), /*#__PURE__*/React.createElement("a", {
    tabIndex: 0,
    onClick: resetTimer,
    style: {
      color: '#0000EE',
      paddingLeft: '10px'
    },
    role: "button",
    ref: alertTagRef,
    onKeyDown: onKeyEnter
  }, t('livehelp.stay_connected')))));
};

var css_248z$8 = ".chat-header-container{background-color:#1768c9!important;border-bottom:1px solid #6b6b6b;box-shadow:0 4px 5px rgba(0,0,0,.14),0 1px 10px rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);display:flex!important;height:47px!important;justify-content:center!important;position:relative!important}.img-responsive{max-height:100%;max-width:100%}.chat-header-title{align-items:center!important;display:flex!important;font-size:16px!important;font-weight:500!important;height:47px!important;justify-content:center!important;margin:0!important}.chat-header-title-left-inline{float:left;padding-left:8%!important}.chat-header-button{color:#fff!important;font-size:16px!important;height:100%!important;position:absolute!important;right:0!important;top:0!important}.chat-header-button:active,.chat-header-button:focus,.chat-header-button:hover{border-color:#fff!important}";
styleInject(css_248z$8);

var Header$1 = function Header(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var shouldMinimise = function shouldMinimise() {
    return matches.l || matches.xl || !props.isChatHistoryComponent;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "chat-header-container"
  }, props.isChatHistoryComponent ? /*#__PURE__*/React.createElement(H2, {
    id: "previouschathistory-heading",
    color: "#ffffff",
    className: "chat-header-title"
  }, t('livehelp.previous_chat_history')) : /*#__PURE__*/React.createElement(H2, {
    id: "livechat-heading",
    color: "#ffffff",
    className: "chat-header-title"
  }, t('livehelp.live_chat_with_HR')), /*#__PURE__*/React.createElement(Button, {
    ref: props.minusButtonRef,
    className: "chat-header-button",
    variant: ButtonVariant.Primary,
    onClick: shouldMinimise() ? props.onMinimizeChat : props.onCloseChat,
    icon: shouldMinimise() ? /*#__PURE__*/React.createElement(IconMinus, {
      color: "white",
      title: t('livehelp.minimize_chat_history')
    }) : /*#__PURE__*/React.createElement(IconCross, {
      color: "white",
      title: "Close Chat"
    })
  })), !props.anyChildModalOpen && props.chatState.idlenessReminder === IdlenessReminder.Warning && /*#__PURE__*/React.createElement(DisconnectBanner, {
    idlenessBannerTimeInMinutes: props.idlenessBannerTimeInMinutes,
    chatState: props.chatState,
    setChatState: props.setChatState,
    inputBoxRef: props.inputBoxRef
  }));
};

var css_248z$9 = "/*!\n * Bootstrap Grid v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{margin-left:auto;margin-right:auto;padding-left:var(--bs-gutter-x,.75rem);padding-right:var(--bs-gutter-x,.75rem);width:100%}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}@media (min-width:1400px){.container,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{max-width:1320px}}.row{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-left:calc(var(--bs-gutter-x)*-.5);margin-right:calc(var(--bs-gutter-x)*-.5);margin-top:calc(var(--bs-gutter-y)*-1)}.row>*{box-sizing:border-box;flex-shrink:0;margin-top:var(--bs-gutter-y);max-width:100%;padding-left:calc(var(--bs-gutter-x)*.5);padding-right:calc(var(--bs-gutter-x)*.5);width:100%}.col{flex:1 0 0%}.row-cols-auto>*{flex:0 0 auto;width:auto}.row-cols-1>*{flex:0 0 auto;width:100%}.row-cols-2>*{flex:0 0 auto;width:50%}.row-cols-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-4>*{flex:0 0 auto;width:25%}.row-cols-5>*{flex:0 0 auto;width:20%}.row-cols-6>*{flex:0 0 auto;width:16.6666666667%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 auto;width:8.33333333%}.col-2{flex:0 0 auto;width:16.66666667%}.col-3{flex:0 0 auto;width:25%}.col-4{flex:0 0 auto;width:33.33333333%}.col-5{flex:0 0 auto;width:41.66666667%}.col-6{flex:0 0 auto;width:50%}.col-7{flex:0 0 auto;width:58.33333333%}.col-8{flex:0 0 auto;width:66.66666667%}.col-9{flex:0 0 auto;width:75%}.col-10{flex:0 0 auto;width:83.33333333%}.col-11{flex:0 0 auto;width:91.66666667%}.col-12{flex:0 0 auto;width:100%}.offset-1{margin-left:8.33333333%}.offset-2{margin-left:16.66666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333333%}.offset-5{margin-left:41.66666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333333%}.offset-8{margin-left:66.66666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333333%}.offset-11{margin-left:91.66666667%}.g-0,.gx-0{--bs-gutter-x:0}.g-0,.gy-0{--bs-gutter-y:0}.g-1,.gx-1{--bs-gutter-x:0.25rem}.g-1,.gy-1{--bs-gutter-y:0.25rem}.g-2,.gx-2{--bs-gutter-x:0.5rem}.g-2,.gy-2{--bs-gutter-y:0.5rem}.g-3,.gx-3{--bs-gutter-x:1rem}.g-3,.gy-3{--bs-gutter-y:1rem}.g-4,.gx-4{--bs-gutter-x:1.5rem}.g-4,.gy-4{--bs-gutter-y:1.5rem}.g-5,.gx-5{--bs-gutter-x:3rem}.g-5,.gy-5{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm{flex:1 0 0%}.row-cols-sm-auto>*{flex:0 0 auto;width:auto}.row-cols-sm-1>*{flex:0 0 auto;width:100%}.row-cols-sm-2>*{flex:0 0 auto;width:50%}.row-cols-sm-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>*{flex:0 0 auto;width:25%}.row-cols-sm-5>*{flex:0 0 auto;width:20%}.row-cols-sm-6>*{flex:0 0 auto;width:16.6666666667%}.col-sm-auto{flex:0 0 auto;width:auto}.col-sm-1{flex:0 0 auto;width:8.33333333%}.col-sm-2{flex:0 0 auto;width:16.66666667%}.col-sm-3{flex:0 0 auto;width:25%}.col-sm-4{flex:0 0 auto;width:33.33333333%}.col-sm-5{flex:0 0 auto;width:41.66666667%}.col-sm-6{flex:0 0 auto;width:50%}.col-sm-7{flex:0 0 auto;width:58.33333333%}.col-sm-8{flex:0 0 auto;width:66.66666667%}.col-sm-9{flex:0 0 auto;width:75%}.col-sm-10{flex:0 0 auto;width:83.33333333%}.col-sm-11{flex:0 0 auto;width:91.66666667%}.col-sm-12{flex:0 0 auto;width:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333333%}.offset-sm-2{margin-left:16.66666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333333%}.offset-sm-5{margin-left:41.66666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333333%}.offset-sm-8{margin-left:66.66666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333333%}.offset-sm-11{margin-left:91.66666667%}.g-sm-0,.gx-sm-0{--bs-gutter-x:0}.g-sm-0,.gy-sm-0{--bs-gutter-y:0}.g-sm-1,.gx-sm-1{--bs-gutter-x:0.25rem}.g-sm-1,.gy-sm-1{--bs-gutter-y:0.25rem}.g-sm-2,.gx-sm-2{--bs-gutter-x:0.5rem}.g-sm-2,.gy-sm-2{--bs-gutter-y:0.5rem}.g-sm-3,.gx-sm-3{--bs-gutter-x:1rem}.g-sm-3,.gy-sm-3{--bs-gutter-y:1rem}.g-sm-4,.gx-sm-4{--bs-gutter-x:1.5rem}.g-sm-4,.gy-sm-4{--bs-gutter-y:1.5rem}.g-sm-5,.gx-sm-5{--bs-gutter-x:3rem}.g-sm-5,.gy-sm-5{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md{flex:1 0 0%}.row-cols-md-auto>*{flex:0 0 auto;width:auto}.row-cols-md-1>*{flex:0 0 auto;width:100%}.row-cols-md-2>*{flex:0 0 auto;width:50%}.row-cols-md-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>*{flex:0 0 auto;width:25%}.row-cols-md-5>*{flex:0 0 auto;width:20%}.row-cols-md-6>*{flex:0 0 auto;width:16.6666666667%}.col-md-auto{flex:0 0 auto;width:auto}.col-md-1{flex:0 0 auto;width:8.33333333%}.col-md-2{flex:0 0 auto;width:16.66666667%}.col-md-3{flex:0 0 auto;width:25%}.col-md-4{flex:0 0 auto;width:33.33333333%}.col-md-5{flex:0 0 auto;width:41.66666667%}.col-md-6{flex:0 0 auto;width:50%}.col-md-7{flex:0 0 auto;width:58.33333333%}.col-md-8{flex:0 0 auto;width:66.66666667%}.col-md-9{flex:0 0 auto;width:75%}.col-md-10{flex:0 0 auto;width:83.33333333%}.col-md-11{flex:0 0 auto;width:91.66666667%}.col-md-12{flex:0 0 auto;width:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333333%}.offset-md-2{margin-left:16.66666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333333%}.offset-md-5{margin-left:41.66666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333333%}.offset-md-8{margin-left:66.66666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333333%}.offset-md-11{margin-left:91.66666667%}.g-md-0,.gx-md-0{--bs-gutter-x:0}.g-md-0,.gy-md-0{--bs-gutter-y:0}.g-md-1,.gx-md-1{--bs-gutter-x:0.25rem}.g-md-1,.gy-md-1{--bs-gutter-y:0.25rem}.g-md-2,.gx-md-2{--bs-gutter-x:0.5rem}.g-md-2,.gy-md-2{--bs-gutter-y:0.5rem}.g-md-3,.gx-md-3{--bs-gutter-x:1rem}.g-md-3,.gy-md-3{--bs-gutter-y:1rem}.g-md-4,.gx-md-4{--bs-gutter-x:1.5rem}.g-md-4,.gy-md-4{--bs-gutter-y:1.5rem}.g-md-5,.gx-md-5{--bs-gutter-x:3rem}.g-md-5,.gy-md-5{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg{flex:1 0 0%}.row-cols-lg-auto>*{flex:0 0 auto;width:auto}.row-cols-lg-1>*{flex:0 0 auto;width:100%}.row-cols-lg-2>*{flex:0 0 auto;width:50%}.row-cols-lg-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>*{flex:0 0 auto;width:25%}.row-cols-lg-5>*{flex:0 0 auto;width:20%}.row-cols-lg-6>*{flex:0 0 auto;width:16.6666666667%}.col-lg-auto{flex:0 0 auto;width:auto}.col-lg-1{flex:0 0 auto;width:8.33333333%}.col-lg-2{flex:0 0 auto;width:16.66666667%}.col-lg-3{flex:0 0 auto;width:25%}.col-lg-4{flex:0 0 auto;width:33.33333333%}.col-lg-5{flex:0 0 auto;width:41.66666667%}.col-lg-6{flex:0 0 auto;width:50%}.col-lg-7{flex:0 0 auto;width:58.33333333%}.col-lg-8{flex:0 0 auto;width:66.66666667%}.col-lg-9{flex:0 0 auto;width:75%}.col-lg-10{flex:0 0 auto;width:83.33333333%}.col-lg-11{flex:0 0 auto;width:91.66666667%}.col-lg-12{flex:0 0 auto;width:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333333%}.offset-lg-2{margin-left:16.66666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333333%}.offset-lg-5{margin-left:41.66666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333333%}.offset-lg-8{margin-left:66.66666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333333%}.offset-lg-11{margin-left:91.66666667%}.g-lg-0,.gx-lg-0{--bs-gutter-x:0}.g-lg-0,.gy-lg-0{--bs-gutter-y:0}.g-lg-1,.gx-lg-1{--bs-gutter-x:0.25rem}.g-lg-1,.gy-lg-1{--bs-gutter-y:0.25rem}.g-lg-2,.gx-lg-2{--bs-gutter-x:0.5rem}.g-lg-2,.gy-lg-2{--bs-gutter-y:0.5rem}.g-lg-3,.gx-lg-3{--bs-gutter-x:1rem}.g-lg-3,.gy-lg-3{--bs-gutter-y:1rem}.g-lg-4,.gx-lg-4{--bs-gutter-x:1.5rem}.g-lg-4,.gy-lg-4{--bs-gutter-y:1.5rem}.g-lg-5,.gx-lg-5{--bs-gutter-x:3rem}.g-lg-5,.gy-lg-5{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl{flex:1 0 0%}.row-cols-xl-auto>*{flex:0 0 auto;width:auto}.row-cols-xl-1>*{flex:0 0 auto;width:100%}.row-cols-xl-2>*{flex:0 0 auto;width:50%}.row-cols-xl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>*{flex:0 0 auto;width:25%}.row-cols-xl-5>*{flex:0 0 auto;width:20%}.row-cols-xl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xl-auto{flex:0 0 auto;width:auto}.col-xl-1{flex:0 0 auto;width:8.33333333%}.col-xl-2{flex:0 0 auto;width:16.66666667%}.col-xl-3{flex:0 0 auto;width:25%}.col-xl-4{flex:0 0 auto;width:33.33333333%}.col-xl-5{flex:0 0 auto;width:41.66666667%}.col-xl-6{flex:0 0 auto;width:50%}.col-xl-7{flex:0 0 auto;width:58.33333333%}.col-xl-8{flex:0 0 auto;width:66.66666667%}.col-xl-9{flex:0 0 auto;width:75%}.col-xl-10{flex:0 0 auto;width:83.33333333%}.col-xl-11{flex:0 0 auto;width:91.66666667%}.col-xl-12{flex:0 0 auto;width:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333333%}.offset-xl-2{margin-left:16.66666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333333%}.offset-xl-5{margin-left:41.66666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333333%}.offset-xl-8{margin-left:66.66666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333333%}.offset-xl-11{margin-left:91.66666667%}.g-xl-0,.gx-xl-0{--bs-gutter-x:0}.g-xl-0,.gy-xl-0{--bs-gutter-y:0}.g-xl-1,.gx-xl-1{--bs-gutter-x:0.25rem}.g-xl-1,.gy-xl-1{--bs-gutter-y:0.25rem}.g-xl-2,.gx-xl-2{--bs-gutter-x:0.5rem}.g-xl-2,.gy-xl-2{--bs-gutter-y:0.5rem}.g-xl-3,.gx-xl-3{--bs-gutter-x:1rem}.g-xl-3,.gy-xl-3{--bs-gutter-y:1rem}.g-xl-4,.gx-xl-4{--bs-gutter-x:1.5rem}.g-xl-4,.gy-xl-4{--bs-gutter-y:1.5rem}.g-xl-5,.gx-xl-5{--bs-gutter-x:3rem}.g-xl-5,.gy-xl-5{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl{flex:1 0 0%}.row-cols-xxl-auto>*{flex:0 0 auto;width:auto}.row-cols-xxl-1>*{flex:0 0 auto;width:100%}.row-cols-xxl-2>*{flex:0 0 auto;width:50%}.row-cols-xxl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>*{flex:0 0 auto;width:25%}.row-cols-xxl-5>*{flex:0 0 auto;width:20%}.row-cols-xxl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto{flex:0 0 auto;width:auto}.col-xxl-1{flex:0 0 auto;width:8.33333333%}.col-xxl-2{flex:0 0 auto;width:16.66666667%}.col-xxl-3{flex:0 0 auto;width:25%}.col-xxl-4{flex:0 0 auto;width:33.33333333%}.col-xxl-5{flex:0 0 auto;width:41.66666667%}.col-xxl-6{flex:0 0 auto;width:50%}.col-xxl-7{flex:0 0 auto;width:58.33333333%}.col-xxl-8{flex:0 0 auto;width:66.66666667%}.col-xxl-9{flex:0 0 auto;width:75%}.col-xxl-10{flex:0 0 auto;width:83.33333333%}.col-xxl-11{flex:0 0 auto;width:91.66666667%}.col-xxl-12{flex:0 0 auto;width:100%}.offset-xxl-0{margin-left:0}.offset-xxl-1{margin-left:8.33333333%}.offset-xxl-2{margin-left:16.66666667%}.offset-xxl-3{margin-left:25%}.offset-xxl-4{margin-left:33.33333333%}.offset-xxl-5{margin-left:41.66666667%}.offset-xxl-6{margin-left:50%}.offset-xxl-7{margin-left:58.33333333%}.offset-xxl-8{margin-left:66.66666667%}.offset-xxl-9{margin-left:75%}.offset-xxl-10{margin-left:83.33333333%}.offset-xxl-11{margin-left:91.66666667%}.g-xxl-0,.gx-xxl-0{--bs-gutter-x:0}.g-xxl-0,.gy-xxl-0{--bs-gutter-y:0}.g-xxl-1,.gx-xxl-1{--bs-gutter-x:0.25rem}.g-xxl-1,.gy-xxl-1{--bs-gutter-y:0.25rem}.g-xxl-2,.gx-xxl-2{--bs-gutter-x:0.5rem}.g-xxl-2,.gy-xxl-2{--bs-gutter-y:0.5rem}.g-xxl-3,.gx-xxl-3{--bs-gutter-x:1rem}.g-xxl-3,.gy-xxl-3{--bs-gutter-y:1rem}.g-xxl-4,.gx-xxl-4{--bs-gutter-x:1.5rem}.g-xxl-4,.gy-xxl-4{--bs-gutter-y:1.5rem}.g-xxl-5,.gx-xxl-5{--bs-gutter-x:3rem}.g-xxl-5,.gy-xxl-5{--bs-gutter-y:3rem}}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-grid{display:grid!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}.d-none{display:none!important}.flex-fill{flex:1 1 auto!important}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-grow-0{flex-grow:0!important}.flex-grow-1{flex-grow:1!important}.flex-shrink-0{flex-shrink:0!important}.flex-shrink-1{flex-shrink:1!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.justify-content-evenly{justify-content:space-evenly!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}.order-first{order:-1!important}.order-0{order:0!important}.order-1{order:1!important}.order-2{order:2!important}.order-3{order:3!important}.order-4{order:4!important}.order-5{order:5!important}.order-last{order:6!important}.m-0{margin:0!important}.m-1{margin:.25rem!important}.m-2{margin:.5rem!important}.m-3{margin:1rem!important}.m-4{margin:1.5rem!important}.m-5{margin:3rem!important}.m-auto{margin:auto!important}.mx-0{margin-left:0!important;margin-right:0!important}.mx-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-3{margin-left:1rem!important;margin-right:1rem!important}.mx-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-5{margin-left:3rem!important;margin-right:3rem!important}.mx-auto{margin-left:auto!important;margin-right:auto!important}.my-0{margin-bottom:0!important;margin-top:0!important}.my-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-0{margin-top:0!important}.mt-1{margin-top:.25rem!important}.mt-2{margin-top:.5rem!important}.mt-3{margin-top:1rem!important}.mt-4{margin-top:1.5rem!important}.mt-5{margin-top:3rem!important}.mt-auto{margin-top:auto!important}.me-0{margin-right:0!important}.me-1{margin-right:.25rem!important}.me-2{margin-right:.5rem!important}.me-3{margin-right:1rem!important}.me-4{margin-right:1.5rem!important}.me-5{margin-right:3rem!important}.me-auto{margin-right:auto!important}.mb-0{margin-bottom:0!important}.mb-1{margin-bottom:.25rem!important}.mb-2{margin-bottom:.5rem!important}.mb-3{margin-bottom:1rem!important}.mb-4{margin-bottom:1.5rem!important}.mb-5{margin-bottom:3rem!important}.mb-auto{margin-bottom:auto!important}.ms-0{margin-left:0!important}.ms-1{margin-left:.25rem!important}.ms-2{margin-left:.5rem!important}.ms-3{margin-left:1rem!important}.ms-4{margin-left:1.5rem!important}.ms-5{margin-left:3rem!important}.ms-auto{margin-left:auto!important}.p-0{padding:0!important}.p-1{padding:.25rem!important}.p-2{padding:.5rem!important}.p-3{padding:1rem!important}.p-4{padding:1.5rem!important}.p-5{padding:3rem!important}.px-0{padding-left:0!important;padding-right:0!important}.px-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-3{padding-left:1rem!important;padding-right:1rem!important}.px-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-5{padding-left:3rem!important;padding-right:3rem!important}.py-0{padding-bottom:0!important;padding-top:0!important}.py-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-0{padding-top:0!important}.pt-1{padding-top:.25rem!important}.pt-2{padding-top:.5rem!important}.pt-3{padding-top:1rem!important}.pt-4{padding-top:1.5rem!important}.pt-5{padding-top:3rem!important}.pe-0{padding-right:0!important}.pe-1{padding-right:.25rem!important}.pe-2{padding-right:.5rem!important}.pe-3{padding-right:1rem!important}.pe-4{padding-right:1.5rem!important}.pe-5{padding-right:3rem!important}.pb-0{padding-bottom:0!important}.pb-1{padding-bottom:.25rem!important}.pb-2{padding-bottom:.5rem!important}.pb-3{padding-bottom:1rem!important}.pb-4{padding-bottom:1.5rem!important}.pb-5{padding-bottom:3rem!important}.ps-0{padding-left:0!important}.ps-1{padding-left:.25rem!important}.ps-2{padding-left:.5rem!important}.ps-3{padding-left:1rem!important}.ps-4{padding-left:1.5rem!important}.ps-5{padding-left:3rem!important}@media (min-width:576px){.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-grid{display:grid!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}.d-sm-none{display:none!important}.flex-sm-fill{flex:1 1 auto!important}.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-grow-0{flex-grow:0!important}.flex-sm-grow-1{flex-grow:1!important}.flex-sm-shrink-0{flex-shrink:0!important}.flex-sm-shrink-1{flex-shrink:1!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.justify-content-sm-evenly{justify-content:space-evenly!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{align-self:stretch!important}.order-sm-first{order:-1!important}.order-sm-0{order:0!important}.order-sm-1{order:1!important}.order-sm-2{order:2!important}.order-sm-3{order:3!important}.order-sm-4{order:4!important}.order-sm-5{order:5!important}.order-sm-last{order:6!important}.m-sm-0{margin:0!important}.m-sm-1{margin:.25rem!important}.m-sm-2{margin:.5rem!important}.m-sm-3{margin:1rem!important}.m-sm-4{margin:1.5rem!important}.m-sm-5{margin:3rem!important}.m-sm-auto{margin:auto!important}.mx-sm-0{margin-left:0!important;margin-right:0!important}.mx-sm-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-sm-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-sm-3{margin-left:1rem!important;margin-right:1rem!important}.mx-sm-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-sm-5{margin-left:3rem!important;margin-right:3rem!important}.mx-sm-auto{margin-left:auto!important;margin-right:auto!important}.my-sm-0{margin-bottom:0!important;margin-top:0!important}.my-sm-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-sm-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-sm-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-sm-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-sm-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-sm-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-sm-0{margin-top:0!important}.mt-sm-1{margin-top:.25rem!important}.mt-sm-2{margin-top:.5rem!important}.mt-sm-3{margin-top:1rem!important}.mt-sm-4{margin-top:1.5rem!important}.mt-sm-5{margin-top:3rem!important}.mt-sm-auto{margin-top:auto!important}.me-sm-0{margin-right:0!important}.me-sm-1{margin-right:.25rem!important}.me-sm-2{margin-right:.5rem!important}.me-sm-3{margin-right:1rem!important}.me-sm-4{margin-right:1.5rem!important}.me-sm-5{margin-right:3rem!important}.me-sm-auto{margin-right:auto!important}.mb-sm-0{margin-bottom:0!important}.mb-sm-1{margin-bottom:.25rem!important}.mb-sm-2{margin-bottom:.5rem!important}.mb-sm-3{margin-bottom:1rem!important}.mb-sm-4{margin-bottom:1.5rem!important}.mb-sm-5{margin-bottom:3rem!important}.mb-sm-auto{margin-bottom:auto!important}.ms-sm-0{margin-left:0!important}.ms-sm-1{margin-left:.25rem!important}.ms-sm-2{margin-left:.5rem!important}.ms-sm-3{margin-left:1rem!important}.ms-sm-4{margin-left:1.5rem!important}.ms-sm-5{margin-left:3rem!important}.ms-sm-auto{margin-left:auto!important}.p-sm-0{padding:0!important}.p-sm-1{padding:.25rem!important}.p-sm-2{padding:.5rem!important}.p-sm-3{padding:1rem!important}.p-sm-4{padding:1.5rem!important}.p-sm-5{padding:3rem!important}.px-sm-0{padding-left:0!important;padding-right:0!important}.px-sm-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-sm-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-sm-3{padding-left:1rem!important;padding-right:1rem!important}.px-sm-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-sm-5{padding-left:3rem!important;padding-right:3rem!important}.py-sm-0{padding-bottom:0!important;padding-top:0!important}.py-sm-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-sm-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-sm-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-sm-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-sm-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-sm-0{padding-top:0!important}.pt-sm-1{padding-top:.25rem!important}.pt-sm-2{padding-top:.5rem!important}.pt-sm-3{padding-top:1rem!important}.pt-sm-4{padding-top:1.5rem!important}.pt-sm-5{padding-top:3rem!important}.pe-sm-0{padding-right:0!important}.pe-sm-1{padding-right:.25rem!important}.pe-sm-2{padding-right:.5rem!important}.pe-sm-3{padding-right:1rem!important}.pe-sm-4{padding-right:1.5rem!important}.pe-sm-5{padding-right:3rem!important}.pb-sm-0{padding-bottom:0!important}.pb-sm-1{padding-bottom:.25rem!important}.pb-sm-2{padding-bottom:.5rem!important}.pb-sm-3{padding-bottom:1rem!important}.pb-sm-4{padding-bottom:1.5rem!important}.pb-sm-5{padding-bottom:3rem!important}.ps-sm-0{padding-left:0!important}.ps-sm-1{padding-left:.25rem!important}.ps-sm-2{padding-left:.5rem!important}.ps-sm-3{padding-left:1rem!important}.ps-sm-4{padding-left:1.5rem!important}.ps-sm-5{padding-left:3rem!important}}@media (min-width:768px){.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-grid{display:grid!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}.d-md-none{display:none!important}.flex-md-fill{flex:1 1 auto!important}.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-grow-0{flex-grow:0!important}.flex-md-grow-1{flex-grow:1!important}.flex-md-shrink-0{flex-shrink:0!important}.flex-md-shrink-1{flex-shrink:1!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.justify-content-md-evenly{justify-content:space-evenly!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{align-self:stretch!important}.order-md-first{order:-1!important}.order-md-0{order:0!important}.order-md-1{order:1!important}.order-md-2{order:2!important}.order-md-3{order:3!important}.order-md-4{order:4!important}.order-md-5{order:5!important}.order-md-last{order:6!important}.m-md-0{margin:0!important}.m-md-1{margin:.25rem!important}.m-md-2{margin:.5rem!important}.m-md-3{margin:1rem!important}.m-md-4{margin:1.5rem!important}.m-md-5{margin:3rem!important}.m-md-auto{margin:auto!important}.mx-md-0{margin-left:0!important;margin-right:0!important}.mx-md-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-md-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-md-3{margin-left:1rem!important;margin-right:1rem!important}.mx-md-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-md-5{margin-left:3rem!important;margin-right:3rem!important}.mx-md-auto{margin-left:auto!important;margin-right:auto!important}.my-md-0{margin-bottom:0!important;margin-top:0!important}.my-md-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-md-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-md-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-md-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-md-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-md-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-md-0{margin-top:0!important}.mt-md-1{margin-top:.25rem!important}.mt-md-2{margin-top:.5rem!important}.mt-md-3{margin-top:1rem!important}.mt-md-4{margin-top:1.5rem!important}.mt-md-5{margin-top:3rem!important}.mt-md-auto{margin-top:auto!important}.me-md-0{margin-right:0!important}.me-md-1{margin-right:.25rem!important}.me-md-2{margin-right:.5rem!important}.me-md-3{margin-right:1rem!important}.me-md-4{margin-right:1.5rem!important}.me-md-5{margin-right:3rem!important}.me-md-auto{margin-right:auto!important}.mb-md-0{margin-bottom:0!important}.mb-md-1{margin-bottom:.25rem!important}.mb-md-2{margin-bottom:.5rem!important}.mb-md-3{margin-bottom:1rem!important}.mb-md-4{margin-bottom:1.5rem!important}.mb-md-5{margin-bottom:3rem!important}.mb-md-auto{margin-bottom:auto!important}.ms-md-0{margin-left:0!important}.ms-md-1{margin-left:.25rem!important}.ms-md-2{margin-left:.5rem!important}.ms-md-3{margin-left:1rem!important}.ms-md-4{margin-left:1.5rem!important}.ms-md-5{margin-left:3rem!important}.ms-md-auto{margin-left:auto!important}.p-md-0{padding:0!important}.p-md-1{padding:.25rem!important}.p-md-2{padding:.5rem!important}.p-md-3{padding:1rem!important}.p-md-4{padding:1.5rem!important}.p-md-5{padding:3rem!important}.px-md-0{padding-left:0!important;padding-right:0!important}.px-md-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-md-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-md-3{padding-left:1rem!important;padding-right:1rem!important}.px-md-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-md-5{padding-left:3rem!important;padding-right:3rem!important}.py-md-0{padding-bottom:0!important;padding-top:0!important}.py-md-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-md-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-md-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-md-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-md-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-md-0{padding-top:0!important}.pt-md-1{padding-top:.25rem!important}.pt-md-2{padding-top:.5rem!important}.pt-md-3{padding-top:1rem!important}.pt-md-4{padding-top:1.5rem!important}.pt-md-5{padding-top:3rem!important}.pe-md-0{padding-right:0!important}.pe-md-1{padding-right:.25rem!important}.pe-md-2{padding-right:.5rem!important}.pe-md-3{padding-right:1rem!important}.pe-md-4{padding-right:1.5rem!important}.pe-md-5{padding-right:3rem!important}.pb-md-0{padding-bottom:0!important}.pb-md-1{padding-bottom:.25rem!important}.pb-md-2{padding-bottom:.5rem!important}.pb-md-3{padding-bottom:1rem!important}.pb-md-4{padding-bottom:1.5rem!important}.pb-md-5{padding-bottom:3rem!important}.ps-md-0{padding-left:0!important}.ps-md-1{padding-left:.25rem!important}.ps-md-2{padding-left:.5rem!important}.ps-md-3{padding-left:1rem!important}.ps-md-4{padding-left:1.5rem!important}.ps-md-5{padding-left:3rem!important}}@media (min-width:992px){.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-grid{display:grid!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}.d-lg-none{display:none!important}.flex-lg-fill{flex:1 1 auto!important}.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-grow-0{flex-grow:0!important}.flex-lg-grow-1{flex-grow:1!important}.flex-lg-shrink-0{flex-shrink:0!important}.flex-lg-shrink-1{flex-shrink:1!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.justify-content-lg-evenly{justify-content:space-evenly!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{align-self:stretch!important}.order-lg-first{order:-1!important}.order-lg-0{order:0!important}.order-lg-1{order:1!important}.order-lg-2{order:2!important}.order-lg-3{order:3!important}.order-lg-4{order:4!important}.order-lg-5{order:5!important}.order-lg-last{order:6!important}.m-lg-0{margin:0!important}.m-lg-1{margin:.25rem!important}.m-lg-2{margin:.5rem!important}.m-lg-3{margin:1rem!important}.m-lg-4{margin:1.5rem!important}.m-lg-5{margin:3rem!important}.m-lg-auto{margin:auto!important}.mx-lg-0{margin-left:0!important;margin-right:0!important}.mx-lg-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-lg-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-lg-3{margin-left:1rem!important;margin-right:1rem!important}.mx-lg-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-lg-5{margin-left:3rem!important;margin-right:3rem!important}.mx-lg-auto{margin-left:auto!important;margin-right:auto!important}.my-lg-0{margin-bottom:0!important;margin-top:0!important}.my-lg-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-lg-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-lg-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-lg-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-lg-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-lg-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-lg-0{margin-top:0!important}.mt-lg-1{margin-top:.25rem!important}.mt-lg-2{margin-top:.5rem!important}.mt-lg-3{margin-top:1rem!important}.mt-lg-4{margin-top:1.5rem!important}.mt-lg-5{margin-top:3rem!important}.mt-lg-auto{margin-top:auto!important}.me-lg-0{margin-right:0!important}.me-lg-1{margin-right:.25rem!important}.me-lg-2{margin-right:.5rem!important}.me-lg-3{margin-right:1rem!important}.me-lg-4{margin-right:1.5rem!important}.me-lg-5{margin-right:3rem!important}.me-lg-auto{margin-right:auto!important}.mb-lg-0{margin-bottom:0!important}.mb-lg-1{margin-bottom:.25rem!important}.mb-lg-2{margin-bottom:.5rem!important}.mb-lg-3{margin-bottom:1rem!important}.mb-lg-4{margin-bottom:1.5rem!important}.mb-lg-5{margin-bottom:3rem!important}.mb-lg-auto{margin-bottom:auto!important}.ms-lg-0{margin-left:0!important}.ms-lg-1{margin-left:.25rem!important}.ms-lg-2{margin-left:.5rem!important}.ms-lg-3{margin-left:1rem!important}.ms-lg-4{margin-left:1.5rem!important}.ms-lg-5{margin-left:3rem!important}.ms-lg-auto{margin-left:auto!important}.p-lg-0{padding:0!important}.p-lg-1{padding:.25rem!important}.p-lg-2{padding:.5rem!important}.p-lg-3{padding:1rem!important}.p-lg-4{padding:1.5rem!important}.p-lg-5{padding:3rem!important}.px-lg-0{padding-left:0!important;padding-right:0!important}.px-lg-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-lg-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-lg-3{padding-left:1rem!important;padding-right:1rem!important}.px-lg-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-lg-5{padding-left:3rem!important;padding-right:3rem!important}.py-lg-0{padding-bottom:0!important;padding-top:0!important}.py-lg-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-lg-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-lg-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-lg-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-lg-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-lg-0{padding-top:0!important}.pt-lg-1{padding-top:.25rem!important}.pt-lg-2{padding-top:.5rem!important}.pt-lg-3{padding-top:1rem!important}.pt-lg-4{padding-top:1.5rem!important}.pt-lg-5{padding-top:3rem!important}.pe-lg-0{padding-right:0!important}.pe-lg-1{padding-right:.25rem!important}.pe-lg-2{padding-right:.5rem!important}.pe-lg-3{padding-right:1rem!important}.pe-lg-4{padding-right:1.5rem!important}.pe-lg-5{padding-right:3rem!important}.pb-lg-0{padding-bottom:0!important}.pb-lg-1{padding-bottom:.25rem!important}.pb-lg-2{padding-bottom:.5rem!important}.pb-lg-3{padding-bottom:1rem!important}.pb-lg-4{padding-bottom:1.5rem!important}.pb-lg-5{padding-bottom:3rem!important}.ps-lg-0{padding-left:0!important}.ps-lg-1{padding-left:.25rem!important}.ps-lg-2{padding-left:.5rem!important}.ps-lg-3{padding-left:1rem!important}.ps-lg-4{padding-left:1.5rem!important}.ps-lg-5{padding-left:3rem!important}}@media (min-width:1200px){.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-grid{display:grid!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}.d-xl-none{display:none!important}.flex-xl-fill{flex:1 1 auto!important}.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-grow-0{flex-grow:0!important}.flex-xl-grow-1{flex-grow:1!important}.flex-xl-shrink-0{flex-shrink:0!important}.flex-xl-shrink-1{flex-shrink:1!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.justify-content-xl-evenly{justify-content:space-evenly!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{align-self:stretch!important}.order-xl-first{order:-1!important}.order-xl-0{order:0!important}.order-xl-1{order:1!important}.order-xl-2{order:2!important}.order-xl-3{order:3!important}.order-xl-4{order:4!important}.order-xl-5{order:5!important}.order-xl-last{order:6!important}.m-xl-0{margin:0!important}.m-xl-1{margin:.25rem!important}.m-xl-2{margin:.5rem!important}.m-xl-3{margin:1rem!important}.m-xl-4{margin:1.5rem!important}.m-xl-5{margin:3rem!important}.m-xl-auto{margin:auto!important}.mx-xl-0{margin-left:0!important;margin-right:0!important}.mx-xl-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-xl-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-xl-3{margin-left:1rem!important;margin-right:1rem!important}.mx-xl-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-xl-5{margin-left:3rem!important;margin-right:3rem!important}.mx-xl-auto{margin-left:auto!important;margin-right:auto!important}.my-xl-0{margin-bottom:0!important;margin-top:0!important}.my-xl-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-xl-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-xl-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-xl-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-xl-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-xl-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-xl-0{margin-top:0!important}.mt-xl-1{margin-top:.25rem!important}.mt-xl-2{margin-top:.5rem!important}.mt-xl-3{margin-top:1rem!important}.mt-xl-4{margin-top:1.5rem!important}.mt-xl-5{margin-top:3rem!important}.mt-xl-auto{margin-top:auto!important}.me-xl-0{margin-right:0!important}.me-xl-1{margin-right:.25rem!important}.me-xl-2{margin-right:.5rem!important}.me-xl-3{margin-right:1rem!important}.me-xl-4{margin-right:1.5rem!important}.me-xl-5{margin-right:3rem!important}.me-xl-auto{margin-right:auto!important}.mb-xl-0{margin-bottom:0!important}.mb-xl-1{margin-bottom:.25rem!important}.mb-xl-2{margin-bottom:.5rem!important}.mb-xl-3{margin-bottom:1rem!important}.mb-xl-4{margin-bottom:1.5rem!important}.mb-xl-5{margin-bottom:3rem!important}.mb-xl-auto{margin-bottom:auto!important}.ms-xl-0{margin-left:0!important}.ms-xl-1{margin-left:.25rem!important}.ms-xl-2{margin-left:.5rem!important}.ms-xl-3{margin-left:1rem!important}.ms-xl-4{margin-left:1.5rem!important}.ms-xl-5{margin-left:3rem!important}.ms-xl-auto{margin-left:auto!important}.p-xl-0{padding:0!important}.p-xl-1{padding:.25rem!important}.p-xl-2{padding:.5rem!important}.p-xl-3{padding:1rem!important}.p-xl-4{padding:1.5rem!important}.p-xl-5{padding:3rem!important}.px-xl-0{padding-left:0!important;padding-right:0!important}.px-xl-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-xl-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-xl-3{padding-left:1rem!important;padding-right:1rem!important}.px-xl-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-xl-5{padding-left:3rem!important;padding-right:3rem!important}.py-xl-0{padding-bottom:0!important;padding-top:0!important}.py-xl-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-xl-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-xl-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-xl-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-xl-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-xl-0{padding-top:0!important}.pt-xl-1{padding-top:.25rem!important}.pt-xl-2{padding-top:.5rem!important}.pt-xl-3{padding-top:1rem!important}.pt-xl-4{padding-top:1.5rem!important}.pt-xl-5{padding-top:3rem!important}.pe-xl-0{padding-right:0!important}.pe-xl-1{padding-right:.25rem!important}.pe-xl-2{padding-right:.5rem!important}.pe-xl-3{padding-right:1rem!important}.pe-xl-4{padding-right:1.5rem!important}.pe-xl-5{padding-right:3rem!important}.pb-xl-0{padding-bottom:0!important}.pb-xl-1{padding-bottom:.25rem!important}.pb-xl-2{padding-bottom:.5rem!important}.pb-xl-3{padding-bottom:1rem!important}.pb-xl-4{padding-bottom:1.5rem!important}.pb-xl-5{padding-bottom:3rem!important}.ps-xl-0{padding-left:0!important}.ps-xl-1{padding-left:.25rem!important}.ps-xl-2{padding-left:.5rem!important}.ps-xl-3{padding-left:1rem!important}.ps-xl-4{padding-left:1.5rem!important}.ps-xl-5{padding-left:3rem!important}}@media (min-width:1400px){.d-xxl-inline{display:inline!important}.d-xxl-inline-block{display:inline-block!important}.d-xxl-block{display:block!important}.d-xxl-grid{display:grid!important}.d-xxl-table{display:table!important}.d-xxl-table-row{display:table-row!important}.d-xxl-table-cell{display:table-cell!important}.d-xxl-flex{display:flex!important}.d-xxl-inline-flex{display:inline-flex!important}.d-xxl-none{display:none!important}.flex-xxl-fill{flex:1 1 auto!important}.flex-xxl-row{flex-direction:row!important}.flex-xxl-column{flex-direction:column!important}.flex-xxl-row-reverse{flex-direction:row-reverse!important}.flex-xxl-column-reverse{flex-direction:column-reverse!important}.flex-xxl-grow-0{flex-grow:0!important}.flex-xxl-grow-1{flex-grow:1!important}.flex-xxl-shrink-0{flex-shrink:0!important}.flex-xxl-shrink-1{flex-shrink:1!important}.flex-xxl-wrap{flex-wrap:wrap!important}.flex-xxl-nowrap{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xxl-start{justify-content:flex-start!important}.justify-content-xxl-end{justify-content:flex-end!important}.justify-content-xxl-center{justify-content:center!important}.justify-content-xxl-between{justify-content:space-between!important}.justify-content-xxl-around{justify-content:space-around!important}.justify-content-xxl-evenly{justify-content:space-evenly!important}.align-items-xxl-start{align-items:flex-start!important}.align-items-xxl-end{align-items:flex-end!important}.align-items-xxl-center{align-items:center!important}.align-items-xxl-baseline{align-items:baseline!important}.align-items-xxl-stretch{align-items:stretch!important}.align-content-xxl-start{align-content:flex-start!important}.align-content-xxl-end{align-content:flex-end!important}.align-content-xxl-center{align-content:center!important}.align-content-xxl-between{align-content:space-between!important}.align-content-xxl-around{align-content:space-around!important}.align-content-xxl-stretch{align-content:stretch!important}.align-self-xxl-auto{align-self:auto!important}.align-self-xxl-start{align-self:flex-start!important}.align-self-xxl-end{align-self:flex-end!important}.align-self-xxl-center{align-self:center!important}.align-self-xxl-baseline{align-self:baseline!important}.align-self-xxl-stretch{align-self:stretch!important}.order-xxl-first{order:-1!important}.order-xxl-0{order:0!important}.order-xxl-1{order:1!important}.order-xxl-2{order:2!important}.order-xxl-3{order:3!important}.order-xxl-4{order:4!important}.order-xxl-5{order:5!important}.order-xxl-last{order:6!important}.m-xxl-0{margin:0!important}.m-xxl-1{margin:.25rem!important}.m-xxl-2{margin:.5rem!important}.m-xxl-3{margin:1rem!important}.m-xxl-4{margin:1.5rem!important}.m-xxl-5{margin:3rem!important}.m-xxl-auto{margin:auto!important}.mx-xxl-0{margin-left:0!important;margin-right:0!important}.mx-xxl-1{margin-left:.25rem!important;margin-right:.25rem!important}.mx-xxl-2{margin-left:.5rem!important;margin-right:.5rem!important}.mx-xxl-3{margin-left:1rem!important;margin-right:1rem!important}.mx-xxl-4{margin-left:1.5rem!important;margin-right:1.5rem!important}.mx-xxl-5{margin-left:3rem!important;margin-right:3rem!important}.mx-xxl-auto{margin-left:auto!important;margin-right:auto!important}.my-xxl-0{margin-bottom:0!important;margin-top:0!important}.my-xxl-1{margin-bottom:.25rem!important;margin-top:.25rem!important}.my-xxl-2{margin-bottom:.5rem!important;margin-top:.5rem!important}.my-xxl-3{margin-bottom:1rem!important;margin-top:1rem!important}.my-xxl-4{margin-bottom:1.5rem!important;margin-top:1.5rem!important}.my-xxl-5{margin-bottom:3rem!important;margin-top:3rem!important}.my-xxl-auto{margin-bottom:auto!important;margin-top:auto!important}.mt-xxl-0{margin-top:0!important}.mt-xxl-1{margin-top:.25rem!important}.mt-xxl-2{margin-top:.5rem!important}.mt-xxl-3{margin-top:1rem!important}.mt-xxl-4{margin-top:1.5rem!important}.mt-xxl-5{margin-top:3rem!important}.mt-xxl-auto{margin-top:auto!important}.me-xxl-0{margin-right:0!important}.me-xxl-1{margin-right:.25rem!important}.me-xxl-2{margin-right:.5rem!important}.me-xxl-3{margin-right:1rem!important}.me-xxl-4{margin-right:1.5rem!important}.me-xxl-5{margin-right:3rem!important}.me-xxl-auto{margin-right:auto!important}.mb-xxl-0{margin-bottom:0!important}.mb-xxl-1{margin-bottom:.25rem!important}.mb-xxl-2{margin-bottom:.5rem!important}.mb-xxl-3{margin-bottom:1rem!important}.mb-xxl-4{margin-bottom:1.5rem!important}.mb-xxl-5{margin-bottom:3rem!important}.mb-xxl-auto{margin-bottom:auto!important}.ms-xxl-0{margin-left:0!important}.ms-xxl-1{margin-left:.25rem!important}.ms-xxl-2{margin-left:.5rem!important}.ms-xxl-3{margin-left:1rem!important}.ms-xxl-4{margin-left:1.5rem!important}.ms-xxl-5{margin-left:3rem!important}.ms-xxl-auto{margin-left:auto!important}.p-xxl-0{padding:0!important}.p-xxl-1{padding:.25rem!important}.p-xxl-2{padding:.5rem!important}.p-xxl-3{padding:1rem!important}.p-xxl-4{padding:1.5rem!important}.p-xxl-5{padding:3rem!important}.px-xxl-0{padding-left:0!important;padding-right:0!important}.px-xxl-1{padding-left:.25rem!important;padding-right:.25rem!important}.px-xxl-2{padding-left:.5rem!important;padding-right:.5rem!important}.px-xxl-3{padding-left:1rem!important;padding-right:1rem!important}.px-xxl-4{padding-left:1.5rem!important;padding-right:1.5rem!important}.px-xxl-5{padding-left:3rem!important;padding-right:3rem!important}.py-xxl-0{padding-bottom:0!important;padding-top:0!important}.py-xxl-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.py-xxl-2{padding-bottom:.5rem!important;padding-top:.5rem!important}.py-xxl-3{padding-bottom:1rem!important;padding-top:1rem!important}.py-xxl-4{padding-bottom:1.5rem!important;padding-top:1.5rem!important}.py-xxl-5{padding-bottom:3rem!important;padding-top:3rem!important}.pt-xxl-0{padding-top:0!important}.pt-xxl-1{padding-top:.25rem!important}.pt-xxl-2{padding-top:.5rem!important}.pt-xxl-3{padding-top:1rem!important}.pt-xxl-4{padding-top:1.5rem!important}.pt-xxl-5{padding-top:3rem!important}.pe-xxl-0{padding-right:0!important}.pe-xxl-1{padding-right:.25rem!important}.pe-xxl-2{padding-right:.5rem!important}.pe-xxl-3{padding-right:1rem!important}.pe-xxl-4{padding-right:1.5rem!important}.pe-xxl-5{padding-right:3rem!important}.pb-xxl-0{padding-bottom:0!important}.pb-xxl-1{padding-bottom:.25rem!important}.pb-xxl-2{padding-bottom:.5rem!important}.pb-xxl-3{padding-bottom:1rem!important}.pb-xxl-4{padding-bottom:1.5rem!important}.pb-xxl-5{padding-bottom:3rem!important}.ps-xxl-0{padding-left:0!important}.ps-xxl-1{padding-left:.25rem!important}.ps-xxl-2{padding-left:.5rem!important}.ps-xxl-3{padding-left:1rem!important}.ps-xxl-4{padding-left:1.5rem!important}.ps-xxl-5{padding-left:3rem!important}}@media print{.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-grid{display:grid!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}.d-print-none{display:none!important}}";
styleInject(css_248z$9);

var DownloadAttachmentService = /*#__PURE__*/function () {
  function DownloadAttachmentService() {}

  var _proto = DownloadAttachmentService.prototype;

  _proto.downloadFile = function downloadFile(attachmentId, chatSession, connectRegion) {
    var userIdentifier = getUserIdentifier();
    var OPERATION_NAME = 'DownloadChatAttachment';
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: userIdentifier,
      pageName: HelpChannel.LIVE_CHAT,
      operationName: OPERATION_NAME
    };

    var getPresignedUrl = function getPresignedUrl() {
      try {
        var _chatSession$chatSess, _chatSession$chatSess2, _chatSession$chatSess3;

        var data = {
          AttachmentId: attachmentId
        };
        var connectionToken = chatSession === null || chatSession === void 0 ? void 0 : (_chatSession$chatSess = chatSession.chatSession) === null || _chatSession$chatSess === void 0 ? void 0 : (_chatSession$chatSess2 = _chatSession$chatSess.controller) === null || _chatSession$chatSess2 === void 0 ? void 0 : (_chatSession$chatSess3 = _chatSession$chatSess2.connectionHelper) === null || _chatSession$chatSess3 === void 0 ? void 0 : _chatSession$chatSess3.getConnectionToken();
        var headers = {
          'Content-Type': 'application/json',
          'X-Amz-Bearer': connectionToken
        };
        var connectDownloadAttachmentUrl = "https://participant.connect." + connectRegion + ".amazonaws.com/participant/attachment";
        return Promise.resolve(retryOperation(function () {
          return fetch(connectDownloadAttachmentUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        })).then(function (response) {
          return Promise.resolve(response.json()).then(function (parsedResponse) {
            var url = parsedResponse.Url;
            return url;
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    var errorMessage = null;
    getPresignedUrl().then(function (url) {
      windowCopy.open(url, '_blank');
    })["catch"](function (error) {
      myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred in LiveHelpChat while downloading attachment. " + getDetailedErrorMessage(error), logsContext);
      recordErrorCountMetric(HelpChannel.LIVE_CHAT, OPERATION_NAME, JSON.stringify(error));
      errorMessage = error.toString();
    });
    return errorMessage;
  };

  return DownloadAttachmentService;
}();

var css_248z$a = ".message-container{display:flex;flex-direction:column}.time-container{flex-shrink:0}.display-name{padding:8px!important}.customer-container{align-items:flex-end;display:flex;flex-direction:row-reverse;padding:10px;width:100%}.customer-container,.customer-name{align-self:flex-start}.customer-message{border-bottom-left-radius:8px}.customer-message,.customer-typing{border-top-left-radius:8px;border-top-right-radius:8px}.customer-typing{background-color:#add8e6;border-bottom-right-radius:8px}.agent-container{align-items:center;display:flex;flex-direction:row;padding:10px;width:100%}.agent-container,.agent-name{align-self:flex-end}.agent-message{border-bottom-right-radius:8px;flex-grow:1}.agent-message,.agent-typing{border-top-left-radius:8px;border-top-right-radius:8px}.agent-typing{background-color:#90ee90;border-bottom-left-radius:8px}.system-container{align-items:center;display:flex;flex-direction:row;padding:5px;width:100%}.system-container,.system-name{align-self:flex-end}.system-message{border-bottom-right-radius:8px;border-top-left-radius:8px;border-top-right-radius:8px;flex-grow:1}.attachment-link{text-decoration:underline!important}.attachment-link:hover{cursor:pointer}.circular-background{border-radius:50%;height:80px;width:80px}";
styleInject(css_248z$a);

var AttachmentMessage = function AttachmentMessage(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var matches = useBreakpoints();

  if (props.messageData.participant === ParticipantRole.Customer) {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-end",
      className: "customer-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      textAlign: "right",
      fontSize: '14px',
      lineHeight: '22px',
      className: "display-name"
    }, props.messageData.displayName), /*#__PURE__*/React.createElement(View$1, {
      backgroundColor: "#D7EBFB",
      padding: 8,
      className: "customer-message"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "attachment-link",
      fontWeight: "regular",
      role: "link",
      tabIndex: 0,
      fontSize: '16px',
      lineHeight: '24px',
      color: "#232F3E !important",
      onClick: function onClick() {
        return props.downloadAttachment(props.messageData.attachmentId);
      }
    }, props.messageData.attachmentName))));
  } else if (props.messageData.participant === ParticipantRole.Agent || props.messageData.participant === ParticipantRole.System) {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-start",
      className: "agent-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      fontSize: '14px',
      lineHeight: '22px',
      className: "display-name"
    }, props.messageData.participant === ParticipantRole.Agent ? props.messageData.displayName : t('livehelp.system')), /*#__PURE__*/React.createElement(View$1, {
      backgroundColor: "#E8EAEE",
      padding: 8,
      className: "agent-message"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "attachment-link",
      fontWeight: "regular",
      fontSize: '16px',
      lineHeight: '24px',
      role: "link",
      tabIndex: 0,
      color: "#232F3E !important",
      onClick: function onClick() {
        return props.downloadAttachment(props.messageData.attachmentId);
      }
    }, props.messageData.attachmentName))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

var renderText = function renderText(message, color, index, linkTitle) {
  var webAddressPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
  var emailPattern = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
  var newElement = [];

  if (message.match(webAddressPattern)) {
    var parts = message.split(webAddressPattern);

    for (var i = 0; i < parts.length; i++) {
      if (parts[i].match(webAddressPattern)) {
        var title = parts[i];

        if (linkTitle) {
          title = linkTitle;
        }

        newElement.push( /*#__PURE__*/React.createElement(Link, {
          href: parts[i],
          className: "attachment-link",
          target: "_blank",
          fontWeight: "regular",
          role: "link",
          tabIndex: 0,
          color: color + ' !important',
          key: "" + (100 * index + i),
          fontSize: '16px',
          lineHeight: '24px'
        }, title));
      } else {
        newElement.push( /*#__PURE__*/React.createElement("span", {
          key: 100 * index + i
        }, parts[i]));
      }
    }
  } else if (message.match(emailPattern)) {
    var _parts = message.split(emailPattern);

    for (var _i = 0; _i < _parts.length; _i++) {
      if (_parts[_i].match(emailPattern)) {
        var _title = _parts[_i];

        if (linkTitle) {
          _title = linkTitle;
        }

        newElement.push( /*#__PURE__*/React.createElement(Link, {
          href: "mailto:" + _parts[_i],
          className: "attachment-link",
          target: "_blank",
          fontWeight: "regular",
          role: "link",
          tabIndex: 0,
          color: color + ' !important',
          key: "" + (100 * index + _i),
          fontSize: '16px',
          lineHeight: '24px'
        }, _title));
      } else {
        newElement.push( /*#__PURE__*/React.createElement("span", {
          key: 100 * index + _i
        }, _parts[_i]));
      }
    }
  } else {
    newElement.push( /*#__PURE__*/React.createElement("span", {
      key: 100 * index
    }, message));
  }

  return newElement;
};

var MessageContent = function MessageContent(props) {
  var matches = useBreakpoints();
  return /*#__PURE__*/React.createElement(Text$1, {
    color: "#232F3E",
    fontWeight: "regular",
    fontSize: '16px',
    lineHeight: '24px',
    style: {
      overflowWrap: 'break-word'
    }
  }, renderText(props.message, '#232F3E', props.index, props.linkTitle));
};

var TextMessage = function TextMessage(props) {
  if (props.messageData.participant === ParticipantRole.Customer) {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-end",
      className: "customer-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      textAlign: "right",
      fontSize: '14px',
      lineHeight: '22px',
      className: "display-name"
    }, props.messageData.displayName), /*#__PURE__*/React.createElement(View$1, {
      backgroundColor: "#D7EBFB",
      padding: 8,
      className: "customer-message"
    }, /*#__PURE__*/React.createElement(MessageContent, {
      message: props.messageData.content,
      index: props.messageData.index
    }))));
  } else if (props.messageData.participant === ParticipantRole.Agent) {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-start",
      className: "agent-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      fontSize: '14px',
      lineHeight: '22px',
      className: "display-name"
    }, props.messageData.displayName), /*#__PURE__*/React.createElement(View$1, {
      backgroundColor: "#E8EAEE",
      padding: 8,
      className: "agent-message"
    }, /*#__PURE__*/React.createElement(MessageContent, {
      message: props.messageData.content,
      index: props.messageData.index
    }))));
  } else if (props.messageData.participant === ParticipantRole.System) {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-start",
      className: "system-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#232F3E",
      fontSize: '16px',
      lineHeight: '24px'
    }, props.messageData.content)));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

var MessageContainer = function MessageContainer(props) {
  var downloadAttachmentService = new DownloadAttachmentService();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;
  /**
   * Download Attachment
   * Uses Connect-ChatJS to download attachment
   * @param attachmentId
   */


  var downloadAttachment = function downloadAttachment(attachmentId) {
    try {
      var message = props.messages.find(function (item) {
        if (item.attachmentId === attachmentId) {
          return item;
        } else {
          return null;
        }
      });

      if (message && attachmentId) {
        var downloadAttachmentResponse = downloadAttachmentService.downloadFile(attachmentId, props.chatSession, props.connectRegion);

        if (downloadAttachmentResponse) {
          props.props.setChatSession(Object.assign({}, props.props.chatSession, {
            errorMessage: t('livehelp.download_attachment_error'),
            actionResponse: ChatSessionActionResponse.DownloadAttachmentFailed
          }));
        } else {
          props.props.setChatSession(Object.assign({}, props.props.chatSession, {
            errorMessage: '',
            actionResponse: ChatSessionActionResponse.DownloadAttachmentSuccessful
          }));
        }
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var getFormattedDate = function getFormattedDate(time) {
    var date = new Date(time);
    var formattedDate = moment(date).format('dddd MMM. DD, Y · h:mm a');
    return formattedDate;
  };

  var ChatInfoMessage = function ChatInfoMessage() {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-start",
      className: "system-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      fontSize: '14px',
      lineHeight: '22px'
    }, props.messageData.content), /*#__PURE__*/React.createElement(Text$1, {
      color: "#56616C",
      fontSize: '14px',
      lineHeight: '22px'
    }, getFormattedDate(props.messageData.timestamp))));
  };

  if (props.messageData.type === MessageType.Attachment) {
    return /*#__PURE__*/React.createElement(AttachmentMessage, {
      downloadAttachment: downloadAttachment,
      messageData: props.messageData,
      participantToken: props === null || props === void 0 ? void 0 : props.participantToken
    });
  } else if (props.messageData.type === MessageType.Message) {
    return /*#__PURE__*/React.createElement(TextMessage, {
      downloadAttachment: downloadAttachment,
      messageData: props.messageData
    });
  } else if (props.messageData.type === MessageType.ChatInfo) {
    return /*#__PURE__*/React.createElement(ChatInfoMessage, null);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

function arePropsEqual(prevProps, nextProps) {
  return prevProps.messageData.messageId === nextProps.messageData.messageId;
}

var MessageContainer$1 = /*#__PURE__*/memo(MessageContainer, arePropsEqual);

var isFirstMessage = true;
var issue = true;

var MessageRenderHelper = /*#__PURE__*/function () {
  function MessageRenderHelper() {
    /**
     * Render Timestamp
     * Converts timestamp to Local Timezone (based on Browser Settings)
     * Format: hh:mm AM/PM or mm:ss since last message
     * @param timestamp `string`
     * @param last `boolean`
     * @param languageCode `string`
     */
    this.PAGE_NAME = 'ChatContainer';
  }

  var _proto = MessageRenderHelper.prototype;

  _proto.renderTimestamp = function renderTimestamp(timestamp) {
    return new Date(timestamp).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  _proto.sendMessageFromSystem = function sendMessageFromSystem(message, messagesRef, setMessages) {
    var newMessage = {
      displayName: 'System',
      content: message,
      index: messagesRef.current.length,
      participant: ParticipantRole.System,
      type: MessageType.Message,
      timestamp: Date().toString()
    };
    setMessages([].concat(messagesRef.current, [newMessage]));
  };

  _proto.sendChatStatusHeader = function sendChatStatusHeader(message, messagesRef, setMessages, timeStamp) {
    var _timeStamp$toString;

    var newMessage = {
      displayName: '',
      content: message,
      index: messagesRef.current.length,
      participant: ParticipantRole.System,
      type: MessageType.ChatInfo,
      timestamp: (_timeStamp$toString = timeStamp === null || timeStamp === void 0 ? void 0 : timeStamp.toString()) !== null && _timeStamp$toString !== void 0 ? _timeStamp$toString : Date().toString()
    };
    setMessages([].concat(messagesRef.current, [newMessage]));
  };

  _proto.renderMessageFromResponse = function renderMessageFromResponse(messageContent, messagesRef, chatState, setChatState, setMessages, setChatSession) {
    var userIdentifier = getUserIdentifier();
    var newMessage = {
      displayName: messageContent.DisplayName,
      content: messageContent.Content ? messageContent.Content : '',
      index: messagesRef.current.length,
      messageId: messageContent.Id,
      participant: messageContent.ParticipantRole,
      type: messageContent.Type,
      timestamp: messageContent.AbsoluteTime
    }; //Do not render any Welcome message from connect

    if (messageContent.ParticipantRole === ParticipantRole.System && (messageContent.Content.toLowerCase().includes('welcome') || messageContent.Content.toLowerCase().includes('your chat may be recorded for quality or training purposes.'))) {
      return;
    }

    if (messageContent.Type === MessageType.Attachment) {
      newMessage.attachmentName = messageContent.Attachments[0].AttachmentName;
      newMessage.attachmentId = messageContent.Attachments[0].AttachmentId;
      newMessage.contentType = messageContent.Attachments[0].ContentType;
    }

    var i18n = i18.getInstance();

    if (messageContent.ContentType === ContentType.AgentJoined && messageContent.ParticipantRole === ParticipantRole.Agent) {
      var idleness_message = i18n.t('livehelp.idleness_disconnect_message', {
        minutes: chatState.idlenessDisconnectTimeOutInMinutes
      });
      this.sendMessageFromSystem(idleness_message, messagesRef, setMessages);
      this.sendChatStatusHeader(i18n.t('livehelp.chat_session_started'), messagesRef, setMessages, new Date(messageContent.AbsoluteTime));
      setChatState({
        agentConnected: true,
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener,
        waitingForAgentPostTransfer: false
      });
    } else if (messageContent.ContentType === ContentType.ChatTransferSucceeded) {
      setChatState(Object.assign({}, chatState, {
        waitingForAgentPostTransfer: true
      }));
    } else if (messageContent.ContentType === ContentType.AgentLeft && messageContent.ParticipantRole === ParticipantRole.Agent) {
      var user = newMessage.displayName;
      var user_left_chat = chatState.waitingForAgentPostTransfer ? i18n.t('livehelp.user_left_chat_during_transfer', {
        user: user
      }) : i18n.t('livehelp.user_left_chat', {
        user: user
      });
      this.sendMessageFromSystem(user_left_chat, messagesRef, setMessages);
      setChatState({
        agentConnected: false,
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener
      });
      var AGENT_LEFT_CHAT = chatState.waitingForAgentPostTransfer ? 'AgentLeftChatDuringTransfer' : 'AgentLeftChat';
      var agentLeftLogContext = {
        serviceName: ServiceName.LIVEHELP_SERVICE,
        userIdentifier: userIdentifier,
        pageName: this.PAGE_NAME,
        operationName: AGENT_LEFT_CHAT,
        chatMetaData: {
          queueId: chatState.queueId,
          contactFlowId: chatState.contactFlowId
        }
      };
      myHRLoggerInfoLog("[" + chatState.chatTokens.contactId + "]: Agent left the chat: " + JSON.stringify(chatState.cti) + "}", agentLeftLogContext);
      recordCountMetric(this.PAGE_NAME, AGENT_LEFT_CHAT, MetricEvents.COUNT);
    } else if (messageContent.ParticipantRole === ParticipantRole.System && messageContent.Content === EndChatType.AgentNotAvailable) {
      var CHAT_CLOSED_NO_AGENTS_AVAILABLE_OPERATION_NAME = 'ChatClosedDueToNoAgentsAvailable';
      var chatEndedLogContext = {
        serviceName: ServiceName.LIVEHELP_SERVICE,
        userIdentifier: userIdentifier,
        pageName: this.PAGE_NAME,
        operationName: CHAT_CLOSED_NO_AGENTS_AVAILABLE_OPERATION_NAME,
        chatMetaData: {
          queueId: chatState.queueId,
          contactFlowId: chatState.contactFlowId
        }
      };
      myHRLoggerWarnLog("[" + chatState.chatTokens.contactId + "]: Chat closed due to no agents available. Details { employeeId : " + userIdentifier + ", cti : " + JSON.stringify(chatState.cti) + "}", chatEndedLogContext);
      recordCountMetric(HelpChannel.LIVE_CHAT, CHAT_CLOSED_NO_AGENTS_AVAILABLE_OPERATION_NAME, MetricEvents.COUNT);
      setChatState({
        agentConnected: false,
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener
      });
    } else if (messageContent.ContentType === ContentType.ChatEnded) {
      setChatSession({
        chatSession: null,
        connectionStatus: ChatSessionConnectionStatus.Ended,
        errorMessage: ''
      });
    }

    var getWaitTime = function getWaitTime(waitTime) {
      if (waitTime < 1) {
        return i18n.t('livehelp.waiting_time_less_than_minute_text');
      } else if (waitTime === 1) {
        return i18n.t('livehelp.waiting_time_minute_text', {
          minutes: waitTime
        });
      } else if (waitTime < 60) {
        return i18n.t('livehelp.waiting_time_minutes_text', {
          minutes: waitTime
        });
      } else if (waitTime < 120) {
        return i18n.t('livehelp.waiting_time_hours_text', {
          hours: '1-2'
        });
      } else {
        return i18n.t('livehelp.waiting_time_more_than_hours_text', {
          hours: '2'
        });
      }
    };

    if (newMessage.type === MessageType.Attachment || newMessage.content !== undefined && newMessage.content !== null && newMessage.content.trim().length > 0) {
      setMessages([].concat(messagesRef.current, [newMessage]));
      if (isFirstMessage || issue) isFirstMessage = true;

      if (isFirstMessage === true) {
        issue = false;

        if (chatState.isDescribeIssue) {
          setChatState({
            isDescribeIssue: false
          });
        }

        isFirstMessage = false;
        this.sendMessageFromSystem(i18n.t('livehelp.chat_waitTime_system_message') + ' ' + getWaitTime(chatState.waitTime) + '.', messagesRef, setMessages);

        if (chatState.chatRecordingBehavior === ChatRecordingBehavior.Consent) {
          this.sendMessageFromSystem(i18n.t('livehelp.record_chat_session'), messagesRef, setMessages);
        }
      }
    }
  };

  _proto.renderMessagesFromTranscript = function renderMessagesFromTranscript(customerChatSession, messagesRef, chatState, setChatState, setMessages, setChatSession, receivedMessageIdsRef, addToReceivedMessageIds) {
    try {
      var _this2 = this;

      var nextToken = null;
      issue = chatState.isDescribeIssue;

      var _temp2 = _do(function () {
        return Promise.resolve(customerChatSession.getTranscript({
          maxResults: 100,
          sortOrder: 'ASCENDING'
        })).then(function (transcriptData) {
          var previousMessagesBatch = transcriptData.data.Transcript;
          previousMessagesBatch.forEach(function (messageContent) {
            if (receivedMessageIdsRef.current.has(messageContent.Id)) {
              return;
            }

            addToReceivedMessageIds(messageContent.Id);

            _this2.renderMessageFromResponse(messageContent, messagesRef, chatState, setChatState, setMessages, setChatSession);
          });
          nextToken = transcriptData.nextToken;
        });
      }, function () {
        return !!nextToken;
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return MessageRenderHelper;
}();

var css_248z$b = ".message-board,.message-board-mobile{background-color:#fff;overflow-y:auto;padding-left:32px!important;padding-right:32px!important;padding-top:2%;width:100%}.agent-typing{border-bottom-left-radius:8px;border-top-left-radius:8px;border-top-right-radius:8px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}@-webkit-keyframes bot-think{0%{opacity:1}50%{opacity:0}to{opacity:1}}@keyframes bot-think{0%{opacity:1}50%{opacity:0}to{opacity:1}}.bot-thinking{-webkit-animation:bot-think 2s infinite;animation:bot-think 2s infinite}.message-list{list-style:none;padding:0}.chat-inner-header-container{display:flex;flex-direction:column;padding:42px 8px 32px}.chat-header-subtitle{color:#161e2d;display:flex;flex-direction:row;padding-top:8px}";
styleInject(css_248z$b);

var MessageBoard = function MessageBoard(props) {
  var matches = useBreakpoints();
  var messageBoardBottomRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var scrollToBottom = function scrollToBottom() {
    if (!props.isHistoryComponent && messageBoardBottomRef.current) {
      messageBoardBottomRef.current.scrollIntoView();
    }
  };

  useEffect(function () {
    scrollToBottom();
  }, [props.messages, props.fileUploadStatus]);

  var getTopic = function getTopic() {
    var _props$cti, _props$cti2;

    return (_props$cti = props.cti) !== null && _props$cti !== void 0 && _props$cti.I ? props.cti.I : (_props$cti2 = props.cti) !== null && _props$cti2 !== void 0 && _props$cti2.T ? props.cti.T : props.cti ? props.cti.C : 'Not known';
  };

  var AgentTyping = function AgentTyping() {
    return /*#__PURE__*/React.createElement(Col, {
      margin: {
        top: 8
      },
      alignItems: "flex-start",
      className: "system-container"
    }, /*#__PURE__*/React.createElement(View$1, {
      maxWidth: "90%"
    }, /*#__PURE__*/React.createElement(Text$1, {
      color: "#232F3E",
      fontSize: '16px',
      lineHeight: '24px'
    }, t('livehelp.chat_agent_typing_message') + '...')));
  };

  var ChatHeader = function ChatHeader() {
    return /*#__PURE__*/React.createElement(View$1, {
      className: "chat-inner-header-container"
    }, props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue && /*#__PURE__*/React.createElement(Text$1, {
      fontSize: '22px',
      lineHeight: '32px',
      color: '#161E2D',
      fontWeight: 'medium'
    }, t('livehelp.describe_issue_title')), /*#__PURE__*/React.createElement(View$1, {
      className: "chat-header-subtitle"
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: '16px',
      lineHeight: '24px'
    }, t('livehelp.chat_header_subtitle_key'), ": \xA0"), /*#__PURE__*/React.createElement(Text$1, {
      fontSize: '16px',
      lineHeight: '24px'
    }, getTopic())));
  };

  return /*#__PURE__*/React.createElement(Container, {
    className: matches.matches.l || matches.matches.xl ? 'message-board' : 'message-board-mobile',
    tabIndex: 0,
    "aria-label": "Message Board",
    role: 'group'
  }, !props.isHistoryComponent && /*#__PURE__*/React.createElement(ChatHeader, null), props.messages.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ol", {
    className: "message-list",
    role: 'list'
  }, props.messages.map(function (message) {
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MessageContainer$1, {
      key: message.index,
      messageData: message,
      messages: props.messages,
      chatSession: props.chatSession,
      props: props,
      participantToken: props === null || props === void 0 ? void 0 : props.participantToken,
      connectRegion: props.connectRegion
    }));
  }))), props.isAgentTyping && /*#__PURE__*/React.createElement(AgentTyping, null), /*#__PURE__*/React.createElement("span", {
    ref: messageBoardBottomRef
  }));
};

var css_248z$c = "#chat_transcript_opt_in_title_text{color:#282626;font-size:22px;font-weight:400;margin-top:5px}";
styleInject(css_248z$c);

var ChatRecordingOptModal = function ChatRecordingOptModal(props) {
  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var PAGE_NAME = 'ChatRecordingOptModal';
  var userIdentifier = getUserIdentifier();
  var OPERATION_NAME = 'ChatTranscriptOptIn';
  var CONSENT = 'CONSENT';
  var DECLINE = 'DECLINE';
  var CANCEL = 'CANCEL';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME,
    chatMetaData: {
      queueId: props.chatState.queueId,
      contactFlowId: props.chatState.contactFlowId
    }
  };

  var chatRecordingConsent = function chatRecordingConsent() {
    props.setChatState({
      chatRecordingBehavior: ChatRecordingBehavior.Consent
    });
    publishLogsAndMetricsforChatRecordingOptIn(CONSENT);
  };

  var chatRecordingDecline = function chatRecordingDecline() {
    props.setChatState({
      chatRecordingBehavior: ChatRecordingBehavior.Decline
    });
    publishLogsAndMetricsforChatRecordingOptIn(DECLINE);
  };

  var chatRecordingCancel = function chatRecordingCancel() {
    props.setChatState({
      chatRecordingBehavior: ChatRecordingBehavior.Decline
    });
    publishLogsAndMetricsforChatRecordingOptIn(CANCEL);
  };

  var publishLogsAndMetricsforChatRecordingOptIn = function publishLogsAndMetricsforChatRecordingOptIn(optedChatRecordingBehavior) {
    var operationName = "" + OPERATION_NAME + optedChatRecordingBehavior;

    if (isComponentInline()) {
      myHRLoggerInfoLog("[" + userIdentifier + "]: User clicked on " + optedChatRecordingBehavior + " for chat transcript, on pageName " + getPageName() + " for client: " + getClientId$1(), Object.assign({}, logsContext, {
        operationName: operationName,
        clientId: getClientId$1(),
        pageName: getPageName()
      }));
    } else {
      myHRLoggerInfoLog("[" + userIdentifier + "]: User clicked on " + optedChatRecordingBehavior + " for chat transcript.", Object.assign({}, logsContext, {
        operationName: operationName
      }));
    }

    recordCountMetric(PAGE_NAME, operationName, MetricEvents.COUNT);
  };

  var isChatTranscriptOptInModalOpen = function isChatTranscriptOptInModalOpen() {
    return props.chatState.chatRecordingBehavior === ChatRecordingBehavior.OptIn;
  };

  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnClickOutside: false,
    isOpen: isChatTranscriptOptInModalOpen(),
    close: chatRecordingCancel
  }, /*#__PURE__*/React.createElement(ModalContent, {
    titleText: t('livehelp.chat_transcript_opt_in_modal_title'),
    titleTextId: "chat_transcript_opt_in_title_text",
    onCloseButtonClick: chatRecordingCancel,
    buttons: [/*#__PURE__*/React.createElement(Button, {
      css: {
        width: matches.s ? '100%' : 'auto'
      },
      isDestructive: false,
      variant: ButtonVariant.Primary,
      onClick: chatRecordingConsent
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: '14px'
    }, t('livehelp.chat_transcript_opt_in_consent'))), /*#__PURE__*/React.createElement(Button, {
      css: {
        width: matches.s ? '100%' : 'auto'
      },
      isDestructive: true,
      variant: ButtonVariant.Primary,
      onClick: chatRecordingDecline
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: '14px'
    }, t('livehelp.chat_transcript_opt_in_decline')))]
  }, /*#__PURE__*/React.createElement(Text$1, {
    color: 'neutral90',
    fontSize: '16px'
  }, t('livehelp.chat_transcript_opt_in_modal_content'))));
};

/**
 * @function updateChatContactAttributes - function to send a post request to updateChatContact API
 * @param region - liveChat region
 * @param instanceId - liveChat instanceId
 * @param initialContactId - liveChat initialContactId
 * @param attributes - request attributes
 * @param pageName - pageName attribute for logging
 */

var updateChatContactAttributes = function updateChatContactAttributes(region, instanceId, initialContactId, attributes, pageName, connectAWSAccount) {
  try {
    var queryParams = {
      'x-myhr-client-id': 'MyHR_LiveHelp',
      operation: 'api/contact/chat/attributes'
    };
    var body = {
      region: region,
      instanceId: instanceId,
      initialContactId: initialContactId,
      attributes: attributes,
      connectAWSAccount: connectAWSAccount
    };
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: getUserIdentifier(),
      pageName: pageName,
      operationName: 'UpdateChatContactAttributes'
    };

    if (!body.region || !body.instanceId || !body.initialContactId) {
      recordCountMetric(logsContext.pageName, logsContext.operationName, MetricEvents.INVALID_INPUT);
      throw new Error("Invalid chat attributes - " + JSON.stringify(body));
    }

    var backendServiceClient = new BackendServiceClientWrapper();
    var startTimePostCall = Date.now();
    return Promise.resolve(backendServiceClient.post(body, queryParams).then(function () {
      recordLatencyMetric(logsContext.pageName, logsContext.operationName, startTimePostCall);
      recordCountMetric(logsContext.pageName, logsContext.operationName, MetricEvents.SUCCESS_COUNT);
    })["catch"](function (_e) {
      recordErrorCountMetric(logsContext.pageName, logsContext.operationName, JSON.stringify(_e));
      throw JSON.stringify(_e);
    })).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};

var MayDayServices = /*#__PURE__*/function () {
  function MayDayServices() {}

  var _proto = MayDayServices.prototype;

  _proto.getChatTokens = function getChatTokens(preferredName, country, preferredLanguage, createNewChatContact, //If true, forces service to create new chat session
  instanceId, contactFlowId, queueId, userContext, businessLine, region, userIdentifier, waitTimeInMin, isWaitTimeDisplayed, timeStampForLiveHelpClick, timeStampForChatClick, isAtoZApp, connectAWSAccount, idlenessDisconnectTimeOutInMinutes, chatRecordingBehavior) {
    try {
      var _isWaitTimeDisplayed;

      var PAGE_NAME = 'LiveHelpChat';
      var OPERATION_NAME = 'CreateChatContact';
      var logsContext = {
        serviceName: ServiceName.LIVEHELP_SERVICE,
        userIdentifier: userIdentifier,
        pageName: HelpChannel.LIVE_CHAT,
        operationName: OPERATION_NAME,
        chatMetaData: {
          queueId: queueId,
          contactFlowId: contactFlowId
        }
      };
      var backendServiceClient = new BackendServiceClientWrapper();
      var queryParams = {
        'x-myhr-client-id': 'MyHR_LiveHelp',
        operation: '/api/contact/chat'
      };
      var body = {
        attributes: {
          preferredName: preferredName,
          location_country: country,
          queueId: queueId,
          queuePassed: queueId ? 'true' : 'false',
          userLanguage: preferredLanguage,
          userContext: userContext,
          businessLine: businessLine,
          waitTimeInMin: waitTimeInMin === null || waitTimeInMin === void 0 ? void 0 : waitTimeInMin.toString(),
          isWaitTimeDisplayed: (_isWaitTimeDisplayed = !isWaitTimeDisplayed) === null || _isWaitTimeDisplayed === void 0 ? void 0 : _isWaitTimeDisplayed.toString(),
          timeStampForLiveHelpClick: timeStampForLiveHelpClick === null || timeStampForLiveHelpClick === void 0 ? void 0 : timeStampForLiveHelpClick.toString(),
          timeStampForChatClick: timeStampForChatClick === null || timeStampForChatClick === void 0 ? void 0 : timeStampForChatClick.toString(),
          isAtoZApp: isAtoZApp.toString(),
          chat_recording_optin: chatRecordingBehavior
        },
        chatContactChannel: {
          instanceId: instanceId,
          contactFlowId: contactFlowId,
          queueId: queueId,
          region: region,
          businessLine: businessLine,
          idlenessDisconnectTimeOutInMinutes: idlenessDisconnectTimeOutInMinutes
        },
        initialMessage: 'Hey there!',
        connectAWSAccount: connectAWSAccount,
        createNewChatContact: createNewChatContact
      };
      return Promise.resolve(_catch(function () {
        if (!body.chatContactChannel.instanceId || !body.chatContactChannel.contactFlowId || !body.chatContactChannel.region) {
          myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while creating chat contact channel. Invalid voice contact channel attributes - " + JSON.stringify(body.chatContactChannel), logsContext);
          recordCountMetric(logsContext.pageName, logsContext.operationName, MetricEvents.INVALID_INPUT);
          throw Error("Invalid chatContactChannel attributes. Attributes details - " + JSON.stringify(body.chatContactChannel));
        }

        var startTimeCreateChatContact = Date.now();
        return Promise.resolve(backendServiceClient.post(body, queryParams)).then(function (result) {
          recordLatencyMetric(PAGE_NAME, OPERATION_NAME, startTimeCreateChatContact);
          recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
          var ChatAPIData = JSON.parse(result.data.response);
          var tokens = {
            contactId: ChatAPIData['contactId'],
            participantId: ChatAPIData['participantId'],
            participantToken: ChatAPIData['participantToken'],
            initialContactId: ChatAPIData['initialContactId']
          };
          myHRLoggerInfoLog("[" + tokens.initialContactId + "]: Chat session created for user - " + userIdentifier + " with wait time " + waitTimeInMin, logsContext);
          return tokens;
        });
      }, function (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error while getting the chat token. " + getDetailedErrorMessage(error), logsContext);
        var NETWORK_ERROR = 'Network Error';
        var RE_RESPONSE_ERROR_OPERATION_NAME = (error === null || error === void 0 ? void 0 : error.message) === NETWORK_ERROR ? 'NetworkErrorInGettingREResponse' : OPERATION_NAME;
        recordErrorCountMetric(PAGE_NAME, RE_RESPONSE_ERROR_OPERATION_NAME, JSON.stringify(error));
        console.log('Error in Getting RE response', error);
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getActiveChatSession = function getActiveChatSession() {
    try {
      var PAGE_NAME = 'LiveHelpChat';
      var OPERATION_NAME = 'QueryChatSession';
      var userIdentifier = getUserIdentifier();
      var logsContext = {
        serviceName: ServiceName.LIVEHELP_SERVICE,
        userIdentifier: userIdentifier,
        pageName: HelpChannel.LIVE_CHAT,
        operationName: OPERATION_NAME
      };
      var backendServiceClient = new BackendServiceClientWrapper();
      var queryParams = {
        'x-myhr-client-id': 'MyHR_LiveHelp',
        operation: '/api/contact/chat'
      };
      return Promise.resolve(_catch(function () {
        var startTimeQueryChatSession = Date.now();
        return Promise.resolve(backendServiceClient.get(queryParams)).then(function (result) {
          recordLatencyMetric(PAGE_NAME, OPERATION_NAME, startTimeQueryChatSession);
          recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
          var chatSessionData = JSON.parse(result.data.response);

          if (chatSessionData.contactId === null) {
            return null;
          }

          myHRLoggerInfoLog("[" + chatSessionData.contactId + "]: Queried active chat session for user - " + userIdentifier, logsContext);
          return chatSessionData;
        });
      }, function (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error while querying active chat session. " + getDetailedErrorMessage(error), logsContext);
        recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(error));
        throw error;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return MayDayServices;
}();

var mayDayServices = /*#__PURE__*/new MayDayServices();
var messageRenderHelper = /*#__PURE__*/new MessageRenderHelper();

var init = function init(employeeAttributes, queueId, contactFlowId) {
  var OPERATION_NAME = 'CreateChatConnection';

  var getFirstName = function getFirstName(legalName) {
    return legalName.substring(0, legalName.indexOf(' ') === -1 ? legalName.length : legalName.indexOf(' '));
  };

  var getPreferredName = function getPreferredName() {
    if (employeeAttributes !== null && employeeAttributes !== void 0 && employeeAttributes.preferredName) {
      return employeeAttributes.preferredName;
    } else if (employeeAttributes !== null && employeeAttributes !== void 0 && employeeAttributes.legalName) {
      return getFirstName(employeeAttributes.legalName);
    } else if (employeeAttributes !== null && employeeAttributes !== void 0 && employeeAttributes.login) {
      return employeeAttributes === null || employeeAttributes === void 0 ? void 0 : employeeAttributes.login;
    } else {
      return 'User';
    }
  };

  var userIdentifier = getUserIdentifier(getPreferredName());
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: HelpChannel.LIVE_CHAT,
    operationName: OPERATION_NAME,
    chatMetaData: {
      queueId: queueId,
      contactFlowId: contactFlowId
    }
  };
  var preferredName = getPreferredName();
  var isAtoZApp = !isEnvironmentBrowser();
  return {
    logsContext: logsContext,
    preferredName: preferredName,
    userIdentifier: userIdentifier,
    isAtoZApp: isAtoZApp
  };
};

var createChat = function createChat(employeeAttributes, preferredLanguage, instanceId, contactFlowId, queueId, userContext, businessLine, region, waitTimeInMin, isWaitTimeDisplayed, timeStampForLiveHelpClick, timeStampForChatClick, connectAWSAccount, idlenessDisconnectTimeOutInMinutes, chatRecordingBehavior, receivedProps, liveHelpClickSource, connectToPriorityQueue) {
  try {
    var _init = init(employeeAttributes, queueId, contactFlowId),
        logsContext = _init.logsContext,
        preferredName = _init.preferredName,
        userIdentifier = _init.userIdentifier,
        isAtoZApp = _init.isAtoZApp;

    var receivedExpiredTokens = false;
    return Promise.resolve(mayDayServices.getChatTokens(preferredName, employeeAttributes.country, preferredLanguage, receivedExpiredTokens, instanceId, contactFlowId, queueId, userContext, businessLine, region, userIdentifier, waitTimeInMin, isWaitTimeDisplayed, timeStampForLiveHelpClick, timeStampForChatClick, isAtoZApp, connectAWSAccount, idlenessDisconnectTimeOutInMinutes, chatRecordingBehavior)).then(function (chatTokens) {
      var connectProperties = {
        instanceId: instanceId,
        contactFlowId: contactFlowId,
        queueId: queueId,
        contactId: chatTokens.contactId
      };
      var intentDisambiguted = userContext.split('_');
      var intent = {
        C: intentDisambiguted[0],
        T: intentDisambiguted[1],
        I: intentDisambiguted[2]
      };

      if (connectToPriorityQueue) {
        logPriortyQueue({
          sourceIntent: intent,
          bussinessLine: businessLine
        }).then(function () {
          return console.log('logged metric from Priorty_Queue');
        })["catch"](function (error) {
          myHRLoggerErrorLog("[" + userIdentifier + "]: Unable to publish business metric for Priorty_Queue_Users. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
            operationName: CommonOperations.SUCESS_PRIORTY_QUEUE_USER_METRIC
          }));
          recordErrorCountMetric(HelpChannel.LIVE_CHAT, CommonOperations.SUCESS_PRIORTY_QUEUE_USER_METRIC, JSON.stringify(error));
        });
      }

      logContactVolumeMetric({
        sourceIntent: intent,
        helpChannel: HelpChannel.LIVE_CHAT,
        connectProperties: connectProperties,
        clickSource: liveHelpClickSource,
        typeOfMRI: receivedProps.typeOfMRI,
        variation: receivedProps.variation
      }).then(function () {
        return console.log('logged metric from chat');
      })["catch"](function (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Unable to publish business volume metric from chat. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
          operationName: CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC
        }));
        recordErrorCountMetric(HelpChannel.LIVE_CHAT, CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC, JSON.stringify(error));
      });
      return chatTokens;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var startChat = function startChat(employeeAttributes, participantId, participantToken, initialContactId, region, chatState, setChatState, chatSession, setChatSession, messagesRef, setMessages, receivedMessageIdsRef, addToReceivedMessageIds) {
  try {
    var _init2 = init(employeeAttributes, chatState.queueId, chatState.contactFlowId),
        logsContext = _init2.logsContext,
        preferredName = _init2.preferredName,
        userIdentifier = _init2.userIdentifier;

    try {
      connect.ChatSession.setGlobalConfig({
        loggerConfig: {
          // optional, the logging configuration. If omitted, no logging occurs
          logger: {
            debug: function debug(msg) {
              return console.debug(msg);
            },
            info: function info(msg) {
              return console.info(msg);
            },
            warn: function warn(msg) {
              return console.warn(msg);
            },
            error: function error(msg) {
              return console.error(msg);
            }
          },
          level: connect.ChatSession.LogLevel.WARN
        },
        region: region
      });
    } catch (error) {
      myHRLoggerErrorLog("[" + userIdentifier + "]: ChatSession setGlobalConfig failed. " + getDetailedErrorMessage(error) + "}", logsContext);
      setChatSession({
        chatSession: null,
        connectionStatus: ChatSessionConnectionStatus.Failure,
        errorMessage: 'Unable to establish chat session. Refresh the page.',
        actionResponse: ChatSessionActionResponse.NoAction
      });
      recordErrorCountMetric(HelpChannel.LIVE_CHAT, CommonOperations.ATOZ_TOKEN_EXPIRED, JSON.stringify(error));
    }

    var connectToAgent = function connectToAgent() {
      try {
        //creating chat session
        var customerChatSession = connect.ChatSession.create({
          chatDetails: {
            contactId: initialContactId,
            participantId: participantId,
            participantToken: participantToken
          },
          type: connect.ChatSession.SessionTypes.CUSTOMER
        });
        return Promise.resolve(customerChatSession.connect()).then(function (_ref) {
          var connectCalled = _ref.connectCalled,
              connectSuccess = _ref.connectSuccess;

          if (connectSuccess) {
            setChatSession(Object.assign({}, chatSession, {
              chatSession: customerChatSession,
              connectionStatus: ChatSessionConnectionStatus.Connected
            }));
            setChatState({
              newChatSession: false
            });
            messageRenderHelper.renderMessagesFromTranscript(customerChatSession, messagesRef, chatState, setChatState, setMessages, setChatSession, receivedMessageIdsRef, addToReceivedMessageIds)["catch"](function (error) {
              myHRLoggerErrorLog("[" + userIdentifier + "]: Error occured in LiveHelpChat while fetching previous messages. " + getDetailedErrorMessage(error), logsContext);
              recordErrorCountMetric(HelpChannel.LIVE_CHAT, CommonOperations.MESSAGES_DOWNLOAD_FAILED, JSON.stringify(error));
            });
          } else {
            throw new Error('Unable to establish Chat session');
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    connectToAgent().then(function () {
      console.log('CHAT SESSION CONNECTED.');
      myHRLoggerInfoLog("[" + initialContactId + "]: Chat session connected successfully for user " + userIdentifier, logsContext);
    })["catch"](function (error) {
      if (chatState.newChatSession) {
        var _error$_debug, _error$_debug$_debug;

        console.log('Unable to establish chat session:', error);
        myHRLoggerErrorLog("[" + userIdentifier + "]: Unable to establish chat session. " + getDetailedErrorMessage(error), logsContext);
        setChatSession({
          chatSession: null,
          connectionStatus: ChatSessionConnectionStatus.Failure,
          errorMessage: 'Unable to establish chat session. Please try again.',
          actionResponse: ChatSessionActionResponse.NoAction
        });
        var chatConnectionFailedReason = error === null || error === void 0 ? void 0 : (_error$_debug = error._debug) === null || _error$_debug === void 0 ? void 0 : (_error$_debug$_debug = _error$_debug._debug) === null || _error$_debug$_debug === void 0 ? void 0 : _error$_debug$_debug.type;
        var NETWORKING_ERROR = 'NetworkingError';
        var ACCESS_DENIED_ERROR = 'AccessDeniedException';
        var CHAT_CONNECTION_FAILED_OPERATION_NAME = chatConnectionFailedReason === NETWORKING_ERROR ? 'ChatConnectionFailedDueToNetworkError' : chatConnectionFailedReason === ACCESS_DENIED_ERROR ? 'ChatConnectionFailedDueToAccessDeniedError' : 'ChatConnectionFailedDueToNonNetworkError';
        recordErrorCountMetric(HelpChannel.LIVE_CHAT, CHAT_CONNECTION_FAILED_OPERATION_NAME, JSON.stringify(error));
      } else {
        setChatSession({
          chatSession: null,
          connectionStatus: ChatSessionConnectionStatus.Failure,
          errorMessage: 'This chat session has ended. Please create a new chat.',
          actionResponse: ChatSessionActionResponse.NoAction
        });
      }
    });
    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};
var closeConnectionFromParticipantSide = function closeConnectionFromParticipantSide(chatSession, setChatSession, chatState, pageName, connectAWSAccount, disconnectDueToIdle) {
  if (disconnectDueToIdle === void 0) {
    disconnectDueToIdle = false;
  }

  try {
    var _temp3 = function _temp3(_result) {
      if (_exit2) return _result;

      if (chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue || chatSession.connectionStatus === ChatSessionConnectionStatus.Connected) {
        setChatSession(Object.assign({}, chatSession, {
          chatSession: null,
          connectionStatus: ChatSessionConnectionStatus.Ended,
          errorMessage: ''
        }));
      }
    };

    var _exit2 = false;

    var _temp4 = function () {
      if (chatSession.connectionStatus === ChatSessionConnectionStatus.Connected) {
        return Promise.resolve(chatSession.chatSession.disconnectParticipant()).then(function (result) {
          var attributes = {};
          var disconnectionReasonKey = 'disconnectedDueToIdleness';
          attributes[disconnectionReasonKey] = disconnectDueToIdle.toString();

          try {
            updateChatContactAttributes(chatState.region, chatState.instanceId, chatSession.chatSession.controller.initialContactId, attributes, pageName, connectAWSAccount);
          } catch (e) {
            throw e;
          }
        });
      }
    }();

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
  } catch (e) {
    return Promise.reject(e);
  }
};

var css_248z$d = ".end-chat-modal-button{font-size:16px!important;width:100%}";
styleInject(css_248z$d);

var EndChatModal = function EndChatModal(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var PAGE_NAME = 'ChatContainer';
  var OPERATION_NAME = 'EndChat';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME,
    chatMetaData: {
      queueId: props.chatState.queueId,
      contactFlowId: props.chatState.contactFlowId
    }
  };
  var messageRenderHelper = new MessageRenderHelper();

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var cancelDisconnect = function cancelDisconnect() {
    var _props$chatState$chat;

    console.log('[Live Chat] End Chat Cancelled');
    myHRLoggerInfoLog("[" + ((_props$chatState$chat = props.chatState.chatTokens) === null || _props$chatState$chat === void 0 ? void 0 : _props$chatState$chat.initialContactId) + "]: User clicked on cancel end chat", logsContext);
    props.setChatState(Object.assign({}, props.chatState, {
      confirmExit: false
    }));
  };

  var confirmDisconnect = function confirmDisconnect() {
    try {
      var _temp3 = function _temp3() {
        setTimeout(function () {
          if (props.chatCloseButtonRef.current && !props.willSurveyBeShown) {
            props.chatCloseButtonRef.current.focus();
          }
        }, 1000);

        if (props.chatState.disconnectFor === DisconnectFor.Window) {
          props.onCloseChatWindow();
        }
      };

      console.log('[Live Chat] End Chat Confirmed');
      props.setChatState(Object.assign({}, props.chatState, {
        confirmExit: false
      }));
      messageRenderHelper.sendMessageFromSystem(t('livehelp.chat_ended'), props.messagesRef, props.setMessages);

      var _temp4 = _catch(function () {
        // additional variable is used to store the connectionStatus of chatSession as it gets altered after function call
        var connectionStatus = props.chatSession.connectionStatus;

        if (props.chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue) {
          var operationName = 'ChatEndedWithoutDescribeIsuue';
          myHRLoggerInfoLog("[" + getUserIdentifier() + "] : Chat ended by employee before describe issue. cti: " + JSON.stringify(props.chatState.cti), Object.assign({}, logsContext, {
            operationName: operationName
          }));
          recordCountMetric(PAGE_NAME, operationName, MetricEvents.COUNT);
        }

        return Promise.resolve(closeConnectionFromParticipantSide(props.chatSession, props.setChatSession, props.chatState, PAGE_NAME, props.chatState.connectAWSAccount)).then(function () {
          if (connectionStatus !== ChatSessionConnectionStatus.DescribeIssue) {
            if (props.chatState.agentConnected && !props.messagesRef.current.find(function (messageContent) {
              return messageContent.participant === ParticipantRole.Agent;
            })) {
              var CHAT_ENDED_BEFORE_AGENT_FIRST_RESPONSE_OPERATION_NAME = 'ChatEndedByEmployeeBeforeAgentsFirstResponse';
              myHRLoggerInfoLog("[" + props.chatState.chatTokens.contactId + "]: Chat ended by employee before agents first response when agent is connected. cti: " + JSON.stringify(props.chatState.cti), Object.assign({}, logsContext, {
                operationName: CHAT_ENDED_BEFORE_AGENT_FIRST_RESPONSE_OPERATION_NAME
              }));
              recordCountMetric(PAGE_NAME, CHAT_ENDED_BEFORE_AGENT_FIRST_RESPONSE_OPERATION_NAME, MetricEvents.COUNT);
            }

            if (!props.chatState.agentConnected) {
              var expectedWaitTimeInSeconds = Math.max(props.chatState.waitTime, 1) * 60;
              var chatStartTime = new Date(props.messagesRef.current[0].timestamp).getTime();
              var employeeWaitTimeInSeconds = Math.floor((Date.now() - chatStartTime) / 1000); // time for which employee waited for agent before ending the chat

              var CHAT_ENDED_BEFORE_AGENT_JOINED_OPERATION_NAME = employeeWaitTimeInSeconds > expectedWaitTimeInSeconds ? 'ChatEndedByEmployeeAfterExpectedWaitTimeForAgent' : 'ChatEndedByEmployeeBeforeExpectedWaitTimeForAgent';
              myHRLoggerInfoLog("[" + props.chatState.chatTokens.contactId + "]: Expected wait time for agent to join the chat is " + expectedWaitTimeInSeconds + " seconds. Chat ended by employee after " + employeeWaitTimeInSeconds + " seconds. CTI: " + JSON.stringify(props.chatState.cti) + "}", Object.assign({}, logsContext, {
                operationName: CHAT_ENDED_BEFORE_AGENT_JOINED_OPERATION_NAME
              }));
              recordCountMetric(PAGE_NAME, CHAT_ENDED_BEFORE_AGENT_JOINED_OPERATION_NAME, MetricEvents.COUNT);
            }

            var EMPLOYEE_ENDED_CHAT = 'ChatEndedByEmployee';
            myHRLoggerInfoLog("[" + props.chatState.chatTokens.contactId + "]: Employee ended the chat: " + JSON.stringify(props.chatState.cti) + "}", Object.assign({}, logsContext, {
              operationName: EMPLOYEE_ENDED_CHAT
            })); // Metric to record total chat ended by employee

            recordCountMetric(PAGE_NAME, EMPLOYEE_ENDED_CHAT, MetricEvents.COUNT);
          }
        });
      }, function (error) {
        myHRLoggerErrorLog("[" + getUserIdentifier() + "]: Error occurred in updateChatContact API while disconnecting chat session. " + getDetailedErrorMessage(error), logsContext);
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnClickOutside: true,
    isOpen: props.chatState.confirmExit,
    "aria-labelledby": "livechat-endchat-title",
    close: cancelDisconnect
  }, /*#__PURE__*/React.createElement(ModalContent, {
    titleText: "",
    maxWidth: null,
    closeButtonAltText: 'Close dialog',
    onCloseButtonClick: cancelDisconnect,
    buttons: [/*#__PURE__*/React.createElement(Button, {
      className: "end-chat-modal-button",
      isDestructive: true,
      key: "disconnectConfirm",
      variant: ButtonVariant.Primary,
      onClick: confirmDisconnect
    }, t('livehelp.end_chat'))]
  }, /*#__PURE__*/React.createElement(H2, {
    margin: {
      bottom: '20px'
    },
    style: {
      fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    },
    id: "livechat-endchat-title"
  }, t('livehelp.end_chat_modal_title')), props.chatState.idlenessReminder === IdlenessReminder.Warning && /*#__PURE__*/React.createElement(View$1, {
    margin: {
      bottom: 16
    }
  }, /*#__PURE__*/React.createElement(DisconnectBanner, {
    idlenessBannerTimeInMinutes: props.idlenessBannerTimeInMinutes,
    chatState: props.chatState,
    setChatState: props.setChatState
  })), /*#__PURE__*/React.createElement(Text$1, {
    className: 'endchat-text',
    fontSize: 16
  }, t('livehelp.end_chat_modal_text'))));
};

var css_248z$e = "#fileUpload-footer>div,#fileUpload-label,.file-upload-button,.file-upload-cancel-button,.file-upload-successful-close-button{font-size:14px!important}";
styleInject(css_248z$e);

var FileUploadModal = function FileUploadModal(props) {
  var PAGE_NAME = 'LiveHelpChat';
  var userIdentifier = getUserIdentifier();
  var OPERATION_NAME = 'FileUpload';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(undefined),
      fileData = _useState[0],
      setFileData = _useState[1];

  var _useState2 = useState(true),
      isFileButtonDisabled = _useState2[0],
      setIsFileUploadButtonDisabled = _useState2[1];

  var _useState3 = useState(false),
      showFileSizeErrorBanner = _useState3[0],
      setShowFileSizeErrorBanner = _useState3[1];

  var supportedFileTypes = ['.pdf,', '.jpg,', '.jpeg,', '.png,', '.doc,', '.docx,', '.xls,', '.csv,', '.wav,', '.pptx,', '.ppt,', '.txt'];

  var loadAttachment = function loadAttachment() {
    try {
      props.setFileReadyToUpload({
        fileData: fileData,
        uploadStatus: AttachmentUploadStatus.Ready
      });
      close();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleFileInputChange = function handleFileInputChange(e) {
    setShowFileSizeErrorBanner(false);

    try {
      var file = e.target.files[0];
      var fileSizeCheck = file.size / (1024 * 1024) > 20;
      setFileData(file); //Disable upload if nothing is selected or file selected is of size greater than 20 mb

      setIsFileUploadButtonDisabled(typeof file !== 'object' || fileSizeCheck);
      setShowFileSizeErrorBanner(fileSizeCheck);
    } catch (error) {
      myHRLoggerErrorLog("[" + userIdentifier + "]: Error occured in LiveHelpChat while File upload. " + getDetailedErrorMessage(error), logsContext);
      recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(e));
      console.log(e);
    }
  };

  var close = function close() {
    // reset everything related to upload popup
    props.setShouldStartIdlenessTimer(false);
    setIsFileUploadButtonDisabled(true);
    setFileData(undefined);
    props.setShowFileUploadModal(false);
  };

  var handleOnDismiss = function handleOnDismiss() {
    setShowFileSizeErrorBanner(false);
  };

  var getUploadForm = function getUploadForm() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputWrapper, {
      labelText: t('livehelp.select_a_file'),
      id: "fileUpload",
      footer: t('livehelp.supported_file_attachments')
    }, function () {
      return /*#__PURE__*/React.createElement("input", {
        type: "file",
        id: "fileUpload",
        name: "fileUpload",
        onChange: handleFileInputChange,
        className: 'file-upload',
        "aria-describedby": "fileUpload-footer",
        accept: supportedFileTypes.join(' ')
      });
    }), showFileSizeErrorBanner && /*#__PURE__*/React.createElement(View$1, {
      width: '100%',
      margin: {
        top: '8px'
      }
    }, /*#__PURE__*/React.createElement(MessageBanner, {
      type: MessageBannerType.Error,
      isDismissible: true,
      onDismissed: handleOnDismiss
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: 14,
      color: "#232F3E"
    }, t('livehelp.file_size_limit')))), /*#__PURE__*/React.createElement(Row, {
      gridGap: 16,
      padding: 8,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Spacer, {
      flex: 1
    }), /*#__PURE__*/React.createElement(Button, {
      className: "file-upload-button",
      variant: ButtonVariant.Primary,
      onClick: loadAttachment,
      disabled: isFileButtonDisabled
    }, t('livehelp.upload')), /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Tertiary,
      className: "file-upload-cancel-button",
      onClick: close
    }, t('livehelp.cancel'))));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: props.showFileUploadModal,
    close: close,
    "aria-labelledby": "attachment-dialog-header"
  }, /*#__PURE__*/React.createElement(Col, {
    backgroundColor: "neutral0",
    gridGap: "S500",
    padding: "S500",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(H2, {
    id: "attachment-dialog-header"
  }, t('livehelp.upload_attachment')), /*#__PURE__*/React.createElement(View$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "aria-live": "assertive"
  }, getUploadForm())));
};

var CRC = {
	BusinessLine: "CRC",
	Survey: {
		Questions: [
			{
				AnswerType: "Rating",
				Id: "Question1",
				Question: "The Amazon COVID Resource Center provided me with the necessary information and resources.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "I am satisfied with the support I received today.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question3",
				Question: "Is there anything else you’d like to say about your experience with the Amazon COVID Resource Center?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-a088f4fe-9f65-40be-b0b1-6df7cfeab633",
		beta: "translation-a088f4fe-9f65-40be-b0b1-6df7cfeab633",
		prod: "translation-a088f4fe-9f65-40be-b0b1-6df7cfeab633"
	}
};
var DLS = {
	BusinessLine: "DLS",
	Survey: {
		Questions: [
			{
				AnswerType: "Radio",
				Id: "Question1",
				Question: "My issue was resolved today.",
				Answers: [
					{
						value: "1",
						text: "Agree"
					},
					{
						value: "2",
						text: "Disagree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "Overall, my experience with Disability and Leave Services today was frustration-free.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question3",
				Question: "Is there anything else you would like to tell us about your experience with Disability and Leave Services team?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-0bff17e4-5ad7-45b4-95b2-c88d2549487b",
		beta: "translation-0bff17e4-5ad7-45b4-95b2-c88d2549487b",
		prod: "translation-0bff17e4-5ad7-45b4-95b2-c88d2549487b"
	}
};
var ERC = {
	BusinessLine: "ERC",
	Survey: {
		Questions: [
			{
				AnswerType: "Radio",
				Id: "Question1",
				Question: "The ERC resolved my issue today",
				Tag: "user-satisfaction",
				Answers: [
					{
						value: "1",
						text: "Agree"
					},
					{
						value: "2",
						text: "Disagree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "Overall, my experience with the ERC today was frustration-free.",
				Tag: "user-satisfaction",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Radio",
				Id: "Question3",
				Question: "Were you redirected between Site & Central teams?",
				Tag: "site-hr-central-redirect",
				Answers: [
					{
						value: "1",
						text: "Yes"
					},
					{
						value: "2",
						text: "No"
					}
				]
			},
			{
				AnswerType: "Radio",
				Id: "Question4",
				Question: "We understand your request was not served well. Do you want to get connected to priority support?",
				Tag: "priority-support",
				Answers: [
					{
						value: "1",
						text: "Yes"
					},
					{
						value: "2",
						text: "No"
					}
				]
			},
			{
				AnswerType: "Multiple-Rating",
				Id: "Question5",
				Question: "Rate our representative (5 stars being the highest score)",
				Tag: "agent-rating",
				SubQuestions: [
					{
						AnswerType: "Rating",
						Id: "Subquestion1",
						SubQuestion: "Friendly",
						Answers: [
							{
								value: "1",
								text: "Strongly Disagree"
							},
							{
								value: "2",
								text: "Disagree"
							},
							{
								value: "3",
								text: "Neutral"
							},
							{
								value: "4",
								text: "Agree"
							},
							{
								value: "5",
								text: "Strongly Agree"
							}
						]
					},
					{
						AnswerType: "Rating",
						Id: "Subquestion2",
						SubQuestion: "Attentive",
						Answers: [
							{
								value: "1",
								text: "Strongly Disagree"
							},
							{
								value: "2",
								text: "Disagree"
							},
							{
								value: "3",
								text: "Neutral"
							},
							{
								value: "4",
								text: "Agree"
							},
							{
								value: "5",
								text: "Strongly Agree"
							}
						]
					},
					{
						AnswerType: "Rating",
						Id: "Subquestion3",
						SubQuestion: "Knowledgeable",
						Answers: [
							{
								value: "1",
								text: "Strongly Disagree"
							},
							{
								value: "2",
								text: "Disagree"
							},
							{
								value: "3",
								text: "Neutral"
							},
							{
								value: "4",
								text: "Agree"
							},
							{
								value: "5",
								text: "Strongly Agree"
							}
						]
					},
					{
						AnswerType: "Rating",
						Id: "Subquestion4",
						SubQuestion: "Overall Service",
						Answers: [
							{
								value: "1",
								text: "Strongly Disagree"
							},
							{
								value: "2",
								text: "Disagree"
							},
							{
								value: "3",
								text: "Neutral"
							},
							{
								value: "4",
								text: "Agree"
							},
							{
								value: "5",
								text: "Strongly Agree"
							}
						]
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question6",
				Question: "Is there anything else you’d like to say about your experience with the ERC?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-2e32442b-603d-4ddf-b56e-c3edfe5f59a8",
		beta: "translation-2e32442b-603d-4ddf-b56e-c3edfe5f59a8",
		prod: "translation-2e32442b-603d-4ddf-b56e-c3edfe5f59a8"
	}
};
var CTK = {
	BusinessLine: "CTK",
	Survey: {
		Questions: [
			{
				AnswerType: "Radio",
				Id: "Question1",
				Question: "The Time Keepers resolved my issue today",
				Answers: [
					{
						value: "1",
						text: "Agree"
					},
					{
						value: "2",
						text: "Disagree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "Overall, my experience with the Time Keepers today was frustration-free.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question3",
				Question: "Is there anything else you’d like to say about your experience with the Time Keepers?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-bfcdd9d5-60c2-4e4e-b07c-68bab29dceeb",
		beta: "translation-bfcdd9d5-60c2-4e4e-b07c-68bab29dceeb",
		prod: "translation-bfcdd9d5-60c2-4e4e-b07c-68bab29dceeb"
	}
};
var TAT = {
	BusinessLine: "TAT",
	Survey: {
		Questions: [
			{
				AnswerType: "Radio",
				Id: "Question1",
				Question: "My issue was resolved today.",
				Answers: [
					{
						value: "1",
						text: "Agree"
					},
					{
						value: "2",
						text: "Disagree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "Overall, my experience with the Transfer Ambassador today was frustration-free.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question3",
				Question: "Is there anything else you would like to tell us about your experience with the Transfers Ambassdor ?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-83d8a451-6359-3c48-837d-2a294f493952",
		beta: "translation-83d8a451-6359-3c48-837d-2a294f493952",
		prod: "translation-83d8a451-6359-3c48-837d-2a294f493952"
	}
};
var SurveyConfig = {
	CRC: CRC,
	DLS: DLS,
	ERC: ERC,
	CTK: CTK,
	"PXT-OC": {
	BusinessLine: "PXT-OC",
	Survey: {
		Questions: [
			{
				AnswerType: "Radio",
				Id: "Question1",
				Question: "The HR Operations Center resolved my issue today",
				Answers: [
					{
						value: "1",
						text: "Agree"
					},
					{
						value: "2",
						text: "Disagree"
					}
				]
			},
			{
				AnswerType: "Rating",
				Id: "Question2",
				Question: "Overall, my experience with the HR Operations Center today was frustration-free.",
				Answers: [
					{
						value: "1",
						text: "Strongly Disagree"
					},
					{
						value: "2",
						text: "Disagree"
					},
					{
						value: "3",
						text: "Neutral"
					},
					{
						value: "4",
						text: "Agree"
					},
					{
						value: "5",
						text: "Strongly Agree"
					}
				]
			},
			{
				AnswerType: "Textarea",
				Id: "Question3",
				Question: " Is there anything else you’d like to say about your experience with the HR Operations Center?",
				Answers: [
				]
			}
		]
	},
	translationId: {
		test: "translation-fc2a8456-f41e-4a75-8abf-a3d902199e6f",
		beta: "translation-fc2a8456-f41e-4a75-8abf-a3d902199e6f",
		prod: "translation-fc2a8456-f41e-4a75-8abf-a3d902199e6f"
	}
},
	TAT: TAT
};

var css_248z$f = ".survey-button,.survey-text-area,.survey-text-area+div>div>div{font-size:16px!important}.survey-button{margin-right:5px}.survey-text-area+div>div{align-items:center!important}.survey-rating-button:active,.survey-rating-button:focus,.survey-rating-button:hover{border-color:#ffd033!important}.survey-footer{float:right;padding-top:10px}.survey-legend{border-bottom:0!important}#textarea,#textarea-label{font-size:16px!important}#textarea-footer>div{font-size:12px!important}.survey-header-close-button:active,.survey-header-close-button:focus,.survey-header-close-button:hover{border-color:#56616c!important}.subquestion{border:none;width:50%}.subquestion-rating{width:50%}.subquestion-field{margin-bottom:15px}";
styleInject(css_248z$f);

var SurveyButtonStatus;

(function (SurveyButtonStatus) {
  SurveyButtonStatus["DISABLED"] = "disabled";
  SurveyButtonStatus["TOGGLABLE"] = "togglable";
  SurveyButtonStatus["ENABLED"] = "enabled";
})(SurveyButtonStatus || (SurveyButtonStatus = {}));

var SurveyModal = function SurveyModal(_ref) {
  var _SurveyConfig$busines, _SurveyConfig$busines2, _SurveyConfig$busines3;

  var showLiveChatSurvey = _ref.showLiveChatSurvey,
      setShowLiveChatSurvey = _ref.setShowLiveChatSurvey,
      businessLine = _ref.businessLine,
      region = _ref.region,
      instanceId = _ref.instanceId,
      initialContactId = _ref.initialContactId,
      chatCloseButtonRef = _ref.chatCloseButtonRef,
      translatedSurveyData = _ref.translatedSurveyData,
      isChatVisible = _ref.isChatVisible,
      connectAWSAccount = _ref.connectAWSAccount,
      queueId = _ref.queueId,
      contactFlowId = _ref.contactFlowId,
      employeeAttributes = _ref.employeeAttributes,
      isPriorityChannelAvailable = _ref.isPriorityChannelAvailable;
  var PAGE_NAME = 'LiveHelpSurvey';

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var setValuesUtil = function setValuesUtil(question) {
    if (Array.isArray(question.SubQuestions)) {
      return new Array(question.SubQuestions.length).fill('');
    }

    return '';
  };

  var _useState = useState((_SurveyConfig$busines = SurveyConfig[businessLine]) === null || _SurveyConfig$busines === void 0 ? void 0 : (_SurveyConfig$busines2 = _SurveyConfig$busines.Survey) === null || _SurveyConfig$busines2 === void 0 ? void 0 : (_SurveyConfig$busines3 = _SurveyConfig$busines2.Questions) === null || _SurveyConfig$busines3 === void 0 ? void 0 : _SurveyConfig$busines3.map(setValuesUtil)),
      values = _useState[0],
      setValues = _useState[1];

  var _useState2 = useState(SurveyButtonStatus.DISABLED),
      surveyButtonStatus = _useState2[0],
      setSurveyButtonStatus = _useState2[1];

  var _useState3 = useState(false),
      showErrorBanner = _useState3[0],
      setShowErrorBanner = _useState3[1];

  var _useState4 = useState(t('livehelp.generic_error_message')),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var userIdentifier = getUserIdentifier();
  var hoopOpen = isPriorityQueueOpen();
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: 'LiveChatHMDSurvey',
    chatMetaData: {
      queueId: queueId,
      contactFlowId: contactFlowId
    }
  };

  var _useState5 = useState(''),
      verbatimTranscription = _useState5[0],
      setVerbatimTranscription = _useState5[1];

  var _useState6 = useState(false),
      userNotSatisfied = _useState6[0],
      setUserNotSatisfied = _useState6[1];

  var _useState7 = useState(false),
      promptForPrioritySupport = _useState7[0],
      setPromptForPrioritySupport = _useState7[1];

  var _useState8 = useState(false),
      connectToPrioritySupport = _useState8[0],
      setConnectToPrioritySupport = _useState8[1];

  var questionsToCheck = useRef(new Map());

  var myHRHMDStarBasedRatingSurveyFlag = function myHRHMDStarBasedRatingSurveyFlag() {
    return getPopstarFeatures().includes('my_hr_hmd_survey');
  };

  useEffect(function () {
    var atozHeader = document.getElementById('employeenav');
    var defaultZIndexAtoZ = atozHeader === null || atozHeader === void 0 ? void 0 : atozHeader.style.zIndex;

    if (atozHeader) {
      atozHeader.style.zIndex = '750';
    }

    return function () {
      if (atozHeader) {
        atozHeader.style.zIndex = defaultZIndexAtoZ || '1000';
      }
    };
  }, []);
  useEffect(function () {
    var ratingLessThanThree = false;
    var issueNotResolved = false;

    for (var _iterator = _createForOfIteratorHelperLoose(questionsToCheck.current.entries()), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          questionType = _step$value[0],
          index = _step$value[1];

      if (questionType === 'Rating') {
        if (values[index] === '1' || values[index] === '2') {
          ratingLessThanThree = true;
        }
      } else if (questionType === 'Radio') {
        if (values[index] === '2') {
          issueNotResolved = true;
        }
      }
    }

    setUserNotSatisfied(ratingLessThanThree && issueNotResolved);
  }, [values]);
  useEffect(function () {
    if (connectToPrioritySupport) {
      close();
    }
  }, [connectToPrioritySupport]);
  useEffect(function () {
    if (!userNotSatisfied) {
      setPromptForPrioritySupport(false);
    }
  }, [userNotSatisfied]);

  var setFocusToCloseButton = function setFocusToCloseButton() {
    setTimeout(function () {
      if (chatCloseButtonRef.current) {
        chatCloseButtonRef.current.focus();
      }
    }, 100);
  };

  var close = function close() {
    var _SurveyConfig$busines4, _SurveyConfig$busines5, _SurveyConfig$busines6;

    myHRLoggerInfoLog("[" + initialContactId + "]: User closed the survey modal by clicking on cross button on header", logsContext);

    if (isChatVisible) {
      setFocusToCloseButton();
    }

    setValues((_SurveyConfig$busines4 = SurveyConfig[businessLine]) === null || _SurveyConfig$busines4 === void 0 ? void 0 : (_SurveyConfig$busines5 = _SurveyConfig$busines4.Survey) === null || _SurveyConfig$busines5 === void 0 ? void 0 : (_SurveyConfig$busines6 = _SurveyConfig$busines5.Questions) === null || _SurveyConfig$busines6 === void 0 ? void 0 : _SurveyConfig$busines6.map(setValuesUtil));
    setVerbatimTranscription('');
    var SEEN_REDIRECT_QUESTION = 'SeenSiteHrRedirectQuestion';
    var SEEN_PRIORITY_SUPPORT_OPTION = 'SeenPrioritySupportOption';
    var CHOOSE_TO_CONNECT_TO_PRIORITY_SUPPORT = 'ChooseToConnectToPrioritySupport';
    var DID_NOT_CHOOSE_PRIORITY_SUPPORT = 'DidNotChooseToConnectToPrioritySupport';

    if (userNotSatisfied && !showLiveChatSurvey.connectToPriorityQueue && employeeAttributes && isPriorityChannelAvailable && getSiteHRRedirectFlag()) {
      myHRLoggerInfoLog("[" + initialContactId + "]: User shown site HR redict question", logsContext);
      recordCountMetric(PAGE_NAME, SEEN_REDIRECT_QUESTION, MetricEvents.COUNT);
    }

    if (promptForPrioritySupport) {
      myHRLoggerInfoLog("[" + initialContactId + "]: User prompted to connect to priority support", logsContext);
      recordCountMetric(PAGE_NAME, SEEN_PRIORITY_SUPPORT_OPTION, MetricEvents.COUNT);
    }

    if (connectToPrioritySupport) {
      myHRLoggerInfoLog("[" + initialContactId + "]: User chose to connect to priority support", logsContext);
      recordCountMetric(PAGE_NAME, CHOOSE_TO_CONNECT_TO_PRIORITY_SUPPORT, MetricEvents.COUNT);
      setShowLiveChatSurvey({
        showSurvey: false,
        connectToPriorityQueue: true
      });
    } else {
      if (promptForPrioritySupport) {
        myHRLoggerInfoLog("[" + initialContactId + "]: User was prompted for priority support but did not connect to it", logsContext);
        recordCountMetric(PAGE_NAME, DID_NOT_CHOOSE_PRIORITY_SUPPORT, MetricEvents.COUNT);
      }

      setShowLiveChatSurvey({
        showSurvey: false,
        connectToPriorityQueue: false
      });
    }

    setConnectToPrioritySupport(false);
    setPromptForPrioritySupport(false);
    setSurveyButtonStatus(SurveyButtonStatus.DISABLED);
  }; //Renders an individual Radio button, and can also set a boolean state on selecting it


  var getRadioButton = function getRadioButton(answer, index, setState, valueToSet) {
    if (translatedSurveyData) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Radio, {
        name: "radio-group-" + index,
        onClick: function onClick() {
          var newValues = [].concat(values);
          newValues[index] = answer.value;
          setValues(newValues);
          setSurveyButtonStatus(SurveyButtonStatus.ENABLED);

          if (setState && valueToSet !== undefined && valueToSet !== null) {
            setState(valueToSet);
          }
        },
        id: "radio-group-" + index + "-" + answer.value
      }), /*#__PURE__*/React.createElement(Label, {
        htmlFor: "radio-group-" + index + "-" + answer.value,
        margin: {
          left: '8px',
          right: '8px'
        },
        fontSize: 16
      }, translatedSurveyData.Survey.Questions[index].Answers[parseInt(answer.value) - 1].text));
    }
  }; //Render the question, along with all its options. There's also optional parameter shouldRender, which enables conditional rendering of question.


  var getRadioButtons = function getRadioButtons(index, setState, shouldRender, allowedToModifyState) {
    if (shouldRender === void 0) {
      shouldRender = true;
    }

    if (allowedToModifyState === void 0) {
      allowedToModifyState = true;
    }

    return shouldRender && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      className: "survey-legend"
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: 16
    }, translatedSurveyData.Survey.Questions[index].Question)), /*#__PURE__*/React.createElement(Row, null, SurveyConfig[businessLine].Survey.Questions[index].Answers.map(function (answer) {
      if (setState && allowedToModifyState) {
        var valueToSet = answer.text === 'Yes' ? true : false;
        return getRadioButton(answer, index, setState, valueToSet);
      } else {
        return getRadioButton(answer, index);
      }
    }))));
  };

  var getStarRatingButton = function getStarRatingButton(answer, index) {
    if (translatedSurveyData) {
      var starValue = values[index];

      var handleOnClick = function handleOnClick() {
        var newValues = [].concat(values);
        newValues[index] = answer.value;
        setValues(newValues);
        setSurveyButtonStatus(SurveyButtonStatus.ENABLED);
      };

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RatingsButton, {
        name: "radio-group-" + index,
        handleOnClick: handleOnClick,
        labelText: translatedSurveyData.Survey.Questions[index].Answers[parseInt(answer.value) - 1].text,
        id: "radio-group-" + index + "-" + answer.value,
        filled: answer.value <= starValue
      }));
    }
  };

  var getStarRatings = function getStarRatings(index) {
    if (translatedSurveyData) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
        className: "survey-legend"
      }, /*#__PURE__*/React.createElement(Text$1, {
        fontSize: 16
      }, translatedSurveyData.Survey.Questions[index].Question)), /*#__PURE__*/React.createElement(Row, null, SurveyConfig[businessLine].Survey.Questions[index].Answers.map(function (answer) {
        return getStarRatingButton(answer, index);
      })), /*#__PURE__*/React.createElement(Text$1, {
        "aria-hidden": true,
        fontSize: 16
      }, values[index] === '' ? '' : translatedSurveyData.Survey.Questions[index].Answers[parseInt(values[index]) - 1].text)));
    }
  };

  var getSubStarRatingButton = function getSubStarRatingButton(answer, index, subindex) {
    if (translatedSurveyData) {
      var starValue = values[index][subindex];

      var handleOnClick = function handleOnClick() {
        var newValues = [].concat(values);
        newValues[index][subindex] = answer.value;
        setValues(newValues);
        setSurveyButtonStatus(SurveyButtonStatus.ENABLED);
      };

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RatingsButton, {
        name: "radio-group-" + index + "-" + subindex,
        handleOnClick: handleOnClick,
        labelText: translatedSurveyData.Survey.Questions[index].SubQuestions[subindex].Answers[parseInt(answer.value) - 1].text,
        id: "radio-group-" + index + "-" + subindex + "-" + answer.value,
        filled: answer.value <= starValue
      }));
    }
  };

  var getSubStarRatings = function getSubStarRatings(index, subIndex) {
    if (translatedSurveyData) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", {
        className: "subquestion-field"
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("legend", {
        className: "subquestion"
      }, /*#__PURE__*/React.createElement(Text$1, {
        fontSize: 16,
        textDecoration: "none"
      }, translatedSurveyData.Survey.Questions[index].SubQuestions[subIndex].SubQuestion)), /*#__PURE__*/React.createElement(Row, {
        className: "subquestion-rating"
      }, SurveyConfig[businessLine].Survey.Questions[index].SubQuestions[subIndex].Answers.map(function (answer) {
        return getSubStarRatingButton(answer, index, subIndex);
      }))), /*#__PURE__*/React.createElement(Text$1, {
        "aria-hidden": true,
        fontSize: 16
      }, values[index][subIndex] === '' ? '' : translatedSurveyData.Survey.Questions[index].SubQuestions[subIndex].Answers[parseInt(values[index][subIndex]) - 1].text)));
    }
  };

  var _useRecommendedLength = useRecommendedLength({
    value: verbatimTranscription,
    tokenType: TokenType.Words,
    recommendedLength: 1024
  }),
      footerText = _useRecommendedLength.footerText,
      warning = _useRecommendedLength.warning,
      error = _useRecommendedLength.error,
      progress = _useRecommendedLength.progress;

  var getTextarea = function getTextarea(index) {
    if (translatedSurveyData) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputWrapper, {
        labelText: translatedSurveyData.Survey.Questions[index].Question,
        id: 'textarea',
        warning: warning,
        error: error,
        footer: function footer(footerProps) {
          return /*#__PURE__*/React.createElement(RecommendedLengthFooter, Object.assign({
            progress: progress
          }, footerProps), footerText);
        }
      }, function (inputProps) {
        return /*#__PURE__*/React.createElement(TextArea, Object.assign({}, inputProps, {
          value: verbatimTranscription,
          onChange: function onChange(e) {
            var newValues = [].concat(values);
            newValues[index] = e.target.value;

            if (surveyButtonStatus !== SurveyButtonStatus.ENABLED) {
              e.target.value.length > 0 ? setSurveyButtonStatus(SurveyButtonStatus.TOGGLABLE) : setSurveyButtonStatus(SurveyButtonStatus.DISABLED);
            }

            setValues(newValues);
            setVerbatimTranscription(e.target.value);
          }
        }));
      }));
    }
  };

  var processSurveySubQuestion = function processSurveySubQuestion(index) {
    var question = translatedSurveyData.Survey.Questions[index].Question;
    var subQuestion = translatedSurveyData.Survey.Questions[index].SubQuestions.map(function (_question, subindex) {
      return getSubStarRatings(index, subindex);
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: 16,
      margin: {
        bottom: '20px'
      }
    }, question), subQuestion));
  }; //Returns react component based on question configuration - Radio, Rating, and text


  var processSurveyQuestion = function processSurveyQuestion(question, index) {
    if (question.AnswerType === 'Radio') {
      if ((question === null || question === void 0 ? void 0 : question.Tag) === 'site-hr-central-redirect') {
        return getRadioButtons(index, setPromptForPrioritySupport, userNotSatisfied && !showLiveChatSurvey.connectToPriorityQueue && employeeAttributes && isPriorityChannelAvailable && getSiteHRRedirectFlag(), hoopOpen);
      } else if ((question === null || question === void 0 ? void 0 : question.Tag) === 'priority-support') {
        return getRadioButtons(index, setConnectToPrioritySupport, promptForPrioritySupport && !showLiveChatSurvey.connectToPriorityQueue && employeeAttributes && isPriorityChannelAvailable && getSiteHRRedirectFlag());
      } else if ((question === null || question === void 0 ? void 0 : question.Tag) === 'user-satisfaction') {
        questionsToCheck.current.set('Radio', index);
      }

      return getRadioButtons(index);
    } else if (question.AnswerType === 'Rating') {
      if ((question === null || question === void 0 ? void 0 : question.Tag) === 'user-satisfaction') {
        questionsToCheck.current.set('Rating', index);
      }

      return getStarRatings(index);
    } else if (myHRHMDStarBasedRatingSurveyFlag() && question.AnswerType === 'Multiple-Rating') {
      return processSurveySubQuestion(index);
    } else if (question.AnswerType === 'Textarea') {
      return getTextarea(index);
    }
  }; //Iteratively processes and renders all survey questions


  var processSurveyQuestions = function processSurveyQuestions() {
    return SurveyConfig[businessLine].Survey.Questions.map(function (question, index) {
      return processSurveyQuestion(question, index);
    });
  };

  var getSurveyContent = function getSurveyContent() {
    if (translatedSurveyData) {
      var surveyMessage = translatedSurveyData.Survey.SurveyMessage;
      var questions = processSurveyQuestions();
      return /*#__PURE__*/React.createElement(React.Fragment, null, SurveyConfig[businessLine].BusinessLine !== 'ERC' && /*#__PURE__*/React.createElement(Text$1, {
        fontSize: 16
      }, surveyMessage), questions);
    }
  };

  var handleSubmit = function handleSubmit() {
    try {
      myHRLoggerInfoLog("[" + initialContactId + "]: User clicked on submit survey button", logsContext);
      var OPERATION_NAME = 'UpdateChatContactAttributes';
      setShowErrorBanner(false);
      var attributes = {};
      var questionsArray = SurveyConfig[businessLine].Survey.Questions;

      var subQuestionAttributes = function subQuestionAttributes(index) {
        var subQuestionsArray = SurveyConfig[businessLine].Survey.Questions[index].SubQuestions;

        for (var subindex = 0; subindex < subQuestionsArray.length; subindex++) {
          if (!values[index][subindex]) {
            continue;
          }

          var subquestion = subQuestionsArray[subindex];
          attributes["VOC_Question" + (index + 1) + "_Subquestion" + (subindex + 1) + "Answered"] = subquestion.Answers[parseInt(values[index][subindex]) - 1].text;
          attributes["VOC_Question" + (index + 1) + "_Subquestion" + (subindex + 1) + "Asked"] = SurveyConfig[businessLine].Survey.Questions[index].Question + '-' + subquestion.SubQuestion;
        }
      };

      for (var index = 0; index < questionsArray.length; index++) {
        var question = questionsArray[index];

        if (question.AnswerType === 'Multiple-Rating') {
          subQuestionAttributes(index);
          continue;
        }

        if (!values[index]) {
          continue;
        }

        if (question.AnswerType === 'Textarea') {
          attributes['VOC_VerbatimTranscription'] = verbatimTranscription;
        } else {
          attributes["VOC_Question" + (index + 1) + "Answered"] = question.Answers[parseInt(values[index]) - 1].text;
          attributes["VOC_Question" + (index + 1) + "Asked"] = question.Question;
        }
      }

      setSurveyButtonStatus(SurveyButtonStatus.DISABLED);

      try {
        updateChatContactAttributes(region, instanceId, initialContactId, attributes, PAGE_NAME, connectAWSAccount);
        close();
      } catch (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while submitting LiveHelp chat survey. " + getDetailedErrorMessage(error), logsContext);
        setSurveyButtonStatus(SurveyButtonStatus.ENABLED);
        setErrorMessage(t('livehelp.generic_error_message'));
        setShowErrorBanner(true);
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var CustomErrorBanner = function CustomErrorBanner(_ref2) {
    var errorText = _ref2.errorText;
    return /*#__PURE__*/React.createElement(View$1, {
      width: '100%'
    }, /*#__PURE__*/React.createElement(MessageBanner, {
      type: MessageBannerType.Error,
      isDismissible: false
    }, /*#__PURE__*/React.createElement(Text$1, {
      fontSize: 14,
      color: "#232F3E"
    }, errorText)));
  };

  var SurveyFooter = function SurveyFooter() {
    return /*#__PURE__*/React.createElement(Row, {
      className: "survey-footer"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "survey-button",
      variant: ButtonVariant.Primary,
      onClick: handleSubmit,
      disabled: surveyButtonStatus === SurveyButtonStatus.DISABLED
    }, t('livehelp.send_survey')), /*#__PURE__*/React.createElement(Button, {
      className: "survey-button",
      variant: ButtonVariant.Tertiary,
      onClick: function onClick() {
        close();
        myHRLoggerInfoLog("[" + initialContactId + "]: User closed the survey modal by clicking on cancel button in footer", logsContext);
      }
    }, t('livehelp.cancel')));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, translatedSurveyData ? /*#__PURE__*/React.createElement(Modal, {
    isOpen: showLiveChatSurvey.showSurvey,
    close: close,
    "aria-labelledby": "livechat-hmd-title"
  }, /*#__PURE__*/React.createElement(ModalContent, {
    titleText: ""
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "space-between",
    className: "survey-header"
  }, SurveyConfig[businessLine].BusinessLine === 'ERC' ? /*#__PURE__*/React.createElement(Text$1, {
    margin: {
      bottom: '12px',
      top: '25px'
    },
    fontSize: 16
  }, translatedSurveyData.Survey.SurveyMessage) : /*#__PURE__*/React.createElement(H2, {
    margin: {
      bottom: '20px'
    },
    style: {
      fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    },
    id: "livechat-hmd-title"
  }, translatedSurveyData.Survey.SurveyName), /*#__PURE__*/React.createElement(Button, {
    className: "survey-header-close-button",
    onClick: close,
    variant: ButtonVariant.Tertiary,
    icon: /*#__PURE__*/React.createElement(IconCross, {
      color: "rgb(86, 97, 108)",
      title: "Close dialog"
    })
  })), /*#__PURE__*/React.createElement(FormWrapper, {
    rowGap: 16
  }, getSurveyContent(), showErrorBanner && /*#__PURE__*/React.createElement(CustomErrorBanner, {
    errorText: errorMessage
  })), /*#__PURE__*/React.createElement(SurveyFooter, null)))) : /*#__PURE__*/React.createElement(React.Fragment, null));
};

var css_248z$g = ".chat-container-right{right:0}.chat-container-left,.chat-container-right{background:#fff;border:1px solid #000;bottom:0;overflow:scroll!important;position:fixed!important;z-index:2}.chat-container-left{left:0}.chat-container-mobile{background:#fff;border:1px solid #000;bottom:0;height:100%!important;overflow:scroll!important;right:0;width:100vw!important;z-index:2}.header-minimized-container-right{right:0}.header-minimized-container-left,.header-minimized-container-right{background:#1768c9!important;border:1px solid #000;bottom:0;padding-left:32px;position:fixed;width:30vw;z-index:2}.header-minimized-container-left{left:0}.header-minimized-container-mobile{background:#1768c9!important;border:1px solid #000;padding-left:32px;position:-webkit-sticky;position:sticky;top:0;width:100vw;z-index:2}#stencil-modal-title{font-size:22px!important}.maximize-btn:active,.maximize-btn:focus,.maximize-btn:hover{border-color:#fff!important}.select-container{margin-bottom:10px!important;padding-left:32px!important;padding-right:32px!important;width:100%!important}.select-label{font-size:13px!important;font-weight:700!important;margin-top:15px}.select-container>div>div>div>div>div>input{font-size:16px!important}";
styleInject(css_248z$g);

var NetworkConnectionStatus;

(function (NetworkConnectionStatus) {
  NetworkConnectionStatus["ONLINE"] = "online";
  NetworkConnectionStatus["OFFLINE"] = "offline";
})(NetworkConnectionStatus || (NetworkConnectionStatus = {}));

function useNetworkAwareness() {
  var _useState = useState(NetworkConnectionStatus.ONLINE),
      isOnline = _useState[0],
      setIsOnline = _useState[1];

  useEffect(function () {
    var handleOnline = function handleOnline() {
      setIsOnline(NetworkConnectionStatus.ONLINE);
    };

    var handleOffline = function handleOffline() {
      setIsOnline(NetworkConnectionStatus.OFFLINE);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return function () {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  return isOnline;
}

var defaultState = {
  isChatHistoryVisible: false,
  isChatHistoryMinimised: false,
  setIsChatHistoryVisible: function setIsChatHistoryVisible() {
    return null;
  },
  setIsChatHistoryMinimised: function setIsChatHistoryMinimised() {
    return null;
  }
};
var ChatHistoryContext = /*#__PURE__*/createContext(defaultState);
var useChatHistoryContext = function useChatHistoryContext() {
  return useContext(ChatHistoryContext);
};

var ERC$1 = {
	"en-US": {
		test: {
			contactFlowId: "393bf1b6-d75f-41e7-93fc-22f54b94125a",
			instanceId: "9a5e3395-4eba-4243-8f17-29e4e31915b9",
			queueId: "e91fe9ad-1faa-4ed6-a1ed-712a481230ea",
			region: "us-east-1",
			connectAWSAccount: "152353010928"
		},
		beta: {
			contactFlowId: "6e787670-3cab-4060-bd60-4530947d4f88",
			instanceId: "2b67a692-d7ea-44a6-bd1e-9501245ce170",
			queueId: "b81086ef-0c81-4486-bac4-7981d7a6152f",
			region: "us-east-1",
			connectAWSAccount: "152353010928"
		},
		prod: {
			contactFlowId: "4dace697-f731-49cd-ad97-3df6822d88b6",
			instanceId: "60c36f41-899a-4475-a01a-4db2172f2721",
			queueId: "54a9357f-65d0-452c-8bb1-21d29e904059",
			region: "us-east-1",
			connectAWSAccount: "152353010928"
		}
	}
};
var PriorityQueueConfig = {
	ERC: ERC$1
};

var _templateObject;
var LiveHelpInlineCloseBtn = /*#__PURE__*/styledWithTheme(Button)(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: 400;\n  position: absolute;\n  right: 0 !important;\n  top:0 !important;\n  height: 30px;\n  margin-top: 5px;\n  border: none;\n  color: #ffffff !important;\n"])));
var ChatContainer = function ChatContainer() {
  var _PriorityQueueConfig$, _PriorityQueueConfig$2, _chatState$chatTokens9;

  var _useChatContext = useChatContext(),
      chatState = _useChatContext.chatState,
      chatSession = _useChatContext.chatSession,
      setChatState = _useChatContext.setChatState,
      setChatSession = _useChatContext.setChatSession;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var isMobile = matches === null || matches === void 0 ? void 0 : matches.s;
  var liveHelpInlineContext = useLiveHelpInlineContext();

  var _useChatHistoryContex = useChatHistoryContext(),
      isChatHistoryVisible = _useChatHistoryContex.isChatHistoryVisible,
      isChatHistoryMinimised = _useChatHistoryContex.isChatHistoryMinimised;

  var currentPagePathname = window.location.pathname;
  var NewMessageNotificationRef = useRef(new Audio(cloudFrontURI + 'chat_message_received.mp3'));
  var IdlenessWarningNotificationRef = useRef(new Audio(cloudFrontURI + 'chat_idle_warning.mp3'));
  var DisconnectionWarningNotificationRef = useRef(new Audio(cloudFrontURI + 'chat_session_end.mp3')); // Reducing conditional line length

  var liveHelpInlineActiveChannel = liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.activeChannel;
  var isLiveHelpInlineChatActive = liveHelpInlineActiveChannel === LiveHelpChannel.CHAT || chatState.isLiveHelpInlineSource;
  /**
   * @constant isNotInlineViewFromDesktop
   * This is checking whether the person has availed inline widget in Desktop Mode
   */

  var isNotInlineViewFromDesktop = !isLiveHelpInlineChatActive || isMobile;

  var _useState = useState(i18.getInstance),
      i18Instance = _useState[0];

  var PAGE_NAME = 'ChatContainer';
  var userIdentifier = getUserIdentifier();
  var messageRenderHelper = new MessageRenderHelper();
  var agentTypingTimer;

  var _useTranslation = useTranslation(undefined, {
    i18n: i18Instance
  }),
      t = _useTranslation.t;

  var _useState2 = useState(false),
      shouldStartIdlenessTimer = _useState2[0],
      setShouldStartIdlenessTimer = _useState2[1];

  var _useState3 = useState({
    width: isLiveHelpInlineChatActive ? INLINE_FLYOUT_WIDTH_PX : convertVwToPx(MIN_CONTAINER_WIDTH_BROWSER),
    height: convertVhToPx(MIN_CONTAINER_HEIGHT_BROWSER)
  }),
      chatContainerSize = _useState3[0],
      setChatContainerSize = _useState3[1];

  var chatStateRef = useRef(chatState);

  var _useState4 = useState(false),
      setDisableCloseButton = _useState4[1];

  chatStateRef.current = chatState;
  var networkConnectionStatus = useNetworkAwareness();
  var languageDirection = document.documentElement.dir; //file upload modal

  var _useState5 = useState(false),
      setConfirmExit = _useState5[1];

  var _useState6 = useState(false),
      showFileUploadModal = _useState6[0],
      setShowFileUploadModal = _useState6[1];

  var showFileUploadModalRef = useRef(showFileUploadModal);
  showFileUploadModalRef.current = showFileUploadModal; //HMD Survey

  var stage = 'prod';

  var _useState7 = useState(undefined),
      translatedSurveyData = _useState7[0],
      setTranslatedSurveyData = _useState7[1];

  var willSurveyBeShown = chatState.businessLine && SurveyConfig[chatState.businessLine];

  var _useState8 = useState(''),
      messageString = _useState8[0],
      setMessageString = _useState8[1];

  var _useState9 = useState({
    showSurvey: false,
    connectToPriorityQueue: false
  }),
      showLiveChatSurvey = _useState9[0],
      setShowLiveChatSurvey = _useState9[1];

  if (chatState.idlenessDisconnectTimeOutInMinutes == null) {
    chatState.idlenessDisconnectTimeOutInMinutes = DEFAULT_IDLENESS_DISCONNECT_TIME_OUT_IN_MINUTES;
  }

  var disconnectTimeoutInMilliSec = chatState.idlenessDisconnectTimeOutInMinutes * 60000;
  var warningTimeoutCountInMilliSec = disconnectTimeoutInMilliSec - defaultChatState.idlenessBannerTimeInMinutes * 60000;
  useEffect(function () {
    if (!showLiveChatSurvey.showSurvey && showLiveChatSurvey.connectToPriorityQueue) {
      setMessages([]);
      setChatState(Object.assign({}, chatState, {
        chatTokens: null,
        timeStampForChatClick: Date.now(),
        isDescribeIssue: true
      }));
      setChatSession(Object.assign({}, defaultChatSession, {
        connectionStatus: ChatSessionConnectionStatus.DescribeIssue
      }));
    }
  }, [showLiveChatSurvey]);

  var _useState10 = useState({
    fileData: null,
    uploadStatus: AttachmentUploadStatus.Inactive
  }),
      fileReadyToUpload = _useState10[0],
      setFileReadyToUpload = _useState10[1]; //States for Chat Notification Sounds


  var isPageVisible = usePageVisibility();

  var _useState11 = useState(0),
      unreadMessagesCount = _useState11[0],
      _setUnreadMessagesCount = _useState11[1];

  var unreadMessagesCountRef = useRef(unreadMessagesCount);

  var setUnreadMessagesCount = function setUnreadMessagesCount(count) {
    unreadMessagesCountRef.current = count;

    _setUnreadMessagesCount(count);
  };

  var _useState12 = useState(false),
      showErrorBanner = _useState12[0],
      setShowErrorBanner = _useState12[1];

  var _useState13 = useState(t('livehelp.generic_error_message')),
      errorMessage = _useState13[0];

  var plusButtonRef = useRef(null);
  var minusButtonRef = useRef(null);
  var priorityConfig = PriorityQueueConfig === null || PriorityQueueConfig === void 0 ? void 0 : (_PriorityQueueConfig$ = PriorityQueueConfig[chatState.businessLine]) === null || _PriorityQueueConfig$ === void 0 ? void 0 : (_PriorityQueueConfig$2 = _PriorityQueueConfig$[chatState.currentLanguage]) === null || _PriorityQueueConfig$2 === void 0 ? void 0 : _PriorityQueueConfig$2[stage];
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: PAGE_NAME,
    operationName: 'CHAT_OPERATIONS',
    chatMetaData: {
      queueId: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['queueId'] : chatState.queueId,
      contactFlowId: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['contactFlowId'] : chatState.contactFlowId
    }
  };
  var inputBoxRef = useRef(null);

  var focusMinus = function focusMinus() {
    setTimeout(function () {
      if (minusButtonRef.current) {
        minusButtonRef.current.focus();
      }
    }, 500);
  };

  var focusPlus = function focusPlus() {
    setTimeout(function () {
      if (plusButtonRef.current) {
        plusButtonRef.current.focus();
      }
    }, 100);
  };

  var setIsChatMinimized = function setIsChatMinimized(newIsChatMinimized) {
    var _chatState$chatTokens;

    setChatState({
      isChatMinimized: newIsChatMinimized
    });
    var operation = newIsChatMinimized ? 'minimised' : 'maximised';
    myHRLoggerInfoLog("[" + ((_chatState$chatTokens = chatState.chatTokens) === null || _chatState$chatTokens === void 0 ? void 0 : _chatState$chatTokens.initialContactId) + "]: User " + operation + " the chat window.", logsContext);
  };
  /**
   * @function onCloseLiveHelpChat
   * This function purely works for logic of handling the chat opened by usage of Inline experience
   * and it sought to set necessary states of chat header close button and respective chat state.
   */


  var onCloseLiveHelpChat = function onCloseLiveHelpChat() {
    if ((chatSession === null || chatSession === void 0 ? void 0 : chatSession.connectionStatus) === ChatSessionConnectionStatus.Ended) {
      onCloseChatWindow();
    } else {
      setChatState({
        confirmExit: true
      });
    }

    if (chatState.isLiveHelpInlineSource) setDisableCloseButton(true);
  };
  /**
   * @function onCloseChatWindow
   * This function purely works for logic of handling the chat opened from livehelp
   * page with minimiztion logic.
   */


  var onCloseChatWindow = function onCloseChatWindow() {
    setChatState(Object.assign({}, defaultChatState));
    setChatSession(Object.assign({}, defaultChatSession));
  };

  useEffect(function () {
    var header = document.getElementById('page-header');
    var footer = document.getElementById('page-footer');

    if (chatState.isChatMinimized) {
      header === null || header === void 0 ? void 0 : header.setAttribute('aria-hidden', 'true');
      footer === null || footer === void 0 ? void 0 : footer.setAttribute('aria-hidden', 'true');
    } else {
      header === null || header === void 0 ? void 0 : header.removeAttribute('aria-hidden');
      footer === null || footer === void 0 ? void 0 : footer.removeAttribute('aria-hidden');
    }
  }, [chatState.isChatMinimized]);
  useEffect(function () {
    var _getPreferredLanguage;

    i18Instance.changeLanguage((_getPreferredLanguage = getPreferredLanguage()) !== null && _getPreferredLanguage !== void 0 ? _getPreferredLanguage : LanguagesAvailable.en_US);
  }, [currentPagePathname]);
  useEffect(function () {
    var atozHeader = document.getElementById('employeenav');
    var defaultZIndexAtoZ = atozHeader === null || atozHeader === void 0 ? void 0 : atozHeader.style.zIndex;

    if (atozHeader) {
      atozHeader.style.zIndex = '750';
    } // logic for refresh case of inline service


    if (chatState.isLiveHelpInlineSource) {
      liveHelpInlineContext.setLiveHelpServiceState({
        activeChannel: LiveHelpChannel.CHAT
      });
    }

    return function () {
      if (atozHeader) {
        atozHeader.style.zIndex = defaultZIndexAtoZ || '1000';
      }
    };
  }, []);

  var MinimizedChatHeader = function MinimizedChatHeader() {
    return /*#__PURE__*/React.createElement(View$1, {
      className: matches.l || matches.xl ? languageDirection === 'rtl' ? 'header-minimized-container-left' : 'header-minimized-container-right' : 'header-minimized-container-mobile',
      style: languageDirection === 'rtl' ? {
        marginLeft: isChatHistoryVisible && !isChatHistoryMinimised ? '30.5%' : '0px'
      } : {
        marginRight: isChatHistoryVisible && !isChatHistoryMinimised ? '30.5%' : '0px'
      }
    }, /*#__PURE__*/React.createElement(Row, {
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(H2, {
      color: "#ffffff",
      fontSize: "16px !important",
      fontWeight: 500
    }, t('livehelp.live_chat')), /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Primary,
      onClick: function onClick() {
        setIsChatMinimized(false);
        focusMinus();
      },
      icon: /*#__PURE__*/React.createElement(IconPlus, {
        color: "white",
        title: t('livehelp.maximize_chat_history')
      }),
      className: "maximize-btn",
      ref: plusButtonRef
    })));
  }; // ref to focus on close chat button on Footer


  var chatCloseButtonRef = useRef();

  var _useState14 = useState([]),
      messages = _useState14[0],
      _setMessages = _useState14[1];

  var messagesRef = useRef(messages);

  var setMessages = function setMessages(data) {
    messagesRef.current = data;

    _setMessages(data);
  };

  var _useState15 = useState(new Set([])),
      receivedMessageIds = _useState15[0],
      _setReceivedMessageIds = _useState15[1];

  var receivedMessageIdsRef = useRef(receivedMessageIds);

  var addToReceivedMessageIds = function addToReceivedMessageIds(id) {
    var updatedIds = receivedMessageIdsRef.current.add(id);

    _setReceivedMessageIds(updatedIds);
  };

  var _useState16 = useState(false),
      isAgentTyping = _useState16[0],
      setIsAgentTyping = _useState16[1];

  var _useState17 = useState(undefined),
      chatConnectionToggled = _useState17[0],
      setChatConnectionToggled = _useState17[1];

  var _useState18 = useState(0),
      startTime = _useState18[0],
      setStartTime = _useState18[1];

  var _useState19 = useState(true),
      metricPublishedFirstTime = _useState19[0],
      setMetricPublishedFirstTime = _useState19[1];

  useEffect(function () {
    if (chatState.agentConnected) {
      var _chatState$chatTokens2;

      setChatConnectionToggled(true);
      myHRLoggerInfoLog("[" + ((_chatState$chatTokens2 = chatState.chatTokens) === null || _chatState$chatTokens2 === void 0 ? void 0 : _chatState$chatTokens2.initialContactId) + "]: Agent joined the chat session.", logsContext);
    } else {
      setChatState({
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener
      });
    }
  }, [chatState.agentConnected]);
  useEffect(function () {
    if (chatSession.connectionStatus === ChatSessionConnectionStatus.Ended) {
      setChatConnectionToggled(false);
    }

    if (metricPublishedFirstTime) {
      if (chatSession.connectionStatus === ChatSessionConnectionStatus.Attempting) setStartTime(Date.now());

      if (startTime !== 0 && chatSession.connectionStatus !== ChatSessionConnectionStatus.Attempting && chatSession.connectionStatus !== ChatSessionConnectionStatus.DescribeIssue) {
        if (isComponentInline()) {
          // used separate operationName as it can get merged with Contact page load metric
          recordLatencyMetric(getPageName(), CommonOperations.CHAT_CONTAINER_PAGE_LOAD, startTime);
        } else {
          recordLatencyMetric(PAGE_NAME, CommonOperations.PAGE_LOAD, startTime);
        }

        setMetricPublishedFirstTime(false);
      }
    }
  }, [chatSession.connectionStatus]);

  var closeInactiveChatConnection = function closeInactiveChatConnection(timerIdleWarning, timerIdleDisconnect) {
    var minutes = chatState.idlenessDisconnectTimeOutInMinutes;
    var message = t('livehelp.chat_idle_message', {
      minutes: minutes
    });
    var CLOSE_INACTIVE_CHAT_SESSION_OPERATION_NAME = 'CloseChatSessionOnIdleness';
    sendMessageFromParticipant(message, chatSession, setChatSession);
    messageRenderHelper.sendMessageFromSystem(t('livehelp.chat_ended'), messagesRef, setMessages);

    try {
      closeConnectionFromParticipantSide(chatSession, setChatSession, chatState, PAGE_NAME, chatState.connectAWSAccount, true);
      recordCountMetric(PAGE_NAME, CLOSE_INACTIVE_CHAT_SESSION_OPERATION_NAME, MetricEvents.COUNT);
    } catch (error) {
      myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred in updateChatContact API while disconnecting chat session due to inactivity. " + getDetailedErrorMessage(error), logsContext);
      recordErrorCountMetric(PAGE_NAME, CLOSE_INACTIVE_CHAT_SESSION_OPERATION_NAME, error);
    }

    clearInterval(timerIdleWarning);
    clearInterval(timerIdleDisconnect);
  };

  var clearTimer = function clearTimer(timerIdleWarning, timerIdleDisconnect) {
    clearInterval(timerIdleWarning);
    clearInterval(timerIdleDisconnect);
    setChatState({
      idlenessReminder: IdlenessReminder.NotActive
    });
  };

  var handleWarningTimeout = function handleWarningTimeout() {
    if (shouldStartIdlenessTimer) {
      setChatState({
        idlenessReminder: IdlenessReminder.Warning
      });
    }
  };

  var handleDisconnectTimeout = function handleDisconnectTimeout(timerIdleWarning, timerIdleDisconnect) {
    if (shouldStartIdlenessTimer) {
      setChatState({
        idlenessReminder: IdlenessReminder.Disconnect
      });
      closeInactiveChatConnection(timerIdleWarning, timerIdleDisconnect);
    }
  };

  useEffect(function () {
    var intervalId;
    var timeoutId; // For setting disconnect warning banner time

    if (chatState.idlenessReminder === IdlenessReminder.Warning) {
      setChatState({
        idlenessBannerTimeInMinutes: defaultChatState.idlenessBannerTimeInMinutes
      });
      intervalId = setInterval(function () {
        setChatState({
          idlenessBannerTimeInMinutes: chatState.idlenessBannerTimeInMinutes - 1
        });
      }, 60000);
      timeoutId = setTimeout(function () {
        clearInterval(intervalId);
      }, defaultChatState.idlenessBannerTimeInMinutes * 60000);
    }

    return function () {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [chatState.idlenessReminder]);
  useEffect(function () {
    var timerIdleWarning;
    var timerIdleDisconnect;

    if (chatState.timerState === TimerState.ResetTimer) {
      clearTimer(timerIdleWarning, timerIdleDisconnect);
      timerIdleWarning = setTimeout(handleWarningTimeout, warningTimeoutCountInMilliSec);
      timerIdleDisconnect = setTimeout(handleDisconnectTimeout, disconnectTimeoutInMilliSec);
    } else if (chatState.timerState === TimerState.NotActive) {
      clearTimer(timerIdleWarning, timerIdleDisconnect);
    }

    return function () {
      clearTimer(timerIdleWarning, timerIdleDisconnect);
    };
  }, [chatState.activateListener]);

  var uploadDescribeissueAttachmentToConnect = function uploadDescribeissueAttachmentToConnect() {
    try {
      var operationName = 'UploadAttachment';
      recordCountMetric(PAGE_NAME, operationName, MetricEvents.CLICKS_COUNT);
      var response;
      setFileReadyToUpload(Object.assign({}, fileReadyToUpload, {
        uploadStatus: AttachmentUploadStatus.Uploading
      }));

      var _temp2 = _catch(function () {
        return Promise.resolve(retryOperation(function () {
          return chatSession.chatSession.sendAttachment({
            attachment: fileReadyToUpload.fileData
          });
        })).then(function (_retryOperation) {
          var _chatState$chatTokens3;

          response = _retryOperation;
          recordCountMetric(PAGE_NAME, operationName, MetricEvents.SUCCESS_COUNT); //Added Logs for attachment

          myHRLoggerInfoLog("[" + ((_chatState$chatTokens3 = chatState.chatTokens) === null || _chatState$chatTokens3 === void 0 ? void 0 : _chatState$chatTokens3.contactId) + "]: User Sent an attachment  ", Object.assign({}, logsContext, {
            operationName: operationName
          }));
        });
      }, function (e) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred in LiveHelpChat while uploading attachment. " + getDetailedErrorMessage(e), Object.assign({}, logsContext, {
          operationName: operationName
        }));
        recordErrorCountMetric(PAGE_NAME, operationName, JSON.stringify(e));
        setFileReadyToUpload({
          fileData: null,
          uploadStatus: AttachmentUploadStatus.Inactive
        });
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var sendDescribeIssueMessages = function sendDescribeIssueMessages() {
    var pageName = 'LiveHelpChat';
    var operationName = 'UserDescribeIssue';

    if (messageString.length > 0 || fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Ready) {
      myHRLoggerInfoLog("[" + userIdentifier + "]: User sent describe issue", Object.assign({}, logsContext, {
        operationName: operationName
      }));
      recordCountMetric(pageName, operationName, MetricEvents.CLICKS_COUNT);
    }

    if (messageString.length > 0) sendMessageFromParticipant(messageString, chatSession, setChatSession);
    if (fileReadyToUpload.uploadStatus === AttachmentUploadStatus.Ready) uploadDescribeissueAttachmentToConnect();
  };

  var onTransferSucceeded = function onTransferSucceeded(transferredContactId, transferredParticipantId) {
    try {
      var UPDATE_CHAT_SESSION_OPERATION_NAME = 'UpdateChatSessionOnTransfer';
      return Promise.resolve(chatSession.chatSession.getChatDetails()).then(function (response) {
        var token = response.participantToken;
        var employeeId = getUserIdentifier();
        var backendServiceClient = new BackendServiceClientWrapper();
        var queryParams = {
          'x-myhr-client-id': 'MyHR_LiveHelp',
          operation: '/api/contact/chat/contactId'
        };
        var body = {
          employeeId: employeeId,
          instanceId: chatState.instanceId,
          contactId: transferredContactId,
          participantId: transferredParticipantId,
          participantToken: token,
          region: chatState.region,
          businessLine: chatState.businessLine,
          connectAWSAccount: chatState.connectAWSAccount,
          idlenessDisconnectTimeOutInMinutes: chatState.idlenessDisconnectTimeOutInMinutes
        };

        if (!body.contactId || !body.participantId || !body.participantToken) {
          setShowErrorBanner(true);
          myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while updating chat session on transfer. Invalid chat contact channel attributes - " + JSON.stringify(body), Object.assign({}, logsContext, {
            operationName: UPDATE_CHAT_SESSION_OPERATION_NAME
          }));
          recordCountMetric(logsContext.pageName, UPDATE_CHAT_SESSION_OPERATION_NAME, MetricEvents.INVALID_INPUT);
          return;
        }

        var _temp3 = _catch(function () {
          var startTimeUpdateChatSession = Date.now();
          return Promise.resolve(backendServiceClient.post(body, queryParams)).then(function (backendResponse) {
            var _chatState$chatTokens4;

            myHRLoggerInfoLog("[" + ((_chatState$chatTokens4 = chatState.chatTokens) === null || _chatState$chatTokens4 === void 0 ? void 0 : _chatState$chatTokens4.initialContactId) + "] Chat was transferred successfully with new contact id " + transferredContactId, Object.assign({}, logsContext, {
              operationName: UPDATE_CHAT_SESSION_OPERATION_NAME
            }));
            recordLatencyMetric(PAGE_NAME, UPDATE_CHAT_SESSION_OPERATION_NAME, startTimeUpdateChatSession);
            recordCountMetric(PAGE_NAME, UPDATE_CHAT_SESSION_OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
          });
        }, function (error) {
          myHRLoggerErrorLog("[" + employeeId + "]: Error while updating the chat session on transfer. " + getDetailedErrorMessage(error), logsContext);
          recordErrorCountMetric(PAGE_NAME, UPDATE_CHAT_SESSION_OPERATION_NAME, JSON.stringify(error));
        });

        if (_temp3 && _temp3.then) return _temp3.then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleOnMessage = function handleOnMessage(data) {
    var messageContent = data.data;

    if (receivedMessageIdsRef.current.has(messageContent.Id)) {
      return;
    }

    addToReceivedMessageIds(messageContent.Id);
    messageRenderHelper.renderMessageFromResponse(messageContent, messagesRef, chatStateRef.current, setChatState, setMessages, setChatSession);

    if (messageContent.Type === MessageType.Attachment && messageContent.ParticipantRole === ParticipantRole.Customer) {
      setFileReadyToUpload(Object.assign({}, fileReadyToUpload, {
        uploadStatus: AttachmentUploadStatus.Inactive
      }));
    }

    if (chatStateRef.current.agentConnected) {
      if (messageContent.ParticipantRole === ParticipantRole.Customer) {
        setShouldStartIdlenessTimer(false);
      }

      if (messageContent.ParticipantRole === ParticipantRole.Agent && messageContent.ContentType !== ContentType.AgentJoined && !showFileUploadModalRef.current) {
        setShouldStartIdlenessTimer(true);
        setUnreadMessagesCount(unreadMessagesCountRef.current + 1);
      }
    }

    if (messageContent.ContentType === ContentType.AgentLeft && messageContent.ParticipantRole === ParticipantRole.Agent) {
      setShouldStartIdlenessTimer(false);
    }

    if (messageContent.ContentType === ContentType.AgentJoined && messageContent.ParticipantRole === ParticipantRole.Agent && messageContent.InitialContactId !== messageContent.ContactId) {
      onTransferSucceeded(messageContent.ContactId, messageContent.ParticipantId);
    }
  };

  var handleOnTyping = function handleOnTyping(event) {
    var data = event.data;

    if (data.ParticipantRole === ParticipantRole.Agent) {
      setIsAgentTyping(true); //Upon receiving the typing event, set the isAgentTyping state to true for 5 seconds. If count down is already in place, then over-write it

      if (agentTypingTimer) {
        clearInterval(agentTypingTimer);
      }

      agentTypingTimer = setTimeout(function () {
        setIsAgentTyping(false);
      }, 5000);
    }
  };

  var handleOnConnectionBroken = function handleOnConnectionBroken(event) {
    setChatState(Object.assign({}, chatState, {
      timerState: TimerState.NotActive,
      activateListener: !chatState.activateListener
    }));
    var eventErrorMessage = "[" + userIdentifier + "]: Error occurred in LiveHelpChat due to broken session connection. " + getDetailedErrorMessage(event);
    myHRLoggerErrorLog(eventErrorMessage, logsContext);
    recordErrorCountMetric(HelpChannel.LIVE_CHAT, logsContext.operationName, eventErrorMessage);
  };

  var handleOnConnectionEstablished = function handleOnConnectionEstablished() {
    messageRenderHelper.renderMessagesFromTranscript(chatSession.chatSession, messagesRef, chatStateRef.current, setChatState, setMessages, setChatSession, receivedMessageIdsRef, addToReceivedMessageIds);
    setTimeout(function () {
      return messageRenderHelper.renderMessagesFromTranscript(chatSession.chatSession, messagesRef, chatStateRef.current, setChatState, setMessages, setChatSession, receivedMessageIdsRef, addToReceivedMessageIds)["catch"](function (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occured in LiveHelpChat while fetching previous messages. " + getDetailedErrorMessage(error), logsContext);
        recordErrorCountMetric(HelpChannel.LIVE_CHAT, CommonOperations.MESSAGES_DOWNLOAD_FAILED, JSON.stringify(error));
      });
    }, DELAY_FOR_REFRESH);
  };

  useEffect(function () {
    if (chatSession.connectionStatus !== ChatSessionConnectionStatus.Connected) {
      return;
    }

    if (networkConnectionStatus === NetworkConnectionStatus.OFFLINE) {
      setChatState(Object.assign({}, chatState, {
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener
      }));
      return;
    }

    handleOnConnectionEstablished();
  }, [networkConnectionStatus]);

  var setUpEventListeners = function setUpEventListeners() {
    chatSession.chatSession.onMessage(handleOnMessage);
    chatSession.chatSession.onConnectionBroken(handleOnConnectionBroken);
    chatSession.chatSession.onConnectionEstablished(handleOnConnectionEstablished); //On typing event listener

    chatSession.chatSession.onTyping(handleOnTyping);
  }; //This useEffect hook depends on the chat session state


  useEffect(function () {
    if (chatSession.connectionStatus === ChatSessionConnectionStatus.Connected) {
      receivedMessageIdsRef.current.clear();
      setUpEventListeners();
      sendDescribeIssueMessages();
    } else if (chatSession.connectionStatus === ChatSessionConnectionStatus.Attempting) {
      new Promise(function (resolve, reject) {
        if (chatState.chatTokens) {
          return resolve(chatState.chatTokens);
        }

        createChat(chatState.employeeAttributes, chatState.currentLanguage, showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['instanceId'] : chatState.instanceId, showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['contactFlowId'] : chatState.contactFlowId, showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['queueId'] : chatState.queueId, chatState.userContext, chatState.businessLine, showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['region'] : chatState.region, chatState.waitTime, chatState.showWaitTime, chatState.timeStampForLiveHelpClick, chatState.timeStampForChatClick, showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['connectAWSAccount'] : chatState.connectAWSAccount, chatState.idlenessDisconnectTimeOutInMinutes, chatState.chatRecordingBehavior, chatState.receivedProps, chatState.liveHelpClickSource, showLiveChatSurvey.connectToPriorityQueue).then(function (chatTokens) {
          setChatState({
            chatTokens: chatTokens
          });

          if (showLiveChatSurvey.connectToPriorityQueue) {
            var OPERATION_NAME = 'GetPriorityChatTokens';
            myHRLoggerInfoLog("[" + (chatTokens === null || chatTokens === void 0 ? void 0 : chatTokens.contactId) + "]: Chat Successfully established with priority support", Object.assign({}, logsContext, {
              operationName: OPERATION_NAME
            }));
          } else {
            var _OPERATION_NAME = 'GetChatTokens';
            myHRLoggerInfoLog("[" + (chatTokens === null || chatTokens === void 0 ? void 0 : chatTokens.contactId) + "]: Chat Successfully established", Object.assign({}, logsContext, {
              operationName: _OPERATION_NAME
            }));
          }

          return resolve(chatTokens);
        })["catch"](function (error) {
          var OPERATION_NAME = 'GetChatTokens';
          myHRLoggerErrorLog("[" + userIdentifier + "]: Error while establishing chat. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
            operationName: OPERATION_NAME
          }));
          return reject(error);
        });
      }).then(function (chatTokens) {
        startChat(chatState.employeeAttributes, chatTokens.participantId, chatTokens.participantToken, chatTokens.initialContactId, chatState.region, chatState, setChatState, chatSession, setChatSession, messagesRef, setMessages, receivedMessageIdsRef, addToReceivedMessageIds);
      })["catch"](function () {
        setChatSession({
          chatSession: null,
          connectionStatus: ChatSessionConnectionStatus.Failure,
          errorMessage: 'Unable to establish chat session. Please try again.',
          actionResponse: ChatSessionActionResponse.NoAction
        });
      });
    } else if (chatSession.connectionStatus === ChatSessionConnectionStatus.Ended) {
      messageRenderHelper.sendChatStatusHeader(t('livehelp.chat_session_ended'), messagesRef, setMessages);
      setChatState(Object.assign({}, chatState, {
        idlenessReminder: defaultChatState.idlenessReminder,
        idlenessBannerTimeInMinutes: defaultChatState.idlenessBannerTimeInMinutes,
        timerState: defaultChatState.timerState,
        agentConnected: defaultChatState.agentConnected
      }));

      if (willSurveyBeShown) {
        var preferredLanguage = localStorage.getItem('i18nextLng') || 'en-US';
        var TAS_OPERATION_NAME = 'FetchSurveyDataFromTAS';
        var startTimeTASCall = Date.now();

        if (chatState.businessLine && !chatState.isDescribeIssue) {
          getTranslatedContentFromTAS(SurveyConfig[chatState.businessLine].translationId[stage.trim()], preferredLanguage).then(function (result) {
            recordLatencyMetric(PAGE_NAME, TAS_OPERATION_NAME, startTimeTASCall);
            recordCountMetric(PAGE_NAME, TAS_OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
            var tasResponseTranslation = JSON.parse(JSON.parse(result.data.response).translation);
            setTranslatedSurveyData(tasResponseTranslation);
            setShowLiveChatSurvey(Object.assign({}, showLiveChatSurvey, {
              showSurvey: true
            }));
          })["catch"](function (error) {
            myHRLoggerErrorLog("[" + userIdentifier + "]: . Error while fetching survey data from TAS. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
              operationName: TAS_OPERATION_NAME
            }));
            recordErrorCountMetric(PAGE_NAME, TAS_OPERATION_NAME, JSON.stringify(error));
            setShowLiveChatSurvey(Object.assign({}, showLiveChatSurvey, {
              showSurvey: false
            }));
          });
        }
      }
    }
  }, [chatSession.connectionStatus]);
  useEffect(function () {
    if (shouldStartIdlenessTimer) {
      setChatState({
        timerState: TimerState.ResetTimer,
        activateListener: !chatState.activateListener
      });
    } else {
      setChatState({
        timerState: TimerState.NotActive,
        activateListener: !chatState.activateListener
      });
    }
  }, [shouldStartIdlenessTimer]);

  var playNotificationSound = function playNotificationSound(notificationSoundRef) {
    if (matches.l || matches.xl) {
      var PLAY_CHAT_NOTIFICATION_OPERATION_NAME = 'PlayNotificationsOnChat';
      notificationSoundRef.current.play()["catch"](function (error) {
        myHRLoggerErrorLog("Error while playing Notification sound in Live Chat. " + getDetailedErrorMessage(error), logsContext);
        recordErrorCountMetric(PAGE_NAME, PLAY_CHAT_NOTIFICATION_OPERATION_NAME, JSON.stringify(error));
      });
    }
  };

  useEffect(function () {
    // notification and title change for idleness and disconnection
    //Added Logs for Notifications
    var OPERATION_NAME = 'IdlenessBanner';

    if (!isPageVisible || chatState.isChatMinimized) {
      if (chatStateRef.current.idlenessReminder === IdlenessReminder.Warning) {
        var _chatState$chatTokens5;

        document.title = PageTitle.CHAT_DISCONNECTING_SOON;
        myHRLoggerInfoLog("[" + ((_chatState$chatTokens5 = chatState.chatTokens) === null || _chatState$chatTokens5 === void 0 ? void 0 : _chatState$chatTokens5.contactId) + "]: User Received Idleness Reminder Warning Banner ", Object.assign({}, logsContext, {
          operationName: OPERATION_NAME
        }));
        playNotificationSound(IdlenessWarningNotificationRef);
      } else if (chatStateRef.current.idlenessReminder === IdlenessReminder.Disconnect) {
        var _chatState$chatTokens6;

        document.title = PageTitle.CHAT_WITH_HR;
        myHRLoggerInfoLog("[" + ((_chatState$chatTokens6 = chatState.chatTokens) === null || _chatState$chatTokens6 === void 0 ? void 0 : _chatState$chatTokens6.contactId) + "]: User Received Idleness Reminder Disconnect Banner ", Object.assign({}, logsContext, {
          operationName: OPERATION_NAME
        }));
        playNotificationSound(DisconnectionWarningNotificationRef);
      }
    }
  }, [chatStateRef.current.idlenessReminder]);
  useEffect(function () {
    // notification and title change for new message
    var OPERATION_NAME = 'NewMessagePing';

    if (unreadMessagesCount > 0 && (!isPageVisible || chatState.isChatMinimized)) {
      var _chatState$chatTokens7;

      document.title = unreadMessagesCount + PageTitle.NEW_CHAT_MESSAGE;
      myHRLoggerInfoLog("[" + ((_chatState$chatTokens7 = chatState.chatTokens) === null || _chatState$chatTokens7 === void 0 ? void 0 : _chatState$chatTokens7.contactId) + "]: User Recieved New Message Ping ", Object.assign({}, logsContext, {
        operationName: OPERATION_NAME
      }));
      playNotificationSound(NewMessageNotificationRef);
    }
  }, [unreadMessagesCount]);
  useEffect(function () {
    if (isPageVisible && !chatState.isChatMinimized) {
      document.title = PageTitle.CHAT_WITH_HR;
    }

    if (isPageVisible && !chatState.isChatMinimized) {
      setUnreadMessagesCount(0);
    }

    if (chatState.isChatMinimized) {
      document.title = PageTitle.LIVE_HELP;
    }
  }, [isPageVisible, chatState.isChatMinimized]);

  var chatBody = function chatBody() {
    var _chatState$chatTokens8;

    return /*#__PURE__*/React.createElement(MessageBoard, {
      messages: messages,
      isAgentTyping: isAgentTyping,
      chatSession: chatSession,
      setChatSession: setChatSession,
      cti: chatState.cti,
      chatConnectionToggled: chatConnectionToggled,
      setChatConnectionToggled: setChatConnectionToggled,
      messagesRef: messagesRef,
      setMessages: setMessages,
      participantToken: (_chatState$chatTokens8 = chatState.chatTokens) === null || _chatState$chatTokens8 === void 0 ? void 0 : _chatState$chatTokens8.participantToken,
      connectRegion: chatState.region,
      fileUploadStatus: fileReadyToUpload.uploadStatus
    });
  };

  var chatFooter = function chatFooter() {
    return /*#__PURE__*/React.createElement(Footer$1, {
      messageString: messageString,
      setMessageString: setMessageString,
      chatSession: chatSession,
      setChatSession: setChatSession,
      chatState: chatState,
      setChatState: setChatState,
      timerState: TimerState,
      messages: messages,
      setMessages: setMessages,
      disconnectFor: DisconnectFor,
      setConfirmExit: setConfirmExit,
      onCloseChatWindow: onCloseChatWindow,
      chatCloseButtonRef: chatCloseButtonRef,
      fileReadyToUpload: fileReadyToUpload,
      setFileReadyToUpload: setFileReadyToUpload,
      setShowFileUploadModal: setShowFileUploadModal,
      inputBoxRef: inputBoxRef,
      shouldStartIdlenessTimer: shouldStartIdlenessTimer
    });
  };

  var chatModals = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChatRecordingOptModal, {
    chatState: chatState,
    setChatState: setChatState
  }), /*#__PURE__*/React.createElement(EndChatModal, {
    chatState: chatState,
    setChatState: setChatState,
    onCloseChatWindow: onCloseChatWindow,
    messagesRef: messagesRef,
    setMessages: setMessages,
    chatSession: chatSession,
    setChatSession: setChatSession,
    idlenessBannerTimeInMinutes: chatState.idlenessBannerTimeInMinutes,
    chatCloseButtonRef: chatCloseButtonRef,
    willSurveyBeShown: willSurveyBeShown
  }), /*#__PURE__*/React.createElement(FileUploadModal, {
    setFileReadyToUpload: setFileReadyToUpload,
    showFileUploadModal: showFileUploadModal,
    setShowFileUploadModal: setShowFileUploadModal,
    setShouldStartIdlenessTimer: setShouldStartIdlenessTimer
  }), /*#__PURE__*/React.createElement(SurveyModal, {
    showLiveChatSurvey: showLiveChatSurvey,
    setShowLiveChatSurvey: setShowLiveChatSurvey,
    businessLine: chatState.businessLine,
    region: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['region'] : chatState.region,
    instanceId: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['region'] : chatState.instanceId,
    initialContactId: (_chatState$chatTokens9 = chatState.chatTokens) === null || _chatState$chatTokens9 === void 0 ? void 0 : _chatState$chatTokens9.initialContactId,
    chatCloseButtonRef: chatCloseButtonRef,
    translatedSurveyData: translatedSurveyData,
    isChatVisible: !chatState.isChatMinimized,
    connectAWSAccount: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['connectAWSAccount'] : chatState.connectAWSAccount,
    queueId: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['queueId'] : chatState.queueId,
    contactFlowId: showLiveChatSurvey.connectToPriorityQueue ? priorityConfig === null || priorityConfig === void 0 ? void 0 : priorityConfig['contactFlowId'] : chatState.contactFlowId,
    employeeAttributes: chatState.employeeAttributes,
    isPriorityChannelAvailable: priorityConfig ? true : false
  }));

  var closeOnEscape = function closeOnEscape(event) {
    var ESCAPE_KEY_CODE = 27;

    if (!chatState.isChatMinimized && event.keyCode === ESCAPE_KEY_CODE) {
      setIsChatMinimized(true);
    }
  }; // @ts-ignore
  // tslint:disable-next-line


  var onChatContainerResizeStops = function onChatContainerResizeStops(event, direction, elementRef, dimensionsDelta) {
    var width = dimensionsDelta.width,
        height = dimensionsDelta.height;
    setChatContainerSize(function (prevSize) {
      return {
        width: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.width) + width,
        height: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.height) + height
      };
    });
  };

  var anyChildModalOpen = chatState.confirmExit || showLiveChatSurvey.showSurvey || showFileUploadModalRef.current;
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18Instance
  }, chatState.isChatMinimized ? !isLiveHelpInlineChatActive && /*#__PURE__*/React.createElement(MinimizedChatHeader, null) : /*#__PURE__*/React.createElement(Flyout, {
    isOpen: !chatState.isChatMinimized,
    close: function close() {
      return void 0;
    },
    shouldCloseOnClickOutside: false,
    "aria-labelledby": "livechat-heading",
    "aria-hidden": anyChildModalOpen
  }, /*#__PURE__*/React.createElement(Col, {
    maxWidth: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Resizable, {
    style: {
      zIndex: isNotInlineViewFromDesktop ? 1 : FAB_ICON_ZINDEX + 1
    },
    className: matches.l || matches.xl ? languageDirection === 'rtl' ? 'chat-container-left' : 'chat-container-right' : 'chat-container-mobile',
    size: chatContainerSize,
    onResizeStop: onChatContainerResizeStops,
    enable: matches.l || matches.xl ? BROWSER_RESIZE_SIDES_ENABLED : MOBILE_RESIZE_SIDES_ENABLED,
    minHeight: isNotInlineViewFromDesktop ? MIN_CONTAINER_HEIGHT_BROWSER : '100%',
    minWidth: MIN_CONTAINER_WIDTH_BROWSER,
    maxHeight: MAX_CONTAINER_HEIGHT,
    maxWidth: MAX_CONTAINER_WIDTH
  }, /*#__PURE__*/React.createElement(View$1, {
    style: {
      visibility: !chatState.isChatMinimized ? 'visible' : 'hidden'
    },
    onKeyDown: closeOnEscape,
    height: '100%',
    width: '100%'
  }, /*#__PURE__*/React.createElement(View$1, {
    height: '100%',
    display: "flex",
    flexDirection: "column"
  }, isLiveHelpInlineChatActive ? /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement(Container, {
    className: "chat-header-container"
  }, /*#__PURE__*/React.createElement(H2, {
    id: "livechat-heading",
    color: "#ffffff",
    className: 'chat-header-title  chat-header-title-left-inline'
  }, t('livehelp.live_chat_with_HR')), /*#__PURE__*/React.createElement(LiveHelpInlineCloseBtn, {
    variant: ButtonVariant.Tertiary,
    size: ButtonSize.Default,
    onClick: onCloseLiveHelpChat
  }, /*#__PURE__*/React.createElement(IconCross, null))), !anyChildModalOpen && chatState.idlenessReminder === IdlenessReminder.Warning && /*#__PURE__*/React.createElement(DisconnectBanner, {
    idlenessBannerTimeInMinutes: chatState.idlenessBannerTimeInMinutes,
    chatState: chatState,
    setChatState: setChatState,
    inputBoxRef: inputBoxRef
  })) : /*#__PURE__*/React.createElement(Header$1, {
    onCloseChat: onCloseChatWindow,
    idlenessBannerTimeInMinutes: chatState.idlenessBannerTimeInMinutes,
    anyChildModalOpen: anyChildModalOpen,
    chatState: chatState,
    onMinimizeChat: function onMinimizeChat() {
      setIsChatMinimized(true);
      focusPlus();
    },
    minusButtonRef: minusButtonRef,
    setChatState: setChatState,
    inputBoxRef: inputBoxRef
  }), (chatSession.actionResponse === ChatSessionActionResponse.DownloadChatFailed || chatSession.actionResponse === ChatSessionActionResponse.MessageSentFailed || chatSession.actionResponse === ChatSessionActionResponse.DownloadAttachmentFailed) && /*#__PURE__*/React.createElement(ChatErrorBanner, {
    message: chatSession.errorMessage
  }), chatSession.connectionStatus === ChatSessionConnectionStatus.Failure && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChatErrorBanner, {
    message: chatSession.errorMessage
  }), chatFooter()), (chatSession.connectionStatus === ChatSessionConnectionStatus.Connected && chatState.isDescribeIssue === false || chatSession.connectionStatus === ChatSessionConnectionStatus.Ended || chatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue) && /*#__PURE__*/React.createElement(React.Fragment, null, chatBody(), chatFooter()), (chatSession.connectionStatus === ChatSessionConnectionStatus.Attempting || chatSession.connectionStatus === ChatSessionConnectionStatus.Connected && chatState.isDescribeIssue === true) && /*#__PURE__*/React.createElement(ChatSpinner, null), showErrorBanner && /*#__PURE__*/React.createElement(ChatErrorBanner, {
    message: errorMessage
  })))))), chatModals);
};

/**
 * Defines the redirection flow.
 * EXTERNAL marks redirection to a URL outside MyHR.
 * INTERNAL marks redirection to create a case within MyHR.
 */
var ICaseSystemType;

(function (ICaseSystemType) {
  ICaseSystemType["EXTERNAL"] = "EXTERNAL";
  ICaseSystemType["INTERNAL"] = "INTERNAL";
})(ICaseSystemType || (ICaseSystemType = {}));

var SIM_T = {
	canAccessibleOffNetwork: false,
	link: "https://t.corp.amazon.com/create/templates/8b0691d9-1778-483b-a07b-11fde25296ad"
};
var Remedy = {
	canAccessibleOffNetwork: false,
	link: "https://tt.amazon.com/new?ticket_type=US+HR+Support&prev_qid=Q001257101&use_the_force=Yes&routingDirection=Auto&impact=5&cti-finder-type=keyword&category=Human+Resources&type=Time+%26+Attendance+(MyTime)&item=Data+Changes+-+Recode&country=United+States&case_type=Trouble+Ticket&quicklink_creator=crouse&add_perm=%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3B%27CTK-Admin-Primary%27%3BERC-Support&short_description=Canada+Use+Only%3A+Recode+Time+for+%5BENTER+NAME+%26+DATE%5D&details=**+NOTE%3A+If+this+ticket+is+for+PAY+RELATED+ISSUE+(under+Closed+Pay+Period)+and+needs+to+be+corrected%2Fpaid.+Please+route+the+ticket+to+Payroll+Correction+CTI+-+Human+Resources%3E%3E+Pay+Quality%3E%3E+Pay+Adjustment%2C+MyTime**%0D%0A%0D%0A*Manager%2FSite+HR+Approval+is+required+to+process+your+request+otherwise+your+ticket+might+go+into+pending*%0D%0A%0D%0AThis+ticket+is+for+HR+teams+to+request+a+recode+of+time+for+a+USA+or+Canada+associate+within+MyTime.+Associates+should+use+self-service+options+through+the+MyTime+Kiosks+and+Amazon+Hub+for+same+day+and+future+dated+requests.%0D%0A%0D%0AAttach+an+excel+spreadsheet+for+multiple+associate+requests+with+the+required+information+below.+%0D%0A%0D%0AFor+individual+associate+requests%2C+complete+the+following+information%3A%0D%0A%0D%0AAssociate+Full+Name%3A%0D%0AAssociate+Employee+ID%3A%0D%0ADate+that+needs+to+be+recoded+(mm%2Fdd%2Fyyyy)%3A+%0D%0AStart+time+to+be+recoded+(AM%2FPM)%3A%0D%0ALength+of+the+pay-code+to+be+coded+(hrs%2Fmins)%3A%0D%0ACurrently+coded+as%3A+%0D%0APay-code+to+be+coded+(Paid%2FUn-paid)%3A%0D%0A%0D%0AThank+you%2C%0D%0AHR+Services+-+Centralized+Timekeeping+Team&quicklink_id=Q001257101&quicklink_status=0"
};
var Dali = {
	canAccessibleOffNetwork: true,
	link: "https://dls.idp.amazon-corp.com/"
};
var Smartforms = {
	canAccessibleOffNetwork: false,
	link: "https://smartforms.corp.amazon.com/#/groupchange-grid"
};
var ExternalCaseSystem = {
	SIM_T: SIM_T,
	Remedy: Remedy,
	Dali: Dali,
	Smartforms: Smartforms
};

var getIsCaseCreationAccessibleOffNetwork = function getIsCaseCreationAccessibleOffNetwork(getContactChannelResponse) {
  var _getContactChannelRes, _getContactChannelRes2, _getContactChannelRes3, _getContactChannelRes4;

  var caseSystemType = (_getContactChannelRes = getContactChannelResponse.caseAttributes) === null || _getContactChannelRes === void 0 ? void 0 : (_getContactChannelRes2 = _getContactChannelRes.caseContactChannel) === null || _getContactChannelRes2 === void 0 ? void 0 : _getContactChannelRes2.caseContactAttributes.caseSystemType;
  var caseSystem = (_getContactChannelRes3 = getContactChannelResponse.caseAttributes) === null || _getContactChannelRes3 === void 0 ? void 0 : (_getContactChannelRes4 = _getContactChannelRes3.caseContactChannel) === null || _getContactChannelRes4 === void 0 ? void 0 : _getContactChannelRes4.caseContactAttributes.caseSystem;

  if (caseSystem) {
    var _ExternalCaseSystem$c;

    return caseSystemType === ICaseSystemType.INTERNAL || ((_ExternalCaseSystem$c = ExternalCaseSystem[caseSystem]) === null || _ExternalCaseSystem$c === void 0 ? void 0 : _ExternalCaseSystem$c.canAccessibleOffNetwork);
  }

  return true;
};

var isCurrentLanguageEnglish = function isCurrentLanguageEnglish(currentLanguage) {
  if (currentLanguage === LanguagesAvailable.en_CA.toString() || currentLanguage === LanguagesAvailable.en_IN.toString() || currentLanguage === LanguagesAvailable.en_GB.toString() || currentLanguage === LanguagesAvailable.en_US.toString()) {
    return true;
  }

  return false;
};
var isRequiredCTI = function isRequiredCTI(userContext) {
  if (!userContext) {
    return false;
  }

  var intentDisambiguted = userContext.split('_');
  var category = intentDisambiguted[0];
  var type = intentDisambiguted[1];
  var covid19Category = 'COVID-19';
  var timeLeaveAccommodationCategory = 'Time, Leave of Absence and Accommodation';
  var leaveOfAbsenceType = 'Leave of Absence';
  var accommodationType = 'Accommodation';

  if (category === covid19Category) {
    return true;
  }

  if (category === timeLeaveAccommodationCategory && (type === leaveOfAbsenceType || type === accommodationType)) {
    return true;
  }

  return false;
};
var isRequiredCountry = function isRequiredCountry(countryCode) {
  if (!countryCode) {
    return false;
  }

  if (countryCode === 'USA' || countryCode === 'PRI') {
    return true;
  }

  return false;
};

var getNextHoursOfOperation = function getNextHoursOfOperation(startTime, endTime, day, timezone) {
  // Get hours and minutes for start and end time
  var t1 = startTime.split(':');
  var startTimeHours = Number(t1[0]);
  var startTimeMinutes = Number(t1[1]);
  var t2 = endTime.split(':');
  var endTimeHours = Number(t2[0]);
  var endTimeMinutes = Number(t2[1]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var startDateTime = DateTime.fromObject({
    hour: startTimeHours,
    minute: startTimeMinutes
  }, {
    zone: timezone
  });
  var endDateTime = DateTime.fromObject({
    hour: endTimeHours,
    minute: endTimeMinutes
  }, {
    zone: timezone
  });
  var dayOfWeekIndex = CALENDAR_CONSTANTS.DAYS.indexOf(day);
  var startDayDiff = dayOfWeekIndex - startDateTime.weekday;
  var endDayDiff = dayOfWeekIndex - endDateTime.weekday;
  var localStartTime = startDateTime.plus({
    days: startDayDiff
  }).toLocal();
  var localEndTime = endDateTime.plus({
    days: endDayDiff
  }).toLocal();
  var startDayOfWeek = localStartTime.toFormat(CALENDAR_CONSTANTS.FORMAT_TOKEN.DAY);
  var endDayOfWeek = localEndTime.toFormat(CALENDAR_CONSTANTS.FORMAT_TOKEN.DAY);
  var translatedStartDayOfWeek = t("" + startDayOfWeek);
  var translatedEndDayOfWeek = t("" + endDayOfWeek);
  return {
    startDay: translatedStartDayOfWeek,
    endDay: translatedEndDayOfWeek,
    startTime: localStartTime.toFormat(CALENDAR_CONSTANTS.FORMAT_TOKEN.TIME),
    endTime: localEndTime.toFormat(CALENDAR_CONSTANTS.FORMAT_TOKEN.TIME)
  };
};

var css_248z$h = ".chat-open-error-modal-button{font-size:16px!important}";
styleInject(css_248z$h);

var ChatOpenErrorModal = function ChatOpenErrorModal(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnClickOutside: true,
    isOpen: props.isOpen,
    "aria-labelledby": "livechat-chat-open-error-title",
    close: props.onClose
  }, /*#__PURE__*/React.createElement(ModalContent, {
    titleText: "",
    maxWidth: null,
    closeButtonAltText: "Close dialog",
    onCloseButtonClick: props.onClose,
    buttons: [/*#__PURE__*/React.createElement(Button, {
      className: "chat-open-error-modal-button",
      key: "closeModal",
      variant: ButtonVariant.Primary,
      onClick: props.onClose
    }, t('livehelp.okay'))]
  }, /*#__PURE__*/React.createElement(H2, {
    margin: {
      bottom: '20px'
    },
    style: {
      fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    },
    id: "livechat-chat-open-error-title"
  }, t('livehelp.chat_open_error_modal_title')), /*#__PURE__*/React.createElement(Text$1, {
    className: "chat-open-error-text",
    fontSize: 16
  }, t('livehelp.chat_open_error_modal_text'))));
};

var css_248z$i = ".contact-channel{background-color:#fff!important}.contact-channel-row-mobile{align-items:center;display:flex;flex-direction:row}.contact-channel-col-mobile{align-items:center}.contact-channel-icon-container{border-radius:42px;box-shadow:0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.2);flex-grow:0!important;height:48px!important;margin:0 8px!important;padding:12px!important;width:48px!important}.contact-channel-icon-container>div>svg{height:21.6px!important;width:22.8px!important}.contact-channel-icon-container>div{align-items:center;display:flex;justify-content:center}.contact-channel-text-container{padding:0!important}.contact-channel-button{font:inherit!important;padding:0!important;text-align:left!important;width:100%!important}.contact-channel-button,.contact-channel-link{border:none!important;color:inherit!important;height:100%!important}.contact-channel-link{display:block!important;text-decoration:none!important}.contact-channel-locked{background:#d1d5da!important}.contact-channel-button:focus,.contact-channel-link:focus{outline:1px auto -webkit-focus-ring-color;outline-offset:1px}.contact-channel-main-text-container{display:flex;flex-direction:row;text-align:center}.contact-channel-padlock-row{padding-left:22px;padding-top:12px}.contact-channel-external-link-icon,.contact-channel-padlock-text{padding-left:4px}.chat-active-tag{align-items:center!important;display:flex!important;height:100%!important;justify-content:flex-end!important;padding-right:10px!important}.chat-active-tag>div>div>div{font-size:14px!important}.contact-channel-tag-container{margin-left:auto!important;width:100px!important}.text-padding{padding:2px!important}.contact-channel-icon-and-text-container{display:flex!important}.english-language-only-text{font-size:15px!important;padding-left:4px!important}.contact-channel-subtext{color:#56616c}.contact-channel--icon{margin:0 15px!important}";
styleInject(css_248z$i);

var ChannelDisplayState;

(function (ChannelDisplayState) {
  ChannelDisplayState["NOT_SHOWN"] = "NOT_SHOWN";
  ChannelDisplayState["ACTIVE"] = "ACTIVE";
  ChannelDisplayState["DISABLED"] = "DISABLED";
  ChannelDisplayState["LOCKED"] = "LOCKED";
  ChannelDisplayState["DISABLED_NO_AGENTS"] = "DISABLED_NO_AGENTS";
  ChannelDisplayState["DISABLED_HIGH_WAIT_TIME"] = "DISABLED_HIGH_WAIT_TIME";
})(ChannelDisplayState || (ChannelDisplayState = {}));

var PAGE_NAME = 'ContactChannel';
var ContactChannel = function ContactChannel(_ref) {
  var _props$state$employee;

  var channelDisplayState = _ref.channelDisplayState,
      name = _ref.name,
      props = _ref.props,
      shouldHideWaitTime = _ref.shouldHideWaitTime;
  var channelIsDisabled;
  var waitTime;
  var isChannelLocked = false;

  var _useChatContext = useChatContext(),
      chatState = _useChatContext.chatState,
      setChatState = _useChatContext.setChatState,
      setChatSession = _useChatContext.setChatSession;

  var liveHelpInlineContext = useLiveHelpInlineContext();

  var _useState = useState(false),
      isChatOpenErrorModalOpen = _useState[0],
      setIsChatOpenErrorModalOpen = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var setIsChannelLocked = function setIsChannelLocked() {
    if (name === 'ticket') {
      isChannelLocked = props.state.isUserOffNetwork && props.state.isCaseCreationAccessibleOffNetwork === false;
    }
  };

  var setIsDisabled = function setIsDisabled() {
    channelIsDisabled = channelDisplayState === ChannelDisplayState.DISABLED || channelDisplayState === ChannelDisplayState.DISABLED_NO_AGENTS || channelDisplayState === ChannelDisplayState.DISABLED_HIGH_WAIT_TIME;
  };

  var setWaitTime = function setWaitTime() {
    var _props$state$external;

    if (name === 'chat' && props.state.chatAvailable) {
      waitTime = props.state.chatAttributes.waitTimeInMinutes;
    } else if (name === 'phone' && props.state.voiceAvailable) {
      waitTime = props.state.voiceAttributes.waitTimeInMinutes;
    } else if (name === 'ticket' && props.state.caseAvailable) {
      waitTime = props.state.caseAttributes.waitTimeInMinutes;
    } else if (name === 'externalChat' && (_props$state$external = props.state.externalChatAttributes) !== null && _props$state$external !== void 0 && _props$state$external.isAvailable) {
      waitTime = Math.ceil(props.state.externalChatAttributes.waitTimeInSeconds / 60);
    } else {
      waitTime = 0;
    }
  };

  var getDisabledChannelSubText = function getDisabledChannelSubText() {
    if (channelDisplayState === ChannelDisplayState.DISABLED) {
      return getNextHoursOfOperationText();
    }

    if (channelDisplayState === ChannelDisplayState.DISABLED_NO_AGENTS) {
      return t('livehelp.no_agents');
    }

    if (channelDisplayState === ChannelDisplayState.DISABLED_HIGH_WAIT_TIME) {
      return t('livehelp.high_wait_time');
    }

    return '';
  };

  var getNextHoursOfOperationText = function getNextHoursOfOperationText() {
    var _props$state$chatAttr, _props$state$voiceAtt;

    if (name === 'chat' && !props.state.chatAvailable && ((_props$state$chatAttr = props.state.chatAttributes) === null || _props$state$chatAttr === void 0 ? void 0 : _props$state$chatAttr.nextOperableQueueHours) != null) {
      var _props$state$chatAttr2, _props$state$chatAttr3, _props$state$chatAttr4, _props$state$chatAttr5, _props$state$chatAttr6, _props$state$chatAttr7, _props$state$chatAttr8, _props$state$chatAttr9;

      var result = getNextHoursOfOperation((_props$state$chatAttr2 = props.state.chatAttributes) === null || _props$state$chatAttr2 === void 0 ? void 0 : (_props$state$chatAttr3 = _props$state$chatAttr2.nextOperableQueueHours) === null || _props$state$chatAttr3 === void 0 ? void 0 : _props$state$chatAttr3.startTime, (_props$state$chatAttr4 = props.state.chatAttributes) === null || _props$state$chatAttr4 === void 0 ? void 0 : (_props$state$chatAttr5 = _props$state$chatAttr4.nextOperableQueueHours) === null || _props$state$chatAttr5 === void 0 ? void 0 : _props$state$chatAttr5.endTime, (_props$state$chatAttr6 = props.state.chatAttributes) === null || _props$state$chatAttr6 === void 0 ? void 0 : (_props$state$chatAttr7 = _props$state$chatAttr6.nextOperableQueueHours) === null || _props$state$chatAttr7 === void 0 ? void 0 : _props$state$chatAttr7.day, (_props$state$chatAttr8 = props.state.chatAttributes) === null || _props$state$chatAttr8 === void 0 ? void 0 : (_props$state$chatAttr9 = _props$state$chatAttr8.nextOperableQueueHours) === null || _props$state$chatAttr9 === void 0 ? void 0 : _props$state$chatAttr9.timezone);

      if (result.startDay !== result.endDay) {
        return t('livehelp.next_hours_of_operation_with_days', {
          startDay: result.startDay,
          endDay: result.endDay,
          startTime: result.startTime,
          endTime: result.endTime
        });
      }

      return t('livehelp.next_hours_of_operation', {
        day: result.startDay,
        startTime: result.startTime,
        endTime: result.endTime
      });
    }

    if (name === 'phone' && !props.state.voiceAvailable && ((_props$state$voiceAtt = props.state.voiceAttributes) === null || _props$state$voiceAtt === void 0 ? void 0 : _props$state$voiceAtt.nextOperableQueueHours) != null) {
      var _props$state$voiceAtt2, _props$state$voiceAtt3, _props$state$voiceAtt4, _props$state$voiceAtt5, _props$state$voiceAtt6, _props$state$voiceAtt7, _props$state$voiceAtt8, _props$state$voiceAtt9;

      var _result = getNextHoursOfOperation((_props$state$voiceAtt2 = props.state.voiceAttributes) === null || _props$state$voiceAtt2 === void 0 ? void 0 : (_props$state$voiceAtt3 = _props$state$voiceAtt2.nextOperableQueueHours) === null || _props$state$voiceAtt3 === void 0 ? void 0 : _props$state$voiceAtt3.startTime, (_props$state$voiceAtt4 = props.state.voiceAttributes) === null || _props$state$voiceAtt4 === void 0 ? void 0 : (_props$state$voiceAtt5 = _props$state$voiceAtt4.nextOperableQueueHours) === null || _props$state$voiceAtt5 === void 0 ? void 0 : _props$state$voiceAtt5.endTime, (_props$state$voiceAtt6 = props.state.voiceAttributes) === null || _props$state$voiceAtt6 === void 0 ? void 0 : (_props$state$voiceAtt7 = _props$state$voiceAtt6.nextOperableQueueHours) === null || _props$state$voiceAtt7 === void 0 ? void 0 : _props$state$voiceAtt7.day, (_props$state$voiceAtt8 = props.state.voiceAttributes) === null || _props$state$voiceAtt8 === void 0 ? void 0 : (_props$state$voiceAtt9 = _props$state$voiceAtt8.nextOperableQueueHours) === null || _props$state$voiceAtt9 === void 0 ? void 0 : _props$state$voiceAtt9.timezone);

      if (_result.startDay !== _result.endDay) {
        return t('livehelp.next_hours_of_operation_with_days', {
          startDay: _result.startDay,
          endDay: _result.endDay,
          startTime: _result.startTime,
          endTime: _result.endTime
        });
      }

      return t('livehelp.next_hours_of_operation', {
        day: _result.startDay,
        startTime: _result.startTime,
        endTime: _result.endTime
      });
    }

    return '';
  };

  var getWaitTimeString = function getWaitTimeString() {
    if (name === 'chat' || name === 'phone' || name === 'externalChat') {
      return t('livehelp.wait_time');
    }

    return t('livehelp.response_time');
  };

  var getWaitTimeDescriptionForCase = function getWaitTimeDescriptionForCase(waitTimeInMinutes) {
    var oneMinuteWaitTimeMessage = t('livehelp.waiting_time_minute_text', {
      minutes: 1
    });

    if (waitTimeInMinutes < 0) {
      return oneMinuteWaitTimeMessage;
    }

    var waitTimeInDays = Math.round(waitTimeInMinutes / 60 / 24);

    if (waitTimeInDays < 1) {
      var waitTimeInHours = Math.floor(waitTimeInMinutes / 60);
      var remainingWaitTimeInMinutes = Math.round(waitTimeInMinutes - 60 * waitTimeInHours);
      var hoursTextTranslationId = waitTimeInHours === 1 ? 'livehelp.waiting_time_hour_text' : 'livehelp.waiting_time_hours_text';
      var waitTimeInHoursText = waitTimeInHours === 0 ? '' : t(hoursTextTranslationId, {
        hours: waitTimeInHours
      });
      var minutesTextTranslationId = remainingWaitTimeInMinutes === 1 ? 'livehelp.waiting_time_minute_text' : 'livehelp.waiting_time_minutes_text';
      var waitTimeInMinutesText = remainingWaitTimeInMinutes === 0 ? '' : t(minutesTextTranslationId, {
        minutes: remainingWaitTimeInMinutes
      });
      var hoursAndMinutesWaitTimeText = (waitTimeInHoursText + ' ' + waitTimeInMinutesText).trim();
      return hoursAndMinutesWaitTimeText.length !== 0 ? hoursAndMinutesWaitTimeText : oneMinuteWaitTimeMessage;
    }

    if (waitTimeInDays === 1) {
      return t('livehelp.business_day', {
        day: 1
      });
    }

    return t('livehelp.business_days', {
      days: waitTimeInDays
    });
  };

  var getWaitTimeDescriptionString = function getWaitTimeDescriptionString() {
    if (name === 'chat' || name === 'phone' || name === 'externalChat') {
      if (waitTime < 1) {
        return t('livehelp.waiting_time_less_than_minute_text');
      }

      if (waitTime === 1) {
        return t('livehelp.waiting_time_minute_text', {
          minutes: waitTime
        });
      }

      if (waitTime < 60) {
        return t('livehelp.waiting_time_minutes_text', {
          minutes: waitTime
        });
      }

      if (waitTime < 120) {
        return t('livehelp.waiting_time_hours_text', {
          hours: '1-2'
        });
      }

      return t('livehelp.waiting_time_more_than_hours_text', {
        hours: '2'
      });
    }

    return getWaitTimeDescriptionForCase(waitTime);
  };

  var getIcon = function getIcon() {
    if (name === 'chat' || name === 'externalChat') {
      return /*#__PURE__*/React.createElement(IconLiveHelp, {
        size: IconSize.Medium
      });
    }

    if (name === 'phone') {
      return /*#__PURE__*/React.createElement(IconPhone, {
        size: IconSize.Medium
      });
    }

    return /*#__PURE__*/React.createElement(IconCopy, {
      size: IconSize.Medium
    });
  };

  var getMainText = function getMainText() {
    if (name === 'chat' || name === 'externalChat') {
      return t('livehelp.chat_with_HR');
    }

    if (name === 'phone') {
      return t('livehelp.call_HR');
    }

    return t('livehelp.create_hr_request');
  };

  var getChannel = function getChannel() {
    if (name === 'chat') {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        tabIndex: channelIsDisabled ? -1 : 0,
        className: 'contact-channel contact-channel-button' + (channelIsDisabled ? ' contact-channel-locked' : ''),
        onClick: handleOnClick,
        disabled: channelIsDisabled,
        "data-isanimationdisabled": channelIsDisabled
      }, channel), /*#__PURE__*/React.createElement(ChatOpenErrorModal, {
        isOpen: isChatOpenErrorModalOpen,
        onClose: function onClose() {
          return setIsChatOpenErrorModalOpen(false);
        }
      }));
    }

    if (name === 'phone' || name === 'externalChat') {
      return /*#__PURE__*/React.createElement("button", {
        tabIndex: channelIsDisabled ? -1 : 0,
        className: 'contact-channel contact-channel-button' + (channelIsDisabled ? ' contact-channel-locked' : ''),
        onClick: handleOnClick,
        disabled: channelIsDisabled,
        "data-isanimationdisabled": channelIsDisabled
      }, channel);
    }

    return /*#__PURE__*/React.createElement("a", {
      tabIndex: channelIsDisabled || isChannelLocked ? -1 : 0,
      className: 'contact-channel contact-channel-link' + (channelIsDisabled || isChannelLocked ? ' contact-channel-locked' : ''),
      onClick: handleOnClick,
      onKeyUp: handleKeyUp,
      "aria-disabled": channelIsDisabled || isChannelLocked,
      "data-isanimationdisabled": channelIsDisabled || isChannelLocked,
      role: "link"
    }, channel);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var ENTER_KEY_CODE = 13;

    if (event.keyCode === ENTER_KEY_CODE) {
      handleOnClick();
    }
  };

  var handleOnClick = function handleOnClick() {
    var operationName = name + 'Channel';
    recordCountMetric(PAGE_NAME, operationName, MetricEvents.CLICKS_COUNT);
    var isLiveHelpInlineActive = liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.isGetHelpActive;

    if (isLiveHelpInlineActive) {
      if (name === 'chat') {
        if (chatState.isActive) {
          setIsChatOpenErrorModalOpen(true);
          return;
        }

        liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.setLiveHelpServiceState({
          activeChannel: LiveHelpChannel.CHAT,
          inlineChannelTitle: getMainText()
        });
        liveHelpInlineContext.closeModal();
      } else {
        var currentActiveChannel = LiveHelpChannel.NONE;

        if (name === 'phone') {
          currentActiveChannel = LiveHelpChannel.CALL;
        }

        if (name === 'ticket') {
          currentActiveChannel = LiveHelpChannel.REQUEST;
        }

        liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.setLiveHelpServiceState({
          activeChannel: currentActiveChannel,
          inlineChannelTitle: getMainText()
        });
      }
    }

    if (!channelIsDisabled) {
      if (name === 'chat') {
        var _props$state$chatAttr10, _props$state$channels;

        WebAnalytics.sendOmnitureMetric({
          pageName: getPageNameForOmnitureMetrics(),
          pageAction: PageActionsForOmnitureMetrics.LIVE_CHAT_CLICK,
          hitType: OmnitureHelper.HitTypes.Action
        });

        if (chatState.isActive) {
          setIsChatOpenErrorModalOpen(true);
          return;
        }

        setChatState(Object.assign({}, defaultChatState, {
          isLiveHelpInlineSource: isLiveHelpInlineActive,
          isActive: true,
          chatRecordingBehavior: (_props$state$chatAttr10 = props.state.chatAttributes.chatRecordingBehavior) !== null && _props$state$chatAttr10 !== void 0 ? _props$state$chatAttr10 : ChatRecordingBehavior.Decline,
          chatTokens: null,
          instanceId: props.state.chatAttributes.chatContactChannel.instanceId,
          region: props.state.chatAttributes.chatContactChannel.region,
          cti: props.state.cti,
          employeeAttributes: props.state.employeeAttributes,
          contactFlowId: props.state.chatAttributes.chatContactChannel.contactFlowId,
          queueId: props.state.chatAttributes.chatContactChannel.queueId,
          idlenessDisconnectTimeOutInMinutes: props.state.chatAttributes.chatContactChannel.idlenessDisconnectTimeOutInMinutes,
          userContext: props.state.userContext,
          showWaitTime: !((_props$state$channels = props.state.channelsHideWaitTime) !== null && _props$state$channels !== void 0 && _props$state$channels.isChatWaitTimeHidden),
          waitTime: props.state.chatAttributes.waitTimeInMinutes,
          businessLine: props.state.chatAttributes.chatContactChannel.businessLine,
          currentLanguage: props.state.preferredLanguage,
          timeStampForLiveHelpClick: props.state.timeStampForLiveHelpClick,
          timeStampForChatClick: Date.now(),
          connectAWSAccount: props.state.chatAttributes.connectAWSAccount,
          receivedProps: props.state.passedProps,
          liveHelpClickSource: props.state.clickSource,
          clientId: props.clientId
        }));
        setChatSession(Object.assign({}, defaultChatSession, {
          connectionStatus: ChatSessionConnectionStatus.DescribeIssue
        }));
      } else if (name === 'externalChat') {
        if (props.state.externalChatAttributes.externalChatType === ExternalChatType.WPO) {
          props.setState({
            viewWPOContainer: true
          });
        }
      } else if (name === 'phone') {
        WebAnalytics.sendOmnitureMetric({
          pageName: getPageNameForOmnitureMetrics(),
          pageAction: PageActionsForOmnitureMetrics.CALL_CLICK,
          hitType: OmnitureHelper.HitTypes.Action
        });
        props.setState({
          viewContactCard: true
        });
      } else if (!isChannelLocked && props.state.caseAvailable) {
        if (props.state.caseAttributes.caseContactChannel.caseContactAttributes.caseSystemType === ICaseSystemType.EXTERNAL) {
          window.open(props.state.caseAttributes.caseContactChannel.caseContactAttributes.externalUrl);
        }

        if (props.state.caseAttributes.caseContactChannel.caseContactAttributes.caseSystemType === ICaseSystemType.INTERNAL) {
          props.setState({
            redirectToCaseCreation: true
          });
        }

        WebAnalytics.sendOmnitureMetric({
          pageName: getPageNameForOmnitureMetrics(),
          pageAction: PageActionsForOmnitureMetrics.CASE_CLICK,
          hitType: OmnitureHelper.HitTypes.Action
        });

        if (typeof props.state.userContext === 'string') {
          var userContext = props.state.userContext;
          var intentDisambiguted = userContext.split('_');
          var intent = {
            C: intentDisambiguted[0],
            T: intentDisambiguted[1],
            I: intentDisambiguted[2]
          };
          logContactVolumeMetric({
            sourceIntent: intent,
            helpChannel: HelpChannel.CASE,
            clickSource: props.state.clickSource,
            typeOfMRI: props.state.passedProps.typeOfMRI,
            variation: props.state.passedProps.variation,
            clientId: props.clientId
          })["catch"]();
        }
      }
    }
  };

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  setIsChannelLocked();
  setIsDisabled();
  setWaitTime();
  var channel = /*#__PURE__*/React.createElement(Container, {
    paddingBottom: 8,
    paddingTop: 8,
    className: "contact-channel-container"
  }, /*#__PURE__*/React.createElement(View$1, {
    className: "contact-channel-row-mobile"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "contact-channel--icon"
  }, getIcon()), /*#__PURE__*/React.createElement(Container, {
    className: "contact-channel-text-container contact-channel-col-mobile"
  }, /*#__PURE__*/React.createElement(View$1, {
    className: "contact-channel-main-text-container"
  }, /*#__PURE__*/React.createElement(Text$1, {
    className: "contact-channel-main-text",
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    fontWeight: "medium",
    color: "#232F3E"
  }, getMainText()), name === 'ticket' && props.state.caseAvailable && !channelIsDisabled && !isChannelLocked && /*#__PURE__*/React.createElement(View$1, {
    className: "contact-channel-icon-and-text-container"
  }, props.state.caseAttributes.caseContactChannel.caseContactAttributes.caseSystemType === ICaseSystemType.EXTERNAL && /*#__PURE__*/React.createElement(View$1, {
    className: "contact-channel-external-link-icon"
  }, /*#__PURE__*/React.createElement(IconExternalLink, {
    size: IconSize.ExtraSmall,
    title: "Opens in a new window"
  })), !isCurrentLanguageEnglish(props.state.preferredLanguage) && isRequiredCountry((_props$state$employee = props.state.employeeAttributes) === null || _props$state$employee === void 0 ? void 0 : _props$state$employee.country) && isRequiredCTI(props.state.userContext) && /*#__PURE__*/React.createElement(Text$1, {
    className: "english-language-only-text"
  }, /*#__PURE__*/React.createElement("i", null, "(", t('livehelp.english_language_only_text'), ")")))), /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    display: shouldHideWaitTime || name === 'chat' && chatState.agentConnected ? 'none' : 'block',
    className: "contact-channel-subtext"
  }, getWaitTimeString(), ": ", getWaitTimeDescriptionString(), ' '), name === 'chat' && /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    display: chatState.agentConnected && chatState.idlenessReminder === IdlenessReminder.Warning ? 'block' : 'none',
    className: "contact-channel-subtext"
  }, "Disconnect in: ", /*#__PURE__*/React.createElement("b", null, chatState.idlenessBannerTimeInMinutes), ' minutes.'), /*#__PURE__*/React.createElement(Text$1, {
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP,
    display: channelIsDisabled ? 'block' : 'none',
    className: "contact-channel-next-hours-operation-time"
  }, getDisabledChannelSubText())), name === 'chat' && chatState.agentConnected && /*#__PURE__*/React.createElement(Container, {
    className: "contact-channel-col-mobile contact-channel-tag-container"
  }, /*#__PURE__*/React.createElement(Tag, {
    className: "chat-active-tag",
    backgroundColor: "green05"
  }, "Active")), /*#__PURE__*/React.createElement(Row, {
    justifyContent: "flex-end",
    alignItems: "center",
    margin: {
      right: '20px'
    }
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    size: IconSize.Medium,
    color: "primary70"
  }))), name === 'ticket' && /*#__PURE__*/React.createElement(Row, {
    className: "contact-channel-padlock-row",
    display: isChannelLocked ? 'flex' : 'none'
  }, /*#__PURE__*/React.createElement(IconPadlock, {
    color: "grey",
    size: IconSize.ExtraSmall
  }), /*#__PURE__*/React.createElement(Text$1, {
    className: "contact-channel-padlock-text",
    fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
  }, t('livehelp.external_disable_message'))));
  return getChannel();
};

var css_248z$j = ".contact-container-row{list-style:none;padding-left:0!important;padding-top:5px!important}.contact-container-row-desktop{list-style:none;padding:5px 0!important}.contact-container-row-desktop-inline{max-width:550px!important}.contact-container-col-mobile{margin-bottom:5px!important}.contact-container-desktop{padding-top:42px!important}.contact-container-text-desktop{margin-bottom:8px!important;margin-right:16px!important}.contact-container-text-mobile-heading{color:#161e2d;font-weight:500!important;line-height:22px!important;margin:0!important}.contact-container-text-desktop-heading{color:#161e2d!important;font-weight:500!important;line-height:28px!important}.contact-container-heading{color:#161e2d!important;font-weight:700!important;line-height:36px!important}.contact-container-heading-mobile{color:#161e2d!important;font-weight:500!important;line-height:32px!important;margin:0 0 8px!important}.contact-container-heading:focus-visible{outline:none!important}.language-support-text{font-size:14px!important}";
styleInject(css_248z$j);

var channelPriorityComparator = function channelPriorityComparator(channel1, channel2) {
  return channel1.channelPriority - channel2.channelPriority;
};
/**
 * Returns whether to hide the channels need to be hidden based on GetContactChannel API response.
 *
 * @param getContactChannelResponse LiveHelp GetContactChannel API response
 */

var getShouldHideChannels = function getShouldHideChannels(getContactChannelResponse) {
  var _getContactChannelRes = getContactChannelResponse.clientConfig,
      isChatHidden = _getContactChannelRes.isChatHidden,
      isCallHidden = _getContactChannelRes.isCallHidden,
      isCaseHidden = _getContactChannelRes.isCaseHidden;
  return {
    voice: isCallHidden,
    chat: isChatHidden,
    "case": isCaseHidden || isComponentInline()
  };
};
/**
 * Returns whether the wait time is to be shown for channels based on GetContactChannel API response.
 *
 * @param getContactChannelResponse LiveHelp GetContactChannel API response
 */

var getShouldHideChannelsWaitTime = function getShouldHideChannelsWaitTime(getContactChannelResponse) {
  var chatAttributes = getContactChannelResponse.chatAttributes,
      voiceAttributes = getContactChannelResponse.voiceAttributes,
      caseAttributes = getContactChannelResponse.caseAttributes;
  var isChatChannelDisabled = Boolean(!chatAttributes.isAvailable && chatAttributes.nextOperableQueueHours);
  var isVoiceChannelDisabled = Boolean(!voiceAttributes.isAvailable && voiceAttributes.nextOperableQueueHours);
  return {
    isChatWaitTimeHidden: !chatAttributes.showWaitTime || isChatChannelDisabled,
    isVoiceWaitTimeHidden: !voiceAttributes.showWaitTime || isVoiceChannelDisabled,
    isCaseWaitTimeHidden: !caseAttributes.showWaitTime
  };
};
/**
 * Returns list of active and inactive channels to be shown based on GetContactChannel API response.
 *
 * @param getContactChannelResponse LiveHelp GetContactChannel API response
 */

var getChannelListFromGetContactChannelResponse = function getChannelListFromGetContactChannelResponse(getContactChannelResponse) {
  var _voiceAttributes$chan, _chatAttributes$chann, _caseAttributes$chann;

  var shouldHideChannels = getShouldHideChannels(getContactChannelResponse);

  var _getShouldHideChannel = getShouldHideChannelsWaitTime(getContactChannelResponse),
      isChatWaitTimeHidden = _getShouldHideChannel.isChatWaitTimeHidden,
      isCaseWaitTimeHidden = _getShouldHideChannel.isCaseWaitTimeHidden,
      isVoiceWaitTimeHidden = _getShouldHideChannel.isVoiceWaitTimeHidden;

  var chatAttributes = getContactChannelResponse.chatAttributes,
      voiceAttributes = getContactChannelResponse.voiceAttributes,
      caseAttributes = getContactChannelResponse.caseAttributes,
      externalChatAttributes = getContactChannelResponse.externalChatAttributes;
  var voiceChannelDetails = {
    attributes: voiceAttributes,
    channelPriority: (_voiceAttributes$chan = voiceAttributes.channelPriority) !== null && _voiceAttributes$chan !== void 0 ? _voiceAttributes$chan : DEFAULT_LIVEHELP_CHANNEL_PRIORITY,
    name: 'phone',
    availability: !shouldHideChannels.voice,
    hideWaitTime: isVoiceWaitTimeHidden
  };
  var chatChannelDetails = {
    attributes: chatAttributes,
    channelPriority: (_chatAttributes$chann = chatAttributes.channelPriority) !== null && _chatAttributes$chann !== void 0 ? _chatAttributes$chann : DEFAULT_LIVEHELP_CHANNEL_PRIORITY,
    name: 'chat',
    availability: !shouldHideChannels.chat,
    hideWaitTime: isChatWaitTimeHidden
  };
  var caseChannelDetails = {
    attributes: caseAttributes,
    channelPriority: (_caseAttributes$chann = caseAttributes.channelPriority) !== null && _caseAttributes$chann !== void 0 ? _caseAttributes$chann : DEFAULT_LIVEHELP_CHANNEL_PRIORITY,
    name: 'ticket',
    availability: !shouldHideChannels["case"],
    hideWaitTime: isCaseWaitTimeHidden
  };
  var externalChatChannelDetails = {
    attributes: externalChatAttributes,
    channelPriority: DEFAULT_LIVEHELP_CHANNEL_PRIORITY,
    name: 'externalChat',
    availability: externalChatAttributes ? externalChatAttributes.isAvailable : false,
    hideWaitTime: !((externalChatAttributes === null || externalChatAttributes === void 0 ? void 0 : externalChatAttributes.channelDisplayState) === ChannelDisplayState.ACTIVE)
  };
  var livehelpChannels = [chatChannelDetails, voiceChannelDetails, caseChannelDetails, externalChatChannelDetails];
  var sortedLivehelpChannels = livehelpChannels.sort(channelPriorityComparator);
  var activeLivehelpChannels = sortedLivehelpChannels.filter(function (channel) {
    return channel.attributes.channelDisplayState === ChannelDisplayState.ACTIVE && channel.availability;
  });
  var inactiveLivehelpChannels = sortedLivehelpChannels.filter(function (channel) {
    return (channel.attributes.channelDisplayState === ChannelDisplayState.LOCKED || channel.attributes.channelDisplayState === ChannelDisplayState.DISABLED || channel.attributes.channelDisplayState === ChannelDisplayState.DISABLED_NO_AGENTS || channel.attributes.channelDisplayState === ChannelDisplayState.DISABLED_HIGH_WAIT_TIME) && channel.availability;
  });
  return {
    sortedLivehelpChannels: sortedLivehelpChannels,
    activeLivehelpChannels: activeLivehelpChannels,
    inactiveLivehelpChannels: inactiveLivehelpChannels
  };
};

/**
 * Defines the ssa flow received from Routing Engine.
 * WORKFLOW marks redirection to a workflow for self service
 * URL marks redirection to single page SSA for self service
 */
var ISelfServiceTypeFromRE;

(function (ISelfServiceTypeFromRE) {
  ISelfServiceTypeFromRE["WORKFLOW"] = "WORKFLOW";
  ISelfServiceTypeFromRE["URL"] = "URL";
})(ISelfServiceTypeFromRE || (ISelfServiceTypeFromRE = {}));
/**
 * Defines the ssa type.
 * WORKFLOW means self service is on Khonsu workflow
 * INTERNAL_URL_BASED means self service page is in MyHR domain
 * EXTERNAL_URL_BASED means self service page is not in MyHR domain
 * NOT_DEFINED means self service is not defined
 */


var SelfServiceType;

(function (SelfServiceType) {
  SelfServiceType[SelfServiceType["WORKFLOW"] = 0] = "WORKFLOW";
  SelfServiceType[SelfServiceType["INTERNAL_URL_BASED"] = 1] = "INTERNAL_URL_BASED";
  SelfServiceType[SelfServiceType["EXTERNAL_URL_BASED"] = 2] = "EXTERNAL_URL_BASED";
  SelfServiceType[SelfServiceType["NOT_DEFINED"] = 3] = "NOT_DEFINED";
})(SelfServiceType || (SelfServiceType = {}));

var isMyHrPath = function isMyHrPath(url) {
  if (url.startsWith('/myhr')) {
    return true;
  }

  return false;
};
var createURLWithParameters = function createURLWithParameters(_ref) {
  var url = _ref.url,
      urlSearchParametersMap = _ref.urlSearchParametersMap;
  var urlParameters = new URLSearchParams();
  var paramsPresent = false;
  urlSearchParametersMap === null || urlSearchParametersMap === void 0 ? void 0 : urlSearchParametersMap.forEach(function (value, key) {
    if (value) {
      urlParameters.set(key, value);
      paramsPresent = true;
    }
  });
  return paramsPresent ? url + "?" + urlParameters.toString() : url;
};
var redirectToUrl = function redirectToUrl(redirectUrlParams, shouldPushOnHistoryStack) {
  shouldPushOnHistoryStack ? window.location.assign(redirectUrlParams.url) : window.location.replace(redirectUrlParams.url);
};

var dynamicValueOfMyHR = '/' + /*#__PURE__*/location.pathname.split('/')[1];
var workflowUrl = dynamicValueOfMyHR + '/workflow';
var WorkflowRedirection = function WorkflowRedirection(_ref) {
  var workflowId = _ref.workflowId,
      crumbs = _ref.crumbs,
      presentationDetails = _ref.presentationDetails,
      crumbTitle = _ref.crumbTitle,
      category = _ref.category,
      type = _ref.type,
      item = _ref.item,
      businessOwner = _ref.businessOwner,
      countryCode = _ref.countryCode,
      recordTypeId = _ref.recordTypeId,
      _ref$shouldPushOnHist = _ref.shouldPushOnHistoryStack,
      shouldPushOnHistoryStack = _ref$shouldPushOnHist === void 0 ? true : _ref$shouldPushOnHist,
      clickSource = _ref.clickSource,
      _ref$clientId = _ref.clientId,
      clientId = _ref$clientId === void 0 ? LaasClientId.MY_HR : _ref$clientId;
  var crumb = {
    title: crumbTitle,
    url: workflowUrl
  };
  var crumbsToPass = [].concat(crumbs, [crumb]);
  var queryAttributes = {
    clickSource: {
      type: 'string',
      value: clickSource || 'Browse'
    }
  };
  return /*#__PURE__*/React.createElement(Redirect, {
    push: shouldPushOnHistoryStack,
    to: {
      pathname: workflowUrl,
      state: {
        propsToPass: {
          selectedIntent: {
            intentDetails: {
              category: category,
              type: type,
              item: item
            },
            onClickAction: {
              value: workflowId
            }
          },
          businessOwner: businessOwner,
          countryCode: countryCode,
          recordTypeId: recordTypeId,
          crumbs: crumbsToPass,
          presentationDetails: presentationDetails,
          queryAttributes: queryAttributes,
          clientId: clientId
        }
      }
    }
  });
};

var getSelfServiceType = function getSelfServiceType(selfServiceAttributes) {
  var _selfServiceChannel$a;

  var selfServiceChannel = selfServiceAttributes.selfServiceChannel;

  if (selfServiceChannel.selfServiceType === ISelfServiceTypeFromRE.WORKFLOW) {
    return SelfServiceType.WORKFLOW;
  }

  var ssaUrl = (_selfServiceChannel$a = selfServiceChannel.additionalAttributes) === null || _selfServiceChannel$a === void 0 ? void 0 : _selfServiceChannel$a.url;

  if (ssaUrl === undefined) {
    return SelfServiceType.NOT_DEFINED;
  }

  if (isMyHrPath(ssaUrl)) {
    return SelfServiceType.INTERNAL_URL_BASED;
  }

  return SelfServiceType.EXTERNAL_URL_BASED;
};

var SelfServiceRedirection = function SelfServiceRedirection(props) {
  var selfServiceAttributes = props.selfServiceAttributes;
  var selfServiceType = getSelfServiceType(selfServiceAttributes); // we are deciding whether to push on history stack on the basis of selfServiceContentId being available
  // if selfServiceContentId is available, the SelfServiceContentComponent is shown to the user along with the "Get started" button
  // in which case we need to push on history, to let the user come back to the same page if back is pressed

  var shouldPushOnHistoryStack = selfServiceAttributes.selfServiceChannel.selfServiceContentId ? true : false;
  useEffect(function () {
    if (selfServiceType === SelfServiceType.NOT_DEFINED) {
      var redirectionUrlParams = {
        url: props.fallbackErrorPageUrl
      };
      redirectToUrl(redirectionUrlParams);
    } else {
      logSelfServiceEmployeeActivity({
        userIntent: props.intent,
        selfServiceStartTime: new Date()
      });
    }
  }, []);

  if (selfServiceType === SelfServiceType.WORKFLOW) {
    var _props$selfServiceAtt, _props$selfServiceAtt2, _props$selfServiceAtt3;

    return /*#__PURE__*/React.createElement(WorkflowRedirection, {
      workflowId: (_props$selfServiceAtt = props.selfServiceAttributes.selfServiceChannel.additionalAttributes) === null || _props$selfServiceAtt === void 0 ? void 0 : _props$selfServiceAtt.workflowId,
      recordTypeId: (_props$selfServiceAtt2 = props.selfServiceAttributes.selfServiceChannel.additionalAttributes) === null || _props$selfServiceAtt2 === void 0 ? void 0 : _props$selfServiceAtt2.recordTypeId,
      businessOwner: (_props$selfServiceAtt3 = props.selfServiceAttributes.selfServiceChannel.additionalAttributes) === null || _props$selfServiceAtt3 === void 0 ? void 0 : _props$selfServiceAtt3.businessOwner,
      presentationDetails: props.presentationDetails,
      crumbs: props.crumbs,
      crumbTitle: "" + i18.getInstance().t('livehelp.create_request'),
      category: props.category,
      type: props.type,
      item: props.item,
      shouldPushOnHistoryStack: shouldPushOnHistoryStack,
      clickSource: props.clickSource,
      clientId: LaasClientId$1.MY_HR
    });
  }

  if (selfServiceType === SelfServiceType.INTERNAL_URL_BASED) {
    var _props$selfServiceAtt4, _props$clientId;

    var urlSearchParameters = {
      url: '',
      urlSearchParametersMap: new Map([[URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID, LaasClientId$1.MY_HR]])
    };
    var urlSearchParametersString = createURLWithParameters(urlSearchParameters);
    return /*#__PURE__*/React.createElement(Redirect, {
      push: shouldPushOnHistoryStack,
      to: {
        pathname: (_props$selfServiceAtt4 = props.selfServiceAttributes.selfServiceChannel.additionalAttributes) === null || _props$selfServiceAtt4 === void 0 ? void 0 : _props$selfServiceAtt4.url,
        search: urlSearchParametersString,
        state: {
          propsToPass: {
            employeeAttributes: props.employeeAttributes,
            preferredLanguage: props.preferredLanguage,
            category: props.category,
            type: props.type,
            item: props.item,
            crumbs: props.crumbs,
            liveHelpProps: props.liveHelpProps,
            clientId: (_props$clientId = props.clientId) !== null && _props$clientId !== void 0 ? _props$clientId : LaasClientId$1.MY_HR
          }
        }
      }
    });
  }

  if (selfServiceType === SelfServiceType.EXTERNAL_URL_BASED) {
    var _props$selfServiceAtt5;

    // TODO: Add clientId in URL parameters. Not adding now to not show 'Get Help' Button in time app
    var redirectionUrlParams = {
      url: (_props$selfServiceAtt5 = props.selfServiceAttributes.selfServiceChannel.additionalAttributes) === null || _props$selfServiceAtt5 === void 0 ? void 0 : _props$selfServiceAtt5.url
    };
    redirectToUrl(redirectionUrlParams, shouldPushOnHistoryStack);
  }

  return null;
};

var getSelfServiceContent = function getSelfServiceContent(translationId, locale) {
  try {
    var PAGE_NAME = 'SelfServiceContent';
    var OPERATION_NAME = 'GetSelfServiceContentFromTAS';
    var userIdentifier = getUserIdentifier();
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: userIdentifier,
      pageName: PAGE_NAME,
      operationName: OPERATION_NAME
    };
    return Promise.resolve(_catch(function () {
      return Promise.resolve(getTranslatedContentFromTAS(translationId, locale)).then(function (tasResponse) {
        myHRLoggerInfoLog("[" + userIdentifier + "]: TAS Response on " + PAGE_NAME + " for self service content is: " + JSON.stringify(tasResponse), logsContext);

        var _JSON$parse = JSON.parse(tasResponse.data.response),
            translation = _JSON$parse.translation;

        myHRLoggerInfoLog("[" + userIdentifier + "]: Self service content on " + PAGE_NAME + " is: " + translation, logsContext);
        return translation;
      });
    }, function (error) {
      recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(error));
      myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while fetching self service content on " + PAGE_NAME + ". " + getDetailedErrorMessage(error), logsContext);
      throw error;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$1;
var SelfServiceComponentView = /*#__PURE__*/styledWithTheme(View$1)(function (_ref) {
  var isMobile = _ref.isMobile;
  return {
    marginTop: (isMobile ? 20 : 24) + "px",
    marginBottom: '32px !important',
    '&:last-child': {
      marginBottom: '16px !important'
    }
  };
});
var SelfServiceButton = /*#__PURE__*/styledWithTheme(Button)(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: 16px 0 0 0 !important;\n  font-weight: 500;\n  line-height: 24px !important;\n"])));
var SELF_SERVICE_OPERATION_NAME = 'SelfServiceRedirection';
var SelfServiceContentComponent = function SelfServiceContentComponent(_ref2) {
  var category = _ref2.category,
      clickSource = _ref2.clickSource,
      crumbs = _ref2.crumbs,
      employeeAttributes = _ref2.employeeAttributes,
      fallbackErrorPageUrl = _ref2.fallbackErrorPageUrl,
      intent = _ref2.intent,
      item = _ref2.item,
      liveHelpProps = _ref2.liveHelpProps,
      preferredLanguage = _ref2.preferredLanguage,
      presentationDetails = _ref2.presentationDetails,
      selfServiceAttributes = _ref2.selfServiceAttributes,
      type = _ref2.type,
      userContext = _ref2.userContext,
      _ref2$pageName = _ref2.pageName,
      pageName = _ref2$pageName === void 0 ? PageName.CONTACT_CHANNEL : _ref2$pageName,
      _ref2$clientId = _ref2.clientId,
      clientId = _ref2$clientId === void 0 ? LaasClientId.MY_HR : _ref2$clientId;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var _useTranslation = useTranslation(undefined, {
    i18n: i18.getInstance()
  }),
      t = _useTranslation.t;

  var isMobile = matches.s || matches.m;

  var _useState = useState(null),
      selfServiceContent = _useState[0],
      setSelfServiceContent = _useState[1];

  var _useState2 = useState(false),
      redirectToSelfService = _useState2[0],
      setRedirectToSelfService = _useState2[1];

  var _useState3 = useState(false),
      showSelfServiceErrorBanner = _useState3[0],
      setShowSelfServiceErrorBanner = _useState3[1];

  var DEFAULT_OPERATION_NAME = 'SSAOperations';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: pageName,
    operationName: DEFAULT_OPERATION_NAME
  };
  useEffect(function () {
    if (selfServiceAttributes.selfServiceChannel.selfServiceContentId) {
      getSelfServiceContent(selfServiceAttributes.selfServiceChannel.selfServiceContentId, preferredLanguage).then(function (selfServiceContent) {
        setSelfServiceContent(selfServiceContent);
      })["catch"](function () {
        setShowSelfServiceErrorBanner(true);
      });
    }
  }, [selfServiceAttributes.selfServiceChannel.selfServiceContentId]);
  useEffect(function () {
    emitSSADisplayedMetric(pageName);
  }, []);

  var onClickGetStartedButton = function onClickGetStartedButton() {
    // Setting current session as MyHR session, when user clicks on Get Started button
    sessionStorage.setItem(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID, LaasClientId.MY_HR);
    localStorage.setItem(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID, getMyHRClientIdWithTtl());
    setRedirectToSelfService(function (prevRedirectToSelfService) {
      if (!prevRedirectToSelfService) {
        // publish SSA click and redirection metrics while changing 'redirectToSelfService' state to true.
        // This is to make sure that metrics are published only once.
        emitSSARedirectionMetrics();
      }

      return true;
    });
  };

  var emitSSARedirectionMetrics = function emitSSARedirectionMetrics() {
    // recording few metrics and logs on redirection to self service on "Get started" click
    recordCountMetric(pageName, SELF_SERVICE_OPERATION_NAME, MetricEvents.COUNT);
    logContactVolumeMetric({
      sourceIntent: intent,
      helpChannel: HelpChannel.SSA,
      clickSource: clickSource,
      clientId: clientId
    }).then(function () {
      return console.log('logged metric after clicking SSA Get Started button');
    })["catch"](function (error) {
      myHRLoggerErrorLog("[" + getUserIdentifier() + "]: Unable to publish business volume metric from SSA. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
        operationName: CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC
      }));
      recordErrorCountMetric(HelpChannel.SSA, CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC, JSON.stringify(error));
    });
    myHRLoggerInfoLog("[" + getUserIdentifier() + "]: User redirected to self service via " + pageName);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, selfServiceAttributes.isAvailable && selfServiceAttributes.selfServiceChannel.selfServiceContentId && /*#__PURE__*/React.createElement(SelfServiceComponentView, {
    isMobile: isMobile
  }, showSelfServiceErrorBanner && /*#__PURE__*/React.createElement(MessageBanner, {
    type: MessageBannerType.Error,
    isDismissible: false
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: FontSize.TEXT_MOBILE,
    color: "#232F3E"
  }, /*#__PURE__*/React.createElement("b", null, " ", t('livehelp.loading_error_text'), " "), t('livehelp.self_service_content_error'))), selfServiceContent && /*#__PURE__*/React.createElement("div", {
    className: "content-div",
    dangerouslySetInnerHTML: {
      __html: selfServiceContent
    }
  }), (showSelfServiceErrorBanner || selfServiceContent) && /*#__PURE__*/React.createElement(SelfServiceButton, {
    icon: /*#__PURE__*/React.createElement(IconChevronRight, {
      "aria-hidden": true
    }),
    iconPosition: ButtonIconPosition.Trailing,
    variant: ButtonVariant.Primary,
    onClick: onClickGetStartedButton,
    style: {
      fontSize: FontSize.TEXT_MOBILE
    }
  }, t('livehelp.get_started'))), redirectToSelfService && /*#__PURE__*/React.createElement(SelfServiceRedirection, {
    fallbackErrorPageUrl: fallbackErrorPageUrl,
    selfServiceAttributes: selfServiceAttributes,
    crumbs: crumbs,
    presentationDetails: presentationDetails,
    category: category,
    type: type,
    item: item,
    employeeAttributes: employeeAttributes,
    userContext: userContext,
    preferredLanguage: preferredLanguage,
    liveHelpProps: liveHelpProps,
    intent: intent,
    clickSource: clickSource,
    clientId: clientId
  }));
};

var REDIRECT_TO_MYHR_OPERATION_NAME = 'RedirectToMyHR';
var PAGE_NAME$1 = PageName.CONTACT_CHANNEL;
var REDIRECT_TO_LIVEHELP = 'RedirectToLivehelp';
var REDIRECT_TO_TYPE_INTENT_SELECTION = 'RedirectToTypeIntentSelection';
var REDIRECT_TO_ITEM_INTENT_SELECTION = 'RedirectToItemIntentSelection';

var getLogContext = function getLogContext() {
  return {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    pageName: PAGE_NAME$1
  };
};
/**
 * Encode URL parameter of category and type while forming landing page URLs. Coverts to lower case `_` separated string.
 * @param parameter URL parameter
 */


var encodeUrlParameter = function encodeUrlParameter(parameter) {
  return parameter.toLowerCase().split(' ').join('_');
};
/**
 * Redirects the user to livehelp landing page using query params.
 * @param intent context for showing live help channels
 * @param sourcePage pageName where livehelp journey was initiated
 * @param clientId unique id of the client
 */

var redirectToLivehelp = function redirectToLivehelp(intent, sourcePage, clientId) {
  var urlSearchParametersMap = new Map([[URL_SEARCH_PARAMETER_KEY_CONSTANTS.CATEGORY, intent.category], [URL_SEARCH_PARAMETER_KEY_CONSTANTS.TYPE, intent.type], [URL_SEARCH_PARAMETER_KEY_CONSTANTS.ITEM, intent.item], [URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE, sourcePage], [URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID, clientId]]);
  var redirectionUrlParams = {
    url: '/myhr/livehelp/landing',
    urlSearchParametersMap: urlSearchParametersMap
  };
  var path = createURLWithParameters(redirectionUrlParams);
  recordCountMetric(sourcePage, REDIRECT_TO_LIVEHELP, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "]: Redirecting to livehelp with path " + path, Object.assign({}, getLogContext(), {
    operationName: REDIRECT_TO_LIVEHELP,
    sourcePage: sourcePage,
    clientId: clientId
  }));
  window.location.assign(path);
};
/**
 * Redirects the to item intent selection page.
 * @param intent context for showing live help channels
 * @param sourcePage pageName where livehelp journey was initiated
 * @param clientId unique id of the client
 */

var redirectToItemSelectionPage = function redirectToItemSelectionPage(intent, sourcePage, clientId) {
  var _URLSearchParams;

  if (!intent.category || !intent.type) {
    return;
  }

  var redirectionQueryParams = new URLSearchParams((_URLSearchParams = {
    context: SKIP_SSA_PAGE_QUERY_PARAM
  }, _URLSearchParams[URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE] = sourcePage, _URLSearchParams[URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID] = clientId, _URLSearchParams));
  var path = "/myhr/category/" + encodeUrlParameter(intent.category) + "/type/" + encodeUrlParameter(intent.type) + "?" + redirectionQueryParams;
  recordCountMetric(sourcePage, REDIRECT_TO_ITEM_INTENT_SELECTION, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "]: Redirecting to item intent selection page with path " + path, Object.assign({}, getLogContext(), {
    operationName: REDIRECT_TO_ITEM_INTENT_SELECTION,
    sourcePage: sourcePage,
    clientId: clientId
  }));
  window.location.assign(path);
};
/**
 * Redirects the to type intent selection page.
 * @param intent context for showing live help channels
 * @param sourcePage pageName where livehelp journey was initiated
 * @param clientId unique id of the client
 */

var redirectToTypeSelectionPage = function redirectToTypeSelectionPage(intent, sourcePage, clientId) {
  var _URLSearchParams2;

  if (!intent.category) {
    return;
  }

  var redirectionQueryParams = new URLSearchParams((_URLSearchParams2 = {}, _URLSearchParams2[URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE] = sourcePage, _URLSearchParams2[URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID] = clientId, _URLSearchParams2));
  var path = "/myhr/category/" + encodeUrlParameter(intent.category) + "?" + redirectionQueryParams;
  recordCountMetric(sourcePage, REDIRECT_TO_TYPE_INTENT_SELECTION, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "]: Redirecting to type intent selection page with path " + path, Object.assign({}, getLogContext(), {
    operationName: REDIRECT_TO_TYPE_INTENT_SELECTION,
    sourcePage: sourcePage,
    clientId: clientId
  }));
  window.location.assign(path);
};
/**
 * Redirects the user to myhr intent selection page or livehelp page based on intent.
 * @param intent context for showing live help channels
 * @param sourcePage pageName where livehelp journey was initiated
 * @param clientId unique id of the client
 */

var redirectToMyHR = function redirectToMyHR(intent, sourcePage, clientId) {
  if (!intent || !intent.category) {
    // If intent is not defined, we will not redirect.
    return;
  }

  recordCountMetric(sourcePage, REDIRECT_TO_MYHR_OPERATION_NAME, MetricEvents.COUNT);
  WebAnalytics.sendOmnitureMetric({
    pageName: getPageNameForOmnitureMetrics(),
    pageAction: PageActionsForOmnitureMetrics.REDIRECT_TO_MY_HR,
    hitType: OmnitureHelper.HitTypes.Redirect
  });
  myHRLoggerInfoLog("[" + getUserIdentifier() + "]: Redirecting to MyHR with intent " + JSON.stringify(intent), Object.assign({}, getLogContext(), {
    operationName: REDIRECT_TO_MYHR_OPERATION_NAME,
    sourcePage: sourcePage,
    clientId: clientId
  }));

  if (intent.item) {
    redirectToLivehelp(intent, sourcePage, clientId);
  } else if (intent.type) {
    redirectToItemSelectionPage(intent, sourcePage, clientId);
  } else {
    redirectToTypeSelectionPage(intent, sourcePage, clientId);
  }
};

var ContactContainer = function ContactContainer(_ref) {
  var _props$state$cti, _props$state$cti2, _props$state$cti3, _props$state$external2, _props$state$employee;

  var props = _ref.props,
      intentDetails = _ref.intentDetails,
      clickSource = _ref.clickSource,
      typeOfMRI = _ref.typeOfMRI,
      variation = _ref.variation,
      chatbotContentComponent = _ref.chatbotContentComponent,
      summaryComponent = _ref.summaryComponent,
      faqComponent = _ref.faqComponent,
      selfServiceAvailable = _ref.selfServiceAvailable,
      getContactChannelResponse = _ref.getContactChannelResponse;
  var PAGE_NAME = 'ContactContainer';

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isAllChannelDisabled = _useState[0],
      setIsAllChannelDisabled = _useState[1];

  var liveHelpInlineContext = useLiveHelpInlineContext();
  var liveHelpInlineActive = liveHelpInlineContext === null || liveHelpInlineContext === void 0 ? void 0 : liveHelpInlineContext.liveHelpServiceState.isGetHelpActive;

  var _useState2 = useState(''),
      subheading = _useState2[0],
      setSubheading = _useState2[1];

  console.log(subheading);

  var _useChatContext = useChatContext(),
      chatState = _useChatContext.chatState,
      setChatState = _useChatContext.setChatState;

  var previousTitle;
  var contactHeadingRef = useRef(null);

  var publishEmployeeActivityMetric = function publishEmployeeActivityMetric() {
    if (!(intentDetails !== null && intentDetails !== void 0 && intentDetails.category)) {
      return;
    }

    var intent = {
      C: intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.category,
      T: intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.type,
      I: intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.item
    };

    try {
      logEmployeeActivityMetric({
        sourceIntent: intent,
        clickSource: clickSource,
        typeOfMRI: typeOfMRI,
        variation: variation,
        clientId: props.clientId
      });
    } catch (error) {
      myHRLoggerErrorLog("[" + props.userIdentifier + "]: Unable to publish employee activity metric from Contact. " + getDetailedErrorMessage(error), Object.assign({}, props.logsContext, {
        operationName: CommonOperations.SEND_EMPLOYEE_ACTIVITY_METRIC
      }));
      recordErrorCountMetric(PAGE_NAME, CommonOperations.SEND_EMPLOYEE_ACTIVITY_METRIC, JSON.stringify(error));
    }
  };

  useEffect(function () {
    previousTitle = document.title;
    document.title = PageTitle.LIVE_HELP;
    publishEmployeeActivityMetric();

    if (contactHeadingRef.current) {
      contactHeadingRef.current.focus();
    }

    setSubheading(getSubHeading());

    if (isComponentInline() && (activeLivehelpChannels.length > 0 || inactiveLivehelpChannels.length > 0)) {
      emitChannelsDisplayedOnInlineMetric();
    }

    return function () {
      document.title = previousTitle;
    };
  }, []);

  var getSubHeading = function getSubHeading() {
    var _props$state$chatAttr, _props$state$clientCo, _props$state$external, _props$state$voiceAtt, _props$state$clientCo2, _props$state$clientCo3;

    var availableChannelsList = [];

    if ((props.state.chatAvailable || (_props$state$chatAttr = props.state.chatAttributes) !== null && _props$state$chatAttr !== void 0 && _props$state$chatAttr.nextOperableQueueHours) && !((_props$state$clientCo = props.state.clientConfig) !== null && _props$state$clientCo !== void 0 && _props$state$clientCo.isChatHidden) || (_props$state$external = props.state.externalChatAttributes) !== null && _props$state$external !== void 0 && _props$state$external.isAvailable) {
      availableChannelsList.push(t('livehelp.subheading_chat_text'));
    }

    if ((props.state.voiceAvailable || (_props$state$voiceAtt = props.state.voiceAttributes) !== null && _props$state$voiceAtt !== void 0 && _props$state$voiceAtt.nextOperableQueueHours) && !((_props$state$clientCo2 = props.state.clientConfig) !== null && _props$state$clientCo2 !== void 0 && _props$state$clientCo2.isCallHidden)) {
      availableChannelsList.push(t('livehelp.subheading_call_text'));
    }

    if (props.state.caseAvailable && !((_props$state$clientCo3 = props.state.clientConfig) !== null && _props$state$clientCo3 !== void 0 && _props$state$clientCo3.isCaseHidden) && !liveHelpInlineActive) {
      availableChannelsList.push(t('livehelp.subheading_case_text'));
    }

    if (availableChannelsList.length === 0) {
      setIsAllChannelDisabled(true);
    }

    if (availableChannelsList.length > 0 && isComponentInline()) {
      emitActiveChannelsDisplayedOnInlineMetric(availableChannelsList);
    }

    return availableChannelsList.length === 1 ? availableChannelsList[0] : availableChannelsList.slice(0, availableChannelsList.length - 1).join(', ').concat(', ' + t('livehelp.or_connector') + ' ').concat(availableChannelsList[availableChannelsList.length - 1]);
  };

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var containerClassName = matches.s ? 'contact-container-mobile' : 'contact-container-desktop';
  var shouldShowERCErrorBanner = props.state.showNoChannelMessage || props.state.errorMessageStatus;

  var _ref2 = shouldShowERCErrorBanner ? {
    activeLivehelpChannels: [],
    inactiveLivehelpChannels: []
  } : getChannelListFromGetContactChannelResponse(getContactChannelResponse),
      activeLivehelpChannels = _ref2.activeLivehelpChannels,
      inactiveLivehelpChannels = _ref2.inactiveLivehelpChannels;

  return /*#__PURE__*/React.createElement(Container, {
    isFullWidth: true,
    className: liveHelpInlineActive ? '' : containerClassName
  }, !liveHelpInlineActive && (matches.s ? null : /*#__PURE__*/React.createElement(CustomBreadcrumbs, {
    crumbs: props.state.crumbs
  })), /*#__PURE__*/React.createElement(Col, {
    backgroundColor: "white",
    padding: "15px"
  }, !liveHelpInlineActive && /*#__PURE__*/React.createElement(View$1, {
    className: matches.s ? '' : 'contact-container-text-desktop'
  }, /*#__PURE__*/React.createElement(H1, {
    tabIndex: -1,
    ref: contactHeadingRef,
    className: matches.s ? 'contact-container-heading-mobile' : 'contact-container-heading',
    style: {
      fontSize: matches.s ? FontSize.HEADER_MOBILE : FontSize.HEADER_DESKTOP
    }
  }, props.state.livehelpPageTitle)), shouldShowERCErrorBanner && /*#__PURE__*/React.createElement(ErcErrorBanner, null), chatState.isChatMinimized && chatState.idlenessReminder === IdlenessReminder.Warning && /*#__PURE__*/React.createElement(View$1, {
    margin: {
      top: 8,
      bottom: 8
    },
    width: matches.s ? '100%' : '550px'
  }, /*#__PURE__*/React.createElement(DisconnectBanner, {
    chatState: chatState,
    setChatState: setChatState,
    idlenessBannerTimeInMinutes: chatState.idlenessBannerTimeInMinutes
  })), /*#__PURE__*/React.createElement(View$1, null, selfServiceAvailable && props.state.selfServiceAttributes.selfServiceChannel.selfServiceContentId && !liveHelpInlineActive && /*#__PURE__*/React.createElement(SelfServiceContentComponent, {
    fallbackErrorPageUrl: props.errorUrl,
    selfServiceAttributes: props.state.selfServiceAttributes,
    crumbs: props.state.crumbs,
    presentationDetails: props.state.presentationDetails,
    category: (_props$state$cti = props.state.cti) === null || _props$state$cti === void 0 ? void 0 : _props$state$cti.C,
    type: (_props$state$cti2 = props.state.cti) === null || _props$state$cti2 === void 0 ? void 0 : _props$state$cti2.T,
    item: (_props$state$cti3 = props.state.cti) === null || _props$state$cti3 === void 0 ? void 0 : _props$state$cti3.I,
    employeeAttributes: props.state.employeeAttributes,
    userContext: props.state.userContext,
    preferredLanguage: props.state.preferredLanguage,
    liveHelpProps: props.state.passedProps,
    intent: props.state.cti,
    clickSource: clickSource,
    clientId: props.clientId
  }), chatbotContentComponent, summaryComponent, faqComponent)), !isAllChannelDisabled && !liveHelpInlineActive && (faqComponent || summaryComponent || chatbotContentComponent || selfServiceAvailable) && /*#__PURE__*/React.createElement(Col, {
    backgroundColor: "white",
    padding: "15px",
    margin: "10px 0 0 0"
  }, /*#__PURE__*/React.createElement(H2, {
    tabIndex: -1,
    className: 'contact-container-text-heading ' + (matches.s ? 'contact-container-text-mobile-heading' : 'contact-container-text-desktop-heading'),
    style: {
      fontSize: matches.s ? FontSize.TEXT_MOBILE : FontSize.TEXT_DESKTOP
    }
  }, (_props$state$external2 = props.state.externalChatAttributes) !== null && _props$state$external2 !== void 0 && _props$state$external2.isAvailable ? t('livehelp.live_support_options') : t('livehelp.need_more_help'))), !isAllChannelDisabled && /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("ul", {
    className: matches.s ? 'contact-container-row' : "contact-container-row-desktop " + (liveHelpInlineActive ? 'contact-container-row-desktop-inline' : '')
  }, activeLivehelpChannels.concat(inactiveLivehelpChannels).map(function (channel, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !index && /*#__PURE__*/React.createElement(Hr, {
      style: {
        borderTop: '4px solid #f1f4f7'
      }
    }), /*#__PURE__*/React.createElement("li", {
      key: channel.name,
      className: "contact-container-col-mobile"
    }, /*#__PURE__*/React.createElement(ContactChannel, {
      channelDisplayState: channel.attributes.channelDisplayState,
      name: channel.name,
      props: props,
      shouldHideWaitTime: channel.hideWaitTime
    })), /*#__PURE__*/React.createElement(Hr, {
      style: {
        borderTop: '4px solid #f1f4f7'
      }
    }));
  })), !isCurrentLanguageEnglish(props.state.preferredLanguage) && isRequiredCountry((_props$state$employee = props.state.employeeAttributes) === null || _props$state$employee === void 0 ? void 0 : _props$state$employee.country) && isRequiredCTI(props.state.userContext) && /*#__PURE__*/React.createElement(Text$1, {
    className: "language-support-text"
  }, t('livehelp.language_support_text'))), liveHelpInlineActive && activeLivehelpChannels.length === 0 && inactiveLivehelpChannels.length !== 0 && /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(MessageBanner, null, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: FontSize.TEXT_MOBILE
  }, t('livehelp.not_able_to_get_live_help'))), /*#__PURE__*/React.createElement(Col, {
    alignItems: "center",
    gridGap: "S200",
    backgroundColor: "neutral0",
    height: "10%",
    padding: "S200"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      redirectToMyHR(intentDetails, props.state.clickSource, props.clientId);
    },
    variant: ButtonVariant.Primary
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: FontSize.TEXT_MOBILE
  }, GO_TO_MY_HR_TEXT)))));
};

var css_248z$k = ".changeRowOrientationToColumn{display:flex;flex-direction:row}.contact-faq-expander-desktop{margin-left:8px!important;margin-right:8px!important;padding-left:120px;padding-right:120px}.contact-faq-expander-mobile{padding-left:16px;padding-right:16px}.livehelp-landing-page>[tabindex]:focus{outline-color:#1768c9!important}.livehelp-landing-page{-webkit-tap-highlight-color:transparent;background-color:#f2f2f2!important}";
styleInject(css_248z$k);

var contentIdParityCheck = function contentIdParityCheck(contentFromRE, contentFromP13N, pageName, intent, logsContext) {
  var OPERATION_NAME_PARITY_MATCH = 'ContentIdParityCheck-Match';
  var OPERATION_NAME_PARITY_MISMATCH = 'ContentIdParityCheck-Mismatch';
  var OPERATION_NAME = 'ContentIdParityCheck';

  try {
    var isArrayContentSame = function isArrayContentSame(arrayA, arrayB) {
      if (arrayA.length !== arrayB.length) {
        return false;
      }

      arrayA.sort(function (a, b) {
        return a.id.localeCompare(b.id);
      });
      arrayB.sort(function (a, b) {
        return a.id.localeCompare(b.id);
      });

      for (var i = 0; i < arrayA.length; i += 1) {
        if (arrayA[i].id !== arrayB[i].id || arrayA[i].type !== arrayB[i].type) {
          return false;
        }
      }

      return true;
    };

    var isArrayInvalid = function isArrayInvalid(array) {
      if (array) {
        return array.length === 0;
      }

      return true;
    };

    var isSameContent = false;
    var isContentFromREInvalid = isArrayInvalid(contentFromRE);
    var isContentFromP13NInvalid = isArrayInvalid(contentFromP13N);

    if (!isContentFromP13NInvalid && !isContentFromREInvalid && contentFromP13N && contentFromRE) {
      isSameContent = isArrayContentSame(contentFromRE, contentFromP13N);
    } else if (isContentFromP13NInvalid && isContentFromREInvalid) {
      isSameContent = true;
    }

    if (isSameContent) {
      myHRLoggerInfoLog("\n              Content is same for intent: " + JSON.stringify(intent) + ". RE content- " + JSON.stringify(contentFromRE) + " P13N content - " + JSON.stringify(contentFromP13N) + " \n              ", Object.assign({}, logsContext, {
        operationName: OPERATION_NAME_PARITY_MATCH
      }));
      recordCountMetric(pageName, OPERATION_NAME_PARITY_MATCH, MetricEvents.SUCCESS_COUNT);
    } else {
      myHRLoggerWarnLog("\n              Content is NOT same for intent: " + JSON.stringify(intent) + ". RE content- " + JSON.stringify(contentFromRE) + " P13N content - " + JSON.stringify(contentFromP13N) + " \n              ", Object.assign({}, logsContext, {
        operationName: OPERATION_NAME_PARITY_MISMATCH
      }));
      recordCountMetric(pageName, OPERATION_NAME_PARITY_MISMATCH, MetricEvents.SUCCESS_COUNT);
    }
  } catch (error) {
    myHRLoggerWarnLog('Unable to check parity between RE and P13N Content' + error, Object.assign({}, logsContext, {
      operationName: OPERATION_NAME
    }));
    recordCountMetric(pageName, OPERATION_NAME, MetricEvents.ERROR_COUNT);
  }
};

/**
 * Interface used by MyHRLandingPage and MyHRLiveHelpServiceUI has different key names for ContentAttributes.
 * This function converts MyHRLiveHelpServiceUI compatible interface to MyHRLandingPage compatible interface.
 * No property is changed in this function.
 *
 * @param contentAttributes {@link IContentAttributes} MyHRLiveHelpServiceUI compatible ContentAttributes
 */
var buildContentAttributesForLiveHelpWrapper = function buildContentAttributesForLiveHelpWrapper(contentAttributes) {
  var _contentAttributes$co;

  return contentAttributes === null || contentAttributes === void 0 ? void 0 : (_contentAttributes$co = contentAttributes.contents) === null || _contentAttributes$co === void 0 ? void 0 : _contentAttributes$co.map(function (content) {
    return {
      cmsId: content === null || content === void 0 ? void 0 : content.cmsId,
      id: content === null || content === void 0 ? void 0 : content.contentId,
      type: content === null || content === void 0 ? void 0 : content.contentType
    };
  });
};
/**
 * Filters content attributes to only include most prioritised summary id. Prioritised content is always passed at last.
 *
 * @param contentAttributes {@link IContentAttributes} Content attributes to fetch FAQ, summary etc. from TAS / AEM
 *
 * @see https://code.amazon.com/reviews/CR-78943352
 */

var getFilteredContentAttribute = function getFilteredContentAttribute(contentAttributes) {
  var _contentAttributes$co2;

  var filteredContentAttributes = [];
  var indexOfSummaryContent = -1;
  contentAttributes === null || contentAttributes === void 0 ? void 0 : (_contentAttributes$co2 = contentAttributes.contents) === null || _contentAttributes$co2 === void 0 ? void 0 : _contentAttributes$co2.forEach(function (content, index) {
    if ((content === null || content === void 0 ? void 0 : content.contentType) === 'Summary') {
      if (indexOfSummaryContent === -1) {
        filteredContentAttributes.push(content);
        indexOfSummaryContent = index;
      } else {
        filteredContentAttributes[indexOfSummaryContent] = content;
      }
    } else {
      filteredContentAttributes.push(content);
    }
  });
  return {
    contents: filteredContentAttributes
  };
};

var ButtonWithStyledText = /*#__PURE__*/styledWithTheme(Button)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    fontSize: selectors.fontSize('T400') + " !important",
    maxHeight: selectors.fontSize('T500') + " !important"
  };
});
var EndWpoChatModal = function EndWpoChatModal(_ref2) {
  var _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      setEndChatState = _ref2.setEndChatState;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var handleClose = function handleClose() {
    setEndChatState({
      endStatus: EndChatState.INACTIVE
    });
  };

  var handleConfirm = function handleConfirm() {
    emitWPOChatEmployeeEndedChat();
    setEndChatState({
      endStatus: EndChatState.CONFIRMED
    });
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: open,
    close: handleClose,
    "aria-labelledby": "livechat-third-party-endchat-title",
    style: matches.s ? ModalStyle.BottomSheet : ModalStyle.Default
  }, /*#__PURE__*/React.createElement(ModalContent, {
    closeButtonAltText: "Close dialog",
    onCloseButtonClick: handleClose,
    titleText: "",
    buttons: [/*#__PURE__*/React.createElement(ButtonWithStyledText, {
      className: "end-wpo-chat-modal-button",
      isDestructive: true,
      closeButtonAltText: "Confirm End Chat",
      key: "wpo-end-confirm",
      variant: ButtonVariant.Primary,
      onClick: handleConfirm,
      style: {
        width: '100%',
        minWidth: '200px'
      },
      role: "button"
    }, t('livehelp.end_chat'))]
  }, /*#__PURE__*/React.createElement(ModalTitle, null, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "T600",
    fontWeight: 500
  }, t('livehelp.end_chat_modal_title'))), /*#__PURE__*/React.createElement(View$1, {
    padding: {
      top: 'S600',
      left: 'S200',
      right: 'S200'
    }
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "T400",
    fontWeight: 500
  }, t('livehelp.end_chat_modal_text_wpo')))));
};

var WPOUserInputArea = function WPOUserInputArea(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      announce = _useState[0],
      setAnnounce = _useState[1];

  var _useRecommendedLength = useRecommendedLength({
    value: props.userInput,
    tokenType: TokenType.Words,
    recommendedLength: RECOMMENDED_WORD_LIMIT_FOR_CHAT
  }),
      warning = _useRecommendedLength.warning,
      error = _useRecommendedLength.error,
      progress = _useRecommendedLength.progress;

  var numberOfWordsEntered = useMemo(function () {
    return Number((progress * 100 / 2).toFixed(0));
  }, [progress]);

  var handleChange = function handleChange(e) {
    props.setUserInput(e.target.value);

    if (props.userInput.charAt(numberOfWordsEntered - 1) === ' ') {
      setAnnounce(true);
    } else {
      setAnnounce(false);
    }
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter' && !warning && !error) {
      event.preventDefault();
      props.sendMessage(event);
      setAnnounce(true);
      props.setUserInput('');
    }
  };

  console.log(announce);
  return /*#__PURE__*/React.createElement(Col, {
    gridGap: "S300"
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: "wpo-chat-footer-input",
    labelText: t('livehelp.chat_input_footer_label'),
    renderLabel: function renderLabel(_ref) {
      var labelId = _ref.labelId;
      return /*#__PURE__*/React.createElement(Text$1, {
        id: labelId,
        fontSize: LiveHelpInlineFontScheme.CHAT_TEXTAREA_YOUR_MSG_TEXT
      }, t('livehelp.chat_input_footer_label'));
    }
  }, function (inputProps) {
    return /*#__PURE__*/React.createElement(TextArea, Object.assign({}, inputProps, {
      minHeight: 20,
      fontWeight: "regular",
      value: props.userInput,
      name: "wpo-footer-input",
      onKeyPress: handleKeyPress,
      onChange: handleChange,
      spellCheck: "true",
      width: "100%",
      tabIndex: 0,
      rows: 1,
      ref: props.inputBoxRef,
      css: {
        fontSize: '16px !important'
      },
      disabled: props.isDisabled
    }));
  }));
};

var WpoUserInput = /*#__PURE__*/React.memo(WPOUserInputArea);

var WPOChatContext = /*#__PURE__*/createContext(null);
var useWPOChatContext = function useWPOChatContext() {
  return useContext(WPOChatContext);
};

var css_248z$l = ".chat-container-right{right:0}.chat-container-left,.chat-container-right{background:#fff;border:1px solid #000;bottom:0;overflow:scroll!important;position:fixed!important;z-index:2}.chat-container-left{left:0}.chat-container-mobile{background:#fff;border:1px solid #000;bottom:0;height:100%!important;overflow:scroll!important;right:0;width:100vw!important;z-index:2}";
styleInject(css_248z$l);

var WPOChatView = function WPOChatView(props) {
  var handshakeFlag = 0;
  var agentDisplayName = 'Agent';
  var TWO_MINUTES_IN_MILLISECONDS = 2 * 60 * 1000;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var downloadTranscriptService = new DownloadTranscriptService();
  var endChat = props.endChat,
      userDetails = props.userDetails,
      closeChatContainer = props.closeChatContainer,
      setInsideChatMsgBanner = props.setInsideChatMsgBanner,
      createNewChatInstance = props.createNewChatInstance,
      insideMessageBanner = props.insideMessageBanner;
  var ejabberedCreds = userDetails.ejabberedCreds,
      email = userDetails.email,
      username = userDetails.username;
  var containerRef = useRef(null);
  var userInputRef = useRef(null);

  var _useState = useState([]),
      messages = _useState[0],
      _setMessages = _useState[1];

  var _useState2 = useState(''),
      userInput = _useState2[0],
      _setUserInput = _useState2[1];

  var _useState3 = useState(null),
      connection = _useState3[0],
      setConnection = _useState3[1];

  var _useState4 = useState([]),
      timerQueue = _useState4[0],
      setTimerQueue = _useState4[1];

  var _useState5 = useState(true),
      userInputAreaDisable = _useState5[0],
      setUserInputAreaDisable = _useState5[1];

  var _useState6 = useState(true),
      startSessionTimer = _useState6[0],
      setStartSessionTimer = _useState6[1];

  var _useState7 = useState({
    from: '',
    to: ''
  }),
      person = _useState7[0],
      setPerson = _useState7[1];

  var userIdentifier = getUserIdentifier();
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: WPO_CHAT_CONTAINER_PAGE_NAME,
    operationName: DEFAULT_WPO_OPERATION
  };

  var _useWPOChatContext = useWPOChatContext(),
      chatState = _useWPOChatContext.chatState,
      setChatState = _useWPOChatContext.setChatState;

  var setMessages = function setMessages(newMessage) {
    _setMessages(function (prevMessages) {
      return [].concat(prevMessages, [Object.assign({}, newMessage, {
        type: MessageType.Message
      })]);
    });
  };

  var disconnectedChatBtns = [{
    name: ChatEndFooterBtns.CLOSE,
    variant: ButtonVariant.Primary,
    clickHandler: closeChatContainer
  }, {
    name: ChatEndFooterBtns.DOWNLOAD_TRANSCRIPT,
    variant: ButtonVariant.Secondary,
    clickHandler: function clickHandler() {
      downloadTranscriptService.downloadTranscript(messages);
      emitWPOChatEmployeeDownloadedChatTranscript();
    }
  }, {
    name: ChatEndFooterBtns.NEW_LIVE_CHAT_SESSION,
    variant: ButtonVariant.Secondary,
    clickHandler: createNewChatInstance
  }];
  /**
   * @function enqueue
   * @param id unique string identifier for timer
   * @param tiggerFunction function that will triggered once timeout happens
   * @param timing a number in seconds after which the timer will be triggerd
   */

  var enqueue = function enqueue(id, tiggerFunction, timing) {
    setTimerQueue(function (prevTimers) {
      return prevTimers.filter(function (timer) {
        return timer.id !== id;
      });
    });
    var timerId = setTimeout(function (id) {
      setTimerQueue(function (queue) {
        return queue.filter(function (entry) {
          return entry.id !== id;
        });
      });
      tiggerFunction();
    }, timing * 1000, id);
    setTimerQueue(function (queue) {
      return queue.concat({
        id: id,
        timerId: timerId,
        funcToCall: tiggerFunction
      });
    });
  };

  var initChatSession = function initChatSession() {
    setChatState(initialChatState);
    setInsideChatMsgBanner(InsideContainerFixedMessage.CHAT_CONNECTED);

    _setMessages([{
      displayName: ParticipantRole.System,
      index: messages.length + 1,
      participant: ParticipantRole.System,
      content: t('livehelp.estimated_wait_time_x_minutes', {
        minutes: 2
      }),
      timestamp: Date().toString()
    }]);

    try {
      var stropheConnection = new Strophe.Connection(ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.ejabberdURL);
      setConnection(stropheConnection);
    } catch (e) {
      console.log(e);
      setConnection(null);
    }
  };

  var onSocketConnection = function onSocketConnection(status) {
    if (status === Strophe.Status.CONNECTING) {
      console.log('Strophe is connecting.');
    } else if (status === Strophe.Status.CONNFAIL) {
      console.log('Strophe failed to connect.');
      recordCountMetric(WPO_CHAT_CONTAINER_PAGE_NAME, WPOChatOperations.STROPHE_CONNECTION_FAILED, MetricEvents.COUNT);
      myHRLoggerInfoLog("[" + userIdentifier + "] : WPO Strophe connection failed to connect", logsContext);
    } else if (status === Strophe.Status.DISCONNECTING) {
      console.log('Strophe is disconnecting.');
    } else if (status === Strophe.Status.DISCONNECTED) {
      console.log('Strophe is disconnected.');
      recordCountMetric(WPO_CHAT_CONTAINER_PAGE_NAME, WPOChatOperations.CHAT_SESSION_DISCONNECTED, MetricEvents.COUNT);
      myHRLoggerInfoLog("[" + userIdentifier + "] : WPO Chat session disconnected", logsContext);
    } else if (status === Strophe.Status.CONNECTED) {
      var _props$intentDetails, _props$intentDetails2, _props$intentDetails3;

      console.log('Strophe is connected.');
      recordCountMetric(WPO_CHAT_CONTAINER_PAGE_NAME, WPOChatOperations.CHAT_SESSION_ESTABLISHED, MetricEvents.COUNT);
      myHRLoggerInfoLog("[" + userIdentifier + "] : WPO Chat session established", logsContext);
      connection.send($pres().c(WPO_STROPHE_IDENTIFIER.priority).t(WPO_STROPHE_IDENTIFIER.zero));
      connection.addHandler(onChatMessage, null, WPO_STROPHE_IDENTIFIER.xmlTag.message, null, null, null);
      logContactVolumeMetric({
        sourceIntent: {
          C: ((_props$intentDetails = props.intentDetails) === null || _props$intentDetails === void 0 ? void 0 : _props$intentDetails.category) || EMPTY_STRING_LITERAL,
          T: ((_props$intentDetails2 = props.intentDetails) === null || _props$intentDetails2 === void 0 ? void 0 : _props$intentDetails2.type) || EMPTY_STRING_LITERAL,
          I: ((_props$intentDetails3 = props.intentDetails) === null || _props$intentDetails3 === void 0 ? void 0 : _props$intentDetails3.item) || EMPTY_STRING_LITERAL
        },
        helpChannel: HelpChannel.EXTERNAL_CHAT_WPO,
        clickSource: props.clickSource || DEFAULT_CLICK_SOURCE,
        typeOfMRI: props.typeOfMRI,
        variation: props.variation
      }).then(function () {
        return console.log('logged metric from external chat WPO');
      })["catch"](function (error) {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Unable to publish business volume metric from chat. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
          operationName: CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC
        }));
        recordErrorCountMetric(HelpChannel.EXTERNAL_CHAT_WPO, CommonOperations.SEND_BUSINESS_ACTIVITY_METRIC, JSON.stringify(error));
      });
    }
  };

  var sendMessage = function sendMessage() {
    if (!userInput || userInput.length === 0) {
      return;
    }

    var m = $msg(Object.assign({}, person, {
      type: WPO_STROPHE_IDENTIFIER.chatState.chat
    })).c(WPO_STROPHE_IDENTIFIER.xmlTag.body).t(userInput);
    connection.send(m);
    setMessages({
      displayName: username !== null && username !== void 0 ? username : '',
      index: messages.length + 1,
      participant: ParticipantRole.Customer,
      content: userInput,
      timestamp: Date().toString()
    });

    _setUserInput('');

    if (chatState.agentStatus === AgentStatus.CONNECTED && chatState.endStatus !== EndChatState.CONFIRMED) {
      clearIdlenessTimerAndRestart();
    }
  };

  var send = function send(to, textMsessage) {
    if (!textMsessage || textMsessage.length === 0) {
      return;
    }

    var stropheMsg = $msg({
      to: to,
      from: person.from,
      type: WPO_STROPHE_IDENTIFIER.chatState.chat
    }).c(WPO_STROPHE_IDENTIFIER.xmlTag.body).t(textMsessage);
    connection.send(stropheMsg);
    setPerson(Object.assign({}, person, {
      to: to
    }));
  };

  var onChatMessage = function onChatMessage(xmlMsg) {
    var message = WPO_STROPHE_IDENTIFIER.message,
        xmlTag = WPO_STROPHE_IDENTIFIER.xmlTag,
        chatState = WPO_STROPHE_IDENTIFIER.chatState;
    var from = xmlMsg.getAttribute(xmlTag.attribute.from);
    var chatStateType = xmlMsg.getAttribute(xmlTag.attribute.type);
    var responseElements = xmlMsg.getElementsByTagName(xmlTag.body);

    if (chatStateType === chatState.chat && responseElements && responseElements.length > 0) {
      var body = responseElements[0];
      var bodyText = Strophe.getText(body);

      if (bodyText.indexOf(message.display_name) > '-1') {
        var _bodyText$split = bodyText.split(':');

        agentDisplayName = _bodyText$split[1];

        if (handshakeFlag === 0) {
          var handshakeMsg = message.display_name + ": " + username;
          send(from, handshakeMsg);
          setChatState({
            agentStatus: AgentStatus.CONNECTED,
            isActive: true
          });
          handshakeFlag = 1;
          setMessages({
            displayName: ParticipantRole.System,
            index: messages.length + 1,
            participant: ParticipantRole.System,
            content: t('livehelp.agent_joined_chat_session'),
            timestamp: Date().toString()
          });
          clearIdlenessTimerAndRestart();
          setUserInputAreaDisable(false); // Enable user input

          setStartSessionTimer(true); // starting session ping

          emitWPOChatAgentConnected();
        }
      } else if (bodyText.indexOf(message.left_chat) > '-1') {
        // Agent has left chat
        emitWPOChatAgentDisconnectedChat();
        setMessages({
          displayName: ParticipantRole.System,
          index: messages.length + 1,
          participant: ParticipantRole.System,
          content: t('livehelp.agent_left_chat_session'),
          timestamp: Date().toString()
        });
        setUserInputAreaDisable(true); // Disable user input
      } else {
        setMessages({
          displayName: agentDisplayName,
          index: messages.length + 1,
          participant: ParticipantRole.Agent,
          content: Strophe.getText(body),
          timestamp: Date().toString()
        });
        setChatState({
          isAgentTyping: false
        });
      }
    }

    return true;
  };

  var activeChatFooter = function activeChatFooter() {
    var paddingValue = {
      left: 12,
      bottom: 6,
      right: 12
    };
    return /*#__PURE__*/React.createElement(View$1, {
      padding: {
        top: 'S100'
      }
    }, /*#__PURE__*/React.createElement(Row, {
      padding: Object.assign({}, paddingValue)
    }, /*#__PURE__*/React.createElement(View$1, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(WpoUserInput, {
      isDisabled: userInputAreaDisable,
      userInput: userInput,
      inputBoxRef: userInputRef,
      sendMessage: sendMessage,
      setUserInput: function setUserInput(msg) {
        return _setUserInput(msg);
      }
    }))), /*#__PURE__*/React.createElement(Row, {
      padding: Object.assign({}, paddingValue)
    }, /*#__PURE__*/React.createElement(View$1, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(ButtonWithStyledText$1, {
      tabIndex: 0,
      color: "red80",
      variant: ButtonVariant.Tertiary,
      role: "button",
      size: ButtonSize.Default,
      isDestructive: true,
      onClick: endChat
    }, t('livehelp.end_chat'))), /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(ButtonWithStyledText$1, {
      tabIndex: 0,
      variant: ButtonVariant.Primary,
      size: ButtonSize.Small,
      role: "button",
      onClick: sendMessage
    }, t('livehelp.send')))));
  };

  useEffect(function () {
    var updateSessionTimer = null;

    if (startSessionTimer) {
      updateSessionTimer = setInterval(function () {
        var startTimePingChatStatusAPICall = Date.now();
        requestWPOApi({
          chatEnded: false
        }, WPO_API_TYPE.UPDATE_SESSION_TIMER).then(function () {
          recordCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, MetricEvents.SUCCESS_COUNT);
          recordLatencyMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, startTimePingChatStatusAPICall);
        })["catch"](function (error) {
          recordErrorCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, JSON.stringify(error));
          myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while updating TTL in UpdateSessionData API. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
            operationName: WPOChatOperations.UPDATE_WPO_SESSION_DATA
          }));
        });
      }, TWO_MINUTES_IN_MILLISECONDS);
    } else {
      clearInterval(updateSessionTimer);
    }

    return function () {
      return clearInterval(updateSessionTimer);
    };
  }, [startSessionTimer]);
  useEffect(function () {
    var _ejabberedCreds$ejabb;

    initChatSession();
    setPerson(Object.assign({}, person, {
      from: (_ejabberedCreds$ejabb = ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.ejabberdId) !== null && _ejabberedCreds$ejabb !== void 0 ? _ejabberedCreds$ejabb : ''
    }));
    return function () {
      timerQueue.forEach(function (_ref) {
        var timerId = _ref.timerId;
        return clearTimeout(timerId);
      });
    };
  }, [ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.requestId]);
  useEffect(function () {
    if (containerRef && containerRef.current) {
      var element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [containerRef, messages]);
  useEffect(function () {
    if (connection !== null) {
      setChatState({
        agentStatus: AgentStatus.WAITING
      });
      connection.connect(ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.ejabberdId, ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.ejabberdPwd, onSocketConnection, 120000);
    }
  }, [connection]);

  var setChatEndedMsg = function setChatEndedMsg() {
    if (chatState.agentStatus === AgentStatus.NOT_AVAILALBE) {
      setMessages({
        displayName: ParticipantRole.System,
        index: messages.length + 1,
        participant: ParticipantRole.System,
        content: t('livehelp.all_clinicians_busy'),
        timestamp: Date().toString()
      });
    }

    setMessages({
      displayName: ParticipantRole.System,
      index: messages.length + 1,
      participant: ParticipantRole.System,
      content: t('livehelp.chat_session_ended'),
      timestamp: Date().toString()
    });
    setMessages({
      displayName: ParticipantRole.System,
      index: messages.length + 1,
      participant: ParticipantRole.System,
      content: moment(Date.now()).format('LLLL'),
      timestamp: Date().toString()
    });
  };

  var removeExistingIdlenessTimers = function removeExistingIdlenessTimers() {
    setTimerQueue(function (prevTimers) {
      return prevTimers.filter(function (timer) {
        if (timer.id === TIMER.IDLENESS_DISCONNECT || timer.id === TIMER.IDLENESS_WARNING) {
          clearTimeout(timer.timerId);
          return false;
        }

        return true;
      });
    });
  };

  var clearIdlenessTimerAndRestart = function clearIdlenessTimerAndRestart() {
    removeExistingIdlenessTimers();
    enqueue(TIMER.IDLENESS_WARNING, function () {
      setMessages({
        displayName: ParticipantRole.System,
        index: messages.length + 1,
        participant: ParticipantRole.System,
        content: t('livehelp.disconnect_after_x_minutes_inactivity', {
          minutes: 5
        }),
        timestamp: Date().toString()
      });
      enqueue(TIMER.IDLENESS_DISCONNECT, function () {
        return setChatState({
          endStatus: EndChatState.CONFIRMED
        });
      }, IDLENESS_DISCONNECT_TIME_IN_SEC);
    }, IDLENESS_WARNING_TIME_IN_SEC);
  };

  useEffect(function () {
    if (chatState.agentStatus === AgentStatus.WAITING && chatState.endStatus === EndChatState.INACTIVE) {
      enqueue(TIMER.AGENT_WAIT, function () {
        setChatState(function (prevChatState) {
          if (prevChatState.agentStatus === AgentStatus.WAITING) {
            return Object.assign({}, prevChatState, {
              endStatus: EndChatState.CONFIRMED,
              agentStatus: AgentStatus.NOT_AVAILALBE
            });
          }

          return prevChatState;
        });
      }, AGENT_WAIT_TIME_IN_SEC);
    }

    if (chatState.endStatus === EndChatState.CONFIRMED) {
      setUserInputAreaDisable(true);

      _setUserInput(EMPTY_STRING_LITERAL);
    }

    if (chatState.endStatus === EndChatState.CONFIRMED && chatState.agentStatus !== AgentStatus.NOT_JOINED && chatState.agentStatus !== AgentStatus.DISCONNECTED) {
      send(person.to, WPO_STROPHE_IDENTIFIER.message.left_chat);
      var startTimePingChatStatusAPICall = Date.now();
      requestWPOApi({
        chatEnded: true
      }, WPO_API_TYPE.UPDATE_SESSION_TIMER).then(function () {
        recordCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, MetricEvents.SUCCESS_COUNT);
        recordLatencyMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, startTimePingChatStatusAPICall);
      })["catch"](function (error) {
        recordErrorCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_SESSION_DATA, JSON.stringify(error));
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while updating chat status to ended in UpdateSessionData API. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
          operationName: WPOChatOperations.UPDATE_WPO_SESSION_DATA
        }));
      });
      setStartSessionTimer(false);

      if (chatState.agentStatus !== AgentStatus.NOT_AVAILALBE) {
        setInsideChatMsgBanner(InsideContainerFixedMessage.DOWNLOAD_TRANSCRIPT);
      }

      if (chatState.agentStatus === AgentStatus.CONNECTED) {
        enqueue(TIMER.STROPHE_DISCONNECT, function () {
          return connection.disconnect();
        }, STROPHE_DISCONECT_TIME_IN_SEC);
        setChatState({
          agentStatus: AgentStatus.DISCONNECTED,
          isActive: false
        });
      } else {
        setChatState({
          agentStatus: AgentStatus.NOT_JOINED,
          isActive: false
        });
        updateIMApiCall();
        connection.disconnect();
      }

      setChatEndedMsg();
      removeExistingIdlenessTimers();
    }
  }, [chatState.agentStatus, chatState.endStatus]);

  var updateIMApiCall = function updateIMApiCall() {
    var body = {
      email: email,
      requestId: ejabberedCreds === null || ejabberedCreds === void 0 ? void 0 : ejabberedCreds.requestId,
      requestType: WPO_API_REQUEST_TYPE.IM,
      status: chatState.agentStatus === AgentStatus.NOT_AVAILALBE ? WPO_API_REQUEST_STATUS.EXPIRED : WPO_API_REQUEST_STATUS.CANCELLED
    };
    var startTimeUpdateStatusAPICall = Date.now();
    requestWPOApi(body, WPO_API_TYPE.UPDATE_CHAT_DISCONNECT_STATUS).then(function () {
      if (chatState.agentStatus === AgentStatus.NOT_AVAILALBE) {
        emitWPOChatAgentsNotAvailable();
      } else {
        emitWPOChatEmployeeEndedChatBeforeAgentJoined();
      }

      recordCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_CHAT_STATUS, MetricEvents.SUCCESS_COUNT);
      recordLatencyMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_CHAT_STATUS, startTimeUpdateStatusAPICall);
    })["catch"](function (error) {
      recordErrorCountMetric(logsContext.pageName, WPOChatOperations.UPDATE_WPO_CHAT_STATUS, JSON.stringify(error));
      myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while updating WPO chat status to " + body.status + ". " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
        operationName: WPOChatOperations.UPDATE_WPO_CHAT_STATUS
      }));
    });
  };

  var getMessageSpacingProps = function getMessageSpacingProps(messageText) {
    return {
      padding: {
        top: messageText === t('livehelp.chat_session_ended') ? 'S700' : 'S200',
        bottom: messageText === t('livehelp.chat_session_ended') ? '' : 'S200'
      }
    };
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollColContainer, {
    ref: containerRef
  }, messages.map(function (message) {
    var isCustomersMessage = message.participant === ParticipantRole.Customer;
    return /*#__PURE__*/React.createElement(Col, Object.assign({
      key: message.displayName + "-" + message.content,
      alignItems: isCustomersMessage ? 'flex-end' : 'flex-start'
    }, getMessageSpacingProps(message.content)), message.participant === ParticipantRole.System ? /*#__PURE__*/React.createElement(Text$1, {
      fontSize: "T400",
      key: message.index,
      dangerouslySetInnerHTML: {
        __html: message.content
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChatMessageLabelText, {
      fontSize: "T300"
    }, message.displayName), /*#__PURE__*/React.createElement(ChatMessageText, {
      fontSize: "T400",
      variant: isCustomersMessage ? CHAT_MSG_VIEW_VARIANT.PRIMARY : CHAT_MSG_VIEW_VARIANT.NEUTRAL
    }, message.content)));
  })), /*#__PURE__*/React.createElement(View$1, {
    css: {
      boxShadow: '0px -4px 10px rgba(35, 47, 62, 0.3)'
    }
  }, EndChatState.CONFIRMED === chatState.endStatus ? /*#__PURE__*/React.createElement(View$1, {
    padding: 12
  }, /*#__PURE__*/React.createElement(View$1, {
    width: "100%",
    padding: {
      top: 8
    }
  }, disconnectedChatBtns.map(function (button) {
    return chatState.agentStatus === AgentStatus.NOT_JOINED && insideMessageBanner !== InsideContainerFixedMessage.DOWNLOAD_TRANSCRIPT && button.name === ChatEndFooterBtns.DOWNLOAD_TRANSCRIPT ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(View$1, {
      padding: "S100"
    }, /*#__PURE__*/React.createElement(ButtonWithStyledText$1, {
      key: "wpo-" + button.name,
      onClick: button.clickHandler,
      variant: button.variant,
      fullWidth: true,
      role: "button"
    }, t("livehelp." + button.name)));
  }))) : activeChatFooter()), /*#__PURE__*/React.createElement(EndWpoChatModal, {
    open: chatState.endStatus === EndChatState.ACTIVE,
    setEndChatState: setChatState
  }));
};
var ChatMessageLabelText = /*#__PURE__*/styledWithTheme(View$1)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    color: selectors.color('neutral70'),
    whiteSpace: 'initial',
    wordBreak: 'break-word',
    alignItems: 'flex-start',
    paddingBottom: px(selectors.space('S100')),
    paddingLeft: px(selectors.space('S300')),
    paddingRight: px(selectors.space('S300'))
  };
});
var ScrollColContainer = /*#__PURE__*/styledWithTheme(Col)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    overflow: 'scroll',
    height: '100%',
    width: '100%',
    padding: px(selectors.space('S200'))
  };
});
var ButtonWithStyledText$1 = /*#__PURE__*/styledWithTheme(Button)(function (props) {
  return {
    minWidth: props !== null && props !== void 0 && props.fullWidth ? '100%' : 'auto',
    fontSize: props.theme.selectors.fontSize('T400') + " !important",
    maxHeight: props.theme.selectors.fontSize('T500') + " !important"
  };
});
var ChatMessageText = /*#__PURE__*/styledWithTheme(View$1)(function (_ref4) {
  var selectors = _ref4.theme.selectors,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? CHAT_MSG_VIEW_VARIANT.NEUTRAL : _ref4$variant;
  var isGreyVariant = variant === CHAT_MSG_VIEW_VARIANT.NEUTRAL;
  return {
    color: selectors.color('neutral90'),
    fontSize: selectors.fontSize('T400') + " !important",
    whiteSpace: 'initial',
    wordBreak: 'break-word',
    maxWidth: '79%',
    paddingTop: px(selectors.space('S200')),
    paddingBottom: px(selectors.space('S200')),
    paddingLeft: px(selectors.space('S300')),
    paddingRight: px(selectors.space('S300')),
    borderRadius: px(selectors.space('S400')),
    backgroundColor: selectors.color(isGreyVariant ? 'neutral10' : 'primary10'),
    border: isGreyVariant ? "1px solid " + selectors.color('neutral30') : 'none'
  };
});

var _templateObject$2;

var countries$1 = /*#__PURE__*/require('i18n-iso-countries');

var WPOContainer = function WPOContainer(_ref) {
  var intentDetails = _ref.intentDetails,
      clickSource = _ref.clickSource,
      typeOfMRI = _ref.typeOfMRI,
      variation = _ref.variation,
      setViewWPOContainer = _ref.setViewWPOContainer,
      _ref$showContainer = _ref.showContainer,
      showContainer = _ref$showContainer === void 0 ? false : _ref$showContainer,
      _ref$employeeDetails = _ref.employeeDetails,
      employeeDetails = _ref$employeeDetails === void 0 ? EmployeeDetailsMockResponse : _ref$employeeDetails;

  var _useState = useState(initialChatState),
      chatState = _useState[0],
      _setChatState = _useState[1];

  var setChatState = function setChatState(newChatState) {
    if (typeof newChatState === 'function') {
      _setChatState(newChatState);
    } else {
      _setChatState(function (prevState) {
        return Object.assign({}, prevState, newChatState);
      });
    }
  };

  var WPOChatContextValue = useMemo(function () {
    return {
      chatState: chatState,
      setChatState: setChatState
    };
  }, [chatState]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var containerRef = useRef(null);

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var languageDirection = document.documentElement.dir;

  var _useState2 = useState(false),
      isRequestingBackend = _useState2[0],
      setRequestingBackend = _useState2[1];

  var _useState3 = useState(false),
      landedOnChatContainer = _useState3[0],
      setLandedOnChatContainer = _useState3[1];

  var _useState4 = useState(false),
      continueButtonDisable = _useState4[0],
      setContinueButtonDisable = _useState4[1];

  var _useState5 = useState(DEFAULT_ATOZ_ZINDEX),
      defaultAtoZHeaderZIndex = _useState5[0],
      setDefaultAtoZHeaderZIndex = _useState5[1];

  var _useState6 = useState(InsideContainerFixedMessage.NONE),
      insideChatMsgBanner = _useState6[0],
      setInsideChatMsgBanner = _useState6[1];

  var _useState7 = useState(Object.assign({}, initialUserMetaInformation)),
      userDetails = _useState7[0],
      _setUserDetails = _useState7[1];

  var _useState8 = useState(initialWPOFormErrorValues),
      formErrors = _useState8[0],
      _setFormErrors = _useState8[1];

  var _useState9 = useState({
    width: convertVwToPx(MIN_CONTAINER_WIDTH_BROWSER),
    height: convertVhToPx(MIN_CONTAINER_WIDTH_BROWSER)
  }),
      chatContainerSize = _useState9[0],
      setChatContainerSize = _useState9[1];

  var userIdentifier = getUserIdentifier();
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: WPO_CHAT_CONTAINER_PAGE_NAME,
    operationName: WPOChatOperations.CREATE_WPO_CHAT
  };

  var getResizableClassName = function getResizableClassName() {
    return matches.l || matches.xl ? languageDirection === 'rtl' ? 'chat-container-left' : 'chat-container-right' : 'chat-container-mobile';
  };

  var setUserDetails = function setUserDetails(newUserDetails) {
    _setUserDetails(function (prevUserDetails) {
      return Object.assign({}, prevUserDetails, newUserDetails);
    });
  };

  var setFormErrors = function setFormErrors(newError) {
    _setFormErrors(function (prevError) {
      return Object.assign({}, prevError, newError);
    });
  };

  var onChatContainerResizeStops = function onChatContainerResizeStops(_event, _direction, _elementRef, dimensionsDelta) {
    var width = dimensionsDelta.width,
        height = dimensionsDelta.height;
    setChatContainerSize(function (prevSize) {
      return {
        width: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.width) + width,
        height: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.height) + height
      };
    });
  };

  var closeChat = function closeChat(event) {
    var ESCAPE_KEY_CODE = 27;

    if (event.keyCode === ESCAPE_KEY_CODE) {
      if (setViewWPOContainer) {
        setViewWPOContainer(false);
      }
    }
    /**
     * @todo implementation of closechat reset state and close
     */

  };

  var handleEndChat = function handleEndChat() {
    setChatState({
      endStatus: EndChatState.ACTIVE
    });
  };

  var handleCloseButtonClick = function handleCloseButtonClick() {
    if (landedOnChatContainer && chatState.endStatus === EndChatState.INACTIVE) {
      handleEndChat();
    } else {
      closeWPOContainer();
    }
  };

  var closeWPOContainer = function closeWPOContainer() {
    if (setViewWPOContainer) {
      setViewWPOContainer(false);
    }
  };

  var createNewChatInstance = function createNewChatInstance() {
    var errors = wpoFormFields.reduce(function (prevWPOErrorData, formField) {
      var _userDetails$formFiel, _Object$assign;

      return Object.assign({}, prevWPOErrorData, (_Object$assign = {}, _Object$assign[formField.fieldId] = !formField.validationFunction((_userDetails$formFiel = userDetails[formField.fieldId]) !== null && _userDetails$formFiel !== void 0 ? _userDetails$formFiel : 'email'), _Object$assign));
    }, Object.assign({}, initialWPOFormErrorValues));
    setFormErrors(errors);

    if (errors.email || errors.phoneNumber || errors.username) {
      setInsideChatMsgBanner(InsideContainerFixedMessage.FORM_FIELD_ERROR);
    } else {
      setContinueButtonDisable(true);
      setRequestingBackend(true);
      setInsideChatMsgBanner(InsideContainerFixedMessage.REQUESTING_BACKEND);
    }
  };
  /**
   * @function handleChange helps to reset relevant erros if exits and updated the form values dynamically
   * @param event this is related to the change event of input form fields
   */


  var handleChange = function handleChange(event) {
    var _setUserDetails2;

    var currentTarget = event.target;
    setUserDetails((_setUserDetails2 = {}, _setUserDetails2[currentTarget.name] = currentTarget.value, _setUserDetails2));

    if (formErrors[currentTarget.name]) {
      var _setFormErrors2;

      setFormErrors((_setFormErrors2 = {}, _setFormErrors2[currentTarget.name] = false, _setFormErrors2));
    }
  };

  useEffect(function () {
    if (window && !matches.l && !matches.xl) {
      if (landedOnChatContainer) {
        var paragraphElement = document.createElement('p');
        paragraphElement.id = SCROLL_ELEMENT.ID;
        paragraphElement.style.cssText = SCROLL_ELEMENT.CSS;
        document.body.appendChild(paragraphElement);
        window.scrollTo(0, SCROLL_ELEMENT.PIXELS_TO_SCROLL_FROM_TOP);
      } else {
        var _document$getElementB;

        window.scrollTo(0, -SCROLL_ELEMENT.PIXELS_TO_SCROLL_FROM_TOP);
        (_document$getElementB = document.getElementById(SCROLL_ELEMENT.ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
      }
    }
  }, [landedOnChatContainer]);
  useEffect(function () {
    if (containerRef && containerRef.current) {
      var element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [containerRef]);
  useEffect(function () {
    if (isRequestingBackend) {
      var email = userDetails.email,
          phoneNumber = userDetails.phoneNumber,
          username = userDetails.username;
      var startTimeCreateChatAPICall = Date.now();
      requestWPOApi({
        email: email,
        phoneNumber: phoneNumber,
        name: username
      }, WPO_API_TYPE.CREATE_CHAT_INSTANCE).then(function (result) {
        var response = JSON.parse(result.data.response);

        if (response !== null && response !== void 0 && response.nextSessionWaitTimeInMinutes) {
          setInsideChatMsgBanner(InsideContainerFixedMessage.NEXT_SESSION_WAIT_TIME_MESSAGE);
          setContinueButtonDisable(true);
        } else {
          setUserDetails({
            ejabberedCreds: response
          });
          setLandedOnChatContainer(true);
          setContinueButtonDisable(false);
        }

        recordCountMetric(logsContext.pageName, logsContext.operationName, MetricEvents.SUCCESS_COUNT);
        recordLatencyMetric(logsContext.pageName, logsContext.operationName, startTimeCreateChatAPICall);
      })["catch"](function (error) {
        var _error$response, _error$response2, _error$response2$data, _error$response3, _error$response4, _error$response4$data;

        if (typeof (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) === 'string' && error !== null && error !== void 0 && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && (_error$response2$data = _error$response2.data) !== null && _error$response2$data !== void 0 && _error$response2$data.includes(DESCREPTIVE_ERROR.INVALID_PHONE_NUMBER_TEXT)) {
          setInsideChatMsgBanner(InsideContainerFixedMessage.INVALID_PHONE_NUMBER);
        } else if (typeof (error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data) === 'string' && error !== null && error !== void 0 && (_error$response4 = error.response) !== null && _error$response4 !== void 0 && (_error$response4$data = _error$response4.data) !== null && _error$response4$data !== void 0 && _error$response4$data.includes(DESCREPTIVE_ERROR.DUPLICATE_PHONE_NUMBER)) {
          setInsideChatMsgBanner(InsideContainerFixedMessage.DUPLICATE_PHONE_NUMBER);
        } else {
          switch (error.response.status) {
            case 403:
              setInsideChatMsgBanner(InsideContainerFixedMessage.UNAUTHORIZED);
              break;

            case 400:
              if (error.response.status) setInsideChatMsgBanner(InsideContainerFixedMessage.BAD_REQUEST);
              break;

            default:
              setInsideChatMsgBanner(InsideContainerFixedMessage.DEFAULT_ERROR_MESSAGE);
              break;
          }
        }

        recordErrorCountMetric(logsContext.pageName, logsContext.operationName, JSON.stringify(error));
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while creating WPO chat. " + getDetailedErrorMessage(error), logsContext);
        setContinueButtonDisable(false);
      })["finally"](function () {
        setRequestingBackend(false);
      });
    }
  }, [isRequestingBackend]);

  var getParsedPhoneNumber = function getParsedPhoneNumber(mobilePhone, country) {
    var _parsePhoneNumber;

    return mobilePhone ? (_parsePhoneNumber = parsePhoneNumber$1(mobilePhone, countries$1.alpha3ToAlpha2(country))) === null || _parsePhoneNumber === void 0 ? void 0 : _parsePhoneNumber.number : EMPTY_STRING_LITERAL;
  };

  useEffect(function () {
    var _employeeDetails$emai, _employeeDetails$lega;

    setUserDetails({
      email: (_employeeDetails$emai = employeeDetails === null || employeeDetails === void 0 ? void 0 : employeeDetails.email) !== null && _employeeDetails$emai !== void 0 ? _employeeDetails$emai : EMPTY_STRING_LITERAL,
      phoneNumber: String(getParsedPhoneNumber(employeeDetails === null || employeeDetails === void 0 ? void 0 : employeeDetails.mobilePhone, employeeDetails === null || employeeDetails === void 0 ? void 0 : employeeDetails.country)),
      username: (_employeeDetails$lega = employeeDetails === null || employeeDetails === void 0 ? void 0 : employeeDetails.legalName) !== null && _employeeDetails$lega !== void 0 ? _employeeDetails$lega : EMPTY_STRING_LITERAL
    });
    var atozHeader = document.getElementById('employeenav');

    if (atozHeader) {
      setDefaultAtoZHeaderZIndex(atozHeader === null || atozHeader === void 0 ? void 0 : atozHeader.style.zIndex);
    }
  }, []);
  useEffect(function () {
    var atozHeader = document.getElementById('employeenav');

    if (atozHeader) {
      atozHeader.style.zIndex = showContainer ? OVERRIDEN_ATOZ_ZINDEX : defaultAtoZHeaderZIndex !== null && defaultAtoZHeaderZIndex !== void 0 ? defaultAtoZHeaderZIndex : DEFAULT_ATOZ_ZINDEX;
    }
  }, [showContainer]);
  return /*#__PURE__*/React.createElement(WPOChatContext.Provider, {
    value: WPOChatContextValue
  }, /*#__PURE__*/React.createElement(StencilProvider, {
    theme: stencilOverridenTheme
  }, /*#__PURE__*/React.createElement(Flyout, {
    role: "dialog",
    isOpen: showContainer,
    close: function close() {
      console.log('trying to close');
    },
    shouldCloseOnClickOutside: false,
    "aria-labelledby": "livechat-heading",
    "aria-hidden": false
  }, /*#__PURE__*/React.createElement(Col, {
    maxWidth: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Resizable, Object.assign({
    className: getResizableClassName(),
    size: chatContainerSize,
    onResizeStop: onChatContainerResizeStops,
    enable: matches.l || matches.xl ? BROWSER_RESIZE_SIDES_ENABLED : MOBILE_RESIZE_SIDES_ENABLED
  }, RESIZABLE_DIMENSIONS.chatView), /*#__PURE__*/React.createElement(WpoContainerView, {
    onKeyUp: closeChat
  }, /*#__PURE__*/React.createElement(HiddenOverflowView, null, /*#__PURE__*/React.createElement(WPOChatHeaderView, null, /*#__PURE__*/React.createElement(View$1, {
    width: "93%",
    role: "dialog",
    padding: {
      left: 'S400'
    }
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "T600",
    color: "neutral0",
    textAlign: "center"
  }, t('livehelp.live_chat'))), /*#__PURE__*/React.createElement(View$1, {
    width: "7%",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(FlyoutCloseButton, {
    role: "button",
    size: ButtonSize.Small,
    colorScheme: ButtonColorScheme.DarkBackground,
    icon: /*#__PURE__*/React.createElement(IconCross, {
      title: "Close Live Chat Dialog"
    }),
    onClick: handleCloseButtonClick,
    variant: ButtonVariant.Tertiary
  }))), getContainerMessageBanner(insideChatMsgBanner), landedOnChatContainer ? /*#__PURE__*/React.createElement(WPOChatView, {
    intentDetails: intentDetails,
    clickSource: clickSource,
    typeOfMRI: typeOfMRI,
    variation: variation,
    endChat: handleEndChat,
    closeChatContainer: closeWPOContainer,
    setInsideChatMsgBanner: setInsideChatMsgBanner,
    createNewChatInstance: createNewChatInstance,
    userDetails: userDetails,
    insideMessageBanner: insideChatMsgBanner
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollColContainer$1, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Col, {
    key: "about-third-party",
    gridGap: "S100",
    padding: "S100"
  }, /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(H2, {
    fontWeight: 500
  }, t('livehelp.connect_to_a_provider_outside_amazon'))), /*#__PURE__*/React.createElement(ViewWithTextAndPadding, null, t('livehelp.you_are_now_connected_to_confidential')), /*#__PURE__*/React.createElement(ViewWithTextAndPadding, null, t('livehelp.to_start_live_chat_click_continue')), /*#__PURE__*/React.createElement(ViewWithTextAndPadding, null, /*#__PURE__*/React.createElement(H3, {
    fontSize: "T400",
    fontWeight: 500
  }, t('livehelp.your_information')), t('livehelp.all_feilds_are_required'))), wpoFormFields.map(function (field) {
    var fieldId = field.fieldId,
        employeeAttributeIdentifier = field.employeeAttributeIdentifier;
    var translatedLabel = t("livehelp." + fieldId);
    return /*#__PURE__*/React.createElement(Col, {
      key: fieldId,
      gridGap: "S100",
      padding: "S100"
    }, /*#__PURE__*/React.createElement(InputWrapper, {
      id: fieldId,
      labelText: translatedLabel,
      renderLabel: function renderLabel(_ref2) {
        var labelId = _ref2.labelId;
        return /*#__PURE__*/React.createElement(Label, {
          id: labelId,
          fontSize: "T400",
          htmlFor: fieldId
        }, translatedLabel, " ", /*#__PURE__*/React.createElement("span", {
          "aria-hidden": "true"
        }, "*"));
      },
      error: formErrors[fieldId],
      footer: function footer() {
        return formErrors[fieldId] && /*#__PURE__*/React.createElement(MessageBanner, {
          type: MessageBannerType.Error
        }, /*#__PURE__*/React.createElement(Text$1, {
          role: "alert",
          fontSize: "T400"
        }, t("livehelp.please_provide_valid") + " " + translatedLabel));
      },
      required: true
    }, function (inputProps) {
      var _employeeDetails$empl;

      return /*#__PURE__*/React.createElement(InputWithModifiedTextStyle, Object.assign({}, inputProps, {
        "aria-required": "true",
        tabIndex: 0,
        disabled: ((_employeeDetails$empl = employeeDetails[employeeAttributeIdentifier]) === null || _employeeDetails$empl === void 0 ? void 0 : _employeeDetails$empl.length) !== 0,
        value: userDetails[fieldId],
        onChange: handleChange,
        name: fieldId
      }));
    }));
  })), /*#__PURE__*/React.createElement(EvenlySpacedButtonsContainer, null, /*#__PURE__*/React.createElement(Row, {
    gridGap: "S200",
    alignItems: "left",
    padding: {
      left: 'S200'
    }
  }, /*#__PURE__*/React.createElement(Text$1, {
    fontSize: "T200"
  }, t('livehelp.by_tapping_continue_agree_wpo_terms'), " \xA0", /*#__PURE__*/React.createElement(Link, {
    role: "link",
    href: WPO_POLICY_VIEW_URL,
    target: "_blank"
  }, ' ', t('livehelp.terms_and_conditions'), ".")))), /*#__PURE__*/React.createElement(EvenlySpacedButtonsContainer, null, /*#__PURE__*/React.createElement(ButtonWithStyledText$2, {
    role: "button",
    tabIndex: 0,
    onClick: closeWPOContainer
  }, t('livehelp.cancel')), /*#__PURE__*/React.createElement(ButtonWithStyledText$2, {
    role: "button",
    tabIndex: 0,
    variant: ButtonVariant.Primary,
    onClick: createNewChatInstance,
    disabled: continueButtonDisable
  }, t('livehelp.continue')))))))))));
};
var WPOChatHeaderView = /*#__PURE__*/styledWithTheme(View$1)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: selectors.color('primary70'),
    padding: px(selectors.space('S200')),
    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2);'
  };
});
var ScrollColContainer$1 = /*#__PURE__*/styledWithTheme(Col)(function (_ref4) {
  var selectors = _ref4.theme.selectors;
  return {
    overflow: 'scroll',
    height: '100%',
    width: '100%',
    padding: px(selectors.space('S200'))
  };
});
var ButtonWithStyledText$2 = /*#__PURE__*/styledWithTheme(Button)(function (props) {
  return {
    minWidth: props !== null && props !== void 0 && props.fullWidth ? '100%' : 'auto',
    fontSize: props.theme.selectors.fontSize('T400') + " !important",
    maxHeight: props.theme.selectors.fontSize('T500') + " !important"
  };
});
var HiddenOverflowView = /*#__PURE__*/styledWithTheme(View$1)(function () {
  return {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  };
});
var WpoContainerView = /*#__PURE__*/styledWithTheme(Container)(function () {
  return {
    height: '100%',
    width: '100%',
    position: 'relative'
  };
});
var EvenlySpacedButtonsContainer = /*#__PURE__*/styledWithTheme(Row)(function (_ref5) {
  var selectors = _ref5.theme.selectors;
  return {
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: px(selectors.space('S200'))
  };
});
var InputWithModifiedTextStyle = /*#__PURE__*/styledWithTheme(Input$1)(function (_ref6) {
  var selectors = _ref6.theme.selectors,
      disabled = _ref6.disabled;
  return {
    fontSize: selectors.fontSize('T400') + " !important",
    paddingTop: px(selectors.space('S200')),
    paddingBottom: px(selectors.space('S200')),
    paddingLeft: px(selectors.space(disabled ? 'S500' : 'S200'))
  };
});
var ViewWithTextAndPadding = /*#__PURE__*/styledWithTheme(View$1)(function (_ref7) {
  var selectors = _ref7.theme.selectors;
  return {
    fontSize: selectors.fontSize('T400') + " !important",
    paddingTop: px(selectors.space('S100')),
    paddingBottom: px(selectors.space('S100'))
  };
});
var FlyoutCloseButton = /*#__PURE__*/styledWithTheme(Button)(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  border: none!important;\n  outline: none !important;\n  :hover {\n    color: ", ";\n  }\n  :focus {\n    :before {\n      border-color: none;\n      outline: none !important;\n    }\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.selectors.color('neutral0');
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.selectors.color('neutral10');
});

var Contact = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Contact, _React$Component);

  function Contact(props) {
    var _this$props$passedPro;

    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.defaultChannelsHideWaitTime = {
      isChatWaitTimeHidden: false,
      isVoiceWaitTimeHidden: false,
      isCaseWaitTimeHidden: false
    };
    _this.state = {
      viewContactCard: false,
      voiceAttributes: undefined,
      viewWPOContainer: false,
      externalChatAttributes: undefined,
      chatAttributes: undefined,
      caseAttributes: undefined,
      employeeAttributes: undefined,
      voiceAvailable: false,
      chatAvailable: false,
      caseAvailable: false,
      preferredLanguage: '',
      userContext: '',
      redirectToCaseCreation: false,
      isCaseCreationAccessibleOffNetwork: false,
      isUserOffNetwork: false,
      errorMessageStatus: false,
      isSpinnerActive: true,
      cti: undefined,
      crumbs: [],
      livehelpPageTitle: '',
      passedProps: undefined,
      showNoChannelMessage: false,
      channelsHideWaitTime: _this.defaultChannelsHideWaitTime,
      timeStampForLiveHelpClick: undefined,
      clientConfig: undefined,
      contentAttributes: undefined,
      presentationDetails: undefined,
      selfServiceAttributes: undefined,
      selfServiceAvailable: false,
      clickSource: undefined
    };
    _this.userIdentifier = getUserIdentifier();
    _this.logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: _this.userIdentifier,
      operationName: 'LiveHelpLanding',
      pageName: Contact.PAGE_NAME
    };
    _this.dynamicValueOfMyHR = _this.props.isSourceInline ? '' : '/' + location.pathname.split('/')[1];
    _this.errorUrl = _this.dynamicValueOfMyHR + '/error/3';
    _this.clientId = (_this$props$passedPro = _this.props.passedProps.clientId) !== null && _this$props$passedPro !== void 0 ? _this$props$passedPro : LaasClientId$1.MY_HR;
    _this.redirectedFromSelfService = _this.props.passedProps.sourcePage === SourcePagesForLiveHelpRedirection.SSA || containsSSASubstring(new URLSearchParams(window.location.search).get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE));

    _this.setViewWPOContainer = function (isVisible) {
      _this.setState({
        viewWPOContainer: isVisible
      });
    };

    _this.setState = _this.setState.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Contact.prototype;

  _proto.createUserContext = function createUserContext(C, T, I) {
    if (T === null && I === null) {
      return C;
    }

    if (I === null) {
      return [C, T].join('_');
    }

    return [C, T, I].join('_');
  };

  _proto.setShowErrorBannerStates = function setShowErrorBannerStates() {
    this.setState({
      errorMessageStatus: true,
      showNoChannelMessage: true,
      isSpinnerActive: false
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    try {
      var _intentDetails$catego, _intentDetails$type, _intentDetails$item, _presentationDetails$, _chatAttributes$isAva, _selfServiceAttribute;

      var _this$props = this.props,
          passedProps = _this$props.passedProps,
          getContactChannelResponse = _this$props.getContactChannelResponse;
      var selectedIntent = passedProps.selectedIntent,
          clickSource = passedProps.clickSource,
          crumbs = passedProps.crumbs;
      var contents = selectedIntent.contents,
          intentDetails = selectedIntent.intentDetails,
          presentationDetails = selectedIntent.presentationDetails;

      var _ref = getContactChannelResponse !== null && getContactChannelResponse !== void 0 ? getContactChannelResponse : {},
          chatAttributes = _ref.chatAttributes,
          externalChatAttributes = _ref.externalChatAttributes,
          voiceAttributes = _ref.voiceAttributes,
          caseAttributes = _ref.caseAttributes,
          selfServiceAttributes = _ref.selfServiceAttributes,
          contentAttributes = _ref.contentAttributes,
          clientConfig = _ref.clientConfig,
          employeeDetails = _ref.employeeDetails;

      var cti = {
        C: (_intentDetails$catego = intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.category) !== null && _intentDetails$catego !== void 0 ? _intentDetails$catego : '',
        T: (_intentDetails$type = intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.type) !== null && _intentDetails$type !== void 0 ? _intentDetails$type : '',
        I: (_intentDetails$item = intentDetails === null || intentDetails === void 0 ? void 0 : intentDetails.item) !== null && _intentDetails$item !== void 0 ? _intentDetails$item : ''
      };
      var isUserOffNetwork = getIsUserOffNetwork();
      var preferredLanguage = this.fetchPreferredLanguage();
      var isCaseCreationAccessibleOffNetwork = getContactChannelResponse ? getIsCaseCreationAccessibleOffNetwork(getContactChannelResponse) : false;
      this.setState({
        isSpinnerActive: false,
        timeStampForLiveHelpClick: Date.now(),
        isUserOffNetwork: isUserOffNetwork,
        crumbs: crumbs !== undefined ? [].concat(crumbs) : [],
        cti: cti.C ? cti : undefined,
        livehelpPageTitle: (_presentationDetails$ = presentationDetails === null || presentationDetails === void 0 ? void 0 : presentationDetails.title) !== null && _presentationDetails$ !== void 0 ? _presentationDetails$ : '',
        presentationDetails: presentationDetails === null || presentationDetails === void 0 ? void 0 : presentationDetails.title,
        clickSource: clickSource,
        channelsHideWaitTime: getContactChannelResponse ? getShouldHideChannelsWaitTime(getContactChannelResponse) : this.defaultChannelsHideWaitTime,
        preferredLanguage: preferredLanguage,
        passedProps: passedProps,
        voiceAttributes: voiceAttributes,
        externalChatAttributes: externalChatAttributes,
        chatAttributes: chatAttributes,
        caseAttributes: caseAttributes,
        selfServiceAttributes: selfServiceAttributes,
        voiceAvailable: voiceAttributes ? voiceAttributes.isAvailable : false,
        chatAvailable: (_chatAttributes$isAva = chatAttributes === null || chatAttributes === void 0 ? void 0 : chatAttributes.isAvailable) !== null && _chatAttributes$isAva !== void 0 ? _chatAttributes$isAva : false,
        caseAvailable: caseAttributes ? caseAttributes.isAvailable : false,
        selfServiceAvailable: (_selfServiceAttribute = selfServiceAttributes === null || selfServiceAttributes === void 0 ? void 0 : selfServiceAttributes.isAvailable) !== null && _selfServiceAttribute !== void 0 ? _selfServiceAttribute : false,
        userContext: cti.C ? this.createUserContext(cti.C, cti.T, cti.I) : '',
        isCaseCreationAccessibleOffNetwork: isCaseCreationAccessibleOffNetwork,
        employeeAttributes: employeeDetails,
        clientConfig: clientConfig,
        contentAttributes: contentAttributes
      });

      if (this.props.showErrorMessage) {
        this.setShowErrorBannerStates();
        return;
      }

      var pageActionForOmnitureMetric = isComponentInline() ? PageActionsForOmnitureMetrics.CONTACT_CHANNELS_PAGE_LOAD_INLINE : PageActionsForOmnitureMetrics.CONTACT_CHANNELS_PAGE_LOAD_DEFAULT;
      WebAnalytics.sendOmnitureMetric({
        pageName: getPageNameForOmnitureMetrics(),
        pageAction: pageActionForOmnitureMetric,
        hitType: OmnitureHelper.HitTypes.PageHit
      });

      if (isComponentInline()) {
        // for calculating overall latency from the time FAB was clicked,
        // At this time some info should be visible to user either channels or error
        emitLatencyForSpecificOperationFromFabClick(CommonOperations.INLINE_WIDGET_PAGE_LOAD); // for calculating latency for the page load (ATF + CF + more) in inline component,
        // used different operationName as it can get merged with pageLoad metric in chat container

        recordPerformanceLatencyMetric(getPageName(), CommonOperations.CONTACT_CHANNEL_PAGE_LOAD);
      } else {
        // for calculating latency for the page load (ATF + CF + more)
        recordPerformanceLatencyMetric(Contact.PAGE_NAME, CommonOperations.PAGE_LOAD);
      }

      contentIdParityCheck(buildContentAttributesForLiveHelpWrapper(contentAttributes), contents, Contact.PAGE_NAME, cti, this.logsContext);
      var instance = i18.getInstance();
      instance.changeLanguage(preferredLanguage);
    } catch (error) {
      var SUB_OPERATION_NAME = 'UserIntentNull';
      recordErrorCountMetric(Contact.PAGE_NAME, SUB_OPERATION_NAME, JSON.stringify(error));

      if (isComponentInline()) {
        myHRLoggerErrorLog("[" + this.userIdentifier + "]: Error occured in Contact while parsing props due to null User Intent in pageName: " + getPageName() + " for client: " + getClientId$1() + ". Error: " + getDetailedErrorMessage(error), Object.assign({}, this.logsContext, {
          operationName: SUB_OPERATION_NAME,
          clientId: getClientId$1(),
          pageName: getPageName()
        })); // When component is inline, we don't want to redirect, instead show error banner

        this.setShowErrorBannerStates();
      } else {
        myHRLoggerErrorLog("[" + this.userIdentifier + "]: Error occured in Contact while parsing props due to null User Intent. " + getDetailedErrorMessage(error), Object.assign({}, this.logsContext, {
          operationName: SUB_OPERATION_NAME
        }));
        window.location.replace(this.dynamicValueOfMyHR);
      }
    }
  }
  /**
   * @returns Selected preferred language by user. Defaults to "en-US" if unavailable.
   */
  ;

  _proto.fetchPreferredLanguage = function fetchPreferredLanguage() {
    var preferredLanguage = LanguagesAvailable.en_US.toString();
    var queryParameters = new URLSearchParams(window.location.search);
    var languageFromParams = queryParameters.get('language');
    var languageFromA2Z = getPreferredLanguage(null);
    var languageFromi18 = localStorage.getItem('i18nextLng');

    if (languageFromParams && Object.values(LanguagesAvailable).includes(languageFromParams)) {
      preferredLanguage = languageFromParams;
    } else if (languageFromA2Z && Object.values(LanguagesAvailable).includes(languageFromA2Z)) {
      preferredLanguage = languageFromA2Z;
    } else if (languageFromi18 && Object.values(LanguagesAvailable).includes(languageFromi18)) {
      preferredLanguage = languageFromi18;
    }

    return preferredLanguage;
  };

  _proto.redirectToCall = function redirectToCall() {
    var _this$state$voiceAttr, _this$state$channelsH;

    var callUrl = this.dynamicValueOfMyHR + '/livehelp/call';
    var crumb = {
      title: i18.getInstance().t('livehelp.request_call'),
      url: callUrl
    };
    var crumbsToPass = [].concat(this.state.crumbs, [crumb]);
    return /*#__PURE__*/React.createElement(Redirect, {
      push: true,
      to: {
        pathname: callUrl,
        state: {
          propsToPass: {
            voiceContactChannel: this.state.voiceAttributes.voiceContactChannel,
            employeeAttributes: this.state.employeeAttributes,
            preferredLanguage: this.state.preferredLanguage,
            userContext: this.state.userContext,
            receivedProps: this.state.passedProps,
            crumbs: crumbsToPass,
            waitTimeInMin: (_this$state$voiceAttr = this.state.voiceAttributes) === null || _this$state$voiceAttr === void 0 ? void 0 : _this$state$voiceAttr.waitTimeInMinutes,
            isVoiceWaitTimeHidden: (_this$state$channelsH = this.state.channelsHideWaitTime) === null || _this$state$channelsH === void 0 ? void 0 : _this$state$channelsH.isVoiceWaitTimeHidden,
            timeStampForLiveHelpClick: this.state.timeStampForLiveHelpClick,
            voiceAttributes: this.state.voiceAttributes,
            liveHelpClickSource: this.state.clickSource,
            clientId: this.clientId
          }
        }
      }
    });
  };

  _proto.render = function render() {
    var _this$state$passedPro, _this$state$passedPro2, _this$state$passedPro3, _this$state$passedPro4, _this$state$passedPro5, _this$state$passedPro6, _this$state$passedPro7, _this$state$passedPro8;

    if (this.state.selfServiceAvailable && !this.redirectedFromSelfService && !this.props.isSourceInline && !this.state.selfServiceAttributes.selfServiceChannel.selfServiceContentId) {
      var _this$state$cti, _this$state$cti2, _this$state$cti3;

      var crumbsToPass = this.props.passedProps.crumbs; // Since we redirect to SSA, we do not need livehelp crumbs

      return /*#__PURE__*/React.createElement(SelfServiceRedirection, {
        fallbackErrorPageUrl: this.errorUrl,
        selfServiceAttributes: this.state.selfServiceAttributes,
        crumbs: crumbsToPass !== undefined ? crumbsToPass : [],
        presentationDetails: this.state.presentationDetails,
        category: (_this$state$cti = this.state.cti) === null || _this$state$cti === void 0 ? void 0 : _this$state$cti.C,
        type: (_this$state$cti2 = this.state.cti) === null || _this$state$cti2 === void 0 ? void 0 : _this$state$cti2.T,
        item: (_this$state$cti3 = this.state.cti) === null || _this$state$cti3 === void 0 ? void 0 : _this$state$cti3.I,
        employeeAttributes: this.state.employeeAttributes,
        userContext: this.state.userContext,
        preferredLanguage: this.state.preferredLanguage,
        liveHelpProps: this.state.passedProps,
        intent: this.state.cti,
        clickSource: this.state.clickSource,
        clientId: this.clientId
      });
    }

    if (this.state.redirectToCaseCreation) {
      var _this$state$cti4, _this$state$cti5, _this$state$cti6;

      return /*#__PURE__*/React.createElement(WorkflowRedirection, {
        workflowId: this.state.caseAttributes.caseContactChannel.caseContactAttributes.workflowId,
        crumbs: this.state.crumbs,
        presentationDetails: this.state.presentationDetails,
        crumbTitle: "" + i18.getInstance().t('livehelp.create_request'),
        category: (_this$state$cti4 = this.state.cti) === null || _this$state$cti4 === void 0 ? void 0 : _this$state$cti4.C,
        type: (_this$state$cti5 = this.state.cti) === null || _this$state$cti5 === void 0 ? void 0 : _this$state$cti5.T,
        item: (_this$state$cti6 = this.state.cti) === null || _this$state$cti6 === void 0 ? void 0 : _this$state$cti6.I,
        businessOwner: this.state.caseAttributes.caseContactChannel.caseContactAttributes.businessOwner,
        countryCode: this.state.employeeAttributes.country,
        recordTypeId: this.state.caseAttributes.caseContactChannel.caseContactAttributes.recordTypeId,
        clientId: this.clientId,
        clickSource: this.state.clickSource
      });
    }

    return /*#__PURE__*/React.createElement(View$1, {
      className: this.props.isSourceInline ? '' : 'livehelp-landing-page'
    }, this.state.isSpinnerActive ? /*#__PURE__*/React.createElement(SuspenseLoader, null) : /*#__PURE__*/React.createElement(I18nextProvider, {
      i18n: i18.getInstance()
    }, /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(ContactContainer, {
      props: this,
      intentDetails: (_this$state$passedPro = this.state.passedProps) === null || _this$state$passedPro === void 0 ? void 0 : (_this$state$passedPro2 = _this$state$passedPro.selectedIntent) === null || _this$state$passedPro2 === void 0 ? void 0 : _this$state$passedPro2.intentDetails,
      clickSource: this.state.clickSource,
      typeOfMRI: (_this$state$passedPro3 = this.state.passedProps) === null || _this$state$passedPro3 === void 0 ? void 0 : _this$state$passedPro3.typeOfMRI,
      variation: (_this$state$passedPro4 = this.state.passedProps) === null || _this$state$passedPro4 === void 0 ? void 0 : _this$state$passedPro4.variation,
      faqComponent: this.props.faqComponent,
      chatbotContentComponent: this.props.chatbotContentComponent,
      summaryComponent: this.props.summaryComponent,
      selfServiceAvailable: this.state.selfServiceAvailable,
      getContactChannelResponse: this.props.getContactChannelResponse
    })), this.state.viewContactCard && this.redirectToCall(), this.state.viewWPOContainer && /*#__PURE__*/React.createElement(WPOContainer, {
      intentDetails: (_this$state$passedPro5 = this.state.passedProps) === null || _this$state$passedPro5 === void 0 ? void 0 : (_this$state$passedPro6 = _this$state$passedPro5.selectedIntent) === null || _this$state$passedPro6 === void 0 ? void 0 : _this$state$passedPro6.intentDetails,
      clickSource: this.state.clickSource,
      typeOfMRI: (_this$state$passedPro7 = this.state.passedProps) === null || _this$state$passedPro7 === void 0 ? void 0 : _this$state$passedPro7.typeOfMRI,
      variation: (_this$state$passedPro8 = this.state.passedProps) === null || _this$state$passedPro8 === void 0 ? void 0 : _this$state$passedPro8.variation,
      setViewWPOContainer: this.setViewWPOContainer,
      employeeDetails: this.state.employeeAttributes,
      showContainer: this.state.viewWPOContainer
    })));
  };

  return Contact;
}(React.Component);
Contact.PAGE_NAME = PageName.CONTACT_CHANNEL;

var sleepUntil = function sleepUntil(condtion, timeoutInMilliseconds) {
  return new Promise(function (resolve, reject) {
    var timeWas = new Date().valueOf();
    var wait = setInterval(function () {
      if (condtion()) {
        clearInterval(wait);
        resolve();
      } else if (new Date().valueOf() - timeWas > timeoutInMilliseconds) {
        // Timeout
        clearInterval(wait);
        reject();
      }
    }, 20);
  });
};

/**
 * This method emits Error Logs and Metric for an API call in Inline component
 * @param error - Error occured in API call
 * @param operationName - Operation for which Error Metric will be calculated
 */

var emitApiCallErrorMetricInFab = function emitApiCallErrorMetricInFab(error, operationName) {
  var logContext = getLivehelpLogContextForInlineComponent(operationName, getClientId$1(), getPageName());
  recordErrorCountMetric(logContext.pageName, operationName, JSON.stringify(error));
  myHRLoggerErrorLog("[" + getUserIdentifier() + "]: Error occurred while calling API: " + operationName + ". " + getDetailedErrorMessage(error), logContext);
};
/**
 * This method emits Latency metric for an API call in Inline component
 * @param startTime - time at which API call started.
 * @param operationName - Operation for which Latency Metric will be calculated
 */

var emitApiCallLatencyMetricInFab = function emitApiCallLatencyMetricInFab(startTime, operationName) {
  var logContext = getLivehelpLogContextForInlineComponent(operationName, getClientId$1(), getPageName());
  recordLatencyMetric(logContext.pageName, operationName, startTime);
};
/**
 * This method emits Count metric and log API response in Inline component
 * @param apiResponse - Response for API
 * @param operationName - Operation for which count Metric will be calculated
 */

var emitApiCallCountMetricInFab = function emitApiCallCountMetricInFab(apiResponse, operationName) {
  var logContext = getLivehelpLogContextForInlineComponent(operationName, getClientId$1(), getPageName());
  recordCountMetric(logContext.pageName, operationName, MetricEvents.COUNT);
  myHRLoggerInfoLog("[" + getUserIdentifier() + "]: got response: " + JSON.stringify(apiResponse) + " while calling API " + operationName + " in pageName: " + logContext.pageName + " for clientId: " + logContext.clientId, logContext);
};

var chatContactChannel = {
	businessLine: "DLS",
	contactFlowId: "a06f63e0-6461-492b-9d12-d120a3ea4903",
	instanceId: "60c36f41-899a-4475-a01a-4db2172f2721",
	queueId: "5b48fb51-cf94-49cf-9acc-2b55e54a17af",
	region: "us-east-1",
	idlenessDisconnectTimeOutInMinutes: 6
};
var isAvailable = true;
var nextOperableQueueHours = {
	timezone: "GMT",
	day: "MONDAY",
	startTime: "4:30",
	endTime: "12:30"
};
var showNextAvailabilityTime = false;
var showWaitTime = true;
var waitTimeInMinutes = 0;
var surveyEnabled = true;
var connectAWSAccount = "152353010928";
var channelDisplayState = "ACTIVE";
var chatRecordingBehavior = "OptIn";
var channelPriority = 1000;
var ProdTestChatAttributes = {
	chatContactChannel: chatContactChannel,
	isAvailable: isAvailable,
	nextOperableQueueHours: nextOperableQueueHours,
	showNextAvailabilityTime: showNextAvailabilityTime,
	showWaitTime: showWaitTime,
	waitTimeInMinutes: waitTimeInMinutes,
	surveyEnabled: surveyEnabled,
	connectAWSAccount: connectAWSAccount,
	channelDisplayState: channelDisplayState,
	chatRecordingBehavior: chatRecordingBehavior,
	channelPriority: channelPriority
};

var employeeDetails = {
	country: "IND",
	legalName: "testName",
	login: "legal",
	mobilePhone: "9876543210",
	preferredName: "testName",
	buildingCode: "HYD13",
	timeZoneId: "Asia/Calcutta"
};
var caseAttributes = {
	caseContactChannel: {
		caseContactAttributes: {
			caseSystem: "Bali",
			ownerId: "00G7i000004K85q",
			recordTypeId: "0127i000001Q6jpAAC",
			workflowId: "1234567"
		}
	},
	isAvailable: true,
	channelDisplayState: "ACTIVE",
	showNextAvailabilityTime: false,
	showWaitTime: true,
	waitTimeInMinutes: 2147483647,
	channelPriority: 1000
};
var externalChatAttributes = {
	waitTimeInSeconds: 120,
	isAvailable: true,
	idlenessDisconnectTimeInMinutes: 4,
	channelDisplayState: "ACTIVE",
	externalChatType: "WPO"
};
var chatAttributes = {
	chatContactChannel: {
		businessLine: "ERC",
		contactFlowId: "393bf1b6-d75f-41e7-93fc-22f54b94125a",
		instanceId: "9a5e3395-4eba-4243-8f17-29e4e31915b9",
		queueId: "da52cc38-78be-47f1-9a4b-9caa58dedb19",
		region: "us-east-1",
		idlenessDisconnectTimeOutInMinutes: 6
	},
	isAvailable: true,
	nextOperableQueueHours: {
		timezone: "GMT",
		day: "MONDAY",
		startTime: "4:30",
		endTime: "12:30"
	},
	showNextAvailabilityTime: false,
	showWaitTime: true,
	waitTimeInMinutes: 0,
	surveyEnabled: true,
	connectAWSAccount: "152353010928",
	channelDisplayState: "ACTIVE",
	chatRecordingBehavior: "OptIn",
	channelPriority: null
};
var voiceAttributes = {
	isAvailable: true,
	nextOperableQueueHours: null,
	showNextAvailabilityTime: false,
	showWaitTime: true,
	channelDisplayState: "ACTIVE",
	voiceContactChannel: {
		businessLine: "DLS",
		contactFlowId: "91250c34-d6e6-4115-a891-e9ab77551ac4",
		instanceId: "9a5e3395-4eba-4243-8f17-29e4e31915b9",
		queueId: "a7f263d5-76ab-480a-8e38-e926ba0b9125",
		sourcePhoneNumber: "+13252190639",
		region: "us-east-1"
	},
	waitTimeInMinutes: 0,
	channelPriority: 1000
};
var selfServiceAttributes = {
	channelDisplayState: "NOT_SHOWN",
	isAvailable: false,
	selfServiceChannel: {
		selfServiceType: "URL",
		selfServiceContentId: "",
		additionalAttributes: {
			url: "/myhr/ssa/punchCorrection"
		}
	},
	showNextAvailabilityTime: false,
	showWaitTime: false,
	waitTimeInMinutes: 0
};
var clientConfig = {
	isChatHidden: false,
	isCallHidden: false,
	isCaseHidden: false,
	isSummaryHidden: false,
	isFaqHidden: false
};
var RoutingEngineMockResponse = {
	employeeDetails: employeeDetails,
	caseAttributes: caseAttributes,
	externalChatAttributes: externalChatAttributes,
	chatAttributes: chatAttributes,
	voiceAttributes: voiceAttributes,
	selfServiceAttributes: selfServiceAttributes,
	clientConfig: clientConfig
};

/**
 * Returns whether mocked chat attributes should be returned from {@link getContactChannels} function.
 * This is used for testing chat, since in most cases the chat is not available for indian employees.
 */

var shouldMockChat = function shouldMockChat() {
  var enableChatKey = 'enableChat';
  var trueString = 'true';
  return new URLSearchParams(window.location.search).get(enableChatKey) === trueString || !isProdStage() && localStorage.getItem(enableChatKey) === trueString;
};
/**
 * Function to fetch contact channels and content for given intent. Calls LiveHelp GetContactChannel API.
 *
 * @param intent CTI details used to fetch contact channels / content.
 * @param clientId The client or tenant using MyHR / FAB
 * @return {@link IGetContactChannelResponse} Response received from GetContactChannel API.
 */


var getContactChannels = function getContactChannels(intent, clientId) {
  try {
    var OPERATION_NAME = 'GetContactChannel';
    var OPERATION_NAME_FOR_INLINE_COMPONENT = 'GetContactChannelInInlineComponent';
    var PAGE_NAME = PageName.CONTACT_CHANNEL;
    var userIdentifier = getUserIdentifier();
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: userIdentifier,
      operationName: OPERATION_NAME,
      pageName: PAGE_NAME
    };

    if (!intent.category) {
      if (isComponentInline()) {// metric not required here as it is already captured in getIntentDetailsForInlineComponent() method
        // When component is inline, we don't want to redirect, instead show error banner
      } else {
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while fetching contact channel. Invalid userCategory - " + (intent === null || intent === void 0 ? void 0 : intent.category), logsContext);
        recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.INVALID_INPUT); // redirecting to main page when intent is null

        window.location.replace(getMyHRUrlPrefix());
      }

      throw Error("Error occurred while fetching contact channel. Invalid userCategory - " + (intent === null || intent === void 0 ? void 0 : intent.category));
    }

    var queryParams = {
      'x-myhr-client-id': 'MyHR_LiveHelp',
      operation: '/api/contact/channel'
    };
    var body = {
      userPreferredLanguage: fetchPreferredLanguage(),
      userIntent: intent,
      isUserOffNetwork: getIsUserOffNetwork(),
      clientId: clientId
    };
    var backendServiceClient = new BackendServiceClientWrapper();
    var startTimeGetContactChannel = Date.now();
    return Promise.resolve(backendServiceClient.post(body, queryParams).then(function (result) {
      var _getContactChannelRes, _getContactChannelRes2;

      var getContactChannelResponse = JSON.parse(result.data.response);

      if (isComponentInline()) {
        emitApiCallLatencyMetricInFab(startTimeGetContactChannel, OPERATION_NAME_FOR_INLINE_COMPONENT);
        emitApiCallCountMetricInFab(getContactChannelResponse, OPERATION_NAME_FOR_INLINE_COMPONENT);
      } else {
        recordLatencyMetric(PAGE_NAME, OPERATION_NAME, startTimeGetContactChannel);
        recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
      }

      var queryParameters = new URLSearchParams(location.search);
      var mockedChatAttributes = isProdStage() ? ProdTestChatAttributes : RoutingEngineMockResponse.chatAttributes;
      var chatAttributes = shouldMockChat() ? mockedChatAttributes : getContactChannelResponse.chatAttributes;
      var externalChatAttributes = shouldMockWPOChat() ? RoutingEngineMockResponse.externalChatAttributes : getContactChannelResponse.externalChatAttributes;
      var mockSelfService = queryParameters.get('enableSsa') === 'true';
      var selfServiceAttributes = mockSelfService ? RoutingEngineMockResponse.selfServiceAttributes : getContactChannelResponse.selfServiceAttributes;

      if ((_getContactChannelRes = getContactChannelResponse.voiceAttributes) !== null && _getContactChannelRes !== void 0 && _getContactChannelRes.isAvailable) {
        recordCountMetric(PAGE_NAME, 'VoiceChannel', MetricEvents.AVAILABILITY);
      }

      if (chatAttributes !== null && chatAttributes !== void 0 && chatAttributes.isAvailable) {
        recordCountMetric(PAGE_NAME, 'ChatChannel', MetricEvents.AVAILABILITY);
      }

      if ((_getContactChannelRes2 = getContactChannelResponse.caseAttributes) !== null && _getContactChannelRes2 !== void 0 && _getContactChannelRes2.isAvailable) {
        recordCountMetric(PAGE_NAME, 'CaseChannel', MetricEvents.AVAILABILITY);
      }

      return Object.assign({}, getContactChannelResponse, {
        chatAttributes: chatAttributes,
        selfServiceAttributes: selfServiceAttributes,
        externalChatAttributes: externalChatAttributes
      });
    })["catch"](function (error) {
      if (isComponentInline()) {
        emitApiCallErrorMetricInFab(error, OPERATION_NAME_FOR_INLINE_COMPONENT);
      } else {
        recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(error));
        myHRLoggerErrorLog("[" + userIdentifier + "]: Error occurred while calling backend GetContactChannel API. " + getDetailedErrorMessage(error), Object.assign({}, logsContext, {
          operationName: OPERATION_NAME
        }));
      }

      throw new Error("Error occurred while calling backend GetContactChannel API.");
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var MyHRContactWrapper = function MyHRContactWrapper(props) {
  var DEFAULT_CLIENT_ID = LaasClientId$1.MY_HR;
  var PAGE_NAME = PageName.CONTACT_CHANNEL;

  var _useState = useState(true),
      showSpinner = _useState[0],
      setShowSpinner = _useState[1];

  var _useState2 = useState(false),
      showErrorMessage = _useState2[0],
      setShowErrorMessage = _useState2[1];

  var passedProps = useRef({
    crumbs: [],
    clientId: DEFAULT_CLIENT_ID
  });
  var getContactChannelResponse = useRef();
  var isRedirected = useRef(false);
  var logsContext = useRef({
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: getUserIdentifier(),
    operationName: 'LiveHelpLanding',
    pageName: PAGE_NAME
  });

  var readURLParamsFromRedirection = function readURLParamsFromRedirection() {
    var OPERATION_NAME = 'LivehelpThroughQueryParamsCTI';
    var queryParameters = new URLSearchParams(window.location.search);
    var intent = {
      category: queryParameters.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CATEGORY),
      type: queryParameters.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.TYPE),
      item: queryParameters.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.ITEM)
    };
    var clientId = queryParameters.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID);

    if (intent.category) {
      recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
      myHRLoggerInfoLog("[" + getUserIdentifier() + "]: User accessed Livehelp through query param CTI. CTI details - " + JSON.stringify(intent), Object.assign({}, logsContext.current, {
        operationName: OPERATION_NAME
      }));
    }

    return {
      intent: intent,
      clientId: clientId
    };
  };

  var getPassedProps = function getPassedProps() {
    try {
      var propsToPass;

      var _temp3 = _finallyRethrows(function () {
        return _catch(function () {
          var _readURLParamsFromRed = readURLParamsFromRedirection(),
              intent = _readURLParamsFromRed.intent,
              clientId = _readURLParamsFromRed.clientId;

          var _temp = function () {
            if (intent.category) {
              var _URLSearchParams$get;

              // For Redirection, gets details from query params.
              var selectedIntent = {
                intentDetails: intent,
                presentationDetails: getPresentationDetailsFromIntent(intent)
              };
              var clickSource = (_URLSearchParams$get = new URLSearchParams(window.location.search).get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE)) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : SourcePagesForLiveHelpRedirection.QUERY;
              propsToPass = {
                selectedIntent: selectedIntent,
                crumbs: [],
                clickSource: clickSource,
                clientId: clientId
              };
              isRedirected.current = true;
            } else {
              // For livehelp in MyHR, gets details from location state of react router.
              return Promise.resolve(sleepUntil(function () {
                var _props$location, _props$location$state, _props$location$state2, _props$location$state3, _props$location$state4;

                return (_props$location = props.location) === null || _props$location === void 0 ? void 0 : (_props$location$state = _props$location.state) === null || _props$location$state === void 0 ? void 0 : (_props$location$state2 = _props$location$state.propsToPass) === null || _props$location$state2 === void 0 ? void 0 : (_props$location$state3 = _props$location$state2.selectedIntent) === null || _props$location$state3 === void 0 ? void 0 : (_props$location$state4 = _props$location$state3.intentDetails) === null || _props$location$state4 === void 0 ? void 0 : _props$location$state4.category;
              }, 200)).then(function () {
                var _props$location2, _props$location2$stat;

                propsToPass = (_props$location2 = props.location) === null || _props$location2 === void 0 ? void 0 : (_props$location2$stat = _props$location2.state) === null || _props$location2$stat === void 0 ? void 0 : _props$location2$stat.propsToPass; // sourcePage has higher priority than clickSource. If sourcePage is present it will be used as clickSource.

                if (propsToPass.sourcePage) {
                  propsToPass.clickSource = propsToPass.sourcePage;
                }
              });
            }
          }();

          if (_temp && _temp.then) return _temp.then(function () {});
        }, function () {
          var selectedIntent = parseStringifiedObject(localStorage.getItem('LiveHelpSelectedIntent'));
          var crumbs = parseStringifiedObject(localStorage.getItem('LiveHelpCrumbs'));
          propsToPass = {
            selectedIntent: selectedIntent,
            crumbs: crumbs
          };
        });
      }, function (_wasThrown, _result) {
        // validate clientId present in propsToPass, if clientId is absent or invalid. replace with MyHR.
        if (!propsToPass.clientId || !Object.values(LaasClientId$1).includes(propsToPass.clientId)) {
          propsToPass.clientId = DEFAULT_CLIENT_ID;
        }

        if (_wasThrown) throw _result;
        return _result;
      });

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {
        return propsToPass;
      }) : propsToPass);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var init = function init() {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(getPassedProps()).then(function (_getPassedProps) {
          passedProps.current = _getPassedProps;
          var _passedProps$current = passedProps.current,
              clientId = _passedProps$current.clientId,
              useREContent = _passedProps$current.useREContent,
              selectedIntent = _passedProps$current.selectedIntent;
          var intent = selectedIntent === null || selectedIntent === void 0 ? void 0 : selectedIntent.intentDetails;

          if (!intent || !intent.category) {
            var OPERATION_NAME = 'GetContactChannel';
            myHRLoggerErrorLog("[" + getUserIdentifier() + "]: Error occurred while fetching contact channel. Invalid userCategory - " + (intent === null || intent === void 0 ? void 0 : intent.category), logsContext.current);
            recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.INVALID_INPUT); // redirecting to main page when intent is null

            window.location.replace(getMyHRUrlPrefix());
            return;
          }

          return Promise.resolve(getContactChannels(intent, clientId !== null && clientId !== void 0 ? clientId : DEFAULT_CLIENT_ID)).then(function (_getContactChannels) {
            getContactChannelResponse.current = _getContactChannels;

            if (isRedirected.current || useREContent) {
              var contentAttributes = getContactChannelResponse.current.contentAttributes;

              if (useREContent) {
                contentAttributes = getFilteredContentAttribute(contentAttributes);
              }

              var filteredContentAttributes = buildContentAttributesForLiveHelpWrapper(contentAttributes);

              if (selectedIntent) {
                selectedIntent.contents = filteredContentAttributes;
              }

              props.setContentAttributes(filteredContentAttributes);
            }

            setShowSpinner(false);
          });
        });
      }, function () {
        setShowErrorMessage(true);
        setShowSpinner(false);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(function () {
    init();
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, showSpinner ? /*#__PURE__*/React.createElement(SuspenseLoader, null) : /*#__PURE__*/React.createElement(Contact, {
    getContactChannelResponse: getContactChannelResponse.current,
    passedProps: passedProps.current,
    showErrorMessage: showErrorMessage,
    chatbotContentComponent: props.chatbotContentComponent,
    summaryComponent: props.summaryComponent,
    faqComponent: props.faqComponent
  }));
};

// import { CreateCase } from "@amzn/pxt_myhr_caseui_shared";
/**
 * Wrapper function over CaseUI's create case to pass received props and render component appropriately on being routed to /myhr/createcase.
 */

function LiveHelpCreateCase() {
  return /*#__PURE__*/React.createElement(React.Fragment, null) // <CreateCase
  //   workflowId={props.location.state.workflowId}
  //   userInfo={{
  //     employeeId: props.location.state.employeeId,
  //     employeeAlias: props.location.state.employeeAlias
  //   }}
  //   cti={{
  //     C: props.location.state.category,
  //     T: props.location.state.type,
  //     I: props.location.state.item
  //   }}
  //   businessOwner={props.location.state.item}
  // />
  ;
}

var fetchChatTranscriptFromS3 = function fetchChatTranscriptFromS3(presignedS3Link) {
  try {
    var userIdentifier = getUserIdentifier();
    var PAGE_NAME = 'LiveHelpChatHistory';
    var OPERATION_NAME = 'FetchAndParseTranscript';
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: userIdentifier,
      pageName: PAGE_NAME,
      operationName: OPERATION_NAME
    };
    var chatDataArray = [];
    return Promise.resolve(_catch(function () {
      return Promise.resolve(fetch(presignedS3Link)).then(function (fetchedTranscript) {
        return Promise.resolve(fetchedTranscript.json()).then(function (response) {
          for (var _iterator = _createForOfIteratorHelperLoose(response.Transcript), _step; !(_step = _iterator()).done;) {
            var transcript = _step.value;
            var chatData = transcript;
            chatDataArray.push(chatData);
          }

          return chatDataArray;
        });
      });
    }, function (error) {
      myHRLoggerErrorLog("[" + userIdentifier + ": Error occurred in Chat History while fetching transcript from the presigned S3 link. " + getDetailedErrorMessage(error), logsContext);
      throw error;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var ChatHistoryContainer = function ChatHistoryContainer(props) {
  var plusButtonRef = useRef(null);
  var minusButtonRef = useRef(null);
  var chatCloseButtonRef = useRef(null);

  var _useState = useState([]),
      messages = _useState[0],
      _setMessages = _useState[1];

  var messagesRef = useRef(messages);

  var setMessages = function setMessages(data) {
    messagesRef.current = data;

    _setMessages(data);
  };

  var _useState2 = useState(i18.getInstance),
      i18Instance = _useState2[0];

  var _useTranslation = useTranslation(undefined, {
    i18n: i18Instance
  }),
      t = _useTranslation.t;

  var title = t('livehelp.previous_chat_history');
  var emptyTranscriptMessage = t('livehelp.empty_chat_present');
  var userIdentifier = getUserIdentifier();
  var messageRenderHelper = new MessageRenderHelper();
  var PAGE_NAME = 'LiveHelpChatHistory';
  var OPERATION_NAME = 'ChatHistoryOperations';
  var logsContext = {
    serviceName: ServiceName.LIVEHELP_SERVICE,
    userIdentifier: userIdentifier,
    pageName: PAGE_NAME,
    operationName: OPERATION_NAME
  };
  var languageDirection = document.documentElement.dir;

  var _useState3 = useState(true),
      isSpinnerActive = _useState3[0],
      setIsSpinnerActive = _useState3[1];

  var _useState4 = useState(),
      selectedHistoryRecord = _useState4[0],
      setSelectedHistoryRecord = _useState4[1];

  var _useState5 = useState({
    width: convertVwToPx(MIN_CONTAINER_WIDTH_BROWSER),
    height: convertVhToPx(MIN_CONTAINER_HEIGHT_BROWSER)
  }),
      chatContainerSize = _useState5[0],
      setChatContainerSize = _useState5[1];

  var _useChatHistoryContex = useChatHistoryContext(),
      isChatHistoryMinimised = _useChatHistoryContex.isChatHistoryMinimised,
      setIsChatHistoryMinimised = _useChatHistoryContex.setIsChatHistoryMinimised,
      setIsChatHistoryVisible = _useChatHistoryContex.setIsChatHistoryVisible;

  var _useChatContext = useChatContext(),
      chatState = _useChatContext.chatState;

  useEffect(function () {
    myHRLoggerInfoLog("[" + userIdentifier + ": Accessed Chat History", logsContext);
    recordCountMetric(PAGE_NAME, logsContext.operationName, MetricEvents.SUCCESS_COUNT);
  }, []);

  var focusMinus = function focusMinus() {
    setTimeout(function () {
      if (minusButtonRef.current) {
        minusButtonRef.current.focus();
      }
    }, 500);
  };

  var focusPlus = function focusPlus() {
    setTimeout(function () {
      if (plusButtonRef.current) {
        plusButtonRef.current.focus();
      }
    }, 100);
  };

  var getTranscriptFromS3 = function getTranscriptFromS3(chatRecord) {
    try {
      var FETCH_CHAT_TRANSCRIPT_OPERATION_NAME = 'FetchChatTranscript';
      return Promise.resolve(_finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(fetchChatTranscriptFromS3(chatRecord.presignedS3Link)).then(function (chatHistory) {
            var messageData = [];
            chatHistory.map(function (messageContent) {
              var newMessage = {
                displayName: messageContent.DisplayName,
                content: messageContent.Content ? messageContent.Content : '',
                index: messageData.length,
                messageId: messageContent.Id,
                participant: messageContent.ParticipantRole,
                type: messageContent.Type,
                timestamp: messageContent.AbsoluteTime
              };

              if (newMessage.participant === ParticipantRole.System || newMessage.type === MessageType.Event) {
                return;
              }

              if (newMessage.content !== undefined && newMessage.content !== null && newMessage.content.trim().length > 0) {
                messageData.push(newMessage);
              }
            });
            setMessages(messageData);

            if (messageData.length === 0) {
              messageRenderHelper.sendMessageFromSystem(emptyTranscriptMessage, messagesRef, setMessages);
            }

            myHRLoggerInfoLog("[" + userIdentifier + ": Successfully fetched Chat History transcript", logsContext);
            recordCountMetric(PAGE_NAME, FETCH_CHAT_TRANSCRIPT_OPERATION_NAME, MetricEvents.SUCCESS_COUNT);
          });
        }, function (error) {
          myHRLoggerErrorLog("[" + userIdentifier + ": Error occurred in Chat History while getting messages from transcript. " + getDetailedErrorMessage(error), logsContext);
          recordErrorCountMetric(PAGE_NAME, FETCH_CHAT_TRANSCRIPT_OPERATION_NAME, JSON.stringify(error));
          throw error;
        });
      }, function (_wasThrown, _result) {
        setIsSpinnerActive(false);
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(function () {
    var atozHeader = document.getElementById('employeenav');
    var defaultZIndexAtoZ = atozHeader === null || atozHeader === void 0 ? void 0 : atozHeader.style.zIndex;

    if (atozHeader) {
      atozHeader.style.zIndex = '750';
    }

    getTranscriptFromS3(props.chatRecords[0]);
    setSelectedHistoryRecord(props.chatRecords[0]);
    return function () {
      if (atozHeader) {
        atozHeader.style.zIndex = defaultZIndexAtoZ || '1000';
      }
    };
  }, []);

  var MinimizedChatHeader = function MinimizedChatHeader() {
    return /*#__PURE__*/React.createElement(View$1, {
      className: languageDirection === 'rtl' ? 'header-minimized-container-left' : 'header-minimized-container-right',
      style: languageDirection === 'rtl' ? {
        marginLeft: chatState.isActive ? '30.5%' : '0px'
      } : {
        marginRight: chatState.isActive ? '30.5%' : '0px'
      }
    }, /*#__PURE__*/React.createElement(Row, {
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(H2, {
      color: "#ffffff",
      fontSize: "16px !important",
      fontWeight: 500
    }, title), /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Primary,
      onClick: function onClick() {
        setIsChatHistoryMinimised(false);
        focusMinus();
      },
      icon: /*#__PURE__*/React.createElement(IconPlus, {
        color: "white",
        title: t('livehelp.maximize_chat_history')
      }),
      className: "maximize-btn",
      ref: plusButtonRef
    })));
  };

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var close = function close() {
    var CLOSE_CHAT_HISTORY_CONTAINER_OPERATION_NAME = 'CloseChatHistoryContainer';
    setIsChatHistoryMinimised(false);
    setIsChatHistoryVisible(false);
    myHRLoggerInfoLog("[" + userIdentifier + ": Closed chat history window", logsContext);
    recordCountMetric(PAGE_NAME, CLOSE_CHAT_HISTORY_CONTAINER_OPERATION_NAME, MetricEvents.COUNT);
  };

  var onMinimizeChat = function onMinimizeChat() {
    setIsChatHistoryMinimised(true);
    focusPlus();
  };

  var closeOnEscape = function closeOnEscape(event) {
    var ESCAPE_KEY_CODE = 27;

    if (!isChatHistoryMinimised && event.keyCode === ESCAPE_KEY_CODE) {
      close();
    }
  };

  var downloadTranscriptService = new DownloadTranscriptService();

  var saveChat = function saveChat() {
    downloadTranscriptService.downloadTranscript(messages);
  };

  var ChatBodyAndFooter = function ChatBodyAndFooter() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MessageBoard, {
      messages: messages,
      isAgentTyping: false,
      chatSession: null,
      setChatSession: null,
      chatConnectionToggled: false,
      setChatConnectionToggled: null,
      messagesRef: messagesRef,
      setMessages: setMessages,
      participantToken: '',
      isHistoryComponent: true,
      fileUploadStatus: AttachmentUploadStatus.Inactive
    }), /*#__PURE__*/React.createElement(Container, {
      isFullWidth: true,
      paddingHorizontal: 0,
      paddingBottom: 0,
      paddingTop: 0,
      className: matches.s ? 'chat-history-footer-container-zoomed' : 'footer-container',
      backgroundColor: "white"
    }, /*#__PURE__*/React.createElement(View$1, {
      className: !matches.s ? 'chat-history-container-view' : ''
    }, /*#__PURE__*/React.createElement(View$1, {
      padding: {
        left: '16px',
        right: '16px',
        top: '0px',
        bottom: '0px'
      },
      width: '100%'
    }, /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Primary,
      className: "chat-end-utilities-bar-button",
      onClick: close,
      ref: chatCloseButtonRef
    }, t('livehelp.close')), isEnvironmentBrowser() && /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.Secondary,
      className: "chat-end-utilities-bar-button button-save-chat",
      onClick: saveChat
    }, t('livehelp.download_transcript'))))));
  };

  var displayDate = function displayDate(timeStamp) {
    return new Date(parseInt(timeStamp)).toLocaleString();
  };

  var getChatRecordName = function getChatRecordName(userContext, timeStamp) {
    return userContext + ' - ' + displayDate(timeStamp);
  };

  var renderOption = function renderOption(selectedOption) {
    return /*#__PURE__*/React.createElement(Row, {
      gridGap: "S200",
      alignItems: "center"
    }, getChatRecordName(selectedOption.userContext, selectedOption.unixTimestamp));
  };

  var onChatContainerResizeStops = function onChatContainerResizeStops(_event, _direction, _elementRef, dimensionsDelta) {
    var width = dimensionsDelta.width,
        height = dimensionsDelta.height;
    setChatContainerSize(function (prevSize) {
      return {
        width: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.width) + width,
        height: (prevSize === null || prevSize === void 0 ? void 0 : prevSize.height) + height
      };
    });
  };

  var renderNativeOption = function renderNativeOption(selectedOption) {
    return getChatRecordName(selectedOption.userContext, selectedOption.unixTimestamp);
  };

  var onChangeOption = function onChangeOption(selectedOption) {
    try {
      setIsSpinnerActive(true);
      setSelectedHistoryRecord(selectedOption);
      return Promise.resolve(getTranscriptFromS3(selectedOption)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var filterOptions = function filterOptions(query) {
    var _props$chatRecords;

    return !!query ? (_props$chatRecords = props.chatRecords) === null || _props$chatRecords === void 0 ? void 0 : _props$chatRecords.filter(function (chatRecord) {
      return chatRecord.userContext.toLowerCase().includes(query.toLowerCase());
    }) : props.chatRecords;
  };

  var valueAccessor = function valueAccessor(selectedOption) {
    return getChatRecordName(selectedOption.userContext, selectedOption.unixTimestamp);
  };

  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18Instance
  }, (matches.l || matches.xl) && isChatHistoryMinimised ? /*#__PURE__*/React.createElement(MinimizedChatHeader, null) : /*#__PURE__*/React.createElement(Flyout, {
    isOpen: !isChatHistoryMinimised,
    close: function close() {
      return null;
    },
    shouldCloseOnClickOutside: false,
    "aria-labelledby": "previouschathistory-heading"
  }, /*#__PURE__*/React.createElement(Col, {
    maxWidth: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Resizable, {
    className: matches.l || matches.xl ? languageDirection === 'rtl' ? 'chat-container-left' : 'chat-container-right' : 'chat-container-mobile',
    size: chatContainerSize,
    onResizeStop: onChatContainerResizeStops,
    enable: matches.l || matches.xl ? BROWSER_RESIZE_SIDES_ENABLED : MOBILE_RESIZE_SIDES_ENABLED,
    minHeight: MIN_CONTAINER_HEIGHT_BROWSER,
    minWidth: MIN_CONTAINER_WIDTH_BROWSER,
    maxHeight: MAX_CONTAINER_HEIGHT,
    maxWidth: MAX_CONTAINER_WIDTH
  }, /*#__PURE__*/React.createElement(View$1, {
    height: '100%',
    width: '100%',
    style: {
      visibility: isChatHistoryMinimised ? 'hidden' : 'visible'
    },
    onKeyDown: closeOnEscape
  }, /*#__PURE__*/React.createElement(View$1, {
    height: '100%',
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Header$1, {
    onCloseChat: close,
    idlenessBannerTimeInMinutes: 10,
    anyChildModalOpen: true,
    chatState: null,
    onMinimizeChat: onMinimizeChat,
    minusButtonRef: minusButtonRef,
    setChatState: function setChatState() {
      return null;
    },
    isChatHistoryComponent: true
  }), /*#__PURE__*/React.createElement(Col, {
    gridGap: "S200",
    className: "select-container"
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "choose-history",
    id: "chat-history-selector",
    className: "select-label"
  }, t('livehelp.choose_chat_history')), /*#__PURE__*/React.createElement(Select, {
    labelId: "chat-history-selector",
    options: props.chatRecords,
    renderOption: renderOption,
    renderNativeOption: renderNativeOption,
    onChange: onChangeOption,
    layout: SelectLayout.Custom,
    value: selectedHistoryRecord,
    isSearchable: true,
    isMulti: false,
    filterOptions: filterOptions,
    valueAccessor: valueAccessor,
    listMaxHeight: "60vh"
  })), isSpinnerActive ? /*#__PURE__*/React.createElement(ChatSpinner, null) : /*#__PURE__*/React.createElement(ChatBodyAndFooter, null)))))));
};

var getChatHistory = function getChatHistory(body) {
  try {
    var PAGE_NAME = 'LiveHelpChatHistory';
    var OPERATION_NAME = 'GetChatHistory';
    var logsContext = {
      serviceName: ServiceName.LIVEHELP_SERVICE,
      userIdentifier: getUserIdentifier(),
      pageName: PAGE_NAME,
      operationName: OPERATION_NAME
    };
    var queryParams = {
      'x-myhr-client-id': 'MyHR_LiveHelp',
      operation: '/api/chat/metadata'
    };
    var backendServiceClient = new BackendServiceClientWrapper();
    var startTime = Date.now();
    return Promise.resolve(_catch(function () {
      return Promise.resolve(backendServiceClient.post(body, queryParams)).then(function (result) {
        recordLatencyMetric(PAGE_NAME, OPERATION_NAME, startTime);
        recordCountMetric(PAGE_NAME, OPERATION_NAME, MetricEvents.SUCCESS_COUNT);

        if (result === null) {
          return null;
        }

        var chatHistory = JSON.parse(result.data.response);
        return chatHistory;
      });
    }, function (error) {
      myHRLoggerErrorLog("[" + logsContext.userIdentifier + ": Error occurred in Chat History while fetching response from the ChatHistory API. " + getDetailedErrorMessage(error), logsContext);
      recordErrorCountMetric(PAGE_NAME, OPERATION_NAME, JSON.stringify(error));
      throw error;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

/*
 * Queries MyHRLiveHelpService to check if employee has an active chat session.
 * if active chat session is present, sets the chatState accordingly.
 */

var getActiveChatSession = function getActiveChatSession(chatState, setChatState) {
  try {
    if (!chatState.isActive) {
      var mayDayServices = new MayDayServices();
      mayDayServices.getActiveChatSession().then(function (activeChatSession) {
        if (activeChatSession !== null) {
          setChatState(Object.assign({}, defaultChatState, {
            isActive: true,
            chatTokens: {
              contactId: activeChatSession.contactId,
              initialContactId: activeChatSession.initialContactId,
              participantId: activeChatSession.participantId,
              participantToken: activeChatSession.participantToken
            },
            instanceId: activeChatSession.instanceId,
            region: activeChatSession.region,
            businessLine: activeChatSession.businessLine,
            currentLanguage: fetchPreferredLanguage(),
            timeStampForLiveHelpClick: Date.now(),
            timeStampForChatClick: Date.now(),
            connectAWSAccount: activeChatSession.connectAWSAccount,
            idlenessDisconnectTimeOutInMinutes: activeChatSession.idlenessDisconnectTimeOutInMinutes
          }));
        }
      });
    }

    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};
/*
 * Returns chatState values from session storage.
 * if chatState is not present in session storage, returns default values.
 */

var initChatState = function initChatState() {
  var savedChatStateString = sessionStorage.getItem(CHAT_STATE_KEY);

  if (savedChatStateString === null) {
    return defaultChatState;
  }

  var savedChatState = JSON.parse(savedChatStateString);
  return Object.assign({}, savedChatState, {
    agentConnected: defaultChatState.agentConnected,
    idlenessReminder: defaultChatState.idlenessReminder,
    idlenessBannerTimeInMinutes: defaultChatState.idlenessBannerTimeInMinutes,
    timerState: defaultChatState.timerState,
    activateListener: defaultChatState.activateListener,
    confirmExit: defaultChatState.confirmExit
  });
};
/*
 * Returns chatSession values from session storage.
 * if chatState is not present in session storage, returns default values.
 */

var initChatSession = function initChatSession() {
  var savedChatStateString = sessionStorage.getItem(CHAT_STATE_KEY);

  if (savedChatStateString === null) {
    return defaultChatSession;
  }

  var savedChatState = JSON.parse(savedChatStateString);
  return Object.assign({}, defaultChatSession, {
    connectionStatus: savedChatState.isDescribeIssue ? ChatSessionConnectionStatus.DescribeIssue : ChatSessionConnectionStatus.Attempting
  });
};
/*
 * Updates chatState value in session storage.
 */

var onChatStateChange = function onChatStateChange(newChatState, newChatSession) {
  if (newChatState.isActive && (newChatSession.connectionStatus === ChatSessionConnectionStatus.Connected || newChatSession.connectionStatus === ChatSessionConnectionStatus.DescribeIssue)) {
    sessionStorage.setItem(CHAT_STATE_KEY, JSON.stringify(newChatState));
  } else {
    sessionStorage.removeItem(CHAT_STATE_KEY);
  }
};

var LiveHelpChat = function LiveHelpChat(props) {
  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var _useState = useState(initChatState),
      chatState = _useState[0],
      _setChatState = _useState[1];

  var _useState2 = useState(initChatSession),
      chatSession = _useState2[0],
      _setChatSession = _useState2[1];

  var setChatState = function setChatState(newChatState) {
    _setChatState(function (prevState) {
      return Object.assign({}, prevState, newChatState);
    });
  };

  var setChatSession = function setChatSession(newChatSession) {
    _setChatSession(function (prevState) {
      return Object.assign({}, prevState, newChatSession);
    });
  };

  useEffect(function () {
    getActiveChatSession(chatState, setChatState);
  }, []);
  useEffect(function () {
    onChatStateChange(chatState, chatSession);
  }, [chatState, chatSession]);
  useEffect(function () {
    if (window && !matches.l && !matches.xl) {
      if (!chatState.isChatMinimized && chatState.isActive) {
        /**
         * CR : https://code.amazon.com/reviews/CR-81605579
         * Creating a dom node so as to provide scroll effect on non-scrollable page.
         */
        var paragraphElement = document.createElement('p');
        paragraphElement.id = SCROLL_ELEMENT.ID;
        paragraphElement.style.cssText = SCROLL_ELEMENT.CSS;
        document.body.appendChild(paragraphElement);
        window.scrollTo(0, SCROLL_ELEMENT.PIXELS_TO_SCROLL_FROM_TOP);
      } else {
        var _document$getElementB;

        window.scrollTo(0, -SCROLL_ELEMENT.PIXELS_TO_SCROLL_FROM_TOP);
        (_document$getElementB = document.getElementById(SCROLL_ELEMENT.ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
      }
    }
  }, [chatState.isChatMinimized, chatState.isActive]);
  return /*#__PURE__*/React.createElement(ChatContext.Provider, {
    value: {
      chatState: chatState,
      chatSession: chatSession,
      setChatState: setChatState,
      setChatSession: setChatSession
    }
  }, chatState.isActive && /*#__PURE__*/React.createElement(ChatContainer, null), props.children);
};

/**
 * @function getWindowDimensions
 * @returns window dimensions
 */

function getWindowDimensions() {
  var _window = window,
      width = _window.innerWidth,
      height = _window.innerHeight;
  return {
    width: width,
    height: height
  };
}
/**
 *
 * @function useWindowDimensions
 * @returns { width , height } where width and height keys depicting respective dimensions of window
 */


var useWindowDimensions = function useWindowDimensions() {
  var _useState = useState(getWindowDimensions()),
      windowDimensions = _useState[0],
      setWindowDimensions = _useState[1];

  useEffect(function () {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowDimensions;
};

/*
 default values will only be used when context provider is not present in the DOM. In which case we will be showing
 error banner
 */

var FABContactWrapperContext = /*#__PURE__*/createContext({
  pageName: PageName.LIVEHELP_INLINE_PAGE_NAME,
  showErrorMessage: true,
  clientId: LaasClientId$1.MY_HR
});
var useFABContactWrapperContext = function useFABContactWrapperContext() {
  return useContext(FABContactWrapperContext);
};

var FABContactWrapper = function FABContactWrapper() {
  var _useFABContactWrapper = useFABContactWrapperContext(),
      intent = _useFABContactWrapper.intent,
      getContactChannelResponse = _useFABContactWrapper.getContactChannelResponse,
      showErrorMessage = _useFABContactWrapper.showErrorMessage,
      clientId = _useFABContactWrapper.clientId,
      pageName = _useFABContactWrapper.pageName;

  var passedProps = useMemo(function () {
    var selectedIntent = {
      intentDetails: intent,
      presentationDetails: getPresentationDetailsFromIntent(intent)
    };
    return {
      selectedIntent: selectedIntent,
      crumbs: [],
      clientId: clientId,
      clickSource: pageName !== null && pageName !== void 0 ? pageName : PageName.LIVEHELP_INLINE_PAGE_NAME
    };
  }, [intent, clientId, pageName]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Contact, {
    getContactChannelResponse: getContactChannelResponse,
    passedProps: passedProps,
    showErrorMessage: showErrorMessage,
    isSourceInline: true
  }));
};

/**
 *
 * @remarks
 * in future another @param prefferedLanguage will be used.
 */

var LiveHelpWrapper = function LiveHelpWrapper(_ref) {
  var pageName = _ref.pageName;
  return /*#__PURE__*/React.createElement(MemoryRouter, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: PATHNAME.ROOT
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: PATHNAME.LIVEHELP_LANDING_PAGE
    }
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: PATHNAME.LIVEHELP_LANDING_PAGE,
    render: function render() {
      return /*#__PURE__*/React.createElement(FABContactWrapper, null);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: PATHNAME.CALL,
    render: function render(routeProps) {
      var _routeProps$location$, _routeProps$location$2, _routeProps$location$3, _routeProps$location$4, _routeProps$location$5, _routeProps$location$6, _routeProps$location$7, _routeProps$location$8, _routeProps$location$9, _routeProps$location$10, _routeProps$location$11, _routeProps$location$12, _routeProps$location$13, _routeProps$location$14, _routeProps$location$15, _routeProps$location$16, _routeProps$location$17, _routeProps$location$18;

      return /*#__PURE__*/React.createElement(PhoneContactCard, Object.assign({}, routeProps, {
        isSourceInline: true,
        voiceContactChannel: (_routeProps$location$ = routeProps.location.state) === null || _routeProps$location$ === void 0 ? void 0 : (_routeProps$location$2 = _routeProps$location$.propsToPass) === null || _routeProps$location$2 === void 0 ? void 0 : _routeProps$location$2.voiceContactChannel,
        employeeAttributes: (_routeProps$location$3 = routeProps.location.state) === null || _routeProps$location$3 === void 0 ? void 0 : (_routeProps$location$4 = _routeProps$location$3.propsToPass) === null || _routeProps$location$4 === void 0 ? void 0 : _routeProps$location$4.employeeAttributes,
        preferredLanguage: (_routeProps$location$5 = routeProps.location.state) === null || _routeProps$location$5 === void 0 ? void 0 : (_routeProps$location$6 = _routeProps$location$5.propsToPass) === null || _routeProps$location$6 === void 0 ? void 0 : _routeProps$location$6.preferredLanguage,
        voiceAttributes: (_routeProps$location$7 = routeProps.location.state) === null || _routeProps$location$7 === void 0 ? void 0 : (_routeProps$location$8 = _routeProps$location$7.propsToPass) === null || _routeProps$location$8 === void 0 ? void 0 : _routeProps$location$8.voiceAttributes,
        userContext: (_routeProps$location$9 = routeProps.location.state) === null || _routeProps$location$9 === void 0 ? void 0 : (_routeProps$location$10 = _routeProps$location$9.propsToPass) === null || _routeProps$location$10 === void 0 ? void 0 : _routeProps$location$10.userContext,
        crumbs: (_routeProps$location$11 = routeProps.location.state) === null || _routeProps$location$11 === void 0 ? void 0 : (_routeProps$location$12 = _routeProps$location$11.propsToPass) === null || _routeProps$location$12 === void 0 ? void 0 : _routeProps$location$12.crumbs,
        waitTimeInMin: (_routeProps$location$13 = routeProps.location.state) === null || _routeProps$location$13 === void 0 ? void 0 : (_routeProps$location$14 = _routeProps$location$13.propsToPass) === null || _routeProps$location$14 === void 0 ? void 0 : _routeProps$location$14.waitTimeInMin,
        isVoiceWaitTimeHidden: (_routeProps$location$15 = routeProps.location.state) === null || _routeProps$location$15 === void 0 ? void 0 : (_routeProps$location$16 = _routeProps$location$15.propsToPass) === null || _routeProps$location$16 === void 0 ? void 0 : _routeProps$location$16.isVoiceWaitTimeHidden,
        timeStampForLiveHelpClick: (_routeProps$location$17 = routeProps.location.state) === null || _routeProps$location$17 === void 0 ? void 0 : (_routeProps$location$18 = _routeProps$location$17.propsToPass) === null || _routeProps$location$18 === void 0 ? void 0 : _routeProps$location$18.timeStampForLiveHelpClick,
        liveHelpClickSource: pageName
      }));
    }
  })));
};

var css_248z$m = "#livehelp-inline-title{background-color:#fff;color:#161e2d;font-size:22px!important}#livehelp-inline-subtitle{color:#394451;font-size:16px!important;font-weight:400}";
styleInject(css_248z$m);

var _templateObject$3;
var InlineHeaderText = /*#__PURE__*/styledWithTheme(Text$1)(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 24px !important;\n"])));
var LiveHelpInlineComponent = function LiveHelpInlineComponent(_ref) {
  var pageName = _ref.pageName,
      isLiveHelpInlineActive = _ref.isLiveHelpInlineActive,
      handleLiveHelpInline = _ref.handleLiveHelpInline;

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var _useWindowDimensions = useWindowDimensions(),
      height = _useWindowDimensions.height;

  var _useState = useState(i18.getInstance()),
      i18Instance = _useState[0],
      setI18Instance = _useState[1];

  var _useTranslation = useTranslation(undefined, {
    i18n: i18Instance
  }),
      t = _useTranslation.t;

  var _useState2 = useState(ATOZ_NAVBAR_ZINDEX.THOUSAND),
      originalAtoZNavbarZindex = _useState2[0],
      setOriginalAtoZNavbarZindex = _useState2[1];

  var _useState3 = useState(initialLiveHelpServiceState),
      liveHelpServiceState = _useState3[0],
      _setLiveHelpServiceState = _useState3[1];

  var _useBreakpoints2 = useBreakpoints({
    propsMap: {
      s: {
        height: height / 2
      },
      "default": {
        height: height / 3
      }
    }
  }),
      modalResponsiveProps = _useBreakpoints2.props;
  /**
   * @constant isMobile for checking whether mobile screen or desktop
   */


  var isMobile = matches === null || matches === void 0 ? void 0 : matches.s;

  var setLiveHelpServiceState = function setLiveHelpServiceState(newLiveHelpServiceState) {
    _setLiveHelpServiceState(function (prevState) {
      return Object.assign({}, prevState, newLiveHelpServiceState);
    });
  };

  var close = function close() {
    handleLiveHelpInline(false);
  };
  /**
   * @function getModalTitle
   * @returns translated string title of inline modal on the basis of user preffered language
   */


  var getTitle = function getTitle() {
    switch (liveHelpServiceState.activeChannel) {
      case LiveHelpChannel.CHAT:
        {
          return t('livehelp.chat_with_HR');
        }

      case LiveHelpChannel.CALL:
        {
          return t('livehelp.request_a_call');
        }

      case LiveHelpChannel.REQUEST:
        {
          return 'Provide Request Details';
        }

      default:
        {
          return t('livehelp.get_help');
        }
    }
  };
  /**
   * @function getSubTitle
   * @returns string which is the subtitle of the inline widget
   */


  var getSubTitle = function getSubTitle() {
    if (getTitle() === t('livehelp.get_help')) {
      return t('livehelp.connect_with_hr_by_chat_phone_request');
    }

    return '';
  };
  /**
   * @returns Array of inline footer components
   */


  var getLiveHelInlineFooterActions = function getLiveHelInlineFooterActions() {
    return [/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      style: {
        width: '100%'
      },
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(View$1, {
      style: {
        margin: 'auto 0px',
        fontSize: isMobile ? '14px' : '16px'
      }
    }, t('livehelp.fab_footer_text'), " \xA0", isMobile ? t('livehelp.go_to') : t('livehelp.open'), " \xA0", /*#__PURE__*/React.createElement(Link, {
      href: "/myhr",
      target: "_blank",
      icon: !isMobile && /*#__PURE__*/React.createElement(IconExternalLink, {
        size: 16
      })
    }, MY_HR)), !isMobile && /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Button, {
      onClick: close,
      variant: ButtonVariant.Secondary,
      style: {
        fontSize: '16px'
      }
    }, t('livehelp.close')))))];
  };
  /**
   * @remarks
   * this effect helps when popup is reopened so inline  modal opening is
   * dependent on the external trigger the button
   */


  useEffect(function () {
    if (isLiveHelpInlineActive) {
      setLiveHelpServiceState(Object.assign({}, initialLiveHelpServiceState, {
        liveHelpInlineFooterActions: getLiveHelInlineFooterActions(),
        isGetHelpActive: true
      }));
      setI18Instance(i18.getInstance);
    }

    var atozHeader = document.getElementById('employeenav');

    if (atozHeader && !isMobile) {
      atozHeader.style.zIndex = isLiveHelpInlineActive || LiveHelpChannel.CHAT === liveHelpServiceState.activeChannel ? ATOZ_NAVBAR_ZINDEX.SEVENT_FIFY : originalAtoZNavbarZindex !== null && originalAtoZNavbarZindex !== void 0 ? originalAtoZNavbarZindex : ATOZ_NAVBAR_ZINDEX.THOUSAND;
    }
  }, [isLiveHelpInlineActive]);
  /**
   * @remarks
   * replicating the logic of z-index of the chatcontainer
   */

  useEffect(function () {
    var _atozHeader$style$zIn;

    var atozHeader = document.getElementById('employeenav');
    setOriginalAtoZNavbarZindex((_atozHeader$style$zIn = atozHeader === null || atozHeader === void 0 ? void 0 : atozHeader.style.zIndex) !== null && _atozHeader$style$zIn !== void 0 ? _atozHeader$style$zIn : ATOZ_NAVBAR_ZINDEX.THOUSAND);
  }, []);
  var liveHelpServiceValue = useMemo(function () {
    return {
      liveHelpServiceState: liveHelpServiceState,
      setLiveHelpServiceState: setLiveHelpServiceState,
      closeModal: close
    };
  }, [liveHelpServiceState]);
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18Instance
  }, /*#__PURE__*/React.createElement(LiveHelpInlineContext.Provider, {
    value: liveHelpServiceValue
  }, isMobile ? /*#__PURE__*/React.createElement(Modal, {
    close: close,
    isOpen: isLiveHelpInlineActive,
    style: ModalStyle.BottomSheet,
    shouldCloseOnClickOutside: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    titleTextId: "livehelp-inline-title",
    maxWidth: null,
    titleText: getTitle(),
    onCloseButtonClick: close,
    buttons: liveHelpServiceState.liveHelpInlineFooterActions
  }, /*#__PURE__*/React.createElement(Col, Object.assign({
    overflow: "auto"
  }, modalResponsiveProps), liveHelpServiceState.activeChannel === LiveHelpChannel.NONE && /*#__PURE__*/React.createElement(ModalTitle, {
    id: "livehelp-inline-subtitle"
  }, getSubTitle()), /*#__PURE__*/React.createElement(LiveHelpWrapper, {
    pageName: pageName
  })))) : /*#__PURE__*/React.createElement(Flyout, {
    close: close,
    isOpen: isLiveHelpInlineActive,
    shouldCloseOnClickOutside: true
  }, /*#__PURE__*/React.createElement(FlyoutContent, {
    titleText: t('livehelp.myhr_contact_us'),
    renderTitle: function renderTitle(_ref2) {
      var titleText = _ref2.titleText;
      return /*#__PURE__*/React.createElement(InlineHeaderText, {
        fontWeight: 400,
        color: "#FFFFFF"
      }, titleText);
    },
    onCloseButtonClick: close,
    buttons: liveHelpServiceState.liveHelpInlineFooterActions
  }, /*#__PURE__*/React.createElement(View$1, {
    width: INLINE_FLYOUT_WIDTH_PX + "px"
  }), liveHelpServiceState.activeChannel === LiveHelpChannel.NONE && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InlineHeaderText, {
    fontWeight: 500
  }, getTitle()), /*#__PURE__*/React.createElement(Text$1, {
    fontSize: LiveHelpInlineFontScheme.GET_HELP_SUBTITLE
  }, getSubTitle())), /*#__PURE__*/React.createElement(LiveHelpWrapper, {
    pageName: pageName
  })))));
};

/**
 * Function to call GetIntentFromContext operation of MyHR RoutingEngine.
 * @param pageName - context to fetch CTI details for
 * @return returns intent details if found in API response, else returns undefined.
 */

var getIntentDetailsFromContext = function getIntentDetailsFromContext(pageName) {
  try {
    var backendServiceClient = new BackendServiceClientWrapper();
    var queryParams = {
      'x-myhr-client-id': 'MyHR_RoutingEngine',
      operation: 'GetIntentFromContext',
      path: '/'
    };
    var body = {
      context: pageName,
      employeeId: getUserIdentifier()
    };
    var OPERATION_NAME_FOR_GET_INTENT_DETAILS_FROM_PAGE_NAME = 'GetIntentDetailsFromPageName';
    return Promise.resolve(_catch(function () {
      var startTimeGetIntentDetailsFromPageName = Date.now();
      return Promise.resolve(backendServiceClient.post(body, queryParams)).then(function (result) {
        var _getIntentFromContext;

        emitApiCallLatencyMetricInFab(startTimeGetIntentDetailsFromPageName, OPERATION_NAME_FOR_GET_INTENT_DETAILS_FROM_PAGE_NAME);
        var getIntentFromContextResponse = JSON.parse(result.data.response);
        emitApiCallCountMetricInFab(getIntentFromContextResponse, OPERATION_NAME_FOR_GET_INTENT_DETAILS_FROM_PAGE_NAME);

        if (!((_getIntentFromContext = getIntentFromContextResponse.intent) !== null && _getIntentFromContext !== void 0 && _getIntentFromContext.category)) {
          var USER_INTENT_NULL_OPERATION_NAME = 'UserIntentNull';
          recordErrorCountMetric(getPageName(), USER_INTENT_NULL_OPERATION_NAME, "[" + getUserIdentifier() + "]: Unable to get Intents from Page Name");
          return undefined;
        }

        return getIntentFromContextResponse.intent;
      });
    }, function (error) {
      emitApiCallErrorMetricInFab(error, OPERATION_NAME_FOR_GET_INTENT_DETAILS_FROM_PAGE_NAME);
      throw Error("Error occurred while calling GetIntentDetailsFromPageName API.");
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$4;
/*
 Reduce stencil spinner size to 24x24 from 28x28 as stencil does not allow granular control over spinner size.
 Adding negative margin since even after transform the spinner will occupy 28x28 space, therefor reducing 2px from
 each side. This will allow seamless transition from MyHR icon to spinner and vice versa.
 */

var FABIconSpinner = /*#__PURE__*/styledWithTheme(Spinner)(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  transform: scale(0.85);\n  margin: -2px;\n"])));
var LiveHelpFAB = function LiveHelpFAB(_ref) {
  var clientId = _ref.clientId,
      draggable = _ref.draggable,
      intent = _ref.intent,
      pageName = _ref.pageName;

  var _useState = useState(false),
      showWidget = _useState[0],
      _setShowWidget = _useState[1];

  var _useState2 = useState(false),
      showSpinner = _useState2[0],
      setShowSpinner = _useState2[1];

  var _useState3 = useState(undefined),
      fabContactProps = _useState3[0],
      setFABContactProps = _useState3[1];

  var setShowWidget = function setShowWidget(value) {
    if (showWidget !== value) {
      if (value) {
        setFABContactProps(undefined);
        WebAnalytics.sendOmnitureMetric({
          pageName: PageName.INLINE_OMNITURE_PAGE_NAME,
          pageAction: PageActionsForOmnitureMetrics.FAB_CLICK,
          hitType: OmnitureHelper.HitTypes.Action
        });
        emitUserClickedOnFabMetric();
      }

      setShowSpinner(value);

      _setShowWidget(value);
    }
  };

  var getIntentDetails = function getIntentDetails() {
    try {
      if (intent) {
        return Promise.resolve(intent);
      }

      return Promise.resolve(getIntentDetailsFromContext(pageName)).then(function (intentDetails) {
        if (!intentDetails) {
          throw Error('Unable to get Intents from Page Name');
        }

        return intentDetails;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var initFABContactProps = function initFABContactProps() {
    try {
      var newIntent;
      var getContactChannelResponse;

      var _temp2 = _finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(getIntentDetails()).then(function (_getIntentDetails) {
            var _getDomDataset;

            newIntent = _getIntentDetails;
            // If clientId = UTA, we cannot send MyHR in backend even if session is MyHR because
            // response will change based on clientID
            var clientIdForGetContactChannels = ((_getDomDataset = getDomDataset()) === null || _getDomDataset === void 0 ? void 0 : _getDomDataset.clientId) === LaasClientId$1.UTA ? LaasClientId$1.UTA : clientId;
            return Promise.resolve(getContactChannels(newIntent, clientIdForGetContactChannels)).then(function (_getContactChannels) {
              getContactChannelResponse = _getContactChannels;

              var _getChannelListFromGe = getChannelListFromGetContactChannelResponse(getContactChannelResponse),
                  activeLivehelpChannels = _getChannelListFromGe.activeLivehelpChannels,
                  inactiveLivehelpChannels = _getChannelListFromGe.inactiveLivehelpChannels;

              if (activeLivehelpChannels.length === 0 && inactiveLivehelpChannels.length === 0) {
                emitLatencyForSpecificOperationFromFabClick(REDIRECT_TO_MYHR_OPERATION_NAME);
                redirectToMyHR(newIntent, pageName, clientId);
              } else {
                setFABContactProps({
                  intent: newIntent,
                  getContactChannelResponse: getContactChannelResponse,
                  showErrorMessage: false,
                  clientId: clientId,
                  pageName: pageName
                });
              }
            });
          });
        }, function () {
          setFABContactProps({
            intent: newIntent,
            getContactChannelResponse: getContactChannelResponse,
            showErrorMessage: true,
            clientId: clientId,
            pageName: pageName
          });
        });
      }, function (_wasThrown, _result) {
        setShowSpinner(false);
        if (_wasThrown) throw _result;
        return _result;
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(function () {
    if (showWidget) {
      initFABContactProps();
    }
  }, [showWidget]);
  useEffect(function () {
    // Whenever FAB is mounted and session is MyHR,
    // we are setting new TTL of 15 minutes for MyHR session in local storage
    if (isCurrentSessionMyHR()) {
      localStorage.setItem(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID, getMyHRClientIdWithTtl());
    } // Set inline request id on FAB mount


    setInlineRequestIdIfNotPresent();
    return function () {
      // When FAB unmounts, we will update the epxiry time for FAB
      // This is to ensure if user moves around pages and FAB is shown to user, same request id is being used
      updateInlineRequestIdExpiryTime();
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FloaterButton, {
    onClick: function onClick() {
      return setShowWidget(true);
    },
    isDraggable: draggable,
    icon: showSpinner ? /*#__PURE__*/React.createElement(FABIconSpinner, {
      size: SpinnerSize.Small
    }) : /*#__PURE__*/React.createElement(GetHelpIcon, null)
  }), showWidget && !showSpinner && fabContactProps && /*#__PURE__*/React.createElement(FABContactWrapperContext.Provider, {
    value: fabContactProps
  }, /*#__PURE__*/React.createElement(LiveHelpInlineComponent, {
    pageName: pageName,
    isLiveHelpInlineActive: showWidget,
    handleLiveHelpInline: setShowWidget
  })));
};

export { ChatContainer, ChatHistoryContainer, ChatHistoryContext, MyHRContactWrapper as Contact, INLINE_SERVICE_NAME, LIVE_HELP_WIDGET_ROOT_ID, LiveHelpChat, LiveHelpCreateCase, LiveHelpFAB, MetricEvents, MetricUnits, PageActionsForOmnitureMetrics, PageName, PhoneContactCard, SelfServiceContentComponent, getChatHistory, getClientId, getUserIdentifier, isCurrentSessionMyHR, myHRLoggerErrorLog, myHRLoggerInfoLog, recordErrorCountMetric, useChatHistoryContext };
//# sourceMappingURL=myhr-livehelp-ui.esm.js.map
